const allMenu = {};
let js = 77381;
let pizzahut = 50666;
let mcD = 81940;
let bgW = 90461;
let newModernCafe = 34829;
let gajananVp = 379063;
let ssd = 447796;
let chineseWok = 403973;
let rajusPizzaCorner = 329272;
let ramdevPureVeg = 73828;
let burgerKing = 513069;
let momoNation = 572069;
let thakurVp = 29591;
let appetiteMomo = 233838;
let behrouzBiryani=59244

allMenu[js] = {
  Beverages: [
    {
      id: "22034331",
      name: "Masala Tea",
      category: "Beverages",
      description:
        "Masala tea is a beverage ,masala tea is a beverage made by simmering spices with milk & tea.",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "23 ratings",
          ratingCountV2: "23",
        },
      },
    },
    {
      id: "22034332",
      name: "Solkadhi",
      category: "Beverages",
      description:
        "Solakadhi or kokam kadhi is the most famous digestive drink in malvani cuisine.",
      imageId: "skuyiwtqilxz74zohakz",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "33208149",
      name: "Package Drinking Water",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "33208154",
      name: "Butter Milk",
      category: "Beverages",
      description: "150 ml",
      imageId: "evchlmeh1dnbbqzf9yza",
      inStock: 1,
      isVeg: 1,
      price: 2500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "150 ml",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "33208162",
      name: "Lassi",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "33208166",
      name: "Kokam Sarbat",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 2500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "69951239",
      name: "Thumps Up. - 750ml",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 5500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "69951240",
      name: "Sprite - 750ml",
      category: "Beverages",
      imageId: "yjo2vulcxodktmoagqug",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Beverage Combos": [
    {
      id: "49900593",
      name: "Ballaleshwar Special Missal Pav + Solkadhi",
      category: "Beverage Combos",
      description:
        "Medium Spicy | Gravy | Serves 1 | Missal pav is a vibrant meal consisting of a spicy sprouted bean curry topped with crunchy farsan, crisp red onions and dahi| Served with one glass of soalkadhi |",
      imageId: "hprx4znac1xklfg3xdnc",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "15581974",
          groupName: "Addon",
          choices: [
            {
              id: "15651540",
              name: "Lassi",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "49900616",
      name: "Vada Rassa Pav + Solkadhi",
      category: "Beverage Combos",
      imageId: "v9zqtv7q3jm0p2vwk2cm",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "49900633",
      name: "Kadhi Vada Pav + Solkadhi",
      category: "Beverage Combos",
      imageId: "y76ycxgkobobnmsuxivl",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Quick Bites": [
    {
      id: "22034318",
      name: "Finger Chips ",
      category: "Quick Bites",
      description: "Medium Spicy",
      imageId: "dndckd3mccvc8augjqyb",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "22034319",
      name: "Baleshwar Special Misal Pav",
      category: "Quick Bites",
      description:
        "Medium Spicy | Serves 1 | A popular maharashtrian delicacy with dry subji topped with flavorsome gravy  | Served with soft pav |",
      imageId: "ftsquc0ng9vpgvj9qmve",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "3155795",
          groupName: "Add On",
          choices: [
            {
              id: "8619578",
              name: "Extra Pav",
              price: 700,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
        {
          groupId: "15581976",
          groupName: "Addon",
          choices: [
            {
              id: "30446338",
              name: "Chutney",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "15651540",
              name: "Lassi",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "22034322",
      name: "Moong Bhaji ",
      category: "Quick Bites",
      description: "Medium Spicy",
      imageId: "t1zppi1cs1svvfyg9jsr",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "43951417",
          groupName: "Addon",
          choices: [
            {
              id: "30446338",
              name: "Chutney",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "22034323",
      name: "Kanda Bhaji ",
      category: "Quick Bites",
      description:
        "Medium Spicy | To enjoy mumbai rains you not only need tea but some crispy onions deep fried.",
      imageId: "zwymsqj3260ofnlpx6vk",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "22034325",
      name: "Vada Rassa Pav",
      category: "Quick Bites",
      description: "Medium Spicy | Gravy",
      imageId: "stba1v60nonjjlsn1ujk",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "15582000",
          groupName: "Addon",
          choices: [
            {
              id: "15651540",
              name: "Lassi",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
        {
          groupId: "3155798",
          groupName: "Add On",
          choices: [
            {
              id: "8619578",
              name: "Extra Pav",
              price: 700,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "22034326",
      name: "Kadhi Vada Pav",
      category: "Quick Bites",
      imageId: "mfceef9paoiso0wr3hia",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "3155799",
          groupName: "Add On",
          choices: [
            {
              id: "8619578",
              name: "Extra Pav",
              price: 700,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
        {
          groupId: "15582008",
          groupName: "Addon",
          choices: [
            {
              id: "15651540",
              name: "Lassi",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "33208177",
      name: "Misal Pav",
      category: "Quick Bites",
      description:
        "Medium Spicy | A popular maharashtrian delicacy with dry subji topped with flavorsome gravy  |Served with soft pav |",
      imageId: "d053dki7gswqgvdihzv1",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "15581983",
          groupName: "Addon",
          choices: [
            {
              id: "30446338",
              name: "Chutney",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "15651540",
              name: "Lassi",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
  ],
  Desserts: [
    {
      id: "33208158",
      name: "Gulabjam ( 1 Pc )",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 1500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "58816892",
      name: "Dahivada ( 2 Pcs )",
      category: "Desserts",
      description:
        "Medium Spicy | Dahi vada is a type of chaat originating from the Indian subcontinent and popular throughout south asia. It is prepared by soaking vadas in thick dahi.",
      imageId: "tyevnuupnwlgfzgy4jul",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Swiggy Exclusive Combos": [
    {
      id: "39327910",
      name: "Misal Pav + Buttermilk",
      category: "Swiggy Exclusive Combos",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "15582015",
          groupName: "Addon",
          choices: [
            {
              id: "15651540",
              name: "Lassi",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "39327915",
      name: "Sabudana Vada + Lassi",
      category: "Swiggy Exclusive Combos",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "101293197",
      name: "7 Vada Pav  ",
      category: "Swiggy Exclusive Combos",
      description: "Serves 1",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Shravan Specials": [
    {
      id: "97887861",
      name: "Sabudana Vada + Lassi   ",
      category: "Shravan Specials",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "97887863",
      name: "Finger Chips + Masala Tea",
      category: "Shravan Specials",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "97887865",
      name: "Sabudana Vada (2 Pcs)  ",
      category: "Shravan Specials",
      description:
        "Medium Spicy | Crispy on the outside, soft on the inside; a deep-fried snack made from sago.",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        spiceLevel: "MEDIUMSPICY",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
  ],
  "Fasting Combo": [
    {
      id: "73002745",
      name: "Sabudana Vada 6 Piece",
      category: "Fasting Combo",
      description: "Sabudana,pinutscrush mirchi, pototo",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[pizzahut] = {
  "One Plus One Medium @649": [
    {
      id: "101899509",
      name: "Super Value Deal : 2 Medium Veg Pizzas starting at Rs 649 (Save Upto 41%)",
      category: "One Plus One Medium @649",
      description: "Serves 1 | Choose any 2 of your Favorite Veg Medium Pizza",
      imageId: "ldywxlfetpfojuajk5xe",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570919",
            name: "Choose 1st Pizza",
            variations: [
              {
                name: "Margherita",
                price: 324.5,
                default: 1,
                id: "84359021",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Tandoori Onion",
                price: 324.5,
                id: "84359022",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Classic Corn",
                price: 324.5,
                id: "84359023",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Veggie Tandoori",
                price: 324.5,
                id: "84359026",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Veggie Feast",
                price: 324.5,
                id: "84359029",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Spiced Paneer",
                price: 324.5,
                id: "84359031",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Double Cheese",
                price: 324.5,
                id: "84359034",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Veggie Lover",
                price: 374.5,
                id: "84359037",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Tandoori Paneer",
                price: 374.5,
                id: "84359040",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Farmers Pick",
                price: 374.5,
                id: "84359042",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Country Feast",
                price: 374.5,
                id: "84359043",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Veg Kebab Surprise",
                price: 374.5,
                id: "84359044",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Veggie Supreme",
                price: 374.5,
                id: "84359045",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Veg Exotica",
                price: 374.5,
                id: "84359046",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
              {
                name: "Double Paneer Supreme",
                price: 374.5,
                id: "84359047",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570922",
                  variationId: "84359048",
                },
              },
            ],
          },
          {
            groupId: "26570922",
            name: "Choose 2nd Pizza",
            variations: [
              {
                name: "Margherita",
                price: 324.5,
                default: 1,
                id: "84359048",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tandoori Onion",
                price: 324.5,
                id: "84359049",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Classic Corn",
                price: 324.5,
                id: "84359050",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veggie Tandoori",
                price: 324.5,
                id: "84359051",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veggie Feast",
                price: 324.5,
                id: "84359052",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Spiced Paneer",
                price: 324.5,
                id: "84359053",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Double Cheese",
                price: 324.5,
                id: "84359054",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veggie Lover",
                price: 374.5,
                id: "84359055",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tandoori Paneer",
                price: 374.5,
                id: "84359056",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Farmers Pick",
                price: 374.5,
                id: "84359057",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Country Feast",
                price: 374.5,
                id: "84359058",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veg Kebab Surprise",
                price: 374.5,
                id: "84359059",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veggie Supreme",
                price: 374.5,
                id: "84359060",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veg Exotica",
                price: 374.5,
                id: "84359061",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Double Paneer Supreme",
                price: 374.5,
                id: "84359062",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359021",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359022",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359023",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359026",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359029",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359031",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 64900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359034",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359037",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359040",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359042",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359043",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359044",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359045",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359046",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359048",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359049",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359050",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359051",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359052",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359053",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359054",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359055",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359056",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359057",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359058",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359059",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359060",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359061",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570919",
                variationId: "84359047",
              },
              {
                groupId: "26570922",
                variationId: "84359062",
              },
            ],
            price: 74900,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 64900,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "101899510",
      name: "Super Value Deal : 2 Medium Non -Veg Pizzas starting at Rs 749 (Save Upto 39%)",
      category: "One Plus One Medium @649",
      description:
        "Serves 1 | Choose any 2 of your Favorite Non-Veg Medium Pizzas",
      imageId: "afwiagiohxk2lyncwihx",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570925",
            name: "Choose 1st Pizza",
            variations: [
              {
                name: "Chicken Sausage",
                price: 374.5,
                default: 1,
                id: "84359075",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Spiced Chicken Meatballs",
                price: 374.5,
                id: "84359076",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Double Chicken Sausage",
                price: 374.5,
                id: "84359077",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Chicken N Corn Delight",
                price: 374.5,
                id: "84359078",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Chicken Pepperoni",
                price: 424.5,
                id: "84359079",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Malai Chicken Tikka",
                price: 424.5,
                id: "84359080",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Chicken Tikka",
                price: 424.5,
                id: "84359081",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Chicken Pepper Crunch",
                price: 424.5,
                id: "84359082",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Italian Chicken Feast",
                price: 424.5,
                id: "84359083",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Triple Chicken Feast",
                price: 424.5,
                id: "84359084",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Chicken Tikka Supreme",
                price: 424.5,
                id: "84359085",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
              {
                name: "Chicken Supreme",
                price: 424.5,
                id: "84359086",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570926",
                  variationId: "84359087",
                },
              },
            ],
          },
          {
            groupId: "26570926",
            name: "Choose 2nd Pizza",
            variations: [
              {
                name: "Chicken Sausage",
                price: 374.5,
                default: 1,
                id: "84359087",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Spiced Chicken Meatballs",
                price: 374.5,
                id: "84359088",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Double Chicken Sausage",
                price: 374.5,
                id: "84359089",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken N Corn Delight",
                price: 374.5,
                id: "84359091",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Pepperoni",
                price: 424.5,
                id: "84359093",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Malai Chicken Tikka",
                price: 424.5,
                id: "84359096",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Tikka",
                price: 424.5,
                id: "84359099",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Pepper Crunch",
                price: 424.5,
                id: "84359102",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Italian Chicken Feast",
                price: 424.5,
                id: "84359105",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Triple Chicken Feast",
                price: 424.5,
                id: "84359108",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Tikka Supreme",
                price: 424.5,
                id: "84359109",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Supreme",
                price: 424.5,
                id: "84359110",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359075",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359076",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359077",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 74900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359078",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359079",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359080",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359081",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359082",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359083",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359084",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359085",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359087",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359088",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359089",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359091",
              },
            ],
            price: 79900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359093",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359096",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359099",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359102",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359105",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359108",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359109",
              },
            ],
            price: 84900,
          },
          {
            variations: [
              {
                groupId: "26570925",
                variationId: "84359086",
              },
              {
                groupId: "26570926",
                variationId: "84359110",
              },
            ],
            price: 84900,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 74900,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  "Veg Pizza": [
    {
      id: "47199975",
      name: "Country Feast",
      category: "Veg Pizza",
      description:
        "Serves 1 | Loaded with Herbed Onion & Green capsicum, Sweet Corn, Tomato & Mushroom with signature pan sauce and 100% mozzarella cheese. It's a feast you can't refuse.",
      imageId: "fqzol9tuftv5aelg0v35",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569986",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84354415",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569987",
                  variationId: "84354418",
                },
              },
              {
                name: "Medium",
                id: "84354417",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569987",
                  variationId: "84354426",
                },
              },
            ],
          },
          {
            groupId: "26569987",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84354418",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84354420",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 339,
                id: "84354422",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 394,
                id: "84354423",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84354425",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84354426",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84354428",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 599,
                id: "84354429",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 668,
                id: "84354431",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84354432",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354415",
              },
              {
                groupId: "26569987",
                variationId: "84354418",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642719",
                addonId: "72640314",
              },
              {
                groupId: "86642719",
                addonId: "72640315",
              },
              {
                groupId: "86642719",
                addonId: "72640316",
              },
              {
                groupId: "86642719",
                addonId: "72640317",
              },
              {
                groupId: "86642719",
                addonId: "72640318",
              },
              {
                groupId: "86642719",
                addonId: "72640319",
              },
              {
                groupId: "86642719",
                addonId: "72640320",
              },
              {
                groupId: "86642719",
                addonId: "72640321",
              },
              {
                groupId: "86642719",
                addonId: "72640322",
              },
              {
                groupId: "86642719",
                addonId: "72640323",
              },
              {
                groupId: "86642719",
                addonId: "72640324",
              },
              {
                groupId: "86642719",
                addonId: "72640325",
              },
              {
                groupId: "86642719",
                addonId: "72640326",
              },
              {
                groupId: "86642719",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354415",
              },
              {
                groupId: "26569987",
                variationId: "84354420",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642719",
                addonId: "72640314",
              },
              {
                groupId: "86642719",
                addonId: "72640315",
              },
              {
                groupId: "86642719",
                addonId: "72640316",
              },
              {
                groupId: "86642719",
                addonId: "72640317",
              },
              {
                groupId: "86642719",
                addonId: "72640318",
              },
              {
                groupId: "86642719",
                addonId: "72640319",
              },
              {
                groupId: "86642719",
                addonId: "72640320",
              },
              {
                groupId: "86642719",
                addonId: "72640321",
              },
              {
                groupId: "86642719",
                addonId: "72640322",
              },
              {
                groupId: "86642719",
                addonId: "72640323",
              },
              {
                groupId: "86642719",
                addonId: "72640324",
              },
              {
                groupId: "86642719",
                addonId: "72640325",
              },
              {
                groupId: "86642719",
                addonId: "72640326",
              },
              {
                groupId: "86642719",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354415",
              },
              {
                groupId: "26569987",
                variationId: "84354422",
              },
            ],
            price: 33900,
            addonCombinations: [
              {
                groupId: "86642719",
                addonId: "72640314",
              },
              {
                groupId: "86642719",
                addonId: "72640315",
              },
              {
                groupId: "86642719",
                addonId: "72640316",
              },
              {
                groupId: "86642719",
                addonId: "72640317",
              },
              {
                groupId: "86642719",
                addonId: "72640318",
              },
              {
                groupId: "86642719",
                addonId: "72640319",
              },
              {
                groupId: "86642719",
                addonId: "72640320",
              },
              {
                groupId: "86642719",
                addonId: "72640321",
              },
              {
                groupId: "86642719",
                addonId: "72640322",
              },
              {
                groupId: "86642719",
                addonId: "72640323",
              },
              {
                groupId: "86642719",
                addonId: "72640324",
              },
              {
                groupId: "86642719",
                addonId: "72640325",
              },
              {
                groupId: "86642719",
                addonId: "72640326",
              },
              {
                groupId: "86642719",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354415",
              },
              {
                groupId: "26569987",
                variationId: "84354423",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642719",
                addonId: "72640314",
              },
              {
                groupId: "86642719",
                addonId: "72640315",
              },
              {
                groupId: "86642719",
                addonId: "72640316",
              },
              {
                groupId: "86642719",
                addonId: "72640317",
              },
              {
                groupId: "86642719",
                addonId: "72640318",
              },
              {
                groupId: "86642719",
                addonId: "72640319",
              },
              {
                groupId: "86642719",
                addonId: "72640320",
              },
              {
                groupId: "86642719",
                addonId: "72640321",
              },
              {
                groupId: "86642719",
                addonId: "72640322",
              },
              {
                groupId: "86642719",
                addonId: "72640323",
              },
              {
                groupId: "86642719",
                addonId: "72640324",
              },
              {
                groupId: "86642719",
                addonId: "72640325",
              },
              {
                groupId: "86642719",
                addonId: "72640326",
              },
              {
                groupId: "86642719",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354415",
              },
              {
                groupId: "26569987",
                variationId: "84354425",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642719",
                addonId: "72640314",
              },
              {
                groupId: "86642719",
                addonId: "72640315",
              },
              {
                groupId: "86642719",
                addonId: "72640316",
              },
              {
                groupId: "86642719",
                addonId: "72640317",
              },
              {
                groupId: "86642719",
                addonId: "72640318",
              },
              {
                groupId: "86642719",
                addonId: "72640319",
              },
              {
                groupId: "86642719",
                addonId: "72640320",
              },
              {
                groupId: "86642719",
                addonId: "72640321",
              },
              {
                groupId: "86642719",
                addonId: "72640322",
              },
              {
                groupId: "86642719",
                addonId: "72640323",
              },
              {
                groupId: "86642719",
                addonId: "72640324",
              },
              {
                groupId: "86642719",
                addonId: "72640325",
              },
              {
                groupId: "86642719",
                addonId: "72640326",
              },
              {
                groupId: "86642719",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354417",
              },
              {
                groupId: "26569987",
                variationId: "84354426",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642718",
                addonId: "72640334",
              },
              {
                groupId: "86642718",
                addonId: "72640335",
              },
              {
                groupId: "86642718",
                addonId: "72640336",
              },
              {
                groupId: "86642718",
                addonId: "72640337",
              },
              {
                groupId: "86642718",
                addonId: "72640338",
              },
              {
                groupId: "86642718",
                addonId: "72640339",
              },
              {
                groupId: "86642718",
                addonId: "72640340",
              },
              {
                groupId: "86642718",
                addonId: "72640341",
              },
              {
                groupId: "86642718",
                addonId: "72640342",
              },
              {
                groupId: "86642718",
                addonId: "72640343",
              },
              {
                groupId: "86642718",
                addonId: "72640344",
              },
              {
                groupId: "86642718",
                addonId: "72640345",
              },
              {
                groupId: "86642718",
                addonId: "72640346",
              },
              {
                groupId: "86642718",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354417",
              },
              {
                groupId: "26569987",
                variationId: "84354428",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642718",
                addonId: "72640334",
              },
              {
                groupId: "86642718",
                addonId: "72640335",
              },
              {
                groupId: "86642718",
                addonId: "72640336",
              },
              {
                groupId: "86642718",
                addonId: "72640337",
              },
              {
                groupId: "86642718",
                addonId: "72640338",
              },
              {
                groupId: "86642718",
                addonId: "72640339",
              },
              {
                groupId: "86642718",
                addonId: "72640340",
              },
              {
                groupId: "86642718",
                addonId: "72640341",
              },
              {
                groupId: "86642718",
                addonId: "72640342",
              },
              {
                groupId: "86642718",
                addonId: "72640343",
              },
              {
                groupId: "86642718",
                addonId: "72640344",
              },
              {
                groupId: "86642718",
                addonId: "72640345",
              },
              {
                groupId: "86642718",
                addonId: "72640346",
              },
              {
                groupId: "86642718",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354417",
              },
              {
                groupId: "26569987",
                variationId: "84354429",
              },
            ],
            price: 59900,
            addonCombinations: [
              {
                groupId: "86642718",
                addonId: "72640334",
              },
              {
                groupId: "86642718",
                addonId: "72640335",
              },
              {
                groupId: "86642718",
                addonId: "72640336",
              },
              {
                groupId: "86642718",
                addonId: "72640337",
              },
              {
                groupId: "86642718",
                addonId: "72640338",
              },
              {
                groupId: "86642718",
                addonId: "72640339",
              },
              {
                groupId: "86642718",
                addonId: "72640340",
              },
              {
                groupId: "86642718",
                addonId: "72640341",
              },
              {
                groupId: "86642718",
                addonId: "72640342",
              },
              {
                groupId: "86642718",
                addonId: "72640343",
              },
              {
                groupId: "86642718",
                addonId: "72640344",
              },
              {
                groupId: "86642718",
                addonId: "72640345",
              },
              {
                groupId: "86642718",
                addonId: "72640346",
              },
              {
                groupId: "86642718",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354417",
              },
              {
                groupId: "26569987",
                variationId: "84354431",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642718",
                addonId: "72640334",
              },
              {
                groupId: "86642718",
                addonId: "72640335",
              },
              {
                groupId: "86642718",
                addonId: "72640336",
              },
              {
                groupId: "86642718",
                addonId: "72640337",
              },
              {
                groupId: "86642718",
                addonId: "72640338",
              },
              {
                groupId: "86642718",
                addonId: "72640339",
              },
              {
                groupId: "86642718",
                addonId: "72640340",
              },
              {
                groupId: "86642718",
                addonId: "72640341",
              },
              {
                groupId: "86642718",
                addonId: "72640342",
              },
              {
                groupId: "86642718",
                addonId: "72640343",
              },
              {
                groupId: "86642718",
                addonId: "72640344",
              },
              {
                groupId: "86642718",
                addonId: "72640345",
              },
              {
                groupId: "86642718",
                addonId: "72640346",
              },
              {
                groupId: "86642718",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569986",
                variationId: "84354417",
              },
              {
                groupId: "26569987",
                variationId: "84354432",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642718",
                addonId: "72640334",
              },
              {
                groupId: "86642718",
                addonId: "72640335",
              },
              {
                groupId: "86642718",
                addonId: "72640336",
              },
              {
                groupId: "86642718",
                addonId: "72640337",
              },
              {
                groupId: "86642718",
                addonId: "72640338",
              },
              {
                groupId: "86642718",
                addonId: "72640339",
              },
              {
                groupId: "86642718",
                addonId: "72640340",
              },
              {
                groupId: "86642718",
                addonId: "72640341",
              },
              {
                groupId: "86642718",
                addonId: "72640342",
              },
              {
                groupId: "86642718",
                addonId: "72640343",
              },
              {
                groupId: "86642718",
                addonId: "72640344",
              },
              {
                groupId: "86642718",
                addonId: "72640345",
              },
              {
                groupId: "86642718",
                addonId: "72640346",
              },
              {
                groupId: "86642718",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642718",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642719",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "47199991",
      name: "Double Cheese",
      category: "Veg Pizza",
      description:
        "Serves 1 | Did someone say EXTRA CHEESE? Pizza topped with extra Cheese that is 100% mozzerella with herb-infused signature pan sauce.",
      imageId: "llk1grmcjyijsxryo0pc",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570347",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84356187",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570348",
                  variationId: "84356191",
                },
              },
              {
                name: "Medium",
                id: "84356190",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570348",
                  variationId: "84356196",
                },
              },
            ],
          },
          {
            groupId: "26570348",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 259,
                default: 1,
                id: "84356191",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 259,
                id: "84356192",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 279,
                id: "84356193",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 334,
                id: "84356194",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 334,
                id: "84356195",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 489,
                id: "84356196",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 489,
                id: "84356197",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 519,
                id: "84356198",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 588,
                id: "84356199",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 588,
                id: "84356200",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356187",
              },
              {
                groupId: "26570348",
                variationId: "84356191",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642851",
                addonId: "72640314",
              },
              {
                groupId: "86642851",
                addonId: "72640315",
              },
              {
                groupId: "86642851",
                addonId: "72640316",
              },
              {
                groupId: "86642851",
                addonId: "72640317",
              },
              {
                groupId: "86642851",
                addonId: "72640318",
              },
              {
                groupId: "86642851",
                addonId: "72640319",
              },
              {
                groupId: "86642851",
                addonId: "72640320",
              },
              {
                groupId: "86642851",
                addonId: "72640321",
              },
              {
                groupId: "86642851",
                addonId: "72640322",
              },
              {
                groupId: "86642851",
                addonId: "72640323",
              },
              {
                groupId: "86642851",
                addonId: "72640324",
              },
              {
                groupId: "86642851",
                addonId: "72640325",
              },
              {
                groupId: "86642851",
                addonId: "72640326",
              },
              {
                groupId: "86642851",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356187",
              },
              {
                groupId: "26570348",
                variationId: "84356192",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642851",
                addonId: "72640314",
              },
              {
                groupId: "86642851",
                addonId: "72640315",
              },
              {
                groupId: "86642851",
                addonId: "72640316",
              },
              {
                groupId: "86642851",
                addonId: "72640317",
              },
              {
                groupId: "86642851",
                addonId: "72640318",
              },
              {
                groupId: "86642851",
                addonId: "72640319",
              },
              {
                groupId: "86642851",
                addonId: "72640320",
              },
              {
                groupId: "86642851",
                addonId: "72640321",
              },
              {
                groupId: "86642851",
                addonId: "72640322",
              },
              {
                groupId: "86642851",
                addonId: "72640323",
              },
              {
                groupId: "86642851",
                addonId: "72640324",
              },
              {
                groupId: "86642851",
                addonId: "72640325",
              },
              {
                groupId: "86642851",
                addonId: "72640326",
              },
              {
                groupId: "86642851",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356187",
              },
              {
                groupId: "26570348",
                variationId: "84356193",
              },
            ],
            price: 27900,
            addonCombinations: [
              {
                groupId: "86642851",
                addonId: "72640314",
              },
              {
                groupId: "86642851",
                addonId: "72640315",
              },
              {
                groupId: "86642851",
                addonId: "72640316",
              },
              {
                groupId: "86642851",
                addonId: "72640317",
              },
              {
                groupId: "86642851",
                addonId: "72640318",
              },
              {
                groupId: "86642851",
                addonId: "72640319",
              },
              {
                groupId: "86642851",
                addonId: "72640320",
              },
              {
                groupId: "86642851",
                addonId: "72640321",
              },
              {
                groupId: "86642851",
                addonId: "72640322",
              },
              {
                groupId: "86642851",
                addonId: "72640323",
              },
              {
                groupId: "86642851",
                addonId: "72640324",
              },
              {
                groupId: "86642851",
                addonId: "72640325",
              },
              {
                groupId: "86642851",
                addonId: "72640326",
              },
              {
                groupId: "86642851",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356187",
              },
              {
                groupId: "26570348",
                variationId: "84356194",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642851",
                addonId: "72640314",
              },
              {
                groupId: "86642851",
                addonId: "72640315",
              },
              {
                groupId: "86642851",
                addonId: "72640316",
              },
              {
                groupId: "86642851",
                addonId: "72640317",
              },
              {
                groupId: "86642851",
                addonId: "72640318",
              },
              {
                groupId: "86642851",
                addonId: "72640319",
              },
              {
                groupId: "86642851",
                addonId: "72640320",
              },
              {
                groupId: "86642851",
                addonId: "72640321",
              },
              {
                groupId: "86642851",
                addonId: "72640322",
              },
              {
                groupId: "86642851",
                addonId: "72640323",
              },
              {
                groupId: "86642851",
                addonId: "72640324",
              },
              {
                groupId: "86642851",
                addonId: "72640325",
              },
              {
                groupId: "86642851",
                addonId: "72640326",
              },
              {
                groupId: "86642851",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356187",
              },
              {
                groupId: "26570348",
                variationId: "84356195",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642851",
                addonId: "72640314",
              },
              {
                groupId: "86642851",
                addonId: "72640315",
              },
              {
                groupId: "86642851",
                addonId: "72640316",
              },
              {
                groupId: "86642851",
                addonId: "72640317",
              },
              {
                groupId: "86642851",
                addonId: "72640318",
              },
              {
                groupId: "86642851",
                addonId: "72640319",
              },
              {
                groupId: "86642851",
                addonId: "72640320",
              },
              {
                groupId: "86642851",
                addonId: "72640321",
              },
              {
                groupId: "86642851",
                addonId: "72640322",
              },
              {
                groupId: "86642851",
                addonId: "72640323",
              },
              {
                groupId: "86642851",
                addonId: "72640324",
              },
              {
                groupId: "86642851",
                addonId: "72640325",
              },
              {
                groupId: "86642851",
                addonId: "72640326",
              },
              {
                groupId: "86642851",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356190",
              },
              {
                groupId: "26570348",
                variationId: "84356196",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642849",
                addonId: "72640334",
              },
              {
                groupId: "86642849",
                addonId: "72640335",
              },
              {
                groupId: "86642849",
                addonId: "72640336",
              },
              {
                groupId: "86642849",
                addonId: "72640337",
              },
              {
                groupId: "86642849",
                addonId: "72640338",
              },
              {
                groupId: "86642849",
                addonId: "72640339",
              },
              {
                groupId: "86642849",
                addonId: "72640340",
              },
              {
                groupId: "86642849",
                addonId: "72640341",
              },
              {
                groupId: "86642849",
                addonId: "72640342",
              },
              {
                groupId: "86642849",
                addonId: "72640343",
              },
              {
                groupId: "86642849",
                addonId: "72640344",
              },
              {
                groupId: "86642849",
                addonId: "72640345",
              },
              {
                groupId: "86642849",
                addonId: "72640346",
              },
              {
                groupId: "86642849",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356190",
              },
              {
                groupId: "26570348",
                variationId: "84356197",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642849",
                addonId: "72640334",
              },
              {
                groupId: "86642849",
                addonId: "72640335",
              },
              {
                groupId: "86642849",
                addonId: "72640336",
              },
              {
                groupId: "86642849",
                addonId: "72640337",
              },
              {
                groupId: "86642849",
                addonId: "72640338",
              },
              {
                groupId: "86642849",
                addonId: "72640339",
              },
              {
                groupId: "86642849",
                addonId: "72640340",
              },
              {
                groupId: "86642849",
                addonId: "72640341",
              },
              {
                groupId: "86642849",
                addonId: "72640342",
              },
              {
                groupId: "86642849",
                addonId: "72640343",
              },
              {
                groupId: "86642849",
                addonId: "72640344",
              },
              {
                groupId: "86642849",
                addonId: "72640345",
              },
              {
                groupId: "86642849",
                addonId: "72640346",
              },
              {
                groupId: "86642849",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356190",
              },
              {
                groupId: "26570348",
                variationId: "84356198",
              },
            ],
            price: 51900,
            addonCombinations: [
              {
                groupId: "86642849",
                addonId: "72640334",
              },
              {
                groupId: "86642849",
                addonId: "72640335",
              },
              {
                groupId: "86642849",
                addonId: "72640336",
              },
              {
                groupId: "86642849",
                addonId: "72640337",
              },
              {
                groupId: "86642849",
                addonId: "72640338",
              },
              {
                groupId: "86642849",
                addonId: "72640339",
              },
              {
                groupId: "86642849",
                addonId: "72640340",
              },
              {
                groupId: "86642849",
                addonId: "72640341",
              },
              {
                groupId: "86642849",
                addonId: "72640342",
              },
              {
                groupId: "86642849",
                addonId: "72640343",
              },
              {
                groupId: "86642849",
                addonId: "72640344",
              },
              {
                groupId: "86642849",
                addonId: "72640345",
              },
              {
                groupId: "86642849",
                addonId: "72640346",
              },
              {
                groupId: "86642849",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356190",
              },
              {
                groupId: "26570348",
                variationId: "84356199",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642849",
                addonId: "72640334",
              },
              {
                groupId: "86642849",
                addonId: "72640335",
              },
              {
                groupId: "86642849",
                addonId: "72640336",
              },
              {
                groupId: "86642849",
                addonId: "72640337",
              },
              {
                groupId: "86642849",
                addonId: "72640338",
              },
              {
                groupId: "86642849",
                addonId: "72640339",
              },
              {
                groupId: "86642849",
                addonId: "72640340",
              },
              {
                groupId: "86642849",
                addonId: "72640341",
              },
              {
                groupId: "86642849",
                addonId: "72640342",
              },
              {
                groupId: "86642849",
                addonId: "72640343",
              },
              {
                groupId: "86642849",
                addonId: "72640344",
              },
              {
                groupId: "86642849",
                addonId: "72640345",
              },
              {
                groupId: "86642849",
                addonId: "72640346",
              },
              {
                groupId: "86642849",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570347",
                variationId: "84356190",
              },
              {
                groupId: "26570348",
                variationId: "84356200",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642849",
                addonId: "72640334",
              },
              {
                groupId: "86642849",
                addonId: "72640335",
              },
              {
                groupId: "86642849",
                addonId: "72640336",
              },
              {
                groupId: "86642849",
                addonId: "72640337",
              },
              {
                groupId: "86642849",
                addonId: "72640338",
              },
              {
                groupId: "86642849",
                addonId: "72640339",
              },
              {
                groupId: "86642849",
                addonId: "72640340",
              },
              {
                groupId: "86642849",
                addonId: "72640341",
              },
              {
                groupId: "86642849",
                addonId: "72640342",
              },
              {
                groupId: "86642849",
                addonId: "72640343",
              },
              {
                groupId: "86642849",
                addonId: "72640344",
              },
              {
                groupId: "86642849",
                addonId: "72640345",
              },
              {
                groupId: "86642849",
                addonId: "72640346",
              },
              {
                groupId: "86642849",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642851",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642849",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 25900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "47200016",
      name: "Farmers Pick",
      category: "Veg Pizza",
      description:
        "Serves 1 | Flavourful Herbed Onion and Green, crunchy Red Capsicum, yummy  Mushrooms & Baby Corn with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "abecxrnu6gpe6btgcgzx",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569992",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84354448",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569993",
                  variationId: "84354451",
                },
              },
              {
                name: "Medium",
                id: "84354450",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569993",
                  variationId: "84354456",
                },
              },
            ],
          },
          {
            groupId: "26569993",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84354451",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84354452",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 339,
                id: "84354453",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 394,
                id: "84354454",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84354455",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84354456",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84354457",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 599,
                id: "84354458",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 668,
                id: "84354459",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84354460",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354448",
              },
              {
                groupId: "26569993",
                variationId: "84354451",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642723",
                addonId: "72640314",
              },
              {
                groupId: "86642723",
                addonId: "72640315",
              },
              {
                groupId: "86642723",
                addonId: "72640316",
              },
              {
                groupId: "86642723",
                addonId: "72640317",
              },
              {
                groupId: "86642723",
                addonId: "72640318",
              },
              {
                groupId: "86642723",
                addonId: "72640319",
              },
              {
                groupId: "86642723",
                addonId: "72640320",
              },
              {
                groupId: "86642723",
                addonId: "72640321",
              },
              {
                groupId: "86642723",
                addonId: "72640322",
              },
              {
                groupId: "86642723",
                addonId: "72640323",
              },
              {
                groupId: "86642723",
                addonId: "72640324",
              },
              {
                groupId: "86642723",
                addonId: "72640325",
              },
              {
                groupId: "86642723",
                addonId: "72640326",
              },
              {
                groupId: "86642723",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354448",
              },
              {
                groupId: "26569993",
                variationId: "84354452",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642723",
                addonId: "72640314",
              },
              {
                groupId: "86642723",
                addonId: "72640315",
              },
              {
                groupId: "86642723",
                addonId: "72640316",
              },
              {
                groupId: "86642723",
                addonId: "72640317",
              },
              {
                groupId: "86642723",
                addonId: "72640318",
              },
              {
                groupId: "86642723",
                addonId: "72640319",
              },
              {
                groupId: "86642723",
                addonId: "72640320",
              },
              {
                groupId: "86642723",
                addonId: "72640321",
              },
              {
                groupId: "86642723",
                addonId: "72640322",
              },
              {
                groupId: "86642723",
                addonId: "72640323",
              },
              {
                groupId: "86642723",
                addonId: "72640324",
              },
              {
                groupId: "86642723",
                addonId: "72640325",
              },
              {
                groupId: "86642723",
                addonId: "72640326",
              },
              {
                groupId: "86642723",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354448",
              },
              {
                groupId: "26569993",
                variationId: "84354453",
              },
            ],
            price: 33900,
            addonCombinations: [
              {
                groupId: "86642723",
                addonId: "72640314",
              },
              {
                groupId: "86642723",
                addonId: "72640315",
              },
              {
                groupId: "86642723",
                addonId: "72640316",
              },
              {
                groupId: "86642723",
                addonId: "72640317",
              },
              {
                groupId: "86642723",
                addonId: "72640318",
              },
              {
                groupId: "86642723",
                addonId: "72640319",
              },
              {
                groupId: "86642723",
                addonId: "72640320",
              },
              {
                groupId: "86642723",
                addonId: "72640321",
              },
              {
                groupId: "86642723",
                addonId: "72640322",
              },
              {
                groupId: "86642723",
                addonId: "72640323",
              },
              {
                groupId: "86642723",
                addonId: "72640324",
              },
              {
                groupId: "86642723",
                addonId: "72640325",
              },
              {
                groupId: "86642723",
                addonId: "72640326",
              },
              {
                groupId: "86642723",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354448",
              },
              {
                groupId: "26569993",
                variationId: "84354454",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642723",
                addonId: "72640314",
              },
              {
                groupId: "86642723",
                addonId: "72640315",
              },
              {
                groupId: "86642723",
                addonId: "72640316",
              },
              {
                groupId: "86642723",
                addonId: "72640317",
              },
              {
                groupId: "86642723",
                addonId: "72640318",
              },
              {
                groupId: "86642723",
                addonId: "72640319",
              },
              {
                groupId: "86642723",
                addonId: "72640320",
              },
              {
                groupId: "86642723",
                addonId: "72640321",
              },
              {
                groupId: "86642723",
                addonId: "72640322",
              },
              {
                groupId: "86642723",
                addonId: "72640323",
              },
              {
                groupId: "86642723",
                addonId: "72640324",
              },
              {
                groupId: "86642723",
                addonId: "72640325",
              },
              {
                groupId: "86642723",
                addonId: "72640326",
              },
              {
                groupId: "86642723",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354448",
              },
              {
                groupId: "26569993",
                variationId: "84354455",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642723",
                addonId: "72640314",
              },
              {
                groupId: "86642723",
                addonId: "72640315",
              },
              {
                groupId: "86642723",
                addonId: "72640316",
              },
              {
                groupId: "86642723",
                addonId: "72640317",
              },
              {
                groupId: "86642723",
                addonId: "72640318",
              },
              {
                groupId: "86642723",
                addonId: "72640319",
              },
              {
                groupId: "86642723",
                addonId: "72640320",
              },
              {
                groupId: "86642723",
                addonId: "72640321",
              },
              {
                groupId: "86642723",
                addonId: "72640322",
              },
              {
                groupId: "86642723",
                addonId: "72640323",
              },
              {
                groupId: "86642723",
                addonId: "72640324",
              },
              {
                groupId: "86642723",
                addonId: "72640325",
              },
              {
                groupId: "86642723",
                addonId: "72640326",
              },
              {
                groupId: "86642723",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354450",
              },
              {
                groupId: "26569993",
                variationId: "84354456",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642721",
                addonId: "72640334",
              },
              {
                groupId: "86642721",
                addonId: "72640335",
              },
              {
                groupId: "86642721",
                addonId: "72640336",
              },
              {
                groupId: "86642721",
                addonId: "72640337",
              },
              {
                groupId: "86642721",
                addonId: "72640338",
              },
              {
                groupId: "86642721",
                addonId: "72640339",
              },
              {
                groupId: "86642721",
                addonId: "72640340",
              },
              {
                groupId: "86642721",
                addonId: "72640341",
              },
              {
                groupId: "86642721",
                addonId: "72640342",
              },
              {
                groupId: "86642721",
                addonId: "72640343",
              },
              {
                groupId: "86642721",
                addonId: "72640344",
              },
              {
                groupId: "86642721",
                addonId: "72640345",
              },
              {
                groupId: "86642721",
                addonId: "72640346",
              },
              {
                groupId: "86642721",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354450",
              },
              {
                groupId: "26569993",
                variationId: "84354457",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642721",
                addonId: "72640334",
              },
              {
                groupId: "86642721",
                addonId: "72640335",
              },
              {
                groupId: "86642721",
                addonId: "72640336",
              },
              {
                groupId: "86642721",
                addonId: "72640337",
              },
              {
                groupId: "86642721",
                addonId: "72640338",
              },
              {
                groupId: "86642721",
                addonId: "72640339",
              },
              {
                groupId: "86642721",
                addonId: "72640340",
              },
              {
                groupId: "86642721",
                addonId: "72640341",
              },
              {
                groupId: "86642721",
                addonId: "72640342",
              },
              {
                groupId: "86642721",
                addonId: "72640343",
              },
              {
                groupId: "86642721",
                addonId: "72640344",
              },
              {
                groupId: "86642721",
                addonId: "72640345",
              },
              {
                groupId: "86642721",
                addonId: "72640346",
              },
              {
                groupId: "86642721",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354450",
              },
              {
                groupId: "26569993",
                variationId: "84354458",
              },
            ],
            price: 59900,
            addonCombinations: [
              {
                groupId: "86642721",
                addonId: "72640334",
              },
              {
                groupId: "86642721",
                addonId: "72640335",
              },
              {
                groupId: "86642721",
                addonId: "72640336",
              },
              {
                groupId: "86642721",
                addonId: "72640337",
              },
              {
                groupId: "86642721",
                addonId: "72640338",
              },
              {
                groupId: "86642721",
                addonId: "72640339",
              },
              {
                groupId: "86642721",
                addonId: "72640340",
              },
              {
                groupId: "86642721",
                addonId: "72640341",
              },
              {
                groupId: "86642721",
                addonId: "72640342",
              },
              {
                groupId: "86642721",
                addonId: "72640343",
              },
              {
                groupId: "86642721",
                addonId: "72640344",
              },
              {
                groupId: "86642721",
                addonId: "72640345",
              },
              {
                groupId: "86642721",
                addonId: "72640346",
              },
              {
                groupId: "86642721",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354450",
              },
              {
                groupId: "26569993",
                variationId: "84354459",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642721",
                addonId: "72640334",
              },
              {
                groupId: "86642721",
                addonId: "72640335",
              },
              {
                groupId: "86642721",
                addonId: "72640336",
              },
              {
                groupId: "86642721",
                addonId: "72640337",
              },
              {
                groupId: "86642721",
                addonId: "72640338",
              },
              {
                groupId: "86642721",
                addonId: "72640339",
              },
              {
                groupId: "86642721",
                addonId: "72640340",
              },
              {
                groupId: "86642721",
                addonId: "72640341",
              },
              {
                groupId: "86642721",
                addonId: "72640342",
              },
              {
                groupId: "86642721",
                addonId: "72640343",
              },
              {
                groupId: "86642721",
                addonId: "72640344",
              },
              {
                groupId: "86642721",
                addonId: "72640345",
              },
              {
                groupId: "86642721",
                addonId: "72640346",
              },
              {
                groupId: "86642721",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569992",
                variationId: "84354450",
              },
              {
                groupId: "26569993",
                variationId: "84354460",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642721",
                addonId: "72640334",
              },
              {
                groupId: "86642721",
                addonId: "72640335",
              },
              {
                groupId: "86642721",
                addonId: "72640336",
              },
              {
                groupId: "86642721",
                addonId: "72640337",
              },
              {
                groupId: "86642721",
                addonId: "72640338",
              },
              {
                groupId: "86642721",
                addonId: "72640339",
              },
              {
                groupId: "86642721",
                addonId: "72640340",
              },
              {
                groupId: "86642721",
                addonId: "72640341",
              },
              {
                groupId: "86642721",
                addonId: "72640342",
              },
              {
                groupId: "86642721",
                addonId: "72640343",
              },
              {
                groupId: "86642721",
                addonId: "72640344",
              },
              {
                groupId: "86642721",
                addonId: "72640345",
              },
              {
                groupId: "86642721",
                addonId: "72640346",
              },
              {
                groupId: "86642721",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642721",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642723",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "47200055",
      name: "Margherita",
      category: "Veg Pizza",
      description:
        "Serves 1 | Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there!",
      imageId: "dpventcrozvfni0lqb10",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570319",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84356024",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570320",
                  variationId: "84356026",
                },
              },
              {
                name: "Medium",
                id: "84356025",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570320",
                  variationId: "84356034",
                },
              },
            ],
          },
          {
            groupId: "26570320",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 169,
                default: 1,
                id: "84356026",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 169,
                id: "84356027",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 189,
                id: "84356028",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 244,
                id: "84356029",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 244,
                id: "84356032",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 329,
                id: "84356034",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 329,
                id: "84356036",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 359,
                id: "84356039",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 428,
                id: "84356041",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 428,
                id: "84356043",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356024",
              },
              {
                groupId: "26570320",
                variationId: "84356026",
              },
            ],
            price: 16900,
            addonCombinations: [
              {
                groupId: "86642843",
                addonId: "72640314",
              },
              {
                groupId: "86642843",
                addonId: "72640315",
              },
              {
                groupId: "86642843",
                addonId: "72640316",
              },
              {
                groupId: "86642843",
                addonId: "72640317",
              },
              {
                groupId: "86642843",
                addonId: "72640318",
              },
              {
                groupId: "86642843",
                addonId: "72640319",
              },
              {
                groupId: "86642843",
                addonId: "72640320",
              },
              {
                groupId: "86642843",
                addonId: "72640321",
              },
              {
                groupId: "86642843",
                addonId: "72640322",
              },
              {
                groupId: "86642843",
                addonId: "72640323",
              },
              {
                groupId: "86642843",
                addonId: "72640324",
              },
              {
                groupId: "86642843",
                addonId: "72640325",
              },
              {
                groupId: "86642843",
                addonId: "72640326",
              },
              {
                groupId: "86642843",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356024",
              },
              {
                groupId: "26570320",
                variationId: "84356027",
              },
            ],
            price: 16900,
            addonCombinations: [
              {
                groupId: "86642843",
                addonId: "72640314",
              },
              {
                groupId: "86642843",
                addonId: "72640315",
              },
              {
                groupId: "86642843",
                addonId: "72640316",
              },
              {
                groupId: "86642843",
                addonId: "72640317",
              },
              {
                groupId: "86642843",
                addonId: "72640318",
              },
              {
                groupId: "86642843",
                addonId: "72640319",
              },
              {
                groupId: "86642843",
                addonId: "72640320",
              },
              {
                groupId: "86642843",
                addonId: "72640321",
              },
              {
                groupId: "86642843",
                addonId: "72640322",
              },
              {
                groupId: "86642843",
                addonId: "72640323",
              },
              {
                groupId: "86642843",
                addonId: "72640324",
              },
              {
                groupId: "86642843",
                addonId: "72640325",
              },
              {
                groupId: "86642843",
                addonId: "72640326",
              },
              {
                groupId: "86642843",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356024",
              },
              {
                groupId: "26570320",
                variationId: "84356028",
              },
            ],
            price: 18900,
            addonCombinations: [
              {
                groupId: "86642843",
                addonId: "72640314",
              },
              {
                groupId: "86642843",
                addonId: "72640315",
              },
              {
                groupId: "86642843",
                addonId: "72640316",
              },
              {
                groupId: "86642843",
                addonId: "72640317",
              },
              {
                groupId: "86642843",
                addonId: "72640318",
              },
              {
                groupId: "86642843",
                addonId: "72640319",
              },
              {
                groupId: "86642843",
                addonId: "72640320",
              },
              {
                groupId: "86642843",
                addonId: "72640321",
              },
              {
                groupId: "86642843",
                addonId: "72640322",
              },
              {
                groupId: "86642843",
                addonId: "72640323",
              },
              {
                groupId: "86642843",
                addonId: "72640324",
              },
              {
                groupId: "86642843",
                addonId: "72640325",
              },
              {
                groupId: "86642843",
                addonId: "72640326",
              },
              {
                groupId: "86642843",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356024",
              },
              {
                groupId: "26570320",
                variationId: "84356029",
              },
            ],
            price: 24400,
            addonCombinations: [
              {
                groupId: "86642843",
                addonId: "72640314",
              },
              {
                groupId: "86642843",
                addonId: "72640315",
              },
              {
                groupId: "86642843",
                addonId: "72640316",
              },
              {
                groupId: "86642843",
                addonId: "72640317",
              },
              {
                groupId: "86642843",
                addonId: "72640318",
              },
              {
                groupId: "86642843",
                addonId: "72640319",
              },
              {
                groupId: "86642843",
                addonId: "72640320",
              },
              {
                groupId: "86642843",
                addonId: "72640321",
              },
              {
                groupId: "86642843",
                addonId: "72640322",
              },
              {
                groupId: "86642843",
                addonId: "72640323",
              },
              {
                groupId: "86642843",
                addonId: "72640324",
              },
              {
                groupId: "86642843",
                addonId: "72640325",
              },
              {
                groupId: "86642843",
                addonId: "72640326",
              },
              {
                groupId: "86642843",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356024",
              },
              {
                groupId: "26570320",
                variationId: "84356032",
              },
            ],
            price: 24400,
            addonCombinations: [
              {
                groupId: "86642843",
                addonId: "72640314",
              },
              {
                groupId: "86642843",
                addonId: "72640315",
              },
              {
                groupId: "86642843",
                addonId: "72640316",
              },
              {
                groupId: "86642843",
                addonId: "72640317",
              },
              {
                groupId: "86642843",
                addonId: "72640318",
              },
              {
                groupId: "86642843",
                addonId: "72640319",
              },
              {
                groupId: "86642843",
                addonId: "72640320",
              },
              {
                groupId: "86642843",
                addonId: "72640321",
              },
              {
                groupId: "86642843",
                addonId: "72640322",
              },
              {
                groupId: "86642843",
                addonId: "72640323",
              },
              {
                groupId: "86642843",
                addonId: "72640324",
              },
              {
                groupId: "86642843",
                addonId: "72640325",
              },
              {
                groupId: "86642843",
                addonId: "72640326",
              },
              {
                groupId: "86642843",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356025",
              },
              {
                groupId: "26570320",
                variationId: "84356034",
              },
            ],
            price: 32900,
            addonCombinations: [
              {
                groupId: "86642842",
                addonId: "72640334",
              },
              {
                groupId: "86642842",
                addonId: "72640335",
              },
              {
                groupId: "86642842",
                addonId: "72640336",
              },
              {
                groupId: "86642842",
                addonId: "72640337",
              },
              {
                groupId: "86642842",
                addonId: "72640338",
              },
              {
                groupId: "86642842",
                addonId: "72640339",
              },
              {
                groupId: "86642842",
                addonId: "72640340",
              },
              {
                groupId: "86642842",
                addonId: "72640341",
              },
              {
                groupId: "86642842",
                addonId: "72640342",
              },
              {
                groupId: "86642842",
                addonId: "72640343",
              },
              {
                groupId: "86642842",
                addonId: "72640344",
              },
              {
                groupId: "86642842",
                addonId: "72640345",
              },
              {
                groupId: "86642842",
                addonId: "72640346",
              },
              {
                groupId: "86642842",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356025",
              },
              {
                groupId: "26570320",
                variationId: "84356036",
              },
            ],
            price: 32900,
            addonCombinations: [
              {
                groupId: "86642842",
                addonId: "72640334",
              },
              {
                groupId: "86642842",
                addonId: "72640335",
              },
              {
                groupId: "86642842",
                addonId: "72640336",
              },
              {
                groupId: "86642842",
                addonId: "72640337",
              },
              {
                groupId: "86642842",
                addonId: "72640338",
              },
              {
                groupId: "86642842",
                addonId: "72640339",
              },
              {
                groupId: "86642842",
                addonId: "72640340",
              },
              {
                groupId: "86642842",
                addonId: "72640341",
              },
              {
                groupId: "86642842",
                addonId: "72640342",
              },
              {
                groupId: "86642842",
                addonId: "72640343",
              },
              {
                groupId: "86642842",
                addonId: "72640344",
              },
              {
                groupId: "86642842",
                addonId: "72640345",
              },
              {
                groupId: "86642842",
                addonId: "72640346",
              },
              {
                groupId: "86642842",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356025",
              },
              {
                groupId: "26570320",
                variationId: "84356039",
              },
            ],
            price: 35900,
            addonCombinations: [
              {
                groupId: "86642842",
                addonId: "72640334",
              },
              {
                groupId: "86642842",
                addonId: "72640335",
              },
              {
                groupId: "86642842",
                addonId: "72640336",
              },
              {
                groupId: "86642842",
                addonId: "72640337",
              },
              {
                groupId: "86642842",
                addonId: "72640338",
              },
              {
                groupId: "86642842",
                addonId: "72640339",
              },
              {
                groupId: "86642842",
                addonId: "72640340",
              },
              {
                groupId: "86642842",
                addonId: "72640341",
              },
              {
                groupId: "86642842",
                addonId: "72640342",
              },
              {
                groupId: "86642842",
                addonId: "72640343",
              },
              {
                groupId: "86642842",
                addonId: "72640344",
              },
              {
                groupId: "86642842",
                addonId: "72640345",
              },
              {
                groupId: "86642842",
                addonId: "72640346",
              },
              {
                groupId: "86642842",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356025",
              },
              {
                groupId: "26570320",
                variationId: "84356041",
              },
            ],
            price: 42800,
            addonCombinations: [
              {
                groupId: "86642842",
                addonId: "72640334",
              },
              {
                groupId: "86642842",
                addonId: "72640335",
              },
              {
                groupId: "86642842",
                addonId: "72640336",
              },
              {
                groupId: "86642842",
                addonId: "72640337",
              },
              {
                groupId: "86642842",
                addonId: "72640338",
              },
              {
                groupId: "86642842",
                addonId: "72640339",
              },
              {
                groupId: "86642842",
                addonId: "72640340",
              },
              {
                groupId: "86642842",
                addonId: "72640341",
              },
              {
                groupId: "86642842",
                addonId: "72640342",
              },
              {
                groupId: "86642842",
                addonId: "72640343",
              },
              {
                groupId: "86642842",
                addonId: "72640344",
              },
              {
                groupId: "86642842",
                addonId: "72640345",
              },
              {
                groupId: "86642842",
                addonId: "72640346",
              },
              {
                groupId: "86642842",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570319",
                variationId: "84356025",
              },
              {
                groupId: "26570320",
                variationId: "84356043",
              },
            ],
            price: 42800,
            addonCombinations: [
              {
                groupId: "86642842",
                addonId: "72640334",
              },
              {
                groupId: "86642842",
                addonId: "72640335",
              },
              {
                groupId: "86642842",
                addonId: "72640336",
              },
              {
                groupId: "86642842",
                addonId: "72640337",
              },
              {
                groupId: "86642842",
                addonId: "72640338",
              },
              {
                groupId: "86642842",
                addonId: "72640339",
              },
              {
                groupId: "86642842",
                addonId: "72640340",
              },
              {
                groupId: "86642842",
                addonId: "72640341",
              },
              {
                groupId: "86642842",
                addonId: "72640342",
              },
              {
                groupId: "86642842",
                addonId: "72640343",
              },
              {
                groupId: "86642842",
                addonId: "72640344",
              },
              {
                groupId: "86642842",
                addonId: "72640345",
              },
              {
                groupId: "86642842",
                addonId: "72640346",
              },
              {
                groupId: "86642842",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642842",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642843",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 16900,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "89 ratings",
          ratingCountV2: "89",
        },
      },
    },
    {
      id: "47200107",
      name: "Tandoori Paneer",
      category: "Veg Pizza",
      description:
        "Serves 1 | It's our signature. Spiced Paneer, Crunchy Onions & Green Capsicum, spicy Red Paprika with delicious Tandoori Sauce and 100% mozzarella cheese!",
      imageId: "s5ld93rsknx0fhj6xarn",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569997",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84354469",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569998",
                  variationId: "84354472",
                },
              },
              {
                name: "Medium",
                id: "84354470",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569998",
                  variationId: "84354480",
                },
              },
            ],
          },
          {
            groupId: "26569998",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84354472",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84354474",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 339,
                id: "84354475",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 394,
                id: "84354477",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84354478",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84354480",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84354481",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 599,
                id: "84354483",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 668,
                id: "84354484",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84354485",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354469",
              },
              {
                groupId: "26569998",
                variationId: "84354472",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642727",
                addonId: "72640314",
              },
              {
                groupId: "86642727",
                addonId: "72640315",
              },
              {
                groupId: "86642727",
                addonId: "72640316",
              },
              {
                groupId: "86642727",
                addonId: "72640317",
              },
              {
                groupId: "86642727",
                addonId: "72640318",
              },
              {
                groupId: "86642727",
                addonId: "72640319",
              },
              {
                groupId: "86642727",
                addonId: "72640320",
              },
              {
                groupId: "86642727",
                addonId: "72640321",
              },
              {
                groupId: "86642727",
                addonId: "72640322",
              },
              {
                groupId: "86642727",
                addonId: "72640323",
              },
              {
                groupId: "86642727",
                addonId: "72640324",
              },
              {
                groupId: "86642727",
                addonId: "72640325",
              },
              {
                groupId: "86642727",
                addonId: "72640326",
              },
              {
                groupId: "86642727",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354469",
              },
              {
                groupId: "26569998",
                variationId: "84354474",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642727",
                addonId: "72640314",
              },
              {
                groupId: "86642727",
                addonId: "72640315",
              },
              {
                groupId: "86642727",
                addonId: "72640316",
              },
              {
                groupId: "86642727",
                addonId: "72640317",
              },
              {
                groupId: "86642727",
                addonId: "72640318",
              },
              {
                groupId: "86642727",
                addonId: "72640319",
              },
              {
                groupId: "86642727",
                addonId: "72640320",
              },
              {
                groupId: "86642727",
                addonId: "72640321",
              },
              {
                groupId: "86642727",
                addonId: "72640322",
              },
              {
                groupId: "86642727",
                addonId: "72640323",
              },
              {
                groupId: "86642727",
                addonId: "72640324",
              },
              {
                groupId: "86642727",
                addonId: "72640325",
              },
              {
                groupId: "86642727",
                addonId: "72640326",
              },
              {
                groupId: "86642727",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354469",
              },
              {
                groupId: "26569998",
                variationId: "84354475",
              },
            ],
            price: 33900,
            addonCombinations: [
              {
                groupId: "86642727",
                addonId: "72640314",
              },
              {
                groupId: "86642727",
                addonId: "72640315",
              },
              {
                groupId: "86642727",
                addonId: "72640316",
              },
              {
                groupId: "86642727",
                addonId: "72640317",
              },
              {
                groupId: "86642727",
                addonId: "72640318",
              },
              {
                groupId: "86642727",
                addonId: "72640319",
              },
              {
                groupId: "86642727",
                addonId: "72640320",
              },
              {
                groupId: "86642727",
                addonId: "72640321",
              },
              {
                groupId: "86642727",
                addonId: "72640322",
              },
              {
                groupId: "86642727",
                addonId: "72640323",
              },
              {
                groupId: "86642727",
                addonId: "72640324",
              },
              {
                groupId: "86642727",
                addonId: "72640325",
              },
              {
                groupId: "86642727",
                addonId: "72640326",
              },
              {
                groupId: "86642727",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354469",
              },
              {
                groupId: "26569998",
                variationId: "84354477",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642727",
                addonId: "72640314",
              },
              {
                groupId: "86642727",
                addonId: "72640315",
              },
              {
                groupId: "86642727",
                addonId: "72640316",
              },
              {
                groupId: "86642727",
                addonId: "72640317",
              },
              {
                groupId: "86642727",
                addonId: "72640318",
              },
              {
                groupId: "86642727",
                addonId: "72640319",
              },
              {
                groupId: "86642727",
                addonId: "72640320",
              },
              {
                groupId: "86642727",
                addonId: "72640321",
              },
              {
                groupId: "86642727",
                addonId: "72640322",
              },
              {
                groupId: "86642727",
                addonId: "72640323",
              },
              {
                groupId: "86642727",
                addonId: "72640324",
              },
              {
                groupId: "86642727",
                addonId: "72640325",
              },
              {
                groupId: "86642727",
                addonId: "72640326",
              },
              {
                groupId: "86642727",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354469",
              },
              {
                groupId: "26569998",
                variationId: "84354478",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642727",
                addonId: "72640314",
              },
              {
                groupId: "86642727",
                addonId: "72640315",
              },
              {
                groupId: "86642727",
                addonId: "72640316",
              },
              {
                groupId: "86642727",
                addonId: "72640317",
              },
              {
                groupId: "86642727",
                addonId: "72640318",
              },
              {
                groupId: "86642727",
                addonId: "72640319",
              },
              {
                groupId: "86642727",
                addonId: "72640320",
              },
              {
                groupId: "86642727",
                addonId: "72640321",
              },
              {
                groupId: "86642727",
                addonId: "72640322",
              },
              {
                groupId: "86642727",
                addonId: "72640323",
              },
              {
                groupId: "86642727",
                addonId: "72640324",
              },
              {
                groupId: "86642727",
                addonId: "72640325",
              },
              {
                groupId: "86642727",
                addonId: "72640326",
              },
              {
                groupId: "86642727",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354470",
              },
              {
                groupId: "26569998",
                variationId: "84354480",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642726",
                addonId: "72640334",
              },
              {
                groupId: "86642726",
                addonId: "72640335",
              },
              {
                groupId: "86642726",
                addonId: "72640336",
              },
              {
                groupId: "86642726",
                addonId: "72640337",
              },
              {
                groupId: "86642726",
                addonId: "72640338",
              },
              {
                groupId: "86642726",
                addonId: "72640339",
              },
              {
                groupId: "86642726",
                addonId: "72640340",
              },
              {
                groupId: "86642726",
                addonId: "72640341",
              },
              {
                groupId: "86642726",
                addonId: "72640342",
              },
              {
                groupId: "86642726",
                addonId: "72640343",
              },
              {
                groupId: "86642726",
                addonId: "72640344",
              },
              {
                groupId: "86642726",
                addonId: "72640345",
              },
              {
                groupId: "86642726",
                addonId: "72640346",
              },
              {
                groupId: "86642726",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354470",
              },
              {
                groupId: "26569998",
                variationId: "84354481",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642726",
                addonId: "72640334",
              },
              {
                groupId: "86642726",
                addonId: "72640335",
              },
              {
                groupId: "86642726",
                addonId: "72640336",
              },
              {
                groupId: "86642726",
                addonId: "72640337",
              },
              {
                groupId: "86642726",
                addonId: "72640338",
              },
              {
                groupId: "86642726",
                addonId: "72640339",
              },
              {
                groupId: "86642726",
                addonId: "72640340",
              },
              {
                groupId: "86642726",
                addonId: "72640341",
              },
              {
                groupId: "86642726",
                addonId: "72640342",
              },
              {
                groupId: "86642726",
                addonId: "72640343",
              },
              {
                groupId: "86642726",
                addonId: "72640344",
              },
              {
                groupId: "86642726",
                addonId: "72640345",
              },
              {
                groupId: "86642726",
                addonId: "72640346",
              },
              {
                groupId: "86642726",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354470",
              },
              {
                groupId: "26569998",
                variationId: "84354483",
              },
            ],
            price: 59900,
            addonCombinations: [
              {
                groupId: "86642726",
                addonId: "72640334",
              },
              {
                groupId: "86642726",
                addonId: "72640335",
              },
              {
                groupId: "86642726",
                addonId: "72640336",
              },
              {
                groupId: "86642726",
                addonId: "72640337",
              },
              {
                groupId: "86642726",
                addonId: "72640338",
              },
              {
                groupId: "86642726",
                addonId: "72640339",
              },
              {
                groupId: "86642726",
                addonId: "72640340",
              },
              {
                groupId: "86642726",
                addonId: "72640341",
              },
              {
                groupId: "86642726",
                addonId: "72640342",
              },
              {
                groupId: "86642726",
                addonId: "72640343",
              },
              {
                groupId: "86642726",
                addonId: "72640344",
              },
              {
                groupId: "86642726",
                addonId: "72640345",
              },
              {
                groupId: "86642726",
                addonId: "72640346",
              },
              {
                groupId: "86642726",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354470",
              },
              {
                groupId: "26569998",
                variationId: "84354484",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642726",
                addonId: "72640334",
              },
              {
                groupId: "86642726",
                addonId: "72640335",
              },
              {
                groupId: "86642726",
                addonId: "72640336",
              },
              {
                groupId: "86642726",
                addonId: "72640337",
              },
              {
                groupId: "86642726",
                addonId: "72640338",
              },
              {
                groupId: "86642726",
                addonId: "72640339",
              },
              {
                groupId: "86642726",
                addonId: "72640340",
              },
              {
                groupId: "86642726",
                addonId: "72640341",
              },
              {
                groupId: "86642726",
                addonId: "72640342",
              },
              {
                groupId: "86642726",
                addonId: "72640343",
              },
              {
                groupId: "86642726",
                addonId: "72640344",
              },
              {
                groupId: "86642726",
                addonId: "72640345",
              },
              {
                groupId: "86642726",
                addonId: "72640346",
              },
              {
                groupId: "86642726",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569997",
                variationId: "84354470",
              },
              {
                groupId: "26569998",
                variationId: "84354485",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642726",
                addonId: "72640334",
              },
              {
                groupId: "86642726",
                addonId: "72640335",
              },
              {
                groupId: "86642726",
                addonId: "72640336",
              },
              {
                groupId: "86642726",
                addonId: "72640337",
              },
              {
                groupId: "86642726",
                addonId: "72640338",
              },
              {
                groupId: "86642726",
                addonId: "72640339",
              },
              {
                groupId: "86642726",
                addonId: "72640340",
              },
              {
                groupId: "86642726",
                addonId: "72640341",
              },
              {
                groupId: "86642726",
                addonId: "72640342",
              },
              {
                groupId: "86642726",
                addonId: "72640343",
              },
              {
                groupId: "86642726",
                addonId: "72640344",
              },
              {
                groupId: "86642726",
                addonId: "72640345",
              },
              {
                groupId: "86642726",
                addonId: "72640346",
              },
              {
                groupId: "86642726",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642726",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642727",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "53 ratings",
          ratingCountV2: "53",
        },
      },
    },
    {
      id: "47200135",
      name: "Veggie Feast",
      category: "Veg Pizza",
      description:
        "Serves 1 | Herbed onion and Green Capsicum, juicy Sweet Corn & 100% mozzarella cheese with flavourful pan sauce.",
      imageId: "cbye9x7wxeopwqvenn7g",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570383",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84356386",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570385",
                  variationId: "84356395",
                },
              },
              {
                name: "Medium",
                id: "84356391",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570385",
                  variationId: "84356408",
                },
              },
            ],
          },
          {
            groupId: "26570385",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 259,
                default: 1,
                id: "84356395",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 259,
                id: "84356398",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 279,
                id: "84356401",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 334,
                id: "84356404",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 334,
                id: "84356406",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 489,
                id: "84356408",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 489,
                id: "84356411",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 519,
                id: "84356413",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 588,
                id: "84356415",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 588,
                id: "84356417",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356386",
              },
              {
                groupId: "26570385",
                variationId: "84356395",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642861",
                addonId: "72640314",
              },
              {
                groupId: "86642861",
                addonId: "72640315",
              },
              {
                groupId: "86642861",
                addonId: "72640316",
              },
              {
                groupId: "86642861",
                addonId: "72640317",
              },
              {
                groupId: "86642861",
                addonId: "72640318",
              },
              {
                groupId: "86642861",
                addonId: "72640319",
              },
              {
                groupId: "86642861",
                addonId: "72640320",
              },
              {
                groupId: "86642861",
                addonId: "72640321",
              },
              {
                groupId: "86642861",
                addonId: "72640322",
              },
              {
                groupId: "86642861",
                addonId: "72640323",
              },
              {
                groupId: "86642861",
                addonId: "72640324",
              },
              {
                groupId: "86642861",
                addonId: "72640325",
              },
              {
                groupId: "86642861",
                addonId: "72640326",
              },
              {
                groupId: "86642861",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356386",
              },
              {
                groupId: "26570385",
                variationId: "84356398",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642861",
                addonId: "72640314",
              },
              {
                groupId: "86642861",
                addonId: "72640315",
              },
              {
                groupId: "86642861",
                addonId: "72640316",
              },
              {
                groupId: "86642861",
                addonId: "72640317",
              },
              {
                groupId: "86642861",
                addonId: "72640318",
              },
              {
                groupId: "86642861",
                addonId: "72640319",
              },
              {
                groupId: "86642861",
                addonId: "72640320",
              },
              {
                groupId: "86642861",
                addonId: "72640321",
              },
              {
                groupId: "86642861",
                addonId: "72640322",
              },
              {
                groupId: "86642861",
                addonId: "72640323",
              },
              {
                groupId: "86642861",
                addonId: "72640324",
              },
              {
                groupId: "86642861",
                addonId: "72640325",
              },
              {
                groupId: "86642861",
                addonId: "72640326",
              },
              {
                groupId: "86642861",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356386",
              },
              {
                groupId: "26570385",
                variationId: "84356401",
              },
            ],
            price: 27900,
            addonCombinations: [
              {
                groupId: "86642861",
                addonId: "72640314",
              },
              {
                groupId: "86642861",
                addonId: "72640315",
              },
              {
                groupId: "86642861",
                addonId: "72640316",
              },
              {
                groupId: "86642861",
                addonId: "72640317",
              },
              {
                groupId: "86642861",
                addonId: "72640318",
              },
              {
                groupId: "86642861",
                addonId: "72640319",
              },
              {
                groupId: "86642861",
                addonId: "72640320",
              },
              {
                groupId: "86642861",
                addonId: "72640321",
              },
              {
                groupId: "86642861",
                addonId: "72640322",
              },
              {
                groupId: "86642861",
                addonId: "72640323",
              },
              {
                groupId: "86642861",
                addonId: "72640324",
              },
              {
                groupId: "86642861",
                addonId: "72640325",
              },
              {
                groupId: "86642861",
                addonId: "72640326",
              },
              {
                groupId: "86642861",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356386",
              },
              {
                groupId: "26570385",
                variationId: "84356404",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642861",
                addonId: "72640314",
              },
              {
                groupId: "86642861",
                addonId: "72640315",
              },
              {
                groupId: "86642861",
                addonId: "72640316",
              },
              {
                groupId: "86642861",
                addonId: "72640317",
              },
              {
                groupId: "86642861",
                addonId: "72640318",
              },
              {
                groupId: "86642861",
                addonId: "72640319",
              },
              {
                groupId: "86642861",
                addonId: "72640320",
              },
              {
                groupId: "86642861",
                addonId: "72640321",
              },
              {
                groupId: "86642861",
                addonId: "72640322",
              },
              {
                groupId: "86642861",
                addonId: "72640323",
              },
              {
                groupId: "86642861",
                addonId: "72640324",
              },
              {
                groupId: "86642861",
                addonId: "72640325",
              },
              {
                groupId: "86642861",
                addonId: "72640326",
              },
              {
                groupId: "86642861",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356386",
              },
              {
                groupId: "26570385",
                variationId: "84356406",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642861",
                addonId: "72640314",
              },
              {
                groupId: "86642861",
                addonId: "72640315",
              },
              {
                groupId: "86642861",
                addonId: "72640316",
              },
              {
                groupId: "86642861",
                addonId: "72640317",
              },
              {
                groupId: "86642861",
                addonId: "72640318",
              },
              {
                groupId: "86642861",
                addonId: "72640319",
              },
              {
                groupId: "86642861",
                addonId: "72640320",
              },
              {
                groupId: "86642861",
                addonId: "72640321",
              },
              {
                groupId: "86642861",
                addonId: "72640322",
              },
              {
                groupId: "86642861",
                addonId: "72640323",
              },
              {
                groupId: "86642861",
                addonId: "72640324",
              },
              {
                groupId: "86642861",
                addonId: "72640325",
              },
              {
                groupId: "86642861",
                addonId: "72640326",
              },
              {
                groupId: "86642861",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356391",
              },
              {
                groupId: "26570385",
                variationId: "84356408",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642860",
                addonId: "72640334",
              },
              {
                groupId: "86642860",
                addonId: "72640335",
              },
              {
                groupId: "86642860",
                addonId: "72640336",
              },
              {
                groupId: "86642860",
                addonId: "72640337",
              },
              {
                groupId: "86642860",
                addonId: "72640338",
              },
              {
                groupId: "86642860",
                addonId: "72640339",
              },
              {
                groupId: "86642860",
                addonId: "72640340",
              },
              {
                groupId: "86642860",
                addonId: "72640341",
              },
              {
                groupId: "86642860",
                addonId: "72640342",
              },
              {
                groupId: "86642860",
                addonId: "72640343",
              },
              {
                groupId: "86642860",
                addonId: "72640344",
              },
              {
                groupId: "86642860",
                addonId: "72640345",
              },
              {
                groupId: "86642860",
                addonId: "72640346",
              },
              {
                groupId: "86642860",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356391",
              },
              {
                groupId: "26570385",
                variationId: "84356411",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642860",
                addonId: "72640334",
              },
              {
                groupId: "86642860",
                addonId: "72640335",
              },
              {
                groupId: "86642860",
                addonId: "72640336",
              },
              {
                groupId: "86642860",
                addonId: "72640337",
              },
              {
                groupId: "86642860",
                addonId: "72640338",
              },
              {
                groupId: "86642860",
                addonId: "72640339",
              },
              {
                groupId: "86642860",
                addonId: "72640340",
              },
              {
                groupId: "86642860",
                addonId: "72640341",
              },
              {
                groupId: "86642860",
                addonId: "72640342",
              },
              {
                groupId: "86642860",
                addonId: "72640343",
              },
              {
                groupId: "86642860",
                addonId: "72640344",
              },
              {
                groupId: "86642860",
                addonId: "72640345",
              },
              {
                groupId: "86642860",
                addonId: "72640346",
              },
              {
                groupId: "86642860",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356391",
              },
              {
                groupId: "26570385",
                variationId: "84356413",
              },
            ],
            price: 51900,
            addonCombinations: [
              {
                groupId: "86642860",
                addonId: "72640334",
              },
              {
                groupId: "86642860",
                addonId: "72640335",
              },
              {
                groupId: "86642860",
                addonId: "72640336",
              },
              {
                groupId: "86642860",
                addonId: "72640337",
              },
              {
                groupId: "86642860",
                addonId: "72640338",
              },
              {
                groupId: "86642860",
                addonId: "72640339",
              },
              {
                groupId: "86642860",
                addonId: "72640340",
              },
              {
                groupId: "86642860",
                addonId: "72640341",
              },
              {
                groupId: "86642860",
                addonId: "72640342",
              },
              {
                groupId: "86642860",
                addonId: "72640343",
              },
              {
                groupId: "86642860",
                addonId: "72640344",
              },
              {
                groupId: "86642860",
                addonId: "72640345",
              },
              {
                groupId: "86642860",
                addonId: "72640346",
              },
              {
                groupId: "86642860",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356391",
              },
              {
                groupId: "26570385",
                variationId: "84356415",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642860",
                addonId: "72640334",
              },
              {
                groupId: "86642860",
                addonId: "72640335",
              },
              {
                groupId: "86642860",
                addonId: "72640336",
              },
              {
                groupId: "86642860",
                addonId: "72640337",
              },
              {
                groupId: "86642860",
                addonId: "72640338",
              },
              {
                groupId: "86642860",
                addonId: "72640339",
              },
              {
                groupId: "86642860",
                addonId: "72640340",
              },
              {
                groupId: "86642860",
                addonId: "72640341",
              },
              {
                groupId: "86642860",
                addonId: "72640342",
              },
              {
                groupId: "86642860",
                addonId: "72640343",
              },
              {
                groupId: "86642860",
                addonId: "72640344",
              },
              {
                groupId: "86642860",
                addonId: "72640345",
              },
              {
                groupId: "86642860",
                addonId: "72640346",
              },
              {
                groupId: "86642860",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570383",
                variationId: "84356391",
              },
              {
                groupId: "26570385",
                variationId: "84356417",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642860",
                addonId: "72640334",
              },
              {
                groupId: "86642860",
                addonId: "72640335",
              },
              {
                groupId: "86642860",
                addonId: "72640336",
              },
              {
                groupId: "86642860",
                addonId: "72640337",
              },
              {
                groupId: "86642860",
                addonId: "72640338",
              },
              {
                groupId: "86642860",
                addonId: "72640339",
              },
              {
                groupId: "86642860",
                addonId: "72640340",
              },
              {
                groupId: "86642860",
                addonId: "72640341",
              },
              {
                groupId: "86642860",
                addonId: "72640342",
              },
              {
                groupId: "86642860",
                addonId: "72640343",
              },
              {
                groupId: "86642860",
                addonId: "72640344",
              },
              {
                groupId: "86642860",
                addonId: "72640345",
              },
              {
                groupId: "86642860",
                addonId: "72640346",
              },
              {
                groupId: "86642860",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642860",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642861",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 25900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "37 ratings",
          ratingCountV2: "37",
        },
      },
    },
    {
      id: "47200146",
      name: "Veggie Lover",
      category: "Veg Pizza",
      description:
        "Serves 1 | Crunchy Onions, Green Capsicum, Mushroom, Tomato & Red Paprika topped on our signature pan pizza base with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "ibbl63tauvntdic0gnvq",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569977",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84354367",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569978",
                  variationId: "84354371",
                },
              },
              {
                name: "Medium",
                id: "84354368",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569978",
                  variationId: "84354382",
                },
              },
            ],
          },
          {
            groupId: "26569978",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84354371",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84354374",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 339,
                id: "84354375",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 394,
                id: "84354378",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84354381",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84354382",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84354385",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 599,
                id: "84354388",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 668,
                id: "84354391",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84354393",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354367",
              },
              {
                groupId: "26569978",
                variationId: "84354371",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642713",
                addonId: "72640314",
              },
              {
                groupId: "86642713",
                addonId: "72640315",
              },
              {
                groupId: "86642713",
                addonId: "72640316",
              },
              {
                groupId: "86642713",
                addonId: "72640317",
              },
              {
                groupId: "86642713",
                addonId: "72640318",
              },
              {
                groupId: "86642713",
                addonId: "72640319",
              },
              {
                groupId: "86642713",
                addonId: "72640320",
              },
              {
                groupId: "86642713",
                addonId: "72640321",
              },
              {
                groupId: "86642713",
                addonId: "72640322",
              },
              {
                groupId: "86642713",
                addonId: "72640323",
              },
              {
                groupId: "86642713",
                addonId: "72640324",
              },
              {
                groupId: "86642713",
                addonId: "72640325",
              },
              {
                groupId: "86642713",
                addonId: "72640326",
              },
              {
                groupId: "86642713",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354367",
              },
              {
                groupId: "26569978",
                variationId: "84354374",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642713",
                addonId: "72640314",
              },
              {
                groupId: "86642713",
                addonId: "72640315",
              },
              {
                groupId: "86642713",
                addonId: "72640316",
              },
              {
                groupId: "86642713",
                addonId: "72640317",
              },
              {
                groupId: "86642713",
                addonId: "72640318",
              },
              {
                groupId: "86642713",
                addonId: "72640319",
              },
              {
                groupId: "86642713",
                addonId: "72640320",
              },
              {
                groupId: "86642713",
                addonId: "72640321",
              },
              {
                groupId: "86642713",
                addonId: "72640322",
              },
              {
                groupId: "86642713",
                addonId: "72640323",
              },
              {
                groupId: "86642713",
                addonId: "72640324",
              },
              {
                groupId: "86642713",
                addonId: "72640325",
              },
              {
                groupId: "86642713",
                addonId: "72640326",
              },
              {
                groupId: "86642713",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354367",
              },
              {
                groupId: "26569978",
                variationId: "84354375",
              },
            ],
            price: 33900,
            addonCombinations: [
              {
                groupId: "86642713",
                addonId: "72640314",
              },
              {
                groupId: "86642713",
                addonId: "72640315",
              },
              {
                groupId: "86642713",
                addonId: "72640316",
              },
              {
                groupId: "86642713",
                addonId: "72640317",
              },
              {
                groupId: "86642713",
                addonId: "72640318",
              },
              {
                groupId: "86642713",
                addonId: "72640319",
              },
              {
                groupId: "86642713",
                addonId: "72640320",
              },
              {
                groupId: "86642713",
                addonId: "72640321",
              },
              {
                groupId: "86642713",
                addonId: "72640322",
              },
              {
                groupId: "86642713",
                addonId: "72640323",
              },
              {
                groupId: "86642713",
                addonId: "72640324",
              },
              {
                groupId: "86642713",
                addonId: "72640325",
              },
              {
                groupId: "86642713",
                addonId: "72640326",
              },
              {
                groupId: "86642713",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354367",
              },
              {
                groupId: "26569978",
                variationId: "84354378",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642713",
                addonId: "72640314",
              },
              {
                groupId: "86642713",
                addonId: "72640315",
              },
              {
                groupId: "86642713",
                addonId: "72640316",
              },
              {
                groupId: "86642713",
                addonId: "72640317",
              },
              {
                groupId: "86642713",
                addonId: "72640318",
              },
              {
                groupId: "86642713",
                addonId: "72640319",
              },
              {
                groupId: "86642713",
                addonId: "72640320",
              },
              {
                groupId: "86642713",
                addonId: "72640321",
              },
              {
                groupId: "86642713",
                addonId: "72640322",
              },
              {
                groupId: "86642713",
                addonId: "72640323",
              },
              {
                groupId: "86642713",
                addonId: "72640324",
              },
              {
                groupId: "86642713",
                addonId: "72640325",
              },
              {
                groupId: "86642713",
                addonId: "72640326",
              },
              {
                groupId: "86642713",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354367",
              },
              {
                groupId: "26569978",
                variationId: "84354381",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642713",
                addonId: "72640314",
              },
              {
                groupId: "86642713",
                addonId: "72640315",
              },
              {
                groupId: "86642713",
                addonId: "72640316",
              },
              {
                groupId: "86642713",
                addonId: "72640317",
              },
              {
                groupId: "86642713",
                addonId: "72640318",
              },
              {
                groupId: "86642713",
                addonId: "72640319",
              },
              {
                groupId: "86642713",
                addonId: "72640320",
              },
              {
                groupId: "86642713",
                addonId: "72640321",
              },
              {
                groupId: "86642713",
                addonId: "72640322",
              },
              {
                groupId: "86642713",
                addonId: "72640323",
              },
              {
                groupId: "86642713",
                addonId: "72640324",
              },
              {
                groupId: "86642713",
                addonId: "72640325",
              },
              {
                groupId: "86642713",
                addonId: "72640326",
              },
              {
                groupId: "86642713",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354368",
              },
              {
                groupId: "26569978",
                variationId: "84354382",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642710",
                addonId: "72640334",
              },
              {
                groupId: "86642710",
                addonId: "72640335",
              },
              {
                groupId: "86642710",
                addonId: "72640336",
              },
              {
                groupId: "86642710",
                addonId: "72640337",
              },
              {
                groupId: "86642710",
                addonId: "72640338",
              },
              {
                groupId: "86642710",
                addonId: "72640339",
              },
              {
                groupId: "86642710",
                addonId: "72640340",
              },
              {
                groupId: "86642710",
                addonId: "72640341",
              },
              {
                groupId: "86642710",
                addonId: "72640342",
              },
              {
                groupId: "86642710",
                addonId: "72640343",
              },
              {
                groupId: "86642710",
                addonId: "72640344",
              },
              {
                groupId: "86642710",
                addonId: "72640345",
              },
              {
                groupId: "86642710",
                addonId: "72640346",
              },
              {
                groupId: "86642710",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354368",
              },
              {
                groupId: "26569978",
                variationId: "84354385",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642710",
                addonId: "72640334",
              },
              {
                groupId: "86642710",
                addonId: "72640335",
              },
              {
                groupId: "86642710",
                addonId: "72640336",
              },
              {
                groupId: "86642710",
                addonId: "72640337",
              },
              {
                groupId: "86642710",
                addonId: "72640338",
              },
              {
                groupId: "86642710",
                addonId: "72640339",
              },
              {
                groupId: "86642710",
                addonId: "72640340",
              },
              {
                groupId: "86642710",
                addonId: "72640341",
              },
              {
                groupId: "86642710",
                addonId: "72640342",
              },
              {
                groupId: "86642710",
                addonId: "72640343",
              },
              {
                groupId: "86642710",
                addonId: "72640344",
              },
              {
                groupId: "86642710",
                addonId: "72640345",
              },
              {
                groupId: "86642710",
                addonId: "72640346",
              },
              {
                groupId: "86642710",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354368",
              },
              {
                groupId: "26569978",
                variationId: "84354388",
              },
            ],
            price: 59900,
            addonCombinations: [
              {
                groupId: "86642710",
                addonId: "72640334",
              },
              {
                groupId: "86642710",
                addonId: "72640335",
              },
              {
                groupId: "86642710",
                addonId: "72640336",
              },
              {
                groupId: "86642710",
                addonId: "72640337",
              },
              {
                groupId: "86642710",
                addonId: "72640338",
              },
              {
                groupId: "86642710",
                addonId: "72640339",
              },
              {
                groupId: "86642710",
                addonId: "72640340",
              },
              {
                groupId: "86642710",
                addonId: "72640341",
              },
              {
                groupId: "86642710",
                addonId: "72640342",
              },
              {
                groupId: "86642710",
                addonId: "72640343",
              },
              {
                groupId: "86642710",
                addonId: "72640344",
              },
              {
                groupId: "86642710",
                addonId: "72640345",
              },
              {
                groupId: "86642710",
                addonId: "72640346",
              },
              {
                groupId: "86642710",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354368",
              },
              {
                groupId: "26569978",
                variationId: "84354391",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642710",
                addonId: "72640334",
              },
              {
                groupId: "86642710",
                addonId: "72640335",
              },
              {
                groupId: "86642710",
                addonId: "72640336",
              },
              {
                groupId: "86642710",
                addonId: "72640337",
              },
              {
                groupId: "86642710",
                addonId: "72640338",
              },
              {
                groupId: "86642710",
                addonId: "72640339",
              },
              {
                groupId: "86642710",
                addonId: "72640340",
              },
              {
                groupId: "86642710",
                addonId: "72640341",
              },
              {
                groupId: "86642710",
                addonId: "72640342",
              },
              {
                groupId: "86642710",
                addonId: "72640343",
              },
              {
                groupId: "86642710",
                addonId: "72640344",
              },
              {
                groupId: "86642710",
                addonId: "72640345",
              },
              {
                groupId: "86642710",
                addonId: "72640346",
              },
              {
                groupId: "86642710",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569977",
                variationId: "84354368",
              },
              {
                groupId: "26569978",
                variationId: "84354393",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642710",
                addonId: "72640334",
              },
              {
                groupId: "86642710",
                addonId: "72640335",
              },
              {
                groupId: "86642710",
                addonId: "72640336",
              },
              {
                groupId: "86642710",
                addonId: "72640337",
              },
              {
                groupId: "86642710",
                addonId: "72640338",
              },
              {
                groupId: "86642710",
                addonId: "72640339",
              },
              {
                groupId: "86642710",
                addonId: "72640340",
              },
              {
                groupId: "86642710",
                addonId: "72640341",
              },
              {
                groupId: "86642710",
                addonId: "72640342",
              },
              {
                groupId: "86642710",
                addonId: "72640343",
              },
              {
                groupId: "86642710",
                addonId: "72640344",
              },
              {
                groupId: "86642710",
                addonId: "72640345",
              },
              {
                groupId: "86642710",
                addonId: "72640346",
              },
              {
                groupId: "86642710",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642710",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642713",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "72275936",
      name: "Veg Exotica",
      category: "Veg Pizza",
      description:
        "Serves 1 | An exotic combination of Baby Corn, Black Olives, Green Capsicum, spicy Jalapeno, Red Capsicum with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "fczfoggv5ehndszayadg",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569860",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84353814",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569861",
                  variationId: "84353816",
                },
              },
              {
                name: "Medium",
                id: "84353815",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569861",
                  variationId: "84353821",
                },
              },
            ],
          },
          {
            groupId: "26569861",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84353816",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84353817",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84353818",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 454,
                id: "84353819",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84353820",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84353821",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84353823",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84353825",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 738,
                id: "84353828",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84353831",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353814",
              },
              {
                groupId: "26569861",
                variationId: "84353816",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642621",
                addonId: "72640314",
              },
              {
                groupId: "86642621",
                addonId: "72640315",
              },
              {
                groupId: "86642621",
                addonId: "72640316",
              },
              {
                groupId: "86642621",
                addonId: "72640317",
              },
              {
                groupId: "86642621",
                addonId: "72640318",
              },
              {
                groupId: "86642621",
                addonId: "72640319",
              },
              {
                groupId: "86642621",
                addonId: "72640320",
              },
              {
                groupId: "86642621",
                addonId: "72640321",
              },
              {
                groupId: "86642621",
                addonId: "72640322",
              },
              {
                groupId: "86642621",
                addonId: "72640323",
              },
              {
                groupId: "86642621",
                addonId: "72640324",
              },
              {
                groupId: "86642621",
                addonId: "72640325",
              },
              {
                groupId: "86642621",
                addonId: "72640326",
              },
              {
                groupId: "86642621",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353814",
              },
              {
                groupId: "26569861",
                variationId: "84353817",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642621",
                addonId: "72640314",
              },
              {
                groupId: "86642621",
                addonId: "72640315",
              },
              {
                groupId: "86642621",
                addonId: "72640316",
              },
              {
                groupId: "86642621",
                addonId: "72640317",
              },
              {
                groupId: "86642621",
                addonId: "72640318",
              },
              {
                groupId: "86642621",
                addonId: "72640319",
              },
              {
                groupId: "86642621",
                addonId: "72640320",
              },
              {
                groupId: "86642621",
                addonId: "72640321",
              },
              {
                groupId: "86642621",
                addonId: "72640322",
              },
              {
                groupId: "86642621",
                addonId: "72640323",
              },
              {
                groupId: "86642621",
                addonId: "72640324",
              },
              {
                groupId: "86642621",
                addonId: "72640325",
              },
              {
                groupId: "86642621",
                addonId: "72640326",
              },
              {
                groupId: "86642621",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353814",
              },
              {
                groupId: "26569861",
                variationId: "84353818",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642621",
                addonId: "72640314",
              },
              {
                groupId: "86642621",
                addonId: "72640315",
              },
              {
                groupId: "86642621",
                addonId: "72640316",
              },
              {
                groupId: "86642621",
                addonId: "72640317",
              },
              {
                groupId: "86642621",
                addonId: "72640318",
              },
              {
                groupId: "86642621",
                addonId: "72640319",
              },
              {
                groupId: "86642621",
                addonId: "72640320",
              },
              {
                groupId: "86642621",
                addonId: "72640321",
              },
              {
                groupId: "86642621",
                addonId: "72640322",
              },
              {
                groupId: "86642621",
                addonId: "72640323",
              },
              {
                groupId: "86642621",
                addonId: "72640324",
              },
              {
                groupId: "86642621",
                addonId: "72640325",
              },
              {
                groupId: "86642621",
                addonId: "72640326",
              },
              {
                groupId: "86642621",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353814",
              },
              {
                groupId: "26569861",
                variationId: "84353819",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642621",
                addonId: "72640314",
              },
              {
                groupId: "86642621",
                addonId: "72640315",
              },
              {
                groupId: "86642621",
                addonId: "72640316",
              },
              {
                groupId: "86642621",
                addonId: "72640317",
              },
              {
                groupId: "86642621",
                addonId: "72640318",
              },
              {
                groupId: "86642621",
                addonId: "72640319",
              },
              {
                groupId: "86642621",
                addonId: "72640320",
              },
              {
                groupId: "86642621",
                addonId: "72640321",
              },
              {
                groupId: "86642621",
                addonId: "72640322",
              },
              {
                groupId: "86642621",
                addonId: "72640323",
              },
              {
                groupId: "86642621",
                addonId: "72640324",
              },
              {
                groupId: "86642621",
                addonId: "72640325",
              },
              {
                groupId: "86642621",
                addonId: "72640326",
              },
              {
                groupId: "86642621",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353814",
              },
              {
                groupId: "26569861",
                variationId: "84353820",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642621",
                addonId: "72640314",
              },
              {
                groupId: "86642621",
                addonId: "72640315",
              },
              {
                groupId: "86642621",
                addonId: "72640316",
              },
              {
                groupId: "86642621",
                addonId: "72640317",
              },
              {
                groupId: "86642621",
                addonId: "72640318",
              },
              {
                groupId: "86642621",
                addonId: "72640319",
              },
              {
                groupId: "86642621",
                addonId: "72640320",
              },
              {
                groupId: "86642621",
                addonId: "72640321",
              },
              {
                groupId: "86642621",
                addonId: "72640322",
              },
              {
                groupId: "86642621",
                addonId: "72640323",
              },
              {
                groupId: "86642621",
                addonId: "72640324",
              },
              {
                groupId: "86642621",
                addonId: "72640325",
              },
              {
                groupId: "86642621",
                addonId: "72640326",
              },
              {
                groupId: "86642621",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353815",
              },
              {
                groupId: "26569861",
                variationId: "84353821",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642618",
                addonId: "72640334",
              },
              {
                groupId: "86642618",
                addonId: "72640335",
              },
              {
                groupId: "86642618",
                addonId: "72640336",
              },
              {
                groupId: "86642618",
                addonId: "72640337",
              },
              {
                groupId: "86642618",
                addonId: "72640338",
              },
              {
                groupId: "86642618",
                addonId: "72640339",
              },
              {
                groupId: "86642618",
                addonId: "72640340",
              },
              {
                groupId: "86642618",
                addonId: "72640341",
              },
              {
                groupId: "86642618",
                addonId: "72640342",
              },
              {
                groupId: "86642618",
                addonId: "72640343",
              },
              {
                groupId: "86642618",
                addonId: "72640344",
              },
              {
                groupId: "86642618",
                addonId: "72640345",
              },
              {
                groupId: "86642618",
                addonId: "72640346",
              },
              {
                groupId: "86642618",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353815",
              },
              {
                groupId: "26569861",
                variationId: "84353823",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642618",
                addonId: "72640334",
              },
              {
                groupId: "86642618",
                addonId: "72640335",
              },
              {
                groupId: "86642618",
                addonId: "72640336",
              },
              {
                groupId: "86642618",
                addonId: "72640337",
              },
              {
                groupId: "86642618",
                addonId: "72640338",
              },
              {
                groupId: "86642618",
                addonId: "72640339",
              },
              {
                groupId: "86642618",
                addonId: "72640340",
              },
              {
                groupId: "86642618",
                addonId: "72640341",
              },
              {
                groupId: "86642618",
                addonId: "72640342",
              },
              {
                groupId: "86642618",
                addonId: "72640343",
              },
              {
                groupId: "86642618",
                addonId: "72640344",
              },
              {
                groupId: "86642618",
                addonId: "72640345",
              },
              {
                groupId: "86642618",
                addonId: "72640346",
              },
              {
                groupId: "86642618",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353815",
              },
              {
                groupId: "26569861",
                variationId: "84353825",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642618",
                addonId: "72640334",
              },
              {
                groupId: "86642618",
                addonId: "72640335",
              },
              {
                groupId: "86642618",
                addonId: "72640336",
              },
              {
                groupId: "86642618",
                addonId: "72640337",
              },
              {
                groupId: "86642618",
                addonId: "72640338",
              },
              {
                groupId: "86642618",
                addonId: "72640339",
              },
              {
                groupId: "86642618",
                addonId: "72640340",
              },
              {
                groupId: "86642618",
                addonId: "72640341",
              },
              {
                groupId: "86642618",
                addonId: "72640342",
              },
              {
                groupId: "86642618",
                addonId: "72640343",
              },
              {
                groupId: "86642618",
                addonId: "72640344",
              },
              {
                groupId: "86642618",
                addonId: "72640345",
              },
              {
                groupId: "86642618",
                addonId: "72640346",
              },
              {
                groupId: "86642618",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353815",
              },
              {
                groupId: "26569861",
                variationId: "84353828",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642618",
                addonId: "72640334",
              },
              {
                groupId: "86642618",
                addonId: "72640335",
              },
              {
                groupId: "86642618",
                addonId: "72640336",
              },
              {
                groupId: "86642618",
                addonId: "72640337",
              },
              {
                groupId: "86642618",
                addonId: "72640338",
              },
              {
                groupId: "86642618",
                addonId: "72640339",
              },
              {
                groupId: "86642618",
                addonId: "72640340",
              },
              {
                groupId: "86642618",
                addonId: "72640341",
              },
              {
                groupId: "86642618",
                addonId: "72640342",
              },
              {
                groupId: "86642618",
                addonId: "72640343",
              },
              {
                groupId: "86642618",
                addonId: "72640344",
              },
              {
                groupId: "86642618",
                addonId: "72640345",
              },
              {
                groupId: "86642618",
                addonId: "72640346",
              },
              {
                groupId: "86642618",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569860",
                variationId: "84353815",
              },
              {
                groupId: "26569861",
                variationId: "84353831",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642618",
                addonId: "72640334",
              },
              {
                groupId: "86642618",
                addonId: "72640335",
              },
              {
                groupId: "86642618",
                addonId: "72640336",
              },
              {
                groupId: "86642618",
                addonId: "72640337",
              },
              {
                groupId: "86642618",
                addonId: "72640338",
              },
              {
                groupId: "86642618",
                addonId: "72640339",
              },
              {
                groupId: "86642618",
                addonId: "72640340",
              },
              {
                groupId: "86642618",
                addonId: "72640341",
              },
              {
                groupId: "86642618",
                addonId: "72640342",
              },
              {
                groupId: "86642618",
                addonId: "72640343",
              },
              {
                groupId: "86642618",
                addonId: "72640344",
              },
              {
                groupId: "86642618",
                addonId: "72640345",
              },
              {
                groupId: "86642618",
                addonId: "72640346",
              },
              {
                groupId: "86642618",
                addonId: "72640396",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642621",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642618",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640396",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "72276012",
      name: "Corn & Cheese",
      category: "Veg Pizza",
      description:
        "Serves 1 | A combination of juicy Sweet Corn & 100% mozzarella cheese with flavourful signature pan sauce.",
      imageId: "ckbnw98n6tffy50wvuzm",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570006",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84354506",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570007",
                  variationId: "84354510",
                },
              },
              {
                name: "Medium",
                id: "84354508",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570007",
                  variationId: "84354518",
                },
              },
            ],
          },
          {
            groupId: "26570007",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 219,
                default: 1,
                id: "84354510",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 219,
                id: "84354511",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 239,
                id: "84354513",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 294,
                id: "84354515",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 294,
                id: "84354516",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 409,
                id: "84354518",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 409,
                id: "84354519",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 439,
                id: "84354521",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 508,
                id: "84354523",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 508,
                id: "84354524",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354506",
              },
              {
                groupId: "26570007",
                variationId: "84354510",
              },
            ],
            price: 21900,
            addonCombinations: [
              {
                groupId: "86642733",
                addonId: "72640314",
              },
              {
                groupId: "86642733",
                addonId: "72640315",
              },
              {
                groupId: "86642733",
                addonId: "72640316",
              },
              {
                groupId: "86642733",
                addonId: "72640317",
              },
              {
                groupId: "86642733",
                addonId: "72640318",
              },
              {
                groupId: "86642733",
                addonId: "72640319",
              },
              {
                groupId: "86642733",
                addonId: "72640320",
              },
              {
                groupId: "86642733",
                addonId: "72640321",
              },
              {
                groupId: "86642733",
                addonId: "72640322",
              },
              {
                groupId: "86642733",
                addonId: "72640323",
              },
              {
                groupId: "86642733",
                addonId: "72640324",
              },
              {
                groupId: "86642733",
                addonId: "72640325",
              },
              {
                groupId: "86642733",
                addonId: "72640326",
              },
              {
                groupId: "86642733",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354506",
              },
              {
                groupId: "26570007",
                variationId: "84354511",
              },
            ],
            price: 21900,
            addonCombinations: [
              {
                groupId: "86642733",
                addonId: "72640314",
              },
              {
                groupId: "86642733",
                addonId: "72640315",
              },
              {
                groupId: "86642733",
                addonId: "72640316",
              },
              {
                groupId: "86642733",
                addonId: "72640317",
              },
              {
                groupId: "86642733",
                addonId: "72640318",
              },
              {
                groupId: "86642733",
                addonId: "72640319",
              },
              {
                groupId: "86642733",
                addonId: "72640320",
              },
              {
                groupId: "86642733",
                addonId: "72640321",
              },
              {
                groupId: "86642733",
                addonId: "72640322",
              },
              {
                groupId: "86642733",
                addonId: "72640323",
              },
              {
                groupId: "86642733",
                addonId: "72640324",
              },
              {
                groupId: "86642733",
                addonId: "72640325",
              },
              {
                groupId: "86642733",
                addonId: "72640326",
              },
              {
                groupId: "86642733",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354506",
              },
              {
                groupId: "26570007",
                variationId: "84354513",
              },
            ],
            price: 23900,
            addonCombinations: [
              {
                groupId: "86642733",
                addonId: "72640314",
              },
              {
                groupId: "86642733",
                addonId: "72640315",
              },
              {
                groupId: "86642733",
                addonId: "72640316",
              },
              {
                groupId: "86642733",
                addonId: "72640317",
              },
              {
                groupId: "86642733",
                addonId: "72640318",
              },
              {
                groupId: "86642733",
                addonId: "72640319",
              },
              {
                groupId: "86642733",
                addonId: "72640320",
              },
              {
                groupId: "86642733",
                addonId: "72640321",
              },
              {
                groupId: "86642733",
                addonId: "72640322",
              },
              {
                groupId: "86642733",
                addonId: "72640323",
              },
              {
                groupId: "86642733",
                addonId: "72640324",
              },
              {
                groupId: "86642733",
                addonId: "72640325",
              },
              {
                groupId: "86642733",
                addonId: "72640326",
              },
              {
                groupId: "86642733",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354506",
              },
              {
                groupId: "26570007",
                variationId: "84354515",
              },
            ],
            price: 29400,
            addonCombinations: [
              {
                groupId: "86642733",
                addonId: "72640314",
              },
              {
                groupId: "86642733",
                addonId: "72640315",
              },
              {
                groupId: "86642733",
                addonId: "72640316",
              },
              {
                groupId: "86642733",
                addonId: "72640317",
              },
              {
                groupId: "86642733",
                addonId: "72640318",
              },
              {
                groupId: "86642733",
                addonId: "72640319",
              },
              {
                groupId: "86642733",
                addonId: "72640320",
              },
              {
                groupId: "86642733",
                addonId: "72640321",
              },
              {
                groupId: "86642733",
                addonId: "72640322",
              },
              {
                groupId: "86642733",
                addonId: "72640323",
              },
              {
                groupId: "86642733",
                addonId: "72640324",
              },
              {
                groupId: "86642733",
                addonId: "72640325",
              },
              {
                groupId: "86642733",
                addonId: "72640326",
              },
              {
                groupId: "86642733",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354506",
              },
              {
                groupId: "26570007",
                variationId: "84354516",
              },
            ],
            price: 29400,
            addonCombinations: [
              {
                groupId: "86642733",
                addonId: "72640314",
              },
              {
                groupId: "86642733",
                addonId: "72640315",
              },
              {
                groupId: "86642733",
                addonId: "72640316",
              },
              {
                groupId: "86642733",
                addonId: "72640317",
              },
              {
                groupId: "86642733",
                addonId: "72640318",
              },
              {
                groupId: "86642733",
                addonId: "72640319",
              },
              {
                groupId: "86642733",
                addonId: "72640320",
              },
              {
                groupId: "86642733",
                addonId: "72640321",
              },
              {
                groupId: "86642733",
                addonId: "72640322",
              },
              {
                groupId: "86642733",
                addonId: "72640323",
              },
              {
                groupId: "86642733",
                addonId: "72640324",
              },
              {
                groupId: "86642733",
                addonId: "72640325",
              },
              {
                groupId: "86642733",
                addonId: "72640326",
              },
              {
                groupId: "86642733",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354508",
              },
              {
                groupId: "26570007",
                variationId: "84354518",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642732",
                addonId: "72640334",
              },
              {
                groupId: "86642732",
                addonId: "72640335",
              },
              {
                groupId: "86642732",
                addonId: "72640336",
              },
              {
                groupId: "86642732",
                addonId: "72640337",
              },
              {
                groupId: "86642732",
                addonId: "72640338",
              },
              {
                groupId: "86642732",
                addonId: "72640339",
              },
              {
                groupId: "86642732",
                addonId: "72640340",
              },
              {
                groupId: "86642732",
                addonId: "72640341",
              },
              {
                groupId: "86642732",
                addonId: "72640342",
              },
              {
                groupId: "86642732",
                addonId: "72640343",
              },
              {
                groupId: "86642732",
                addonId: "72640344",
              },
              {
                groupId: "86642732",
                addonId: "72640345",
              },
              {
                groupId: "86642732",
                addonId: "72640346",
              },
              {
                groupId: "86642732",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354508",
              },
              {
                groupId: "26570007",
                variationId: "84354519",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642732",
                addonId: "72640334",
              },
              {
                groupId: "86642732",
                addonId: "72640335",
              },
              {
                groupId: "86642732",
                addonId: "72640336",
              },
              {
                groupId: "86642732",
                addonId: "72640337",
              },
              {
                groupId: "86642732",
                addonId: "72640338",
              },
              {
                groupId: "86642732",
                addonId: "72640339",
              },
              {
                groupId: "86642732",
                addonId: "72640340",
              },
              {
                groupId: "86642732",
                addonId: "72640341",
              },
              {
                groupId: "86642732",
                addonId: "72640342",
              },
              {
                groupId: "86642732",
                addonId: "72640343",
              },
              {
                groupId: "86642732",
                addonId: "72640344",
              },
              {
                groupId: "86642732",
                addonId: "72640345",
              },
              {
                groupId: "86642732",
                addonId: "72640346",
              },
              {
                groupId: "86642732",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354508",
              },
              {
                groupId: "26570007",
                variationId: "84354521",
              },
            ],
            price: 43900,
            addonCombinations: [
              {
                groupId: "86642732",
                addonId: "72640334",
              },
              {
                groupId: "86642732",
                addonId: "72640335",
              },
              {
                groupId: "86642732",
                addonId: "72640336",
              },
              {
                groupId: "86642732",
                addonId: "72640337",
              },
              {
                groupId: "86642732",
                addonId: "72640338",
              },
              {
                groupId: "86642732",
                addonId: "72640339",
              },
              {
                groupId: "86642732",
                addonId: "72640340",
              },
              {
                groupId: "86642732",
                addonId: "72640341",
              },
              {
                groupId: "86642732",
                addonId: "72640342",
              },
              {
                groupId: "86642732",
                addonId: "72640343",
              },
              {
                groupId: "86642732",
                addonId: "72640344",
              },
              {
                groupId: "86642732",
                addonId: "72640345",
              },
              {
                groupId: "86642732",
                addonId: "72640346",
              },
              {
                groupId: "86642732",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354508",
              },
              {
                groupId: "26570007",
                variationId: "84354523",
              },
            ],
            price: 50800,
            addonCombinations: [
              {
                groupId: "86642732",
                addonId: "72640334",
              },
              {
                groupId: "86642732",
                addonId: "72640335",
              },
              {
                groupId: "86642732",
                addonId: "72640336",
              },
              {
                groupId: "86642732",
                addonId: "72640337",
              },
              {
                groupId: "86642732",
                addonId: "72640338",
              },
              {
                groupId: "86642732",
                addonId: "72640339",
              },
              {
                groupId: "86642732",
                addonId: "72640340",
              },
              {
                groupId: "86642732",
                addonId: "72640341",
              },
              {
                groupId: "86642732",
                addonId: "72640342",
              },
              {
                groupId: "86642732",
                addonId: "72640343",
              },
              {
                groupId: "86642732",
                addonId: "72640344",
              },
              {
                groupId: "86642732",
                addonId: "72640345",
              },
              {
                groupId: "86642732",
                addonId: "72640346",
              },
              {
                groupId: "86642732",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570006",
                variationId: "84354508",
              },
              {
                groupId: "26570007",
                variationId: "84354524",
              },
            ],
            price: 50800,
            addonCombinations: [
              {
                groupId: "86642732",
                addonId: "72640334",
              },
              {
                groupId: "86642732",
                addonId: "72640335",
              },
              {
                groupId: "86642732",
                addonId: "72640336",
              },
              {
                groupId: "86642732",
                addonId: "72640337",
              },
              {
                groupId: "86642732",
                addonId: "72640338",
              },
              {
                groupId: "86642732",
                addonId: "72640339",
              },
              {
                groupId: "86642732",
                addonId: "72640340",
              },
              {
                groupId: "86642732",
                addonId: "72640341",
              },
              {
                groupId: "86642732",
                addonId: "72640342",
              },
              {
                groupId: "86642732",
                addonId: "72640343",
              },
              {
                groupId: "86642732",
                addonId: "72640344",
              },
              {
                groupId: "86642732",
                addonId: "72640345",
              },
              {
                groupId: "86642732",
                addonId: "72640346",
              },
              {
                groupId: "86642732",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642732",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642733",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 21900,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "32 ratings",
          ratingCountV2: "32",
        },
      },
    },
    {
      id: "72276022",
      name: "Tandoori Onion",
      category: "Veg Pizza",
      description:
        "Serves 1 | Lip-smacking combination of Tandoori Sauce & Onion with 100% mozzarella cheese.",
      imageId: "sxie7yopt8wye2humidg",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570272",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84355737",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570274",
                  variationId: "84355747",
                },
              },
              {
                name: "Medium",
                id: "84355743",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570274",
                  variationId: "84355757",
                },
              },
            ],
          },
          {
            groupId: "26570274",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 219,
                default: 1,
                id: "84355747",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 219,
                id: "84355750",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 239,
                id: "84355752",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 294,
                id: "84355754",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 294,
                id: "84355756",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 409,
                id: "84355757",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 409,
                id: "84355758",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 439,
                id: "84355759",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 508,
                id: "84355760",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 508,
                id: "84355761",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355737",
              },
              {
                groupId: "26570274",
                variationId: "84355747",
              },
            ],
            price: 21900,
            addonCombinations: [
              {
                groupId: "86642823",
                addonId: "72640314",
              },
              {
                groupId: "86642823",
                addonId: "72640315",
              },
              {
                groupId: "86642823",
                addonId: "72640316",
              },
              {
                groupId: "86642823",
                addonId: "72640317",
              },
              {
                groupId: "86642823",
                addonId: "72640318",
              },
              {
                groupId: "86642823",
                addonId: "72640319",
              },
              {
                groupId: "86642823",
                addonId: "72640320",
              },
              {
                groupId: "86642823",
                addonId: "72640321",
              },
              {
                groupId: "86642823",
                addonId: "72640322",
              },
              {
                groupId: "86642823",
                addonId: "72640323",
              },
              {
                groupId: "86642823",
                addonId: "72640324",
              },
              {
                groupId: "86642823",
                addonId: "72640325",
              },
              {
                groupId: "86642823",
                addonId: "72640326",
              },
              {
                groupId: "86642823",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355737",
              },
              {
                groupId: "26570274",
                variationId: "84355750",
              },
            ],
            price: 21900,
            addonCombinations: [
              {
                groupId: "86642823",
                addonId: "72640314",
              },
              {
                groupId: "86642823",
                addonId: "72640315",
              },
              {
                groupId: "86642823",
                addonId: "72640316",
              },
              {
                groupId: "86642823",
                addonId: "72640317",
              },
              {
                groupId: "86642823",
                addonId: "72640318",
              },
              {
                groupId: "86642823",
                addonId: "72640319",
              },
              {
                groupId: "86642823",
                addonId: "72640320",
              },
              {
                groupId: "86642823",
                addonId: "72640321",
              },
              {
                groupId: "86642823",
                addonId: "72640322",
              },
              {
                groupId: "86642823",
                addonId: "72640323",
              },
              {
                groupId: "86642823",
                addonId: "72640324",
              },
              {
                groupId: "86642823",
                addonId: "72640325",
              },
              {
                groupId: "86642823",
                addonId: "72640326",
              },
              {
                groupId: "86642823",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355737",
              },
              {
                groupId: "26570274",
                variationId: "84355752",
              },
            ],
            price: 23900,
            addonCombinations: [
              {
                groupId: "86642823",
                addonId: "72640314",
              },
              {
                groupId: "86642823",
                addonId: "72640315",
              },
              {
                groupId: "86642823",
                addonId: "72640316",
              },
              {
                groupId: "86642823",
                addonId: "72640317",
              },
              {
                groupId: "86642823",
                addonId: "72640318",
              },
              {
                groupId: "86642823",
                addonId: "72640319",
              },
              {
                groupId: "86642823",
                addonId: "72640320",
              },
              {
                groupId: "86642823",
                addonId: "72640321",
              },
              {
                groupId: "86642823",
                addonId: "72640322",
              },
              {
                groupId: "86642823",
                addonId: "72640323",
              },
              {
                groupId: "86642823",
                addonId: "72640324",
              },
              {
                groupId: "86642823",
                addonId: "72640325",
              },
              {
                groupId: "86642823",
                addonId: "72640326",
              },
              {
                groupId: "86642823",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355737",
              },
              {
                groupId: "26570274",
                variationId: "84355754",
              },
            ],
            price: 29400,
            addonCombinations: [
              {
                groupId: "86642823",
                addonId: "72640314",
              },
              {
                groupId: "86642823",
                addonId: "72640315",
              },
              {
                groupId: "86642823",
                addonId: "72640316",
              },
              {
                groupId: "86642823",
                addonId: "72640317",
              },
              {
                groupId: "86642823",
                addonId: "72640318",
              },
              {
                groupId: "86642823",
                addonId: "72640319",
              },
              {
                groupId: "86642823",
                addonId: "72640320",
              },
              {
                groupId: "86642823",
                addonId: "72640321",
              },
              {
                groupId: "86642823",
                addonId: "72640322",
              },
              {
                groupId: "86642823",
                addonId: "72640323",
              },
              {
                groupId: "86642823",
                addonId: "72640324",
              },
              {
                groupId: "86642823",
                addonId: "72640325",
              },
              {
                groupId: "86642823",
                addonId: "72640326",
              },
              {
                groupId: "86642823",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355737",
              },
              {
                groupId: "26570274",
                variationId: "84355756",
              },
            ],
            price: 29400,
            addonCombinations: [
              {
                groupId: "86642823",
                addonId: "72640314",
              },
              {
                groupId: "86642823",
                addonId: "72640315",
              },
              {
                groupId: "86642823",
                addonId: "72640316",
              },
              {
                groupId: "86642823",
                addonId: "72640317",
              },
              {
                groupId: "86642823",
                addonId: "72640318",
              },
              {
                groupId: "86642823",
                addonId: "72640319",
              },
              {
                groupId: "86642823",
                addonId: "72640320",
              },
              {
                groupId: "86642823",
                addonId: "72640321",
              },
              {
                groupId: "86642823",
                addonId: "72640322",
              },
              {
                groupId: "86642823",
                addonId: "72640323",
              },
              {
                groupId: "86642823",
                addonId: "72640324",
              },
              {
                groupId: "86642823",
                addonId: "72640325",
              },
              {
                groupId: "86642823",
                addonId: "72640326",
              },
              {
                groupId: "86642823",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355743",
              },
              {
                groupId: "26570274",
                variationId: "84355757",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642822",
                addonId: "72640334",
              },
              {
                groupId: "86642822",
                addonId: "72640335",
              },
              {
                groupId: "86642822",
                addonId: "72640336",
              },
              {
                groupId: "86642822",
                addonId: "72640337",
              },
              {
                groupId: "86642822",
                addonId: "72640338",
              },
              {
                groupId: "86642822",
                addonId: "72640339",
              },
              {
                groupId: "86642822",
                addonId: "72640340",
              },
              {
                groupId: "86642822",
                addonId: "72640341",
              },
              {
                groupId: "86642822",
                addonId: "72640342",
              },
              {
                groupId: "86642822",
                addonId: "72640343",
              },
              {
                groupId: "86642822",
                addonId: "72640344",
              },
              {
                groupId: "86642822",
                addonId: "72640345",
              },
              {
                groupId: "86642822",
                addonId: "72640346",
              },
              {
                groupId: "86642822",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355743",
              },
              {
                groupId: "26570274",
                variationId: "84355758",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642822",
                addonId: "72640334",
              },
              {
                groupId: "86642822",
                addonId: "72640335",
              },
              {
                groupId: "86642822",
                addonId: "72640336",
              },
              {
                groupId: "86642822",
                addonId: "72640337",
              },
              {
                groupId: "86642822",
                addonId: "72640338",
              },
              {
                groupId: "86642822",
                addonId: "72640339",
              },
              {
                groupId: "86642822",
                addonId: "72640340",
              },
              {
                groupId: "86642822",
                addonId: "72640341",
              },
              {
                groupId: "86642822",
                addonId: "72640342",
              },
              {
                groupId: "86642822",
                addonId: "72640343",
              },
              {
                groupId: "86642822",
                addonId: "72640344",
              },
              {
                groupId: "86642822",
                addonId: "72640345",
              },
              {
                groupId: "86642822",
                addonId: "72640346",
              },
              {
                groupId: "86642822",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355743",
              },
              {
                groupId: "26570274",
                variationId: "84355759",
              },
            ],
            price: 43900,
            addonCombinations: [
              {
                groupId: "86642822",
                addonId: "72640334",
              },
              {
                groupId: "86642822",
                addonId: "72640335",
              },
              {
                groupId: "86642822",
                addonId: "72640336",
              },
              {
                groupId: "86642822",
                addonId: "72640337",
              },
              {
                groupId: "86642822",
                addonId: "72640338",
              },
              {
                groupId: "86642822",
                addonId: "72640339",
              },
              {
                groupId: "86642822",
                addonId: "72640340",
              },
              {
                groupId: "86642822",
                addonId: "72640341",
              },
              {
                groupId: "86642822",
                addonId: "72640342",
              },
              {
                groupId: "86642822",
                addonId: "72640343",
              },
              {
                groupId: "86642822",
                addonId: "72640344",
              },
              {
                groupId: "86642822",
                addonId: "72640345",
              },
              {
                groupId: "86642822",
                addonId: "72640346",
              },
              {
                groupId: "86642822",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355743",
              },
              {
                groupId: "26570274",
                variationId: "84355760",
              },
            ],
            price: 50800,
            addonCombinations: [
              {
                groupId: "86642822",
                addonId: "72640334",
              },
              {
                groupId: "86642822",
                addonId: "72640335",
              },
              {
                groupId: "86642822",
                addonId: "72640336",
              },
              {
                groupId: "86642822",
                addonId: "72640337",
              },
              {
                groupId: "86642822",
                addonId: "72640338",
              },
              {
                groupId: "86642822",
                addonId: "72640339",
              },
              {
                groupId: "86642822",
                addonId: "72640340",
              },
              {
                groupId: "86642822",
                addonId: "72640341",
              },
              {
                groupId: "86642822",
                addonId: "72640342",
              },
              {
                groupId: "86642822",
                addonId: "72640343",
              },
              {
                groupId: "86642822",
                addonId: "72640344",
              },
              {
                groupId: "86642822",
                addonId: "72640345",
              },
              {
                groupId: "86642822",
                addonId: "72640346",
              },
              {
                groupId: "86642822",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570272",
                variationId: "84355743",
              },
              {
                groupId: "26570274",
                variationId: "84355761",
              },
            ],
            price: 50800,
            addonCombinations: [
              {
                groupId: "86642822",
                addonId: "72640334",
              },
              {
                groupId: "86642822",
                addonId: "72640335",
              },
              {
                groupId: "86642822",
                addonId: "72640336",
              },
              {
                groupId: "86642822",
                addonId: "72640337",
              },
              {
                groupId: "86642822",
                addonId: "72640338",
              },
              {
                groupId: "86642822",
                addonId: "72640339",
              },
              {
                groupId: "86642822",
                addonId: "72640340",
              },
              {
                groupId: "86642822",
                addonId: "72640341",
              },
              {
                groupId: "86642822",
                addonId: "72640342",
              },
              {
                groupId: "86642822",
                addonId: "72640343",
              },
              {
                groupId: "86642822",
                addonId: "72640344",
              },
              {
                groupId: "86642822",
                addonId: "72640345",
              },
              {
                groupId: "86642822",
                addonId: "72640346",
              },
              {
                groupId: "86642822",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642822",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642823",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 21900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "72276167",
      name: "Veggie Tandoori",
      category: "Veg Pizza",
      description:
        "Serves 1 | Crunchy Onion, Green Capsicum & yummy Mushroom with your favourite Tandoori Sauce.",
      imageId: "pdnars9izjxrigqy675c",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570619",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84357713",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570620",
                  variationId: "84357715",
                },
              },
              {
                name: "Medium",
                id: "84357714",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570620",
                  variationId: "84357720",
                },
              },
            ],
          },
          {
            groupId: "26570620",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 259,
                default: 1,
                id: "84357715",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 259,
                id: "84357716",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 279,
                id: "84357717",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 334,
                id: "84357718",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 334,
                id: "84357719",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 489,
                id: "84357720",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 489,
                id: "84357721",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 519,
                id: "84357722",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 588,
                id: "84357723",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 588,
                id: "84357724",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357713",
              },
              {
                groupId: "26570620",
                variationId: "84357715",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642937",
                addonId: "72640314",
              },
              {
                groupId: "86642937",
                addonId: "72640315",
              },
              {
                groupId: "86642937",
                addonId: "72640316",
              },
              {
                groupId: "86642937",
                addonId: "72640317",
              },
              {
                groupId: "86642937",
                addonId: "72640318",
              },
              {
                groupId: "86642937",
                addonId: "72640319",
              },
              {
                groupId: "86642937",
                addonId: "72640320",
              },
              {
                groupId: "86642937",
                addonId: "72640321",
              },
              {
                groupId: "86642937",
                addonId: "72640322",
              },
              {
                groupId: "86642937",
                addonId: "72640323",
              },
              {
                groupId: "86642937",
                addonId: "72640324",
              },
              {
                groupId: "86642937",
                addonId: "72640325",
              },
              {
                groupId: "86642937",
                addonId: "72640326",
              },
              {
                groupId: "86642937",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357713",
              },
              {
                groupId: "26570620",
                variationId: "84357716",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642937",
                addonId: "72640314",
              },
              {
                groupId: "86642937",
                addonId: "72640315",
              },
              {
                groupId: "86642937",
                addonId: "72640316",
              },
              {
                groupId: "86642937",
                addonId: "72640317",
              },
              {
                groupId: "86642937",
                addonId: "72640318",
              },
              {
                groupId: "86642937",
                addonId: "72640319",
              },
              {
                groupId: "86642937",
                addonId: "72640320",
              },
              {
                groupId: "86642937",
                addonId: "72640321",
              },
              {
                groupId: "86642937",
                addonId: "72640322",
              },
              {
                groupId: "86642937",
                addonId: "72640323",
              },
              {
                groupId: "86642937",
                addonId: "72640324",
              },
              {
                groupId: "86642937",
                addonId: "72640325",
              },
              {
                groupId: "86642937",
                addonId: "72640326",
              },
              {
                groupId: "86642937",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357713",
              },
              {
                groupId: "26570620",
                variationId: "84357717",
              },
            ],
            price: 27900,
            addonCombinations: [
              {
                groupId: "86642937",
                addonId: "72640314",
              },
              {
                groupId: "86642937",
                addonId: "72640315",
              },
              {
                groupId: "86642937",
                addonId: "72640316",
              },
              {
                groupId: "86642937",
                addonId: "72640317",
              },
              {
                groupId: "86642937",
                addonId: "72640318",
              },
              {
                groupId: "86642937",
                addonId: "72640319",
              },
              {
                groupId: "86642937",
                addonId: "72640320",
              },
              {
                groupId: "86642937",
                addonId: "72640321",
              },
              {
                groupId: "86642937",
                addonId: "72640322",
              },
              {
                groupId: "86642937",
                addonId: "72640323",
              },
              {
                groupId: "86642937",
                addonId: "72640324",
              },
              {
                groupId: "86642937",
                addonId: "72640325",
              },
              {
                groupId: "86642937",
                addonId: "72640326",
              },
              {
                groupId: "86642937",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357713",
              },
              {
                groupId: "26570620",
                variationId: "84357718",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642937",
                addonId: "72640314",
              },
              {
                groupId: "86642937",
                addonId: "72640315",
              },
              {
                groupId: "86642937",
                addonId: "72640316",
              },
              {
                groupId: "86642937",
                addonId: "72640317",
              },
              {
                groupId: "86642937",
                addonId: "72640318",
              },
              {
                groupId: "86642937",
                addonId: "72640319",
              },
              {
                groupId: "86642937",
                addonId: "72640320",
              },
              {
                groupId: "86642937",
                addonId: "72640321",
              },
              {
                groupId: "86642937",
                addonId: "72640322",
              },
              {
                groupId: "86642937",
                addonId: "72640323",
              },
              {
                groupId: "86642937",
                addonId: "72640324",
              },
              {
                groupId: "86642937",
                addonId: "72640325",
              },
              {
                groupId: "86642937",
                addonId: "72640326",
              },
              {
                groupId: "86642937",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357713",
              },
              {
                groupId: "26570620",
                variationId: "84357719",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642937",
                addonId: "72640314",
              },
              {
                groupId: "86642937",
                addonId: "72640315",
              },
              {
                groupId: "86642937",
                addonId: "72640316",
              },
              {
                groupId: "86642937",
                addonId: "72640317",
              },
              {
                groupId: "86642937",
                addonId: "72640318",
              },
              {
                groupId: "86642937",
                addonId: "72640319",
              },
              {
                groupId: "86642937",
                addonId: "72640320",
              },
              {
                groupId: "86642937",
                addonId: "72640321",
              },
              {
                groupId: "86642937",
                addonId: "72640322",
              },
              {
                groupId: "86642937",
                addonId: "72640323",
              },
              {
                groupId: "86642937",
                addonId: "72640324",
              },
              {
                groupId: "86642937",
                addonId: "72640325",
              },
              {
                groupId: "86642937",
                addonId: "72640326",
              },
              {
                groupId: "86642937",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357714",
              },
              {
                groupId: "26570620",
                variationId: "84357720",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642936",
                addonId: "72640334",
              },
              {
                groupId: "86642936",
                addonId: "72640335",
              },
              {
                groupId: "86642936",
                addonId: "72640336",
              },
              {
                groupId: "86642936",
                addonId: "72640337",
              },
              {
                groupId: "86642936",
                addonId: "72640338",
              },
              {
                groupId: "86642936",
                addonId: "72640339",
              },
              {
                groupId: "86642936",
                addonId: "72640340",
              },
              {
                groupId: "86642936",
                addonId: "72640341",
              },
              {
                groupId: "86642936",
                addonId: "72640342",
              },
              {
                groupId: "86642936",
                addonId: "72640343",
              },
              {
                groupId: "86642936",
                addonId: "72640344",
              },
              {
                groupId: "86642936",
                addonId: "72640345",
              },
              {
                groupId: "86642936",
                addonId: "72640346",
              },
              {
                groupId: "86642936",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357714",
              },
              {
                groupId: "26570620",
                variationId: "84357721",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642936",
                addonId: "72640334",
              },
              {
                groupId: "86642936",
                addonId: "72640335",
              },
              {
                groupId: "86642936",
                addonId: "72640336",
              },
              {
                groupId: "86642936",
                addonId: "72640337",
              },
              {
                groupId: "86642936",
                addonId: "72640338",
              },
              {
                groupId: "86642936",
                addonId: "72640339",
              },
              {
                groupId: "86642936",
                addonId: "72640340",
              },
              {
                groupId: "86642936",
                addonId: "72640341",
              },
              {
                groupId: "86642936",
                addonId: "72640342",
              },
              {
                groupId: "86642936",
                addonId: "72640343",
              },
              {
                groupId: "86642936",
                addonId: "72640344",
              },
              {
                groupId: "86642936",
                addonId: "72640345",
              },
              {
                groupId: "86642936",
                addonId: "72640346",
              },
              {
                groupId: "86642936",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357714",
              },
              {
                groupId: "26570620",
                variationId: "84357722",
              },
            ],
            price: 51900,
            addonCombinations: [
              {
                groupId: "86642936",
                addonId: "72640334",
              },
              {
                groupId: "86642936",
                addonId: "72640335",
              },
              {
                groupId: "86642936",
                addonId: "72640336",
              },
              {
                groupId: "86642936",
                addonId: "72640337",
              },
              {
                groupId: "86642936",
                addonId: "72640338",
              },
              {
                groupId: "86642936",
                addonId: "72640339",
              },
              {
                groupId: "86642936",
                addonId: "72640340",
              },
              {
                groupId: "86642936",
                addonId: "72640341",
              },
              {
                groupId: "86642936",
                addonId: "72640342",
              },
              {
                groupId: "86642936",
                addonId: "72640343",
              },
              {
                groupId: "86642936",
                addonId: "72640344",
              },
              {
                groupId: "86642936",
                addonId: "72640345",
              },
              {
                groupId: "86642936",
                addonId: "72640346",
              },
              {
                groupId: "86642936",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357714",
              },
              {
                groupId: "26570620",
                variationId: "84357723",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642936",
                addonId: "72640334",
              },
              {
                groupId: "86642936",
                addonId: "72640335",
              },
              {
                groupId: "86642936",
                addonId: "72640336",
              },
              {
                groupId: "86642936",
                addonId: "72640337",
              },
              {
                groupId: "86642936",
                addonId: "72640338",
              },
              {
                groupId: "86642936",
                addonId: "72640339",
              },
              {
                groupId: "86642936",
                addonId: "72640340",
              },
              {
                groupId: "86642936",
                addonId: "72640341",
              },
              {
                groupId: "86642936",
                addonId: "72640342",
              },
              {
                groupId: "86642936",
                addonId: "72640343",
              },
              {
                groupId: "86642936",
                addonId: "72640344",
              },
              {
                groupId: "86642936",
                addonId: "72640345",
              },
              {
                groupId: "86642936",
                addonId: "72640346",
              },
              {
                groupId: "86642936",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570619",
                variationId: "84357714",
              },
              {
                groupId: "26570620",
                variationId: "84357724",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642936",
                addonId: "72640334",
              },
              {
                groupId: "86642936",
                addonId: "72640335",
              },
              {
                groupId: "86642936",
                addonId: "72640336",
              },
              {
                groupId: "86642936",
                addonId: "72640337",
              },
              {
                groupId: "86642936",
                addonId: "72640338",
              },
              {
                groupId: "86642936",
                addonId: "72640339",
              },
              {
                groupId: "86642936",
                addonId: "72640340",
              },
              {
                groupId: "86642936",
                addonId: "72640341",
              },
              {
                groupId: "86642936",
                addonId: "72640342",
              },
              {
                groupId: "86642936",
                addonId: "72640343",
              },
              {
                groupId: "86642936",
                addonId: "72640344",
              },
              {
                groupId: "86642936",
                addonId: "72640345",
              },
              {
                groupId: "86642936",
                addonId: "72640346",
              },
              {
                groupId: "86642936",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642936",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642937",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 25900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "76895585",
      name: "Veg Kebab Surprise",
      category: "Veg Pizza",
      description:
        "Serves 1 | Flavorful Veg Kebab, crunchy Onion, Green Capsicum, Tomato & juicy Sweet Corn with  delicious Tandoori Sauce and 100% mozzarella cheese.",
      imageId: "mvkqcxttjxvafhxhah4u",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569968",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84354334",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569969",
                  variationId: "84354338",
                },
              },
              {
                name: "Medium",
                id: "84354336",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569969",
                  variationId: "84354345",
                },
              },
            ],
          },
          {
            groupId: "26569969",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84354338",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84354339",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84354341",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 454,
                id: "84354342",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84354344",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84354345",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84354347",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84354348",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 738,
                id: "84354350",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84354351",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354334",
              },
              {
                groupId: "26569969",
                variationId: "84354338",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642708",
                addonId: "72640314",
              },
              {
                groupId: "86642708",
                addonId: "72640315",
              },
              {
                groupId: "86642708",
                addonId: "72640316",
              },
              {
                groupId: "86642708",
                addonId: "72640317",
              },
              {
                groupId: "86642708",
                addonId: "72640318",
              },
              {
                groupId: "86642708",
                addonId: "72640319",
              },
              {
                groupId: "86642708",
                addonId: "72640320",
              },
              {
                groupId: "86642708",
                addonId: "72640321",
              },
              {
                groupId: "86642708",
                addonId: "72640322",
              },
              {
                groupId: "86642708",
                addonId: "72640323",
              },
              {
                groupId: "86642708",
                addonId: "72640324",
              },
              {
                groupId: "86642708",
                addonId: "72640325",
              },
              {
                groupId: "86642708",
                addonId: "72640326",
              },
              {
                groupId: "86642708",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354334",
              },
              {
                groupId: "26569969",
                variationId: "84354339",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642708",
                addonId: "72640314",
              },
              {
                groupId: "86642708",
                addonId: "72640315",
              },
              {
                groupId: "86642708",
                addonId: "72640316",
              },
              {
                groupId: "86642708",
                addonId: "72640317",
              },
              {
                groupId: "86642708",
                addonId: "72640318",
              },
              {
                groupId: "86642708",
                addonId: "72640319",
              },
              {
                groupId: "86642708",
                addonId: "72640320",
              },
              {
                groupId: "86642708",
                addonId: "72640321",
              },
              {
                groupId: "86642708",
                addonId: "72640322",
              },
              {
                groupId: "86642708",
                addonId: "72640323",
              },
              {
                groupId: "86642708",
                addonId: "72640324",
              },
              {
                groupId: "86642708",
                addonId: "72640325",
              },
              {
                groupId: "86642708",
                addonId: "72640326",
              },
              {
                groupId: "86642708",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354334",
              },
              {
                groupId: "26569969",
                variationId: "84354341",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642708",
                addonId: "72640314",
              },
              {
                groupId: "86642708",
                addonId: "72640315",
              },
              {
                groupId: "86642708",
                addonId: "72640316",
              },
              {
                groupId: "86642708",
                addonId: "72640317",
              },
              {
                groupId: "86642708",
                addonId: "72640318",
              },
              {
                groupId: "86642708",
                addonId: "72640319",
              },
              {
                groupId: "86642708",
                addonId: "72640320",
              },
              {
                groupId: "86642708",
                addonId: "72640321",
              },
              {
                groupId: "86642708",
                addonId: "72640322",
              },
              {
                groupId: "86642708",
                addonId: "72640323",
              },
              {
                groupId: "86642708",
                addonId: "72640324",
              },
              {
                groupId: "86642708",
                addonId: "72640325",
              },
              {
                groupId: "86642708",
                addonId: "72640326",
              },
              {
                groupId: "86642708",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354334",
              },
              {
                groupId: "26569969",
                variationId: "84354342",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642708",
                addonId: "72640314",
              },
              {
                groupId: "86642708",
                addonId: "72640315",
              },
              {
                groupId: "86642708",
                addonId: "72640316",
              },
              {
                groupId: "86642708",
                addonId: "72640317",
              },
              {
                groupId: "86642708",
                addonId: "72640318",
              },
              {
                groupId: "86642708",
                addonId: "72640319",
              },
              {
                groupId: "86642708",
                addonId: "72640320",
              },
              {
                groupId: "86642708",
                addonId: "72640321",
              },
              {
                groupId: "86642708",
                addonId: "72640322",
              },
              {
                groupId: "86642708",
                addonId: "72640323",
              },
              {
                groupId: "86642708",
                addonId: "72640324",
              },
              {
                groupId: "86642708",
                addonId: "72640325",
              },
              {
                groupId: "86642708",
                addonId: "72640326",
              },
              {
                groupId: "86642708",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354334",
              },
              {
                groupId: "26569969",
                variationId: "84354344",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642708",
                addonId: "72640314",
              },
              {
                groupId: "86642708",
                addonId: "72640315",
              },
              {
                groupId: "86642708",
                addonId: "72640316",
              },
              {
                groupId: "86642708",
                addonId: "72640317",
              },
              {
                groupId: "86642708",
                addonId: "72640318",
              },
              {
                groupId: "86642708",
                addonId: "72640319",
              },
              {
                groupId: "86642708",
                addonId: "72640320",
              },
              {
                groupId: "86642708",
                addonId: "72640321",
              },
              {
                groupId: "86642708",
                addonId: "72640322",
              },
              {
                groupId: "86642708",
                addonId: "72640323",
              },
              {
                groupId: "86642708",
                addonId: "72640324",
              },
              {
                groupId: "86642708",
                addonId: "72640325",
              },
              {
                groupId: "86642708",
                addonId: "72640326",
              },
              {
                groupId: "86642708",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354336",
              },
              {
                groupId: "26569969",
                variationId: "84354345",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642706",
                addonId: "72640334",
              },
              {
                groupId: "86642706",
                addonId: "72640335",
              },
              {
                groupId: "86642706",
                addonId: "72640336",
              },
              {
                groupId: "86642706",
                addonId: "72640337",
              },
              {
                groupId: "86642706",
                addonId: "72640338",
              },
              {
                groupId: "86642706",
                addonId: "72640339",
              },
              {
                groupId: "86642706",
                addonId: "72640340",
              },
              {
                groupId: "86642706",
                addonId: "72640341",
              },
              {
                groupId: "86642706",
                addonId: "72640342",
              },
              {
                groupId: "86642706",
                addonId: "72640343",
              },
              {
                groupId: "86642706",
                addonId: "72640344",
              },
              {
                groupId: "86642706",
                addonId: "72640345",
              },
              {
                groupId: "86642706",
                addonId: "72640346",
              },
              {
                groupId: "86642706",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354336",
              },
              {
                groupId: "26569969",
                variationId: "84354347",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642706",
                addonId: "72640334",
              },
              {
                groupId: "86642706",
                addonId: "72640335",
              },
              {
                groupId: "86642706",
                addonId: "72640336",
              },
              {
                groupId: "86642706",
                addonId: "72640337",
              },
              {
                groupId: "86642706",
                addonId: "72640338",
              },
              {
                groupId: "86642706",
                addonId: "72640339",
              },
              {
                groupId: "86642706",
                addonId: "72640340",
              },
              {
                groupId: "86642706",
                addonId: "72640341",
              },
              {
                groupId: "86642706",
                addonId: "72640342",
              },
              {
                groupId: "86642706",
                addonId: "72640343",
              },
              {
                groupId: "86642706",
                addonId: "72640344",
              },
              {
                groupId: "86642706",
                addonId: "72640345",
              },
              {
                groupId: "86642706",
                addonId: "72640346",
              },
              {
                groupId: "86642706",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354336",
              },
              {
                groupId: "26569969",
                variationId: "84354348",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642706",
                addonId: "72640334",
              },
              {
                groupId: "86642706",
                addonId: "72640335",
              },
              {
                groupId: "86642706",
                addonId: "72640336",
              },
              {
                groupId: "86642706",
                addonId: "72640337",
              },
              {
                groupId: "86642706",
                addonId: "72640338",
              },
              {
                groupId: "86642706",
                addonId: "72640339",
              },
              {
                groupId: "86642706",
                addonId: "72640340",
              },
              {
                groupId: "86642706",
                addonId: "72640341",
              },
              {
                groupId: "86642706",
                addonId: "72640342",
              },
              {
                groupId: "86642706",
                addonId: "72640343",
              },
              {
                groupId: "86642706",
                addonId: "72640344",
              },
              {
                groupId: "86642706",
                addonId: "72640345",
              },
              {
                groupId: "86642706",
                addonId: "72640346",
              },
              {
                groupId: "86642706",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354336",
              },
              {
                groupId: "26569969",
                variationId: "84354350",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642706",
                addonId: "72640334",
              },
              {
                groupId: "86642706",
                addonId: "72640335",
              },
              {
                groupId: "86642706",
                addonId: "72640336",
              },
              {
                groupId: "86642706",
                addonId: "72640337",
              },
              {
                groupId: "86642706",
                addonId: "72640338",
              },
              {
                groupId: "86642706",
                addonId: "72640339",
              },
              {
                groupId: "86642706",
                addonId: "72640340",
              },
              {
                groupId: "86642706",
                addonId: "72640341",
              },
              {
                groupId: "86642706",
                addonId: "72640342",
              },
              {
                groupId: "86642706",
                addonId: "72640343",
              },
              {
                groupId: "86642706",
                addonId: "72640344",
              },
              {
                groupId: "86642706",
                addonId: "72640345",
              },
              {
                groupId: "86642706",
                addonId: "72640346",
              },
              {
                groupId: "86642706",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569968",
                variationId: "84354336",
              },
              {
                groupId: "26569969",
                variationId: "84354351",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642706",
                addonId: "72640334",
              },
              {
                groupId: "86642706",
                addonId: "72640335",
              },
              {
                groupId: "86642706",
                addonId: "72640336",
              },
              {
                groupId: "86642706",
                addonId: "72640337",
              },
              {
                groupId: "86642706",
                addonId: "72640338",
              },
              {
                groupId: "86642706",
                addonId: "72640339",
              },
              {
                groupId: "86642706",
                addonId: "72640340",
              },
              {
                groupId: "86642706",
                addonId: "72640341",
              },
              {
                groupId: "86642706",
                addonId: "72640342",
              },
              {
                groupId: "86642706",
                addonId: "72640343",
              },
              {
                groupId: "86642706",
                addonId: "72640344",
              },
              {
                groupId: "86642706",
                addonId: "72640345",
              },
              {
                groupId: "86642706",
                addonId: "72640346",
              },
              {
                groupId: "86642706",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642708",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642706",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "87274176",
      name: "Spiced Paneer",
      category: "Veg Pizza",
      description:
        "Serves 1 | Spiced Paneer, crunchy Onion, juicy Tomato  & 100% mozzarella cheese, with our classic pan sauce.",
      imageId: "a89yqx09ppwlecyqterp",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570365",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84356285",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570367",
                  variationId: "84356288",
                },
              },
              {
                name: "Medium",
                id: "84356286",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570367",
                  variationId: "84356302",
                },
              },
            ],
          },
          {
            groupId: "26570367",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 259,
                default: 1,
                id: "84356288",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 259,
                id: "84356291",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 279,
                id: "84356293",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 334,
                id: "84356296",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 334,
                id: "84356298",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 489,
                id: "84356302",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 489,
                id: "84356305",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 519,
                id: "84356308",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 588,
                id: "84356311",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 588,
                id: "84356313",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356285",
              },
              {
                groupId: "26570367",
                variationId: "84356288",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642858",
                addonId: "72640314",
              },
              {
                groupId: "86642858",
                addonId: "72640315",
              },
              {
                groupId: "86642858",
                addonId: "72640316",
              },
              {
                groupId: "86642858",
                addonId: "72640317",
              },
              {
                groupId: "86642858",
                addonId: "72640318",
              },
              {
                groupId: "86642858",
                addonId: "72640319",
              },
              {
                groupId: "86642858",
                addonId: "72640320",
              },
              {
                groupId: "86642858",
                addonId: "72640321",
              },
              {
                groupId: "86642858",
                addonId: "72640322",
              },
              {
                groupId: "86642858",
                addonId: "72640323",
              },
              {
                groupId: "86642858",
                addonId: "72640324",
              },
              {
                groupId: "86642858",
                addonId: "72640325",
              },
              {
                groupId: "86642858",
                addonId: "72640326",
              },
              {
                groupId: "86642858",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356285",
              },
              {
                groupId: "26570367",
                variationId: "84356291",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642858",
                addonId: "72640314",
              },
              {
                groupId: "86642858",
                addonId: "72640315",
              },
              {
                groupId: "86642858",
                addonId: "72640316",
              },
              {
                groupId: "86642858",
                addonId: "72640317",
              },
              {
                groupId: "86642858",
                addonId: "72640318",
              },
              {
                groupId: "86642858",
                addonId: "72640319",
              },
              {
                groupId: "86642858",
                addonId: "72640320",
              },
              {
                groupId: "86642858",
                addonId: "72640321",
              },
              {
                groupId: "86642858",
                addonId: "72640322",
              },
              {
                groupId: "86642858",
                addonId: "72640323",
              },
              {
                groupId: "86642858",
                addonId: "72640324",
              },
              {
                groupId: "86642858",
                addonId: "72640325",
              },
              {
                groupId: "86642858",
                addonId: "72640326",
              },
              {
                groupId: "86642858",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356285",
              },
              {
                groupId: "26570367",
                variationId: "84356293",
              },
            ],
            price: 27900,
            addonCombinations: [
              {
                groupId: "86642858",
                addonId: "72640314",
              },
              {
                groupId: "86642858",
                addonId: "72640315",
              },
              {
                groupId: "86642858",
                addonId: "72640316",
              },
              {
                groupId: "86642858",
                addonId: "72640317",
              },
              {
                groupId: "86642858",
                addonId: "72640318",
              },
              {
                groupId: "86642858",
                addonId: "72640319",
              },
              {
                groupId: "86642858",
                addonId: "72640320",
              },
              {
                groupId: "86642858",
                addonId: "72640321",
              },
              {
                groupId: "86642858",
                addonId: "72640322",
              },
              {
                groupId: "86642858",
                addonId: "72640323",
              },
              {
                groupId: "86642858",
                addonId: "72640324",
              },
              {
                groupId: "86642858",
                addonId: "72640325",
              },
              {
                groupId: "86642858",
                addonId: "72640326",
              },
              {
                groupId: "86642858",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356285",
              },
              {
                groupId: "26570367",
                variationId: "84356296",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642858",
                addonId: "72640314",
              },
              {
                groupId: "86642858",
                addonId: "72640315",
              },
              {
                groupId: "86642858",
                addonId: "72640316",
              },
              {
                groupId: "86642858",
                addonId: "72640317",
              },
              {
                groupId: "86642858",
                addonId: "72640318",
              },
              {
                groupId: "86642858",
                addonId: "72640319",
              },
              {
                groupId: "86642858",
                addonId: "72640320",
              },
              {
                groupId: "86642858",
                addonId: "72640321",
              },
              {
                groupId: "86642858",
                addonId: "72640322",
              },
              {
                groupId: "86642858",
                addonId: "72640323",
              },
              {
                groupId: "86642858",
                addonId: "72640324",
              },
              {
                groupId: "86642858",
                addonId: "72640325",
              },
              {
                groupId: "86642858",
                addonId: "72640326",
              },
              {
                groupId: "86642858",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356285",
              },
              {
                groupId: "26570367",
                variationId: "84356298",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642858",
                addonId: "72640314",
              },
              {
                groupId: "86642858",
                addonId: "72640315",
              },
              {
                groupId: "86642858",
                addonId: "72640316",
              },
              {
                groupId: "86642858",
                addonId: "72640317",
              },
              {
                groupId: "86642858",
                addonId: "72640318",
              },
              {
                groupId: "86642858",
                addonId: "72640319",
              },
              {
                groupId: "86642858",
                addonId: "72640320",
              },
              {
                groupId: "86642858",
                addonId: "72640321",
              },
              {
                groupId: "86642858",
                addonId: "72640322",
              },
              {
                groupId: "86642858",
                addonId: "72640323",
              },
              {
                groupId: "86642858",
                addonId: "72640324",
              },
              {
                groupId: "86642858",
                addonId: "72640325",
              },
              {
                groupId: "86642858",
                addonId: "72640326",
              },
              {
                groupId: "86642858",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356286",
              },
              {
                groupId: "26570367",
                variationId: "84356302",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642855",
                addonId: "72640334",
              },
              {
                groupId: "86642855",
                addonId: "72640335",
              },
              {
                groupId: "86642855",
                addonId: "72640336",
              },
              {
                groupId: "86642855",
                addonId: "72640337",
              },
              {
                groupId: "86642855",
                addonId: "72640338",
              },
              {
                groupId: "86642855",
                addonId: "72640339",
              },
              {
                groupId: "86642855",
                addonId: "72640340",
              },
              {
                groupId: "86642855",
                addonId: "72640341",
              },
              {
                groupId: "86642855",
                addonId: "72640342",
              },
              {
                groupId: "86642855",
                addonId: "72640343",
              },
              {
                groupId: "86642855",
                addonId: "72640344",
              },
              {
                groupId: "86642855",
                addonId: "72640345",
              },
              {
                groupId: "86642855",
                addonId: "72640346",
              },
              {
                groupId: "86642855",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356286",
              },
              {
                groupId: "26570367",
                variationId: "84356305",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356286",
              },
              {
                groupId: "26570367",
                variationId: "84356308",
              },
            ],
            price: 51900,
            addonCombinations: [
              {
                groupId: "86642855",
                addonId: "72640334",
              },
              {
                groupId: "86642855",
                addonId: "72640335",
              },
              {
                groupId: "86642855",
                addonId: "72640336",
              },
              {
                groupId: "86642855",
                addonId: "72640337",
              },
              {
                groupId: "86642855",
                addonId: "72640338",
              },
              {
                groupId: "86642855",
                addonId: "72640339",
              },
              {
                groupId: "86642855",
                addonId: "72640340",
              },
              {
                groupId: "86642855",
                addonId: "72640341",
              },
              {
                groupId: "86642855",
                addonId: "72640342",
              },
              {
                groupId: "86642855",
                addonId: "72640343",
              },
              {
                groupId: "86642855",
                addonId: "72640344",
              },
              {
                groupId: "86642855",
                addonId: "72640345",
              },
              {
                groupId: "86642855",
                addonId: "72640346",
              },
              {
                groupId: "86642855",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356286",
              },
              {
                groupId: "26570367",
                variationId: "84356311",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642855",
                addonId: "72640334",
              },
              {
                groupId: "86642855",
                addonId: "72640335",
              },
              {
                groupId: "86642855",
                addonId: "72640336",
              },
              {
                groupId: "86642855",
                addonId: "72640337",
              },
              {
                groupId: "86642855",
                addonId: "72640338",
              },
              {
                groupId: "86642855",
                addonId: "72640339",
              },
              {
                groupId: "86642855",
                addonId: "72640340",
              },
              {
                groupId: "86642855",
                addonId: "72640341",
              },
              {
                groupId: "86642855",
                addonId: "72640342",
              },
              {
                groupId: "86642855",
                addonId: "72640343",
              },
              {
                groupId: "86642855",
                addonId: "72640344",
              },
              {
                groupId: "86642855",
                addonId: "72640345",
              },
              {
                groupId: "86642855",
                addonId: "72640346",
              },
              {
                groupId: "86642855",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570365",
                variationId: "84356286",
              },
              {
                groupId: "26570367",
                variationId: "84356313",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642855",
                addonId: "72640334",
              },
              {
                groupId: "86642855",
                addonId: "72640335",
              },
              {
                groupId: "86642855",
                addonId: "72640336",
              },
              {
                groupId: "86642855",
                addonId: "72640337",
              },
              {
                groupId: "86642855",
                addonId: "72640338",
              },
              {
                groupId: "86642855",
                addonId: "72640339",
              },
              {
                groupId: "86642855",
                addonId: "72640340",
              },
              {
                groupId: "86642855",
                addonId: "72640341",
              },
              {
                groupId: "86642855",
                addonId: "72640342",
              },
              {
                groupId: "86642855",
                addonId: "72640343",
              },
              {
                groupId: "86642855",
                addonId: "72640344",
              },
              {
                groupId: "86642855",
                addonId: "72640345",
              },
              {
                groupId: "86642855",
                addonId: "72640346",
              },
              {
                groupId: "86642855",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642858",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642855",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 25900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.9",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "87274177",
      name: "Double Paneer Supreme",
      category: "Veg Pizza",
      description:
        "Serves 1 | Loaded with extra Spiced Paneer, Herbed Onion & Green Capsicum, spicy Red Paprika with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "dytjxmainn1bjd7jjoda",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569846",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84353734",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569848",
                  variationId: "84353741",
                },
              },
              {
                name: "Medium",
                id: "84353736",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569848",
                  variationId: "84353762",
                },
              },
            ],
          },
          {
            groupId: "26569848",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84353741",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84353745",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84353751",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 454,
                id: "84353755",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84353758",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84353762",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84353766",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84353769",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 738,
                id: "84353772",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84353775",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353734",
              },
              {
                groupId: "26569848",
                variationId: "84353741",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642611",
                addonId: "72640314",
              },
              {
                groupId: "86642611",
                addonId: "72640315",
              },
              {
                groupId: "86642611",
                addonId: "72640316",
              },
              {
                groupId: "86642611",
                addonId: "72640317",
              },
              {
                groupId: "86642611",
                addonId: "72640318",
              },
              {
                groupId: "86642611",
                addonId: "72640319",
              },
              {
                groupId: "86642611",
                addonId: "72640320",
              },
              {
                groupId: "86642611",
                addonId: "72640321",
              },
              {
                groupId: "86642611",
                addonId: "72640322",
              },
              {
                groupId: "86642611",
                addonId: "72640323",
              },
              {
                groupId: "86642611",
                addonId: "72640324",
              },
              {
                groupId: "86642611",
                addonId: "72640325",
              },
              {
                groupId: "86642611",
                addonId: "72640326",
              },
              {
                groupId: "86642611",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353734",
              },
              {
                groupId: "26569848",
                variationId: "84353745",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642611",
                addonId: "72640314",
              },
              {
                groupId: "86642611",
                addonId: "72640315",
              },
              {
                groupId: "86642611",
                addonId: "72640316",
              },
              {
                groupId: "86642611",
                addonId: "72640317",
              },
              {
                groupId: "86642611",
                addonId: "72640318",
              },
              {
                groupId: "86642611",
                addonId: "72640319",
              },
              {
                groupId: "86642611",
                addonId: "72640320",
              },
              {
                groupId: "86642611",
                addonId: "72640321",
              },
              {
                groupId: "86642611",
                addonId: "72640322",
              },
              {
                groupId: "86642611",
                addonId: "72640323",
              },
              {
                groupId: "86642611",
                addonId: "72640324",
              },
              {
                groupId: "86642611",
                addonId: "72640325",
              },
              {
                groupId: "86642611",
                addonId: "72640326",
              },
              {
                groupId: "86642611",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353734",
              },
              {
                groupId: "26569848",
                variationId: "84353751",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642611",
                addonId: "72640314",
              },
              {
                groupId: "86642611",
                addonId: "72640315",
              },
              {
                groupId: "86642611",
                addonId: "72640316",
              },
              {
                groupId: "86642611",
                addonId: "72640317",
              },
              {
                groupId: "86642611",
                addonId: "72640318",
              },
              {
                groupId: "86642611",
                addonId: "72640319",
              },
              {
                groupId: "86642611",
                addonId: "72640320",
              },
              {
                groupId: "86642611",
                addonId: "72640321",
              },
              {
                groupId: "86642611",
                addonId: "72640322",
              },
              {
                groupId: "86642611",
                addonId: "72640323",
              },
              {
                groupId: "86642611",
                addonId: "72640324",
              },
              {
                groupId: "86642611",
                addonId: "72640325",
              },
              {
                groupId: "86642611",
                addonId: "72640326",
              },
              {
                groupId: "86642611",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353734",
              },
              {
                groupId: "26569848",
                variationId: "84353755",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642611",
                addonId: "72640314",
              },
              {
                groupId: "86642611",
                addonId: "72640315",
              },
              {
                groupId: "86642611",
                addonId: "72640316",
              },
              {
                groupId: "86642611",
                addonId: "72640317",
              },
              {
                groupId: "86642611",
                addonId: "72640318",
              },
              {
                groupId: "86642611",
                addonId: "72640319",
              },
              {
                groupId: "86642611",
                addonId: "72640320",
              },
              {
                groupId: "86642611",
                addonId: "72640321",
              },
              {
                groupId: "86642611",
                addonId: "72640322",
              },
              {
                groupId: "86642611",
                addonId: "72640323",
              },
              {
                groupId: "86642611",
                addonId: "72640324",
              },
              {
                groupId: "86642611",
                addonId: "72640325",
              },
              {
                groupId: "86642611",
                addonId: "72640326",
              },
              {
                groupId: "86642611",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353734",
              },
              {
                groupId: "26569848",
                variationId: "84353758",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642611",
                addonId: "72640314",
              },
              {
                groupId: "86642611",
                addonId: "72640315",
              },
              {
                groupId: "86642611",
                addonId: "72640316",
              },
              {
                groupId: "86642611",
                addonId: "72640317",
              },
              {
                groupId: "86642611",
                addonId: "72640318",
              },
              {
                groupId: "86642611",
                addonId: "72640319",
              },
              {
                groupId: "86642611",
                addonId: "72640320",
              },
              {
                groupId: "86642611",
                addonId: "72640321",
              },
              {
                groupId: "86642611",
                addonId: "72640322",
              },
              {
                groupId: "86642611",
                addonId: "72640323",
              },
              {
                groupId: "86642611",
                addonId: "72640324",
              },
              {
                groupId: "86642611",
                addonId: "72640325",
              },
              {
                groupId: "86642611",
                addonId: "72640326",
              },
              {
                groupId: "86642611",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353736",
              },
              {
                groupId: "26569848",
                variationId: "84353762",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642608",
                addonId: "72640334",
              },
              {
                groupId: "86642608",
                addonId: "72640335",
              },
              {
                groupId: "86642608",
                addonId: "72640336",
              },
              {
                groupId: "86642608",
                addonId: "72640337",
              },
              {
                groupId: "86642608",
                addonId: "72640338",
              },
              {
                groupId: "86642608",
                addonId: "72640339",
              },
              {
                groupId: "86642608",
                addonId: "72640340",
              },
              {
                groupId: "86642608",
                addonId: "72640341",
              },
              {
                groupId: "86642608",
                addonId: "72640342",
              },
              {
                groupId: "86642608",
                addonId: "72640343",
              },
              {
                groupId: "86642608",
                addonId: "72640344",
              },
              {
                groupId: "86642608",
                addonId: "72640345",
              },
              {
                groupId: "86642608",
                addonId: "72640346",
              },
              {
                groupId: "86642608",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353736",
              },
              {
                groupId: "26569848",
                variationId: "84353766",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642608",
                addonId: "72640334",
              },
              {
                groupId: "86642608",
                addonId: "72640335",
              },
              {
                groupId: "86642608",
                addonId: "72640336",
              },
              {
                groupId: "86642608",
                addonId: "72640337",
              },
              {
                groupId: "86642608",
                addonId: "72640338",
              },
              {
                groupId: "86642608",
                addonId: "72640339",
              },
              {
                groupId: "86642608",
                addonId: "72640340",
              },
              {
                groupId: "86642608",
                addonId: "72640341",
              },
              {
                groupId: "86642608",
                addonId: "72640342",
              },
              {
                groupId: "86642608",
                addonId: "72640343",
              },
              {
                groupId: "86642608",
                addonId: "72640344",
              },
              {
                groupId: "86642608",
                addonId: "72640345",
              },
              {
                groupId: "86642608",
                addonId: "72640346",
              },
              {
                groupId: "86642608",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353736",
              },
              {
                groupId: "26569848",
                variationId: "84353769",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642608",
                addonId: "72640334",
              },
              {
                groupId: "86642608",
                addonId: "72640335",
              },
              {
                groupId: "86642608",
                addonId: "72640336",
              },
              {
                groupId: "86642608",
                addonId: "72640337",
              },
              {
                groupId: "86642608",
                addonId: "72640338",
              },
              {
                groupId: "86642608",
                addonId: "72640339",
              },
              {
                groupId: "86642608",
                addonId: "72640340",
              },
              {
                groupId: "86642608",
                addonId: "72640341",
              },
              {
                groupId: "86642608",
                addonId: "72640342",
              },
              {
                groupId: "86642608",
                addonId: "72640343",
              },
              {
                groupId: "86642608",
                addonId: "72640344",
              },
              {
                groupId: "86642608",
                addonId: "72640345",
              },
              {
                groupId: "86642608",
                addonId: "72640346",
              },
              {
                groupId: "86642608",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353736",
              },
              {
                groupId: "26569848",
                variationId: "84353772",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642608",
                addonId: "72640334",
              },
              {
                groupId: "86642608",
                addonId: "72640335",
              },
              {
                groupId: "86642608",
                addonId: "72640336",
              },
              {
                groupId: "86642608",
                addonId: "72640337",
              },
              {
                groupId: "86642608",
                addonId: "72640338",
              },
              {
                groupId: "86642608",
                addonId: "72640339",
              },
              {
                groupId: "86642608",
                addonId: "72640340",
              },
              {
                groupId: "86642608",
                addonId: "72640341",
              },
              {
                groupId: "86642608",
                addonId: "72640342",
              },
              {
                groupId: "86642608",
                addonId: "72640343",
              },
              {
                groupId: "86642608",
                addonId: "72640344",
              },
              {
                groupId: "86642608",
                addonId: "72640345",
              },
              {
                groupId: "86642608",
                addonId: "72640346",
              },
              {
                groupId: "86642608",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569846",
                variationId: "84353736",
              },
              {
                groupId: "26569848",
                variationId: "84353775",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642608",
                addonId: "72640334",
              },
              {
                groupId: "86642608",
                addonId: "72640335",
              },
              {
                groupId: "86642608",
                addonId: "72640336",
              },
              {
                groupId: "86642608",
                addonId: "72640337",
              },
              {
                groupId: "86642608",
                addonId: "72640338",
              },
              {
                groupId: "86642608",
                addonId: "72640339",
              },
              {
                groupId: "86642608",
                addonId: "72640340",
              },
              {
                groupId: "86642608",
                addonId: "72640341",
              },
              {
                groupId: "86642608",
                addonId: "72640342",
              },
              {
                groupId: "86642608",
                addonId: "72640343",
              },
              {
                groupId: "86642608",
                addonId: "72640344",
              },
              {
                groupId: "86642608",
                addonId: "72640345",
              },
              {
                groupId: "86642608",
                addonId: "72640346",
              },
              {
                groupId: "86642608",
                addonId: "72640396",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642608",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640396",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642611",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "87274178",
      name: "Veggie Supreme",
      category: "Veg Pizza",
      description:
        "Serves 1 | A supreme combination of Black Olives, Green Capsicum, Mushroom, Onion, spicy Red Paprika & juicy Sweet Corn  with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "z0c4xpovma1qtmu4tlls",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569874",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84353898",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569875",
                  variationId: "84353900",
                },
              },
              {
                name: "Medium",
                id: "84353899",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569875",
                  variationId: "84353905",
                },
              },
            ],
          },
          {
            groupId: "26569875",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84353900",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84353901",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84353902",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 454,
                id: "84353903",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84353904",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84353905",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84353906",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84353907",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 738,
                id: "84353908",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84353909",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353898",
              },
              {
                groupId: "26569875",
                variationId: "84353900",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642638",
                addonId: "72640314",
              },
              {
                groupId: "86642638",
                addonId: "72640315",
              },
              {
                groupId: "86642638",
                addonId: "72640316",
              },
              {
                groupId: "86642638",
                addonId: "72640317",
              },
              {
                groupId: "86642638",
                addonId: "72640318",
              },
              {
                groupId: "86642638",
                addonId: "72640319",
              },
              {
                groupId: "86642638",
                addonId: "72640320",
              },
              {
                groupId: "86642638",
                addonId: "72640321",
              },
              {
                groupId: "86642638",
                addonId: "72640322",
              },
              {
                groupId: "86642638",
                addonId: "72640323",
              },
              {
                groupId: "86642638",
                addonId: "72640324",
              },
              {
                groupId: "86642638",
                addonId: "72640325",
              },
              {
                groupId: "86642638",
                addonId: "72640326",
              },
              {
                groupId: "86642638",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353898",
              },
              {
                groupId: "26569875",
                variationId: "84353901",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642638",
                addonId: "72640314",
              },
              {
                groupId: "86642638",
                addonId: "72640315",
              },
              {
                groupId: "86642638",
                addonId: "72640316",
              },
              {
                groupId: "86642638",
                addonId: "72640317",
              },
              {
                groupId: "86642638",
                addonId: "72640318",
              },
              {
                groupId: "86642638",
                addonId: "72640319",
              },
              {
                groupId: "86642638",
                addonId: "72640320",
              },
              {
                groupId: "86642638",
                addonId: "72640321",
              },
              {
                groupId: "86642638",
                addonId: "72640322",
              },
              {
                groupId: "86642638",
                addonId: "72640323",
              },
              {
                groupId: "86642638",
                addonId: "72640324",
              },
              {
                groupId: "86642638",
                addonId: "72640325",
              },
              {
                groupId: "86642638",
                addonId: "72640326",
              },
              {
                groupId: "86642638",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353898",
              },
              {
                groupId: "26569875",
                variationId: "84353902",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642638",
                addonId: "72640314",
              },
              {
                groupId: "86642638",
                addonId: "72640315",
              },
              {
                groupId: "86642638",
                addonId: "72640316",
              },
              {
                groupId: "86642638",
                addonId: "72640317",
              },
              {
                groupId: "86642638",
                addonId: "72640318",
              },
              {
                groupId: "86642638",
                addonId: "72640319",
              },
              {
                groupId: "86642638",
                addonId: "72640320",
              },
              {
                groupId: "86642638",
                addonId: "72640321",
              },
              {
                groupId: "86642638",
                addonId: "72640322",
              },
              {
                groupId: "86642638",
                addonId: "72640323",
              },
              {
                groupId: "86642638",
                addonId: "72640324",
              },
              {
                groupId: "86642638",
                addonId: "72640325",
              },
              {
                groupId: "86642638",
                addonId: "72640326",
              },
              {
                groupId: "86642638",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353898",
              },
              {
                groupId: "26569875",
                variationId: "84353903",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642638",
                addonId: "72640314",
              },
              {
                groupId: "86642638",
                addonId: "72640315",
              },
              {
                groupId: "86642638",
                addonId: "72640316",
              },
              {
                groupId: "86642638",
                addonId: "72640317",
              },
              {
                groupId: "86642638",
                addonId: "72640318",
              },
              {
                groupId: "86642638",
                addonId: "72640319",
              },
              {
                groupId: "86642638",
                addonId: "72640320",
              },
              {
                groupId: "86642638",
                addonId: "72640321",
              },
              {
                groupId: "86642638",
                addonId: "72640322",
              },
              {
                groupId: "86642638",
                addonId: "72640323",
              },
              {
                groupId: "86642638",
                addonId: "72640324",
              },
              {
                groupId: "86642638",
                addonId: "72640325",
              },
              {
                groupId: "86642638",
                addonId: "72640326",
              },
              {
                groupId: "86642638",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353898",
              },
              {
                groupId: "26569875",
                variationId: "84353904",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642638",
                addonId: "72640314",
              },
              {
                groupId: "86642638",
                addonId: "72640315",
              },
              {
                groupId: "86642638",
                addonId: "72640316",
              },
              {
                groupId: "86642638",
                addonId: "72640317",
              },
              {
                groupId: "86642638",
                addonId: "72640318",
              },
              {
                groupId: "86642638",
                addonId: "72640319",
              },
              {
                groupId: "86642638",
                addonId: "72640320",
              },
              {
                groupId: "86642638",
                addonId: "72640321",
              },
              {
                groupId: "86642638",
                addonId: "72640322",
              },
              {
                groupId: "86642638",
                addonId: "72640323",
              },
              {
                groupId: "86642638",
                addonId: "72640324",
              },
              {
                groupId: "86642638",
                addonId: "72640325",
              },
              {
                groupId: "86642638",
                addonId: "72640326",
              },
              {
                groupId: "86642638",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353899",
              },
              {
                groupId: "26569875",
                variationId: "84353905",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642636",
                addonId: "72640334",
              },
              {
                groupId: "86642636",
                addonId: "72640335",
              },
              {
                groupId: "86642636",
                addonId: "72640336",
              },
              {
                groupId: "86642636",
                addonId: "72640337",
              },
              {
                groupId: "86642636",
                addonId: "72640338",
              },
              {
                groupId: "86642636",
                addonId: "72640339",
              },
              {
                groupId: "86642636",
                addonId: "72640340",
              },
              {
                groupId: "86642636",
                addonId: "72640341",
              },
              {
                groupId: "86642636",
                addonId: "72640342",
              },
              {
                groupId: "86642636",
                addonId: "72640343",
              },
              {
                groupId: "86642636",
                addonId: "72640344",
              },
              {
                groupId: "86642636",
                addonId: "72640345",
              },
              {
                groupId: "86642636",
                addonId: "72640346",
              },
              {
                groupId: "86642636",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353899",
              },
              {
                groupId: "26569875",
                variationId: "84353906",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642636",
                addonId: "72640334",
              },
              {
                groupId: "86642636",
                addonId: "72640335",
              },
              {
                groupId: "86642636",
                addonId: "72640336",
              },
              {
                groupId: "86642636",
                addonId: "72640337",
              },
              {
                groupId: "86642636",
                addonId: "72640338",
              },
              {
                groupId: "86642636",
                addonId: "72640339",
              },
              {
                groupId: "86642636",
                addonId: "72640340",
              },
              {
                groupId: "86642636",
                addonId: "72640341",
              },
              {
                groupId: "86642636",
                addonId: "72640342",
              },
              {
                groupId: "86642636",
                addonId: "72640343",
              },
              {
                groupId: "86642636",
                addonId: "72640344",
              },
              {
                groupId: "86642636",
                addonId: "72640345",
              },
              {
                groupId: "86642636",
                addonId: "72640346",
              },
              {
                groupId: "86642636",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353899",
              },
              {
                groupId: "26569875",
                variationId: "84353907",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642636",
                addonId: "72640334",
              },
              {
                groupId: "86642636",
                addonId: "72640335",
              },
              {
                groupId: "86642636",
                addonId: "72640336",
              },
              {
                groupId: "86642636",
                addonId: "72640337",
              },
              {
                groupId: "86642636",
                addonId: "72640338",
              },
              {
                groupId: "86642636",
                addonId: "72640339",
              },
              {
                groupId: "86642636",
                addonId: "72640340",
              },
              {
                groupId: "86642636",
                addonId: "72640341",
              },
              {
                groupId: "86642636",
                addonId: "72640342",
              },
              {
                groupId: "86642636",
                addonId: "72640343",
              },
              {
                groupId: "86642636",
                addonId: "72640344",
              },
              {
                groupId: "86642636",
                addonId: "72640345",
              },
              {
                groupId: "86642636",
                addonId: "72640346",
              },
              {
                groupId: "86642636",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353899",
              },
              {
                groupId: "26569875",
                variationId: "84353908",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642636",
                addonId: "72640334",
              },
              {
                groupId: "86642636",
                addonId: "72640335",
              },
              {
                groupId: "86642636",
                addonId: "72640336",
              },
              {
                groupId: "86642636",
                addonId: "72640337",
              },
              {
                groupId: "86642636",
                addonId: "72640338",
              },
              {
                groupId: "86642636",
                addonId: "72640339",
              },
              {
                groupId: "86642636",
                addonId: "72640340",
              },
              {
                groupId: "86642636",
                addonId: "72640341",
              },
              {
                groupId: "86642636",
                addonId: "72640342",
              },
              {
                groupId: "86642636",
                addonId: "72640343",
              },
              {
                groupId: "86642636",
                addonId: "72640344",
              },
              {
                groupId: "86642636",
                addonId: "72640345",
              },
              {
                groupId: "86642636",
                addonId: "72640346",
              },
              {
                groupId: "86642636",
                addonId: "72640396",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569874",
                variationId: "84353899",
              },
              {
                groupId: "26569875",
                variationId: "84353909",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642636",
                addonId: "72640334",
              },
              {
                groupId: "86642636",
                addonId: "72640335",
              },
              {
                groupId: "86642636",
                addonId: "72640336",
              },
              {
                groupId: "86642636",
                addonId: "72640337",
              },
              {
                groupId: "86642636",
                addonId: "72640338",
              },
              {
                groupId: "86642636",
                addonId: "72640339",
              },
              {
                groupId: "86642636",
                addonId: "72640340",
              },
              {
                groupId: "86642636",
                addonId: "72640341",
              },
              {
                groupId: "86642636",
                addonId: "72640342",
              },
              {
                groupId: "86642636",
                addonId: "72640343",
              },
              {
                groupId: "86642636",
                addonId: "72640344",
              },
              {
                groupId: "86642636",
                addonId: "72640345",
              },
              {
                groupId: "86642636",
                addonId: "72640346",
              },
              {
                groupId: "86642636",
                addonId: "72640396",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642638",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642636",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640396",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.8",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "96199298",
      name: "Margherita Pizza",
      category: "Veg Pizza",
      description:
        "Serves 1 | Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there!",
      imageId: "dpventcrozvfni0lqb10",
      inStock: 1,
      isVeg: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "83 ratings",
          ratingCountV2: "83",
        },
      },
    },
    {
      id: "113502224",
      name: "Schezwan Margherita",
      category: "Veg Pizza",
      description:
        "Serves 1 | Your very own Margherita, now with a spicy twist! Loaded with our signature spicy schezwan sauce & 100% mozzarella cheese",
      imageId: "0e7df98b7cffdb0b88856464014ad2ff",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571191",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84360353",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571192",
                  variationId: "84360355",
                },
              },
              {
                name: "Medium",
                id: "84360354",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571192",
                  variationId: "84360358",
                },
              },
            ],
          },
          {
            groupId: "26571192",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 219,
                default: 1,
                id: "84360355",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 219,
                id: "84360356",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 294,
                id: "84360357",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 409,
                id: "84360358",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 409,
                id: "84360359",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 508,
                id: "84360360",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571191",
                variationId: "84360353",
              },
              {
                groupId: "26571192",
                variationId: "84360355",
              },
            ],
            price: 21900,
            addonCombinations: [
              {
                groupId: "86643233",
                addonId: "72640314",
              },
              {
                groupId: "86643233",
                addonId: "72640315",
              },
              {
                groupId: "86643233",
                addonId: "72640316",
              },
              {
                groupId: "86643233",
                addonId: "72640317",
              },
              {
                groupId: "86643233",
                addonId: "72640318",
              },
              {
                groupId: "86643233",
                addonId: "72640319",
              },
              {
                groupId: "86643233",
                addonId: "72640320",
              },
              {
                groupId: "86643233",
                addonId: "72640321",
              },
              {
                groupId: "86643233",
                addonId: "72640322",
              },
              {
                groupId: "86643233",
                addonId: "72640323",
              },
              {
                groupId: "86643233",
                addonId: "72640324",
              },
              {
                groupId: "86643233",
                addonId: "72640325",
              },
              {
                groupId: "86643233",
                addonId: "72640326",
              },
              {
                groupId: "86643233",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571191",
                variationId: "84360353",
              },
              {
                groupId: "26571192",
                variationId: "84360356",
              },
            ],
            price: 21900,
            addonCombinations: [
              {
                groupId: "86643233",
                addonId: "72640314",
              },
              {
                groupId: "86643233",
                addonId: "72640315",
              },
              {
                groupId: "86643233",
                addonId: "72640316",
              },
              {
                groupId: "86643233",
                addonId: "72640317",
              },
              {
                groupId: "86643233",
                addonId: "72640318",
              },
              {
                groupId: "86643233",
                addonId: "72640319",
              },
              {
                groupId: "86643233",
                addonId: "72640320",
              },
              {
                groupId: "86643233",
                addonId: "72640321",
              },
              {
                groupId: "86643233",
                addonId: "72640322",
              },
              {
                groupId: "86643233",
                addonId: "72640323",
              },
              {
                groupId: "86643233",
                addonId: "72640324",
              },
              {
                groupId: "86643233",
                addonId: "72640325",
              },
              {
                groupId: "86643233",
                addonId: "72640326",
              },
              {
                groupId: "86643233",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571191",
                variationId: "84360353",
              },
              {
                groupId: "26571192",
                variationId: "84360357",
              },
            ],
            price: 29400,
            addonCombinations: [
              {
                groupId: "86643233",
                addonId: "72640314",
              },
              {
                groupId: "86643233",
                addonId: "72640315",
              },
              {
                groupId: "86643233",
                addonId: "72640316",
              },
              {
                groupId: "86643233",
                addonId: "72640317",
              },
              {
                groupId: "86643233",
                addonId: "72640318",
              },
              {
                groupId: "86643233",
                addonId: "72640319",
              },
              {
                groupId: "86643233",
                addonId: "72640320",
              },
              {
                groupId: "86643233",
                addonId: "72640321",
              },
              {
                groupId: "86643233",
                addonId: "72640322",
              },
              {
                groupId: "86643233",
                addonId: "72640323",
              },
              {
                groupId: "86643233",
                addonId: "72640324",
              },
              {
                groupId: "86643233",
                addonId: "72640325",
              },
              {
                groupId: "86643233",
                addonId: "72640326",
              },
              {
                groupId: "86643233",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571191",
                variationId: "84360354",
              },
              {
                groupId: "26571192",
                variationId: "84360358",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86643232",
                addonId: "72640334",
              },
              {
                groupId: "86643232",
                addonId: "72640335",
              },
              {
                groupId: "86643232",
                addonId: "72640336",
              },
              {
                groupId: "86643232",
                addonId: "72640337",
              },
              {
                groupId: "86643232",
                addonId: "72640338",
              },
              {
                groupId: "86643232",
                addonId: "72640339",
              },
              {
                groupId: "86643232",
                addonId: "72640340",
              },
              {
                groupId: "86643232",
                addonId: "72640341",
              },
              {
                groupId: "86643232",
                addonId: "72640342",
              },
              {
                groupId: "86643232",
                addonId: "72640343",
              },
              {
                groupId: "86643232",
                addonId: "72640344",
              },
              {
                groupId: "86643232",
                addonId: "72640345",
              },
              {
                groupId: "86643232",
                addonId: "72640346",
              },
              {
                groupId: "86643232",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571191",
                variationId: "84360354",
              },
              {
                groupId: "26571192",
                variationId: "84360359",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86643232",
                addonId: "72640334",
              },
              {
                groupId: "86643232",
                addonId: "72640335",
              },
              {
                groupId: "86643232",
                addonId: "72640336",
              },
              {
                groupId: "86643232",
                addonId: "72640337",
              },
              {
                groupId: "86643232",
                addonId: "72640338",
              },
              {
                groupId: "86643232",
                addonId: "72640339",
              },
              {
                groupId: "86643232",
                addonId: "72640340",
              },
              {
                groupId: "86643232",
                addonId: "72640341",
              },
              {
                groupId: "86643232",
                addonId: "72640342",
              },
              {
                groupId: "86643232",
                addonId: "72640343",
              },
              {
                groupId: "86643232",
                addonId: "72640344",
              },
              {
                groupId: "86643232",
                addonId: "72640345",
              },
              {
                groupId: "86643232",
                addonId: "72640346",
              },
              {
                groupId: "86643232",
                addonId: "72640394",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571191",
                variationId: "84360354",
              },
              {
                groupId: "26571192",
                variationId: "84360360",
              },
            ],
            price: 50800,
            addonCombinations: [
              {
                groupId: "86643232",
                addonId: "72640334",
              },
              {
                groupId: "86643232",
                addonId: "72640335",
              },
              {
                groupId: "86643232",
                addonId: "72640336",
              },
              {
                groupId: "86643232",
                addonId: "72640337",
              },
              {
                groupId: "86643232",
                addonId: "72640338",
              },
              {
                groupId: "86643232",
                addonId: "72640339",
              },
              {
                groupId: "86643232",
                addonId: "72640340",
              },
              {
                groupId: "86643232",
                addonId: "72640341",
              },
              {
                groupId: "86643232",
                addonId: "72640342",
              },
              {
                groupId: "86643232",
                addonId: "72640343",
              },
              {
                groupId: "86643232",
                addonId: "72640344",
              },
              {
                groupId: "86643232",
                addonId: "72640345",
              },
              {
                groupId: "86643232",
                addonId: "72640346",
              },
              {
                groupId: "86643232",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643232",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643233",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 21900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Non-Veg Pizza": [
    {
      id: "47199929",
      name: "Chicken Sausage",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Pizza topped with Chicken n Cheese Sausages & crunchy Onions, flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "aylqpxx08pltowbzxhd3",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570333",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84356076",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570336",
                  variationId: "84356086",
                },
              },
              {
                name: "Medium",
                id: "84356081",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570336",
                  variationId: "84356105",
                },
              },
            ],
          },
          {
            groupId: "26570336",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 259,
                default: 1,
                id: "84356086",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 259,
                id: "84356090",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 279,
                id: "84356094",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 334,
                id: "84356098",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 334,
                id: "84356102",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 489,
                id: "84356105",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 489,
                id: "84356110",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 519,
                id: "84356113",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 588,
                id: "84356116",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 588,
                id: "84356120",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356076",
              },
              {
                groupId: "26570336",
                variationId: "84356086",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642845",
                addonId: "72640314",
              },
              {
                groupId: "86642845",
                addonId: "72640315",
              },
              {
                groupId: "86642845",
                addonId: "72640316",
              },
              {
                groupId: "86642845",
                addonId: "72640317",
              },
              {
                groupId: "86642845",
                addonId: "72640318",
              },
              {
                groupId: "86642845",
                addonId: "72640319",
              },
              {
                groupId: "86642845",
                addonId: "72640320",
              },
              {
                groupId: "86642845",
                addonId: "72640321",
              },
              {
                groupId: "86642845",
                addonId: "72640322",
              },
              {
                groupId: "86642845",
                addonId: "72640323",
              },
              {
                groupId: "86642845",
                addonId: "72640324",
              },
              {
                groupId: "86642845",
                addonId: "72640325",
              },
              {
                groupId: "86642845",
                addonId: "72640326",
              },
              {
                groupId: "86642845",
                addonId: "72640327",
              },
              {
                groupId: "86642845",
                addonId: "72640328",
              },
              {
                groupId: "86642845",
                addonId: "72640329",
              },
              {
                groupId: "86642845",
                addonId: "72640330",
              },
              {
                groupId: "86642845",
                addonId: "72640331",
              },
              {
                groupId: "86642845",
                addonId: "72640332",
              },
              {
                groupId: "86642845",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356076",
              },
              {
                groupId: "26570336",
                variationId: "84356090",
              },
            ],
            price: 25900,
            addonCombinations: [
              {
                groupId: "86642845",
                addonId: "72640314",
              },
              {
                groupId: "86642845",
                addonId: "72640315",
              },
              {
                groupId: "86642845",
                addonId: "72640316",
              },
              {
                groupId: "86642845",
                addonId: "72640317",
              },
              {
                groupId: "86642845",
                addonId: "72640318",
              },
              {
                groupId: "86642845",
                addonId: "72640319",
              },
              {
                groupId: "86642845",
                addonId: "72640320",
              },
              {
                groupId: "86642845",
                addonId: "72640321",
              },
              {
                groupId: "86642845",
                addonId: "72640322",
              },
              {
                groupId: "86642845",
                addonId: "72640323",
              },
              {
                groupId: "86642845",
                addonId: "72640324",
              },
              {
                groupId: "86642845",
                addonId: "72640325",
              },
              {
                groupId: "86642845",
                addonId: "72640326",
              },
              {
                groupId: "86642845",
                addonId: "72640327",
              },
              {
                groupId: "86642845",
                addonId: "72640328",
              },
              {
                groupId: "86642845",
                addonId: "72640329",
              },
              {
                groupId: "86642845",
                addonId: "72640330",
              },
              {
                groupId: "86642845",
                addonId: "72640331",
              },
              {
                groupId: "86642845",
                addonId: "72640332",
              },
              {
                groupId: "86642845",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356076",
              },
              {
                groupId: "26570336",
                variationId: "84356094",
              },
            ],
            price: 27900,
            addonCombinations: [
              {
                groupId: "86642845",
                addonId: "72640314",
              },
              {
                groupId: "86642845",
                addonId: "72640315",
              },
              {
                groupId: "86642845",
                addonId: "72640316",
              },
              {
                groupId: "86642845",
                addonId: "72640317",
              },
              {
                groupId: "86642845",
                addonId: "72640318",
              },
              {
                groupId: "86642845",
                addonId: "72640319",
              },
              {
                groupId: "86642845",
                addonId: "72640320",
              },
              {
                groupId: "86642845",
                addonId: "72640321",
              },
              {
                groupId: "86642845",
                addonId: "72640322",
              },
              {
                groupId: "86642845",
                addonId: "72640323",
              },
              {
                groupId: "86642845",
                addonId: "72640324",
              },
              {
                groupId: "86642845",
                addonId: "72640325",
              },
              {
                groupId: "86642845",
                addonId: "72640326",
              },
              {
                groupId: "86642845",
                addonId: "72640327",
              },
              {
                groupId: "86642845",
                addonId: "72640328",
              },
              {
                groupId: "86642845",
                addonId: "72640329",
              },
              {
                groupId: "86642845",
                addonId: "72640330",
              },
              {
                groupId: "86642845",
                addonId: "72640331",
              },
              {
                groupId: "86642845",
                addonId: "72640332",
              },
              {
                groupId: "86642845",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356076",
              },
              {
                groupId: "26570336",
                variationId: "84356098",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642845",
                addonId: "72640314",
              },
              {
                groupId: "86642845",
                addonId: "72640315",
              },
              {
                groupId: "86642845",
                addonId: "72640316",
              },
              {
                groupId: "86642845",
                addonId: "72640317",
              },
              {
                groupId: "86642845",
                addonId: "72640318",
              },
              {
                groupId: "86642845",
                addonId: "72640319",
              },
              {
                groupId: "86642845",
                addonId: "72640320",
              },
              {
                groupId: "86642845",
                addonId: "72640321",
              },
              {
                groupId: "86642845",
                addonId: "72640322",
              },
              {
                groupId: "86642845",
                addonId: "72640323",
              },
              {
                groupId: "86642845",
                addonId: "72640324",
              },
              {
                groupId: "86642845",
                addonId: "72640325",
              },
              {
                groupId: "86642845",
                addonId: "72640326",
              },
              {
                groupId: "86642845",
                addonId: "72640327",
              },
              {
                groupId: "86642845",
                addonId: "72640328",
              },
              {
                groupId: "86642845",
                addonId: "72640329",
              },
              {
                groupId: "86642845",
                addonId: "72640330",
              },
              {
                groupId: "86642845",
                addonId: "72640331",
              },
              {
                groupId: "86642845",
                addonId: "72640332",
              },
              {
                groupId: "86642845",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356076",
              },
              {
                groupId: "26570336",
                variationId: "84356102",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86642845",
                addonId: "72640314",
              },
              {
                groupId: "86642845",
                addonId: "72640315",
              },
              {
                groupId: "86642845",
                addonId: "72640316",
              },
              {
                groupId: "86642845",
                addonId: "72640317",
              },
              {
                groupId: "86642845",
                addonId: "72640318",
              },
              {
                groupId: "86642845",
                addonId: "72640319",
              },
              {
                groupId: "86642845",
                addonId: "72640320",
              },
              {
                groupId: "86642845",
                addonId: "72640321",
              },
              {
                groupId: "86642845",
                addonId: "72640322",
              },
              {
                groupId: "86642845",
                addonId: "72640323",
              },
              {
                groupId: "86642845",
                addonId: "72640324",
              },
              {
                groupId: "86642845",
                addonId: "72640325",
              },
              {
                groupId: "86642845",
                addonId: "72640326",
              },
              {
                groupId: "86642845",
                addonId: "72640327",
              },
              {
                groupId: "86642845",
                addonId: "72640328",
              },
              {
                groupId: "86642845",
                addonId: "72640329",
              },
              {
                groupId: "86642845",
                addonId: "72640330",
              },
              {
                groupId: "86642845",
                addonId: "72640331",
              },
              {
                groupId: "86642845",
                addonId: "72640332",
              },
              {
                groupId: "86642845",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356081",
              },
              {
                groupId: "26570336",
                variationId: "84356105",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642847",
                addonId: "72640334",
              },
              {
                groupId: "86642847",
                addonId: "72640335",
              },
              {
                groupId: "86642847",
                addonId: "72640336",
              },
              {
                groupId: "86642847",
                addonId: "72640337",
              },
              {
                groupId: "86642847",
                addonId: "72640338",
              },
              {
                groupId: "86642847",
                addonId: "72640339",
              },
              {
                groupId: "86642847",
                addonId: "72640340",
              },
              {
                groupId: "86642847",
                addonId: "72640341",
              },
              {
                groupId: "86642847",
                addonId: "72640342",
              },
              {
                groupId: "86642847",
                addonId: "72640343",
              },
              {
                groupId: "86642847",
                addonId: "72640344",
              },
              {
                groupId: "86642847",
                addonId: "72640345",
              },
              {
                groupId: "86642847",
                addonId: "72640346",
              },
              {
                groupId: "86642847",
                addonId: "72640347",
              },
              {
                groupId: "86642847",
                addonId: "72640348",
              },
              {
                groupId: "86642847",
                addonId: "72640349",
              },
              {
                groupId: "86642847",
                addonId: "72640350",
              },
              {
                groupId: "86642847",
                addonId: "72640351",
              },
              {
                groupId: "86642847",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356081",
              },
              {
                groupId: "26570336",
                variationId: "84356110",
              },
            ],
            price: 48900,
            addonCombinations: [
              {
                groupId: "86642847",
                addonId: "72640334",
              },
              {
                groupId: "86642847",
                addonId: "72640335",
              },
              {
                groupId: "86642847",
                addonId: "72640336",
              },
              {
                groupId: "86642847",
                addonId: "72640337",
              },
              {
                groupId: "86642847",
                addonId: "72640338",
              },
              {
                groupId: "86642847",
                addonId: "72640339",
              },
              {
                groupId: "86642847",
                addonId: "72640340",
              },
              {
                groupId: "86642847",
                addonId: "72640341",
              },
              {
                groupId: "86642847",
                addonId: "72640342",
              },
              {
                groupId: "86642847",
                addonId: "72640343",
              },
              {
                groupId: "86642847",
                addonId: "72640344",
              },
              {
                groupId: "86642847",
                addonId: "72640345",
              },
              {
                groupId: "86642847",
                addonId: "72640346",
              },
              {
                groupId: "86642847",
                addonId: "72640347",
              },
              {
                groupId: "86642847",
                addonId: "72640348",
              },
              {
                groupId: "86642847",
                addonId: "72640349",
              },
              {
                groupId: "86642847",
                addonId: "72640350",
              },
              {
                groupId: "86642847",
                addonId: "72640351",
              },
              {
                groupId: "86642847",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356081",
              },
              {
                groupId: "26570336",
                variationId: "84356113",
              },
            ],
            price: 51900,
            addonCombinations: [
              {
                groupId: "86642847",
                addonId: "72640334",
              },
              {
                groupId: "86642847",
                addonId: "72640335",
              },
              {
                groupId: "86642847",
                addonId: "72640336",
              },
              {
                groupId: "86642847",
                addonId: "72640337",
              },
              {
                groupId: "86642847",
                addonId: "72640338",
              },
              {
                groupId: "86642847",
                addonId: "72640339",
              },
              {
                groupId: "86642847",
                addonId: "72640340",
              },
              {
                groupId: "86642847",
                addonId: "72640341",
              },
              {
                groupId: "86642847",
                addonId: "72640342",
              },
              {
                groupId: "86642847",
                addonId: "72640343",
              },
              {
                groupId: "86642847",
                addonId: "72640344",
              },
              {
                groupId: "86642847",
                addonId: "72640345",
              },
              {
                groupId: "86642847",
                addonId: "72640346",
              },
              {
                groupId: "86642847",
                addonId: "72640347",
              },
              {
                groupId: "86642847",
                addonId: "72640348",
              },
              {
                groupId: "86642847",
                addonId: "72640349",
              },
              {
                groupId: "86642847",
                addonId: "72640350",
              },
              {
                groupId: "86642847",
                addonId: "72640351",
              },
              {
                groupId: "86642847",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356081",
              },
              {
                groupId: "26570336",
                variationId: "84356116",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642847",
                addonId: "72640334",
              },
              {
                groupId: "86642847",
                addonId: "72640335",
              },
              {
                groupId: "86642847",
                addonId: "72640336",
              },
              {
                groupId: "86642847",
                addonId: "72640337",
              },
              {
                groupId: "86642847",
                addonId: "72640338",
              },
              {
                groupId: "86642847",
                addonId: "72640339",
              },
              {
                groupId: "86642847",
                addonId: "72640340",
              },
              {
                groupId: "86642847",
                addonId: "72640341",
              },
              {
                groupId: "86642847",
                addonId: "72640342",
              },
              {
                groupId: "86642847",
                addonId: "72640343",
              },
              {
                groupId: "86642847",
                addonId: "72640344",
              },
              {
                groupId: "86642847",
                addonId: "72640345",
              },
              {
                groupId: "86642847",
                addonId: "72640346",
              },
              {
                groupId: "86642847",
                addonId: "72640347",
              },
              {
                groupId: "86642847",
                addonId: "72640348",
              },
              {
                groupId: "86642847",
                addonId: "72640349",
              },
              {
                groupId: "86642847",
                addonId: "72640350",
              },
              {
                groupId: "86642847",
                addonId: "72640351",
              },
              {
                groupId: "86642847",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570333",
                variationId: "84356081",
              },
              {
                groupId: "26570336",
                variationId: "84356120",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86642847",
                addonId: "72640334",
              },
              {
                groupId: "86642847",
                addonId: "72640335",
              },
              {
                groupId: "86642847",
                addonId: "72640336",
              },
              {
                groupId: "86642847",
                addonId: "72640337",
              },
              {
                groupId: "86642847",
                addonId: "72640338",
              },
              {
                groupId: "86642847",
                addonId: "72640339",
              },
              {
                groupId: "86642847",
                addonId: "72640340",
              },
              {
                groupId: "86642847",
                addonId: "72640341",
              },
              {
                groupId: "86642847",
                addonId: "72640342",
              },
              {
                groupId: "86642847",
                addonId: "72640343",
              },
              {
                groupId: "86642847",
                addonId: "72640344",
              },
              {
                groupId: "86642847",
                addonId: "72640345",
              },
              {
                groupId: "86642847",
                addonId: "72640346",
              },
              {
                groupId: "86642847",
                addonId: "72640347",
              },
              {
                groupId: "86642847",
                addonId: "72640348",
              },
              {
                groupId: "86642847",
                addonId: "72640349",
              },
              {
                groupId: "86642847",
                addonId: "72640350",
              },
              {
                groupId: "86642847",
                addonId: "72640351",
              },
              {
                groupId: "86642847",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642847",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642845",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 25900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "47199944",
      name: "Chicken Tikka",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Mouth-watering Chicken Tikka, crunchy Onion & Tomato with delicious Tandoori Sauce and 100% mozzarella cheese.",
      imageId: "juplqft4tmub5hqocwxk",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569803",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84353519",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569804",
                  variationId: "84353521",
                },
              },
              {
                name: "Medium",
                id: "84353520",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569804",
                  variationId: "84353531",
                },
              },
            ],
          },
          {
            groupId: "26569804",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84353521",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84353522",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84353524",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 454,
                id: "84353526",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84353528",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84353531",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84353534",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84353536",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 738,
                id: "84353539",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84353542",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353519",
              },
              {
                groupId: "26569804",
                variationId: "84353521",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642577",
                addonId: "72640314",
              },
              {
                groupId: "86642577",
                addonId: "72640315",
              },
              {
                groupId: "86642577",
                addonId: "72640316",
              },
              {
                groupId: "86642577",
                addonId: "72640317",
              },
              {
                groupId: "86642577",
                addonId: "72640318",
              },
              {
                groupId: "86642577",
                addonId: "72640319",
              },
              {
                groupId: "86642577",
                addonId: "72640320",
              },
              {
                groupId: "86642577",
                addonId: "72640321",
              },
              {
                groupId: "86642577",
                addonId: "72640322",
              },
              {
                groupId: "86642577",
                addonId: "72640323",
              },
              {
                groupId: "86642577",
                addonId: "72640324",
              },
              {
                groupId: "86642577",
                addonId: "72640325",
              },
              {
                groupId: "86642577",
                addonId: "72640326",
              },
              {
                groupId: "86642577",
                addonId: "72640327",
              },
              {
                groupId: "86642577",
                addonId: "72640328",
              },
              {
                groupId: "86642577",
                addonId: "72640329",
              },
              {
                groupId: "86642577",
                addonId: "72640330",
              },
              {
                groupId: "86642577",
                addonId: "72640331",
              },
              {
                groupId: "86642577",
                addonId: "72640332",
              },
              {
                groupId: "86642577",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353519",
              },
              {
                groupId: "26569804",
                variationId: "84353522",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642577",
                addonId: "72640314",
              },
              {
                groupId: "86642577",
                addonId: "72640315",
              },
              {
                groupId: "86642577",
                addonId: "72640316",
              },
              {
                groupId: "86642577",
                addonId: "72640317",
              },
              {
                groupId: "86642577",
                addonId: "72640318",
              },
              {
                groupId: "86642577",
                addonId: "72640319",
              },
              {
                groupId: "86642577",
                addonId: "72640320",
              },
              {
                groupId: "86642577",
                addonId: "72640321",
              },
              {
                groupId: "86642577",
                addonId: "72640322",
              },
              {
                groupId: "86642577",
                addonId: "72640323",
              },
              {
                groupId: "86642577",
                addonId: "72640324",
              },
              {
                groupId: "86642577",
                addonId: "72640325",
              },
              {
                groupId: "86642577",
                addonId: "72640326",
              },
              {
                groupId: "86642577",
                addonId: "72640327",
              },
              {
                groupId: "86642577",
                addonId: "72640328",
              },
              {
                groupId: "86642577",
                addonId: "72640329",
              },
              {
                groupId: "86642577",
                addonId: "72640330",
              },
              {
                groupId: "86642577",
                addonId: "72640331",
              },
              {
                groupId: "86642577",
                addonId: "72640332",
              },
              {
                groupId: "86642577",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353519",
              },
              {
                groupId: "26569804",
                variationId: "84353524",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642577",
                addonId: "72640314",
              },
              {
                groupId: "86642577",
                addonId: "72640315",
              },
              {
                groupId: "86642577",
                addonId: "72640316",
              },
              {
                groupId: "86642577",
                addonId: "72640317",
              },
              {
                groupId: "86642577",
                addonId: "72640318",
              },
              {
                groupId: "86642577",
                addonId: "72640319",
              },
              {
                groupId: "86642577",
                addonId: "72640320",
              },
              {
                groupId: "86642577",
                addonId: "72640321",
              },
              {
                groupId: "86642577",
                addonId: "72640322",
              },
              {
                groupId: "86642577",
                addonId: "72640323",
              },
              {
                groupId: "86642577",
                addonId: "72640324",
              },
              {
                groupId: "86642577",
                addonId: "72640325",
              },
              {
                groupId: "86642577",
                addonId: "72640326",
              },
              {
                groupId: "86642577",
                addonId: "72640327",
              },
              {
                groupId: "86642577",
                addonId: "72640328",
              },
              {
                groupId: "86642577",
                addonId: "72640329",
              },
              {
                groupId: "86642577",
                addonId: "72640330",
              },
              {
                groupId: "86642577",
                addonId: "72640331",
              },
              {
                groupId: "86642577",
                addonId: "72640332",
              },
              {
                groupId: "86642577",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353519",
              },
              {
                groupId: "26569804",
                variationId: "84353526",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642577",
                addonId: "72640314",
              },
              {
                groupId: "86642577",
                addonId: "72640315",
              },
              {
                groupId: "86642577",
                addonId: "72640316",
              },
              {
                groupId: "86642577",
                addonId: "72640317",
              },
              {
                groupId: "86642577",
                addonId: "72640318",
              },
              {
                groupId: "86642577",
                addonId: "72640319",
              },
              {
                groupId: "86642577",
                addonId: "72640320",
              },
              {
                groupId: "86642577",
                addonId: "72640321",
              },
              {
                groupId: "86642577",
                addonId: "72640322",
              },
              {
                groupId: "86642577",
                addonId: "72640323",
              },
              {
                groupId: "86642577",
                addonId: "72640324",
              },
              {
                groupId: "86642577",
                addonId: "72640325",
              },
              {
                groupId: "86642577",
                addonId: "72640326",
              },
              {
                groupId: "86642577",
                addonId: "72640327",
              },
              {
                groupId: "86642577",
                addonId: "72640328",
              },
              {
                groupId: "86642577",
                addonId: "72640329",
              },
              {
                groupId: "86642577",
                addonId: "72640330",
              },
              {
                groupId: "86642577",
                addonId: "72640331",
              },
              {
                groupId: "86642577",
                addonId: "72640332",
              },
              {
                groupId: "86642577",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353519",
              },
              {
                groupId: "26569804",
                variationId: "84353528",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642577",
                addonId: "72640314",
              },
              {
                groupId: "86642577",
                addonId: "72640315",
              },
              {
                groupId: "86642577",
                addonId: "72640316",
              },
              {
                groupId: "86642577",
                addonId: "72640317",
              },
              {
                groupId: "86642577",
                addonId: "72640318",
              },
              {
                groupId: "86642577",
                addonId: "72640319",
              },
              {
                groupId: "86642577",
                addonId: "72640320",
              },
              {
                groupId: "86642577",
                addonId: "72640321",
              },
              {
                groupId: "86642577",
                addonId: "72640322",
              },
              {
                groupId: "86642577",
                addonId: "72640323",
              },
              {
                groupId: "86642577",
                addonId: "72640324",
              },
              {
                groupId: "86642577",
                addonId: "72640325",
              },
              {
                groupId: "86642577",
                addonId: "72640326",
              },
              {
                groupId: "86642577",
                addonId: "72640327",
              },
              {
                groupId: "86642577",
                addonId: "72640328",
              },
              {
                groupId: "86642577",
                addonId: "72640329",
              },
              {
                groupId: "86642577",
                addonId: "72640330",
              },
              {
                groupId: "86642577",
                addonId: "72640331",
              },
              {
                groupId: "86642577",
                addonId: "72640332",
              },
              {
                groupId: "86642577",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353520",
              },
              {
                groupId: "26569804",
                variationId: "84353531",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642579",
                addonId: "72640334",
              },
              {
                groupId: "86642579",
                addonId: "72640335",
              },
              {
                groupId: "86642579",
                addonId: "72640336",
              },
              {
                groupId: "86642579",
                addonId: "72640337",
              },
              {
                groupId: "86642579",
                addonId: "72640338",
              },
              {
                groupId: "86642579",
                addonId: "72640339",
              },
              {
                groupId: "86642579",
                addonId: "72640340",
              },
              {
                groupId: "86642579",
                addonId: "72640341",
              },
              {
                groupId: "86642579",
                addonId: "72640342",
              },
              {
                groupId: "86642579",
                addonId: "72640343",
              },
              {
                groupId: "86642579",
                addonId: "72640344",
              },
              {
                groupId: "86642579",
                addonId: "72640345",
              },
              {
                groupId: "86642579",
                addonId: "72640346",
              },
              {
                groupId: "86642579",
                addonId: "72640347",
              },
              {
                groupId: "86642579",
                addonId: "72640348",
              },
              {
                groupId: "86642579",
                addonId: "72640349",
              },
              {
                groupId: "86642579",
                addonId: "72640350",
              },
              {
                groupId: "86642579",
                addonId: "72640351",
              },
              {
                groupId: "86642579",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353520",
              },
              {
                groupId: "26569804",
                variationId: "84353534",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642579",
                addonId: "72640334",
              },
              {
                groupId: "86642579",
                addonId: "72640335",
              },
              {
                groupId: "86642579",
                addonId: "72640336",
              },
              {
                groupId: "86642579",
                addonId: "72640337",
              },
              {
                groupId: "86642579",
                addonId: "72640338",
              },
              {
                groupId: "86642579",
                addonId: "72640339",
              },
              {
                groupId: "86642579",
                addonId: "72640340",
              },
              {
                groupId: "86642579",
                addonId: "72640341",
              },
              {
                groupId: "86642579",
                addonId: "72640342",
              },
              {
                groupId: "86642579",
                addonId: "72640343",
              },
              {
                groupId: "86642579",
                addonId: "72640344",
              },
              {
                groupId: "86642579",
                addonId: "72640345",
              },
              {
                groupId: "86642579",
                addonId: "72640346",
              },
              {
                groupId: "86642579",
                addonId: "72640347",
              },
              {
                groupId: "86642579",
                addonId: "72640348",
              },
              {
                groupId: "86642579",
                addonId: "72640349",
              },
              {
                groupId: "86642579",
                addonId: "72640350",
              },
              {
                groupId: "86642579",
                addonId: "72640351",
              },
              {
                groupId: "86642579",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353520",
              },
              {
                groupId: "26569804",
                variationId: "84353536",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642579",
                addonId: "72640334",
              },
              {
                groupId: "86642579",
                addonId: "72640335",
              },
              {
                groupId: "86642579",
                addonId: "72640336",
              },
              {
                groupId: "86642579",
                addonId: "72640337",
              },
              {
                groupId: "86642579",
                addonId: "72640338",
              },
              {
                groupId: "86642579",
                addonId: "72640339",
              },
              {
                groupId: "86642579",
                addonId: "72640340",
              },
              {
                groupId: "86642579",
                addonId: "72640341",
              },
              {
                groupId: "86642579",
                addonId: "72640342",
              },
              {
                groupId: "86642579",
                addonId: "72640343",
              },
              {
                groupId: "86642579",
                addonId: "72640344",
              },
              {
                groupId: "86642579",
                addonId: "72640345",
              },
              {
                groupId: "86642579",
                addonId: "72640346",
              },
              {
                groupId: "86642579",
                addonId: "72640347",
              },
              {
                groupId: "86642579",
                addonId: "72640348",
              },
              {
                groupId: "86642579",
                addonId: "72640349",
              },
              {
                groupId: "86642579",
                addonId: "72640350",
              },
              {
                groupId: "86642579",
                addonId: "72640351",
              },
              {
                groupId: "86642579",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353520",
              },
              {
                groupId: "26569804",
                variationId: "84353539",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642579",
                addonId: "72640334",
              },
              {
                groupId: "86642579",
                addonId: "72640335",
              },
              {
                groupId: "86642579",
                addonId: "72640336",
              },
              {
                groupId: "86642579",
                addonId: "72640337",
              },
              {
                groupId: "86642579",
                addonId: "72640338",
              },
              {
                groupId: "86642579",
                addonId: "72640339",
              },
              {
                groupId: "86642579",
                addonId: "72640340",
              },
              {
                groupId: "86642579",
                addonId: "72640341",
              },
              {
                groupId: "86642579",
                addonId: "72640342",
              },
              {
                groupId: "86642579",
                addonId: "72640343",
              },
              {
                groupId: "86642579",
                addonId: "72640344",
              },
              {
                groupId: "86642579",
                addonId: "72640345",
              },
              {
                groupId: "86642579",
                addonId: "72640346",
              },
              {
                groupId: "86642579",
                addonId: "72640347",
              },
              {
                groupId: "86642579",
                addonId: "72640348",
              },
              {
                groupId: "86642579",
                addonId: "72640349",
              },
              {
                groupId: "86642579",
                addonId: "72640350",
              },
              {
                groupId: "86642579",
                addonId: "72640351",
              },
              {
                groupId: "86642579",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569803",
                variationId: "84353520",
              },
              {
                groupId: "26569804",
                variationId: "84353542",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642579",
                addonId: "72640334",
              },
              {
                groupId: "86642579",
                addonId: "72640335",
              },
              {
                groupId: "86642579",
                addonId: "72640336",
              },
              {
                groupId: "86642579",
                addonId: "72640337",
              },
              {
                groupId: "86642579",
                addonId: "72640338",
              },
              {
                groupId: "86642579",
                addonId: "72640339",
              },
              {
                groupId: "86642579",
                addonId: "72640340",
              },
              {
                groupId: "86642579",
                addonId: "72640341",
              },
              {
                groupId: "86642579",
                addonId: "72640342",
              },
              {
                groupId: "86642579",
                addonId: "72640343",
              },
              {
                groupId: "86642579",
                addonId: "72640344",
              },
              {
                groupId: "86642579",
                addonId: "72640345",
              },
              {
                groupId: "86642579",
                addonId: "72640346",
              },
              {
                groupId: "86642579",
                addonId: "72640347",
              },
              {
                groupId: "86642579",
                addonId: "72640348",
              },
              {
                groupId: "86642579",
                addonId: "72640349",
              },
              {
                groupId: "86642579",
                addonId: "72640350",
              },
              {
                groupId: "86642579",
                addonId: "72640351",
              },
              {
                groupId: "86642579",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642577",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642579",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "47200091",
      name: "Spiced Chicken Meatballs",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Juicy Schezwan Chicken Meatball, crunchy Onion & 100% mozzarella cheese with flavourful pan sauce.",
      imageId: "ckrqkssgc6qkqqvkfpnq",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570290",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84355840",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570291",
                  variationId: "84355844",
                },
              },
              {
                name: "Medium",
                id: "84355842",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570291",
                  variationId: "84355850",
                },
              },
            ],
          },
          {
            groupId: "26570291",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84355844",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84355845",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 339,
                id: "84355846",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 394,
                id: "84355847",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84355848",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84355850",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84355852",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 599,
                id: "84355855",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 668,
                id: "84355857",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84355861",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355840",
              },
              {
                groupId: "26570291",
                variationId: "84355844",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642830",
                addonId: "72640314",
              },
              {
                groupId: "86642830",
                addonId: "72640315",
              },
              {
                groupId: "86642830",
                addonId: "72640316",
              },
              {
                groupId: "86642830",
                addonId: "72640317",
              },
              {
                groupId: "86642830",
                addonId: "72640318",
              },
              {
                groupId: "86642830",
                addonId: "72640319",
              },
              {
                groupId: "86642830",
                addonId: "72640320",
              },
              {
                groupId: "86642830",
                addonId: "72640321",
              },
              {
                groupId: "86642830",
                addonId: "72640322",
              },
              {
                groupId: "86642830",
                addonId: "72640323",
              },
              {
                groupId: "86642830",
                addonId: "72640324",
              },
              {
                groupId: "86642830",
                addonId: "72640325",
              },
              {
                groupId: "86642830",
                addonId: "72640326",
              },
              {
                groupId: "86642830",
                addonId: "72640327",
              },
              {
                groupId: "86642830",
                addonId: "72640328",
              },
              {
                groupId: "86642830",
                addonId: "72640329",
              },
              {
                groupId: "86642830",
                addonId: "72640330",
              },
              {
                groupId: "86642830",
                addonId: "72640331",
              },
              {
                groupId: "86642830",
                addonId: "72640332",
              },
              {
                groupId: "86642830",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355840",
              },
              {
                groupId: "26570291",
                variationId: "84355845",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642830",
                addonId: "72640314",
              },
              {
                groupId: "86642830",
                addonId: "72640315",
              },
              {
                groupId: "86642830",
                addonId: "72640316",
              },
              {
                groupId: "86642830",
                addonId: "72640317",
              },
              {
                groupId: "86642830",
                addonId: "72640318",
              },
              {
                groupId: "86642830",
                addonId: "72640319",
              },
              {
                groupId: "86642830",
                addonId: "72640320",
              },
              {
                groupId: "86642830",
                addonId: "72640321",
              },
              {
                groupId: "86642830",
                addonId: "72640322",
              },
              {
                groupId: "86642830",
                addonId: "72640323",
              },
              {
                groupId: "86642830",
                addonId: "72640324",
              },
              {
                groupId: "86642830",
                addonId: "72640325",
              },
              {
                groupId: "86642830",
                addonId: "72640326",
              },
              {
                groupId: "86642830",
                addonId: "72640327",
              },
              {
                groupId: "86642830",
                addonId: "72640328",
              },
              {
                groupId: "86642830",
                addonId: "72640329",
              },
              {
                groupId: "86642830",
                addonId: "72640330",
              },
              {
                groupId: "86642830",
                addonId: "72640331",
              },
              {
                groupId: "86642830",
                addonId: "72640332",
              },
              {
                groupId: "86642830",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355840",
              },
              {
                groupId: "26570291",
                variationId: "84355846",
              },
            ],
            price: 33900,
            addonCombinations: [
              {
                groupId: "86642830",
                addonId: "72640314",
              },
              {
                groupId: "86642830",
                addonId: "72640315",
              },
              {
                groupId: "86642830",
                addonId: "72640316",
              },
              {
                groupId: "86642830",
                addonId: "72640317",
              },
              {
                groupId: "86642830",
                addonId: "72640318",
              },
              {
                groupId: "86642830",
                addonId: "72640319",
              },
              {
                groupId: "86642830",
                addonId: "72640320",
              },
              {
                groupId: "86642830",
                addonId: "72640321",
              },
              {
                groupId: "86642830",
                addonId: "72640322",
              },
              {
                groupId: "86642830",
                addonId: "72640323",
              },
              {
                groupId: "86642830",
                addonId: "72640324",
              },
              {
                groupId: "86642830",
                addonId: "72640325",
              },
              {
                groupId: "86642830",
                addonId: "72640326",
              },
              {
                groupId: "86642830",
                addonId: "72640327",
              },
              {
                groupId: "86642830",
                addonId: "72640328",
              },
              {
                groupId: "86642830",
                addonId: "72640329",
              },
              {
                groupId: "86642830",
                addonId: "72640330",
              },
              {
                groupId: "86642830",
                addonId: "72640331",
              },
              {
                groupId: "86642830",
                addonId: "72640332",
              },
              {
                groupId: "86642830",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355840",
              },
              {
                groupId: "26570291",
                variationId: "84355847",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642830",
                addonId: "72640314",
              },
              {
                groupId: "86642830",
                addonId: "72640315",
              },
              {
                groupId: "86642830",
                addonId: "72640316",
              },
              {
                groupId: "86642830",
                addonId: "72640317",
              },
              {
                groupId: "86642830",
                addonId: "72640318",
              },
              {
                groupId: "86642830",
                addonId: "72640319",
              },
              {
                groupId: "86642830",
                addonId: "72640320",
              },
              {
                groupId: "86642830",
                addonId: "72640321",
              },
              {
                groupId: "86642830",
                addonId: "72640322",
              },
              {
                groupId: "86642830",
                addonId: "72640323",
              },
              {
                groupId: "86642830",
                addonId: "72640324",
              },
              {
                groupId: "86642830",
                addonId: "72640325",
              },
              {
                groupId: "86642830",
                addonId: "72640326",
              },
              {
                groupId: "86642830",
                addonId: "72640327",
              },
              {
                groupId: "86642830",
                addonId: "72640328",
              },
              {
                groupId: "86642830",
                addonId: "72640329",
              },
              {
                groupId: "86642830",
                addonId: "72640330",
              },
              {
                groupId: "86642830",
                addonId: "72640331",
              },
              {
                groupId: "86642830",
                addonId: "72640332",
              },
              {
                groupId: "86642830",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355840",
              },
              {
                groupId: "26570291",
                variationId: "84355848",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642830",
                addonId: "72640314",
              },
              {
                groupId: "86642830",
                addonId: "72640315",
              },
              {
                groupId: "86642830",
                addonId: "72640316",
              },
              {
                groupId: "86642830",
                addonId: "72640317",
              },
              {
                groupId: "86642830",
                addonId: "72640318",
              },
              {
                groupId: "86642830",
                addonId: "72640319",
              },
              {
                groupId: "86642830",
                addonId: "72640320",
              },
              {
                groupId: "86642830",
                addonId: "72640321",
              },
              {
                groupId: "86642830",
                addonId: "72640322",
              },
              {
                groupId: "86642830",
                addonId: "72640323",
              },
              {
                groupId: "86642830",
                addonId: "72640324",
              },
              {
                groupId: "86642830",
                addonId: "72640325",
              },
              {
                groupId: "86642830",
                addonId: "72640326",
              },
              {
                groupId: "86642830",
                addonId: "72640327",
              },
              {
                groupId: "86642830",
                addonId: "72640328",
              },
              {
                groupId: "86642830",
                addonId: "72640329",
              },
              {
                groupId: "86642830",
                addonId: "72640330",
              },
              {
                groupId: "86642830",
                addonId: "72640331",
              },
              {
                groupId: "86642830",
                addonId: "72640332",
              },
              {
                groupId: "86642830",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355842",
              },
              {
                groupId: "26570291",
                variationId: "84355850",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642831",
                addonId: "72640334",
              },
              {
                groupId: "86642831",
                addonId: "72640335",
              },
              {
                groupId: "86642831",
                addonId: "72640336",
              },
              {
                groupId: "86642831",
                addonId: "72640337",
              },
              {
                groupId: "86642831",
                addonId: "72640338",
              },
              {
                groupId: "86642831",
                addonId: "72640339",
              },
              {
                groupId: "86642831",
                addonId: "72640340",
              },
              {
                groupId: "86642831",
                addonId: "72640341",
              },
              {
                groupId: "86642831",
                addonId: "72640342",
              },
              {
                groupId: "86642831",
                addonId: "72640343",
              },
              {
                groupId: "86642831",
                addonId: "72640344",
              },
              {
                groupId: "86642831",
                addonId: "72640345",
              },
              {
                groupId: "86642831",
                addonId: "72640346",
              },
              {
                groupId: "86642831",
                addonId: "72640347",
              },
              {
                groupId: "86642831",
                addonId: "72640348",
              },
              {
                groupId: "86642831",
                addonId: "72640349",
              },
              {
                groupId: "86642831",
                addonId: "72640350",
              },
              {
                groupId: "86642831",
                addonId: "72640351",
              },
              {
                groupId: "86642831",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355842",
              },
              {
                groupId: "26570291",
                variationId: "84355852",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642831",
                addonId: "72640334",
              },
              {
                groupId: "86642831",
                addonId: "72640335",
              },
              {
                groupId: "86642831",
                addonId: "72640336",
              },
              {
                groupId: "86642831",
                addonId: "72640337",
              },
              {
                groupId: "86642831",
                addonId: "72640338",
              },
              {
                groupId: "86642831",
                addonId: "72640339",
              },
              {
                groupId: "86642831",
                addonId: "72640340",
              },
              {
                groupId: "86642831",
                addonId: "72640341",
              },
              {
                groupId: "86642831",
                addonId: "72640342",
              },
              {
                groupId: "86642831",
                addonId: "72640343",
              },
              {
                groupId: "86642831",
                addonId: "72640344",
              },
              {
                groupId: "86642831",
                addonId: "72640345",
              },
              {
                groupId: "86642831",
                addonId: "72640346",
              },
              {
                groupId: "86642831",
                addonId: "72640347",
              },
              {
                groupId: "86642831",
                addonId: "72640348",
              },
              {
                groupId: "86642831",
                addonId: "72640349",
              },
              {
                groupId: "86642831",
                addonId: "72640350",
              },
              {
                groupId: "86642831",
                addonId: "72640351",
              },
              {
                groupId: "86642831",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355842",
              },
              {
                groupId: "26570291",
                variationId: "84355855",
              },
            ],
            price: 59900,
            addonCombinations: [
              {
                groupId: "86642831",
                addonId: "72640334",
              },
              {
                groupId: "86642831",
                addonId: "72640335",
              },
              {
                groupId: "86642831",
                addonId: "72640336",
              },
              {
                groupId: "86642831",
                addonId: "72640337",
              },
              {
                groupId: "86642831",
                addonId: "72640338",
              },
              {
                groupId: "86642831",
                addonId: "72640339",
              },
              {
                groupId: "86642831",
                addonId: "72640340",
              },
              {
                groupId: "86642831",
                addonId: "72640341",
              },
              {
                groupId: "86642831",
                addonId: "72640342",
              },
              {
                groupId: "86642831",
                addonId: "72640343",
              },
              {
                groupId: "86642831",
                addonId: "72640344",
              },
              {
                groupId: "86642831",
                addonId: "72640345",
              },
              {
                groupId: "86642831",
                addonId: "72640346",
              },
              {
                groupId: "86642831",
                addonId: "72640347",
              },
              {
                groupId: "86642831",
                addonId: "72640348",
              },
              {
                groupId: "86642831",
                addonId: "72640349",
              },
              {
                groupId: "86642831",
                addonId: "72640350",
              },
              {
                groupId: "86642831",
                addonId: "72640351",
              },
              {
                groupId: "86642831",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355842",
              },
              {
                groupId: "26570291",
                variationId: "84355857",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642831",
                addonId: "72640334",
              },
              {
                groupId: "86642831",
                addonId: "72640335",
              },
              {
                groupId: "86642831",
                addonId: "72640336",
              },
              {
                groupId: "86642831",
                addonId: "72640337",
              },
              {
                groupId: "86642831",
                addonId: "72640338",
              },
              {
                groupId: "86642831",
                addonId: "72640339",
              },
              {
                groupId: "86642831",
                addonId: "72640340",
              },
              {
                groupId: "86642831",
                addonId: "72640341",
              },
              {
                groupId: "86642831",
                addonId: "72640342",
              },
              {
                groupId: "86642831",
                addonId: "72640343",
              },
              {
                groupId: "86642831",
                addonId: "72640344",
              },
              {
                groupId: "86642831",
                addonId: "72640345",
              },
              {
                groupId: "86642831",
                addonId: "72640346",
              },
              {
                groupId: "86642831",
                addonId: "72640347",
              },
              {
                groupId: "86642831",
                addonId: "72640348",
              },
              {
                groupId: "86642831",
                addonId: "72640349",
              },
              {
                groupId: "86642831",
                addonId: "72640350",
              },
              {
                groupId: "86642831",
                addonId: "72640351",
              },
              {
                groupId: "86642831",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570290",
                variationId: "84355842",
              },
              {
                groupId: "26570291",
                variationId: "84355861",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642831",
                addonId: "72640334",
              },
              {
                groupId: "86642831",
                addonId: "72640335",
              },
              {
                groupId: "86642831",
                addonId: "72640336",
              },
              {
                groupId: "86642831",
                addonId: "72640337",
              },
              {
                groupId: "86642831",
                addonId: "72640338",
              },
              {
                groupId: "86642831",
                addonId: "72640339",
              },
              {
                groupId: "86642831",
                addonId: "72640340",
              },
              {
                groupId: "86642831",
                addonId: "72640341",
              },
              {
                groupId: "86642831",
                addonId: "72640342",
              },
              {
                groupId: "86642831",
                addonId: "72640343",
              },
              {
                groupId: "86642831",
                addonId: "72640344",
              },
              {
                groupId: "86642831",
                addonId: "72640345",
              },
              {
                groupId: "86642831",
                addonId: "72640346",
              },
              {
                groupId: "86642831",
                addonId: "72640347",
              },
              {
                groupId: "86642831",
                addonId: "72640348",
              },
              {
                groupId: "86642831",
                addonId: "72640349",
              },
              {
                groupId: "86642831",
                addonId: "72640350",
              },
              {
                groupId: "86642831",
                addonId: "72640351",
              },
              {
                groupId: "86642831",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642830",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642831",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "47200116",
      name: "Triple Chicken Feast",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Spicy Schezwan Chicken Meatball, flavourful  Herbed Chicken, juicy Chicken Sausage, Green Capsicum & Onion, spicy Red Paprika with classic pan sauce and 100% mozzarella cheese.",
      imageId: "quxirmjttzksp7xlhysc",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569674",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84352729",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569675",
                  variationId: "84352733",
                },
              },
              {
                name: "Medium",
                id: "84352731",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569675",
                  variationId: "84352738",
                },
              },
            ],
          },
          {
            groupId: "26569675",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 409,
                default: 1,
                id: "84352733",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 409,
                id: "84352734",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 429,
                id: "84352735",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 484,
                id: "84352736",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 484,
                id: "84352737",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 699,
                id: "84352738",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 699,
                id: "84352740",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 729,
                id: "84352743",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 798,
                id: "84352745",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 798,
                id: "84352748",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352729",
              },
              {
                groupId: "26569675",
                variationId: "84352733",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642503",
                addonId: "72640353",
              },
              {
                groupId: "86642503",
                addonId: "72640354",
              },
              {
                groupId: "86642503",
                addonId: "72640355",
              },
              {
                groupId: "86642503",
                addonId: "72640356",
              },
              {
                groupId: "86642503",
                addonId: "72640357",
              },
              {
                groupId: "86642503",
                addonId: "72640358",
              },
              {
                groupId: "86642503",
                addonId: "72640320",
              },
              {
                groupId: "86642503",
                addonId: "72640321",
              },
              {
                groupId: "86642503",
                addonId: "72640322",
              },
              {
                groupId: "86642503",
                addonId: "72640323",
              },
              {
                groupId: "86642503",
                addonId: "72640324",
              },
              {
                groupId: "86642503",
                addonId: "72640325",
              },
              {
                groupId: "86642503",
                addonId: "72640326",
              },
              {
                groupId: "86642503",
                addonId: "72640327",
              },
              {
                groupId: "86642503",
                addonId: "72640328",
              },
              {
                groupId: "86642503",
                addonId: "72640329",
              },
              {
                groupId: "86642503",
                addonId: "72640330",
              },
              {
                groupId: "86642503",
                addonId: "72640331",
              },
              {
                groupId: "86642503",
                addonId: "72640332",
              },
              {
                groupId: "86642503",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352729",
              },
              {
                groupId: "26569675",
                variationId: "84352734",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642503",
                addonId: "72640353",
              },
              {
                groupId: "86642503",
                addonId: "72640354",
              },
              {
                groupId: "86642503",
                addonId: "72640355",
              },
              {
                groupId: "86642503",
                addonId: "72640356",
              },
              {
                groupId: "86642503",
                addonId: "72640357",
              },
              {
                groupId: "86642503",
                addonId: "72640358",
              },
              {
                groupId: "86642503",
                addonId: "72640320",
              },
              {
                groupId: "86642503",
                addonId: "72640321",
              },
              {
                groupId: "86642503",
                addonId: "72640322",
              },
              {
                groupId: "86642503",
                addonId: "72640323",
              },
              {
                groupId: "86642503",
                addonId: "72640324",
              },
              {
                groupId: "86642503",
                addonId: "72640325",
              },
              {
                groupId: "86642503",
                addonId: "72640326",
              },
              {
                groupId: "86642503",
                addonId: "72640327",
              },
              {
                groupId: "86642503",
                addonId: "72640328",
              },
              {
                groupId: "86642503",
                addonId: "72640329",
              },
              {
                groupId: "86642503",
                addonId: "72640330",
              },
              {
                groupId: "86642503",
                addonId: "72640331",
              },
              {
                groupId: "86642503",
                addonId: "72640332",
              },
              {
                groupId: "86642503",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352729",
              },
              {
                groupId: "26569675",
                variationId: "84352735",
              },
            ],
            price: 42900,
            addonCombinations: [
              {
                groupId: "86642503",
                addonId: "72640353",
              },
              {
                groupId: "86642503",
                addonId: "72640354",
              },
              {
                groupId: "86642503",
                addonId: "72640355",
              },
              {
                groupId: "86642503",
                addonId: "72640356",
              },
              {
                groupId: "86642503",
                addonId: "72640357",
              },
              {
                groupId: "86642503",
                addonId: "72640358",
              },
              {
                groupId: "86642503",
                addonId: "72640320",
              },
              {
                groupId: "86642503",
                addonId: "72640321",
              },
              {
                groupId: "86642503",
                addonId: "72640322",
              },
              {
                groupId: "86642503",
                addonId: "72640323",
              },
              {
                groupId: "86642503",
                addonId: "72640324",
              },
              {
                groupId: "86642503",
                addonId: "72640325",
              },
              {
                groupId: "86642503",
                addonId: "72640326",
              },
              {
                groupId: "86642503",
                addonId: "72640327",
              },
              {
                groupId: "86642503",
                addonId: "72640328",
              },
              {
                groupId: "86642503",
                addonId: "72640329",
              },
              {
                groupId: "86642503",
                addonId: "72640330",
              },
              {
                groupId: "86642503",
                addonId: "72640331",
              },
              {
                groupId: "86642503",
                addonId: "72640332",
              },
              {
                groupId: "86642503",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352729",
              },
              {
                groupId: "26569675",
                variationId: "84352736",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642503",
                addonId: "72640353",
              },
              {
                groupId: "86642503",
                addonId: "72640354",
              },
              {
                groupId: "86642503",
                addonId: "72640355",
              },
              {
                groupId: "86642503",
                addonId: "72640356",
              },
              {
                groupId: "86642503",
                addonId: "72640357",
              },
              {
                groupId: "86642503",
                addonId: "72640358",
              },
              {
                groupId: "86642503",
                addonId: "72640320",
              },
              {
                groupId: "86642503",
                addonId: "72640321",
              },
              {
                groupId: "86642503",
                addonId: "72640322",
              },
              {
                groupId: "86642503",
                addonId: "72640323",
              },
              {
                groupId: "86642503",
                addonId: "72640324",
              },
              {
                groupId: "86642503",
                addonId: "72640325",
              },
              {
                groupId: "86642503",
                addonId: "72640326",
              },
              {
                groupId: "86642503",
                addonId: "72640327",
              },
              {
                groupId: "86642503",
                addonId: "72640328",
              },
              {
                groupId: "86642503",
                addonId: "72640329",
              },
              {
                groupId: "86642503",
                addonId: "72640330",
              },
              {
                groupId: "86642503",
                addonId: "72640331",
              },
              {
                groupId: "86642503",
                addonId: "72640332",
              },
              {
                groupId: "86642503",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352729",
              },
              {
                groupId: "26569675",
                variationId: "84352737",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642503",
                addonId: "72640353",
              },
              {
                groupId: "86642503",
                addonId: "72640354",
              },
              {
                groupId: "86642503",
                addonId: "72640355",
              },
              {
                groupId: "86642503",
                addonId: "72640356",
              },
              {
                groupId: "86642503",
                addonId: "72640357",
              },
              {
                groupId: "86642503",
                addonId: "72640358",
              },
              {
                groupId: "86642503",
                addonId: "72640320",
              },
              {
                groupId: "86642503",
                addonId: "72640321",
              },
              {
                groupId: "86642503",
                addonId: "72640322",
              },
              {
                groupId: "86642503",
                addonId: "72640323",
              },
              {
                groupId: "86642503",
                addonId: "72640324",
              },
              {
                groupId: "86642503",
                addonId: "72640325",
              },
              {
                groupId: "86642503",
                addonId: "72640326",
              },
              {
                groupId: "86642503",
                addonId: "72640327",
              },
              {
                groupId: "86642503",
                addonId: "72640328",
              },
              {
                groupId: "86642503",
                addonId: "72640329",
              },
              {
                groupId: "86642503",
                addonId: "72640330",
              },
              {
                groupId: "86642503",
                addonId: "72640331",
              },
              {
                groupId: "86642503",
                addonId: "72640332",
              },
              {
                groupId: "86642503",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352731",
              },
              {
                groupId: "26569675",
                variationId: "84352738",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642506",
                addonId: "72640334",
              },
              {
                groupId: "86642506",
                addonId: "72640335",
              },
              {
                groupId: "86642506",
                addonId: "72640336",
              },
              {
                groupId: "86642506",
                addonId: "72640337",
              },
              {
                groupId: "86642506",
                addonId: "72640338",
              },
              {
                groupId: "86642506",
                addonId: "72640339",
              },
              {
                groupId: "86642506",
                addonId: "72640340",
              },
              {
                groupId: "86642506",
                addonId: "72640341",
              },
              {
                groupId: "86642506",
                addonId: "72640342",
              },
              {
                groupId: "86642506",
                addonId: "72640343",
              },
              {
                groupId: "86642506",
                addonId: "72640344",
              },
              {
                groupId: "86642506",
                addonId: "72640345",
              },
              {
                groupId: "86642506",
                addonId: "72640346",
              },
              {
                groupId: "86642506",
                addonId: "72640347",
              },
              {
                groupId: "86642506",
                addonId: "72640348",
              },
              {
                groupId: "86642506",
                addonId: "72640349",
              },
              {
                groupId: "86642506",
                addonId: "72640350",
              },
              {
                groupId: "86642506",
                addonId: "72640351",
              },
              {
                groupId: "86642506",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352731",
              },
              {
                groupId: "26569675",
                variationId: "84352740",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642506",
                addonId: "72640334",
              },
              {
                groupId: "86642506",
                addonId: "72640335",
              },
              {
                groupId: "86642506",
                addonId: "72640336",
              },
              {
                groupId: "86642506",
                addonId: "72640337",
              },
              {
                groupId: "86642506",
                addonId: "72640338",
              },
              {
                groupId: "86642506",
                addonId: "72640339",
              },
              {
                groupId: "86642506",
                addonId: "72640340",
              },
              {
                groupId: "86642506",
                addonId: "72640341",
              },
              {
                groupId: "86642506",
                addonId: "72640342",
              },
              {
                groupId: "86642506",
                addonId: "72640343",
              },
              {
                groupId: "86642506",
                addonId: "72640344",
              },
              {
                groupId: "86642506",
                addonId: "72640345",
              },
              {
                groupId: "86642506",
                addonId: "72640346",
              },
              {
                groupId: "86642506",
                addonId: "72640347",
              },
              {
                groupId: "86642506",
                addonId: "72640348",
              },
              {
                groupId: "86642506",
                addonId: "72640349",
              },
              {
                groupId: "86642506",
                addonId: "72640350",
              },
              {
                groupId: "86642506",
                addonId: "72640351",
              },
              {
                groupId: "86642506",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352731",
              },
              {
                groupId: "26569675",
                variationId: "84352743",
              },
            ],
            price: 72900,
            addonCombinations: [
              {
                groupId: "86642506",
                addonId: "72640334",
              },
              {
                groupId: "86642506",
                addonId: "72640335",
              },
              {
                groupId: "86642506",
                addonId: "72640336",
              },
              {
                groupId: "86642506",
                addonId: "72640337",
              },
              {
                groupId: "86642506",
                addonId: "72640338",
              },
              {
                groupId: "86642506",
                addonId: "72640339",
              },
              {
                groupId: "86642506",
                addonId: "72640340",
              },
              {
                groupId: "86642506",
                addonId: "72640341",
              },
              {
                groupId: "86642506",
                addonId: "72640342",
              },
              {
                groupId: "86642506",
                addonId: "72640343",
              },
              {
                groupId: "86642506",
                addonId: "72640344",
              },
              {
                groupId: "86642506",
                addonId: "72640345",
              },
              {
                groupId: "86642506",
                addonId: "72640346",
              },
              {
                groupId: "86642506",
                addonId: "72640347",
              },
              {
                groupId: "86642506",
                addonId: "72640348",
              },
              {
                groupId: "86642506",
                addonId: "72640349",
              },
              {
                groupId: "86642506",
                addonId: "72640350",
              },
              {
                groupId: "86642506",
                addonId: "72640351",
              },
              {
                groupId: "86642506",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352731",
              },
              {
                groupId: "26569675",
                variationId: "84352745",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642506",
                addonId: "72640334",
              },
              {
                groupId: "86642506",
                addonId: "72640335",
              },
              {
                groupId: "86642506",
                addonId: "72640336",
              },
              {
                groupId: "86642506",
                addonId: "72640337",
              },
              {
                groupId: "86642506",
                addonId: "72640338",
              },
              {
                groupId: "86642506",
                addonId: "72640339",
              },
              {
                groupId: "86642506",
                addonId: "72640340",
              },
              {
                groupId: "86642506",
                addonId: "72640341",
              },
              {
                groupId: "86642506",
                addonId: "72640342",
              },
              {
                groupId: "86642506",
                addonId: "72640343",
              },
              {
                groupId: "86642506",
                addonId: "72640344",
              },
              {
                groupId: "86642506",
                addonId: "72640345",
              },
              {
                groupId: "86642506",
                addonId: "72640346",
              },
              {
                groupId: "86642506",
                addonId: "72640347",
              },
              {
                groupId: "86642506",
                addonId: "72640348",
              },
              {
                groupId: "86642506",
                addonId: "72640349",
              },
              {
                groupId: "86642506",
                addonId: "72640350",
              },
              {
                groupId: "86642506",
                addonId: "72640351",
              },
              {
                groupId: "86642506",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569674",
                variationId: "84352731",
              },
              {
                groupId: "26569675",
                variationId: "84352748",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642506",
                addonId: "72640334",
              },
              {
                groupId: "86642506",
                addonId: "72640335",
              },
              {
                groupId: "86642506",
                addonId: "72640336",
              },
              {
                groupId: "86642506",
                addonId: "72640337",
              },
              {
                groupId: "86642506",
                addonId: "72640338",
              },
              {
                groupId: "86642506",
                addonId: "72640339",
              },
              {
                groupId: "86642506",
                addonId: "72640340",
              },
              {
                groupId: "86642506",
                addonId: "72640341",
              },
              {
                groupId: "86642506",
                addonId: "72640342",
              },
              {
                groupId: "86642506",
                addonId: "72640343",
              },
              {
                groupId: "86642506",
                addonId: "72640344",
              },
              {
                groupId: "86642506",
                addonId: "72640345",
              },
              {
                groupId: "86642506",
                addonId: "72640346",
              },
              {
                groupId: "86642506",
                addonId: "72640347",
              },
              {
                groupId: "86642506",
                addonId: "72640348",
              },
              {
                groupId: "86642506",
                addonId: "72640349",
              },
              {
                groupId: "86642506",
                addonId: "72640350",
              },
              {
                groupId: "86642506",
                addonId: "72640351",
              },
              {
                groupId: "86642506",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642506",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642503",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640353",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640354",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640355",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640356",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640357",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640358",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 40900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "72275857",
      name: "Chicken Tikka Supreme",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | A divine combination of delicious Chicken Tikka &  Malai Chicken Tikka, Onion, spicy Red Paprika with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "d3bnas8nxt9dr13jhipu",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569686",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84352781",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569687",
                  variationId: "84352783",
                },
              },
              {
                name: "Medium",
                id: "84352782",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569687",
                  variationId: "84352788",
                },
              },
            ],
          },
          {
            groupId: "26569687",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 409,
                default: 1,
                id: "84352783",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 409,
                id: "84352784",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 429,
                id: "84352785",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 484,
                id: "84352786",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 484,
                id: "84352787",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 699,
                id: "84352788",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 699,
                id: "84352789",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 729,
                id: "84352790",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 798,
                id: "84352791",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 798,
                id: "84352792",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352781",
              },
              {
                groupId: "26569687",
                variationId: "84352783",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642508",
                addonId: "72640353",
              },
              {
                groupId: "86642508",
                addonId: "72640354",
              },
              {
                groupId: "86642508",
                addonId: "72640355",
              },
              {
                groupId: "86642508",
                addonId: "72640356",
              },
              {
                groupId: "86642508",
                addonId: "72640357",
              },
              {
                groupId: "86642508",
                addonId: "72640358",
              },
              {
                groupId: "86642508",
                addonId: "72640320",
              },
              {
                groupId: "86642508",
                addonId: "72640321",
              },
              {
                groupId: "86642508",
                addonId: "72640322",
              },
              {
                groupId: "86642508",
                addonId: "72640323",
              },
              {
                groupId: "86642508",
                addonId: "72640324",
              },
              {
                groupId: "86642508",
                addonId: "72640325",
              },
              {
                groupId: "86642508",
                addonId: "72640326",
              },
              {
                groupId: "86642508",
                addonId: "72640327",
              },
              {
                groupId: "86642508",
                addonId: "72640328",
              },
              {
                groupId: "86642508",
                addonId: "72640329",
              },
              {
                groupId: "86642508",
                addonId: "72640330",
              },
              {
                groupId: "86642508",
                addonId: "72640331",
              },
              {
                groupId: "86642508",
                addonId: "72640332",
              },
              {
                groupId: "86642508",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352781",
              },
              {
                groupId: "26569687",
                variationId: "84352784",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642508",
                addonId: "72640353",
              },
              {
                groupId: "86642508",
                addonId: "72640354",
              },
              {
                groupId: "86642508",
                addonId: "72640355",
              },
              {
                groupId: "86642508",
                addonId: "72640356",
              },
              {
                groupId: "86642508",
                addonId: "72640357",
              },
              {
                groupId: "86642508",
                addonId: "72640358",
              },
              {
                groupId: "86642508",
                addonId: "72640320",
              },
              {
                groupId: "86642508",
                addonId: "72640321",
              },
              {
                groupId: "86642508",
                addonId: "72640322",
              },
              {
                groupId: "86642508",
                addonId: "72640323",
              },
              {
                groupId: "86642508",
                addonId: "72640324",
              },
              {
                groupId: "86642508",
                addonId: "72640325",
              },
              {
                groupId: "86642508",
                addonId: "72640326",
              },
              {
                groupId: "86642508",
                addonId: "72640327",
              },
              {
                groupId: "86642508",
                addonId: "72640328",
              },
              {
                groupId: "86642508",
                addonId: "72640329",
              },
              {
                groupId: "86642508",
                addonId: "72640330",
              },
              {
                groupId: "86642508",
                addonId: "72640331",
              },
              {
                groupId: "86642508",
                addonId: "72640332",
              },
              {
                groupId: "86642508",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352781",
              },
              {
                groupId: "26569687",
                variationId: "84352785",
              },
            ],
            price: 42900,
            addonCombinations: [
              {
                groupId: "86642508",
                addonId: "72640353",
              },
              {
                groupId: "86642508",
                addonId: "72640354",
              },
              {
                groupId: "86642508",
                addonId: "72640355",
              },
              {
                groupId: "86642508",
                addonId: "72640356",
              },
              {
                groupId: "86642508",
                addonId: "72640357",
              },
              {
                groupId: "86642508",
                addonId: "72640358",
              },
              {
                groupId: "86642508",
                addonId: "72640320",
              },
              {
                groupId: "86642508",
                addonId: "72640321",
              },
              {
                groupId: "86642508",
                addonId: "72640322",
              },
              {
                groupId: "86642508",
                addonId: "72640323",
              },
              {
                groupId: "86642508",
                addonId: "72640324",
              },
              {
                groupId: "86642508",
                addonId: "72640325",
              },
              {
                groupId: "86642508",
                addonId: "72640326",
              },
              {
                groupId: "86642508",
                addonId: "72640327",
              },
              {
                groupId: "86642508",
                addonId: "72640328",
              },
              {
                groupId: "86642508",
                addonId: "72640329",
              },
              {
                groupId: "86642508",
                addonId: "72640330",
              },
              {
                groupId: "86642508",
                addonId: "72640331",
              },
              {
                groupId: "86642508",
                addonId: "72640332",
              },
              {
                groupId: "86642508",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352781",
              },
              {
                groupId: "26569687",
                variationId: "84352786",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642508",
                addonId: "72640353",
              },
              {
                groupId: "86642508",
                addonId: "72640354",
              },
              {
                groupId: "86642508",
                addonId: "72640355",
              },
              {
                groupId: "86642508",
                addonId: "72640356",
              },
              {
                groupId: "86642508",
                addonId: "72640357",
              },
              {
                groupId: "86642508",
                addonId: "72640358",
              },
              {
                groupId: "86642508",
                addonId: "72640320",
              },
              {
                groupId: "86642508",
                addonId: "72640321",
              },
              {
                groupId: "86642508",
                addonId: "72640322",
              },
              {
                groupId: "86642508",
                addonId: "72640323",
              },
              {
                groupId: "86642508",
                addonId: "72640324",
              },
              {
                groupId: "86642508",
                addonId: "72640325",
              },
              {
                groupId: "86642508",
                addonId: "72640326",
              },
              {
                groupId: "86642508",
                addonId: "72640327",
              },
              {
                groupId: "86642508",
                addonId: "72640328",
              },
              {
                groupId: "86642508",
                addonId: "72640329",
              },
              {
                groupId: "86642508",
                addonId: "72640330",
              },
              {
                groupId: "86642508",
                addonId: "72640331",
              },
              {
                groupId: "86642508",
                addonId: "72640332",
              },
              {
                groupId: "86642508",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352781",
              },
              {
                groupId: "26569687",
                variationId: "84352787",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642508",
                addonId: "72640353",
              },
              {
                groupId: "86642508",
                addonId: "72640354",
              },
              {
                groupId: "86642508",
                addonId: "72640355",
              },
              {
                groupId: "86642508",
                addonId: "72640356",
              },
              {
                groupId: "86642508",
                addonId: "72640357",
              },
              {
                groupId: "86642508",
                addonId: "72640358",
              },
              {
                groupId: "86642508",
                addonId: "72640320",
              },
              {
                groupId: "86642508",
                addonId: "72640321",
              },
              {
                groupId: "86642508",
                addonId: "72640322",
              },
              {
                groupId: "86642508",
                addonId: "72640323",
              },
              {
                groupId: "86642508",
                addonId: "72640324",
              },
              {
                groupId: "86642508",
                addonId: "72640325",
              },
              {
                groupId: "86642508",
                addonId: "72640326",
              },
              {
                groupId: "86642508",
                addonId: "72640327",
              },
              {
                groupId: "86642508",
                addonId: "72640328",
              },
              {
                groupId: "86642508",
                addonId: "72640329",
              },
              {
                groupId: "86642508",
                addonId: "72640330",
              },
              {
                groupId: "86642508",
                addonId: "72640331",
              },
              {
                groupId: "86642508",
                addonId: "72640332",
              },
              {
                groupId: "86642508",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352782",
              },
              {
                groupId: "26569687",
                variationId: "84352788",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642510",
                addonId: "72640334",
              },
              {
                groupId: "86642510",
                addonId: "72640335",
              },
              {
                groupId: "86642510",
                addonId: "72640336",
              },
              {
                groupId: "86642510",
                addonId: "72640337",
              },
              {
                groupId: "86642510",
                addonId: "72640338",
              },
              {
                groupId: "86642510",
                addonId: "72640339",
              },
              {
                groupId: "86642510",
                addonId: "72640340",
              },
              {
                groupId: "86642510",
                addonId: "72640341",
              },
              {
                groupId: "86642510",
                addonId: "72640342",
              },
              {
                groupId: "86642510",
                addonId: "72640343",
              },
              {
                groupId: "86642510",
                addonId: "72640344",
              },
              {
                groupId: "86642510",
                addonId: "72640345",
              },
              {
                groupId: "86642510",
                addonId: "72640346",
              },
              {
                groupId: "86642510",
                addonId: "72640347",
              },
              {
                groupId: "86642510",
                addonId: "72640348",
              },
              {
                groupId: "86642510",
                addonId: "72640349",
              },
              {
                groupId: "86642510",
                addonId: "72640350",
              },
              {
                groupId: "86642510",
                addonId: "72640351",
              },
              {
                groupId: "86642510",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352782",
              },
              {
                groupId: "26569687",
                variationId: "84352789",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642510",
                addonId: "72640334",
              },
              {
                groupId: "86642510",
                addonId: "72640335",
              },
              {
                groupId: "86642510",
                addonId: "72640336",
              },
              {
                groupId: "86642510",
                addonId: "72640337",
              },
              {
                groupId: "86642510",
                addonId: "72640338",
              },
              {
                groupId: "86642510",
                addonId: "72640339",
              },
              {
                groupId: "86642510",
                addonId: "72640340",
              },
              {
                groupId: "86642510",
                addonId: "72640341",
              },
              {
                groupId: "86642510",
                addonId: "72640342",
              },
              {
                groupId: "86642510",
                addonId: "72640343",
              },
              {
                groupId: "86642510",
                addonId: "72640344",
              },
              {
                groupId: "86642510",
                addonId: "72640345",
              },
              {
                groupId: "86642510",
                addonId: "72640346",
              },
              {
                groupId: "86642510",
                addonId: "72640347",
              },
              {
                groupId: "86642510",
                addonId: "72640348",
              },
              {
                groupId: "86642510",
                addonId: "72640349",
              },
              {
                groupId: "86642510",
                addonId: "72640350",
              },
              {
                groupId: "86642510",
                addonId: "72640351",
              },
              {
                groupId: "86642510",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352782",
              },
              {
                groupId: "26569687",
                variationId: "84352790",
              },
            ],
            price: 72900,
            addonCombinations: [
              {
                groupId: "86642510",
                addonId: "72640334",
              },
              {
                groupId: "86642510",
                addonId: "72640335",
              },
              {
                groupId: "86642510",
                addonId: "72640336",
              },
              {
                groupId: "86642510",
                addonId: "72640337",
              },
              {
                groupId: "86642510",
                addonId: "72640338",
              },
              {
                groupId: "86642510",
                addonId: "72640339",
              },
              {
                groupId: "86642510",
                addonId: "72640340",
              },
              {
                groupId: "86642510",
                addonId: "72640341",
              },
              {
                groupId: "86642510",
                addonId: "72640342",
              },
              {
                groupId: "86642510",
                addonId: "72640343",
              },
              {
                groupId: "86642510",
                addonId: "72640344",
              },
              {
                groupId: "86642510",
                addonId: "72640345",
              },
              {
                groupId: "86642510",
                addonId: "72640346",
              },
              {
                groupId: "86642510",
                addonId: "72640347",
              },
              {
                groupId: "86642510",
                addonId: "72640348",
              },
              {
                groupId: "86642510",
                addonId: "72640349",
              },
              {
                groupId: "86642510",
                addonId: "72640350",
              },
              {
                groupId: "86642510",
                addonId: "72640351",
              },
              {
                groupId: "86642510",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352782",
              },
              {
                groupId: "26569687",
                variationId: "84352791",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642510",
                addonId: "72640334",
              },
              {
                groupId: "86642510",
                addonId: "72640335",
              },
              {
                groupId: "86642510",
                addonId: "72640336",
              },
              {
                groupId: "86642510",
                addonId: "72640337",
              },
              {
                groupId: "86642510",
                addonId: "72640338",
              },
              {
                groupId: "86642510",
                addonId: "72640339",
              },
              {
                groupId: "86642510",
                addonId: "72640340",
              },
              {
                groupId: "86642510",
                addonId: "72640341",
              },
              {
                groupId: "86642510",
                addonId: "72640342",
              },
              {
                groupId: "86642510",
                addonId: "72640343",
              },
              {
                groupId: "86642510",
                addonId: "72640344",
              },
              {
                groupId: "86642510",
                addonId: "72640345",
              },
              {
                groupId: "86642510",
                addonId: "72640346",
              },
              {
                groupId: "86642510",
                addonId: "72640347",
              },
              {
                groupId: "86642510",
                addonId: "72640348",
              },
              {
                groupId: "86642510",
                addonId: "72640349",
              },
              {
                groupId: "86642510",
                addonId: "72640350",
              },
              {
                groupId: "86642510",
                addonId: "72640351",
              },
              {
                groupId: "86642510",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569686",
                variationId: "84352782",
              },
              {
                groupId: "26569687",
                variationId: "84352792",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642510",
                addonId: "72640334",
              },
              {
                groupId: "86642510",
                addonId: "72640335",
              },
              {
                groupId: "86642510",
                addonId: "72640336",
              },
              {
                groupId: "86642510",
                addonId: "72640337",
              },
              {
                groupId: "86642510",
                addonId: "72640338",
              },
              {
                groupId: "86642510",
                addonId: "72640339",
              },
              {
                groupId: "86642510",
                addonId: "72640340",
              },
              {
                groupId: "86642510",
                addonId: "72640341",
              },
              {
                groupId: "86642510",
                addonId: "72640342",
              },
              {
                groupId: "86642510",
                addonId: "72640343",
              },
              {
                groupId: "86642510",
                addonId: "72640344",
              },
              {
                groupId: "86642510",
                addonId: "72640345",
              },
              {
                groupId: "86642510",
                addonId: "72640346",
              },
              {
                groupId: "86642510",
                addonId: "72640347",
              },
              {
                groupId: "86642510",
                addonId: "72640348",
              },
              {
                groupId: "86642510",
                addonId: "72640349",
              },
              {
                groupId: "86642510",
                addonId: "72640350",
              },
              {
                groupId: "86642510",
                addonId: "72640351",
              },
              {
                groupId: "86642510",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642510",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642508",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640353",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640354",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640355",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640356",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640357",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640358",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 40900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "72275868",
      name: "Chicken Pepper Crunch",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Flavourful Herbed Chicken, crunchy Onion& Green Capsicum,  Red Capsicum  & 100% mozzarella cheese with our classic pan sauce.",
      imageId: "phtizckwm3bmcssnrtz2",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569795",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84353471",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569796",
                  variationId: "84353473",
                },
              },
              {
                name: "Medium",
                id: "84353472",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569796",
                  variationId: "84353478",
                },
              },
            ],
          },
          {
            groupId: "26569796",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84353473",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84353474",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84353475",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 454,
                id: "84353476",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84353477",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84353478",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84353479",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84353480",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 738,
                id: "84353482",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84353484",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353471",
              },
              {
                groupId: "26569796",
                variationId: "84353473",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642568",
                addonId: "72640314",
              },
              {
                groupId: "86642568",
                addonId: "72640315",
              },
              {
                groupId: "86642568",
                addonId: "72640316",
              },
              {
                groupId: "86642568",
                addonId: "72640317",
              },
              {
                groupId: "86642568",
                addonId: "72640318",
              },
              {
                groupId: "86642568",
                addonId: "72640319",
              },
              {
                groupId: "86642568",
                addonId: "72640320",
              },
              {
                groupId: "86642568",
                addonId: "72640321",
              },
              {
                groupId: "86642568",
                addonId: "72640322",
              },
              {
                groupId: "86642568",
                addonId: "72640323",
              },
              {
                groupId: "86642568",
                addonId: "72640324",
              },
              {
                groupId: "86642568",
                addonId: "72640325",
              },
              {
                groupId: "86642568",
                addonId: "72640326",
              },
              {
                groupId: "86642568",
                addonId: "72640327",
              },
              {
                groupId: "86642568",
                addonId: "72640328",
              },
              {
                groupId: "86642568",
                addonId: "72640329",
              },
              {
                groupId: "86642568",
                addonId: "72640330",
              },
              {
                groupId: "86642568",
                addonId: "72640331",
              },
              {
                groupId: "86642568",
                addonId: "72640332",
              },
              {
                groupId: "86642568",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353471",
              },
              {
                groupId: "26569796",
                variationId: "84353474",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642568",
                addonId: "72640314",
              },
              {
                groupId: "86642568",
                addonId: "72640315",
              },
              {
                groupId: "86642568",
                addonId: "72640316",
              },
              {
                groupId: "86642568",
                addonId: "72640317",
              },
              {
                groupId: "86642568",
                addonId: "72640318",
              },
              {
                groupId: "86642568",
                addonId: "72640319",
              },
              {
                groupId: "86642568",
                addonId: "72640320",
              },
              {
                groupId: "86642568",
                addonId: "72640321",
              },
              {
                groupId: "86642568",
                addonId: "72640322",
              },
              {
                groupId: "86642568",
                addonId: "72640323",
              },
              {
                groupId: "86642568",
                addonId: "72640324",
              },
              {
                groupId: "86642568",
                addonId: "72640325",
              },
              {
                groupId: "86642568",
                addonId: "72640326",
              },
              {
                groupId: "86642568",
                addonId: "72640327",
              },
              {
                groupId: "86642568",
                addonId: "72640328",
              },
              {
                groupId: "86642568",
                addonId: "72640329",
              },
              {
                groupId: "86642568",
                addonId: "72640330",
              },
              {
                groupId: "86642568",
                addonId: "72640331",
              },
              {
                groupId: "86642568",
                addonId: "72640332",
              },
              {
                groupId: "86642568",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353471",
              },
              {
                groupId: "26569796",
                variationId: "84353475",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642568",
                addonId: "72640314",
              },
              {
                groupId: "86642568",
                addonId: "72640315",
              },
              {
                groupId: "86642568",
                addonId: "72640316",
              },
              {
                groupId: "86642568",
                addonId: "72640317",
              },
              {
                groupId: "86642568",
                addonId: "72640318",
              },
              {
                groupId: "86642568",
                addonId: "72640319",
              },
              {
                groupId: "86642568",
                addonId: "72640320",
              },
              {
                groupId: "86642568",
                addonId: "72640321",
              },
              {
                groupId: "86642568",
                addonId: "72640322",
              },
              {
                groupId: "86642568",
                addonId: "72640323",
              },
              {
                groupId: "86642568",
                addonId: "72640324",
              },
              {
                groupId: "86642568",
                addonId: "72640325",
              },
              {
                groupId: "86642568",
                addonId: "72640326",
              },
              {
                groupId: "86642568",
                addonId: "72640327",
              },
              {
                groupId: "86642568",
                addonId: "72640328",
              },
              {
                groupId: "86642568",
                addonId: "72640329",
              },
              {
                groupId: "86642568",
                addonId: "72640330",
              },
              {
                groupId: "86642568",
                addonId: "72640331",
              },
              {
                groupId: "86642568",
                addonId: "72640332",
              },
              {
                groupId: "86642568",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353471",
              },
              {
                groupId: "26569796",
                variationId: "84353476",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642568",
                addonId: "72640314",
              },
              {
                groupId: "86642568",
                addonId: "72640315",
              },
              {
                groupId: "86642568",
                addonId: "72640316",
              },
              {
                groupId: "86642568",
                addonId: "72640317",
              },
              {
                groupId: "86642568",
                addonId: "72640318",
              },
              {
                groupId: "86642568",
                addonId: "72640319",
              },
              {
                groupId: "86642568",
                addonId: "72640320",
              },
              {
                groupId: "86642568",
                addonId: "72640321",
              },
              {
                groupId: "86642568",
                addonId: "72640322",
              },
              {
                groupId: "86642568",
                addonId: "72640323",
              },
              {
                groupId: "86642568",
                addonId: "72640324",
              },
              {
                groupId: "86642568",
                addonId: "72640325",
              },
              {
                groupId: "86642568",
                addonId: "72640326",
              },
              {
                groupId: "86642568",
                addonId: "72640327",
              },
              {
                groupId: "86642568",
                addonId: "72640328",
              },
              {
                groupId: "86642568",
                addonId: "72640329",
              },
              {
                groupId: "86642568",
                addonId: "72640330",
              },
              {
                groupId: "86642568",
                addonId: "72640331",
              },
              {
                groupId: "86642568",
                addonId: "72640332",
              },
              {
                groupId: "86642568",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353471",
              },
              {
                groupId: "26569796",
                variationId: "84353477",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642568",
                addonId: "72640314",
              },
              {
                groupId: "86642568",
                addonId: "72640315",
              },
              {
                groupId: "86642568",
                addonId: "72640316",
              },
              {
                groupId: "86642568",
                addonId: "72640317",
              },
              {
                groupId: "86642568",
                addonId: "72640318",
              },
              {
                groupId: "86642568",
                addonId: "72640319",
              },
              {
                groupId: "86642568",
                addonId: "72640320",
              },
              {
                groupId: "86642568",
                addonId: "72640321",
              },
              {
                groupId: "86642568",
                addonId: "72640322",
              },
              {
                groupId: "86642568",
                addonId: "72640323",
              },
              {
                groupId: "86642568",
                addonId: "72640324",
              },
              {
                groupId: "86642568",
                addonId: "72640325",
              },
              {
                groupId: "86642568",
                addonId: "72640326",
              },
              {
                groupId: "86642568",
                addonId: "72640327",
              },
              {
                groupId: "86642568",
                addonId: "72640328",
              },
              {
                groupId: "86642568",
                addonId: "72640329",
              },
              {
                groupId: "86642568",
                addonId: "72640330",
              },
              {
                groupId: "86642568",
                addonId: "72640331",
              },
              {
                groupId: "86642568",
                addonId: "72640332",
              },
              {
                groupId: "86642568",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353472",
              },
              {
                groupId: "26569796",
                variationId: "84353478",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642570",
                addonId: "72640334",
              },
              {
                groupId: "86642570",
                addonId: "72640335",
              },
              {
                groupId: "86642570",
                addonId: "72640336",
              },
              {
                groupId: "86642570",
                addonId: "72640337",
              },
              {
                groupId: "86642570",
                addonId: "72640338",
              },
              {
                groupId: "86642570",
                addonId: "72640339",
              },
              {
                groupId: "86642570",
                addonId: "72640340",
              },
              {
                groupId: "86642570",
                addonId: "72640341",
              },
              {
                groupId: "86642570",
                addonId: "72640342",
              },
              {
                groupId: "86642570",
                addonId: "72640343",
              },
              {
                groupId: "86642570",
                addonId: "72640344",
              },
              {
                groupId: "86642570",
                addonId: "72640345",
              },
              {
                groupId: "86642570",
                addonId: "72640346",
              },
              {
                groupId: "86642570",
                addonId: "72640347",
              },
              {
                groupId: "86642570",
                addonId: "72640348",
              },
              {
                groupId: "86642570",
                addonId: "72640349",
              },
              {
                groupId: "86642570",
                addonId: "72640350",
              },
              {
                groupId: "86642570",
                addonId: "72640351",
              },
              {
                groupId: "86642570",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353472",
              },
              {
                groupId: "26569796",
                variationId: "84353479",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642570",
                addonId: "72640334",
              },
              {
                groupId: "86642570",
                addonId: "72640335",
              },
              {
                groupId: "86642570",
                addonId: "72640336",
              },
              {
                groupId: "86642570",
                addonId: "72640337",
              },
              {
                groupId: "86642570",
                addonId: "72640338",
              },
              {
                groupId: "86642570",
                addonId: "72640339",
              },
              {
                groupId: "86642570",
                addonId: "72640340",
              },
              {
                groupId: "86642570",
                addonId: "72640341",
              },
              {
                groupId: "86642570",
                addonId: "72640342",
              },
              {
                groupId: "86642570",
                addonId: "72640343",
              },
              {
                groupId: "86642570",
                addonId: "72640344",
              },
              {
                groupId: "86642570",
                addonId: "72640345",
              },
              {
                groupId: "86642570",
                addonId: "72640346",
              },
              {
                groupId: "86642570",
                addonId: "72640347",
              },
              {
                groupId: "86642570",
                addonId: "72640348",
              },
              {
                groupId: "86642570",
                addonId: "72640349",
              },
              {
                groupId: "86642570",
                addonId: "72640350",
              },
              {
                groupId: "86642570",
                addonId: "72640351",
              },
              {
                groupId: "86642570",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353472",
              },
              {
                groupId: "26569796",
                variationId: "84353480",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642570",
                addonId: "72640334",
              },
              {
                groupId: "86642570",
                addonId: "72640335",
              },
              {
                groupId: "86642570",
                addonId: "72640336",
              },
              {
                groupId: "86642570",
                addonId: "72640337",
              },
              {
                groupId: "86642570",
                addonId: "72640338",
              },
              {
                groupId: "86642570",
                addonId: "72640339",
              },
              {
                groupId: "86642570",
                addonId: "72640340",
              },
              {
                groupId: "86642570",
                addonId: "72640341",
              },
              {
                groupId: "86642570",
                addonId: "72640342",
              },
              {
                groupId: "86642570",
                addonId: "72640343",
              },
              {
                groupId: "86642570",
                addonId: "72640344",
              },
              {
                groupId: "86642570",
                addonId: "72640345",
              },
              {
                groupId: "86642570",
                addonId: "72640346",
              },
              {
                groupId: "86642570",
                addonId: "72640347",
              },
              {
                groupId: "86642570",
                addonId: "72640348",
              },
              {
                groupId: "86642570",
                addonId: "72640349",
              },
              {
                groupId: "86642570",
                addonId: "72640350",
              },
              {
                groupId: "86642570",
                addonId: "72640351",
              },
              {
                groupId: "86642570",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353472",
              },
              {
                groupId: "26569796",
                variationId: "84353482",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642570",
                addonId: "72640334",
              },
              {
                groupId: "86642570",
                addonId: "72640335",
              },
              {
                groupId: "86642570",
                addonId: "72640336",
              },
              {
                groupId: "86642570",
                addonId: "72640337",
              },
              {
                groupId: "86642570",
                addonId: "72640338",
              },
              {
                groupId: "86642570",
                addonId: "72640339",
              },
              {
                groupId: "86642570",
                addonId: "72640340",
              },
              {
                groupId: "86642570",
                addonId: "72640341",
              },
              {
                groupId: "86642570",
                addonId: "72640342",
              },
              {
                groupId: "86642570",
                addonId: "72640343",
              },
              {
                groupId: "86642570",
                addonId: "72640344",
              },
              {
                groupId: "86642570",
                addonId: "72640345",
              },
              {
                groupId: "86642570",
                addonId: "72640346",
              },
              {
                groupId: "86642570",
                addonId: "72640347",
              },
              {
                groupId: "86642570",
                addonId: "72640348",
              },
              {
                groupId: "86642570",
                addonId: "72640349",
              },
              {
                groupId: "86642570",
                addonId: "72640350",
              },
              {
                groupId: "86642570",
                addonId: "72640351",
              },
              {
                groupId: "86642570",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569795",
                variationId: "84353472",
              },
              {
                groupId: "26569796",
                variationId: "84353484",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642570",
                addonId: "72640334",
              },
              {
                groupId: "86642570",
                addonId: "72640335",
              },
              {
                groupId: "86642570",
                addonId: "72640336",
              },
              {
                groupId: "86642570",
                addonId: "72640337",
              },
              {
                groupId: "86642570",
                addonId: "72640338",
              },
              {
                groupId: "86642570",
                addonId: "72640339",
              },
              {
                groupId: "86642570",
                addonId: "72640340",
              },
              {
                groupId: "86642570",
                addonId: "72640341",
              },
              {
                groupId: "86642570",
                addonId: "72640342",
              },
              {
                groupId: "86642570",
                addonId: "72640343",
              },
              {
                groupId: "86642570",
                addonId: "72640344",
              },
              {
                groupId: "86642570",
                addonId: "72640345",
              },
              {
                groupId: "86642570",
                addonId: "72640346",
              },
              {
                groupId: "86642570",
                addonId: "72640347",
              },
              {
                groupId: "86642570",
                addonId: "72640348",
              },
              {
                groupId: "86642570",
                addonId: "72640349",
              },
              {
                groupId: "86642570",
                addonId: "72640350",
              },
              {
                groupId: "86642570",
                addonId: "72640351",
              },
              {
                groupId: "86642570",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642570",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642568",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "72275891",
      name: "Italian Chicken Feast",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Juicy Chicken n Cheese Sausage, yummy Chicken Pepperoni, juicy Sweet Corn, Black Olive & spicy Jalapeno with flavourful pan sauce and 100% Mozzarella cheese.",
      imageId: "vn50jmkd5nalg83ystso",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569811",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84353567",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569812",
                  variationId: "84353569",
                },
              },
              {
                name: "Medium",
                id: "84353568",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569812",
                  variationId: "84353574",
                },
              },
            ],
          },
          {
            groupId: "26569812",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 409,
                default: 1,
                id: "84353569",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 409,
                id: "84353570",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 429,
                id: "84353571",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 484,
                id: "84353572",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 484,
                id: "84353573",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 699,
                id: "84353574",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 699,
                id: "84353575",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 729,
                id: "84353576",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 798,
                id: "84353577",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 798,
                id: "84353578",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353567",
              },
              {
                groupId: "26569812",
                variationId: "84353569",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642584",
                addonId: "72640314",
              },
              {
                groupId: "86642584",
                addonId: "72640315",
              },
              {
                groupId: "86642584",
                addonId: "72640316",
              },
              {
                groupId: "86642584",
                addonId: "72640317",
              },
              {
                groupId: "86642584",
                addonId: "72640318",
              },
              {
                groupId: "86642584",
                addonId: "72640319",
              },
              {
                groupId: "86642584",
                addonId: "72640320",
              },
              {
                groupId: "86642584",
                addonId: "72640321",
              },
              {
                groupId: "86642584",
                addonId: "72640322",
              },
              {
                groupId: "86642584",
                addonId: "72640323",
              },
              {
                groupId: "86642584",
                addonId: "72640324",
              },
              {
                groupId: "86642584",
                addonId: "72640325",
              },
              {
                groupId: "86642584",
                addonId: "72640326",
              },
              {
                groupId: "86642584",
                addonId: "72640327",
              },
              {
                groupId: "86642584",
                addonId: "72640328",
              },
              {
                groupId: "86642584",
                addonId: "72640329",
              },
              {
                groupId: "86642584",
                addonId: "72640330",
              },
              {
                groupId: "86642584",
                addonId: "72640331",
              },
              {
                groupId: "86642584",
                addonId: "72640332",
              },
              {
                groupId: "86642584",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353567",
              },
              {
                groupId: "26569812",
                variationId: "84353570",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642584",
                addonId: "72640314",
              },
              {
                groupId: "86642584",
                addonId: "72640315",
              },
              {
                groupId: "86642584",
                addonId: "72640316",
              },
              {
                groupId: "86642584",
                addonId: "72640317",
              },
              {
                groupId: "86642584",
                addonId: "72640318",
              },
              {
                groupId: "86642584",
                addonId: "72640319",
              },
              {
                groupId: "86642584",
                addonId: "72640320",
              },
              {
                groupId: "86642584",
                addonId: "72640321",
              },
              {
                groupId: "86642584",
                addonId: "72640322",
              },
              {
                groupId: "86642584",
                addonId: "72640323",
              },
              {
                groupId: "86642584",
                addonId: "72640324",
              },
              {
                groupId: "86642584",
                addonId: "72640325",
              },
              {
                groupId: "86642584",
                addonId: "72640326",
              },
              {
                groupId: "86642584",
                addonId: "72640327",
              },
              {
                groupId: "86642584",
                addonId: "72640328",
              },
              {
                groupId: "86642584",
                addonId: "72640329",
              },
              {
                groupId: "86642584",
                addonId: "72640330",
              },
              {
                groupId: "86642584",
                addonId: "72640331",
              },
              {
                groupId: "86642584",
                addonId: "72640332",
              },
              {
                groupId: "86642584",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353567",
              },
              {
                groupId: "26569812",
                variationId: "84353571",
              },
            ],
            price: 42900,
            addonCombinations: [
              {
                groupId: "86642584",
                addonId: "72640314",
              },
              {
                groupId: "86642584",
                addonId: "72640315",
              },
              {
                groupId: "86642584",
                addonId: "72640316",
              },
              {
                groupId: "86642584",
                addonId: "72640317",
              },
              {
                groupId: "86642584",
                addonId: "72640318",
              },
              {
                groupId: "86642584",
                addonId: "72640319",
              },
              {
                groupId: "86642584",
                addonId: "72640320",
              },
              {
                groupId: "86642584",
                addonId: "72640321",
              },
              {
                groupId: "86642584",
                addonId: "72640322",
              },
              {
                groupId: "86642584",
                addonId: "72640323",
              },
              {
                groupId: "86642584",
                addonId: "72640324",
              },
              {
                groupId: "86642584",
                addonId: "72640325",
              },
              {
                groupId: "86642584",
                addonId: "72640326",
              },
              {
                groupId: "86642584",
                addonId: "72640327",
              },
              {
                groupId: "86642584",
                addonId: "72640328",
              },
              {
                groupId: "86642584",
                addonId: "72640329",
              },
              {
                groupId: "86642584",
                addonId: "72640330",
              },
              {
                groupId: "86642584",
                addonId: "72640331",
              },
              {
                groupId: "86642584",
                addonId: "72640332",
              },
              {
                groupId: "86642584",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353567",
              },
              {
                groupId: "26569812",
                variationId: "84353572",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642584",
                addonId: "72640314",
              },
              {
                groupId: "86642584",
                addonId: "72640315",
              },
              {
                groupId: "86642584",
                addonId: "72640316",
              },
              {
                groupId: "86642584",
                addonId: "72640317",
              },
              {
                groupId: "86642584",
                addonId: "72640318",
              },
              {
                groupId: "86642584",
                addonId: "72640319",
              },
              {
                groupId: "86642584",
                addonId: "72640320",
              },
              {
                groupId: "86642584",
                addonId: "72640321",
              },
              {
                groupId: "86642584",
                addonId: "72640322",
              },
              {
                groupId: "86642584",
                addonId: "72640323",
              },
              {
                groupId: "86642584",
                addonId: "72640324",
              },
              {
                groupId: "86642584",
                addonId: "72640325",
              },
              {
                groupId: "86642584",
                addonId: "72640326",
              },
              {
                groupId: "86642584",
                addonId: "72640327",
              },
              {
                groupId: "86642584",
                addonId: "72640328",
              },
              {
                groupId: "86642584",
                addonId: "72640329",
              },
              {
                groupId: "86642584",
                addonId: "72640330",
              },
              {
                groupId: "86642584",
                addonId: "72640331",
              },
              {
                groupId: "86642584",
                addonId: "72640332",
              },
              {
                groupId: "86642584",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353567",
              },
              {
                groupId: "26569812",
                variationId: "84353573",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642584",
                addonId: "72640314",
              },
              {
                groupId: "86642584",
                addonId: "72640315",
              },
              {
                groupId: "86642584",
                addonId: "72640316",
              },
              {
                groupId: "86642584",
                addonId: "72640317",
              },
              {
                groupId: "86642584",
                addonId: "72640318",
              },
              {
                groupId: "86642584",
                addonId: "72640319",
              },
              {
                groupId: "86642584",
                addonId: "72640320",
              },
              {
                groupId: "86642584",
                addonId: "72640321",
              },
              {
                groupId: "86642584",
                addonId: "72640322",
              },
              {
                groupId: "86642584",
                addonId: "72640323",
              },
              {
                groupId: "86642584",
                addonId: "72640324",
              },
              {
                groupId: "86642584",
                addonId: "72640325",
              },
              {
                groupId: "86642584",
                addonId: "72640326",
              },
              {
                groupId: "86642584",
                addonId: "72640327",
              },
              {
                groupId: "86642584",
                addonId: "72640328",
              },
              {
                groupId: "86642584",
                addonId: "72640329",
              },
              {
                groupId: "86642584",
                addonId: "72640330",
              },
              {
                groupId: "86642584",
                addonId: "72640331",
              },
              {
                groupId: "86642584",
                addonId: "72640332",
              },
              {
                groupId: "86642584",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353568",
              },
              {
                groupId: "26569812",
                variationId: "84353574",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642587",
                addonId: "72640334",
              },
              {
                groupId: "86642587",
                addonId: "72640335",
              },
              {
                groupId: "86642587",
                addonId: "72640336",
              },
              {
                groupId: "86642587",
                addonId: "72640337",
              },
              {
                groupId: "86642587",
                addonId: "72640338",
              },
              {
                groupId: "86642587",
                addonId: "72640339",
              },
              {
                groupId: "86642587",
                addonId: "72640340",
              },
              {
                groupId: "86642587",
                addonId: "72640341",
              },
              {
                groupId: "86642587",
                addonId: "72640342",
              },
              {
                groupId: "86642587",
                addonId: "72640343",
              },
              {
                groupId: "86642587",
                addonId: "72640344",
              },
              {
                groupId: "86642587",
                addonId: "72640345",
              },
              {
                groupId: "86642587",
                addonId: "72640346",
              },
              {
                groupId: "86642587",
                addonId: "72640347",
              },
              {
                groupId: "86642587",
                addonId: "72640348",
              },
              {
                groupId: "86642587",
                addonId: "72640349",
              },
              {
                groupId: "86642587",
                addonId: "72640350",
              },
              {
                groupId: "86642587",
                addonId: "72640351",
              },
              {
                groupId: "86642587",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353568",
              },
              {
                groupId: "26569812",
                variationId: "84353575",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642587",
                addonId: "72640334",
              },
              {
                groupId: "86642587",
                addonId: "72640335",
              },
              {
                groupId: "86642587",
                addonId: "72640336",
              },
              {
                groupId: "86642587",
                addonId: "72640337",
              },
              {
                groupId: "86642587",
                addonId: "72640338",
              },
              {
                groupId: "86642587",
                addonId: "72640339",
              },
              {
                groupId: "86642587",
                addonId: "72640340",
              },
              {
                groupId: "86642587",
                addonId: "72640341",
              },
              {
                groupId: "86642587",
                addonId: "72640342",
              },
              {
                groupId: "86642587",
                addonId: "72640343",
              },
              {
                groupId: "86642587",
                addonId: "72640344",
              },
              {
                groupId: "86642587",
                addonId: "72640345",
              },
              {
                groupId: "86642587",
                addonId: "72640346",
              },
              {
                groupId: "86642587",
                addonId: "72640347",
              },
              {
                groupId: "86642587",
                addonId: "72640348",
              },
              {
                groupId: "86642587",
                addonId: "72640349",
              },
              {
                groupId: "86642587",
                addonId: "72640350",
              },
              {
                groupId: "86642587",
                addonId: "72640351",
              },
              {
                groupId: "86642587",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353568",
              },
              {
                groupId: "26569812",
                variationId: "84353576",
              },
            ],
            price: 72900,
            addonCombinations: [
              {
                groupId: "86642587",
                addonId: "72640334",
              },
              {
                groupId: "86642587",
                addonId: "72640335",
              },
              {
                groupId: "86642587",
                addonId: "72640336",
              },
              {
                groupId: "86642587",
                addonId: "72640337",
              },
              {
                groupId: "86642587",
                addonId: "72640338",
              },
              {
                groupId: "86642587",
                addonId: "72640339",
              },
              {
                groupId: "86642587",
                addonId: "72640340",
              },
              {
                groupId: "86642587",
                addonId: "72640341",
              },
              {
                groupId: "86642587",
                addonId: "72640342",
              },
              {
                groupId: "86642587",
                addonId: "72640343",
              },
              {
                groupId: "86642587",
                addonId: "72640344",
              },
              {
                groupId: "86642587",
                addonId: "72640345",
              },
              {
                groupId: "86642587",
                addonId: "72640346",
              },
              {
                groupId: "86642587",
                addonId: "72640347",
              },
              {
                groupId: "86642587",
                addonId: "72640348",
              },
              {
                groupId: "86642587",
                addonId: "72640349",
              },
              {
                groupId: "86642587",
                addonId: "72640350",
              },
              {
                groupId: "86642587",
                addonId: "72640351",
              },
              {
                groupId: "86642587",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353568",
              },
              {
                groupId: "26569812",
                variationId: "84353577",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642587",
                addonId: "72640334",
              },
              {
                groupId: "86642587",
                addonId: "72640335",
              },
              {
                groupId: "86642587",
                addonId: "72640336",
              },
              {
                groupId: "86642587",
                addonId: "72640337",
              },
              {
                groupId: "86642587",
                addonId: "72640338",
              },
              {
                groupId: "86642587",
                addonId: "72640339",
              },
              {
                groupId: "86642587",
                addonId: "72640340",
              },
              {
                groupId: "86642587",
                addonId: "72640341",
              },
              {
                groupId: "86642587",
                addonId: "72640342",
              },
              {
                groupId: "86642587",
                addonId: "72640343",
              },
              {
                groupId: "86642587",
                addonId: "72640344",
              },
              {
                groupId: "86642587",
                addonId: "72640345",
              },
              {
                groupId: "86642587",
                addonId: "72640346",
              },
              {
                groupId: "86642587",
                addonId: "72640347",
              },
              {
                groupId: "86642587",
                addonId: "72640348",
              },
              {
                groupId: "86642587",
                addonId: "72640349",
              },
              {
                groupId: "86642587",
                addonId: "72640350",
              },
              {
                groupId: "86642587",
                addonId: "72640351",
              },
              {
                groupId: "86642587",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569811",
                variationId: "84353568",
              },
              {
                groupId: "26569812",
                variationId: "84353578",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642587",
                addonId: "72640334",
              },
              {
                groupId: "86642587",
                addonId: "72640335",
              },
              {
                groupId: "86642587",
                addonId: "72640336",
              },
              {
                groupId: "86642587",
                addonId: "72640337",
              },
              {
                groupId: "86642587",
                addonId: "72640338",
              },
              {
                groupId: "86642587",
                addonId: "72640339",
              },
              {
                groupId: "86642587",
                addonId: "72640340",
              },
              {
                groupId: "86642587",
                addonId: "72640341",
              },
              {
                groupId: "86642587",
                addonId: "72640342",
              },
              {
                groupId: "86642587",
                addonId: "72640343",
              },
              {
                groupId: "86642587",
                addonId: "72640344",
              },
              {
                groupId: "86642587",
                addonId: "72640345",
              },
              {
                groupId: "86642587",
                addonId: "72640346",
              },
              {
                groupId: "86642587",
                addonId: "72640347",
              },
              {
                groupId: "86642587",
                addonId: "72640348",
              },
              {
                groupId: "86642587",
                addonId: "72640349",
              },
              {
                groupId: "86642587",
                addonId: "72640350",
              },
              {
                groupId: "86642587",
                addonId: "72640351",
              },
              {
                groupId: "86642587",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642587",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642584",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 40900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "72275906",
      name: "Malai Chicken Tikka",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Amazingly flavourful Chicken Malai Tikka, Herbed Onion & Green Capsicum, spicy Red Paprika with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "t1stinhga3alitdpr6yt",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569824",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84353625",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569825",
                  variationId: "84353631",
                },
              },
              {
                name: "Medium",
                id: "84353628",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569825",
                  variationId: "84353642",
                },
              },
            ],
          },
          {
            groupId: "26569825",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84353631",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84353633",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84353636",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 454,
                id: "84353638",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84353640",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84353642",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84353643",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84353644",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 738,
                id: "84353646",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84353648",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353625",
              },
              {
                groupId: "26569825",
                variationId: "84353631",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642594",
                addonId: "72640314",
              },
              {
                groupId: "86642594",
                addonId: "72640315",
              },
              {
                groupId: "86642594",
                addonId: "72640316",
              },
              {
                groupId: "86642594",
                addonId: "72640317",
              },
              {
                groupId: "86642594",
                addonId: "72640318",
              },
              {
                groupId: "86642594",
                addonId: "72640319",
              },
              {
                groupId: "86642594",
                addonId: "72640320",
              },
              {
                groupId: "86642594",
                addonId: "72640321",
              },
              {
                groupId: "86642594",
                addonId: "72640322",
              },
              {
                groupId: "86642594",
                addonId: "72640323",
              },
              {
                groupId: "86642594",
                addonId: "72640324",
              },
              {
                groupId: "86642594",
                addonId: "72640325",
              },
              {
                groupId: "86642594",
                addonId: "72640326",
              },
              {
                groupId: "86642594",
                addonId: "72640327",
              },
              {
                groupId: "86642594",
                addonId: "72640328",
              },
              {
                groupId: "86642594",
                addonId: "72640329",
              },
              {
                groupId: "86642594",
                addonId: "72640330",
              },
              {
                groupId: "86642594",
                addonId: "72640331",
              },
              {
                groupId: "86642594",
                addonId: "72640332",
              },
              {
                groupId: "86642594",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353625",
              },
              {
                groupId: "26569825",
                variationId: "84353633",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642594",
                addonId: "72640314",
              },
              {
                groupId: "86642594",
                addonId: "72640315",
              },
              {
                groupId: "86642594",
                addonId: "72640316",
              },
              {
                groupId: "86642594",
                addonId: "72640317",
              },
              {
                groupId: "86642594",
                addonId: "72640318",
              },
              {
                groupId: "86642594",
                addonId: "72640319",
              },
              {
                groupId: "86642594",
                addonId: "72640320",
              },
              {
                groupId: "86642594",
                addonId: "72640321",
              },
              {
                groupId: "86642594",
                addonId: "72640322",
              },
              {
                groupId: "86642594",
                addonId: "72640323",
              },
              {
                groupId: "86642594",
                addonId: "72640324",
              },
              {
                groupId: "86642594",
                addonId: "72640325",
              },
              {
                groupId: "86642594",
                addonId: "72640326",
              },
              {
                groupId: "86642594",
                addonId: "72640327",
              },
              {
                groupId: "86642594",
                addonId: "72640328",
              },
              {
                groupId: "86642594",
                addonId: "72640329",
              },
              {
                groupId: "86642594",
                addonId: "72640330",
              },
              {
                groupId: "86642594",
                addonId: "72640331",
              },
              {
                groupId: "86642594",
                addonId: "72640332",
              },
              {
                groupId: "86642594",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353625",
              },
              {
                groupId: "26569825",
                variationId: "84353636",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642594",
                addonId: "72640314",
              },
              {
                groupId: "86642594",
                addonId: "72640315",
              },
              {
                groupId: "86642594",
                addonId: "72640316",
              },
              {
                groupId: "86642594",
                addonId: "72640317",
              },
              {
                groupId: "86642594",
                addonId: "72640318",
              },
              {
                groupId: "86642594",
                addonId: "72640319",
              },
              {
                groupId: "86642594",
                addonId: "72640320",
              },
              {
                groupId: "86642594",
                addonId: "72640321",
              },
              {
                groupId: "86642594",
                addonId: "72640322",
              },
              {
                groupId: "86642594",
                addonId: "72640323",
              },
              {
                groupId: "86642594",
                addonId: "72640324",
              },
              {
                groupId: "86642594",
                addonId: "72640325",
              },
              {
                groupId: "86642594",
                addonId: "72640326",
              },
              {
                groupId: "86642594",
                addonId: "72640327",
              },
              {
                groupId: "86642594",
                addonId: "72640328",
              },
              {
                groupId: "86642594",
                addonId: "72640329",
              },
              {
                groupId: "86642594",
                addonId: "72640330",
              },
              {
                groupId: "86642594",
                addonId: "72640331",
              },
              {
                groupId: "86642594",
                addonId: "72640332",
              },
              {
                groupId: "86642594",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353625",
              },
              {
                groupId: "26569825",
                variationId: "84353638",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642594",
                addonId: "72640314",
              },
              {
                groupId: "86642594",
                addonId: "72640315",
              },
              {
                groupId: "86642594",
                addonId: "72640316",
              },
              {
                groupId: "86642594",
                addonId: "72640317",
              },
              {
                groupId: "86642594",
                addonId: "72640318",
              },
              {
                groupId: "86642594",
                addonId: "72640319",
              },
              {
                groupId: "86642594",
                addonId: "72640320",
              },
              {
                groupId: "86642594",
                addonId: "72640321",
              },
              {
                groupId: "86642594",
                addonId: "72640322",
              },
              {
                groupId: "86642594",
                addonId: "72640323",
              },
              {
                groupId: "86642594",
                addonId: "72640324",
              },
              {
                groupId: "86642594",
                addonId: "72640325",
              },
              {
                groupId: "86642594",
                addonId: "72640326",
              },
              {
                groupId: "86642594",
                addonId: "72640327",
              },
              {
                groupId: "86642594",
                addonId: "72640328",
              },
              {
                groupId: "86642594",
                addonId: "72640329",
              },
              {
                groupId: "86642594",
                addonId: "72640330",
              },
              {
                groupId: "86642594",
                addonId: "72640331",
              },
              {
                groupId: "86642594",
                addonId: "72640332",
              },
              {
                groupId: "86642594",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353625",
              },
              {
                groupId: "26569825",
                variationId: "84353640",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642594",
                addonId: "72640314",
              },
              {
                groupId: "86642594",
                addonId: "72640315",
              },
              {
                groupId: "86642594",
                addonId: "72640316",
              },
              {
                groupId: "86642594",
                addonId: "72640317",
              },
              {
                groupId: "86642594",
                addonId: "72640318",
              },
              {
                groupId: "86642594",
                addonId: "72640319",
              },
              {
                groupId: "86642594",
                addonId: "72640320",
              },
              {
                groupId: "86642594",
                addonId: "72640321",
              },
              {
                groupId: "86642594",
                addonId: "72640322",
              },
              {
                groupId: "86642594",
                addonId: "72640323",
              },
              {
                groupId: "86642594",
                addonId: "72640324",
              },
              {
                groupId: "86642594",
                addonId: "72640325",
              },
              {
                groupId: "86642594",
                addonId: "72640326",
              },
              {
                groupId: "86642594",
                addonId: "72640327",
              },
              {
                groupId: "86642594",
                addonId: "72640328",
              },
              {
                groupId: "86642594",
                addonId: "72640329",
              },
              {
                groupId: "86642594",
                addonId: "72640330",
              },
              {
                groupId: "86642594",
                addonId: "72640331",
              },
              {
                groupId: "86642594",
                addonId: "72640332",
              },
              {
                groupId: "86642594",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353628",
              },
              {
                groupId: "26569825",
                variationId: "84353642",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642598",
                addonId: "72640334",
              },
              {
                groupId: "86642598",
                addonId: "72640335",
              },
              {
                groupId: "86642598",
                addonId: "72640336",
              },
              {
                groupId: "86642598",
                addonId: "72640337",
              },
              {
                groupId: "86642598",
                addonId: "72640338",
              },
              {
                groupId: "86642598",
                addonId: "72640339",
              },
              {
                groupId: "86642598",
                addonId: "72640340",
              },
              {
                groupId: "86642598",
                addonId: "72640341",
              },
              {
                groupId: "86642598",
                addonId: "72640342",
              },
              {
                groupId: "86642598",
                addonId: "72640343",
              },
              {
                groupId: "86642598",
                addonId: "72640344",
              },
              {
                groupId: "86642598",
                addonId: "72640345",
              },
              {
                groupId: "86642598",
                addonId: "72640346",
              },
              {
                groupId: "86642598",
                addonId: "72640347",
              },
              {
                groupId: "86642598",
                addonId: "72640348",
              },
              {
                groupId: "86642598",
                addonId: "72640349",
              },
              {
                groupId: "86642598",
                addonId: "72640350",
              },
              {
                groupId: "86642598",
                addonId: "72640351",
              },
              {
                groupId: "86642598",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353628",
              },
              {
                groupId: "26569825",
                variationId: "84353643",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642598",
                addonId: "72640334",
              },
              {
                groupId: "86642598",
                addonId: "72640335",
              },
              {
                groupId: "86642598",
                addonId: "72640336",
              },
              {
                groupId: "86642598",
                addonId: "72640337",
              },
              {
                groupId: "86642598",
                addonId: "72640338",
              },
              {
                groupId: "86642598",
                addonId: "72640339",
              },
              {
                groupId: "86642598",
                addonId: "72640340",
              },
              {
                groupId: "86642598",
                addonId: "72640341",
              },
              {
                groupId: "86642598",
                addonId: "72640342",
              },
              {
                groupId: "86642598",
                addonId: "72640343",
              },
              {
                groupId: "86642598",
                addonId: "72640344",
              },
              {
                groupId: "86642598",
                addonId: "72640345",
              },
              {
                groupId: "86642598",
                addonId: "72640346",
              },
              {
                groupId: "86642598",
                addonId: "72640347",
              },
              {
                groupId: "86642598",
                addonId: "72640348",
              },
              {
                groupId: "86642598",
                addonId: "72640349",
              },
              {
                groupId: "86642598",
                addonId: "72640350",
              },
              {
                groupId: "86642598",
                addonId: "72640351",
              },
              {
                groupId: "86642598",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353628",
              },
              {
                groupId: "26569825",
                variationId: "84353644",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642598",
                addonId: "72640334",
              },
              {
                groupId: "86642598",
                addonId: "72640335",
              },
              {
                groupId: "86642598",
                addonId: "72640336",
              },
              {
                groupId: "86642598",
                addonId: "72640337",
              },
              {
                groupId: "86642598",
                addonId: "72640338",
              },
              {
                groupId: "86642598",
                addonId: "72640339",
              },
              {
                groupId: "86642598",
                addonId: "72640340",
              },
              {
                groupId: "86642598",
                addonId: "72640341",
              },
              {
                groupId: "86642598",
                addonId: "72640342",
              },
              {
                groupId: "86642598",
                addonId: "72640343",
              },
              {
                groupId: "86642598",
                addonId: "72640344",
              },
              {
                groupId: "86642598",
                addonId: "72640345",
              },
              {
                groupId: "86642598",
                addonId: "72640346",
              },
              {
                groupId: "86642598",
                addonId: "72640347",
              },
              {
                groupId: "86642598",
                addonId: "72640348",
              },
              {
                groupId: "86642598",
                addonId: "72640349",
              },
              {
                groupId: "86642598",
                addonId: "72640350",
              },
              {
                groupId: "86642598",
                addonId: "72640351",
              },
              {
                groupId: "86642598",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353628",
              },
              {
                groupId: "26569825",
                variationId: "84353646",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642598",
                addonId: "72640334",
              },
              {
                groupId: "86642598",
                addonId: "72640335",
              },
              {
                groupId: "86642598",
                addonId: "72640336",
              },
              {
                groupId: "86642598",
                addonId: "72640337",
              },
              {
                groupId: "86642598",
                addonId: "72640338",
              },
              {
                groupId: "86642598",
                addonId: "72640339",
              },
              {
                groupId: "86642598",
                addonId: "72640340",
              },
              {
                groupId: "86642598",
                addonId: "72640341",
              },
              {
                groupId: "86642598",
                addonId: "72640342",
              },
              {
                groupId: "86642598",
                addonId: "72640343",
              },
              {
                groupId: "86642598",
                addonId: "72640344",
              },
              {
                groupId: "86642598",
                addonId: "72640345",
              },
              {
                groupId: "86642598",
                addonId: "72640346",
              },
              {
                groupId: "86642598",
                addonId: "72640347",
              },
              {
                groupId: "86642598",
                addonId: "72640348",
              },
              {
                groupId: "86642598",
                addonId: "72640349",
              },
              {
                groupId: "86642598",
                addonId: "72640350",
              },
              {
                groupId: "86642598",
                addonId: "72640351",
              },
              {
                groupId: "86642598",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569824",
                variationId: "84353628",
              },
              {
                groupId: "26569825",
                variationId: "84353648",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642598",
                addonId: "72640334",
              },
              {
                groupId: "86642598",
                addonId: "72640335",
              },
              {
                groupId: "86642598",
                addonId: "72640336",
              },
              {
                groupId: "86642598",
                addonId: "72640337",
              },
              {
                groupId: "86642598",
                addonId: "72640338",
              },
              {
                groupId: "86642598",
                addonId: "72640339",
              },
              {
                groupId: "86642598",
                addonId: "72640340",
              },
              {
                groupId: "86642598",
                addonId: "72640341",
              },
              {
                groupId: "86642598",
                addonId: "72640342",
              },
              {
                groupId: "86642598",
                addonId: "72640343",
              },
              {
                groupId: "86642598",
                addonId: "72640344",
              },
              {
                groupId: "86642598",
                addonId: "72640345",
              },
              {
                groupId: "86642598",
                addonId: "72640346",
              },
              {
                groupId: "86642598",
                addonId: "72640347",
              },
              {
                groupId: "86642598",
                addonId: "72640348",
              },
              {
                groupId: "86642598",
                addonId: "72640349",
              },
              {
                groupId: "86642598",
                addonId: "72640350",
              },
              {
                groupId: "86642598",
                addonId: "72640351",
              },
              {
                groupId: "86642598",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642598",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642594",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "72276189",
      name: "Chicken N Corn Delight",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Oh-so-flavourful Herbed Chicken, juicy Sweet Corn, crunchy  Green Capsicum  & 100% mozzarella cheese with classic pan sauce.",
      imageId: "ydm9zbwskvhw1mozn4nd",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570631",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84357770",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570633",
                  variationId: "84357776",
                },
              },
              {
                name: "Medium",
                id: "84357772",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570633",
                  variationId: "84357786",
                },
              },
            ],
          },
          {
            groupId: "26570633",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84357776",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84357779",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 339,
                id: "84357782",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 394,
                id: "84357784",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84357785",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84357786",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84357788",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 599,
                id: "84357790",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 668,
                id: "84357792",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84357793",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357770",
              },
              {
                groupId: "26570633",
                variationId: "84357776",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642946",
                addonId: "72640314",
              },
              {
                groupId: "86642946",
                addonId: "72640315",
              },
              {
                groupId: "86642946",
                addonId: "72640316",
              },
              {
                groupId: "86642946",
                addonId: "72640317",
              },
              {
                groupId: "86642946",
                addonId: "72640318",
              },
              {
                groupId: "86642946",
                addonId: "72640319",
              },
              {
                groupId: "86642946",
                addonId: "72640320",
              },
              {
                groupId: "86642946",
                addonId: "72640321",
              },
              {
                groupId: "86642946",
                addonId: "72640322",
              },
              {
                groupId: "86642946",
                addonId: "72640323",
              },
              {
                groupId: "86642946",
                addonId: "72640324",
              },
              {
                groupId: "86642946",
                addonId: "72640325",
              },
              {
                groupId: "86642946",
                addonId: "72640326",
              },
              {
                groupId: "86642946",
                addonId: "72640327",
              },
              {
                groupId: "86642946",
                addonId: "72640328",
              },
              {
                groupId: "86642946",
                addonId: "72640329",
              },
              {
                groupId: "86642946",
                addonId: "72640330",
              },
              {
                groupId: "86642946",
                addonId: "72640331",
              },
              {
                groupId: "86642946",
                addonId: "72640332",
              },
              {
                groupId: "86642946",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357770",
              },
              {
                groupId: "26570633",
                variationId: "84357779",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642946",
                addonId: "72640314",
              },
              {
                groupId: "86642946",
                addonId: "72640315",
              },
              {
                groupId: "86642946",
                addonId: "72640316",
              },
              {
                groupId: "86642946",
                addonId: "72640317",
              },
              {
                groupId: "86642946",
                addonId: "72640318",
              },
              {
                groupId: "86642946",
                addonId: "72640319",
              },
              {
                groupId: "86642946",
                addonId: "72640320",
              },
              {
                groupId: "86642946",
                addonId: "72640321",
              },
              {
                groupId: "86642946",
                addonId: "72640322",
              },
              {
                groupId: "86642946",
                addonId: "72640323",
              },
              {
                groupId: "86642946",
                addonId: "72640324",
              },
              {
                groupId: "86642946",
                addonId: "72640325",
              },
              {
                groupId: "86642946",
                addonId: "72640326",
              },
              {
                groupId: "86642946",
                addonId: "72640327",
              },
              {
                groupId: "86642946",
                addonId: "72640328",
              },
              {
                groupId: "86642946",
                addonId: "72640329",
              },
              {
                groupId: "86642946",
                addonId: "72640330",
              },
              {
                groupId: "86642946",
                addonId: "72640331",
              },
              {
                groupId: "86642946",
                addonId: "72640332",
              },
              {
                groupId: "86642946",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357770",
              },
              {
                groupId: "26570633",
                variationId: "84357782",
              },
            ],
            price: 33900,
            addonCombinations: [
              {
                groupId: "86642946",
                addonId: "72640314",
              },
              {
                groupId: "86642946",
                addonId: "72640315",
              },
              {
                groupId: "86642946",
                addonId: "72640316",
              },
              {
                groupId: "86642946",
                addonId: "72640317",
              },
              {
                groupId: "86642946",
                addonId: "72640318",
              },
              {
                groupId: "86642946",
                addonId: "72640319",
              },
              {
                groupId: "86642946",
                addonId: "72640320",
              },
              {
                groupId: "86642946",
                addonId: "72640321",
              },
              {
                groupId: "86642946",
                addonId: "72640322",
              },
              {
                groupId: "86642946",
                addonId: "72640323",
              },
              {
                groupId: "86642946",
                addonId: "72640324",
              },
              {
                groupId: "86642946",
                addonId: "72640325",
              },
              {
                groupId: "86642946",
                addonId: "72640326",
              },
              {
                groupId: "86642946",
                addonId: "72640327",
              },
              {
                groupId: "86642946",
                addonId: "72640328",
              },
              {
                groupId: "86642946",
                addonId: "72640329",
              },
              {
                groupId: "86642946",
                addonId: "72640330",
              },
              {
                groupId: "86642946",
                addonId: "72640331",
              },
              {
                groupId: "86642946",
                addonId: "72640332",
              },
              {
                groupId: "86642946",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357770",
              },
              {
                groupId: "26570633",
                variationId: "84357784",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642946",
                addonId: "72640314",
              },
              {
                groupId: "86642946",
                addonId: "72640315",
              },
              {
                groupId: "86642946",
                addonId: "72640316",
              },
              {
                groupId: "86642946",
                addonId: "72640317",
              },
              {
                groupId: "86642946",
                addonId: "72640318",
              },
              {
                groupId: "86642946",
                addonId: "72640319",
              },
              {
                groupId: "86642946",
                addonId: "72640320",
              },
              {
                groupId: "86642946",
                addonId: "72640321",
              },
              {
                groupId: "86642946",
                addonId: "72640322",
              },
              {
                groupId: "86642946",
                addonId: "72640323",
              },
              {
                groupId: "86642946",
                addonId: "72640324",
              },
              {
                groupId: "86642946",
                addonId: "72640325",
              },
              {
                groupId: "86642946",
                addonId: "72640326",
              },
              {
                groupId: "86642946",
                addonId: "72640327",
              },
              {
                groupId: "86642946",
                addonId: "72640328",
              },
              {
                groupId: "86642946",
                addonId: "72640329",
              },
              {
                groupId: "86642946",
                addonId: "72640330",
              },
              {
                groupId: "86642946",
                addonId: "72640331",
              },
              {
                groupId: "86642946",
                addonId: "72640332",
              },
              {
                groupId: "86642946",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357770",
              },
              {
                groupId: "26570633",
                variationId: "84357785",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642946",
                addonId: "72640314",
              },
              {
                groupId: "86642946",
                addonId: "72640315",
              },
              {
                groupId: "86642946",
                addonId: "72640316",
              },
              {
                groupId: "86642946",
                addonId: "72640317",
              },
              {
                groupId: "86642946",
                addonId: "72640318",
              },
              {
                groupId: "86642946",
                addonId: "72640319",
              },
              {
                groupId: "86642946",
                addonId: "72640320",
              },
              {
                groupId: "86642946",
                addonId: "72640321",
              },
              {
                groupId: "86642946",
                addonId: "72640322",
              },
              {
                groupId: "86642946",
                addonId: "72640323",
              },
              {
                groupId: "86642946",
                addonId: "72640324",
              },
              {
                groupId: "86642946",
                addonId: "72640325",
              },
              {
                groupId: "86642946",
                addonId: "72640326",
              },
              {
                groupId: "86642946",
                addonId: "72640327",
              },
              {
                groupId: "86642946",
                addonId: "72640328",
              },
              {
                groupId: "86642946",
                addonId: "72640329",
              },
              {
                groupId: "86642946",
                addonId: "72640330",
              },
              {
                groupId: "86642946",
                addonId: "72640331",
              },
              {
                groupId: "86642946",
                addonId: "72640332",
              },
              {
                groupId: "86642946",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357772",
              },
              {
                groupId: "26570633",
                variationId: "84357786",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642947",
                addonId: "72640334",
              },
              {
                groupId: "86642947",
                addonId: "72640335",
              },
              {
                groupId: "86642947",
                addonId: "72640336",
              },
              {
                groupId: "86642947",
                addonId: "72640337",
              },
              {
                groupId: "86642947",
                addonId: "72640338",
              },
              {
                groupId: "86642947",
                addonId: "72640339",
              },
              {
                groupId: "86642947",
                addonId: "72640340",
              },
              {
                groupId: "86642947",
                addonId: "72640341",
              },
              {
                groupId: "86642947",
                addonId: "72640342",
              },
              {
                groupId: "86642947",
                addonId: "72640343",
              },
              {
                groupId: "86642947",
                addonId: "72640344",
              },
              {
                groupId: "86642947",
                addonId: "72640345",
              },
              {
                groupId: "86642947",
                addonId: "72640346",
              },
              {
                groupId: "86642947",
                addonId: "72640347",
              },
              {
                groupId: "86642947",
                addonId: "72640348",
              },
              {
                groupId: "86642947",
                addonId: "72640349",
              },
              {
                groupId: "86642947",
                addonId: "72640350",
              },
              {
                groupId: "86642947",
                addonId: "72640351",
              },
              {
                groupId: "86642947",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357772",
              },
              {
                groupId: "26570633",
                variationId: "84357788",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642947",
                addonId: "72640334",
              },
              {
                groupId: "86642947",
                addonId: "72640335",
              },
              {
                groupId: "86642947",
                addonId: "72640336",
              },
              {
                groupId: "86642947",
                addonId: "72640337",
              },
              {
                groupId: "86642947",
                addonId: "72640338",
              },
              {
                groupId: "86642947",
                addonId: "72640339",
              },
              {
                groupId: "86642947",
                addonId: "72640340",
              },
              {
                groupId: "86642947",
                addonId: "72640341",
              },
              {
                groupId: "86642947",
                addonId: "72640342",
              },
              {
                groupId: "86642947",
                addonId: "72640343",
              },
              {
                groupId: "86642947",
                addonId: "72640344",
              },
              {
                groupId: "86642947",
                addonId: "72640345",
              },
              {
                groupId: "86642947",
                addonId: "72640346",
              },
              {
                groupId: "86642947",
                addonId: "72640347",
              },
              {
                groupId: "86642947",
                addonId: "72640348",
              },
              {
                groupId: "86642947",
                addonId: "72640349",
              },
              {
                groupId: "86642947",
                addonId: "72640350",
              },
              {
                groupId: "86642947",
                addonId: "72640351",
              },
              {
                groupId: "86642947",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357772",
              },
              {
                groupId: "26570633",
                variationId: "84357790",
              },
            ],
            price: 59900,
            addonCombinations: [
              {
                groupId: "86642947",
                addonId: "72640334",
              },
              {
                groupId: "86642947",
                addonId: "72640335",
              },
              {
                groupId: "86642947",
                addonId: "72640336",
              },
              {
                groupId: "86642947",
                addonId: "72640337",
              },
              {
                groupId: "86642947",
                addonId: "72640338",
              },
              {
                groupId: "86642947",
                addonId: "72640339",
              },
              {
                groupId: "86642947",
                addonId: "72640340",
              },
              {
                groupId: "86642947",
                addonId: "72640341",
              },
              {
                groupId: "86642947",
                addonId: "72640342",
              },
              {
                groupId: "86642947",
                addonId: "72640343",
              },
              {
                groupId: "86642947",
                addonId: "72640344",
              },
              {
                groupId: "86642947",
                addonId: "72640345",
              },
              {
                groupId: "86642947",
                addonId: "72640346",
              },
              {
                groupId: "86642947",
                addonId: "72640347",
              },
              {
                groupId: "86642947",
                addonId: "72640348",
              },
              {
                groupId: "86642947",
                addonId: "72640349",
              },
              {
                groupId: "86642947",
                addonId: "72640350",
              },
              {
                groupId: "86642947",
                addonId: "72640351",
              },
              {
                groupId: "86642947",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357772",
              },
              {
                groupId: "26570633",
                variationId: "84357792",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642947",
                addonId: "72640334",
              },
              {
                groupId: "86642947",
                addonId: "72640335",
              },
              {
                groupId: "86642947",
                addonId: "72640336",
              },
              {
                groupId: "86642947",
                addonId: "72640337",
              },
              {
                groupId: "86642947",
                addonId: "72640338",
              },
              {
                groupId: "86642947",
                addonId: "72640339",
              },
              {
                groupId: "86642947",
                addonId: "72640340",
              },
              {
                groupId: "86642947",
                addonId: "72640341",
              },
              {
                groupId: "86642947",
                addonId: "72640342",
              },
              {
                groupId: "86642947",
                addonId: "72640343",
              },
              {
                groupId: "86642947",
                addonId: "72640344",
              },
              {
                groupId: "86642947",
                addonId: "72640345",
              },
              {
                groupId: "86642947",
                addonId: "72640346",
              },
              {
                groupId: "86642947",
                addonId: "72640347",
              },
              {
                groupId: "86642947",
                addonId: "72640348",
              },
              {
                groupId: "86642947",
                addonId: "72640349",
              },
              {
                groupId: "86642947",
                addonId: "72640350",
              },
              {
                groupId: "86642947",
                addonId: "72640351",
              },
              {
                groupId: "86642947",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570631",
                variationId: "84357772",
              },
              {
                groupId: "26570633",
                variationId: "84357793",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642947",
                addonId: "72640334",
              },
              {
                groupId: "86642947",
                addonId: "72640335",
              },
              {
                groupId: "86642947",
                addonId: "72640336",
              },
              {
                groupId: "86642947",
                addonId: "72640337",
              },
              {
                groupId: "86642947",
                addonId: "72640338",
              },
              {
                groupId: "86642947",
                addonId: "72640339",
              },
              {
                groupId: "86642947",
                addonId: "72640340",
              },
              {
                groupId: "86642947",
                addonId: "72640341",
              },
              {
                groupId: "86642947",
                addonId: "72640342",
              },
              {
                groupId: "86642947",
                addonId: "72640343",
              },
              {
                groupId: "86642947",
                addonId: "72640344",
              },
              {
                groupId: "86642947",
                addonId: "72640345",
              },
              {
                groupId: "86642947",
                addonId: "72640346",
              },
              {
                groupId: "86642947",
                addonId: "72640347",
              },
              {
                groupId: "86642947",
                addonId: "72640348",
              },
              {
                groupId: "86642947",
                addonId: "72640349",
              },
              {
                groupId: "86642947",
                addonId: "72640350",
              },
              {
                groupId: "86642947",
                addonId: "72640351",
              },
              {
                groupId: "86642947",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642946",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642947",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "72276243",
      name: "Double Chicken Sausage",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Loaded with extra Chicken n Cheese Sausage with 100% mozzarella cheese &  flavourful pan sauce.",
      imageId: "ryhakpddpfvqgtgrsfnd",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570657",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84357877",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570658",
                  variationId: "84357879",
                },
              },
              {
                name: "Medium",
                id: "84357878",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570658",
                  variationId: "84357888",
                },
              },
            ],
          },
          {
            groupId: "26570658",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84357879",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84357880",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 339,
                id: "84357881",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Veg Kebab",
                price: 394,
                id: "84357883",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84357885",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84357888",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84357891",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 599,
                id: "84357894",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 668,
                id: "84357898",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84357902",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357877",
              },
              {
                groupId: "26570658",
                variationId: "84357879",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642970",
                addonId: "72640314",
              },
              {
                groupId: "86642970",
                addonId: "72640315",
              },
              {
                groupId: "86642970",
                addonId: "72640316",
              },
              {
                groupId: "86642970",
                addonId: "72640317",
              },
              {
                groupId: "86642970",
                addonId: "72640318",
              },
              {
                groupId: "86642970",
                addonId: "72640319",
              },
              {
                groupId: "86642970",
                addonId: "72640320",
              },
              {
                groupId: "86642970",
                addonId: "72640321",
              },
              {
                groupId: "86642970",
                addonId: "72640322",
              },
              {
                groupId: "86642970",
                addonId: "72640323",
              },
              {
                groupId: "86642970",
                addonId: "72640324",
              },
              {
                groupId: "86642970",
                addonId: "72640325",
              },
              {
                groupId: "86642970",
                addonId: "72640326",
              },
              {
                groupId: "86642970",
                addonId: "72640327",
              },
              {
                groupId: "86642970",
                addonId: "72640328",
              },
              {
                groupId: "86642970",
                addonId: "72640329",
              },
              {
                groupId: "86642970",
                addonId: "72640330",
              },
              {
                groupId: "86642970",
                addonId: "72640331",
              },
              {
                groupId: "86642970",
                addonId: "72640332",
              },
              {
                groupId: "86642970",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357877",
              },
              {
                groupId: "26570658",
                variationId: "84357880",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86642970",
                addonId: "72640314",
              },
              {
                groupId: "86642970",
                addonId: "72640315",
              },
              {
                groupId: "86642970",
                addonId: "72640316",
              },
              {
                groupId: "86642970",
                addonId: "72640317",
              },
              {
                groupId: "86642970",
                addonId: "72640318",
              },
              {
                groupId: "86642970",
                addonId: "72640319",
              },
              {
                groupId: "86642970",
                addonId: "72640320",
              },
              {
                groupId: "86642970",
                addonId: "72640321",
              },
              {
                groupId: "86642970",
                addonId: "72640322",
              },
              {
                groupId: "86642970",
                addonId: "72640323",
              },
              {
                groupId: "86642970",
                addonId: "72640324",
              },
              {
                groupId: "86642970",
                addonId: "72640325",
              },
              {
                groupId: "86642970",
                addonId: "72640326",
              },
              {
                groupId: "86642970",
                addonId: "72640327",
              },
              {
                groupId: "86642970",
                addonId: "72640328",
              },
              {
                groupId: "86642970",
                addonId: "72640329",
              },
              {
                groupId: "86642970",
                addonId: "72640330",
              },
              {
                groupId: "86642970",
                addonId: "72640331",
              },
              {
                groupId: "86642970",
                addonId: "72640332",
              },
              {
                groupId: "86642970",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357877",
              },
              {
                groupId: "26570658",
                variationId: "84357881",
              },
            ],
            price: 33900,
            addonCombinations: [
              {
                groupId: "86642970",
                addonId: "72640314",
              },
              {
                groupId: "86642970",
                addonId: "72640315",
              },
              {
                groupId: "86642970",
                addonId: "72640316",
              },
              {
                groupId: "86642970",
                addonId: "72640317",
              },
              {
                groupId: "86642970",
                addonId: "72640318",
              },
              {
                groupId: "86642970",
                addonId: "72640319",
              },
              {
                groupId: "86642970",
                addonId: "72640320",
              },
              {
                groupId: "86642970",
                addonId: "72640321",
              },
              {
                groupId: "86642970",
                addonId: "72640322",
              },
              {
                groupId: "86642970",
                addonId: "72640323",
              },
              {
                groupId: "86642970",
                addonId: "72640324",
              },
              {
                groupId: "86642970",
                addonId: "72640325",
              },
              {
                groupId: "86642970",
                addonId: "72640326",
              },
              {
                groupId: "86642970",
                addonId: "72640327",
              },
              {
                groupId: "86642970",
                addonId: "72640328",
              },
              {
                groupId: "86642970",
                addonId: "72640329",
              },
              {
                groupId: "86642970",
                addonId: "72640330",
              },
              {
                groupId: "86642970",
                addonId: "72640331",
              },
              {
                groupId: "86642970",
                addonId: "72640332",
              },
              {
                groupId: "86642970",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357877",
              },
              {
                groupId: "26570658",
                variationId: "84357883",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642970",
                addonId: "72640314",
              },
              {
                groupId: "86642970",
                addonId: "72640315",
              },
              {
                groupId: "86642970",
                addonId: "72640316",
              },
              {
                groupId: "86642970",
                addonId: "72640317",
              },
              {
                groupId: "86642970",
                addonId: "72640318",
              },
              {
                groupId: "86642970",
                addonId: "72640319",
              },
              {
                groupId: "86642970",
                addonId: "72640320",
              },
              {
                groupId: "86642970",
                addonId: "72640321",
              },
              {
                groupId: "86642970",
                addonId: "72640322",
              },
              {
                groupId: "86642970",
                addonId: "72640323",
              },
              {
                groupId: "86642970",
                addonId: "72640324",
              },
              {
                groupId: "86642970",
                addonId: "72640325",
              },
              {
                groupId: "86642970",
                addonId: "72640326",
              },
              {
                groupId: "86642970",
                addonId: "72640327",
              },
              {
                groupId: "86642970",
                addonId: "72640328",
              },
              {
                groupId: "86642970",
                addonId: "72640329",
              },
              {
                groupId: "86642970",
                addonId: "72640330",
              },
              {
                groupId: "86642970",
                addonId: "72640331",
              },
              {
                groupId: "86642970",
                addonId: "72640332",
              },
              {
                groupId: "86642970",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357877",
              },
              {
                groupId: "26570658",
                variationId: "84357885",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86642970",
                addonId: "72640314",
              },
              {
                groupId: "86642970",
                addonId: "72640315",
              },
              {
                groupId: "86642970",
                addonId: "72640316",
              },
              {
                groupId: "86642970",
                addonId: "72640317",
              },
              {
                groupId: "86642970",
                addonId: "72640318",
              },
              {
                groupId: "86642970",
                addonId: "72640319",
              },
              {
                groupId: "86642970",
                addonId: "72640320",
              },
              {
                groupId: "86642970",
                addonId: "72640321",
              },
              {
                groupId: "86642970",
                addonId: "72640322",
              },
              {
                groupId: "86642970",
                addonId: "72640323",
              },
              {
                groupId: "86642970",
                addonId: "72640324",
              },
              {
                groupId: "86642970",
                addonId: "72640325",
              },
              {
                groupId: "86642970",
                addonId: "72640326",
              },
              {
                groupId: "86642970",
                addonId: "72640327",
              },
              {
                groupId: "86642970",
                addonId: "72640328",
              },
              {
                groupId: "86642970",
                addonId: "72640329",
              },
              {
                groupId: "86642970",
                addonId: "72640330",
              },
              {
                groupId: "86642970",
                addonId: "72640331",
              },
              {
                groupId: "86642970",
                addonId: "72640332",
              },
              {
                groupId: "86642970",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357878",
              },
              {
                groupId: "26570658",
                variationId: "84357888",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642972",
                addonId: "72640334",
              },
              {
                groupId: "86642972",
                addonId: "72640335",
              },
              {
                groupId: "86642972",
                addonId: "72640336",
              },
              {
                groupId: "86642972",
                addonId: "72640337",
              },
              {
                groupId: "86642972",
                addonId: "72640338",
              },
              {
                groupId: "86642972",
                addonId: "72640339",
              },
              {
                groupId: "86642972",
                addonId: "72640340",
              },
              {
                groupId: "86642972",
                addonId: "72640341",
              },
              {
                groupId: "86642972",
                addonId: "72640342",
              },
              {
                groupId: "86642972",
                addonId: "72640343",
              },
              {
                groupId: "86642972",
                addonId: "72640344",
              },
              {
                groupId: "86642972",
                addonId: "72640345",
              },
              {
                groupId: "86642972",
                addonId: "72640346",
              },
              {
                groupId: "86642972",
                addonId: "72640347",
              },
              {
                groupId: "86642972",
                addonId: "72640348",
              },
              {
                groupId: "86642972",
                addonId: "72640349",
              },
              {
                groupId: "86642972",
                addonId: "72640350",
              },
              {
                groupId: "86642972",
                addonId: "72640351",
              },
              {
                groupId: "86642972",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357878",
              },
              {
                groupId: "26570658",
                variationId: "84357891",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86642972",
                addonId: "72640334",
              },
              {
                groupId: "86642972",
                addonId: "72640335",
              },
              {
                groupId: "86642972",
                addonId: "72640336",
              },
              {
                groupId: "86642972",
                addonId: "72640337",
              },
              {
                groupId: "86642972",
                addonId: "72640338",
              },
              {
                groupId: "86642972",
                addonId: "72640339",
              },
              {
                groupId: "86642972",
                addonId: "72640340",
              },
              {
                groupId: "86642972",
                addonId: "72640341",
              },
              {
                groupId: "86642972",
                addonId: "72640342",
              },
              {
                groupId: "86642972",
                addonId: "72640343",
              },
              {
                groupId: "86642972",
                addonId: "72640344",
              },
              {
                groupId: "86642972",
                addonId: "72640345",
              },
              {
                groupId: "86642972",
                addonId: "72640346",
              },
              {
                groupId: "86642972",
                addonId: "72640347",
              },
              {
                groupId: "86642972",
                addonId: "72640348",
              },
              {
                groupId: "86642972",
                addonId: "72640349",
              },
              {
                groupId: "86642972",
                addonId: "72640350",
              },
              {
                groupId: "86642972",
                addonId: "72640351",
              },
              {
                groupId: "86642972",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357878",
              },
              {
                groupId: "26570658",
                variationId: "84357894",
              },
            ],
            price: 59900,
            addonCombinations: [
              {
                groupId: "86642972",
                addonId: "72640334",
              },
              {
                groupId: "86642972",
                addonId: "72640335",
              },
              {
                groupId: "86642972",
                addonId: "72640336",
              },
              {
                groupId: "86642972",
                addonId: "72640337",
              },
              {
                groupId: "86642972",
                addonId: "72640338",
              },
              {
                groupId: "86642972",
                addonId: "72640339",
              },
              {
                groupId: "86642972",
                addonId: "72640340",
              },
              {
                groupId: "86642972",
                addonId: "72640341",
              },
              {
                groupId: "86642972",
                addonId: "72640342",
              },
              {
                groupId: "86642972",
                addonId: "72640343",
              },
              {
                groupId: "86642972",
                addonId: "72640344",
              },
              {
                groupId: "86642972",
                addonId: "72640345",
              },
              {
                groupId: "86642972",
                addonId: "72640346",
              },
              {
                groupId: "86642972",
                addonId: "72640347",
              },
              {
                groupId: "86642972",
                addonId: "72640348",
              },
              {
                groupId: "86642972",
                addonId: "72640349",
              },
              {
                groupId: "86642972",
                addonId: "72640350",
              },
              {
                groupId: "86642972",
                addonId: "72640351",
              },
              {
                groupId: "86642972",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357878",
              },
              {
                groupId: "26570658",
                variationId: "84357898",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642972",
                addonId: "72640334",
              },
              {
                groupId: "86642972",
                addonId: "72640335",
              },
              {
                groupId: "86642972",
                addonId: "72640336",
              },
              {
                groupId: "86642972",
                addonId: "72640337",
              },
              {
                groupId: "86642972",
                addonId: "72640338",
              },
              {
                groupId: "86642972",
                addonId: "72640339",
              },
              {
                groupId: "86642972",
                addonId: "72640340",
              },
              {
                groupId: "86642972",
                addonId: "72640341",
              },
              {
                groupId: "86642972",
                addonId: "72640342",
              },
              {
                groupId: "86642972",
                addonId: "72640343",
              },
              {
                groupId: "86642972",
                addonId: "72640344",
              },
              {
                groupId: "86642972",
                addonId: "72640345",
              },
              {
                groupId: "86642972",
                addonId: "72640346",
              },
              {
                groupId: "86642972",
                addonId: "72640347",
              },
              {
                groupId: "86642972",
                addonId: "72640348",
              },
              {
                groupId: "86642972",
                addonId: "72640349",
              },
              {
                groupId: "86642972",
                addonId: "72640350",
              },
              {
                groupId: "86642972",
                addonId: "72640351",
              },
              {
                groupId: "86642972",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570657",
                variationId: "84357878",
              },
              {
                groupId: "26570658",
                variationId: "84357902",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86642972",
                addonId: "72640334",
              },
              {
                groupId: "86642972",
                addonId: "72640335",
              },
              {
                groupId: "86642972",
                addonId: "72640336",
              },
              {
                groupId: "86642972",
                addonId: "72640337",
              },
              {
                groupId: "86642972",
                addonId: "72640338",
              },
              {
                groupId: "86642972",
                addonId: "72640339",
              },
              {
                groupId: "86642972",
                addonId: "72640340",
              },
              {
                groupId: "86642972",
                addonId: "72640341",
              },
              {
                groupId: "86642972",
                addonId: "72640342",
              },
              {
                groupId: "86642972",
                addonId: "72640343",
              },
              {
                groupId: "86642972",
                addonId: "72640344",
              },
              {
                groupId: "86642972",
                addonId: "72640345",
              },
              {
                groupId: "86642972",
                addonId: "72640346",
              },
              {
                groupId: "86642972",
                addonId: "72640347",
              },
              {
                groupId: "86642972",
                addonId: "72640348",
              },
              {
                groupId: "86642972",
                addonId: "72640349",
              },
              {
                groupId: "86642972",
                addonId: "72640350",
              },
              {
                groupId: "86642972",
                addonId: "72640351",
              },
              {
                groupId: "86642972",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642970",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642972",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "87274179",
      name: "Chicken Pepperoni",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Yummy Chicken Pepperoni & 100% mozzarella cheese with signature pan sauce. It’s a classic!",
      imageId: "gdz44c9hirco09bdafoq",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570646",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84357830",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570648",
                  variationId: "84357834",
                },
              },
              {
                name: "Medium",
                id: "84357832",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570648",
                  variationId: "84357844",
                },
              },
            ],
          },
          {
            groupId: "26570648",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 379,
                default: 1,
                id: "84357834",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 379,
                id: "84357836",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 399,
                id: "84357838",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 454,
                id: "84357840",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                id: "84357842",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 639,
                id: "84357844",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 639,
                id: "84357845",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 669,
                id: "84357848",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 738,
                id: "84357851",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84357855",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357830",
              },
              {
                groupId: "26570648",
                variationId: "84357834",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642959",
                addonId: "72640314",
              },
              {
                groupId: "86642959",
                addonId: "72640315",
              },
              {
                groupId: "86642959",
                addonId: "72640316",
              },
              {
                groupId: "86642959",
                addonId: "72640317",
              },
              {
                groupId: "86642959",
                addonId: "72640318",
              },
              {
                groupId: "86642959",
                addonId: "72640319",
              },
              {
                groupId: "86642959",
                addonId: "72640320",
              },
              {
                groupId: "86642959",
                addonId: "72640321",
              },
              {
                groupId: "86642959",
                addonId: "72640322",
              },
              {
                groupId: "86642959",
                addonId: "72640323",
              },
              {
                groupId: "86642959",
                addonId: "72640324",
              },
              {
                groupId: "86642959",
                addonId: "72640325",
              },
              {
                groupId: "86642959",
                addonId: "72640326",
              },
              {
                groupId: "86642959",
                addonId: "72640327",
              },
              {
                groupId: "86642959",
                addonId: "72640328",
              },
              {
                groupId: "86642959",
                addonId: "72640329",
              },
              {
                groupId: "86642959",
                addonId: "72640330",
              },
              {
                groupId: "86642959",
                addonId: "72640331",
              },
              {
                groupId: "86642959",
                addonId: "72640332",
              },
              {
                groupId: "86642959",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357830",
              },
              {
                groupId: "26570648",
                variationId: "84357836",
              },
            ],
            price: 37900,
            addonCombinations: [
              {
                groupId: "86642959",
                addonId: "72640314",
              },
              {
                groupId: "86642959",
                addonId: "72640315",
              },
              {
                groupId: "86642959",
                addonId: "72640316",
              },
              {
                groupId: "86642959",
                addonId: "72640317",
              },
              {
                groupId: "86642959",
                addonId: "72640318",
              },
              {
                groupId: "86642959",
                addonId: "72640319",
              },
              {
                groupId: "86642959",
                addonId: "72640320",
              },
              {
                groupId: "86642959",
                addonId: "72640321",
              },
              {
                groupId: "86642959",
                addonId: "72640322",
              },
              {
                groupId: "86642959",
                addonId: "72640323",
              },
              {
                groupId: "86642959",
                addonId: "72640324",
              },
              {
                groupId: "86642959",
                addonId: "72640325",
              },
              {
                groupId: "86642959",
                addonId: "72640326",
              },
              {
                groupId: "86642959",
                addonId: "72640327",
              },
              {
                groupId: "86642959",
                addonId: "72640328",
              },
              {
                groupId: "86642959",
                addonId: "72640329",
              },
              {
                groupId: "86642959",
                addonId: "72640330",
              },
              {
                groupId: "86642959",
                addonId: "72640331",
              },
              {
                groupId: "86642959",
                addonId: "72640332",
              },
              {
                groupId: "86642959",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357830",
              },
              {
                groupId: "26570648",
                variationId: "84357838",
              },
            ],
            price: 39900,
            addonCombinations: [
              {
                groupId: "86642959",
                addonId: "72640314",
              },
              {
                groupId: "86642959",
                addonId: "72640315",
              },
              {
                groupId: "86642959",
                addonId: "72640316",
              },
              {
                groupId: "86642959",
                addonId: "72640317",
              },
              {
                groupId: "86642959",
                addonId: "72640318",
              },
              {
                groupId: "86642959",
                addonId: "72640319",
              },
              {
                groupId: "86642959",
                addonId: "72640320",
              },
              {
                groupId: "86642959",
                addonId: "72640321",
              },
              {
                groupId: "86642959",
                addonId: "72640322",
              },
              {
                groupId: "86642959",
                addonId: "72640323",
              },
              {
                groupId: "86642959",
                addonId: "72640324",
              },
              {
                groupId: "86642959",
                addonId: "72640325",
              },
              {
                groupId: "86642959",
                addonId: "72640326",
              },
              {
                groupId: "86642959",
                addonId: "72640327",
              },
              {
                groupId: "86642959",
                addonId: "72640328",
              },
              {
                groupId: "86642959",
                addonId: "72640329",
              },
              {
                groupId: "86642959",
                addonId: "72640330",
              },
              {
                groupId: "86642959",
                addonId: "72640331",
              },
              {
                groupId: "86642959",
                addonId: "72640332",
              },
              {
                groupId: "86642959",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357830",
              },
              {
                groupId: "26570648",
                variationId: "84357840",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642959",
                addonId: "72640314",
              },
              {
                groupId: "86642959",
                addonId: "72640315",
              },
              {
                groupId: "86642959",
                addonId: "72640316",
              },
              {
                groupId: "86642959",
                addonId: "72640317",
              },
              {
                groupId: "86642959",
                addonId: "72640318",
              },
              {
                groupId: "86642959",
                addonId: "72640319",
              },
              {
                groupId: "86642959",
                addonId: "72640320",
              },
              {
                groupId: "86642959",
                addonId: "72640321",
              },
              {
                groupId: "86642959",
                addonId: "72640322",
              },
              {
                groupId: "86642959",
                addonId: "72640323",
              },
              {
                groupId: "86642959",
                addonId: "72640324",
              },
              {
                groupId: "86642959",
                addonId: "72640325",
              },
              {
                groupId: "86642959",
                addonId: "72640326",
              },
              {
                groupId: "86642959",
                addonId: "72640327",
              },
              {
                groupId: "86642959",
                addonId: "72640328",
              },
              {
                groupId: "86642959",
                addonId: "72640329",
              },
              {
                groupId: "86642959",
                addonId: "72640330",
              },
              {
                groupId: "86642959",
                addonId: "72640331",
              },
              {
                groupId: "86642959",
                addonId: "72640332",
              },
              {
                groupId: "86642959",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357830",
              },
              {
                groupId: "26570648",
                variationId: "84357842",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86642959",
                addonId: "72640314",
              },
              {
                groupId: "86642959",
                addonId: "72640315",
              },
              {
                groupId: "86642959",
                addonId: "72640316",
              },
              {
                groupId: "86642959",
                addonId: "72640317",
              },
              {
                groupId: "86642959",
                addonId: "72640318",
              },
              {
                groupId: "86642959",
                addonId: "72640319",
              },
              {
                groupId: "86642959",
                addonId: "72640320",
              },
              {
                groupId: "86642959",
                addonId: "72640321",
              },
              {
                groupId: "86642959",
                addonId: "72640322",
              },
              {
                groupId: "86642959",
                addonId: "72640323",
              },
              {
                groupId: "86642959",
                addonId: "72640324",
              },
              {
                groupId: "86642959",
                addonId: "72640325",
              },
              {
                groupId: "86642959",
                addonId: "72640326",
              },
              {
                groupId: "86642959",
                addonId: "72640327",
              },
              {
                groupId: "86642959",
                addonId: "72640328",
              },
              {
                groupId: "86642959",
                addonId: "72640329",
              },
              {
                groupId: "86642959",
                addonId: "72640330",
              },
              {
                groupId: "86642959",
                addonId: "72640331",
              },
              {
                groupId: "86642959",
                addonId: "72640332",
              },
              {
                groupId: "86642959",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357832",
              },
              {
                groupId: "26570648",
                variationId: "84357844",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642963",
                addonId: "72640334",
              },
              {
                groupId: "86642963",
                addonId: "72640335",
              },
              {
                groupId: "86642963",
                addonId: "72640336",
              },
              {
                groupId: "86642963",
                addonId: "72640337",
              },
              {
                groupId: "86642963",
                addonId: "72640338",
              },
              {
                groupId: "86642963",
                addonId: "72640339",
              },
              {
                groupId: "86642963",
                addonId: "72640340",
              },
              {
                groupId: "86642963",
                addonId: "72640341",
              },
              {
                groupId: "86642963",
                addonId: "72640342",
              },
              {
                groupId: "86642963",
                addonId: "72640343",
              },
              {
                groupId: "86642963",
                addonId: "72640344",
              },
              {
                groupId: "86642963",
                addonId: "72640345",
              },
              {
                groupId: "86642963",
                addonId: "72640346",
              },
              {
                groupId: "86642963",
                addonId: "72640347",
              },
              {
                groupId: "86642963",
                addonId: "72640348",
              },
              {
                groupId: "86642963",
                addonId: "72640349",
              },
              {
                groupId: "86642963",
                addonId: "72640350",
              },
              {
                groupId: "86642963",
                addonId: "72640351",
              },
              {
                groupId: "86642963",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357832",
              },
              {
                groupId: "26570648",
                variationId: "84357845",
              },
            ],
            price: 63900,
            addonCombinations: [
              {
                groupId: "86642963",
                addonId: "72640334",
              },
              {
                groupId: "86642963",
                addonId: "72640335",
              },
              {
                groupId: "86642963",
                addonId: "72640336",
              },
              {
                groupId: "86642963",
                addonId: "72640337",
              },
              {
                groupId: "86642963",
                addonId: "72640338",
              },
              {
                groupId: "86642963",
                addonId: "72640339",
              },
              {
                groupId: "86642963",
                addonId: "72640340",
              },
              {
                groupId: "86642963",
                addonId: "72640341",
              },
              {
                groupId: "86642963",
                addonId: "72640342",
              },
              {
                groupId: "86642963",
                addonId: "72640343",
              },
              {
                groupId: "86642963",
                addonId: "72640344",
              },
              {
                groupId: "86642963",
                addonId: "72640345",
              },
              {
                groupId: "86642963",
                addonId: "72640346",
              },
              {
                groupId: "86642963",
                addonId: "72640347",
              },
              {
                groupId: "86642963",
                addonId: "72640348",
              },
              {
                groupId: "86642963",
                addonId: "72640349",
              },
              {
                groupId: "86642963",
                addonId: "72640350",
              },
              {
                groupId: "86642963",
                addonId: "72640351",
              },
              {
                groupId: "86642963",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357832",
              },
              {
                groupId: "26570648",
                variationId: "84357848",
              },
            ],
            price: 66900,
            addonCombinations: [
              {
                groupId: "86642963",
                addonId: "72640334",
              },
              {
                groupId: "86642963",
                addonId: "72640335",
              },
              {
                groupId: "86642963",
                addonId: "72640336",
              },
              {
                groupId: "86642963",
                addonId: "72640337",
              },
              {
                groupId: "86642963",
                addonId: "72640338",
              },
              {
                groupId: "86642963",
                addonId: "72640339",
              },
              {
                groupId: "86642963",
                addonId: "72640340",
              },
              {
                groupId: "86642963",
                addonId: "72640341",
              },
              {
                groupId: "86642963",
                addonId: "72640342",
              },
              {
                groupId: "86642963",
                addonId: "72640343",
              },
              {
                groupId: "86642963",
                addonId: "72640344",
              },
              {
                groupId: "86642963",
                addonId: "72640345",
              },
              {
                groupId: "86642963",
                addonId: "72640346",
              },
              {
                groupId: "86642963",
                addonId: "72640347",
              },
              {
                groupId: "86642963",
                addonId: "72640348",
              },
              {
                groupId: "86642963",
                addonId: "72640349",
              },
              {
                groupId: "86642963",
                addonId: "72640350",
              },
              {
                groupId: "86642963",
                addonId: "72640351",
              },
              {
                groupId: "86642963",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357832",
              },
              {
                groupId: "26570648",
                variationId: "84357851",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642963",
                addonId: "72640334",
              },
              {
                groupId: "86642963",
                addonId: "72640335",
              },
              {
                groupId: "86642963",
                addonId: "72640336",
              },
              {
                groupId: "86642963",
                addonId: "72640337",
              },
              {
                groupId: "86642963",
                addonId: "72640338",
              },
              {
                groupId: "86642963",
                addonId: "72640339",
              },
              {
                groupId: "86642963",
                addonId: "72640340",
              },
              {
                groupId: "86642963",
                addonId: "72640341",
              },
              {
                groupId: "86642963",
                addonId: "72640342",
              },
              {
                groupId: "86642963",
                addonId: "72640343",
              },
              {
                groupId: "86642963",
                addonId: "72640344",
              },
              {
                groupId: "86642963",
                addonId: "72640345",
              },
              {
                groupId: "86642963",
                addonId: "72640346",
              },
              {
                groupId: "86642963",
                addonId: "72640347",
              },
              {
                groupId: "86642963",
                addonId: "72640348",
              },
              {
                groupId: "86642963",
                addonId: "72640349",
              },
              {
                groupId: "86642963",
                addonId: "72640350",
              },
              {
                groupId: "86642963",
                addonId: "72640351",
              },
              {
                groupId: "86642963",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570646",
                variationId: "84357832",
              },
              {
                groupId: "26570648",
                variationId: "84357855",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86642963",
                addonId: "72640334",
              },
              {
                groupId: "86642963",
                addonId: "72640335",
              },
              {
                groupId: "86642963",
                addonId: "72640336",
              },
              {
                groupId: "86642963",
                addonId: "72640337",
              },
              {
                groupId: "86642963",
                addonId: "72640338",
              },
              {
                groupId: "86642963",
                addonId: "72640339",
              },
              {
                groupId: "86642963",
                addonId: "72640340",
              },
              {
                groupId: "86642963",
                addonId: "72640341",
              },
              {
                groupId: "86642963",
                addonId: "72640342",
              },
              {
                groupId: "86642963",
                addonId: "72640343",
              },
              {
                groupId: "86642963",
                addonId: "72640344",
              },
              {
                groupId: "86642963",
                addonId: "72640345",
              },
              {
                groupId: "86642963",
                addonId: "72640346",
              },
              {
                groupId: "86642963",
                addonId: "72640347",
              },
              {
                groupId: "86642963",
                addonId: "72640348",
              },
              {
                groupId: "86642963",
                addonId: "72640349",
              },
              {
                groupId: "86642963",
                addonId: "72640350",
              },
              {
                groupId: "86642963",
                addonId: "72640351",
              },
              {
                groupId: "86642963",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642959",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642963",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 37900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "87274180",
      name: "Chicken Supreme",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Loaded with delicious Chicken Tikka, flavourful Herbed Chicken, spicy Schezwan Chicken Meatball with flavourful pan sauce and 100% mozzarella cheese.",
      imageId: "dlvdmsn1uotbdn4vzvap",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569960",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84354299",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569961",
                  variationId: "84354302",
                },
              },
              {
                name: "Medium",
                id: "84354301",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569961",
                  variationId: "84354307",
                },
              },
            ],
          },
          {
            groupId: "26569961",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 409,
                default: 1,
                id: "84354302",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 409,
                id: "84354303",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 429,
                id: "84354304",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 484,
                id: "84354305",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 484,
                id: "84354306",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 699,
                id: "84354307",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 699,
                id: "84354308",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Pan Crust",
                price: 729,
                id: "84354310",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 798,
                id: "84354311",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 798,
                id: "84354313",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354299",
              },
              {
                groupId: "26569961",
                variationId: "84354302",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642702",
                addonId: "72640314",
              },
              {
                groupId: "86642702",
                addonId: "72640315",
              },
              {
                groupId: "86642702",
                addonId: "72640316",
              },
              {
                groupId: "86642702",
                addonId: "72640317",
              },
              {
                groupId: "86642702",
                addonId: "72640318",
              },
              {
                groupId: "86642702",
                addonId: "72640319",
              },
              {
                groupId: "86642702",
                addonId: "72640320",
              },
              {
                groupId: "86642702",
                addonId: "72640321",
              },
              {
                groupId: "86642702",
                addonId: "72640322",
              },
              {
                groupId: "86642702",
                addonId: "72640323",
              },
              {
                groupId: "86642702",
                addonId: "72640324",
              },
              {
                groupId: "86642702",
                addonId: "72640325",
              },
              {
                groupId: "86642702",
                addonId: "72640326",
              },
              {
                groupId: "86642702",
                addonId: "72640327",
              },
              {
                groupId: "86642702",
                addonId: "72640328",
              },
              {
                groupId: "86642702",
                addonId: "72640329",
              },
              {
                groupId: "86642702",
                addonId: "72640330",
              },
              {
                groupId: "86642702",
                addonId: "72640331",
              },
              {
                groupId: "86642702",
                addonId: "72640332",
              },
              {
                groupId: "86642702",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354299",
              },
              {
                groupId: "26569961",
                variationId: "84354303",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86642702",
                addonId: "72640314",
              },
              {
                groupId: "86642702",
                addonId: "72640315",
              },
              {
                groupId: "86642702",
                addonId: "72640316",
              },
              {
                groupId: "86642702",
                addonId: "72640317",
              },
              {
                groupId: "86642702",
                addonId: "72640318",
              },
              {
                groupId: "86642702",
                addonId: "72640319",
              },
              {
                groupId: "86642702",
                addonId: "72640320",
              },
              {
                groupId: "86642702",
                addonId: "72640321",
              },
              {
                groupId: "86642702",
                addonId: "72640322",
              },
              {
                groupId: "86642702",
                addonId: "72640323",
              },
              {
                groupId: "86642702",
                addonId: "72640324",
              },
              {
                groupId: "86642702",
                addonId: "72640325",
              },
              {
                groupId: "86642702",
                addonId: "72640326",
              },
              {
                groupId: "86642702",
                addonId: "72640327",
              },
              {
                groupId: "86642702",
                addonId: "72640328",
              },
              {
                groupId: "86642702",
                addonId: "72640329",
              },
              {
                groupId: "86642702",
                addonId: "72640330",
              },
              {
                groupId: "86642702",
                addonId: "72640331",
              },
              {
                groupId: "86642702",
                addonId: "72640332",
              },
              {
                groupId: "86642702",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354299",
              },
              {
                groupId: "26569961",
                variationId: "84354304",
              },
            ],
            price: 42900,
            addonCombinations: [
              {
                groupId: "86642702",
                addonId: "72640314",
              },
              {
                groupId: "86642702",
                addonId: "72640315",
              },
              {
                groupId: "86642702",
                addonId: "72640316",
              },
              {
                groupId: "86642702",
                addonId: "72640317",
              },
              {
                groupId: "86642702",
                addonId: "72640318",
              },
              {
                groupId: "86642702",
                addonId: "72640319",
              },
              {
                groupId: "86642702",
                addonId: "72640320",
              },
              {
                groupId: "86642702",
                addonId: "72640321",
              },
              {
                groupId: "86642702",
                addonId: "72640322",
              },
              {
                groupId: "86642702",
                addonId: "72640323",
              },
              {
                groupId: "86642702",
                addonId: "72640324",
              },
              {
                groupId: "86642702",
                addonId: "72640325",
              },
              {
                groupId: "86642702",
                addonId: "72640326",
              },
              {
                groupId: "86642702",
                addonId: "72640327",
              },
              {
                groupId: "86642702",
                addonId: "72640328",
              },
              {
                groupId: "86642702",
                addonId: "72640329",
              },
              {
                groupId: "86642702",
                addonId: "72640330",
              },
              {
                groupId: "86642702",
                addonId: "72640331",
              },
              {
                groupId: "86642702",
                addonId: "72640332",
              },
              {
                groupId: "86642702",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354299",
              },
              {
                groupId: "26569961",
                variationId: "84354305",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642702",
                addonId: "72640314",
              },
              {
                groupId: "86642702",
                addonId: "72640315",
              },
              {
                groupId: "86642702",
                addonId: "72640316",
              },
              {
                groupId: "86642702",
                addonId: "72640317",
              },
              {
                groupId: "86642702",
                addonId: "72640318",
              },
              {
                groupId: "86642702",
                addonId: "72640319",
              },
              {
                groupId: "86642702",
                addonId: "72640320",
              },
              {
                groupId: "86642702",
                addonId: "72640321",
              },
              {
                groupId: "86642702",
                addonId: "72640322",
              },
              {
                groupId: "86642702",
                addonId: "72640323",
              },
              {
                groupId: "86642702",
                addonId: "72640324",
              },
              {
                groupId: "86642702",
                addonId: "72640325",
              },
              {
                groupId: "86642702",
                addonId: "72640326",
              },
              {
                groupId: "86642702",
                addonId: "72640327",
              },
              {
                groupId: "86642702",
                addonId: "72640328",
              },
              {
                groupId: "86642702",
                addonId: "72640329",
              },
              {
                groupId: "86642702",
                addonId: "72640330",
              },
              {
                groupId: "86642702",
                addonId: "72640331",
              },
              {
                groupId: "86642702",
                addonId: "72640332",
              },
              {
                groupId: "86642702",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354299",
              },
              {
                groupId: "26569961",
                variationId: "84354306",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86642702",
                addonId: "72640314",
              },
              {
                groupId: "86642702",
                addonId: "72640315",
              },
              {
                groupId: "86642702",
                addonId: "72640316",
              },
              {
                groupId: "86642702",
                addonId: "72640317",
              },
              {
                groupId: "86642702",
                addonId: "72640318",
              },
              {
                groupId: "86642702",
                addonId: "72640319",
              },
              {
                groupId: "86642702",
                addonId: "72640320",
              },
              {
                groupId: "86642702",
                addonId: "72640321",
              },
              {
                groupId: "86642702",
                addonId: "72640322",
              },
              {
                groupId: "86642702",
                addonId: "72640323",
              },
              {
                groupId: "86642702",
                addonId: "72640324",
              },
              {
                groupId: "86642702",
                addonId: "72640325",
              },
              {
                groupId: "86642702",
                addonId: "72640326",
              },
              {
                groupId: "86642702",
                addonId: "72640327",
              },
              {
                groupId: "86642702",
                addonId: "72640328",
              },
              {
                groupId: "86642702",
                addonId: "72640329",
              },
              {
                groupId: "86642702",
                addonId: "72640330",
              },
              {
                groupId: "86642702",
                addonId: "72640331",
              },
              {
                groupId: "86642702",
                addonId: "72640332",
              },
              {
                groupId: "86642702",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354301",
              },
              {
                groupId: "26569961",
                variationId: "84354307",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642703",
                addonId: "72640334",
              },
              {
                groupId: "86642703",
                addonId: "72640335",
              },
              {
                groupId: "86642703",
                addonId: "72640336",
              },
              {
                groupId: "86642703",
                addonId: "72640337",
              },
              {
                groupId: "86642703",
                addonId: "72640338",
              },
              {
                groupId: "86642703",
                addonId: "72640339",
              },
              {
                groupId: "86642703",
                addonId: "72640340",
              },
              {
                groupId: "86642703",
                addonId: "72640341",
              },
              {
                groupId: "86642703",
                addonId: "72640342",
              },
              {
                groupId: "86642703",
                addonId: "72640343",
              },
              {
                groupId: "86642703",
                addonId: "72640344",
              },
              {
                groupId: "86642703",
                addonId: "72640345",
              },
              {
                groupId: "86642703",
                addonId: "72640346",
              },
              {
                groupId: "86642703",
                addonId: "72640347",
              },
              {
                groupId: "86642703",
                addonId: "72640348",
              },
              {
                groupId: "86642703",
                addonId: "72640349",
              },
              {
                groupId: "86642703",
                addonId: "72640350",
              },
              {
                groupId: "86642703",
                addonId: "72640351",
              },
              {
                groupId: "86642703",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354301",
              },
              {
                groupId: "26569961",
                variationId: "84354308",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86642703",
                addonId: "72640334",
              },
              {
                groupId: "86642703",
                addonId: "72640335",
              },
              {
                groupId: "86642703",
                addonId: "72640336",
              },
              {
                groupId: "86642703",
                addonId: "72640337",
              },
              {
                groupId: "86642703",
                addonId: "72640338",
              },
              {
                groupId: "86642703",
                addonId: "72640339",
              },
              {
                groupId: "86642703",
                addonId: "72640340",
              },
              {
                groupId: "86642703",
                addonId: "72640341",
              },
              {
                groupId: "86642703",
                addonId: "72640342",
              },
              {
                groupId: "86642703",
                addonId: "72640343",
              },
              {
                groupId: "86642703",
                addonId: "72640344",
              },
              {
                groupId: "86642703",
                addonId: "72640345",
              },
              {
                groupId: "86642703",
                addonId: "72640346",
              },
              {
                groupId: "86642703",
                addonId: "72640347",
              },
              {
                groupId: "86642703",
                addonId: "72640348",
              },
              {
                groupId: "86642703",
                addonId: "72640349",
              },
              {
                groupId: "86642703",
                addonId: "72640350",
              },
              {
                groupId: "86642703",
                addonId: "72640351",
              },
              {
                groupId: "86642703",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354301",
              },
              {
                groupId: "26569961",
                variationId: "84354310",
              },
            ],
            price: 72900,
            addonCombinations: [
              {
                groupId: "86642703",
                addonId: "72640334",
              },
              {
                groupId: "86642703",
                addonId: "72640335",
              },
              {
                groupId: "86642703",
                addonId: "72640336",
              },
              {
                groupId: "86642703",
                addonId: "72640337",
              },
              {
                groupId: "86642703",
                addonId: "72640338",
              },
              {
                groupId: "86642703",
                addonId: "72640339",
              },
              {
                groupId: "86642703",
                addonId: "72640340",
              },
              {
                groupId: "86642703",
                addonId: "72640341",
              },
              {
                groupId: "86642703",
                addonId: "72640342",
              },
              {
                groupId: "86642703",
                addonId: "72640343",
              },
              {
                groupId: "86642703",
                addonId: "72640344",
              },
              {
                groupId: "86642703",
                addonId: "72640345",
              },
              {
                groupId: "86642703",
                addonId: "72640346",
              },
              {
                groupId: "86642703",
                addonId: "72640347",
              },
              {
                groupId: "86642703",
                addonId: "72640348",
              },
              {
                groupId: "86642703",
                addonId: "72640349",
              },
              {
                groupId: "86642703",
                addonId: "72640350",
              },
              {
                groupId: "86642703",
                addonId: "72640351",
              },
              {
                groupId: "86642703",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354301",
              },
              {
                groupId: "26569961",
                variationId: "84354311",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642703",
                addonId: "72640334",
              },
              {
                groupId: "86642703",
                addonId: "72640335",
              },
              {
                groupId: "86642703",
                addonId: "72640336",
              },
              {
                groupId: "86642703",
                addonId: "72640337",
              },
              {
                groupId: "86642703",
                addonId: "72640338",
              },
              {
                groupId: "86642703",
                addonId: "72640339",
              },
              {
                groupId: "86642703",
                addonId: "72640340",
              },
              {
                groupId: "86642703",
                addonId: "72640341",
              },
              {
                groupId: "86642703",
                addonId: "72640342",
              },
              {
                groupId: "86642703",
                addonId: "72640343",
              },
              {
                groupId: "86642703",
                addonId: "72640344",
              },
              {
                groupId: "86642703",
                addonId: "72640345",
              },
              {
                groupId: "86642703",
                addonId: "72640346",
              },
              {
                groupId: "86642703",
                addonId: "72640347",
              },
              {
                groupId: "86642703",
                addonId: "72640348",
              },
              {
                groupId: "86642703",
                addonId: "72640349",
              },
              {
                groupId: "86642703",
                addonId: "72640350",
              },
              {
                groupId: "86642703",
                addonId: "72640351",
              },
              {
                groupId: "86642703",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26569960",
                variationId: "84354301",
              },
              {
                groupId: "26569961",
                variationId: "84354313",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86642703",
                addonId: "72640334",
              },
              {
                groupId: "86642703",
                addonId: "72640335",
              },
              {
                groupId: "86642703",
                addonId: "72640336",
              },
              {
                groupId: "86642703",
                addonId: "72640337",
              },
              {
                groupId: "86642703",
                addonId: "72640338",
              },
              {
                groupId: "86642703",
                addonId: "72640339",
              },
              {
                groupId: "86642703",
                addonId: "72640340",
              },
              {
                groupId: "86642703",
                addonId: "72640341",
              },
              {
                groupId: "86642703",
                addonId: "72640342",
              },
              {
                groupId: "86642703",
                addonId: "72640343",
              },
              {
                groupId: "86642703",
                addonId: "72640344",
              },
              {
                groupId: "86642703",
                addonId: "72640345",
              },
              {
                groupId: "86642703",
                addonId: "72640346",
              },
              {
                groupId: "86642703",
                addonId: "72640347",
              },
              {
                groupId: "86642703",
                addonId: "72640348",
              },
              {
                groupId: "86642703",
                addonId: "72640349",
              },
              {
                groupId: "86642703",
                addonId: "72640350",
              },
              {
                groupId: "86642703",
                addonId: "72640351",
              },
              {
                groupId: "86642703",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86642703",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86642702",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 40900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "113502225",
      name: "Sizzling Schezwan Chicken",
      category: "Non-Veg Pizza",
      description:
        "Serves 1 | Loaded with our signature spicy schezwan sauce, juicy schezwan chicken meatballs & 100% mozzarella cheese",
      imageId: "4061af0525c00c89f0d1edbe7216765c",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571198",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84360379",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571200",
                  variationId: "84360382",
                },
              },
              {
                name: "Medium",
                id: "84360380",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571200",
                  variationId: "84360388",
                },
              },
            ],
          },
          {
            groupId: "26571200",
            name: "Base",
            variations: [
              {
                name: "Pan",
                price: 319,
                default: 1,
                id: "84360382",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 319,
                id: "84360383",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                id: "84360385",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 394,
                id: "84360386",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Pan",
                price: 569,
                id: "84360388",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 569,
                id: "84360391",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84360392",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Chicken Seekh Kebab",
                price: 668,
                id: "84360394",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360379",
              },
              {
                groupId: "26571200",
                variationId: "84360382",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86643236",
                addonId: "72640314",
              },
              {
                groupId: "86643236",
                addonId: "72640315",
              },
              {
                groupId: "86643236",
                addonId: "72640316",
              },
              {
                groupId: "86643236",
                addonId: "72640317",
              },
              {
                groupId: "86643236",
                addonId: "72640318",
              },
              {
                groupId: "86643236",
                addonId: "72640319",
              },
              {
                groupId: "86643236",
                addonId: "72640320",
              },
              {
                groupId: "86643236",
                addonId: "72640321",
              },
              {
                groupId: "86643236",
                addonId: "72640322",
              },
              {
                groupId: "86643236",
                addonId: "72640323",
              },
              {
                groupId: "86643236",
                addonId: "72640324",
              },
              {
                groupId: "86643236",
                addonId: "72640325",
              },
              {
                groupId: "86643236",
                addonId: "72640326",
              },
              {
                groupId: "86643236",
                addonId: "72640327",
              },
              {
                groupId: "86643236",
                addonId: "72640328",
              },
              {
                groupId: "86643236",
                addonId: "72640329",
              },
              {
                groupId: "86643236",
                addonId: "72640330",
              },
              {
                groupId: "86643236",
                addonId: "72640331",
              },
              {
                groupId: "86643236",
                addonId: "72640332",
              },
              {
                groupId: "86643236",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360379",
              },
              {
                groupId: "26571200",
                variationId: "84360383",
              },
            ],
            price: 31900,
            addonCombinations: [
              {
                groupId: "86643236",
                addonId: "72640314",
              },
              {
                groupId: "86643236",
                addonId: "72640315",
              },
              {
                groupId: "86643236",
                addonId: "72640316",
              },
              {
                groupId: "86643236",
                addonId: "72640317",
              },
              {
                groupId: "86643236",
                addonId: "72640318",
              },
              {
                groupId: "86643236",
                addonId: "72640319",
              },
              {
                groupId: "86643236",
                addonId: "72640320",
              },
              {
                groupId: "86643236",
                addonId: "72640321",
              },
              {
                groupId: "86643236",
                addonId: "72640322",
              },
              {
                groupId: "86643236",
                addonId: "72640323",
              },
              {
                groupId: "86643236",
                addonId: "72640324",
              },
              {
                groupId: "86643236",
                addonId: "72640325",
              },
              {
                groupId: "86643236",
                addonId: "72640326",
              },
              {
                groupId: "86643236",
                addonId: "72640327",
              },
              {
                groupId: "86643236",
                addonId: "72640328",
              },
              {
                groupId: "86643236",
                addonId: "72640329",
              },
              {
                groupId: "86643236",
                addonId: "72640330",
              },
              {
                groupId: "86643236",
                addonId: "72640331",
              },
              {
                groupId: "86643236",
                addonId: "72640332",
              },
              {
                groupId: "86643236",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360379",
              },
              {
                groupId: "26571200",
                variationId: "84360385",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86643236",
                addonId: "72640314",
              },
              {
                groupId: "86643236",
                addonId: "72640315",
              },
              {
                groupId: "86643236",
                addonId: "72640316",
              },
              {
                groupId: "86643236",
                addonId: "72640317",
              },
              {
                groupId: "86643236",
                addonId: "72640318",
              },
              {
                groupId: "86643236",
                addonId: "72640319",
              },
              {
                groupId: "86643236",
                addonId: "72640320",
              },
              {
                groupId: "86643236",
                addonId: "72640321",
              },
              {
                groupId: "86643236",
                addonId: "72640322",
              },
              {
                groupId: "86643236",
                addonId: "72640323",
              },
              {
                groupId: "86643236",
                addonId: "72640324",
              },
              {
                groupId: "86643236",
                addonId: "72640325",
              },
              {
                groupId: "86643236",
                addonId: "72640326",
              },
              {
                groupId: "86643236",
                addonId: "72640327",
              },
              {
                groupId: "86643236",
                addonId: "72640328",
              },
              {
                groupId: "86643236",
                addonId: "72640329",
              },
              {
                groupId: "86643236",
                addonId: "72640330",
              },
              {
                groupId: "86643236",
                addonId: "72640331",
              },
              {
                groupId: "86643236",
                addonId: "72640332",
              },
              {
                groupId: "86643236",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360379",
              },
              {
                groupId: "26571200",
                variationId: "84360386",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86643236",
                addonId: "72640314",
              },
              {
                groupId: "86643236",
                addonId: "72640315",
              },
              {
                groupId: "86643236",
                addonId: "72640316",
              },
              {
                groupId: "86643236",
                addonId: "72640317",
              },
              {
                groupId: "86643236",
                addonId: "72640318",
              },
              {
                groupId: "86643236",
                addonId: "72640319",
              },
              {
                groupId: "86643236",
                addonId: "72640320",
              },
              {
                groupId: "86643236",
                addonId: "72640321",
              },
              {
                groupId: "86643236",
                addonId: "72640322",
              },
              {
                groupId: "86643236",
                addonId: "72640323",
              },
              {
                groupId: "86643236",
                addonId: "72640324",
              },
              {
                groupId: "86643236",
                addonId: "72640325",
              },
              {
                groupId: "86643236",
                addonId: "72640326",
              },
              {
                groupId: "86643236",
                addonId: "72640327",
              },
              {
                groupId: "86643236",
                addonId: "72640328",
              },
              {
                groupId: "86643236",
                addonId: "72640329",
              },
              {
                groupId: "86643236",
                addonId: "72640330",
              },
              {
                groupId: "86643236",
                addonId: "72640331",
              },
              {
                groupId: "86643236",
                addonId: "72640332",
              },
              {
                groupId: "86643236",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360380",
              },
              {
                groupId: "26571200",
                variationId: "84360388",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86643237",
                addonId: "72640334",
              },
              {
                groupId: "86643237",
                addonId: "72640335",
              },
              {
                groupId: "86643237",
                addonId: "72640336",
              },
              {
                groupId: "86643237",
                addonId: "72640337",
              },
              {
                groupId: "86643237",
                addonId: "72640338",
              },
              {
                groupId: "86643237",
                addonId: "72640339",
              },
              {
                groupId: "86643237",
                addonId: "72640340",
              },
              {
                groupId: "86643237",
                addonId: "72640341",
              },
              {
                groupId: "86643237",
                addonId: "72640342",
              },
              {
                groupId: "86643237",
                addonId: "72640343",
              },
              {
                groupId: "86643237",
                addonId: "72640344",
              },
              {
                groupId: "86643237",
                addonId: "72640345",
              },
              {
                groupId: "86643237",
                addonId: "72640346",
              },
              {
                groupId: "86643237",
                addonId: "72640347",
              },
              {
                groupId: "86643237",
                addonId: "72640348",
              },
              {
                groupId: "86643237",
                addonId: "72640349",
              },
              {
                groupId: "86643237",
                addonId: "72640350",
              },
              {
                groupId: "86643237",
                addonId: "72640351",
              },
              {
                groupId: "86643237",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360380",
              },
              {
                groupId: "26571200",
                variationId: "84360391",
              },
            ],
            price: 56900,
            addonCombinations: [
              {
                groupId: "86643237",
                addonId: "72640334",
              },
              {
                groupId: "86643237",
                addonId: "72640335",
              },
              {
                groupId: "86643237",
                addonId: "72640336",
              },
              {
                groupId: "86643237",
                addonId: "72640337",
              },
              {
                groupId: "86643237",
                addonId: "72640338",
              },
              {
                groupId: "86643237",
                addonId: "72640339",
              },
              {
                groupId: "86643237",
                addonId: "72640340",
              },
              {
                groupId: "86643237",
                addonId: "72640341",
              },
              {
                groupId: "86643237",
                addonId: "72640342",
              },
              {
                groupId: "86643237",
                addonId: "72640343",
              },
              {
                groupId: "86643237",
                addonId: "72640344",
              },
              {
                groupId: "86643237",
                addonId: "72640345",
              },
              {
                groupId: "86643237",
                addonId: "72640346",
              },
              {
                groupId: "86643237",
                addonId: "72640347",
              },
              {
                groupId: "86643237",
                addonId: "72640348",
              },
              {
                groupId: "86643237",
                addonId: "72640349",
              },
              {
                groupId: "86643237",
                addonId: "72640350",
              },
              {
                groupId: "86643237",
                addonId: "72640351",
              },
              {
                groupId: "86643237",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360380",
              },
              {
                groupId: "26571200",
                variationId: "84360392",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86643237",
                addonId: "72640334",
              },
              {
                groupId: "86643237",
                addonId: "72640335",
              },
              {
                groupId: "86643237",
                addonId: "72640336",
              },
              {
                groupId: "86643237",
                addonId: "72640337",
              },
              {
                groupId: "86643237",
                addonId: "72640338",
              },
              {
                groupId: "86643237",
                addonId: "72640339",
              },
              {
                groupId: "86643237",
                addonId: "72640340",
              },
              {
                groupId: "86643237",
                addonId: "72640341",
              },
              {
                groupId: "86643237",
                addonId: "72640342",
              },
              {
                groupId: "86643237",
                addonId: "72640343",
              },
              {
                groupId: "86643237",
                addonId: "72640344",
              },
              {
                groupId: "86643237",
                addonId: "72640345",
              },
              {
                groupId: "86643237",
                addonId: "72640346",
              },
              {
                groupId: "86643237",
                addonId: "72640347",
              },
              {
                groupId: "86643237",
                addonId: "72640348",
              },
              {
                groupId: "86643237",
                addonId: "72640349",
              },
              {
                groupId: "86643237",
                addonId: "72640350",
              },
              {
                groupId: "86643237",
                addonId: "72640351",
              },
              {
                groupId: "86643237",
                addonId: "72640352",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571198",
                variationId: "84360380",
              },
              {
                groupId: "26571200",
                variationId: "84360394",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86643237",
                addonId: "72640334",
              },
              {
                groupId: "86643237",
                addonId: "72640335",
              },
              {
                groupId: "86643237",
                addonId: "72640336",
              },
              {
                groupId: "86643237",
                addonId: "72640337",
              },
              {
                groupId: "86643237",
                addonId: "72640338",
              },
              {
                groupId: "86643237",
                addonId: "72640339",
              },
              {
                groupId: "86643237",
                addonId: "72640340",
              },
              {
                groupId: "86643237",
                addonId: "72640341",
              },
              {
                groupId: "86643237",
                addonId: "72640342",
              },
              {
                groupId: "86643237",
                addonId: "72640343",
              },
              {
                groupId: "86643237",
                addonId: "72640344",
              },
              {
                groupId: "86643237",
                addonId: "72640345",
              },
              {
                groupId: "86643237",
                addonId: "72640346",
              },
              {
                groupId: "86643237",
                addonId: "72640347",
              },
              {
                groupId: "86643237",
                addonId: "72640348",
              },
              {
                groupId: "86643237",
                addonId: "72640349",
              },
              {
                groupId: "86643237",
                addonId: "72640350",
              },
              {
                groupId: "86643237",
                addonId: "72640351",
              },
              {
                groupId: "86643237",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643236",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643237",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 31900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Garlic Bread": [
    {
      id: "12036702",
      name: "Cheese Garlic Bread",
      category: "Garlic Bread",
      description: "Serves 1 | Nothing beats our garlic bread! Period!",
      imageId: "ziohlqoy38mfqzmfxy7e",
      inStock: 1,
      isVeg: 1,
      price: 15900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "33 ratings",
          ratingCountV2: "33",
        },
      },
    },
    {
      id: "21852758",
      name: "Garlic Bread Stix",
      category: "Garlic Bread",
      description:
        "Serves 1 | Garlic Breadsticks, the perfect pizza companion.",
      imageId: "n2ycmete7ehes9mrerlw",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "41 ratings",
          ratingCountV2: "41",
        },
      },
    },
    {
      id: "47200073",
      name: "Garlic Bread Spicy Supreme",
      category: "Garlic Bread",
      description:
        "Serves 1 | Garlic bread topped with (Mozzarella cheeese , onion & green chillies ).",
      imageId: "m8ecjvtqcjtnt31uvobl",
      inStock: 1,
      isVeg: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "47200074",
      name: "Creamy Garlic Breadstix",
      category: "Garlic Bread",
      description:
        "Serves 1 | Classic Garlic breadsticks with a twist of creamy sauce",
      imageId: "o0zibtrbtyjwznptrsgy",
      inStock: 1,
      isVeg: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "37 ratings",
          ratingCountV2: "37",
        },
      },
    },
    {
      id: "87274226",
      name: "Mexican Garlic Breadstix",
      category: "Garlic Bread",
      description:
        "Serves 1 | Freshly baked San Francisco Style breadsticks topped with chopped onion, green capsicum, red capsicum, jalapeno, black olives & drizzled with olive oil",
      imageId: "dzuiex47nfr408tihonk",
      inStock: 1,
      isVeg: 1,
      price: 15900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
  ],
  "San Francisco Pizzas : Lighter & Crispier": [
    {
      id: "114274178",
      name: "Chicken Supreme",
      category: "San Francisco Pizzas : Lighter & Crispier",
      description:
        "Serves 1 | Light & crispy new San Francisco Style Crust, topped with Chef's special sauce and a drizzle of extra virgin olive oil.",
      imageId: "gi7ytl3oe2327x3ypibr",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570821",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84358591",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570822",
                  variationId: "84358596",
                },
              },
              {
                name: "Medium",
                id: "84358593",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570822",
                  variationId: "84358598",
                },
              },
            ],
          },
          {
            groupId: "26570822",
            name: "Base",
            variations: [
              {
                name: "San Francisco Style",
                price: 409,
                default: 1,
                id: "84358596",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "San Francisco Style",
                price: 699,
                id: "84358598",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570821",
                variationId: "84358591",
              },
              {
                groupId: "26570822",
                variationId: "84358596",
              },
            ],
            price: 40900,
            addonCombinations: [
              {
                groupId: "86643074",
                addonId: "72640314",
              },
              {
                groupId: "86643074",
                addonId: "72640315",
              },
              {
                groupId: "86643074",
                addonId: "72640316",
              },
              {
                groupId: "86643074",
                addonId: "72640317",
              },
              {
                groupId: "86643074",
                addonId: "72640318",
              },
              {
                groupId: "86643074",
                addonId: "72640319",
              },
              {
                groupId: "86643074",
                addonId: "72640320",
              },
              {
                groupId: "86643074",
                addonId: "72640321",
              },
              {
                groupId: "86643074",
                addonId: "72640322",
              },
              {
                groupId: "86643074",
                addonId: "72640323",
              },
              {
                groupId: "86643074",
                addonId: "72640324",
              },
              {
                groupId: "86643074",
                addonId: "72640325",
              },
              {
                groupId: "86643074",
                addonId: "72640326",
              },
              {
                groupId: "86643074",
                addonId: "72640327",
              },
              {
                groupId: "86643074",
                addonId: "72640328",
              },
              {
                groupId: "86643074",
                addonId: "72640329",
              },
              {
                groupId: "86643074",
                addonId: "72640330",
              },
              {
                groupId: "86643074",
                addonId: "72640331",
              },
              {
                groupId: "86643074",
                addonId: "72640332",
              },
              {
                groupId: "86643074",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26570821",
                variationId: "84358593",
              },
              {
                groupId: "26570822",
                variationId: "84358598",
              },
            ],
            price: 69900,
            addonCombinations: [
              {
                groupId: "86643077",
                addonId: "72640334",
              },
              {
                groupId: "86643077",
                addonId: "72640335",
              },
              {
                groupId: "86643077",
                addonId: "72640336",
              },
              {
                groupId: "86643077",
                addonId: "72640337",
              },
              {
                groupId: "86643077",
                addonId: "72640338",
              },
              {
                groupId: "86643077",
                addonId: "72640339",
              },
              {
                groupId: "86643077",
                addonId: "72640340",
              },
              {
                groupId: "86643077",
                addonId: "72640341",
              },
              {
                groupId: "86643077",
                addonId: "72640342",
              },
              {
                groupId: "86643077",
                addonId: "72640343",
              },
              {
                groupId: "86643077",
                addonId: "72640344",
              },
              {
                groupId: "86643077",
                addonId: "72640345",
              },
              {
                groupId: "86643077",
                addonId: "72640346",
              },
              {
                groupId: "86643077",
                addonId: "72640347",
              },
              {
                groupId: "86643077",
                addonId: "72640348",
              },
              {
                groupId: "86643077",
                addonId: "72640349",
              },
              {
                groupId: "86643077",
                addonId: "72640350",
              },
              {
                groupId: "86643077",
                addonId: "72640351",
              },
              {
                groupId: "86643077",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643077",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643074",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 40900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
  ],
  "Meals & Deals (Save Upto 51% - No Coupon Required)": [
    {
      id: "95899799",
      name: "My Box - Veg",
      category: "Meals & Deals (Save Upto 51% - No Coupon Required)",
      description:
        "Serves 1 | 1 Personal Veg Pizza, 2 Pc Garlic Bread & 1 Pepsi Pet Bottle!",
      imageId: "enj70rnnmrp9i9rufmkh",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26569643",
            name: "Pizza",
            variations: [
              {
                name: "Margherita",
                price: 142,
                default: 1,
                id: "84352586",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Corn and Cheese",
                price: 192,
                id: "84352588",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Tandoori Onion",
                price: 192,
                id: "84352590",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Veggie Feast",
                price: 212,
                id: "84352592",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Double Cheese",
                price: 212,
                id: "84352594",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Spiced Paneer",
                price: 212,
                id: "84352596",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Veggie Tandoori",
                price: 212,
                id: "84352598",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Country Feast",
                price: 232,
                id: "84352600",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Farmers Pick",
                price: 232,
                id: "84352602",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Tandoori Paneer",
                price: 232,
                id: "84352604",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Veggie Lover",
                price: 232,
                id: "84352605",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Veg Kebab Surprise",
                price: 252,
                id: "84352606",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Veggie Supreme",
                price: 252,
                id: "84352607",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Veg Exotica",
                price: 252,
                id: "84352608",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
              {
                name: "Double Paneer Supreme",
                price: 252,
                id: "84352609",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569644",
                  variationId: "84352611",
                },
              },
            ],
          },
          {
            groupId: "26569644",
            name: "Garlic Bread",
            variations: [
              {
                name: "2 Pcs Cheese Garlic Bread",
                price: 70,
                id: "84352610",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569645",
                  variationId: "84352612",
                },
              },
              {
                name: "2 Pcs Garlic Bread",
                price: 50,
                default: 1,
                id: "84352611",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26569645",
                  variationId: "84352612",
                },
              },
            ],
          },
          {
            groupId: "26569645",
            name: "Beverage",
            variations: [
              {
                name: "Pepsi Pet Bottle",
                price: 57,
                default: 1,
                id: "84352612",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352586",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 26900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352586",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 24900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352588",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 31900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352588",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 29900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352590",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 31900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352590",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 29900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352592",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352592",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 31900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352594",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352594",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 31900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352596",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352596",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 31900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352598",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352598",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 31900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352600",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352600",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352602",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352602",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352604",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352604",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352605",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352605",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 33900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352606",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 37900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352606",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352607",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 37900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352607",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352608",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 37900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352608",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352609",
              },
              {
                groupId: "26569644",
                variationId: "84352610",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 37900,
          },
          {
            variations: [
              {
                groupId: "26569643",
                variationId: "84352609",
              },
              {
                groupId: "26569644",
                variationId: "84352611",
              },
              {
                groupId: "26569645",
                variationId: "84352612",
              },
            ],
            price: 35900,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 24900,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
  ],
  Dessert: [
    {
      id: "12036660",
      name: "Choco Volcano",
      category: "Dessert",
      description: "Serves 1 | Warm choco cake with gooey center",
      imageId: "k76b8gwkiskwhc9p7nbt",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "71489028",
      name: "Choco Sundae (Inclusive of frozen dessert handling charges)",
      category: "Dessert",
      description:
        "Serves 1 | Choco Sundae Cup (100 ml) (Inclusive of frozen dessert handling charges)",
      imageId: "du6le6m1bxcuz0iorbp1",
      inStock: 1,
      isVeg: 1,
      price: 4357,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "71489029",
      name: "Cornetto Double Chocolate (Inclusive of frozen dessert handling charges)",
      category: "Dessert",
      description:
        "Serves 1 | Cornetto Double Chocolate Cone (105 ml) (Inclusive of frozen dessert handling charges)",
      imageId: "png4dvqoeorjqifznuu4",
      inStock: 1,
      isVeg: 1,
      price: 5310,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "110504597",
      name: "Desi Kulfi (Inclusive of frozen dessert handling charges)",
      category: "Dessert",
      description:
        "Serves 1 | Desi Kulfi Cup (100ml) (Inclusive of frozen dessert handling charges)",
      imageId: "klwvwcqnbmqtgwabjdja",
      inStock: 1,
      isVeg: 1,
      price: 6262,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110504598",
      name: "Oreo & Cream (Inclusive of frozen dessert handling charges)",
      category: "Dessert",
      description:
        "Serves 1 | Oreo & CreamTub (700ml) (Inclusive of frozen dessert handling charges)",
      imageId: "m65kfba5osptyuxuwrro",
      inStock: 1,
      isVeg: 1,
      price: 29976,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  undefined: [
    {
      id: "97598277",
      name: "Create Your Flavour Fun Combo - Box Of 4 - Veg",
      description:
        "Get 4 assorted Flavor Fun Personal Pizzas. Perfect Personal Pizza crust topped with exciting new sauces, cheesy dressing & your favorite toppings",
      imageId: "job6jpsy58ua24htsn1q",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570933",
            name: "Choose your 1st Pizza",
            variations: [
              {
                name: "Classic Corn",
                price: 99.75,
                default: 1,
                id: "84359129",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570936",
                  variationId: "84359148",
                },
              },
              {
                name: "Classic Onion Capsicum",
                price: 99.75,
                id: "84359131",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570936",
                  variationId: "84359148",
                },
              },
              {
                name: "Italian Onion Tomato",
                price: 99.75,
                id: "84359133",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570936",
                  variationId: "84359148",
                },
              },
              {
                name: "Tandoori Mushroom & Sweet Corn",
                price: 109.75,
                id: "84359135",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570936",
                  variationId: "84359148",
                },
              },
              {
                name: "Schezwan Corn & Capsicum",
                price: 99.75,
                id: "84359137",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570936",
                  variationId: "84359148",
                },
              },
              {
                name: "Only Cheesy",
                price: 124.75,
                id: "84359142",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570936",
                  variationId: "84359148",
                },
              },
              {
                name: "Classic Paneer, Capsicum & Onion",
                price: 134.75,
                id: "84359144",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570936",
                  variationId: "84359148",
                },
              },
            ],
          },
          {
            groupId: "26570936",
            name: "Choose your 2nd Pizza",
            variations: [
              {
                name: "Classic Corn",
                price: 99.75,
                default: 1,
                id: "84359148",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570937",
                  variationId: "84359161",
                },
              },
              {
                name: "Classic Onion Capsicum",
                price: 99.75,
                id: "84359151",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570937",
                  variationId: "84359161",
                },
              },
              {
                name: "Italian Onion Tomato",
                price: 99.75,
                id: "84359154",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570937",
                  variationId: "84359161",
                },
              },
              {
                name: "Tandoori Mushroom & Sweet Corn",
                price: 109.75,
                id: "84359157",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570937",
                  variationId: "84359161",
                },
              },
              {
                name: "Schezwan Corn & Capsicum",
                price: 99.75,
                id: "84359158",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570937",
                  variationId: "84359161",
                },
              },
              {
                name: "Only Cheesy",
                price: 124.75,
                id: "84359159",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570937",
                  variationId: "84359161",
                },
              },
              {
                name: "Classic Paneer, Capsicum & Onion",
                price: 134.75,
                id: "84359160",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570937",
                  variationId: "84359161",
                },
              },
            ],
          },
          {
            groupId: "26570937",
            name: "Choose your 3rd Pizza",
            variations: [
              {
                name: "Classic Corn",
                price: 99.75,
                default: 1,
                id: "84359161",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570938",
                  variationId: "84359168",
                },
              },
              {
                name: "Classic Onion Capsicum",
                price: 99.75,
                id: "84359162",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570938",
                  variationId: "84359168",
                },
              },
              {
                name: "Italian Onion Tomato",
                price: 99.75,
                id: "84359163",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570938",
                  variationId: "84359168",
                },
              },
              {
                name: "Tandoori Mushroom & Sweet Corn",
                price: 109.75,
                id: "84359164",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570938",
                  variationId: "84359168",
                },
              },
              {
                name: "Schezwan Corn & Capsicum",
                price: 99.75,
                id: "84359165",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570938",
                  variationId: "84359168",
                },
              },
              {
                name: "Only Cheesy",
                price: 124.75,
                id: "84359166",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570938",
                  variationId: "84359168",
                },
              },
              {
                name: "Classic Paneer, Capsicum & Onion",
                price: 134.75,
                id: "84359167",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570938",
                  variationId: "84359168",
                },
              },
            ],
          },
          {
            groupId: "26570938",
            name: "Choose your 4th Pizza",
            variations: [
              {
                name: "Classic Corn",
                price: 99.75,
                default: 1,
                id: "84359168",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Classic Onion Capsicum",
                price: 99.75,
                id: "84359169",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Italian Onion Tomato",
                price: 99.75,
                id: "84359170",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tandoori Mushroom & Sweet Corn",
                price: 109.75,
                id: "84359171",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan Corn & Capsicum",
                price: 99.75,
                id: "84359172",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Only Cheesy",
                price: 124.75,
                id: "84359173",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Classic Paneer, Capsicum & Onion",
                price: 134.75,
                id: "84359174",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359129",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359131",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359133",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359135",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 42900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 41900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 40900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 39900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359137",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 42400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 47400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 50900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 51900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 50900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 51900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 51900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359142",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 52900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359148",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359151",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359154",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359157",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 45400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 43400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359158",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 45900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 48400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 50900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 51900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 51900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359159",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 52900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359161",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359162",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359163",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359164",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 47900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 46900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359165",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 49400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 51900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359166",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 52900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359168",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359169",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359170",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359171",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359172",
              },
            ],
            price: 50400,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359173",
              },
            ],
            price: 52900,
          },
          {
            variations: [
              {
                groupId: "26570933",
                variationId: "84359144",
              },
              {
                groupId: "26570936",
                variationId: "84359160",
              },
              {
                groupId: "26570937",
                variationId: "84359167",
              },
              {
                groupId: "26570938",
                variationId: "84359174",
              },
            ],
            price: 53900,
          },
        ],
      },
      defaultPrice: 39900,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "20 ratings",
          ratingCountV2: "20",
        },
      },
    },
  ],
  "Cheese Maxx Lovers": [
    {
      id: "113195680",
      name: "Cheese Maxx Veggie Feast",
      category: "Cheese Maxx Lovers",
      description:
        "Serves 1 | Crust filled with creamy cheese, base loaded with gooey liquid cheese, topped with 100% real mozzarella cheese, herbed onion & green capsicum, sweet corn",
      imageId: "4e180e8fc62923bffa49a4b0f28d8c1b",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571118",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84360025",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571119",
                  variationId: "84360027",
                },
              },
              {
                name: "Medium",
                id: "84360026",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571119",
                  variationId: "84360028",
                },
              },
            ],
          },
          {
            groupId: "26571119",
            name: "Base",
            variations: [
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 334,
                default: 1,
                id: "84360027",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 588,
                id: "84360028",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571118",
                variationId: "84360025",
              },
              {
                groupId: "26571119",
                variationId: "84360027",
              },
            ],
            price: 33400,
            addonCombinations: [
              {
                groupId: "86643200",
                addonId: "72640314",
              },
              {
                groupId: "86643200",
                addonId: "72640315",
              },
              {
                groupId: "86643200",
                addonId: "72640316",
              },
              {
                groupId: "86643200",
                addonId: "72640317",
              },
              {
                groupId: "86643200",
                addonId: "72640318",
              },
              {
                groupId: "86643200",
                addonId: "72640319",
              },
              {
                groupId: "86643200",
                addonId: "72640320",
              },
              {
                groupId: "86643200",
                addonId: "72640321",
              },
              {
                groupId: "86643200",
                addonId: "72640322",
              },
              {
                groupId: "86643200",
                addonId: "72640323",
              },
              {
                groupId: "86643200",
                addonId: "72640324",
              },
              {
                groupId: "86643200",
                addonId: "72640325",
              },
              {
                groupId: "86643200",
                addonId: "72640326",
              },
              {
                groupId: "86643200",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571118",
                variationId: "84360026",
              },
              {
                groupId: "26571119",
                variationId: "84360028",
              },
            ],
            price: 58800,
            addonCombinations: [
              {
                groupId: "86643198",
                addonId: "72640334",
              },
              {
                groupId: "86643198",
                addonId: "72640335",
              },
              {
                groupId: "86643198",
                addonId: "72640336",
              },
              {
                groupId: "86643198",
                addonId: "72640337",
              },
              {
                groupId: "86643198",
                addonId: "72640338",
              },
              {
                groupId: "86643198",
                addonId: "72640339",
              },
              {
                groupId: "86643198",
                addonId: "72640340",
              },
              {
                groupId: "86643198",
                addonId: "72640341",
              },
              {
                groupId: "86643198",
                addonId: "72640342",
              },
              {
                groupId: "86643198",
                addonId: "72640343",
              },
              {
                groupId: "86643198",
                addonId: "72640344",
              },
              {
                groupId: "86643198",
                addonId: "72640345",
              },
              {
                groupId: "86643198",
                addonId: "72640346",
              },
              {
                groupId: "86643198",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643198",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643200",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 33400,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "113195681",
      name: "Cheese Maxx Veggie Supreme",
      category: "Cheese Maxx Lovers",
      description:
        "Serves 1 | Crust filled with creamy cheese, base loaded with gooey liquid cheese, topped with 100% real mozzarella cheese, onion, green capsicum, mushroom, red paprika, black olive & sweet corn",
      imageId: "54d38520e8acce8295330478fc87af43",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571131",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84360077",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571132",
                  variationId: "84360079",
                },
              },
              {
                name: "Medium",
                id: "84360078",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571132",
                  variationId: "84360080",
                },
              },
            ],
          },
          {
            groupId: "26571132",
            name: "Base",
            variations: [
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                default: 1,
                id: "84360079",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84360080",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571131",
                variationId: "84360077",
              },
              {
                groupId: "26571132",
                variationId: "84360079",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86643205",
                addonId: "72640314",
              },
              {
                groupId: "86643205",
                addonId: "72640315",
              },
              {
                groupId: "86643205",
                addonId: "72640316",
              },
              {
                groupId: "86643205",
                addonId: "72640317",
              },
              {
                groupId: "86643205",
                addonId: "72640318",
              },
              {
                groupId: "86643205",
                addonId: "72640319",
              },
              {
                groupId: "86643205",
                addonId: "72640320",
              },
              {
                groupId: "86643205",
                addonId: "72640321",
              },
              {
                groupId: "86643205",
                addonId: "72640322",
              },
              {
                groupId: "86643205",
                addonId: "72640323",
              },
              {
                groupId: "86643205",
                addonId: "72640324",
              },
              {
                groupId: "86643205",
                addonId: "72640325",
              },
              {
                groupId: "86643205",
                addonId: "72640326",
              },
              {
                groupId: "86643205",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571131",
                variationId: "84360078",
              },
              {
                groupId: "26571132",
                variationId: "84360080",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86643203",
                addonId: "72640334",
              },
              {
                groupId: "86643203",
                addonId: "72640335",
              },
              {
                groupId: "86643203",
                addonId: "72640336",
              },
              {
                groupId: "86643203",
                addonId: "72640337",
              },
              {
                groupId: "86643203",
                addonId: "72640338",
              },
              {
                groupId: "86643203",
                addonId: "72640339",
              },
              {
                groupId: "86643203",
                addonId: "72640340",
              },
              {
                groupId: "86643203",
                addonId: "72640341",
              },
              {
                groupId: "86643203",
                addonId: "72640342",
              },
              {
                groupId: "86643203",
                addonId: "72640343",
              },
              {
                groupId: "86643203",
                addonId: "72640344",
              },
              {
                groupId: "86643203",
                addonId: "72640345",
              },
              {
                groupId: "86643203",
                addonId: "72640346",
              },
              {
                groupId: "86643203",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643203",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643205",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 45400,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "113195682",
      name: "Cheese Maxx Country Feast",
      category: "Cheese Maxx Lovers",
      description:
        "Serves 1 | Crust filled with creamy cheese, base loaded with gooey liquid cheese, topped with 100% real mozzarella cheese, herbed onion & green capsicum, sweet corn, tomato & mushroom",
      imageId: "61fc955693f1bc62885133e75c26ea6c",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571141",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84360113",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571142",
                  variationId: "84360115",
                },
              },
              {
                name: "Medium",
                id: "84360114",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571142",
                  variationId: "84360116",
                },
              },
            ],
          },
          {
            groupId: "26571142",
            name: "Base",
            variations: [
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 394,
                default: 1,
                id: "84360115",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 668,
                id: "84360116",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571141",
                variationId: "84360113",
              },
              {
                groupId: "26571142",
                variationId: "84360115",
              },
            ],
            price: 39400,
            addonCombinations: [
              {
                groupId: "86643211",
                addonId: "72640314",
              },
              {
                groupId: "86643211",
                addonId: "72640315",
              },
              {
                groupId: "86643211",
                addonId: "72640316",
              },
              {
                groupId: "86643211",
                addonId: "72640317",
              },
              {
                groupId: "86643211",
                addonId: "72640318",
              },
              {
                groupId: "86643211",
                addonId: "72640319",
              },
              {
                groupId: "86643211",
                addonId: "72640320",
              },
              {
                groupId: "86643211",
                addonId: "72640321",
              },
              {
                groupId: "86643211",
                addonId: "72640322",
              },
              {
                groupId: "86643211",
                addonId: "72640323",
              },
              {
                groupId: "86643211",
                addonId: "72640324",
              },
              {
                groupId: "86643211",
                addonId: "72640325",
              },
              {
                groupId: "86643211",
                addonId: "72640326",
              },
              {
                groupId: "86643211",
                addonId: "72640327",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571141",
                variationId: "84360114",
              },
              {
                groupId: "26571142",
                variationId: "84360116",
              },
            ],
            price: 66800,
            addonCombinations: [
              {
                groupId: "86643210",
                addonId: "72640334",
              },
              {
                groupId: "86643210",
                addonId: "72640335",
              },
              {
                groupId: "86643210",
                addonId: "72640336",
              },
              {
                groupId: "86643210",
                addonId: "72640337",
              },
              {
                groupId: "86643210",
                addonId: "72640338",
              },
              {
                groupId: "86643210",
                addonId: "72640339",
              },
              {
                groupId: "86643210",
                addonId: "72640340",
              },
              {
                groupId: "86643210",
                addonId: "72640341",
              },
              {
                groupId: "86643210",
                addonId: "72640342",
              },
              {
                groupId: "86643210",
                addonId: "72640343",
              },
              {
                groupId: "86643210",
                addonId: "72640344",
              },
              {
                groupId: "86643210",
                addonId: "72640345",
              },
              {
                groupId: "86643210",
                addonId: "72640346",
              },
              {
                groupId: "86643210",
                addonId: "72640394",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643210",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640394",
              name: "Veg Kebab",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643211",
          groupName: "Toppings",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 39400,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "113195683",
      name: "Cheese Maxx Chicken Tikka",
      category: "Cheese Maxx Lovers",
      description:
        "Serves 1 | Crust filled with creamy cheese, base loaded with gooey liquid cheese, topped with 100% real mozzarella cheese, chicken tikka, tomato & onion",
      imageId: "39688c255b712a6e99ccf19d20af826a",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571147",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84360146",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571148",
                  variationId: "84360151",
                },
              },
              {
                name: "Medium",
                id: "84360148",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571148",
                  variationId: "84360153",
                },
              },
            ],
          },
          {
            groupId: "26571148",
            name: "Base",
            variations: [
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 454,
                default: 1,
                id: "84360151",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 738,
                id: "84360153",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571147",
                variationId: "84360146",
              },
              {
                groupId: "26571148",
                variationId: "84360151",
              },
            ],
            price: 45400,
            addonCombinations: [
              {
                groupId: "86643214",
                addonId: "72640314",
              },
              {
                groupId: "86643214",
                addonId: "72640315",
              },
              {
                groupId: "86643214",
                addonId: "72640316",
              },
              {
                groupId: "86643214",
                addonId: "72640317",
              },
              {
                groupId: "86643214",
                addonId: "72640318",
              },
              {
                groupId: "86643214",
                addonId: "72640319",
              },
              {
                groupId: "86643214",
                addonId: "72640320",
              },
              {
                groupId: "86643214",
                addonId: "72640321",
              },
              {
                groupId: "86643214",
                addonId: "72640322",
              },
              {
                groupId: "86643214",
                addonId: "72640323",
              },
              {
                groupId: "86643214",
                addonId: "72640324",
              },
              {
                groupId: "86643214",
                addonId: "72640325",
              },
              {
                groupId: "86643214",
                addonId: "72640326",
              },
              {
                groupId: "86643214",
                addonId: "72640327",
              },
              {
                groupId: "86643214",
                addonId: "72640328",
              },
              {
                groupId: "86643214",
                addonId: "72640329",
              },
              {
                groupId: "86643214",
                addonId: "72640330",
              },
              {
                groupId: "86643214",
                addonId: "72640331",
              },
              {
                groupId: "86643214",
                addonId: "72640332",
              },
              {
                groupId: "86643214",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571147",
                variationId: "84360148",
              },
              {
                groupId: "26571148",
                variationId: "84360153",
              },
            ],
            price: 73800,
            addonCombinations: [
              {
                groupId: "86643216",
                addonId: "72640334",
              },
              {
                groupId: "86643216",
                addonId: "72640335",
              },
              {
                groupId: "86643216",
                addonId: "72640336",
              },
              {
                groupId: "86643216",
                addonId: "72640337",
              },
              {
                groupId: "86643216",
                addonId: "72640338",
              },
              {
                groupId: "86643216",
                addonId: "72640339",
              },
              {
                groupId: "86643216",
                addonId: "72640340",
              },
              {
                groupId: "86643216",
                addonId: "72640341",
              },
              {
                groupId: "86643216",
                addonId: "72640342",
              },
              {
                groupId: "86643216",
                addonId: "72640343",
              },
              {
                groupId: "86643216",
                addonId: "72640344",
              },
              {
                groupId: "86643216",
                addonId: "72640345",
              },
              {
                groupId: "86643216",
                addonId: "72640346",
              },
              {
                groupId: "86643216",
                addonId: "72640347",
              },
              {
                groupId: "86643216",
                addonId: "72640348",
              },
              {
                groupId: "86643216",
                addonId: "72640349",
              },
              {
                groupId: "86643216",
                addonId: "72640350",
              },
              {
                groupId: "86643216",
                addonId: "72640351",
              },
              {
                groupId: "86643216",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643214",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643216",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 45400,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "113195684",
      name: "Cheese Maxx Chicken Supreme",
      category: "Cheese Maxx Lovers",
      description:
        "Serves 1 | Crust filled with creamy cheese, base loaded with gooey liquid cheese, topped with 100% real mozzarella cheese, herbed chicken, schezwan chicken meatball & chicken tikka",
      imageId: "fe4e5f22c1cc2eb731558d2c7070f7b2",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571186",
            name: "Size",
            variations: [
              {
                name: "Personal",
                default: 1,
                id: "84360324",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571187",
                  variationId: "84360326",
                },
              },
              {
                name: "Medium",
                id: "84360325",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26571187",
                  variationId: "84360328",
                },
              },
            ],
          },
          {
            groupId: "26571187",
            name: "Base",
            variations: [
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 484,
                default: 1,
                id: "84360326",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Stuffed Crust - Cheese Maxx",
                price: 798,
                id: "84360328",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571186",
                variationId: "84360324",
              },
              {
                groupId: "26571187",
                variationId: "84360326",
              },
            ],
            price: 48400,
            addonCombinations: [
              {
                groupId: "86643230",
                addonId: "72640314",
              },
              {
                groupId: "86643230",
                addonId: "72640315",
              },
              {
                groupId: "86643230",
                addonId: "72640316",
              },
              {
                groupId: "86643230",
                addonId: "72640317",
              },
              {
                groupId: "86643230",
                addonId: "72640318",
              },
              {
                groupId: "86643230",
                addonId: "72640319",
              },
              {
                groupId: "86643230",
                addonId: "72640320",
              },
              {
                groupId: "86643230",
                addonId: "72640321",
              },
              {
                groupId: "86643230",
                addonId: "72640322",
              },
              {
                groupId: "86643230",
                addonId: "72640323",
              },
              {
                groupId: "86643230",
                addonId: "72640324",
              },
              {
                groupId: "86643230",
                addonId: "72640325",
              },
              {
                groupId: "86643230",
                addonId: "72640326",
              },
              {
                groupId: "86643230",
                addonId: "72640327",
              },
              {
                groupId: "86643230",
                addonId: "72640328",
              },
              {
                groupId: "86643230",
                addonId: "72640329",
              },
              {
                groupId: "86643230",
                addonId: "72640330",
              },
              {
                groupId: "86643230",
                addonId: "72640331",
              },
              {
                groupId: "86643230",
                addonId: "72640332",
              },
              {
                groupId: "86643230",
                addonId: "72640333",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "26571186",
                variationId: "84360325",
              },
              {
                groupId: "26571187",
                variationId: "84360328",
              },
            ],
            price: 79800,
            addonCombinations: [
              {
                groupId: "86643231",
                addonId: "72640334",
              },
              {
                groupId: "86643231",
                addonId: "72640335",
              },
              {
                groupId: "86643231",
                addonId: "72640336",
              },
              {
                groupId: "86643231",
                addonId: "72640337",
              },
              {
                groupId: "86643231",
                addonId: "72640338",
              },
              {
                groupId: "86643231",
                addonId: "72640339",
              },
              {
                groupId: "86643231",
                addonId: "72640340",
              },
              {
                groupId: "86643231",
                addonId: "72640341",
              },
              {
                groupId: "86643231",
                addonId: "72640342",
              },
              {
                groupId: "86643231",
                addonId: "72640343",
              },
              {
                groupId: "86643231",
                addonId: "72640344",
              },
              {
                groupId: "86643231",
                addonId: "72640345",
              },
              {
                groupId: "86643231",
                addonId: "72640346",
              },
              {
                groupId: "86643231",
                addonId: "72640347",
              },
              {
                groupId: "86643231",
                addonId: "72640348",
              },
              {
                groupId: "86643231",
                addonId: "72640349",
              },
              {
                groupId: "86643231",
                addonId: "72640350",
              },
              {
                groupId: "86643231",
                addonId: "72640351",
              },
              {
                groupId: "86643231",
                addonId: "72640352",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "86643230",
          groupName: "Toppings.",
          choices: [
            {
              id: "72640314",
              name: "Cheese",
              price: 6500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640316",
              name: "Baby Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640315",
              name: "Black Olives",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640317",
              name: "Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640318",
              name: "Herbed Veggies",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640319",
              name: "Jalapeno",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640320",
              name: "Mushroom",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640321",
              name: "Onion",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640322",
              name: "Paneer",
              price: 5500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640323",
              name: "Red Paprika",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640324",
              name: "Red Capsicum",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640325",
              name: "Sweet Corn",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640326",
              name: "Tomato",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640327",
              name: "Veg Kebab",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640329",
              name: "Chicken Sausage",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640328",
              name: "Chicken Pepperoni",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640330",
              name: "Chicken Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640332",
              name: "Herbed Chicken",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640331",
              name: "Chicken Malai Tikka",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640333",
              name: "Schezwan Chicken Meatball",
              price: 6500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "86643231",
          groupName: "Toppings",
          choices: [
            {
              id: "72640334",
              name: "Cheese",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640336",
              name: "Baby Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640335",
              name: "Black Olives",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640337",
              name: "Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640338",
              name: "Herbed Veggies",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640339",
              name: "Jalapeno",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640340",
              name: "Mushroom",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640341",
              name: "Onion",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640342",
              name: "Paneer",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640343",
              name: "Red Paprika",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640344",
              name: "Red Capsicum",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640345",
              name: "Sweet Corn",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640346",
              name: "Tomato",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "72640350",
              name: "Chicken Malai Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640347",
              name: "Chicken Pepperoni",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640349",
              name: "Chicken Sausage",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640348",
              name: "Chicken Tikka",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640351",
              name: "Herbed Chicken",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "72640352",
              name: "Schezwan Chicken Meatball",
              price: 8500,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 48400,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Pasta: [
    {
      id: "61493636",
      name: "Cheesy Comfort",
      category: "Pasta",
      description:
        "Serves 1 | Cheesy creamy pasta comfort topped with onion, green capsicum, red capsicum & sweet corn",
      imageId: "f2miudjhhrpyeyxn23dz",
      inStock: 1,
      isVeg: 1,
      price: 23900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "61493637",
      name: "Cheesy Comfort - Non Veg",
      category: "Pasta",
      description:
        "Serves 1 | Cheesy creamy pasta comfort topped with chicken sausage, onion, green capsicum & red capsicum",
      imageId: "u7v7arnpdxmffedcrmtq",
      inStock: 1,
      price: 26900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "61493639",
      name: "Spiced Tomato Twist Veg",
      category: "Pasta",
      description:
        "Serves 1 | Tangy flavourful red sauce pasta infused with heavenly herbs & spices topped with onion, green capsicum & red capsicum",
      imageId: "nzq6soxhtqgeslmqufrq",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "61493642",
      name: "Spiced Tomato Twist Non Veg",
      category: "Pasta",
      description:
        "Serves 1 | Tangy flavourful red sauce pasta infused with heavenly herbs & spices topped with chicken sausage",
      imageId: "sqfmbhg8tdrslyn49shw",
      inStock: 1,
      price: 24900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66540679",
      name: "Creamy Mushroom Pasta",
      category: "Pasta",
      description:
        "Serves 1 | Pasta in a rich creamy mushroom sauce flavored with garlic & parsley!",
      imageId: "kcgpendnr72r4ljbdhvw",
      inStock: 1,
      isVeg: 1,
      price: 29900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  Appetizer: [
    {
      id: "33235206",
      name: "Spicy Baked Chicken Wings",
      category: "Appetizer",
      description: "Serves 1 | Tender and Juicy sweet chilli chicken wings.",
      imageId: "aeems3ogejdzxfjblkx7",
      inStock: 1,
      price: 25900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "55368108",
      name: "Jalapeno Poppers",
      category: "Appetizer",
      description: "Serves 1 | Jalapano poppers with gooey white sauce.",
      imageId: "oqfrpjaw6v4q3p3qafww",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "55978804",
      name: "Spicy Baked Chicken Wings (4 pcs)",
      category: "Appetizer",
      description:
        "Serves 1 | 4 pcs of Tender and Juicy sweet chilly chicken wings.",
      imageId: "f5fyw9eyvkdjvybjhgho",
      inStock: 1,
      price: 20900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "59570146",
      name: "Potato Poppers",
      category: "Appetizer",
      description: "Serves 1 | Baked chilli garlic potato bites.",
      imageId: "frdlg5f2vnfcvrztvoyi",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "60786858",
      name: "Zesty Chicken Pocket",
      category: "Appetizer",
      description:
        "Serves 1 | Freshly baked pocket stuffed with chicken, veggies & smoked texas garlic sauce",
      imageId: "wukqmbrmv0vngtlrczgw",
      inStock: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "60786859",
      name: "Zesty Paneer Pocket",
      category: "Appetizer",
      description:
        "Serves 1 | Freshly baked pocket stuffed with flavourful paneer, veggies & smoked texas garlic sauce",
      imageId: "spmefmk8u9ftwbvdk6ay",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "61493647",
      name: "Indi Rockin Roll Non Veg",
      category: "Appetizer",
      description:
        "Serves 1 | Soft tortilla roll stuffed with chicken tikka, mint mayo & melted mozzarella cheese goodness",
      imageId: "mbhnxx2dgxqmk0ai2jvl",
      inStock: 1,
      price: 19900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "76895580",
      name: "Indi Rockin Roll Veg",
      category: "Appetizer",
      description:
        "Serves 1 | Soft tortilla roll stuffed with veg kebab, mint mayo & melted mozzarella cheese goodness",
      imageId: "rll13didzqwfinxrtwts",
      inStock: 1,
      isVeg: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "81890544",
      name: "Veg Mayonnaise Dip",
      category: "Appetizer",
      description: "Serves 1 | Veg Mayonnaise Dip 20 Gm",
      imageId: "k05qzlgnyo43bdjdbbuy",
      inStock: 1,
      isVeg: 1,
      price: 2375,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "81890546",
      name: "Cheesy Dip",
      category: "Appetizer",
      description: "Serves 1 | Cheesy Jalapeno Dip 20 Gm",
      imageId: "l7twhqhybkdlsvkyq3pj",
      inStock: 1,
      isVeg: 1,
      price: 2375,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "87274228",
      name: "Tear & Share Veg",
      category: "Appetizer",
      description:
        "Serves 1 | Garlic bread stix stuffed & topped with Mozzarella Cheese, creamy mayo and Jalapeno. Cheese lovers delight. Tear it to share it !",
      imageId: "nrsyretuvacezojcjeee",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "87274230",
      name: "Tear & Share Non-Veg",
      category: "Appetizer",
      description:
        "Serves 1 | Garlic bread stix stuffed & topped with Mozzarella Cheese, creamy mayo and Chicken Pepperoni. Cheese lovers delight. Tear it to share it !",
      imageId: "doqtxijmd4z61vrtubi6",
      inStock: 1,
      price: 19900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "110321444",
      name: "Ketchup",
      category: "Appetizer",
      description: "Serves 1 | Ketchup Sachet",
      imageId: "hovlvq3ceumkhyivd0ik",
      inStock: 1,
      isVeg: 1,
      price: 95,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Beverages: [
    {
      id: "21852729",
      name: "Pepsi Pet Bottle",
      category: "Beverages",
      description: "Serves 1",
      imageId: "fyddsedv686kkr3sx6py",
      inStock: 1,
      isVeg: 1,
      price: 5700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "25 ratings",
          ratingCountV2: "25",
        },
      },
    },
    {
      id: "21852731",
      name: "Mirinda Pet Bottle",
      category: "Beverages",
      description: "Serves 1",
      imageId: "wjmrbgifbxdmqnumj84h",
      inStock: 1,
      isVeg: 1,
      price: 5700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "33234771",
      name: "7up Pet Bottle",
      category: "Beverages",
      description: "Serves 1",
      imageId: "saksp4hyqaargjlyt0mf",
      inStock: 1,
      isVeg: 1,
      price: 5700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "54627920",
      name: "Water Bottle - 1000ml",
      category: "Beverages",
      description: "Serves 1 | Water Bottle @50",
      imageId: "xqzuwugv50uum4ffglv5",
      inStock: 1,
      isVeg: 1,
      price: 4750,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "60786916",
      name: "Pepsi Black",
      category: "Beverages",
      description: "Serves 1",
      imageId: "ff2fmvckla7eclvn65wu",
      inStock: 1,
      isVeg: 1,
      price: 5700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
  ],
  "Late Night Cravings": [
    {
      id: "111700390",
      name: "Cheesy-Choco Comfort Combo",
      category: "Late Night Cravings",
      description:
        "Serves 1 | Get 1 personal Margherita Pizza, 1 Pepsi, 2 pc. Cheese Garlic Bread & 1 Choco Volcano. Cheesy dreams, guaranteed!",
      imageId: "b0a6791bd371018695167823b4a2e16e",
      isVeg: 1,
      price: 39900,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 11 pm, today",
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112258907",
      name: "Midnight Pizza Party for 2 Veg",
      category: "Late Night Cravings",
      description:
        "Serves 1 | Get any Veg Pizza Medium from the delight/signature/supreme range, 2 pc. Cheese Garlic Bread & a Pepsi FREE!",
      imageId: "3287e3d246ea9304ddda03c73eb9faee",
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570960",
            name: "Beverage",
            variations: [
              {
                name: "Pepsi Pet Bottle",
                price: 57,
                default: 1,
                id: "84359281",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570961",
                  variationId: "84359282",
                },
              },
            ],
          },
          {
            groupId: "26570961",
            name: "Choose Your Veg Pizza",
            variations: [
              {
                name: "Veggie Tandoori",
                price: 372,
                default: 1,
                id: "84359282",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Veggie Feast",
                price: 372,
                id: "84359283",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Spiced Paneer",
                price: 372,
                id: "84359284",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Double Cheese",
                price: 372,
                id: "84359285",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Veggie Lover",
                price: 452,
                id: "84359286",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Tandoori Paneer",
                price: 452,
                id: "84359287",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Farmers Pick",
                price: 452,
                id: "84359288",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Country Feast",
                price: 452,
                id: "84359289",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Veg Kebab Surprise",
                price: 522,
                id: "84359290",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Veggie Supreme",
                price: 522,
                id: "84359291",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Veg Exotica",
                price: 522,
                id: "84359292",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
              {
                name: "Double Paneer Supreme",
                price: 522,
                id: "84359293",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570962",
                  variationId: "84359294",
                },
              },
            ],
          },
          {
            groupId: "26570962",
            name: "Appetizer",
            variations: [
              {
                name: "2 Pcs Cheese Garlic Bread",
                price: 60,
                default: 1,
                id: "84359294",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359282",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359283",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359284",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359285",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 48900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359286",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 56900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359287",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 56900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359288",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 56900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359289",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 56900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359290",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 63900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359291",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 63900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359292",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 63900,
          },
          {
            variations: [
              {
                groupId: "26570960",
                variationId: "84359281",
              },
              {
                groupId: "26570961",
                variationId: "84359293",
              },
              {
                groupId: "26570962",
                variationId: "84359294",
              },
            ],
            price: 63900,
          },
        ],
      },
      nextAvailableAtMessage: "Next available at 11 pm, today",
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 48900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112258909",
      name: "Midnight Pizza Party for 2 Non Veg",
      category: "Late Night Cravings",
      description:
        "Serves 1 | Get any Non Veg Medium Pizza from the delight/signature/supreme range, 2 pc. Cheese Garlic Bread & a Pepsi FREE!",
      imageId: "20108adf9ff5879c136c0457c637e792",
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570972",
            name: "Beverage",
            variations: [
              {
                name: "Pepsi Pet Bottle",
                price: 57,
                default: 1,
                id: "84359331",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570974",
                  variationId: "84359335",
                },
              },
            ],
          },
          {
            groupId: "26570974",
            name: "Choose Your Non-Veg Pizza",
            variations: [
              {
                name: "Spiced Chicken Meatballs",
                price: 452,
                default: 1,
                id: "84359335",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Double Chicken Sausage",
                price: 452,
                id: "84359339",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Chicken N Corn Delight",
                price: 452,
                id: "84359343",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Chicken Pepperoni",
                price: 522,
                id: "84359346",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Malai Chicken Tikka",
                price: 522,
                id: "84359350",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Chicken Tikka",
                price: 522,
                id: "84359354",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Chicken Pepper Crunch",
                price: 522,
                id: "84359356",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Italian Chicken Feast",
                price: 582,
                id: "84359357",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Triple Chicken Feast",
                price: 582,
                id: "84359358",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Chicken Tikka Supreme",
                price: 582,
                id: "84359359",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
              {
                name: "Chicken Supreme",
                price: 582,
                id: "84359360",
                inStock: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "26570976",
                  variationId: "84359361",
                },
              },
            ],
          },
          {
            groupId: "26570976",
            name: "Appetizer",
            variations: [
              {
                name: "2 Pcs Cheese Garlic Bread",
                price: 60,
                default: 1,
                id: "84359361",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359335",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 56900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359339",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 56900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359343",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 56900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359346",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 63900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359350",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 63900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359354",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 63900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359356",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 63900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359357",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359358",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359359",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 69900,
          },
          {
            variations: [
              {
                groupId: "26570972",
                variationId: "84359331",
              },
              {
                groupId: "26570974",
                variationId: "84359360",
              },
              {
                groupId: "26570976",
                variationId: "84359361",
              },
            ],
            price: 69900,
          },
        ],
      },
      nextAvailableAtMessage: "Next available at 11 pm, today",
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 56900,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112258911",
      name: "Flat Night Owl Discount (FLAT Rs. 125) Veg",
      category: "Late Night Cravings",
      description:
        "Serves 1 | Choose any Veg Medium Pizza from the delight/signature/supreme range & get a discount of FLAT Rs. 125!",
      imageId: "3bad769cd93a5cb62966e6605e99cce4",
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26570993",
            name: "Choose Your Veg Pizza",
            variations: [
              {
                name: "Veggie Tandoori",
                price: 364,
                default: 1,
                id: "84359430",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veggie Feast",
                price: 364,
                id: "84359432",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Spiced Paneer",
                price: 364,
                id: "84359434",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Double Cheese",
                price: 364,
                id: "84359436",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veggie Lover",
                price: 444,
                id: "84359438",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tandoori Paneer",
                price: 444,
                id: "84359439",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Farmers Pick",
                price: 444,
                id: "84359440",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Country Feast",
                price: 444,
                id: "84359441",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veg Kebab Surprise",
                price: 514,
                id: "84359442",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veggie Supreme",
                price: 514,
                id: "84359443",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veg Exotica",
                price: 514,
                id: "84359444",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Double Paneer Supreme",
                price: 514,
                id: "84359445",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359430",
              },
            ],
            price: 36400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359432",
              },
            ],
            price: 36400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359434",
              },
            ],
            price: 36400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359436",
              },
            ],
            price: 36400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359438",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359439",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359440",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359441",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359442",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359443",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359444",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26570993",
                variationId: "84359445",
              },
            ],
            price: 51400,
          },
        ],
      },
      nextAvailableAtMessage: "Next available at 11 pm, today",
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 36400,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112258912",
      name: "Flat Night Owl Discount (FLAT Rs. 125) Non Veg",
      category: "Late Night Cravings",
      description:
        "Serves 1 | Choose any Non Veg Medium Pizza from the delight/signature/supreme range & get a discount of FLAT Rs. 125!",
      imageId: "32350427bf6592e237cfea6c5b534576",
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "26571002",
            name: "Choose Your Non-Veg Pizza",
            variations: [
              {
                name: "Spiced Chicken Meatballs",
                price: 444,
                default: 1,
                id: "84359471",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Double Chicken Sausage",
                price: 444,
                id: "84359473",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken N Corn Delight",
                price: 444,
                id: "84359475",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Pepperoni",
                price: 514,
                id: "84359477",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Malai Chicken Tikka",
                price: 514,
                id: "84359479",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Tikka",
                price: 514,
                id: "84359481",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Pepper Crunch",
                price: 514,
                id: "84359482",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Italian Chicken Feast",
                price: 574,
                id: "84359483",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Triple Chicken Feast",
                price: 574,
                id: "84359484",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Tikka Supreme",
                price: 574,
                id: "84359485",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Supreme",
                price: 574,
                id: "84359486",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359471",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359473",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359475",
              },
            ],
            price: 44400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359477",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359479",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359481",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359482",
              },
            ],
            price: 51400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359483",
              },
            ],
            price: 57400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359484",
              },
            ],
            price: 57400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359485",
              },
            ],
            price: 57400,
          },
          {
            variations: [
              {
                groupId: "26571002",
                variationId: "84359486",
              },
            ],
            price: 57400,
          },
        ],
      },
      nextAvailableAtMessage: "Next available at 11 pm, today",
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 44400,
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "40% OFF",
          subTitle: "USE SWIGGYIT",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[mcD] = {
  "Burgers & Wraps": [
    {
      id: "57683253",
      name: "Chicken Maharaja Mac",
      category: "Burgers & Wraps",
      description:
        "Enjoy the tallest burgers innovated by us. Created with chunky juicy grilled chicken patty paired along with fresh ingredients like jalape??o, onion, slice of cheese, tomatoes & crunchy lettuce dressed with the classical Habanero sauce.",
      imageId: "262656fef145b5595ea2a7cc68508b20",
      inStock: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "71 ratings",
          ratingCountV2: "71",
        },
      },
    },
    {
      id: "57683254",
      name: "Veg Maharaja Mac",
      category: "Burgers & Wraps",
      description:
        "Enjoy the tallest burgers innovated by us. Created with perfectly fried corn and cheese patty paired along with fresh ingredients like jalape??o, onion, slice of cheese & crunchy lettuce dressed with cocktail sauce.",
      imageId: "4d91eb6e4a6053046f924af5f6784985",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "92 ratings",
          ratingCountV2: "92",
        },
      },
    },
    {
      id: "58382855",
      name: "Mexican McAloo Tikki Burger",
      category: "Burgers & Wraps",
      description:
        "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, jalapeno, served with delicious Chipotle sauce between two lightly toasted bun.",
      imageId: "c93d1fac528e51215a9bf276c54ba0ba",
      inStock: 1,
      isVeg: 1,
      price: 6900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "173 ratings",
          ratingCountV2: "173",
        },
      },
    },
    {
      id: "58382856",
      name: "McChicken Burger",
      category: "Burgers & Wraps",
      description:
        "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite.",
      imageId: "8ca11513a489d832d5c601dc41a71e07",
      inStock: 1,
      price: 13100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "128 ratings",
          ratingCountV2: "128",
        },
      },
    },
    {
      id: "58382858",
      name: "McAloo Tikki Burger",
      category: "Burgers & Wraps",
      description:
        "The World's favourite Indian burger! Crunchy potato and peas patty with delicious Tom Mayo & crunchy onions; now with Whole Wheat Bun",
      imageId: "5148215730bbb6fd434be4fbecf96467",
      inStock: 1,
      isVeg: 1,
      price: 5800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "343 ratings",
          ratingCountV2: "343",
        },
      },
    },
    {
      id: "58382861",
      name: "McVeggie Burger",
      category: "Burgers & Wraps",
      description:
        "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns.",
      imageId: "3ce65e44b09a9f3fbf623c61241b975e",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "326 ratings",
          ratingCountV2: "326",
        },
      },
    },
    {
      id: "58382863",
      name: "McSpicy Chicken Burger",
      category: "Burgers & Wraps",
      description:
        "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more.",
      imageId: "f2d0fbb5f69ba95e375fea1480dcdb19",
      inStock: 1,
      price: 18500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "273 ratings",
          ratingCountV2: "273",
        },
      },
    },
    {
      id: "58382864",
      name: "McSpicy Paneer Burger",
      category: "Burgers & Wraps",
      description:
        "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more.",
      imageId: "1d31cdb28a1268dba03b0c557b020afe",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "92 ratings",
          ratingCountV2: "92",
        },
      },
    },
    {
      id: "58382865",
      name: "Corn & Cheese Burger",
      category: "Burgers & Wraps",
      description:
        "Earlier known as American Cheese Supreme Veg, this is a burger with crispy corn & cheese patty, covered with a slice of cheese, creamy cocktail sauce, jalapenos and shredded onions",
      imageId: "243ff944e7aa1025698bc362700d66b8",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "100 ratings",
          ratingCountV2: "100",
        },
      },
    },
    {
      id: "58382875",
      name: "Big Spicy Chicken Wrap",
      category: "Burgers & Wraps",
      description:
        "Tender and juicy chicken patty coated in spicy, crispy batter, topped with a creamy sauce, wrapped with lettuce, onions, tomatoes & seasoning and cheese. A BIG indulgence.",
      imageId: "7c2f9996390ee49d9b09b6c79b71417c",
      inStock: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "54 ratings",
          ratingCountV2: "54",
        },
      },
    },
    {
      id: "58382879",
      name: "Big Spicy Paneer Wrap",
      category: "Burgers & Wraps",
      description:
        "Rich & filling cottage cheese patty coated in spicy crispy batter, topped with tom mayo sauce wrapped with lettuce, onions, tomatoes & cheese",
      imageId: "836c1a70e329850ed0bf9a229cfd23e9",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "88 ratings",
          ratingCountV2: "88",
        },
      },
    },
    {
      id: "58382887",
      name: "Chicken Kebab Burger",
      category: "Burgers & Wraps",
      description:
        "A flavourful chicken kebab patty combined with tangy rassam sauce and shredded onions, laid on a perfectly grilled butter naan",
      imageId: "4c9e8a3277ed3e20e9753ffe97c1520a",
      inStock: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
    {
      id: "58383063",
      name: "Grilled Chicken & Cheese Burger",
      category: "Burgers & Wraps",
      description:
        "Earlier known as American Cheese Supreme Chicken, this is a burger with grilled chicken patty covered with a slice of cheese, a dollop of spicy habanero sauce, jalapenos and shredded onions",
      imageId: "c5462433217213b9f66bf6b19e0b461d",
      inStock: 1,
      price: 15900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "73 ratings",
          ratingCountV2: "73",
        },
      },
    },
    {
      id: "67545777",
      name: "Masala McEgg Burger",
      category: "Burgers & Wraps",
      description: "Masala McEgg Burger",
      imageId: "d97cd92486633de2cbffd74fa9fa822c",
      inStock: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "38 ratings",
          ratingCountV2: "38",
        },
      },
    },
    {
      id: "112711813",
      name: "Filet-O-Fish Burger",
      category: "Burgers & Wraps",
      description:
        "Signature fish filet patty, perfectly balanced with a sharp flavour of tartar sauce, a thin slice of cheese served between steamed buns.",
      imageId: "ab17c46c1928b6aec2972298d7ac87aa",
      inStock: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "46 ratings",
          ratingCountV2: "46",
        },
      },
    },
  ],
  "Gourmet Burger and Meals": [
    {
      id: "80574109",
      name: "McCheese Burger Chicken",
      category: "Gourmet Burger and Meals",
      description:
        "Formerly known as Cheese Lava Chicken, this is a burger with sinfully oozing cheesy Veg patty and Flame Grilled Chicken patty, loaded with Roasted Chipotle sauce, shredded?  Onions, Jalapenos & lettuce, layered between freshly toasted Buns.",
      imageId: "1e7a2d8b512839d084e354ea9b5ad6c9",
      inStock: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "43 ratings",
          ratingCountV2: "43",
        },
      },
    },
    {
      id: "80574110",
      name: "McCheese Burger Veg",
      category: "Gourmet Burger and Meals",
      description:
        "Formerly known as Cheese Lava Veg, this is a burger with sinfully oozing cheesy Veg patty, loaded with Roasted Chipotle sauce, shredded?  Onions, Jalapenos & lettuce, layered between freshly toasted Buns.",
      imageId: "46dc2ed3b890dfaf9ab7590f5ff67c50",
      inStock: 1,
      isVeg: 1,
      price: 24900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "64 ratings",
          ratingCountV2: "64",
        },
      },
    },
    {
      id: "80574112",
      name: "McSpicy Premium Chicken Burger",
      category: "Gourmet Burger and Meals",
      description:
        "A spicy Chicken patty, shredded Lettuce topped with Jalapenos and Cheese slice, Spicy Habanero sauce & Cheese sauce layered between toasted Whole Wheat Buns.",
      imageId: "3fc29c022f0d8809e6c9529ba63cfc93",
      inStock: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "80574114",
      name: "McSpicy Premium Veg Burger",
      category: "Gourmet Burger and Meals",
      description:
        "A spicy Paneer patty, shredded Lettuce topped with Jalapenos and Cheese slice, Spicy Cocktail sauce & Cheese sauce layered between toasted Whole Wheat Buns.",
      imageId: "236b060971eb7732cf8b63e5388e63b7",
      inStock: 1,
      isVeg: 1,
      price: 24900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "20 ratings",
          ratingCountV2: "20",
        },
      },
    },
    {
      id: "100814428",
      name: "Triple Cheese Chicken Burger",
      category: "Gourmet Burger and Meals",
      description:
        "A flame-grilled Chicken patty filled with Cheese, topped with Jalapenos, shredded Lettuce and more Cheese, layered between the goodness of whole wheat buns.",
      imageId: "ebb3ac9a9df71eae5062ef9804ef1ec3",
      inStock: 1,
      price: 22900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "100814430",
      name: "Triple Cheese  Veg Burger",
      category: "Gourmet Burger and Meals",
      description:
        "A crunchy Corn patty filled with Cheese, topped with Jalapenos, shredded Lettuce and more cheese, layered between the goodness of whole wheat buns.",
      imageId: "b70c2f09a68eda825a7986047bdf701c",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "112619925",
      name: "Chicken Maharaja Mac",
      category: "Gourmet Burger and Meals",
      description:
        "Enjoy the tallest burgers innovated by us. Created with chunky juicy grilled chicken patty paired along with fresh ingredients like jalape??o, onion, slice of cheese, tomatoes & crunchy lettuce dressed with the classical Habanero sauce.",
      imageId: "262656fef145b5595ea2a7cc68508b20",
      inStock: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "71 ratings",
          ratingCountV2: "71",
        },
      },
    },
    {
      id: "112620010",
      name: "Veg Maharaja Mac",
      category: "Gourmet Burger and Meals",
      description:
        "Enjoy the tallest burgers innovated by us. Created with perfectly fried corn and cheese patty paired along with fresh ingredients like jalape??o, onion, slice of cheese & crunchy lettuce dressed with cocktail sauce.",
      imageId: "4d91eb6e4a6053046f924af5f6784985",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "92 ratings",
          ratingCountV2: "92",
        },
      },
    },
  ],
  "Match Time Sharing Combos": [
    {
      id: "49053554",
      name: "2 Cappuccino",
      category: "Match Time Sharing Combos",
      description: "2 Cappuccino (S) @ 198",
      imageId: "99b075e17478c96d330cf0d5cef95ddc",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "50447297",
      name: "Strawberry Shake + Fries (M)",
      category: "Match Time Sharing Combos",
      description: "Strawberry Shake + Fries (M)",
      imageId: "96127d4ab24dd7ac71303cc484572b77",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "52431484",
      name: "McSpicy Paneer Burger + Corn & Cheese Burger + McVeggie Burger + Veg Maharaja Mac + 3 Fries (L)",
      category: "Match Time Sharing Combos",
      description:
        "Enjoy a feast of McSpicy Paneer Burger + Corn & Cheese Burger + McVeggie Burger + Maharaja Mac Veg + 3 Fries (L)",
      imageId: "c0b4201bcfaff3226adc821662303b92",
      inStock: 1,
      isVeg: 1,
      price: 87500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "63148039",
      name: "Masala Wedges (M) + Fries (M)",
      category: "Match Time Sharing Combos",
      description: "Masala Wedges (M) + Fries (M)",
      imageId: "2a05e7de8e3e36cf14251eb63c7737b3",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "63148041",
      name: "McVeggie + Fries (M)",
      category: "Match Time Sharing Combos",
      description: "McVeggie + Fries (M)",
      imageId: "b9737407ba66a5cd5257c07d26cdd55f",
      inStock: 1,
      isVeg: 1,
      price: 15900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "86 ratings",
          ratingCountV2: "86",
        },
      },
    },
    {
      id: "63148044",
      name: "McChicken + Fries (M)",
      category: "Match Time Sharing Combos",
      description: "McChicken + Fries (M)",
      imageId: "09dbe5cff94a31f00d87357b6e34dab2",
      inStock: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "130 ratings",
          ratingCountV2: "130",
        },
      },
    },
    {
      id: "65029525",
      name: "2 Coke",
      category: "Match Time Sharing Combos",
      description: "2 Coke",
      imageId: "8e17043cf2e2e408b5b77cf45aa866ea",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "65337391",
      name: "McAloo Tikki + Fries (R)",
      category: "Match Time Sharing Combos",
      description: "Aloo Tikki+ Fries (R)",
      imageId: "922adac276e88300e3e548c93c39b6c7",
      inStock: 1,
      isVeg: 1,
      price: 10100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "65337416",
      name: "Mexican McAloo Tikki Burger + Fries (R)",
      category: "Match Time Sharing Combos",
      description: "Mexican McAloo Tikki Burger + Fries (R)",
      imageId: "d6b2f8774e930f38343540a7c9437c8d",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "65337417",
      name: "McChicken Burger + Veg Pizza McPuff",
      category: "Match Time Sharing Combos",
      description: "McChicken Burger + Veg Pizza McPuff",
      imageId: "352f7c8c6e3edb94ca1d55fc36d29297",
      inStock: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "65337440",
      name: "McChicken Burger + Fries (R)",
      category: "Match Time Sharing Combos",
      description: "McChicken Burger + Fries (R)",
      imageId: "0d0de2636c10800c295e49510e75e5c2",
      inStock: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "65337455",
      name: "McVeggie Burger + Veg Pizza McPuff",
      category: "Match Time Sharing Combos",
      description: "McVeggie Burger + Veg Pizza McPuff",
      imageId: "c7aaf0d20451d4512d6b630cb011a8bf",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "65337458",
      name: "McVeggie Burger + Fries (R)",
      category: "Match Time Sharing Combos",
      description: "McVeggie Burger + Fries (R)",
      imageId: "c69620d75c009d557bdadfaf90cec521",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "66781720",
      name: "Chicken Kebab Burger + McFlurry Oreo (S)",
      category: "Match Time Sharing Combos",
      description: "Chicken Kebab Burger + McFlurry Oreo (S)",
      imageId: "36a13bf9787091ad77a9afb0bb56be4c",
      inStock: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66781723",
      name: "Chicken Kebab Burger + Fries (L)",
      category: "Match Time Sharing Combos",
      description: "Chicken Kebab Burger + Fries (L)",
      imageId: "bfb612366e1e40d8f22c27255cba58dc",
      inStock: 1,
      price: 19900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66781731",
      name: "Mexican McAloo Tikki Burger + McFlurry Oreo (S)",
      category: "Match Time Sharing Combos",
      description: "Mexican McAloo Tikki Burger + McFlurry Oreo (S)",
      imageId: "a35c431d42024f54af7dee42729dffc2",
      inStock: 1,
      isVeg: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "66781761",
      name: "Mexican McAloo Tikki Burger + Fries (L)",
      category: "Match Time Sharing Combos",
      description: "Mexican McAloo Tikki Burger + Fries (L)",
      imageId: "25e1acbac602353b35e79e00adb18f67",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "66781778",
      name: "McChicken Burger + McFlurry Oreo (S)",
      category: "Match Time Sharing Combos",
      description: "McChicken Burger + McFlurry Oreo (S)",
      imageId: "04dfdcacbfd5e8f9a23eecebc163e40d",
      inStock: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66781787",
      name: "McChicken Burger + Fries (L)",
      category: "Match Time Sharing Combos",
      description: "McChicken Burger + Fries (L)",
      imageId: "2270f2a36ed6ec21cea636f8a427a09d",
      inStock: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66781790",
      name: "McChicken Burger + Masala Wedges (R)",
      category: "Match Time Sharing Combos",
      description: "McChicken Burger + Masala Wedges (R)",
      imageId: "5b0fec19d431a5693bd5df87f012658c",
      inStock: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "66781791",
      name: "McVeggie Burger + Fries (L)",
      category: "Match Time Sharing Combos",
      description: "McVeggie Burger + Fries (L)",
      imageId: "2702d604d2ca637c3445e11afe07885b",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66781792",
      name: "McVeggie Burger + McFlurry Oreo (S)",
      category: "Match Time Sharing Combos",
      description: "McVeggie Burger + McFlurry Oreo (S)",
      imageId: "1a8c7c8bb70c2795d7b701ddd481d70c",
      inStock: 1,
      isVeg: 1,
      price: 18500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66781806",
      name: "McVeggie Burger + Masala Wedges (R)",
      category: "Match Time Sharing Combos",
      description: "McVeggie Burger + Masala Wedges (R)",
      imageId: "53966b6dd34e00112c3efd37a42b6a5f",
      inStock: 1,
      isVeg: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "87279140",
      name: "2 Fries (R)",
      category: "Match Time Sharing Combos",
      description: "2 Fries (R)",
      imageId: "a079610f6eec6cbd79f3d3ac4ff7ff5a",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "111 ratings",
          ratingCountV2: "111",
        },
      },
    },
    {
      id: "87279151",
      name: "2 McVeggie Burger",
      category: "Match Time Sharing Combos",
      description: "2 McVeggie Burger",
      imageId: "727ba851c3c783ef1055f39ff17fde43",
      inStock: 1,
      isVeg: 1,
      price: 19100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "133 ratings",
          ratingCountV2: "133",
        },
      },
    },
    {
      id: "102108731",
      name: "McAloo Tikki + Veg Pizza McPuff + Fries (R)",
      category: "Match Time Sharing Combos",
      description:
        "Flat 15% Off on McAloo Tikki + Veg Pizza McPuff + Fries (R)",
      imageId: "d5b932ad3f516272d3fca0018ea988b0",
      inStock: 1,
      isVeg: 1,
      price: 14952,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "31 ratings",
          ratingCountV2: "31",
        },
      },
    },
    {
      id: "102108736",
      name: "McChicken Burger + Chocolate Shake",
      category: "Match Time Sharing Combos",
      description: "Flat 15% Off on McChicken Burger + Chocolate Shake",
      imageId: "8e8c9f15c102952c335be4981d1710b6",
      inStock: 1,
      price: 25524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868012",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537039",
              name: "Strawberry Shake",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102108746",
      name: "McSpicy Chicken Burger + McChicken Burger + Fries (M)",
      category: "Match Time Sharing Combos",
      description:
        "Flat 15% Off on McSpicy Chicken Burger + McChicken Burger + Fries (M)",
      imageId: "5f5b4b0baf79be1b9d213053e42dba18",
      inStock: 1,
      price: 35428,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "45 ratings",
          ratingCountV2: "45",
        },
      },
    },
    {
      id: "102108758",
      name: "McVeggie Burger + Chocolate Shake",
      category: "Match Time Sharing Combos",
      description: "Flat 15% Off on McVeggie Burger + Chocolate Shake",
      imageId: "234b6e1dbb073575a605a2598502e6c5",
      inStock: 1,
      isVeg: 1,
      price: 24952,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868171",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537039",
              name: "Strawberry Shake",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "102108771",
      name: "McVeggie Burger + Fries (M) + Piri Piri Mix",
      category: "Match Time Sharing Combos",
      description:
        "Flat 15% Off on McVeggie Burger + Fries (M) + Piri Piri Mix",
      imageId: "5123ee5237addd8c2e981bb885bcd330",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102108781",
      name: "McVeggie Burger + Veg Pizza McPuff + Fries (L)",
      category: "Match Time Sharing Combos",
      description:
        "Flat 15% Off on McVeggie Burger + Veg Pizza McPuff + Fries (L)",
      imageId: "4c06c28fcd5d912a0ba4c69254dcc87f",
      inStock: 1,
      isVeg: 1,
      price: 25142,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "109037897",
      name: "Grilled Chicken & Cheese Burger + Veg Pizza McPuff",
      category: "Match Time Sharing Combos",
      description:
        "A delicious Grilled Chicken & Cheese Burger + a crispy brown, delicious Pizza McPuff",
      imageId: "2f7d95fe8c5cfc081e096cf4deb1ae63",
      inStock: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "109037898",
      name: "Corn & Cheese Burger + Veg Pizza McPuff",
      category: "Match Time Sharing Combos",
      description:
        "A delicious Corn & Cheese Burger + a crispy brown, delicious Pizza McPuff",
      imageId: "c3e189388ef2e749a3c5cb32ccab3e46",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "109037899",
      name: "Corn & Cheese Burger + Fries (R)",
      category: "Match Time Sharing Combos",
      description:
        "A delicious Corn & Cheese Burger + a side of crispy, golden, world famous fries ??",
      imageId: "f890e20e37aaec2b49173dfd04f5a6d3",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "109037910",
      name: "Grilled Chicken & Cheese Burger + Masala Wedges (R)",
      category: "Match Time Sharing Combos",
      description:
        "A delicious Grilled Chicken & Cheese Burger paired with the deliciously crispy Masala Wedges",
      imageId: "6039056512fa70df76a9c3e39b06b445",
      inStock: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "109883665",
      name: "Chocolate Shake + Fries (M)",
      category: "Match Time Sharing Combos",
      description: "Chocolate Shake + Fries (M)",
      imageId: "09dcab2f02036f3fb3d8e84791057be4",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112711766",
      name: "2 McFlurry Oreo (S)",
      category: "Match Time Sharing Combos",
      description: "2 McFlurry Oreo (S)",
      imageId: "5e5b0a5abb103befaa324eedf370ff14",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112711770",
      name: "2 Soft Serve Hot Fudge (M)",
      category: "Match Time Sharing Combos",
      description: "2 Soft Serve Hot Fudge (M)",
      imageId: "ec326ad3bf778e5e4ef80c14d4c2823f",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112711805",
      name: "Corn & Cheese Burger +McVeggie Burger+Fries (M)",
      category: "Match Time Sharing Combos",
      description:
        "Flat 15% Off on Corn & Cheese Burger +McVeggie Burger+Fries (M)",
      imageId: "6cef15aff8f363185b97940212048cea",
      inStock: 1,
      isVeg: 1,
      price: 31334,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
  ],
  "Sides & Dips": [
    {
      id: "58382851",
      name: "Piri Piri Spice Mix",
      category: "Sides & Dips",
      description:
        "The perfect, taste bud tingling partner for our World Famous Fries. Shake Shake, and dive in!",
      imageId: "3e222ab4d13b736540e512b0c78cd954",
      inStock: 1,
      isVeg: 1,
      price: 2380,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "200 ratings",
          ratingCountV2: "200",
        },
      },
    },
    {
      id: "58382871",
      name: "Masala Wedges (L)",
      category: "Sides & Dips",
      description:
        "Enjoy the Large pack of deliciously crsipy, 100% natural potatoes, cut into wedges and seasoned.",
      imageId: "3ccc16b88e04bbc8636fe8bea4e23d78",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "58382985",
      name: "Veg Pizza McPuff",
      category: "Sides & Dips",
      description:
        "Crispy brown crust with a generous filling of rich tomato sauce, mixed with carrots, bell peppers, beans, onions and mozzarella. Served HOT.",
      imageId: "5b63ce4a195f9f1ada3cd8cd7eaf8db6",
      inStock: 1,
      isVeg: 1,
      price: 5100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "182 ratings",
          ratingCountV2: "182",
        },
      },
    },
    {
      id: "65332869",
      name: "Fries (R)",
      category: "Sides & Dips",
      description:
        "World Famous Fries, crispy golden, fried to perfection and lightly salted. Also known as happiness.",
      imageId: "299c76e9127d75e899113fed4e05b151",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "153 ratings",
          ratingCountV2: "153",
        },
      },
    },
    {
      id: "65332870",
      name: "Fries (M)",
      category: "Sides & Dips",
      description:
        "World Famous Fries, crispy golden, fried to perfection and lightly salted. Also known as happiness.",
      imageId: "6315654dd2a50808120303469e4f28c2",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "200 ratings",
          ratingCountV2: "200",
        },
      },
    },
    {
      id: "65332871",
      name: "Fries (L)",
      category: "Sides & Dips",
      description:
        "World Famous Fries, crispy golden, fried to perfection and lightly salted. Also known as happiness.",
      imageId: "663a682da19c86952e633ffaa71a7194",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "311 ratings",
          ratingCountV2: "311",
        },
      },
    },
    {
      id: "67456331",
      name: "Tomato Ketchup Sachet",
      category: "Sides & Dips",
      description: "Tomato Ketchup Sachet",
      imageId: "4f59e7dd5b7aa42c42294fcbf0fb7115",
      inStock: 1,
      isVeg: 1,
      price: 96,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "68253611",
      name: "Chicken McNuggets - 9 Pcs",
      category: "Sides & Dips",
      description: "Chicken McNuggets - 9 Pcs",
      imageId: "f4a69b36db90ec8d4cbb6d5ba902b293",
      inStock: 1,
      price: 19899,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82735437",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537093",
              name: "Barbeque Sauce",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "42 ratings",
          ratingCountV2: "42",
        },
      },
    },
    {
      id: "68253622",
      name: "Chicken McNuggets - 6 Pcs",
      category: "Sides & Dips",
      description: "Chicken McNuggets - 6 Pcs",
      imageId: "72952bfee3aca3a0ded5d75f8ced11d1",
      inStock: 1,
      price: 15899,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82735436",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537093",
              name: "Barbeque Sauce",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "34 ratings",
          ratingCountV2: "34",
        },
      },
    },
    {
      id: "68253639",
      name: "Masala Wedges (M)",
      category: "Sides & Dips",
      description:
        "Enjoy the Medium pack of deliciously crsipy, 100% natural potatoes, cut into wedges and seasoned.",
      imageId: "00aba1e5e6287e48a3f7e6b51b942257",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "68351469",
      name: "Masala Wedges (R)",
      category: "Sides & Dips",
      description:
        "Enjoy the Small pack of deliciously crsipy, 100% natural potatoes, cut into wedges and seasoned.",
      imageId: "4cfb15162aa882df80a6224ff52b8df2",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "69609954",
      name: "Chilli Sauce Sachet",
      category: "Sides & Dips",
      description: "Chilli Sauce Sachet",
      imageId: "03fffd14413177ea14417a4238b02f5e",
      inStock: 1,
      isVeg: 1,
      price: 190,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "75068159",
      name: "Loaded Masala Wedges",
      category: "Sides & Dips",
      description:
        "Your Favorite Masala Wedges topped with delicious Cheese sauce and spicy red sauce. Available only for a limited time.",
      imageId: "abac420812442928aca944cecdd84103",
      inStock: 1,
      isVeg: 1,
      price: 13600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "112619927",
      name: "Classic Corn Cup",
      category: "Sides & Dips",
      description: "A delicious side of golden sweet kernels of corn in a cup",
      imageId: "a0c8ef0d918e17e45220c90cab6e4009",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112620003",
      name: "Mexican cheesy fries",
      category: "Sides & Dips",
      description:
        "The worlds best French Fries now served with delicious cheese sauce and spicy red sauce. Serving only for a limited time!",
      imageId: "fe0f9db879989c94b467c1a0616ae759",
      inStock: 1,
      isVeg: 1,
      price: 13800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "160 ratings",
          ratingCountV2: "160",
        },
      },
    },
  ],
  "McSaver Snacks": [
    {
      id: "67545729",
      name: "McSaver Chicken Strips (2 Pc)",
      category: "McSaver Snacks",
      description: "McSaver Chicken Strips (2 Pc)",
      imageId: "abdfc0b18c4673a76ea0e414308441ad",
      inStock: 1,
      price: 10380,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "67545734",
      name: "McSaver Chicken Nuggets (4 Pc)",
      category: "McSaver Snacks",
      description: "McSaver Chicken Nuggets (4 Pc)",
      imageId: "e49ea5484f7458eb6f8ae48721a5892d",
      inStock: 1,
      price: 10380,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "22 ratings",
          ratingCountV2: "22",
        },
      },
    },
    {
      id: "67545736",
      name: "McSaver McAloo Tikki",
      category: "McSaver Snacks",
      description:
        "Enjoy a delicious combo of McAloo Tikki Burger with Whole wheat bun and Beverage of your choice in a new, delivery friendly, resuable bottle.",
      imageId: "c16d761a6187115ba53d45be50a8cbca",
      inStock: 1,
      isVeg: 1,
      price: 7524,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "32 ratings",
          ratingCountV2: "32",
        },
      },
    },
    {
      id: "67545737",
      name: "McSaver Chicken Kebab Burger",
      category: "McSaver Snacks",
      description: "McSaver Chicken Kebab Burger",
      imageId: "cb41519290f610d5bd73500810d32776",
      inStock: 1,
      price: 10380,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "27 ratings",
          ratingCountV2: "27",
        },
      },
    },
    {
      id: "67545741",
      name: "McSaver Masala McEgg",
      category: "McSaver Snacks",
      description: "McSaver Masala McEgg",
      imageId: "0bdecd3d5347503323171a26a6fcca22",
      inStock: 1,
      price: 7524,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "67545742",
      name: "McSaver Pizza McPuff",
      category: "McSaver Snacks",
      description: "McSaver Pizza McPuff",
      imageId: "20e69efd54c1be0b6801c3c3e8dfd271",
      inStock: 1,
      isVeg: 1,
      price: 7524,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "44 ratings",
          ratingCountV2: "44",
        },
      },
    },
    {
      id: "67545751",
      name: "McSaver Small Fries",
      category: "McSaver Snacks",
      description: "McSaver Small Fries",
      imageId: "14ff23a39f927c1789a8753f02a4f4b8",
      inStock: 1,
      isVeg: 1,
      price: 7524,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "25 ratings",
          ratingCountV2: "25",
        },
      },
    },
    {
      id: "67545758",
      name: "McSaver Small Wedges",
      category: "McSaver Snacks",
      description: "McSaver Small Wedges",
      imageId: "de05804d2d731105774fcf0ace436c4e",
      inStock: 1,
      isVeg: 1,
      price: 7524,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "67545763",
      name: "McSaver Mexican McAloo Tikki",
      category: "McSaver Snacks",
      description: "McSaver Mexican McAloo Tikki",
      imageId: "4bd83ac67e7a862195ffba2a3d75de4c",
      inStock: 1,
      isVeg: 1,
      price: 10380,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
  ],
  Beverages: [
    {
      id: "69013786",
      name: "Vedica Zen Water Bottle",
      category: "Beverages",
      description: "Vedica Zen Water Bottle",
      imageId: "8df77e3b4ac5eba58e3650e4ae500048",
      inStock: 1,
      isVeg: 1,
      price: 4762,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "78477463",
      name: "Mixed Fruit Beverage",
      category: "Beverages",
      description: "Made with puree, pulp & juice from 6 delicious fruits",
      imageId: "ea294d61e87c4d791599664ffa5feae2",
      inStock: 1,
      isVeg: 1,
      price: 7524,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
  ],
  "Cheese Burgers and Meals": [
    {
      id: "112711804",
      name: "Corn & Cheese Burger",
      category: "Cheese Burgers and Meals",
      description:
        "Earlier known as American Cheese Supreme Veg, this is a burger with crispy corn & cheese patty, covered with a slice of cheese, creamy cocktail sauce, jalapenos and shredded onions",
      imageId: "243ff944e7aa1025698bc362700d66b8",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "100 ratings",
          ratingCountV2: "100",
        },
      },
    },
    {
      id: "112711824",
      name: "Grilled Chicken & Cheese Burger",
      category: "Cheese Burgers and Meals",
      description:
        "Earlier known as American Cheese Supreme Chicken, this is a burger with grilled chicken patty covered with a slice of cheese, a dollop of spicy habanero sauce, jalapenos and shredded onions",
      imageId: "c5462433217213b9f66bf6b19e0b461d",
      inStock: 1,
      price: 15900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "73 ratings",
          ratingCountV2: "73",
        },
      },
    },
    {
      id: "112711876",
      name: "McCheese Burger Chicken",
      category: "Cheese Burgers and Meals",
      description:
        "Formerly known as Cheese Lava Chicken, this is a burger with sinfully oozing cheesy Veg patty and Flame Grilled Chicken patty, loaded with Roasted Chipotle sauce, shredded?  Onions, Jalapenos & lettuce, layered between freshly toasted Buns.",
      imageId: "1e7a2d8b512839d084e354ea9b5ad6c9",
      inStock: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "43 ratings",
          ratingCountV2: "43",
        },
      },
    },
    {
      id: "112711877",
      name: "McCheese Burger Veg",
      category: "Cheese Burgers and Meals",
      description:
        "Formerly known as Cheese Lava Veg, this is a burger with sinfully oozing cheesy Veg patty, loaded with Roasted Chipotle sauce, shredded?  Onions, Jalapenos & lettuce, layered between freshly toasted Buns.",
      imageId: "46dc2ed3b890dfaf9ab7590f5ff67c50",
      inStock: 1,
      isVeg: 1,
      price: 24900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "64 ratings",
          ratingCountV2: "64",
        },
      },
    },
    {
      id: "112712031",
      name: "Triple Cheese Chicken Burger",
      category: "Cheese Burgers and Meals",
      description:
        "A flame-grilled Chicken patty filled with Cheese, topped with Jalapenos, shredded Lettuce and more Cheese, layered between the goodness of whole wheat buns.",
      imageId: "ebb3ac9a9df71eae5062ef9804ef1ec3",
      inStock: 1,
      price: 22900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "112712044",
      name: "Triple Cheese  Veg Burger",
      category: "Cheese Burgers and Meals",
      description:
        "A crunchy Corn patty filled with Cheese, topped with Jalapenos, shredded Lettuce and more cheese, layered between the goodness of whole wheat buns.",
      imageId: "b70c2f09a68eda825a7986047bdf701c",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
  ],
  Desserts: [
    {
      id: "68351463",
      name: "Mcflurry Oreo Small",
      category: "Desserts",
      description:
        "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Perfect for one.",
      imageId: "16f617a424721e56a8d405a196ef6170",
      inStock: 1,
      isVeg: 1,
      price: 9100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "20 ratings",
          ratingCountV2: "20",
        },
      },
    },
    {
      id: "112711898",
      name: "McFlurry Oreo Medium",
      category: "Desserts",
      description:
        "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Share it, if you can.",
      imageId: "390413fb0a2b292141979abe2c8cb413",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "27 ratings",
          ratingCountV2: "27",
        },
      },
    },
    {
      id: "112712017",
      name: "Soft Serve Hot Fudge (M)",
      category: "Desserts",
      description:
        "A sinful delight, soft serve topped with delicious, gooey hot chocolate fudge. Always grab an extra spoon.",
      imageId: "acd6fbc7e030e7f770c13e089741b612",
      inStock: 1,
      isVeg: 1,
      price: 10100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112712018",
      name: "Soft Serve Strawberry (M)",
      category: "Desserts",
      description:
        "The cool vanilla soft serve ice cream with twirls of strawberry syrup.",
      imageId: "8921a3321b0fa095090e2e5214afe8a4",
      inStock: 1,
      isVeg: 1,
      price: 10100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Coffee and Tea": [
    {
      id: "39608977",
      name: "Strawberry Green Tea (S)",
      category: "Coffee and Tea",
      description:
        "Freshly brewed refreshing tea with flavoured with fruity Strawberries.",
      imageId: "94ed8466a9ba6b0bea72808ffbad354f",
      inStock: 1,
      isVeg: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "40651435",
      name: "Flat White",
      category: "Coffee and Tea",
      description:
        "Our signature McCaf?? espresso made with 100% Arabica beans, blended with steamed and slightly frothed 100% real milk.",
      imageId: "a985503e7b6b41cc0db5989f00c02d26",
      inStock: 1,
      isVeg: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "40651436",
      name: "Moroccan Mint Green Tea",
      category: "Coffee and Tea",
      description:
        "Freshly brewed refreshing tea with hint of Moroccon Mint flavour.",
      imageId: "75fc703ae34f16d0feda4a8cd9484ccb",
      inStock: 1,
      isVeg: 1,
      price: 18500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "58382846",
      name: "Mccafe Iced Americano",
      category: "Coffee and Tea",
      description:
        "Feel refreshed with the blend of perfect espresso shot mixed with ice.",
      imageId: "2473955af333499e126ea2d7a68ecaaa",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "58382868",
      name: "Latte (S)",
      category: "Coffee and Tea",
      description:
        "Treat yourself with the smooth and sophisticated Latte, made with our signature McCaf?? espresso and topped with 100% real milk, steamed and frothed.",
      imageId: "7796445cecd7072f6217439573f29ef9",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "58382894",
      name: "Hot Chocolate (S)",
      category: "Coffee and Tea",
      description:
        "Sinful chocolate whisked with silky steamed milk and topped with an even sweeter touch of chocolate.",
      imageId: "9158f7bc6926c8503f0d6e004ae2d941",
      inStock: 1,
      isVeg: 1,
      price: 17900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "58382908",
      name: "McCafe-Classic Coffee",
      category: "Coffee and Tea",
      description:
        "An irrestible blend of our signature espresso and soft serve with whipped cream on top, a timeless combination! Now in a new, convenient and delivery friendly packaging. Now in a new, convenient and delivery friendly packaging",
      imageId: "4bbf96c8b686546078aca0cbb7ff0947",
      inStock: 1,
      isVeg: 1,
      price: 20900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "58382909",
      name: "McCafe-Ice Coffee",
      category: "Coffee and Tea",
      description:
        "An irrestible combination of our signature espresso and soft serve, which is to die for! Now in a new, convenient and delivery friendly packaging",
      imageId: "870afc89c9bd9cdf93a0fe432079fe51",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "68351466",
      name: "McCafe Americano (R)",
      category: "Coffee and Tea",
      description:
        "Our Americano is bold and robust, made with our signature McCaf?? espresso combined with hot water, for coffee aficionados who prefer a bolder cup.",
      imageId: "94ad366573e5226389288c3c1ae9dd41",
      inStock: 1,
      isVeg: 1,
      price: 18500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "68351467",
      name: "McCafe Americano (S)",
      category: "Coffee and Tea",
      description:
        "Our Americano is bold and robust, made with our signature McCaf?? espresso combined with hot water, for coffee aficionados who prefer a bolder cup.",
      imageId: "94ad366573e5226389288c3c1ae9dd41",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "68351472",
      name: "Mocha (R)",
      category: "Coffee and Tea",
      description:
        "A refreshing combination of well-ground coffee beans and white steamed milk, topped off with dark froth.",
      imageId: "445f7200d217d6b4d482d987afa93af0",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "68351473",
      name: "Mocha (S)",
      category: "Coffee and Tea",
      description:
        "A refreshing combination of well-ground coffee beans and white steamed milk, topped off with dark froth.",
      imageId: "445f7200d217d6b4d482d987afa93af0",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "68351474",
      name: "Hot Chocolate (R)",
      category: "Coffee and Tea",
      description:
        "Sinful chocolate whisked with silky steamed milk and topped with an even sweeter touch of chocolate.",
      imageId: "9158f7bc6926c8503f0d6e004ae2d941",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "68351476",
      name: "Latte (R)",
      category: "Coffee and Tea",
      description:
        "Treat yourself with the smooth and sophisticated Latte, made with our signature McCaf?? espresso and topped with 100% real milk, steamed and frothed.",
      imageId: "7796445cecd7072f6217439573f29ef9",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "112711751",
      name: "2 Cappuccino",
      category: "Coffee and Tea",
      description: "2 Cappuccino (S) @ 198",
      imageId: "99b075e17478c96d330cf0d5cef95ddc",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "112711810",
      name: "English Breakfast",
      category: "Coffee and Tea",
      description:
        "Relax. It's your time to enjoy a long, slow sip of delicious and delectable english breakfast tea",
      imageId: "3a4184eec78e9de93740f41ab53ce1c3",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Shakes and Coolers": [
    {
      id: "33226971",
      name: "Berry Lemonade Splash Regular",
      category: "Shakes and Coolers",
      description:
        "A refreshing drink, made with the flavors of strawberries and blueberries ?°± a definite crowd-pleaser. Now in a new, convenient and delivery friendly packaging.",
      imageId: "93f40baaf64eef0606fd21886e0d95e7",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "39345012",
      name: "Mango Smoothie",
      category: "Shakes and Coolers",
      description:
        "A delicious mix of mangoes, soft serve mix and blended ice .Now in a new, convenient and delivery friendly packaging",
      imageId: "c1659667428b071479eae3e8f2ea851f",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "58382890",
      name: "American Mud Pie",
      category: "Shakes and Coolers",
      description:
        "A classic American Mud Pie gets a makeover; wonderfully creamy and rich with Chocolate, this shake is more delicious than it sounds! Now in a ne, convenient and delivery friendly packaging",
      imageId: "6c334b75f83a904b287fb4910cbee621",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "27 ratings",
          ratingCountV2: "27",
        },
      },
    },
    {
      id: "58382904",
      name: "McCafe-Mocha Frappe",
      category: "Shakes and Coolers",
      description:
        "A refreshing coffee beverage, blended with rich mocha sauce and our signature soft serve. Now in a new, convenient, delivery frinedly packaging",
      imageId: "223b81ef93b78c9b9a4bb10d935afc73",
      inStock: 1,
      isVeg: 1,
      price: 27100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "58382905",
      name: "McCafe-Chocolate Frappe",
      category: "Shakes and Coolers",
      description:
        "A refreshing sweet treat made from chocolate sauce and Oreo cookie pieces which is blended with ice and garnished with whipped cream. Now in a new, convenient and delivery friendly packaging",
      imageId: "ef60ed9a6d2c34757579f1a98837efdc",
      inStock: 1,
      isVeg: 1,
      price: 27100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "58382914",
      name: "Mixed Berry Smoothie",
      category: "Shakes and Coolers",
      description:
        "A delectable mix of mixed berries, blended together with our creamy soft serve. Now in a new, convenient and delivery friendly packaging",
      imageId: "d36e61ce67bab6e365f7960c28f85a01",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "65378347",
      name: "Lemon Chiller",
      category: "Shakes and Coolers",
      description:
        "A perfect blend of aromatic teas, infused with lemon flavour.Now in a new, convenient and delivery friendly packaging",
      imageId: "d53170dd1e8229abbda14f9bdc7d8075",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "65378352",
      name: "Strawberry Chiller",
      category: "Shakes and Coolers",
      description:
        "A perfect blend of aromatic teas, infused with strawberry flavour . Now in a new, convenient and delivery friendly packaging",
      imageId: "b91aa351f11e1e9ec9b0e564d61132d9",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "65378353",
      name: "Strawberry Shake",
      category: "Shakes and Coolers",
      description:
        "An all time favourite treat bringing together the perfect blend of creamy vanilla soft serve and strawberry flavor.Now in new, convenient and delivery friendly packaging",
      imageId: "63c2bff701c5b263889955f4a5b1380f",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "67027379",
      name: "Green Apple Chiller",
      category: "Shakes and Coolers",
      description:
        "A perfect blend of aromatic teas, infused with green apple flavour .Now in a new, convenient and delivery friendly packaging",
      imageId: "9b88742d71f02f70397f129981d21b99",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "70249208",
      name: "Chocolate Shake",
      category: "Shakes and Coolers",
      description:
        "The classic sinful chocolate shake, a treat for anytime you need one. Now in new, convenient and delivery friendly packaging",
      imageId: "7b634d056ca122c17d53a7e1751ae072",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "90593980",
      name: "Sweet Lime Cooler",
      category: "Shakes and Coolers",
      description:
        "A cool, sweet, citrusy drink bursting with flavor of  Sweet lime that refreshes you like no other!",
      inStock: 1,
      isVeg: 1,
      price: 12800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
  ],
  "Happy Meals": [
    {
      id: "58382870",
      name: "McAloo Tikki Happy Meal",
      category: "Happy Meals",
      description:
        "Enjoy a combo of McAloo Tikki Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
      imageId: "84f9ecd8c06aa38f6d6960079164a7f4",
      inStock: 1,
      isVeg: 1,
      price: 20101,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "58382896",
      name: "McChicken Happy Meal",
      category: "Happy Meals",
      description:
        "Enjoy a combo of McChicken Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
      imageId: "1279971bd1049f3bce26f10e0c720903",
      inStock: 1,
      price: 31101,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "58382899",
      name: "McVeggie Happy Meal",
      category: "Happy Meals",
      description:
        "Enjoy a combo of McVeggie Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
      imageId: "910d350074c54b69788875537aa5a615",
      inStock: 1,
      isVeg: 1,
      price: 29000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "78477449",
      name: "Birthday Party Package - McChicken",
      category: "Happy Meals",
      description:
        "5 McChicken Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
      imageId: "8edaf9a80566ec89a20e352336e0f22b",
      inStock: 1,
      price: 209000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "78477451",
      name: "Birthday Party Package - McVeggie",
      category: "Happy Meals",
      description:
        "5 McVeggie Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
      imageId: "b63528c73b7b014230699603654dcd69",
      inStock: 1,
      isVeg: 1,
      price: 209000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "78477457",
      name: "McEgg Happy Meal",
      category: "Happy Meals",
      description:
        "Enjoy a combo of McEgg Burger  + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
      imageId: "232954759776ead48093003fdbb5f82d",
      inStock: 1,
      price: 22501,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  McBreakfast: [
    {
      id: "58382972",
      name: "Hashbrown",
      category: "McBreakfast",
      description: "Hashbrown",
      imageId: "4372c85c3c2fb3d2c33695edc5dd396b",
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "45 ratings",
          ratingCountV2: "45",
        },
      },
    },
    {
      id: "75902486",
      name: "Sausage McMuffin 2 pc Meal",
      category: "McBreakfast",
      description:
        "Sizzling aromatic sausage patty between the two slices of fresh English muffins + Coffee (R)",
      imageId: "5ada2d310374b48d92df9bb9cd5d2618",
      price: 23900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868218",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902492",
      name: "Egg & Cheese McMuffin",
      category: "McBreakfast",
      description:
        "Fluffy soft egg topped with Cheese served between English muffins",
      imageId: "e89246d49eb1424628ab78750e6591ac",
      price: 9500,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "23 ratings",
          ratingCountV2: "23",
        },
      },
    },
    {
      id: "75902501",
      name: "Sausage with Egg McMuffin 3 Pc Meal",
      category: "McBreakfast",
      description: "Sausage with Egg McMuffin 3 Pc Meal",
      imageId: "961e516b18eb2ed771c6ba9f15ae3626",
      price: 27900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868242",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "75902511",
      name: "Sausage & Egg McMuffin",
      category: "McBreakfast",
      description:
        "Sizzling aromatic sausage accompanied by the freshly steamed egg between two slices of fresh English muffins. A wholesome breakfast!",
      imageId: "ff085572736b6bcb1db7f6d707f45fd7",
      price: 14500,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "75902512",
      name: "Sausage McMuffin",
      category: "McBreakfast",
      description:
        "Sizzling aromatic sausage patty between two slices of fresh English muffins. A wholesome breakfast!",
      imageId: "18dc7c38dda607b5af2e0072cda0a237",
      price: 12500,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "75902513",
      name: "Sausage & Egg McMuffin 2 pc Meal",
      category: "McBreakfast",
      description:
        "Sizzling aromatic sausage accompanied by the freshly steamed egg between the two slices of fresh English muffins + Coffee (R)",
      imageId: "43bce56ccd3aeb67f889f4a5d8372470",
      price: 25500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868204",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902515",
      name: "Egg & Cheese McMuffin 3 Pc Meal",
      category: "McBreakfast",
      description: "Egg & Cheese McMuffin 3 Pc Meal",
      imageId: "6053c05bb692016c1739bde4da3a215f",
      price: 22900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82867905",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902517",
      name: "Sausage McMuffin 3 Pc Meal",
      category: "McBreakfast",
      description: "Sausage McMuffin 3 Pc Meal",
      imageId: "e631b3127ea014fc43f2e3db3d8b9c58",
      price: 25900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868240",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "75902520",
      name: "Hot Cakes With Maple Syrup",
      category: "McBreakfast",
      description: "Freshly prepared, spongy and oh-so filling hotcakes.",
      imageId: "ceebe10340c42365f97f6f0e4869d24c",
      isVeg: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "75902522",
      name: "Hot Cake 2 Pc Meal",
      category: "McBreakfast",
      description:
        "Freshly prepared, spongy and oh-so filling hotcakes paired with a filter coffee (R)",
      imageId: "4f00c3f4989ff0290b92418e64a8374b",
      isVeg: 1,
      price: 24900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82867941",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902525",
      name: "Hot Cake 3 Pc Meal",
      category: "McBreakfast",
      description: "Hot Cake 3 Pc Meal",
      imageId: "d933e14a9bf322b9810ef3e85bf95e20",
      isVeg: 1,
      price: 26500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82867943",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902526",
      name: "Double Cheese McMuffin",
      category: "McBreakfast",
      description:
        "Make your mornings Cheesy with the new Double Cheese McMuffin. Shredded onion, Jalapenos topped with Cheese (and more cheese) layered between toasted and buttered Muffin buns",
      imageId: "9a7e2158152beb0cf74b4270d5eb51f0",
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902527",
      name: "McSaver Double Cheese McMuffin Meal",
      category: "McBreakfast",
      description: "McSaver Double Cheese McMuffin Meal",
      imageId: "f23dd82d68c8d17e197e1a6fcf051348",
      isVeg: 1,
      price: 14190,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902528",
      name: "Double Cheese McMuffin 3 Pc Meal with Cappuccino (S)",
      category: "McBreakfast",
      description:
        "Try the delcious combo of Double Cheese McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
      imageId: "e2fe2dfeba0b3f02f6db39192feca1db",
      isVeg: 1,
      price: 22900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82867897",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902530",
      name: "McSaver Spicy Egg McMuffin Meal",
      category: "McBreakfast",
      description: "McSaver Spicy Egg McMuffin Meal",
      imageId: "f458881bca6a30b56b5a858ca48c7c17",
      price: 14190,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902531",
      name: "Spicy Egg McMuffin 3 Pc Meal with Cappuccino (S)",
      category: "McBreakfast",
      description:
        "Try the delcious combo of Spicy Egg McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
      imageId: "342659232a44036152ee88770d9d9b9e",
      price: 23900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868257",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "75902533",
      name: "Spicy Egg McMuffin",
      category: "McBreakfast",
      description:
        "Spice up your mornings with the new Spicy Egg McMuffin, Freshly cracked and steamed egg patty topped with spicy masala seasoning, shredded onions, topped with habanero sauce, layered between toasted and buttered Muffin buns.",
      imageId: "f995f7fdf52284c700197a42b3869c1c",
      price: 10100,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "75902534",
      name: "McSaver Egg & Cheese McMuffin Meal",
      category: "McBreakfast",
      description:
        "Start your day with a combo of Egg & Cheese McMuffin and a Cappuccino (S)",
      imageId: "62c69f295c48bd2013db8a9e797bb80b",
      price: 14190,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112712022",
      name: "Spicy Egg McMuffin 3 PC Meal",
      category: "McBreakfast",
      description: "Spicy Egg McMuffin 3 PC Meal with Filter Coffee",
      imageId: "fbd62fe93cf564f9787a69a20c8ef6e9",
      price: 6500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "82868253",
          groupName: "Choose an option",
          choices: [
            {
              id: "67537029",
              name: "Mocha (R)",
              price: 14000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537028",
              name: "Hot Chocolate (R)",
              price: 12000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537026",
              name: "Latte (R)",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537037",
              name: "Lemon Chiller",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537025",
              name: "Mocha (S)",
              price: 11500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537036",
              name: "McCafe-Ice Coffee",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537035",
              name: "Green Apple Chiller",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537023",
              name: "Hot Chocolate (S)",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537034",
              name: "McCafe-Classic Coffee",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537033",
              name: "McCafe-Chocolate Frappe",
              price: 18100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537032",
              name: "Strawberry Chiller",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537031",
              name: "McCafe-Mocha Frappe",
              price: 18100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67537030",
              name: "Cappuccino (S)",
              price: 7500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      nextAvailableAtMessage: "Next available at 8 am, tomorrow",
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "30% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[bgW] = {
  "Offers & Value Deals": [
    {
      id: "92662513",
      name: "Keep Cake & Celebrate + 1 FREE Delight",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 2-3  | Choose any one double layer waffle cake- Death by chococolate Waffle Cake (Double Layer)/ Red velvet waffle Cake (Double Layer)/ Kiki and Oreo Cream waffle cake (Double Layer) and select 1 FREE waffle or pancake from our top picks. Energy - 525 KCAL",
      imageId: "31ce167dc68121669c2f4a7f7ca469c0",
      inStock: 1,
      isVeg: 1,
      price: 58052,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784064",
          groupName: "Waffle Cake",
          choices: [
            {
              id: "41467484",
              name: "Death by Chocolate Waffle Cake (Double Layer)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467486",
              name: "Kiki and Oreo Waffle Cake (Double Layer)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "57504529",
              name: "Berry Velvet Waffle Cake (Double Layer)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "45264712",
              name: "Walnut Brownie Waffle Cake (Double Layer)",
              price: 1905,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784068",
          groupName: "Free Delight",
          choices: [
            {
              id: "54073985",
              name: "Triple Chocolate Mini Pancakes (8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54073983",
              name: "Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467476",
              name: "Belgian Chocolate Milk Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467490",
              name: "Belgian Chocolate Dark Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92662521",
      name: "The WaffShake Duo",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 1 | Triple Chocolate Waffle + Belgian Chocolate Shake. Energy - 457 Kcal per item",
      imageId: "18c3d1aa70f3f6e4fcb4a0a8ed99774b",
      inStock: 1,
      isVeg: 1,
      price: 34667,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "54183565",
          groupName: "Waffle",
          choices: [
            {
              id: "41467493",
              name: "Triple Chocolate Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "54183566",
          groupName: "Shake",
          choices: [
            {
              id: "44450518",
              name: "Belgian Chocolate Shake",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662523",
      name: "Happiness in mini version + 1 FREE Delight",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 1 | Buy Chocolate Mini Waffle Combo pack of 6 and select 1 FREE waffle or pancake from our top picks. Energy - 452 KCAL",
      imageId: "68e17b6856045111d70d4e8d2b105ed2",
      inStock: 1,
      isVeg: 1,
      price: 51119,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784090",
          groupName: "Mini Waffle Combo",
          choices: [
            {
              id: "41467464",
              name: "Naked Nutella Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467466",
              name: "Belgian Chocolate Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467465",
              name: "Chocolate Overload Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467467",
              name: "Dark & White Fantasy Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44191149",
              name: "KitKat Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41711818",
              name: "Belgian Chocolate Dark Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467470",
              name: "Mini Waffle Box (6 Mini Waffle)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
          minAddons: 7,
        },
        {
          groupId: "51784091",
          groupName: "Free Delight",
          choices: [
            {
              id: "54073983",
              name: "Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54073985",
              name: "Triple Chocolate Mini Pancakes (8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467476",
              name: "Belgian Chocolate Milk Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467513",
              name: "Maple Butter Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "92662525",
      name: "The Belgian Club + 1 Free Delight (Milk)",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 3-4  | Buy Belgian chocolate [Milk] waffle and select 1 FREE waffle or pancake from our top picks. Energy - 447 Kcal per item",
      imageId: "4bd400b2fbc760ada31bb766854b315c",
      inStock: 1,
      isVeg: 1,
      price: 46713,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51922228",
          groupName: "Waffle",
          choices: [
            {
              id: "41711827",
              name: "Belgian Chocolate Milk Waffle x 3",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784094",
          groupName: "Free Delight",
          choices: [
            {
              id: "54073983",
              name: "Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54073985",
              name: "Triple Chocolate Mini Pancakes (8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467476",
              name: "Belgian Chocolate Milk Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467513",
              name: "Maple Butter Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662527",
      name: "The Belgian Club + 1 Free Delight (Dark)",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 3-4  | Buy Belgian chocolate [Dark] waffle and select 1 FREE waffle or pancake from our top picks. Energy - 452 Kcal per item",
      imageId: "4bd400b2fbc760ada31bb766854b315c",
      inStock: 1,
      isVeg: 1,
      price: 46713,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51922231",
          groupName: "Waffle",
          choices: [
            {
              id: "41711828",
              name: "Belgian Chocolate Dark Waffle x 3",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784097",
          groupName: "Free Delight",
          choices: [
            {
              id: "54073983",
              name: "Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54073985",
              name: "Triple Chocolate Mini Pancakes (8 Pieces)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467476",
              name: "Belgian Chocolate Milk Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467513",
              name: "Maple Butter Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662531",
      name: "Mini Treats",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 3-4  | Treat your tribe! Save Rs. 67 flat & enjoy Mini Waffle pack of 4 (assorted) + Mini Waffle pack of 4 (chocolate) Energy - 456 Kcal per item",
      imageId: "c09a7c9a2104893edc7c800a1f38d858",
      inStock: 1,
      isVeg: 1,
      price: 59944,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784101",
          groupName: "Mini Waffle 1",
          choices: [
            {
              id: "41467464",
              name: "Naked Nutella Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784102",
          groupName: "Mini Waffle 2",
          choices: [
            {
              id: "41467466",
              name: "Belgian Chocolate Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784103",
          groupName: "Mini Waffle 3",
          choices: [
            {
              id: "41467467",
              name: "Dark & White Fantasy Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "52684196",
          groupName: "Mini Waffle 4",
          choices: [
            {
              id: "41712399",
              name: "Chocolate Overload Dark Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784107",
          groupName: "Mini Waffle 5",
          choices: [
            {
              id: "41467519",
              name: "Almond Cocoa Butter Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784109",
          groupName: "Mini Waffle 6",
          choices: [
            {
              id: "41467469",
              name: "Red Velvet Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784111",
          groupName: "Mini Waffle 7",
          choices: [
            {
              id: "45264736",
              name: "Berry Velvet Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784113",
          groupName: "Mini Waffle 8",
          choices: [
            {
              id: "41467520",
              name: "Belgian Chocolate Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784114",
          groupName: "Box 1",
          choices: [
            {
              id: "41467521",
              name: "Mini Waffle Box",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784115",
          groupName: "Box 2",
          choices: [
            {
              id: "41467522",
              name: "Mini Waffle Box",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "96295378",
      name: "Treats For Two",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 2 | 1 for you, 1 for me & 1 for us. Save Rs. 52 flat & enjoy Belgian Chocolate Milk Waffle + Red Velvet Waffle + Signature Cold Coffee. Energy - 452 Kcal per item",
      imageId: "8fb65da221d2a8ca558109ebfb896ddb",
      inStock: 1,
      isVeg: 1,
      price: 40910,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "55425822",
          groupName: "Waffle 1",
          choices: [
            {
              id: "41467476",
              name: "Belgian Chocolate Milk Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "55425823",
          groupName: "Waffle 2",
          choices: [
            {
              id: "41467515",
              name: "Red Velvet Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "55425824",
          groupName: "Shake",
          choices: [
            {
              id: "45264714",
              name: "Signature Cold Coffee",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295399",
      name: "Make At Home @ Rs.349",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 1 | Save Rs. 78. Make our delicious waffles or pancakes in the comfort of your home with our Premix & Spreads combos! Energy - Original Pancake & Waffle Mix- 377 Kcal, Dark Choco Spread- 593 kcal",
      imageId: "cbee21525f03683222ebd6e9ef4dd02c",
      inStock: 1,
      isVeg: 1,
      price: 34900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "55425934",
          groupName: "Premix",
          choices: [
            {
              id: "45264723",
              name: "Original Pancake & Waffle Mix",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "55425935",
          groupName: "Spreads",
          choices: [
            {
              id: "45264724",
              name: "Milk Choco Spread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "45264725",
              name: "Dark Choco Spread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "45264726",
              name: "Cookie & Cream Spread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295400",
      name: "Make At Home @ Rs.375",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 1 | Save Rs. 72. Make our delicious waffles or pancakes in the comfort of your home with our Premix & Spreads combos! Energy - Choco Oats Pancake & Waffle Mix- 387 Kcal,  Dark Choco Spread- 593 Kcal",
      imageId: "6bbd318e5aa4d61b171a3e7663e4d9dd",
      inStock: 1,
      isVeg: 1,
      price: 37500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "55425936",
          groupName: "Premix",
          choices: [
            {
              id: "45264727",
              name: "Chocolate Oats Pancake & Waffle Mix",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "55425937",
          groupName: "Spreads",
          choices: [
            {
              id: "45264724",
              name: "Milk Choco Spread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "45264725",
              name: "Dark Choco Spread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "45264726",
              name: "Cookie & Cream Spread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96364258",
      name: "Best Of The Best",
      category: "Offers & Value Deals",
      description:
        "Serves 1 | Serves 4 | Share our besties with your besties! Choose any 5 best-selling Waffle from below list for a flat price! (Naked Nutella or Triple Chocolate or Belgian Chocolate Milk or Belgian Chocolate Dark or KitKat Waffle or Red Velvet). Energy - 462 Kcal per item",
      imageId: "fc529e8c5a543ceb729d7786d1b01858",
      inStock: 1,
      isVeg: 1,
      price: 66000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "60372811",
          groupName: "Waffwich",
          choices: [
            {
              id: "41467471",
              name: "Naked Nutella Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467476",
              name: "Belgian Chocolate Milk Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467490",
              name: "Belgian Chocolate Dark Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "45264713",
              name: "KitKat Waffle (Regular Batter)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467493",
              name: "Triple Chocolate Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467515",
              name: "Red Velvet Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
          minAddons: 5,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Waffle Sundae": [
    {
      id: "99154192",
      name: "Choco Brownie Sundae (L)",
      category: "Waffle Sundae",
      description:
        "Serves 1 | Serves 1 | A chocolicious combination is on your way! Chocolate ice cream topped with brownie waffle chunks, crushed walnuts & choco fudge sauce will surely melt your heart. (Images are for representation purpose only) Energy - 271.21 KCAL",
      imageId: "q4l146zpl8wuzlw1hctx",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "99154194",
      name: "Berry Red Velvet Sundae (L)",
      category: "Waffle Sundae",
      description:
        "Serves 1 | Serves 1  | We love this sundae berry berry much! Enjoy the richness of the red velvet waffle chunks and vanilla ice cream with the blast of fresh strawberry compote and white chocolate spread, topped with the crunchy red velvet wafer (Images are for representation purpose only)  Energy - 241.27 KCAL",
      imageId: "gr1edoyleogvtfyjhcmh",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "99154196",
      name: "Banoffee Sundae (L)",
      category: "Waffle Sundae",
      description:
        "Serves 1 | Serves 1  | A combination that you have never tasted before! Dense vanilla ice cream paired with classic waffle chunks and generously topped with real bananas, lotus biscoff spread, and biscuits. (Images are for representation purpose only)  Energy - 274.01 KCAL",
      imageId: "nzqpq4btpocjrco0zida",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Waffle with Ice Cream": [
    {
      id: "92662399",
      name: "Ice Cream & Fudge Vanilla Waffle",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Layer Of Chocolate Fudge Sauce Topped With Vanilla Ice Cream And Chocolate Fudge Drizzle. A Dreamy Combination! Energy - 374.85 KCAL",
      imageId: "czqyg4anhlhvyyeryzbn",
      inStock: 1,
      isVeg: 1,
      price: 17571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783710",
          groupName:
            "Choose From Ice Cream for Ice Cream & Fudge Vanilla Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783709",
          groupName:
            "Choose From Extra Fillings for Ice Cream & Fudge Vanilla Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783708",
          groupName: "Choose From Add On for Ice Cream & Fudge Vanilla Waffle",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662400",
      name: "Ice Cream & Fudge Chocolate Waffle",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Layer Of Chocolate Fudge Sauce Topped with Chocolate Ice Cream And Chocolate Fudge Drizzle. A Dreamy Combination!  Energy - 336.66 KCAL",
      imageId: "dnkoaek8pr8ormkj4ahw",
      inStock: 1,
      isVeg: 1,
      price: 17571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783713",
          groupName:
            "Choose From Ice Cream for Ice Cream & Fudge Chocolate Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783712",
          groupName:
            "Choose From Extra Fillings for Ice Cream & Fudge Chocolate Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783711",
          groupName:
            "Choose From Add On for Ice Cream & Fudge Chocolate Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92662401",
      name: "Triple Cookie",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Original Red Velvet Waffle + A Divine Combination Of Biscoff, Oreo And KitKat Bits In Melted White Chocolate And Vanilla Ice Cream. A Must Try Symphony Of Flavours And Textures.  Energy - 416.73 KCAL",
      imageId: "onkp7n1q63m0fgb7b9rt",
      inStock: 1,
      isVeg: 1,
      price: 20524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783718",
          groupName: "Choose From Ice Cream for Triple Cookie",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783717",
          groupName: "Choose From Extra Fillings for Triple Cookie",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783715",
          groupName: "Choose From Add On for Triple Cookie",
          choices: [
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "92662402",
      name: "Rocky Road",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Signature Dark Chocolate Waffle Loaded With A Combination Of Vanilla Ice Cream, Melted Milk Chocolate, Oreo Cookies And Roasted Almonds. Simply Majestic.  Energy - 461.68 KCAL",
      imageId: "ietykhrzrfetnvxixszx",
      inStock: 1,
      isVeg: 1,
      price: 19476,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783722",
          groupName: "Choose From Ice Cream for Rocky Road",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783721",
          groupName: "Choose From Extra Fillings for Rocky Road",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783720",
          groupName: "Choose From Add On for Rocky Road",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "92662495",
      name: "Ice Cream and Fudge Vanilla Mini Pancakes (8 Pieces)",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Classic Mini Pancakes + Layer Of Chocolate Fudge Sauce Topped with Vanilla Ice Cream And Chocolate Fudge Drizzle. A Dreamy Combination!  Energy - 332 KCAL",
      imageId: "vvk0ugkwllkh5c4dfssc",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779637",
          groupName:
            "Choose From Ice Cream for Ice Cream and Fudge Vanilla Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779638",
          groupName:
            "Choose From Extra Fillings for Ice Cream and Fudge Vanilla Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779639",
          groupName:
            "Choose From Add On for Ice Cream and Fudge Vanilla Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662496",
      name: "Ice Cream and Fudge Chocolate Mini Pancakes (8 Pieces)",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Classic Mini Pancakes + Layer Of Chocolate Fudge Sauce Topped with Chocolate Ice Cream And Chocolate Fudge Drizzle. A Dreamy Combination!  Energy - 323 KCAL",
      imageId: "xdhd0us5e08z7bd868cn",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779641",
          groupName:
            "Choose From Ice Cream for Ice Cream and Fudge Chocolate Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779642",
          groupName:
            "Choose From Extra Fillings for Ice Cream and Fudge Chocolate Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779643",
          groupName:
            "Choose From Add On for Ice Cream and Fudge Chocolate Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662497",
      name: "Triple Cookie Mini Pancakes (8 Pieces)",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Original Red Velvet Mini Pancake + A divine combination of Biscoff, Oreo and KitKat bits in melted White Chocolate and Vanilla Ice Cream. A must try symphony of flavours and textures.  Energy - 365 KCAL",
      imageId: "x2jkjjmt7up3zyx9wukp",
      inStock: 1,
      isVeg: 1,
      price: 17571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779644",
          groupName:
            "Choose From Ice Cream for Triple Cookie Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779645",
          groupName:
            "Choose From Extra Fillings for Triple Cookie Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779646",
          groupName:
            "Choose From Add On for Triple Cookie Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662498",
      name: "Rocky Road Mini Pancakes (8 Pieces)",
      category: "Waffle with Ice Cream",
      description:
        "Serves 1 | Serves 1 | Signature dark chocolate Mini Pancakes + Vanilla Ice Cream +  Oreos + Roasted almonds + melted milk chocolate. Simply majestic.  Energy - 355 KCAL",
      imageId: "qdwtbgaamv3h93oywu1f",
      inStock: 1,
      isVeg: 1,
      price: 16619,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779647",
          groupName:
            "Choose From Ice Cream for Rocky Road Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779648",
          groupName:
            "Choose From Extra Fillings for Rocky Road Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779649",
          groupName:
            "Choose From Add On for Rocky Road Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Waffles: [
    {
      id: "50666339",
      name: "Triple Chocolate Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Signature Dark Chocolate Waffle + 3 Layers Of Melted White Chocolate, Belgian Milk Chocolate And Belgian Dark Chocolate. The Most Indulgent Chocolate Waffle Ever! Energy - 456.5 KCAL",
      imageId: "onq8rhxujd0sx8kubaew",
      inStock: 1,
      isVeg: 1,
      price: 17571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783595",
          groupName: "Choose From Ice Cream for Triple Chocolate Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783594",
          groupName: "Choose From Extra Fillings for Triple Chocolate Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783593",
          groupName: "Choose From Add On for Triple Chocolate Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "102 ratings",
          ratingCountV2: "102",
        },
      },
    },
    {
      id: "50666348",
      name: "Red Velvet Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Original Red Velvet Waffle + Philadelphia style cream cheese and melted Belgian white chocolate. A true Original!  Energy - 441.63 KCAL",
      imageId: "izclpbaijnfbe6dvksts",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783673",
          groupName: "Choose From Ice Cream for Red Velvet Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783671",
          groupName: "Choose From Extra Fillings for Red Velvet Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783669",
          groupName: "Choose From Add On for Red Velvet Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "66750067",
      name: "Biscoff Milkyway Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Signature Black Velvet Waffle + Fondant Of Melted White Chocolate Filled With Crunchy Lotus Biscoff Bits. An All Time Favorite!  Energy - 458.42 KCAL",
      imageId: "kkaojgh2cudnmicfndfj",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "62699192",
          groupName: "Choose From Ice Cream for Biscoff Milkyway Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "62699194",
          groupName: "Choose From Extra Fillings for Biscoff Milkyway Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 11,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783737",
          groupName: "Choose From Add On for Biscoff Milkyway Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "70435346",
      name: "Chocolate Overload Dark Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Signature Dark Chocolate Waffle + Melted Belgian Dark Chocolate. Double The Chocolate! Energy - 453.95 KCAL",
      imageId: "ggnwmgrznp4jjzwwyhjx",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783585",
          groupName: "Choose From Ice Cream for Chocolate Overload Dark Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783584",
          groupName:
            "Choose From Extra Fillings for Chocolate Overload Dark Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783583",
          groupName: "Choose From Add On for Chocolate Overload Dark Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "53 ratings",
          ratingCountV2: "53",
        },
      },
    },
    {
      id: "70435479",
      name: "Chocolate Overload Milk Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Signature Dark Chocolate Waffle + Melted Belgian Milk Chocolate. Double The Chocolate! Energy - 432.81 KCAL",
      imageId: "uoqt4nodzskmp1xldjbw",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783574",
          groupName: "Choose From Ice Cream for Chocolate Overload Milk Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783572",
          groupName:
            "Choose From Extra Fillings for Chocolate Overload Milk Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783570",
          groupName: "Choose From Add On for Chocolate Overload Milk Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "90047358",
      name: "Almond Brownie Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | The Best Of Two Worlds In A Single Bite - A Waffle And A Brownie. With Deliciously Rich Melted Chocolate and Almonds. Your Doorway To Heaven!  Energy - 477.14 KCAL",
      imageId: "lyohj85p1nfyuyn2dr73",
      inStock: 1,
      isVeg: 1,
      price: 18238,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783601",
          groupName: "Choose From Ice Cream for Almond Brownie Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783600",
          groupName: "Choose From Extra Fillings for Almond Brownie Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783599",
          groupName: "Choose From Add On for Almond Brownie Waffle",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
    {
      id: "90047369",
      name: "Walnut Brownie Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | The Best Of Two Worlds In A Single Bite - A Waffle And A Brownie. With Deliciously Rich Melted Chocolate and Walnuts. Your Doorway To Heaven!  Energy - 443.34 KCAL",
      imageId: "qvqshnsdnzrztssiesiw",
      inStock: 1,
      isVeg: 1,
      price: 18238,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783649",
          groupName: "Choose From Ice Cream for Walnut Brownie Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783648",
          groupName: "Choose From Extra Fillings for Walnut Brownie Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783647",
          groupName: "Choose From Add On for Walnut Brownie Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "92662378",
      name: "Dark and White Fantasy Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Signature Dark Chocolate Waffle + Fondant Of Melted Belgian White Chocolate. A Match Made In Heaven!  Energy - 458.31 KCAL",
      imageId: "mtexxlclhen7gkljsems",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51783589",
          groupName: "Choose From Ice Cream for Dark and White Fantasy Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783588",
          groupName:
            "Choose From Extra Fillings for Dark and White Fantasy Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783587",
          groupName: "Choose From Add On for Dark and White Fantasy Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "92662406",
      name: "Kiki & Oreo Cream Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Signature Black Velvet Waffle + Our Special Blue Filling with Cookie Crunchy Oreo Bits Filling. Kiki Do You Love Me?  Energy - 515.21 KCAL",
      imageId: "zg9wrn32hrffl6bz6vc2",
      inStock: 1,
      isVeg: 1,
      price: 15571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "62699195",
          groupName: "Choose From Ice Cream for Kiki & Oreo Cream Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "62699196",
          groupName: "Choose From Extra Fillings for Kiki & Oreo Cream Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 12,
          maxFreeAddons: -1,
        },
        {
          groupId: "51783735",
          groupName: "Choose From Add On for Kiki & Oreo Cream Waffle",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "31 ratings",
          ratingCountV2: "31",
        },
      },
    },
    {
      id: "96295401",
      name: "Belgian Chocolate Milk Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Melted Belgian Milk Chocolate. Simplicity At Its Best!  Energy - 452.19 KCAL",
      imageId: "uepao2q7bc4prdmqw6rx",
      inStock: 1,
      isVeg: 1,
      price: 15571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155521",
            name: "Choose from Belgian Chocolate Milk Waffle",
            variations: [
              {
                name: "Belgian Chocolate Milk Waffle (Regular Batter)",
                default: 1,
                id: "57486471",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Belgian Chocolate Milk Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486470",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155521",
                variationId: "57486471",
              },
            ],
            price: 15571,
            addonCombinations: [
              {
                groupId: "55425939",
                addonId: "41467132",
              },
              {
                groupId: "55425939",
                addonId: "41467134",
              },
              {
                groupId: "55425939",
                addonId: "41467136",
              },
              {
                groupId: "55425939",
                addonId: "55402204",
              },
              {
                groupId: "55425939",
                addonId: "54074008",
              },
              {
                groupId: "55425939",
                addonId: "41467138",
              },
              {
                groupId: "55425939",
                addonId: "54074009",
              },
              {
                groupId: "55425939",
                addonId: "41467140",
              },
              {
                groupId: "55425939",
                addonId: "41467142",
              },
              {
                groupId: "55425939",
                addonId: "41467143",
              },
              {
                groupId: "55425941",
                addonId: "41467145",
              },
              {
                groupId: "55425941",
                addonId: "41467147",
              },
              {
                groupId: "55425941",
                addonId: "41467149",
              },
              {
                groupId: "55425941",
                addonId: "41467151",
              },
              {
                groupId: "55425941",
                addonId: "41467152",
              },
              {
                groupId: "55425941",
                addonId: "41467154",
              },
              {
                groupId: "55425941",
                addonId: "41467156",
              },
              {
                groupId: "55425941",
                addonId: "41467158",
              },
              {
                groupId: "55425941",
                addonId: "41467160",
              },
              {
                groupId: "55425941",
                addonId: "41467162",
              },
              {
                groupId: "55425941",
                addonId: "41467163",
              },
              {
                groupId: "55425941",
                addonId: "41467165",
              },
              {
                groupId: "55425941",
                addonId: "41467167",
              },
              {
                groupId: "55425941",
                addonId: "41467171",
              },
              {
                groupId: "55425943",
                addonId: "41467176",
              },
              {
                groupId: "55425943",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155521",
                variationId: "57486470",
              },
            ],
            price: 19071,
            addonCombinations: [
              {
                groupId: "55425938",
                addonId: "41467132",
              },
              {
                groupId: "55425938",
                addonId: "41467134",
              },
              {
                groupId: "55425938",
                addonId: "41467136",
              },
              {
                groupId: "55425938",
                addonId: "41467138",
              },
              {
                groupId: "55425938",
                addonId: "41467140",
              },
              {
                groupId: "55425938",
                addonId: "41467142",
              },
              {
                groupId: "55425938",
                addonId: "41467143",
              },
              {
                groupId: "55425938",
                addonId: "55402204",
              },
              {
                groupId: "55425938",
                addonId: "54074008",
              },
              {
                groupId: "55425938",
                addonId: "54074009",
              },
              {
                groupId: "55425940",
                addonId: "41467145",
              },
              {
                groupId: "55425940",
                addonId: "41467147",
              },
              {
                groupId: "55425940",
                addonId: "41467149",
              },
              {
                groupId: "55425940",
                addonId: "41467151",
              },
              {
                groupId: "55425940",
                addonId: "41467152",
              },
              {
                groupId: "55425940",
                addonId: "41467154",
              },
              {
                groupId: "55425940",
                addonId: "41467156",
              },
              {
                groupId: "55425940",
                addonId: "41467158",
              },
              {
                groupId: "55425940",
                addonId: "41467160",
              },
              {
                groupId: "55425940",
                addonId: "41467162",
              },
              {
                groupId: "55425940",
                addonId: "41467163",
              },
              {
                groupId: "55425940",
                addonId: "41467165",
              },
              {
                groupId: "55425940",
                addonId: "41467167",
              },
              {
                groupId: "55425940",
                addonId: "41467171",
              },
              {
                groupId: "55425942",
                addonId: "41467176",
              },
              {
                groupId: "55425942",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55425942",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate Milk Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425943",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate Milk Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425940",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate Milk Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425941",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate Milk Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425939",
          groupName:
            "Choose From Add On for Belgian Chocolate Milk Waffle (Regular Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425938",
          groupName:
            "Choose From Add On for Belgian Chocolate Milk Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 15571,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "38 ratings",
          ratingCountV2: "38",
        },
      },
    },
    {
      id: "96295402",
      name: "Belgian Chocolate Dark Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Melted Belgian Dark Chocolate. Darker Simplicity! Energy - 446.5 KCAL",
      imageId: "hlrrukbpjasmhczocwb6",
      inStock: 1,
      isVeg: 1,
      price: 15571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155522",
            name: "Choose from Belgian Chocolate Dark Waffle",
            variations: [
              {
                name: "Belgian Chocolate Dark Waffle (Regular Batter)",
                default: 1,
                id: "57486473",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Belgian Chocolate Dark Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486472",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155522",
                variationId: "57486473",
              },
            ],
            price: 15571,
            addonCombinations: [
              {
                groupId: "55425945",
                addonId: "41467132",
              },
              {
                groupId: "55425945",
                addonId: "41467134",
              },
              {
                groupId: "55425945",
                addonId: "41467136",
              },
              {
                groupId: "55425945",
                addonId: "55402204",
              },
              {
                groupId: "55425945",
                addonId: "54074008",
              },
              {
                groupId: "55425945",
                addonId: "41467138",
              },
              {
                groupId: "55425945",
                addonId: "54074009",
              },
              {
                groupId: "55425945",
                addonId: "41467140",
              },
              {
                groupId: "55425945",
                addonId: "41467142",
              },
              {
                groupId: "55425945",
                addonId: "41467143",
              },
              {
                groupId: "55425947",
                addonId: "41467145",
              },
              {
                groupId: "55425947",
                addonId: "41467147",
              },
              {
                groupId: "55425947",
                addonId: "41467149",
              },
              {
                groupId: "55425947",
                addonId: "41467151",
              },
              {
                groupId: "55425947",
                addonId: "41467152",
              },
              {
                groupId: "55425947",
                addonId: "41467154",
              },
              {
                groupId: "55425947",
                addonId: "41467156",
              },
              {
                groupId: "55425947",
                addonId: "41467158",
              },
              {
                groupId: "55425947",
                addonId: "41467160",
              },
              {
                groupId: "55425947",
                addonId: "41467162",
              },
              {
                groupId: "55425947",
                addonId: "41467163",
              },
              {
                groupId: "55425947",
                addonId: "41467165",
              },
              {
                groupId: "55425947",
                addonId: "41467167",
              },
              {
                groupId: "55425947",
                addonId: "41467171",
              },
              {
                groupId: "55425949",
                addonId: "41467176",
              },
              {
                groupId: "55425949",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155522",
                variationId: "57486472",
              },
            ],
            price: 19071,
            addonCombinations: [
              {
                groupId: "55425944",
                addonId: "41467132",
              },
              {
                groupId: "55425944",
                addonId: "41467134",
              },
              {
                groupId: "55425944",
                addonId: "41467136",
              },
              {
                groupId: "55425944",
                addonId: "41467138",
              },
              {
                groupId: "55425944",
                addonId: "41467140",
              },
              {
                groupId: "55425944",
                addonId: "41467142",
              },
              {
                groupId: "55425944",
                addonId: "41467143",
              },
              {
                groupId: "55425944",
                addonId: "55402204",
              },
              {
                groupId: "55425944",
                addonId: "54074008",
              },
              {
                groupId: "55425944",
                addonId: "54074009",
              },
              {
                groupId: "55425946",
                addonId: "41467145",
              },
              {
                groupId: "55425946",
                addonId: "41467147",
              },
              {
                groupId: "55425946",
                addonId: "41467149",
              },
              {
                groupId: "55425946",
                addonId: "41467151",
              },
              {
                groupId: "55425946",
                addonId: "41467152",
              },
              {
                groupId: "55425946",
                addonId: "41467154",
              },
              {
                groupId: "55425946",
                addonId: "41467156",
              },
              {
                groupId: "55425946",
                addonId: "41467158",
              },
              {
                groupId: "55425946",
                addonId: "41467160",
              },
              {
                groupId: "55425946",
                addonId: "41467162",
              },
              {
                groupId: "55425946",
                addonId: "41467163",
              },
              {
                groupId: "55425946",
                addonId: "41467165",
              },
              {
                groupId: "55425946",
                addonId: "41467167",
              },
              {
                groupId: "55425946",
                addonId: "41467171",
              },
              {
                groupId: "55425948",
                addonId: "41467176",
              },
              {
                groupId: "55425948",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55425948",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate Dark Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425949",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate Dark Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425946",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate Dark Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425947",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate Dark Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425944",
          groupName:
            "Choose From Add On for Belgian Chocolate Dark Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425945",
          groupName:
            "Choose From Add On for Belgian Chocolate Dark Waffle (Regular Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 15571,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "25 ratings",
          ratingCountV2: "25",
        },
      },
    },
    {
      id: "96295403",
      name: "Butterscotch Crunch Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Crunchy Butterscotch Fudge. Go On Indulge!  Energy - 466.64 KCAL",
      imageId: "j7i5ie6zete7ez4oprvh",
      inStock: 1,
      isVeg: 1,
      price: 13524,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155523",
            name: "Choose from Butterscotch Crunch Waffle",
            variations: [
              {
                name: "Butterscotch Crunch Waffle (Regular Batter)",
                default: 1,
                id: "57486475",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Butterscotch Crunch Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486474",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155523",
                variationId: "57486475",
              },
            ],
            price: 13524,
            addonCombinations: [
              {
                groupId: "55425951",
                addonId: "41467140",
              },
              {
                groupId: "55425951",
                addonId: "41467134",
              },
              {
                groupId: "55425951",
                addonId: "41467136",
              },
              {
                groupId: "55425951",
                addonId: "55402204",
              },
              {
                groupId: "55425951",
                addonId: "54074008",
              },
              {
                groupId: "55425951",
                addonId: "41467138",
              },
              {
                groupId: "55425951",
                addonId: "54074009",
              },
              {
                groupId: "55425951",
                addonId: "41467132",
              },
              {
                groupId: "55425951",
                addonId: "41467142",
              },
              {
                groupId: "55425951",
                addonId: "41467143",
              },
              {
                groupId: "55425953",
                addonId: "41467145",
              },
              {
                groupId: "55425953",
                addonId: "41467147",
              },
              {
                groupId: "55425953",
                addonId: "41467149",
              },
              {
                groupId: "55425953",
                addonId: "41467151",
              },
              {
                groupId: "55425953",
                addonId: "41467152",
              },
              {
                groupId: "55425953",
                addonId: "41467154",
              },
              {
                groupId: "55425953",
                addonId: "41467156",
              },
              {
                groupId: "55425953",
                addonId: "41467158",
              },
              {
                groupId: "55425953",
                addonId: "41467160",
              },
              {
                groupId: "55425953",
                addonId: "41467162",
              },
              {
                groupId: "55425953",
                addonId: "41467163",
              },
              {
                groupId: "55425953",
                addonId: "41467165",
              },
              {
                groupId: "55425953",
                addonId: "41467167",
              },
              {
                groupId: "55425953",
                addonId: "41467171",
              },
              {
                groupId: "55425955",
                addonId: "41467176",
              },
              {
                groupId: "55425955",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155523",
                variationId: "57486474",
              },
            ],
            price: 17024,
            addonCombinations: [
              {
                groupId: "55425950",
                addonId: "41467134",
              },
              {
                groupId: "55425950",
                addonId: "41467136",
              },
              {
                groupId: "55425950",
                addonId: "41467138",
              },
              {
                groupId: "55425950",
                addonId: "41467140",
              },
              {
                groupId: "55425950",
                addonId: "41467142",
              },
              {
                groupId: "55425950",
                addonId: "41467143",
              },
              {
                groupId: "55425950",
                addonId: "55402204",
              },
              {
                groupId: "55425950",
                addonId: "54074008",
              },
              {
                groupId: "55425950",
                addonId: "54074009",
              },
              {
                groupId: "55425950",
                addonId: "41467132",
              },
              {
                groupId: "55425952",
                addonId: "41467145",
              },
              {
                groupId: "55425952",
                addonId: "41467147",
              },
              {
                groupId: "55425952",
                addonId: "41467149",
              },
              {
                groupId: "55425952",
                addonId: "41467151",
              },
              {
                groupId: "55425952",
                addonId: "41467152",
              },
              {
                groupId: "55425952",
                addonId: "41467154",
              },
              {
                groupId: "55425952",
                addonId: "41467156",
              },
              {
                groupId: "55425952",
                addonId: "41467158",
              },
              {
                groupId: "55425952",
                addonId: "41467160",
              },
              {
                groupId: "55425952",
                addonId: "41467162",
              },
              {
                groupId: "55425952",
                addonId: "41467163",
              },
              {
                groupId: "55425952",
                addonId: "41467165",
              },
              {
                groupId: "55425952",
                addonId: "41467167",
              },
              {
                groupId: "55425952",
                addonId: "41467171",
              },
              {
                groupId: "55425954",
                addonId: "41467176",
              },
              {
                groupId: "55425954",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55425955",
          groupName:
            "Choose From Ice Cream for Butterscotch Crunch Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425954",
          groupName:
            "Choose From Ice Cream for Butterscotch Crunch Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425952",
          groupName:
            "Choose From Extra Fillings for Butterscotch Crunch Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425953",
          groupName:
            "Choose From Extra Fillings for Butterscotch Crunch Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425951",
          groupName:
            "Choose From Add On for Butterscotch Crunch Waffle (Regular Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55425950",
          groupName:
            "Choose From Add On for Butterscotch Crunch Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 13524,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "96295417",
      name: "Coffee Mocha Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Melted Chocolate Infused With Coffee Crumbs. For Coffee Lovers! Energy - 475.7 KCAL",
      imageId: "ii9usixjbv7djr6g8xui",
      inStock: 1,
      isVeg: 1,
      price: 14571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155537",
            name: "Choose from Coffee Mocha Waffle",
            variations: [
              {
                name: "Coffee Mocha Waffle (Regular Batter)",
                default: 1,
                id: "57486502",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Coffee Mocha Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486501",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155537",
                variationId: "57486502",
              },
            ],
            price: 14571,
            addonCombinations: [
              {
                groupId: "55426030",
                addonId: "41467140",
              },
              {
                groupId: "55426030",
                addonId: "41467134",
              },
              {
                groupId: "55426030",
                addonId: "41467136",
              },
              {
                groupId: "55426030",
                addonId: "55402204",
              },
              {
                groupId: "55426030",
                addonId: "54074008",
              },
              {
                groupId: "55426030",
                addonId: "41467138",
              },
              {
                groupId: "55426030",
                addonId: "54074009",
              },
              {
                groupId: "55426030",
                addonId: "41467132",
              },
              {
                groupId: "55426030",
                addonId: "41467142",
              },
              {
                groupId: "55426030",
                addonId: "41467143",
              },
              {
                groupId: "55426032",
                addonId: "41467145",
              },
              {
                groupId: "55426032",
                addonId: "41467147",
              },
              {
                groupId: "55426032",
                addonId: "41467149",
              },
              {
                groupId: "55426032",
                addonId: "41467151",
              },
              {
                groupId: "55426032",
                addonId: "41467152",
              },
              {
                groupId: "55426032",
                addonId: "41467154",
              },
              {
                groupId: "55426032",
                addonId: "41467156",
              },
              {
                groupId: "55426032",
                addonId: "41467158",
              },
              {
                groupId: "55426032",
                addonId: "41467160",
              },
              {
                groupId: "55426032",
                addonId: "41467162",
              },
              {
                groupId: "55426032",
                addonId: "41467163",
              },
              {
                groupId: "55426032",
                addonId: "41467165",
              },
              {
                groupId: "55426032",
                addonId: "41467167",
              },
              {
                groupId: "55426032",
                addonId: "41467171",
              },
              {
                groupId: "55426034",
                addonId: "41467176",
              },
              {
                groupId: "55426034",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155537",
                variationId: "57486501",
              },
            ],
            price: 18071,
            addonCombinations: [
              {
                groupId: "55426029",
                addonId: "41467134",
              },
              {
                groupId: "55426029",
                addonId: "41467136",
              },
              {
                groupId: "55426029",
                addonId: "41467138",
              },
              {
                groupId: "55426029",
                addonId: "41467140",
              },
              {
                groupId: "55426029",
                addonId: "41467142",
              },
              {
                groupId: "55426029",
                addonId: "41467143",
              },
              {
                groupId: "55426029",
                addonId: "55402204",
              },
              {
                groupId: "55426029",
                addonId: "54074008",
              },
              {
                groupId: "55426029",
                addonId: "54074009",
              },
              {
                groupId: "55426029",
                addonId: "41467132",
              },
              {
                groupId: "55426031",
                addonId: "41467145",
              },
              {
                groupId: "55426031",
                addonId: "41467147",
              },
              {
                groupId: "55426031",
                addonId: "41467149",
              },
              {
                groupId: "55426031",
                addonId: "41467151",
              },
              {
                groupId: "55426031",
                addonId: "41467152",
              },
              {
                groupId: "55426031",
                addonId: "41467154",
              },
              {
                groupId: "55426031",
                addonId: "41467156",
              },
              {
                groupId: "55426031",
                addonId: "41467158",
              },
              {
                groupId: "55426031",
                addonId: "41467160",
              },
              {
                groupId: "55426031",
                addonId: "41467162",
              },
              {
                groupId: "55426031",
                addonId: "41467163",
              },
              {
                groupId: "55426031",
                addonId: "41467165",
              },
              {
                groupId: "55426031",
                addonId: "41467167",
              },
              {
                groupId: "55426031",
                addonId: "41467171",
              },
              {
                groupId: "55426033",
                addonId: "41467176",
              },
              {
                groupId: "55426033",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426033",
          groupName:
            "Choose From Ice Cream for Coffee Mocha Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426034",
          groupName:
            "Choose From Ice Cream for Coffee Mocha Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426031",
          groupName:
            "Choose From Extra Fillings for Coffee Mocha Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426032",
          groupName:
            "Choose From Extra Fillings for Coffee Mocha Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426029",
          groupName:
            "Choose From Add On for Coffee Mocha Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426030",
          groupName:
            "Choose From Add On for Coffee Mocha Waffle (Regular Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 14571,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "96295418",
      name: "Kitkat Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Melted Belgian White Chocolate And KitKat Bits. For KitKat Lovers!  Energy - 461.72 KCAL",
      imageId: "eozerfua7ygpxho5wkao",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155538",
            name: "Choose from Kitkat Waffle",
            variations: [
              {
                name: "KitKat Waffle (Regular Batter)",
                default: 1,
                id: "57486504",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "KitKat Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486503",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155538",
                variationId: "57486504",
              },
            ],
            price: 16524,
            addonCombinations: [
              {
                groupId: "55426036",
                addonId: "41467132",
              },
              {
                groupId: "55426036",
                addonId: "41467134",
              },
              {
                groupId: "55426036",
                addonId: "41467136",
              },
              {
                groupId: "55426036",
                addonId: "55402204",
              },
              {
                groupId: "55426036",
                addonId: "54074008",
              },
              {
                groupId: "55426036",
                addonId: "41467138",
              },
              {
                groupId: "55426036",
                addonId: "54074009",
              },
              {
                groupId: "55426036",
                addonId: "41467140",
              },
              {
                groupId: "55426036",
                addonId: "41467142",
              },
              {
                groupId: "55426036",
                addonId: "41467143",
              },
              {
                groupId: "55426038",
                addonId: "41467145",
              },
              {
                groupId: "55426038",
                addonId: "41467147",
              },
              {
                groupId: "55426038",
                addonId: "41467149",
              },
              {
                groupId: "55426038",
                addonId: "41467151",
              },
              {
                groupId: "55426038",
                addonId: "41467152",
              },
              {
                groupId: "55426038",
                addonId: "41467154",
              },
              {
                groupId: "55426038",
                addonId: "41467156",
              },
              {
                groupId: "55426038",
                addonId: "41467158",
              },
              {
                groupId: "55426038",
                addonId: "41467160",
              },
              {
                groupId: "55426038",
                addonId: "41467162",
              },
              {
                groupId: "55426038",
                addonId: "41467163",
              },
              {
                groupId: "55426038",
                addonId: "41467165",
              },
              {
                groupId: "55426038",
                addonId: "41467167",
              },
              {
                groupId: "55426038",
                addonId: "41467171",
              },
              {
                groupId: "55426040",
                addonId: "41467176",
              },
              {
                groupId: "55426040",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155538",
                variationId: "57486503",
              },
            ],
            price: 20024,
            addonCombinations: [
              {
                groupId: "55426035",
                addonId: "41467132",
              },
              {
                groupId: "55426035",
                addonId: "41467134",
              },
              {
                groupId: "55426035",
                addonId: "41467136",
              },
              {
                groupId: "55426035",
                addonId: "41467138",
              },
              {
                groupId: "55426035",
                addonId: "41467140",
              },
              {
                groupId: "55426035",
                addonId: "41467142",
              },
              {
                groupId: "55426035",
                addonId: "41467143",
              },
              {
                groupId: "55426035",
                addonId: "55402204",
              },
              {
                groupId: "55426035",
                addonId: "54074008",
              },
              {
                groupId: "55426035",
                addonId: "54074009",
              },
              {
                groupId: "55426037",
                addonId: "41467145",
              },
              {
                groupId: "55426037",
                addonId: "41467147",
              },
              {
                groupId: "55426037",
                addonId: "41467149",
              },
              {
                groupId: "55426037",
                addonId: "41467151",
              },
              {
                groupId: "55426037",
                addonId: "41467152",
              },
              {
                groupId: "55426037",
                addonId: "41467154",
              },
              {
                groupId: "55426037",
                addonId: "41467156",
              },
              {
                groupId: "55426037",
                addonId: "41467158",
              },
              {
                groupId: "55426037",
                addonId: "41467160",
              },
              {
                groupId: "55426037",
                addonId: "41467162",
              },
              {
                groupId: "55426037",
                addonId: "41467163",
              },
              {
                groupId: "55426037",
                addonId: "41467165",
              },
              {
                groupId: "55426037",
                addonId: "41467167",
              },
              {
                groupId: "55426037",
                addonId: "41467171",
              },
              {
                groupId: "55426039",
                addonId: "41467176",
              },
              {
                groupId: "55426039",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426039",
          groupName:
            "Choose From Ice Cream for KitKat Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426040",
          groupName: "Choose From Ice Cream for KitKat Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426037",
          groupName:
            "Choose From Extra Fillings for KitKat Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426038",
          groupName:
            "Choose From Extra Fillings for KitKat Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426035",
          groupName:
            "Choose From Add On for KitKat Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426036",
          groupName: "Choose From Add On for KitKat Waffle (Regular Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 16524,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
    {
      id: "96295419",
      name: "Naked Nutella Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Premium European Chocolate Hazelnut Spread (Add Banana If You Like). A Universal Favourite!  Energy - 457.76 KCAL",
      imageId: "qtirovgc75c7a0dedfrt",
      inStock: 1,
      isVeg: 1,
      price: 18238,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155539",
            name: "Choose from Naked Nutella Waffle",
            variations: [
              {
                name: "Naked Nutella Waffle (Regular Batter)",
                default: 1,
                id: "57486506",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Naked Nutella Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486505",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155539",
                variationId: "57486506",
              },
            ],
            price: 18238,
            addonCombinations: [
              {
                groupId: "55426042",
                addonId: "41467140",
              },
              {
                groupId: "55426042",
                addonId: "41467134",
              },
              {
                groupId: "55426042",
                addonId: "41467136",
              },
              {
                groupId: "55426042",
                addonId: "55402204",
              },
              {
                groupId: "55426042",
                addonId: "54074008",
              },
              {
                groupId: "55426042",
                addonId: "41467138",
              },
              {
                groupId: "55426042",
                addonId: "54074009",
              },
              {
                groupId: "55426042",
                addonId: "41467132",
              },
              {
                groupId: "55426042",
                addonId: "41467143",
              },
              {
                groupId: "55426042",
                addonId: "41467142",
              },
              {
                groupId: "55426044",
                addonId: "41467145",
              },
              {
                groupId: "55426044",
                addonId: "41467147",
              },
              {
                groupId: "55426044",
                addonId: "41467149",
              },
              {
                groupId: "55426044",
                addonId: "41467151",
              },
              {
                groupId: "55426044",
                addonId: "41467152",
              },
              {
                groupId: "55426044",
                addonId: "41467154",
              },
              {
                groupId: "55426044",
                addonId: "41467156",
              },
              {
                groupId: "55426044",
                addonId: "41467158",
              },
              {
                groupId: "55426044",
                addonId: "41467160",
              },
              {
                groupId: "55426044",
                addonId: "41467162",
              },
              {
                groupId: "55426044",
                addonId: "41467163",
              },
              {
                groupId: "55426044",
                addonId: "41467165",
              },
              {
                groupId: "55426044",
                addonId: "41467167",
              },
              {
                groupId: "55426044",
                addonId: "41467171",
              },
              {
                groupId: "55426046",
                addonId: "41467176",
              },
              {
                groupId: "55426046",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155539",
                variationId: "57486505",
              },
            ],
            price: 21738,
            addonCombinations: [
              {
                groupId: "55426041",
                addonId: "41467134",
              },
              {
                groupId: "55426041",
                addonId: "41467136",
              },
              {
                groupId: "55426041",
                addonId: "41467138",
              },
              {
                groupId: "55426041",
                addonId: "41467140",
              },
              {
                groupId: "55426041",
                addonId: "41467142",
              },
              {
                groupId: "55426041",
                addonId: "41467143",
              },
              {
                groupId: "55426041",
                addonId: "55402204",
              },
              {
                groupId: "55426041",
                addonId: "54074008",
              },
              {
                groupId: "55426041",
                addonId: "54074009",
              },
              {
                groupId: "55426041",
                addonId: "41467132",
              },
              {
                groupId: "55426043",
                addonId: "41467145",
              },
              {
                groupId: "55426043",
                addonId: "41467147",
              },
              {
                groupId: "55426043",
                addonId: "41467149",
              },
              {
                groupId: "55426043",
                addonId: "41467151",
              },
              {
                groupId: "55426043",
                addonId: "41467152",
              },
              {
                groupId: "55426043",
                addonId: "41467154",
              },
              {
                groupId: "55426043",
                addonId: "41467156",
              },
              {
                groupId: "55426043",
                addonId: "41467158",
              },
              {
                groupId: "55426043",
                addonId: "41467160",
              },
              {
                groupId: "55426043",
                addonId: "41467162",
              },
              {
                groupId: "55426043",
                addonId: "41467163",
              },
              {
                groupId: "55426043",
                addonId: "41467165",
              },
              {
                groupId: "55426043",
                addonId: "41467167",
              },
              {
                groupId: "55426043",
                addonId: "41467171",
              },
              {
                groupId: "55426045",
                addonId: "41467176",
              },
              {
                groupId: "55426045",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426046",
          groupName:
            "Choose From Ice Cream for Naked Nutella Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426045",
          groupName:
            "Choose From Ice Cream for Naked Nutella Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426044",
          groupName:
            "Choose From Extra Fillings for Naked Nutella Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426043",
          groupName:
            "Choose From Extra Fillings for Naked Nutella Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426042",
          groupName:
            "Choose From Add On for Naked Nutella Waffle (Regular Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426041",
          groupName:
            "Choose From Add On for Naked Nutella Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 18238,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "45 ratings",
          ratingCountV2: "45",
        },
      },
    },
    {
      id: "96295420",
      name: "Honey Butter Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Warm Melted Butter And Golden Honey Drizzle. An American Classic!  Energy - 369.28 KCAL",
      imageId: "fzepkoysubchbzr4gt6f",
      inStock: 1,
      isVeg: 1,
      price: 10762,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155540",
            name: "Choose from Honey Butter Waffle",
            variations: [
              {
                name: "Honey Butter Waffle (Regular Batter)",
                default: 1,
                id: "57486508",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Honey Butter Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486507",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155540",
                variationId: "57486508",
              },
            ],
            price: 10762,
            addonCombinations: [
              {
                groupId: "55426048",
                addonId: "41467132",
              },
              {
                groupId: "55426048",
                addonId: "41467134",
              },
              {
                groupId: "55426048",
                addonId: "41467136",
              },
              {
                groupId: "55426048",
                addonId: "55402204",
              },
              {
                groupId: "55426048",
                addonId: "54074008",
              },
              {
                groupId: "55426048",
                addonId: "41467138",
              },
              {
                groupId: "55426048",
                addonId: "54074009",
              },
              {
                groupId: "55426048",
                addonId: "41467140",
              },
              {
                groupId: "55426048",
                addonId: "41467142",
              },
              {
                groupId: "55426048",
                addonId: "41467143",
              },
              {
                groupId: "55426050",
                addonId: "41467145",
              },
              {
                groupId: "55426050",
                addonId: "41467147",
              },
              {
                groupId: "55426050",
                addonId: "41467149",
              },
              {
                groupId: "55426050",
                addonId: "41467151",
              },
              {
                groupId: "55426050",
                addonId: "41467152",
              },
              {
                groupId: "55426050",
                addonId: "41467154",
              },
              {
                groupId: "55426050",
                addonId: "41467156",
              },
              {
                groupId: "55426050",
                addonId: "41467158",
              },
              {
                groupId: "55426050",
                addonId: "41467160",
              },
              {
                groupId: "55426050",
                addonId: "41467162",
              },
              {
                groupId: "55426050",
                addonId: "41467163",
              },
              {
                groupId: "55426050",
                addonId: "41467165",
              },
              {
                groupId: "55426050",
                addonId: "41467167",
              },
              {
                groupId: "55426050",
                addonId: "41467171",
              },
              {
                groupId: "55426053",
                addonId: "41467176",
              },
              {
                groupId: "55426053",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155540",
                variationId: "57486507",
              },
            ],
            price: 14262,
            addonCombinations: [
              {
                groupId: "55426047",
                addonId: "41467134",
              },
              {
                groupId: "55426047",
                addonId: "41467136",
              },
              {
                groupId: "55426047",
                addonId: "41467138",
              },
              {
                groupId: "55426047",
                addonId: "41467140",
              },
              {
                groupId: "55426047",
                addonId: "41467142",
              },
              {
                groupId: "55426047",
                addonId: "41467143",
              },
              {
                groupId: "55426047",
                addonId: "55402204",
              },
              {
                groupId: "55426047",
                addonId: "54074008",
              },
              {
                groupId: "55426047",
                addonId: "54074009",
              },
              {
                groupId: "55426047",
                addonId: "41467132",
              },
              {
                groupId: "55426049",
                addonId: "41467145",
              },
              {
                groupId: "55426049",
                addonId: "41467147",
              },
              {
                groupId: "55426049",
                addonId: "41467149",
              },
              {
                groupId: "55426049",
                addonId: "41467151",
              },
              {
                groupId: "55426049",
                addonId: "41467152",
              },
              {
                groupId: "55426049",
                addonId: "41467154",
              },
              {
                groupId: "55426049",
                addonId: "41467156",
              },
              {
                groupId: "55426049",
                addonId: "41467158",
              },
              {
                groupId: "55426049",
                addonId: "41467160",
              },
              {
                groupId: "55426049",
                addonId: "41467162",
              },
              {
                groupId: "55426049",
                addonId: "41467163",
              },
              {
                groupId: "55426049",
                addonId: "41467165",
              },
              {
                groupId: "55426049",
                addonId: "41467167",
              },
              {
                groupId: "55426049",
                addonId: "41467171",
              },
              {
                groupId: "55426051",
                addonId: "41467176",
              },
              {
                groupId: "55426051",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426053",
          groupName:
            "Choose From Ice Cream for Honey Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426051",
          groupName:
            "Choose From Ice Cream for Honey Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426049",
          groupName:
            "Choose From Extra Fillings for Honey Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426050",
          groupName:
            "Choose From Extra Fillings for Honey Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426048",
          groupName:
            "Choose From Add On for Honey Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426047",
          groupName:
            "Choose From Add On for Honey Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 10762,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "96295422",
      name: "Maple Butter Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Warm Melted Butter And Maple Syrup Drizzle. An American Classic!  Energy - 366.73 KCAL",
      imageId: "cme1izhghagg1vkvvpgu",
      inStock: 1,
      isVeg: 1,
      price: 10762,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155542",
            name: "Choose from Maple Butter Waffle",
            variations: [
              {
                name: "Maple Butter Waffle (Regular Batter)",
                default: 1,
                id: "57486512",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Maple Butter Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486511",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155542",
                variationId: "57486512",
              },
            ],
            price: 10762,
            addonCombinations: [
              {
                groupId: "55426059",
                addonId: "41467132",
              },
              {
                groupId: "55426059",
                addonId: "41467134",
              },
              {
                groupId: "55426059",
                addonId: "41467136",
              },
              {
                groupId: "55426059",
                addonId: "55402204",
              },
              {
                groupId: "55426059",
                addonId: "54074008",
              },
              {
                groupId: "55426059",
                addonId: "41467138",
              },
              {
                groupId: "55426059",
                addonId: "54074009",
              },
              {
                groupId: "55426059",
                addonId: "41467140",
              },
              {
                groupId: "55426059",
                addonId: "41467142",
              },
              {
                groupId: "55426059",
                addonId: "41467143",
              },
              {
                groupId: "55426062",
                addonId: "41467145",
              },
              {
                groupId: "55426062",
                addonId: "41467147",
              },
              {
                groupId: "55426062",
                addonId: "41467149",
              },
              {
                groupId: "55426062",
                addonId: "41467151",
              },
              {
                groupId: "55426062",
                addonId: "41467152",
              },
              {
                groupId: "55426062",
                addonId: "41467154",
              },
              {
                groupId: "55426062",
                addonId: "41467156",
              },
              {
                groupId: "55426062",
                addonId: "41467158",
              },
              {
                groupId: "55426062",
                addonId: "41467160",
              },
              {
                groupId: "55426062",
                addonId: "41467162",
              },
              {
                groupId: "55426062",
                addonId: "41467163",
              },
              {
                groupId: "55426062",
                addonId: "41467165",
              },
              {
                groupId: "55426062",
                addonId: "41467167",
              },
              {
                groupId: "55426062",
                addonId: "41467171",
              },
              {
                groupId: "55426064",
                addonId: "41467176",
              },
              {
                groupId: "55426064",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155542",
                variationId: "57486511",
              },
            ],
            price: 14262,
            addonCombinations: [
              {
                groupId: "55426057",
                addonId: "41467132",
              },
              {
                groupId: "55426057",
                addonId: "41467136",
              },
              {
                groupId: "55426057",
                addonId: "41467138",
              },
              {
                groupId: "55426057",
                addonId: "41467140",
              },
              {
                groupId: "55426057",
                addonId: "41467142",
              },
              {
                groupId: "55426057",
                addonId: "41467143",
              },
              {
                groupId: "55426057",
                addonId: "55402204",
              },
              {
                groupId: "55426057",
                addonId: "54074008",
              },
              {
                groupId: "55426057",
                addonId: "54074009",
              },
              {
                groupId: "55426057",
                addonId: "41467134",
              },
              {
                groupId: "55426061",
                addonId: "41467145",
              },
              {
                groupId: "55426061",
                addonId: "41467147",
              },
              {
                groupId: "55426061",
                addonId: "41467149",
              },
              {
                groupId: "55426061",
                addonId: "41467151",
              },
              {
                groupId: "55426061",
                addonId: "41467152",
              },
              {
                groupId: "55426061",
                addonId: "41467154",
              },
              {
                groupId: "55426061",
                addonId: "41467156",
              },
              {
                groupId: "55426061",
                addonId: "41467158",
              },
              {
                groupId: "55426061",
                addonId: "41467160",
              },
              {
                groupId: "55426061",
                addonId: "41467162",
              },
              {
                groupId: "55426061",
                addonId: "41467163",
              },
              {
                groupId: "55426061",
                addonId: "41467165",
              },
              {
                groupId: "55426061",
                addonId: "41467167",
              },
              {
                groupId: "55426061",
                addonId: "41467171",
              },
              {
                groupId: "55426063",
                addonId: "41467176",
              },
              {
                groupId: "55426063",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426064",
          groupName:
            "Choose From Ice Cream for Maple Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426063",
          groupName:
            "Choose From Ice Cream for Maple Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426062",
          groupName:
            "Choose From Extra Fillings for Maple Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426061",
          groupName:
            "Choose From Extra Fillings for Maple Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426059",
          groupName:
            "Choose From Add On for Maple Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426057",
          groupName:
            "Choose From Add On for Maple Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 10762,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295436",
      name: "Strawberry Creamcheese Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Strawberry Compote Layered With Philadelphia Style Cream Cheese. Deliciously Tart!  Energy - 306.58 KCAL",
      imageId: "zghn5yybkm1pnuqe6dh2",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155556",
            name: "Choose from Strawberry Creamcheese Waffle",
            variations: [
              {
                name: "Strawberry Cream Cheese Waffle (Regular Batter)",
                default: 1,
                id: "57486539",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Strawberry Cream Cheese Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486538",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155556",
                variationId: "57486539",
              },
            ],
            price: 16524,
            addonCombinations: [
              {
                groupId: "55426137",
                addonId: "41467140",
              },
              {
                groupId: "55426137",
                addonId: "41467134",
              },
              {
                groupId: "55426137",
                addonId: "41467136",
              },
              {
                groupId: "55426137",
                addonId: "55402204",
              },
              {
                groupId: "55426137",
                addonId: "54074008",
              },
              {
                groupId: "55426137",
                addonId: "41467138",
              },
              {
                groupId: "55426137",
                addonId: "54074009",
              },
              {
                groupId: "55426137",
                addonId: "41467132",
              },
              {
                groupId: "55426137",
                addonId: "41467142",
              },
              {
                groupId: "55426137",
                addonId: "41467143",
              },
              {
                groupId: "55426139",
                addonId: "41467145",
              },
              {
                groupId: "55426139",
                addonId: "41467147",
              },
              {
                groupId: "55426139",
                addonId: "41467149",
              },
              {
                groupId: "55426139",
                addonId: "41467151",
              },
              {
                groupId: "55426139",
                addonId: "41467152",
              },
              {
                groupId: "55426139",
                addonId: "41467154",
              },
              {
                groupId: "55426139",
                addonId: "41467156",
              },
              {
                groupId: "55426139",
                addonId: "41467158",
              },
              {
                groupId: "55426139",
                addonId: "41467160",
              },
              {
                groupId: "55426139",
                addonId: "41467162",
              },
              {
                groupId: "55426139",
                addonId: "41467163",
              },
              {
                groupId: "55426139",
                addonId: "41467165",
              },
              {
                groupId: "55426139",
                addonId: "41467167",
              },
              {
                groupId: "55426139",
                addonId: "41467171",
              },
              {
                groupId: "55426141",
                addonId: "41467176",
              },
              {
                groupId: "55426141",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155556",
                variationId: "57486538",
              },
            ],
            price: 20024,
            addonCombinations: [
              {
                groupId: "55426136",
                addonId: "41467132",
              },
              {
                groupId: "55426136",
                addonId: "41467136",
              },
              {
                groupId: "55426136",
                addonId: "41467138",
              },
              {
                groupId: "55426136",
                addonId: "41467140",
              },
              {
                groupId: "55426136",
                addonId: "41467142",
              },
              {
                groupId: "55426136",
                addonId: "41467143",
              },
              {
                groupId: "55426136",
                addonId: "55402204",
              },
              {
                groupId: "55426136",
                addonId: "54074008",
              },
              {
                groupId: "55426136",
                addonId: "54074009",
              },
              {
                groupId: "55426136",
                addonId: "41467134",
              },
              {
                groupId: "55426138",
                addonId: "41467145",
              },
              {
                groupId: "55426138",
                addonId: "41467147",
              },
              {
                groupId: "55426138",
                addonId: "41467149",
              },
              {
                groupId: "55426138",
                addonId: "41467151",
              },
              {
                groupId: "55426138",
                addonId: "41467152",
              },
              {
                groupId: "55426138",
                addonId: "41467154",
              },
              {
                groupId: "55426138",
                addonId: "41467156",
              },
              {
                groupId: "55426138",
                addonId: "41467158",
              },
              {
                groupId: "55426138",
                addonId: "41467160",
              },
              {
                groupId: "55426138",
                addonId: "41467162",
              },
              {
                groupId: "55426138",
                addonId: "41467163",
              },
              {
                groupId: "55426138",
                addonId: "41467165",
              },
              {
                groupId: "55426138",
                addonId: "41467167",
              },
              {
                groupId: "55426138",
                addonId: "41467171",
              },
              {
                groupId: "55426140",
                addonId: "41467176",
              },
              {
                groupId: "55426140",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426141",
          groupName:
            "Choose From Ice Cream for Strawberry Cream Cheese Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426140",
          groupName:
            "Choose From Ice Cream for Strawberry Cream Cheese Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426138",
          groupName:
            "Choose From Extra Fillings for Strawberry Cream Cheese Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426139",
          groupName:
            "Choose From Extra Fillings for Strawberry Cream Cheese Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426136",
          groupName:
            "Choose From Add On for Strawberry Cream Cheese Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426137",
          groupName:
            "Choose From Add On for Strawberry Cream Cheese Waffle (Regular Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 16524,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "96295437",
      name: "Blueberry Creamcheese Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Blueberry Compote Layered With Philadelphia Style Cream Cheese. Deliciously Tart! Energy - 305.2 KCAL",
      imageId: "wgs9wxjl1teyimfjfl5d",
      inStock: 1,
      isVeg: 1,
      price: 17476,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155557",
            name: "Choose from Blueberry Creamcheese Waffle",
            variations: [
              {
                name: "Blueberry Cream Cheese Waffle (Regular Batter)",
                default: 1,
                id: "57486541",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Blueberry Cream Cheese Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486540",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155557",
                variationId: "57486541",
              },
            ],
            price: 17476,
            addonCombinations: [
              {
                groupId: "55426143",
                addonId: "41467140",
              },
              {
                groupId: "55426143",
                addonId: "41467134",
              },
              {
                groupId: "55426143",
                addonId: "41467136",
              },
              {
                groupId: "55426143",
                addonId: "55402204",
              },
              {
                groupId: "55426143",
                addonId: "54074008",
              },
              {
                groupId: "55426143",
                addonId: "41467138",
              },
              {
                groupId: "55426143",
                addonId: "54074009",
              },
              {
                groupId: "55426143",
                addonId: "41467132",
              },
              {
                groupId: "55426143",
                addonId: "41467142",
              },
              {
                groupId: "55426143",
                addonId: "41467143",
              },
              {
                groupId: "55426145",
                addonId: "41467145",
              },
              {
                groupId: "55426145",
                addonId: "41467147",
              },
              {
                groupId: "55426145",
                addonId: "41467149",
              },
              {
                groupId: "55426145",
                addonId: "41467151",
              },
              {
                groupId: "55426145",
                addonId: "41467152",
              },
              {
                groupId: "55426145",
                addonId: "41467154",
              },
              {
                groupId: "55426145",
                addonId: "41467156",
              },
              {
                groupId: "55426145",
                addonId: "41467158",
              },
              {
                groupId: "55426145",
                addonId: "41467160",
              },
              {
                groupId: "55426145",
                addonId: "41467162",
              },
              {
                groupId: "55426145",
                addonId: "41467163",
              },
              {
                groupId: "55426145",
                addonId: "41467165",
              },
              {
                groupId: "55426145",
                addonId: "41467167",
              },
              {
                groupId: "55426145",
                addonId: "41467171",
              },
              {
                groupId: "55426147",
                addonId: "41467176",
              },
              {
                groupId: "55426147",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155557",
                variationId: "57486540",
              },
            ],
            price: 20976,
            addonCombinations: [
              {
                groupId: "55426142",
                addonId: "41467132",
              },
              {
                groupId: "55426142",
                addonId: "41467136",
              },
              {
                groupId: "55426142",
                addonId: "41467138",
              },
              {
                groupId: "55426142",
                addonId: "41467140",
              },
              {
                groupId: "55426142",
                addonId: "41467142",
              },
              {
                groupId: "55426142",
                addonId: "41467143",
              },
              {
                groupId: "55426142",
                addonId: "55402204",
              },
              {
                groupId: "55426142",
                addonId: "54074008",
              },
              {
                groupId: "55426142",
                addonId: "54074009",
              },
              {
                groupId: "55426142",
                addonId: "41467134",
              },
              {
                groupId: "55426144",
                addonId: "41467145",
              },
              {
                groupId: "55426144",
                addonId: "41467147",
              },
              {
                groupId: "55426144",
                addonId: "41467149",
              },
              {
                groupId: "55426144",
                addonId: "41467151",
              },
              {
                groupId: "55426144",
                addonId: "41467152",
              },
              {
                groupId: "55426144",
                addonId: "41467154",
              },
              {
                groupId: "55426144",
                addonId: "41467156",
              },
              {
                groupId: "55426144",
                addonId: "41467158",
              },
              {
                groupId: "55426144",
                addonId: "41467160",
              },
              {
                groupId: "55426144",
                addonId: "41467162",
              },
              {
                groupId: "55426144",
                addonId: "41467163",
              },
              {
                groupId: "55426144",
                addonId: "41467165",
              },
              {
                groupId: "55426144",
                addonId: "41467167",
              },
              {
                groupId: "55426144",
                addonId: "41467171",
              },
              {
                groupId: "55426146",
                addonId: "41467176",
              },
              {
                groupId: "55426146",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426147",
          groupName:
            "Choose From Ice Cream for Blueberry Cream Cheese Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426146",
          groupName:
            "Choose From Ice Cream for Blueberry Cream Cheese Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426145",
          groupName:
            "Choose From Extra Fillings for Blueberry Cream Cheese Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426144",
          groupName:
            "Choose From Extra Fillings for Blueberry Cream Cheese Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426143",
          groupName:
            "Choose From Add On for Blueberry Cream Cheese Waffle (Regular Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426142",
          groupName:
            "Choose From Add On for Blueberry Cream Cheese Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 17476,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "96295438",
      name: "Almond Cocoa Butter Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Waffle + Cocoa Butter Topped With Roasted Almonds. Nutty & Delicious!  Energy - 467.19 KCAL",
      imageId: "sltrdervslg41lifbjhh",
      inStock: 1,
      isVeg: 1,
      price: 17571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155558",
            name: "Choose from Almond Cocoa Butter Waffle",
            variations: [
              {
                name: "Almond Cocoa Butter Waffle (Regular Batter)",
                default: 1,
                id: "57486543",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Almond Cocoa Butter Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486542",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155558",
                variationId: "57486543",
              },
            ],
            price: 17571,
            addonCombinations: [
              {
                groupId: "55426149",
                addonId: "41467132",
              },
              {
                groupId: "55426149",
                addonId: "41467134",
              },
              {
                groupId: "55426149",
                addonId: "41467136",
              },
              {
                groupId: "55426149",
                addonId: "55402204",
              },
              {
                groupId: "55426149",
                addonId: "54074008",
              },
              {
                groupId: "55426149",
                addonId: "41467138",
              },
              {
                groupId: "55426149",
                addonId: "54074009",
              },
              {
                groupId: "55426149",
                addonId: "41467140",
              },
              {
                groupId: "55426149",
                addonId: "41467142",
              },
              {
                groupId: "55426151",
                addonId: "41467145",
              },
              {
                groupId: "55426151",
                addonId: "41467147",
              },
              {
                groupId: "55426151",
                addonId: "41467149",
              },
              {
                groupId: "55426151",
                addonId: "41467151",
              },
              {
                groupId: "55426151",
                addonId: "41467152",
              },
              {
                groupId: "55426151",
                addonId: "41467154",
              },
              {
                groupId: "55426151",
                addonId: "41467156",
              },
              {
                groupId: "55426151",
                addonId: "41467158",
              },
              {
                groupId: "55426151",
                addonId: "41467160",
              },
              {
                groupId: "55426151",
                addonId: "41467162",
              },
              {
                groupId: "55426151",
                addonId: "41467163",
              },
              {
                groupId: "55426151",
                addonId: "41467165",
              },
              {
                groupId: "55426151",
                addonId: "41467167",
              },
              {
                groupId: "55426151",
                addonId: "41467171",
              },
              {
                groupId: "55426153",
                addonId: "41467176",
              },
              {
                groupId: "55426153",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155558",
                variationId: "57486542",
              },
            ],
            price: 21071,
            addonCombinations: [
              {
                groupId: "55426148",
                addonId: "41467134",
              },
              {
                groupId: "55426148",
                addonId: "41467136",
              },
              {
                groupId: "55426148",
                addonId: "41467138",
              },
              {
                groupId: "55426148",
                addonId: "41467140",
              },
              {
                groupId: "55426148",
                addonId: "41467142",
              },
              {
                groupId: "55426148",
                addonId: "41467143",
              },
              {
                groupId: "55426148",
                addonId: "55402204",
              },
              {
                groupId: "55426148",
                addonId: "54074008",
              },
              {
                groupId: "55426148",
                addonId: "54074009",
              },
              {
                groupId: "55426148",
                addonId: "41467132",
              },
              {
                groupId: "55426150",
                addonId: "41467145",
              },
              {
                groupId: "55426150",
                addonId: "41467147",
              },
              {
                groupId: "55426150",
                addonId: "41467149",
              },
              {
                groupId: "55426150",
                addonId: "41467151",
              },
              {
                groupId: "55426150",
                addonId: "41467152",
              },
              {
                groupId: "55426150",
                addonId: "41467154",
              },
              {
                groupId: "55426150",
                addonId: "41467156",
              },
              {
                groupId: "55426150",
                addonId: "41467158",
              },
              {
                groupId: "55426150",
                addonId: "41467160",
              },
              {
                groupId: "55426150",
                addonId: "41467162",
              },
              {
                groupId: "55426150",
                addonId: "41467163",
              },
              {
                groupId: "55426150",
                addonId: "41467165",
              },
              {
                groupId: "55426150",
                addonId: "41467167",
              },
              {
                groupId: "55426150",
                addonId: "41467171",
              },
              {
                groupId: "55426152",
                addonId: "41467176",
              },
              {
                groupId: "55426152",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426152",
          groupName:
            "Choose From Ice Cream for Almond Cocoa Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426153",
          groupName:
            "Choose From Ice Cream for Almond Cocoa Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426150",
          groupName:
            "Choose From Extra Fillings for Almond Cocoa Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426151",
          groupName:
            "Choose From Extra Fillings for Almond Cocoa Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426149",
          groupName:
            "Choose From Add On for Almond Cocoa Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426148",
          groupName:
            "Choose From Add On for Almond Cocoa Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 17571,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295439",
      name: "Peanut Butter Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Waffle + Crunchy Roasted Peanut Butter With Melted Milk Chocolate Swirl (add Banana if you like)  Energy - 486.12 KCAL",
      imageId: "svqjru22fjmdgj3ahf58",
      inStock: 1,
      isVeg: 1,
      price: 15571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "17155559",
            name: "Choose from Peanut Butter Waffle",
            variations: [
              {
                name: "Peanut Butter Waffle (Regular Batter)",
                default: 1,
                id: "57486545",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Peanut Butter Waffle (Almond Flour Batter)",
                price: 35,
                id: "57486544",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "17155559",
                variationId: "57486545",
              },
            ],
            price: 15571,
            addonCombinations: [
              {
                groupId: "55426155",
                addonId: "41467134",
              },
              {
                groupId: "55426155",
                addonId: "41467136",
              },
              {
                groupId: "55426155",
                addonId: "41467138",
              },
              {
                groupId: "55426155",
                addonId: "41467140",
              },
              {
                groupId: "55426155",
                addonId: "41467142",
              },
              {
                groupId: "55426155",
                addonId: "41467143",
              },
              {
                groupId: "55426155",
                addonId: "55402204",
              },
              {
                groupId: "55426155",
                addonId: "54074008",
              },
              {
                groupId: "55426155",
                addonId: "54074009",
              },
              {
                groupId: "55426155",
                addonId: "41467132",
              },
              {
                groupId: "62699188",
                addonId: "41467145",
              },
              {
                groupId: "62699188",
                addonId: "41467147",
              },
              {
                groupId: "62699188",
                addonId: "41467149",
              },
              {
                groupId: "62699188",
                addonId: "41467152",
              },
              {
                groupId: "62699188",
                addonId: "41467154",
              },
              {
                groupId: "62699188",
                addonId: "41467156",
              },
              {
                groupId: "62699188",
                addonId: "41467158",
              },
              {
                groupId: "62699188",
                addonId: "41467160",
              },
              {
                groupId: "62699188",
                addonId: "41467162",
              },
              {
                groupId: "62699188",
                addonId: "41467163",
              },
              {
                groupId: "62699188",
                addonId: "41467165",
              },
              {
                groupId: "62699188",
                addonId: "41467167",
              },
              {
                groupId: "62699188",
                addonId: "41467171",
              },
              {
                groupId: "62699187",
                addonId: "41467176",
              },
              {
                groupId: "62699187",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "17155559",
                variationId: "57486544",
              },
            ],
            price: 19071,
            addonCombinations: [
              {
                groupId: "55426154",
                addonId: "41467134",
              },
              {
                groupId: "55426154",
                addonId: "41467136",
              },
              {
                groupId: "55426154",
                addonId: "41467138",
              },
              {
                groupId: "55426154",
                addonId: "41467140",
              },
              {
                groupId: "55426154",
                addonId: "41467142",
              },
              {
                groupId: "55426154",
                addonId: "41467143",
              },
              {
                groupId: "55426154",
                addonId: "55402204",
              },
              {
                groupId: "55426154",
                addonId: "54074008",
              },
              {
                groupId: "55426154",
                addonId: "54074009",
              },
              {
                groupId: "55426154",
                addonId: "41467132",
              },
              {
                groupId: "55426156",
                addonId: "41467145",
              },
              {
                groupId: "55426156",
                addonId: "41467147",
              },
              {
                groupId: "55426156",
                addonId: "41467149",
              },
              {
                groupId: "55426156",
                addonId: "41467151",
              },
              {
                groupId: "55426156",
                addonId: "41467152",
              },
              {
                groupId: "55426156",
                addonId: "41467154",
              },
              {
                groupId: "55426156",
                addonId: "41467156",
              },
              {
                groupId: "55426156",
                addonId: "41467158",
              },
              {
                groupId: "55426156",
                addonId: "41467160",
              },
              {
                groupId: "55426156",
                addonId: "41467162",
              },
              {
                groupId: "55426156",
                addonId: "41467163",
              },
              {
                groupId: "55426156",
                addonId: "41467165",
              },
              {
                groupId: "55426156",
                addonId: "41467167",
              },
              {
                groupId: "55426156",
                addonId: "41467171",
              },
              {
                groupId: "55426157",
                addonId: "41467176",
              },
              {
                groupId: "55426157",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "55426157",
          groupName:
            "Choose From Ice Cream for Peanut Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "62699187",
          groupName:
            "Choose From Ice Cream for Peanut Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426156",
          groupName:
            "Choose From Extra Fillings for Peanut Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "62699188",
          groupName:
            "Choose From Extra Fillings for Peanut Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 12,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426154",
          groupName:
            "Choose From Add On for Peanut Butter Waffle (Almond Flour Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426155",
          groupName:
            "Choose From Add On for Peanut Butter Waffle (Regular Batter)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 15571,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295445",
      name: "Berry Velvet Waffle",
      category: "Waffles",
      description:
        "Serves 1 | Serves 1 | Original Red Velvet Waffle +Strawberry Compote + Philadelphia Style Cream Cheese And Melted White Chocolate. A True Original - Enhanced!  Energy - 317.19 KCAL",
      imageId: "ax9pjars4v2qj7jthb3m",
      inStock: 1,
      isVeg: 1,
      price: 16524,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "62699209",
          groupName: "Choose From Ice Cream for Berry Velvet Waffle",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "62699210",
          groupName: "Choose From Extra Fillings for Berry Velvet Waffle",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 11,
          maxFreeAddons: -1,
        },
        {
          groupId: "55426183",
          groupName: "Choose From Add On for Berry Velvet Waffle",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
  ],
  Beverages: [
    {
      id: "25694401",
      name: "Belgian Chocolate Shake",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | One Of Our Darker Chocolate Shakes Made With Belgian Chocolate. (Images are for representation purpose only)  Energy - 193.81 KCAL",
      imageId: "c5spw0kigqbyh5uq1zl9",
      inStock: 1,
      isVeg: 1,
      price: 17095,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "25694402",
      name: "Oreo Shake",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | Thick shake blended with tons of chocloate Oreos! (Images are for representation purpose only)  Energy - 171.35 KCAL",
      imageId: "lzuyxde65ewytxvjowlv",
      inStock: 1,
      isVeg: 1,
      price: 17095,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "25694404",
      name: "Nutella Shake",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | Our Signature Shake made with real Nutella! (Images are for representation purpose only)  Energy - 176.19 KCAL",
      imageId: "sa9yug2ugbobdohnzhjs",
      inStock: 1,
      isVeg: 1,
      price: 17905,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "25694406",
      name: "Signature Cold Coffee",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | Our Perfectly Balanced Cold Coffee (Images are for representation purpose only)  Energy - 105.41 KCAL",
      imageId: "dukeorbtr1re1c8taqne",
      inStock: 1,
      isVeg: 1,
      price: 14048,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662408",
      name: "Lemon - Iced Tea",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | Refreshing Lemon Iced Tea (Images are for representation purpose only) Energy - 34.32 KCAL",
      imageId: "queec3nz3q5cxl69iw9w",
      inStock: 1,
      isVeg: 1,
      price: 11381,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662410",
      name: "Peach - Iced Tea",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | Refreshing peach Iced tea (Images are for representation purpose only Energy - 32.8 KCAL",
      imageId: "fa9byrd8uoyrjjzg4mch",
      inStock: 1,
      isVeg: 1,
      price: 11381,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662411",
      name: "KitKat Shake",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | A Chocolatey Shake topped with Kit Kat bits! (Images are for representation purpose only)  Energy - 163.67 KCAL",
      imageId: "sqianae2afslhoyodfrq",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92662413",
      name: "Blueberry White Chocolate Shake",
      category: "Beverages",
      description:
        "Serves 1 | Serves 1 | A smoothie blended with bluberries and white chocolate (Images are for representation purpose only)  Energy - 138.13 KCAL",
      imageId: "ras4pxevvedpkuq0ync7",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  "Mini Waffle Combos": [
    {
      id: "70435552",
      name: "Mini Waffle Box of 6 - Chocolate",
      category: "Mini Waffle Combos",
      description:
        "Serves 1 | Serves 2-3 | Can't Pick One? Try A Carefully Curated Assortment of our Bestselling Chocolate Favourites. Includes Naked Nutella, Chocolate Overload (Milk), Dark & White Fantasy, Belgian Chocolate (Milk), Belgian Chocolate (Dark) And KitKat Mini Waffles In A All-In-One Combo Pack.  Energy - 451.54 KCAL",
      imageId: "d7kc3dqkztnvfmbq5tjc",
      inStock: 1,
      isVeg: 1,
      price: 51119,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784176",
          groupName: "Mini Waffle 1",
          choices: [
            {
              id: "41467464",
              name: "Naked Nutella Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784177",
          groupName: "Mini Waffle 2",
          choices: [
            {
              id: "41467466",
              name: "Belgian Chocolate Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "52949969",
          groupName: "Mini Waffle 3",
          choices: [
            {
              id: "41711818",
              name: "Belgian Chocolate Dark Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784180",
          groupName: "Mini Waffle 4",
          choices: [
            {
              id: "41467465",
              name: "Chocolate Overload Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784181",
          groupName: "Mini Waffle 5",
          choices: [
            {
              id: "41467467",
              name: "Dark & White Fantasy Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784182",
          groupName: "Mini Waffle 6",
          choices: [
            {
              id: "44191149",
              name: "KitKat Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784183",
          groupName: "Box",
          choices: [
            {
              id: "41467470",
              name: "Mini Waffle Box (6 Mini Waffle)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "70435666",
      name: "Mini Waffle Box of 6 - Assorted",
      category: "Mini Waffle Combos",
      description:
        "Serves 1 | Serves 2-3 |  In The Mood For Even More Variety? Try A Carefully Curated Assortment of Some of our Fan Favorites. Includes Naked Nutella, Belgian Chocolate (Milk), Chocolate Overload (Dark), Dark & White Fantasy, Red Velvet And Berry Velvet Mini Waffles In An All-In-One Combo Pack. Energy - 426.64 KCAL",
      imageId: "nqtcnakfpwk4dhaum1uq",
      inStock: 1,
      isVeg: 1,
      price: 49005,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784201",
          groupName: "Mini Waffle 1",
          choices: [
            {
              id: "41467464",
              name: "Naked Nutella Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784202",
          groupName: "Mini Waffle 2",
          choices: [
            {
              id: "41467465",
              name: "Chocolate Overload Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784203",
          groupName: "Mini Waffle 3",
          choices: [
            {
              id: "41467466",
              name: "Belgian Chocolate Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784204",
          groupName: "Mini Waffle 4",
          choices: [
            {
              id: "41467467",
              name: "Dark & White Fantasy Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784205",
          groupName: "Mini Waffle 5",
          choices: [
            {
              id: "41467469",
              name: "Red Velvet Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784206",
          groupName: "Mini Waffle 6",
          choices: [
            {
              id: "45264736",
              name: "Berry Velvet Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784207",
          groupName: "Box",
          choices: [
            {
              id: "41467470",
              name: "Mini Waffle Box (6 Mini Waffle)",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "92662548",
      name: "Mini Waffle Box of 4 - Chocolate",
      category: "Mini Waffle Combos",
      description:
        "Serves 1 | Serves 1 |  Can’t Pick One? Try A Carefully Curated Assortment of our Bestselling Chocolate Favorites. Includes Naked Nutella, Belgian Chocolate (Milk), Chocolate Overload (Dark) And Dark & White Fantasy Mini Waffles In An All-In-One Combo Pack. Energy - 455.34 KCAL",
      imageId: "hs4fcgudajhidwcn3xpy",
      inStock: 1,
      isVeg: 1,
      price: 33452,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784169",
          groupName: "Mini Waffle 1",
          choices: [
            {
              id: "41467464",
              name: "Naked Nutella Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784170",
          groupName: "Mini Waffle 2",
          choices: [
            {
              id: "41467466",
              name: "Belgian Chocolate Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784172",
          groupName: "Mini Waffle 3",
          choices: [
            {
              id: "41467467",
              name: "Dark & White Fantasy Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "52949968",
          groupName: "Mini Waffle 4",
          choices: [
            {
              id: "41712399",
              name: "Chocolate Overload Dark Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784174",
          groupName: "Box",
          choices: [
            {
              id: "41467522",
              name: "Mini Waffle Box",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "92662557",
      name: "Mini Waffle Box of 4 - Assorted",
      category: "Mini Waffle Combos",
      description:
        "Serves 1 | Serves 1 | In The Mood For Variety? Try A Carefully Curated Assortment Of Some Of Our Fan Favorites. Includes Belgian Chocolate (Milk), Almond Cocoa Butter, Red Velvet And Berry Velvet Mini Waffles In An All-In-One Combo Pack.  Energy - 419.55 KCAL",
      imageId: "hiqwcprb2zpypkhgxoce",
      inStock: 1,
      isVeg: 1,
      price: 33190,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784193",
          groupName: "Mini Waffle 1",
          choices: [
            {
              id: "41467466",
              name: "Belgian Chocolate Milk Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784195",
          groupName: "Mini Waffle 2",
          choices: [
            {
              id: "41467519",
              name: "Almond Cocoa Butter Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784197",
          groupName: "Mini Waffle 3",
          choices: [
            {
              id: "41467469",
              name: "Red Velvet Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784198",
          groupName: "Mini Waffle 4",
          choices: [
            {
              id: "45264736",
              name: "Berry Velvet Mini Waffle",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "51784200",
          groupName: "Box",
          choices: [
            {
              id: "41467522",
              name: "Mini Waffle Box",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
  ],
  "Waffle Cake": [
    {
      id: "66749959",
      name: "Kiki and Oreo Waffle Cake (Double Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 2-3  | Signature black velvet double layer waffle cake layered thick inside and out with Kiki spread and topped with Crushed Oreos. A universal favorite! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 474.98",
      imageId: "fxatt8nrpmsquqshuk7e",
      inStock: 1,
      isVeg: 1,
      price: 58052,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784167",
          groupName:
            "Choose From Add On for Kiki and Oreo Waffle Cake (Double Layer)",
          choices: [
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "66750066",
      name: "Kiki and Oreo Waffle Cake (Single Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 1-2| Signature black velvet single layer waffle cake layered thick with Kiki spread and topped with Crushed Oreos. A universal favorite! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 474.42 KCAL",
      imageId: "bk95q53yhvqiqob2b4o9",
      inStock: 1,
      isVeg: 1,
      price: 38048,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784147",
          groupName:
            "Choose From Add On for Kiki and Oreo Waffle Cake (Single Layer)",
          choices: [
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "87642853",
      name: "Walnut Brownie Waffle Cake (Single Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 1-2 | The Best Of Two Worlds In A Single Layer Cake - A Waffle And A Brownie. With Deliciously Rich Melted Chocolate and Walnuts. Your Doorway To Heaven! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 500.41",
      imageId: "qnmp30rveqdlb4zdudgj",
      inStock: 1,
      isVeg: 1,
      price: 38050,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "87642854",
      name: "Walnut Brownie Waffle Cake (Double Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 2-3  | The Best Of Two Worlds In A Double Layer Cake - A Waffle And A Brownie. With Deliciously Rich Melted Chocolate and Walnuts. Your Doorway To Heaven! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 524.92 KCAL",
      imageId: "vswiuilm0bfykekoa6zx",
      inStock: 1,
      isVeg: 1,
      price: 60050,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "92662538",
      name: "Death by Chocolate Waffle Cake (Single Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 1-2 | Signature dark chocolate single layer waffle cake layered with creamy White, Milk and Dark melted Belgian Chocolate. Triple the chocolate, triple the fun! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 491.36 KCAL",
      imageId: "tvvdhhxv1ucm0xnhbdfx",
      inStock: 1,
      isVeg: 1,
      price: 36048,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "92662546",
      name: "Death by Chocolate Waffle Cake (Double Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 2-3 | Signature dark chocolate double layer waffle cake layered inside and out with creamy White, Milk and Dark melted Belgian Chocolate. Triple the chocolate, triple the fun! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 482.3 KCAL",
      imageId: "g7v2sn7eezaricdwqcfz",
      inStock: 1,
      isVeg: 1,
      price: 58052,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295448",
      name: "Berry Velvet Waffle Cake (Single Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 1-2 | Original Red Velvet Single Layer Waffle Cake With Strawberry Compote + Philadelphia Style Cream Cheese And Melted White Chocolate Topped With Red Velvet Crumbs. A True Original - Enhanced! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 400.18 KCAL",
      imageId: "f0wxd5msxfmrwlbmto1v",
      inStock: 1,
      isVeg: 1,
      price: 36048,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295469",
      name: "Berry Velvet Waffle Cake (Double Layer)",
      category: "Waffle Cake",
      description:
        "Serves 1 | Serves 2-3  | Original Red Velvet Double Layer Waffle Cake With Strawberry Compote + Philadelphia Style Cream Cheese And Melted White Chocolate Topped With Red Velvet Crumbs. A True Original - Enhanced! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order) Energy - 416.82 KCAL",
      imageId: "pu745scsltqx0ewsfvec",
      inStock: 1,
      isVeg: 1,
      price: 58052,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "The BWC Store": [
    {
      id: "70435369",
      name: "Chocolate Oats Pancake & Waffle Mix",
      category: "The BWC Store",
      description:
        "Serves 1 | Serves 1 | Now enjoy your favorite, 100% vegetarian, original waffles and pancakes at home with The Belgian Waffle Co. Pancake and Waffle premix. This super easy 3-step premix requires you to just Mix, Cook, and Enjoy! Try our Original, Choco Oats or Almond Flour variants with toppings of your choice. Energy - 387 KCAL",
      imageId: "watxxnchlnd6gbm9qy7w",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "51784219",
          groupName:
            "Choose From Spreads for Chocolate Oats Pancake & Waffle Mix",
          choices: [
            {
              id: "41467608",
              name: "Milk Choco Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467609",
              name: "Dark Choco Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467610",
              name: "Cookie & Cream Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 3,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "70435373",
      name: "Original Pancake & Waffle Mix",
      category: "The BWC Store",
      description:
        "Serves 1 | Serves 1 | Now enjoy your favorite, 100% vegetarian, original waffles and pancakes at home with The Belgian Waffle Co. Pancake and Waffle premix. This super easy 3-step premix requires you to just Mix, Cook, and Enjoy! Try our Original, Choco Oats or Almond Flour variants with toppings of your choice. Energy - 377 KCAL",
      imageId: "zcnbryujcm8fy9jordod",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "55426185",
          groupName: "Choose From Spreads for Original Pancake & Waffle Mix",
          choices: [
            {
              id: "41467608",
              name: "Milk Choco Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467609",
              name: "Dark Choco Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467610",
              name: "Cookie & Cream Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 3,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "70435619",
      name: "Waffle Crisps - Chocolate Flavour",
      category: "The BWC Store",
      description:
        "Serves 1 | Thin Crunchy Wholesome And Delightfully Addictive. Uniquely Rich Flavours That Evoke Nostalgic Tastes. From The Creators Of The Original Waffle These Baked Waffle Crisps With Just The Right Chocolate Drizzle Make For The Perfect Bite-Sized And Versatile Snack That Is Sure To Hit The Spot. Enjoy With Coffee Or Tea Ice Cream Or Cake Nut Butters Or Spreads Or Just On Its Delicious Own. Energy - 509 KCAL",
      imageId: "c6pfxetpakdof1ik2gtq",
      inStock: 1,
      isVeg: 1,
      price: 11429,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "70435656",
      name: "Waffle Crisps - Double Chocolate Flavour",
      category: "The BWC Store",
      description:
        "Serves 1 | Thin Crunchy Wholesome And Delightfully Addictive. Uniquely Rich Flavours That Evoke Nostalgic Tastes. From The Creators Of The Original Waffle These Baked Waffle Crisps With Just The Right Chocolate Drizzle Make For The Perfect Bite-Sized And Versatile Snack That Is Sure To Hit The Spot. Enjoy With Coffee Or Tea Ice Cream Or Cake Nut Butters Or Spreads Or Just On Its Delicious Own. Energy - 483 KCAL",
      imageId: "tkonqgukxjfnlvvk1fhf",
      inStock: 1,
      isVeg: 1,
      price: 11429,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80058391",
      name: "Milk Choco Spread",
      category: "The BWC Store",
      description:
        "Serves 1 | A Delicious, Creamy Smooth Spread From Your Favourite The Belgian Waffle Co. Spread It On To Your Favourites Or To Magically Transform Something Into Your New Favorite. Energy - 600 KCAL",
      imageId: "omyu9sd2p8nzamcr8d2n",
      inStock: 1,
      isVeg: 1,
      price: 23714,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80058392",
      name: "Cookie & Cream Spread",
      category: "The BWC Store",
      description:
        "Serves 1 | A Delicious, Creamy Smooth Spread From Your Favourite The Belgian Waffle Co. Spread It On To Your Favourites Or To Magically Transform Something Into Your New Favorite. Energy - 580 KCAL",
      imageId: "najdfhqi76cdnjpjwwxm",
      inStock: 1,
      isVeg: 1,
      price: 23714,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80058393",
      name: "Dark Choco Spread",
      category: "The BWC Store",
      description:
        "Serves 1 | A Delicious, Creamy Smooth Spread From Your Favourite The Belgian Waffle Co. Spread It On To Your Favourites Or To Magically Transform Something Into Your New Favorite. Energy - 593 KCAL",
      imageId: "d4mkvt0g5wbdk2fkw65k",
      inStock: 1,
      isVeg: 1,
      price: 23714,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "97741063",
      name: "Almond Flour Pancake & Waffle Mix",
      category: "The BWC Store",
      description:
        "Serves 1 | Serves 1 | Now enjoy your favorite, 100% vegetarian, original waffles and pancakes at home with The Belgian Waffle Co. Pancake and Waffle premix. This super easy 3-step premix requires you to just Mix, Cook, and Enjoy! Try our Original, Choco Oats or Almond Flour variants with toppings of your choice. Energy - 408 KCAL",
      imageId: "owp6l0rpeoy5tbdt36ky",
      inStock: 1,
      isVeg: 1,
      price: 23809,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "57778106",
          groupName:
            "Choose From Spreads for Almond Flour Pancake & Waffle Mix",
          choices: [
            {
              id: "41467608",
              name: "Milk Choco Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467609",
              name: "Dark Choco Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467610",
              name: "Cookie & Cream Spread",
              price: 23714,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 3,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Mini Pancakes": [
    {
      id: "92662467",
      name: "Chocolate Overload- Milk Mini Pancakes (8 Pieces)",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Signature dark chocolate batter + Melted Belgian milk chocolate. Double the chocolate!  Energy - 418 KCAL",
      imageId: "e88ftehv35vjbvovifb3",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779817",
          groupName:
            "Choose From Ice Cream for Chocolate Overload- Milk Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779816",
          groupName:
            "Choose From Extra Fillings for Chocolate Overload- Milk Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779815",
          groupName:
            "Choose From Add On for Chocolate Overload- Milk Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "92662468",
      name: "Chocolate Overload - Dark Mini Pancakes (8 Pieces)",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Signature dark chocolate batter + Melted Belgian dark chocolate. Double the chocolate!  Energy - 422 KCAL",
      imageId: "hm4dvvj0ablb3khjfami",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779818",
          groupName:
            "Choose From Ice Cream for Chocolate Overload - Dark Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779819",
          groupName:
            "Choose From Extra Fillings for Chocolate Overload - Dark Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779820",
          groupName:
            "Choose From Add On for Chocolate Overload - Dark Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92662469",
      name: "Dark & White Fantasy Mini Pancakes (8 Pieces)",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Mini Pancakes with Signature dark chocolate batter + Fondant of melted Belgian white chocolate. A match made in heaven!  Energy - 405 KCAL",
      imageId: "szhrgmgbauub6lomspn6",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779821",
          groupName:
            "Choose From Ice Cream for Dark & White Fantasy Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779822",
          groupName:
            "Choose From Extra Fillings for Dark & White Fantasy Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779823",
          groupName:
            "Choose From Add On for Dark & White Fantasy Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662470",
      name: "Triple Chocolate Mini Pancakes (8 Pieces)",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Signature dark chocolate batter + 3 layers of White, Milk and Dark melted Belgian Chocolate. The most indulgent Mini chocolate Pancakes!  Energy - 430 KCAL",
      imageId: "ogueypid6hjhhmmzpgxc",
      inStock: 1,
      isVeg: 1,
      price: 14619,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779824",
          groupName:
            "Choose From Ice Cream for Triple Chocolate Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779825",
          groupName:
            "Choose From Extra Fillings for Triple Chocolate Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779826",
          groupName:
            "Choose From Add On for Triple Chocolate Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "92662473",
      name: "Red Velvet Mini Pancakes (8 Pieces)",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Original Red Velvet Mini Pancakes + Melted Belgian white chocolate. A true Original!  Energy - 403 KCAL",
      imageId: "nnolpu7xaxhr8ozizgpv",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779833",
          groupName:
            "Choose From Ice Cream for Red Velvet Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779834",
          groupName:
            "Choose From Extra Fillings for Red Velvet Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779835",
          groupName:
            "Choose From Add On for Red Velvet Mini Pancakes (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662499",
      name: "Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Signature Black Velvet waffle + our special blue filling with crunchy Oreo bits. Kiki do you love me?  Energy - 423 KCAL",
      imageId: "o2daoeik6lfptqjvyrrm",
      inStock: 1,
      isVeg: 1,
      price: 12619,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779830",
          groupName:
            "Choose From Ice Cream for Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779831",
          groupName:
            "Choose From Extra Fillings for Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779832",
          groupName:
            "Choose From Add On for Kiki & Oreo Cream Mini Pancakes(8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662501",
      name: "Biscoff Milkyway Mini Pancake",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Signature Black Velvet Mini Pancakes + Fondant of melted white chocolate topped with crunchy Lotus Biscoff bits. An all time favourite!  Energy - 442 KCAL",
      imageId: "jrib40z3nblj1slcqljv",
      inStock: 1,
      isVeg: 1,
      price: 13476,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67779827",
          groupName: "Choose From Ice Cream for Biscoff Milkyway Mini Pancake",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779828",
          groupName:
            "Choose From Extra Fillings for Biscoff Milkyway Mini Pancake",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779829",
          groupName: "Choose From Add On for Biscoff Milkyway Mini Pancake",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295470",
      name: "Maple Butter Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Warm Melted Butter And Maple Syrup Drizzle. An American Classic!  Energy - 361 KCAL",
      imageId: "cnt2sga21r02vtx6qhhw",
      inStock: 1,
      isVeg: 1,
      price: 8857,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424701",
            name: "Choose from Maple Butter Mini Pancakes",
            variations: [
              {
                name: "Maple Butter Mini Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437554",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Maple Butter Waffle (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437555",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424701",
                variationId: "70437554",
              },
            ],
            price: 8857,
            addonCombinations: [
              {
                groupId: "67779684",
                addonId: "41467134",
              },
              {
                groupId: "67779684",
                addonId: "41467136",
              },
              {
                groupId: "67779684",
                addonId: "41467140",
              },
              {
                groupId: "67779684",
                addonId: "41467138",
              },
              {
                groupId: "67779684",
                addonId: "41467142",
              },
              {
                groupId: "67779684",
                addonId: "55402204",
              },
              {
                groupId: "67779684",
                addonId: "54074008",
              },
              {
                groupId: "67779684",
                addonId: "41467143",
              },
              {
                groupId: "67779684",
                addonId: "54074009",
              },
              {
                groupId: "67779684",
                addonId: "41467132",
              },
              {
                groupId: "67779682",
                addonId: "41467145",
              },
              {
                groupId: "67779682",
                addonId: "41467147",
              },
              {
                groupId: "67779682",
                addonId: "41467149",
              },
              {
                groupId: "67779682",
                addonId: "41467151",
              },
              {
                groupId: "67779682",
                addonId: "41467152",
              },
              {
                groupId: "67779682",
                addonId: "41467154",
              },
              {
                groupId: "67779682",
                addonId: "41467156",
              },
              {
                groupId: "67779682",
                addonId: "41467158",
              },
              {
                groupId: "67779682",
                addonId: "41467160",
              },
              {
                groupId: "67779682",
                addonId: "41467162",
              },
              {
                groupId: "67779682",
                addonId: "41467163",
              },
              {
                groupId: "67779682",
                addonId: "41467165",
              },
              {
                groupId: "67779682",
                addonId: "41467167",
              },
              {
                groupId: "67779682",
                addonId: "41467171",
              },
              {
                groupId: "67779680",
                addonId: "41467176",
              },
              {
                groupId: "67779680",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424701",
                variationId: "70437555",
              },
            ],
            price: 12357,
            addonCombinations: [
              {
                groupId: "67779685",
                addonId: "41467132",
              },
              {
                groupId: "67779685",
                addonId: "41467134",
              },
              {
                groupId: "67779685",
                addonId: "41467136",
              },
              {
                groupId: "67779685",
                addonId: "41467138",
              },
              {
                groupId: "67779685",
                addonId: "41467140",
              },
              {
                groupId: "67779685",
                addonId: "41467142",
              },
              {
                groupId: "67779685",
                addonId: "41467143",
              },
              {
                groupId: "67779685",
                addonId: "55402204",
              },
              {
                groupId: "67779685",
                addonId: "54074009",
              },
              {
                groupId: "67779685",
                addonId: "54074008",
              },
              {
                groupId: "67779683",
                addonId: "41467145",
              },
              {
                groupId: "67779683",
                addonId: "41467147",
              },
              {
                groupId: "67779683",
                addonId: "41467149",
              },
              {
                groupId: "67779683",
                addonId: "41467151",
              },
              {
                groupId: "67779683",
                addonId: "41467152",
              },
              {
                groupId: "67779683",
                addonId: "41467154",
              },
              {
                groupId: "67779683",
                addonId: "41467156",
              },
              {
                groupId: "67779683",
                addonId: "41467158",
              },
              {
                groupId: "67779683",
                addonId: "41467160",
              },
              {
                groupId: "67779683",
                addonId: "41467162",
              },
              {
                groupId: "67779683",
                addonId: "41467163",
              },
              {
                groupId: "67779683",
                addonId: "41467165",
              },
              {
                groupId: "67779683",
                addonId: "41467167",
              },
              {
                groupId: "67779683",
                addonId: "41467171",
              },
              {
                groupId: "67779681",
                addonId: "41467176",
              },
              {
                groupId: "67779681",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779680",
          groupName:
            "Choose From Ice Cream for Maple Butter Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779681",
          groupName:
            "Choose From Ice Cream for Maple Butter Waffle (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779682",
          groupName:
            "Choose From Extra Fillings for Maple Butter Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779683",
          groupName:
            "Choose From Extra Fillings for Maple Butter Waffle (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779684",
          groupName:
            "Choose From Add On for Maple Butter Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779685",
          groupName:
            "Choose From Add On for Maple Butter Waffle (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 8857,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "96295473",
      name: "Strawberry Creamcheese Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Strawberry Compote Layered With Philadelphia Style Cream Cheese. Deliciously Tart!  Energy - 297 KCAL",
      imageId: "gg42wr1xqhmw9c27foaw",
      inStock: 1,
      isVeg: 1,
      price: 14524,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424702",
            name: "Choose from Strawberry Creamcheese Mini Pancakes",
            variations: [
              {
                name: "Strawberry Cream cheese Mini Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437556",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Strawberry Cream Cheese Mini Pancakes(Almond Flour Batter)(8 Pieces)",
                price: 35,
                id: "70437557",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424702",
                variationId: "70437556",
              },
            ],
            price: 14524,
            addonCombinations: [
              {
                groupId: "67779690",
                addonId: "41467134",
              },
              {
                groupId: "67779690",
                addonId: "41467136",
              },
              {
                groupId: "67779690",
                addonId: "41467138",
              },
              {
                groupId: "67779690",
                addonId: "41467140",
              },
              {
                groupId: "67779690",
                addonId: "41467142",
              },
              {
                groupId: "67779690",
                addonId: "55402204",
              },
              {
                groupId: "67779690",
                addonId: "54074008",
              },
              {
                groupId: "67779690",
                addonId: "41467143",
              },
              {
                groupId: "67779690",
                addonId: "54074009",
              },
              {
                groupId: "67779690",
                addonId: "41467132",
              },
              {
                groupId: "67779688",
                addonId: "41467145",
              },
              {
                groupId: "67779688",
                addonId: "41467147",
              },
              {
                groupId: "67779688",
                addonId: "41467149",
              },
              {
                groupId: "67779688",
                addonId: "41467151",
              },
              {
                groupId: "67779688",
                addonId: "41467152",
              },
              {
                groupId: "67779688",
                addonId: "41467154",
              },
              {
                groupId: "67779688",
                addonId: "41467156",
              },
              {
                groupId: "67779688",
                addonId: "41467158",
              },
              {
                groupId: "67779688",
                addonId: "41467160",
              },
              {
                groupId: "67779688",
                addonId: "41467162",
              },
              {
                groupId: "67779688",
                addonId: "41467163",
              },
              {
                groupId: "67779688",
                addonId: "41467165",
              },
              {
                groupId: "67779688",
                addonId: "41467167",
              },
              {
                groupId: "67779688",
                addonId: "41467171",
              },
              {
                groupId: "67779686",
                addonId: "41467176",
              },
              {
                groupId: "67779686",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424702",
                variationId: "70437557",
              },
            ],
            price: 18024,
            addonCombinations: [
              {
                groupId: "67779691",
                addonId: "41467134",
              },
              {
                groupId: "67779691",
                addonId: "41467136",
              },
              {
                groupId: "67779691",
                addonId: "41467138",
              },
              {
                groupId: "67779691",
                addonId: "41467140",
              },
              {
                groupId: "67779691",
                addonId: "41467142",
              },
              {
                groupId: "67779691",
                addonId: "41467143",
              },
              {
                groupId: "67779691",
                addonId: "55402204",
              },
              {
                groupId: "67779691",
                addonId: "54074008",
              },
              {
                groupId: "67779691",
                addonId: "54074009",
              },
              {
                groupId: "67779691",
                addonId: "41467132",
              },
              {
                groupId: "67779689",
                addonId: "41467145",
              },
              {
                groupId: "67779689",
                addonId: "41467147",
              },
              {
                groupId: "67779689",
                addonId: "41467149",
              },
              {
                groupId: "67779689",
                addonId: "41467151",
              },
              {
                groupId: "67779689",
                addonId: "41467152",
              },
              {
                groupId: "67779689",
                addonId: "41467154",
              },
              {
                groupId: "67779689",
                addonId: "41467156",
              },
              {
                groupId: "67779689",
                addonId: "41467158",
              },
              {
                groupId: "67779689",
                addonId: "41467160",
              },
              {
                groupId: "67779689",
                addonId: "41467162",
              },
              {
                groupId: "67779689",
                addonId: "41467163",
              },
              {
                groupId: "67779689",
                addonId: "41467165",
              },
              {
                groupId: "67779689",
                addonId: "41467167",
              },
              {
                groupId: "67779689",
                addonId: "41467171",
              },
              {
                groupId: "67779687",
                addonId: "41467176",
              },
              {
                groupId: "67779687",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779686",
          groupName:
            "Choose From Ice Cream for Strawberry Cream cheese Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779687",
          groupName:
            "Choose From Ice Cream for Strawberry Cream Cheese Mini Pancakes(Almond Flour Batter)(8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779688",
          groupName:
            "Choose From Extra Fillings for Strawberry Cream cheese Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779689",
          groupName:
            "Choose From Extra Fillings for Strawberry Cream Cheese Mini Pancakes(Almond Flour Batter)(8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779691",
          groupName:
            "Choose From Add On for Strawberry Cream Cheese Mini Pancakes(Almond Flour Batter)(8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779690",
          groupName:
            "Choose From Add On for Strawberry Cream cheese Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 14524,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295476",
      name: "Honey Butter Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Warm Melted Butter And Golden Honey Drizzle. An American Classic Energy - 360 KCAL",
      imageId: "waxcbwuz28wce2vwvvgb",
      inStock: 1,
      isVeg: 1,
      price: 8857,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424700",
            name: "Choose from Honey Butter Mini Pancakes",
            variations: [
              {
                name: "Honey Butter Mini Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437552",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Honey Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437553",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424700",
                variationId: "70437552",
              },
            ],
            price: 8857,
            addonCombinations: [
              {
                groupId: "67779678",
                addonId: "41467132",
              },
              {
                groupId: "67779678",
                addonId: "41467134",
              },
              {
                groupId: "67779678",
                addonId: "41467136",
              },
              {
                groupId: "67779678",
                addonId: "41467138",
              },
              {
                groupId: "67779678",
                addonId: "41467142",
              },
              {
                groupId: "67779678",
                addonId: "41467140",
              },
              {
                groupId: "67779678",
                addonId: "55402204",
              },
              {
                groupId: "67779678",
                addonId: "54074008",
              },
              {
                groupId: "67779678",
                addonId: "41467143",
              },
              {
                groupId: "67779678",
                addonId: "54074009",
              },
              {
                groupId: "67779676",
                addonId: "41467145",
              },
              {
                groupId: "67779676",
                addonId: "41467147",
              },
              {
                groupId: "67779676",
                addonId: "41467149",
              },
              {
                groupId: "67779676",
                addonId: "41467151",
              },
              {
                groupId: "67779676",
                addonId: "41467152",
              },
              {
                groupId: "67779676",
                addonId: "41467154",
              },
              {
                groupId: "67779676",
                addonId: "41467156",
              },
              {
                groupId: "67779676",
                addonId: "41467158",
              },
              {
                groupId: "67779676",
                addonId: "41467160",
              },
              {
                groupId: "67779676",
                addonId: "41467162",
              },
              {
                groupId: "67779676",
                addonId: "41467163",
              },
              {
                groupId: "67779676",
                addonId: "41467165",
              },
              {
                groupId: "67779676",
                addonId: "41467171",
              },
              {
                groupId: "67779676",
                addonId: "41467167",
              },
              {
                groupId: "67779674",
                addonId: "41467176",
              },
              {
                groupId: "67779674",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424700",
                variationId: "70437553",
              },
            ],
            price: 12357,
            addonCombinations: [
              {
                groupId: "67779679",
                addonId: "41467134",
              },
              {
                groupId: "67779679",
                addonId: "41467136",
              },
              {
                groupId: "67779679",
                addonId: "41467138",
              },
              {
                groupId: "67779679",
                addonId: "41467140",
              },
              {
                groupId: "67779679",
                addonId: "41467142",
              },
              {
                groupId: "67779679",
                addonId: "41467143",
              },
              {
                groupId: "67779679",
                addonId: "55402204",
              },
              {
                groupId: "67779679",
                addonId: "54074008",
              },
              {
                groupId: "67779679",
                addonId: "54074009",
              },
              {
                groupId: "67779679",
                addonId: "41467132",
              },
              {
                groupId: "67779677",
                addonId: "41467145",
              },
              {
                groupId: "67779677",
                addonId: "41467147",
              },
              {
                groupId: "67779677",
                addonId: "41467149",
              },
              {
                groupId: "67779677",
                addonId: "41467151",
              },
              {
                groupId: "67779677",
                addonId: "41467152",
              },
              {
                groupId: "67779677",
                addonId: "41467154",
              },
              {
                groupId: "67779677",
                addonId: "41467156",
              },
              {
                groupId: "67779677",
                addonId: "41467158",
              },
              {
                groupId: "67779677",
                addonId: "41467160",
              },
              {
                groupId: "67779677",
                addonId: "41467162",
              },
              {
                groupId: "67779677",
                addonId: "41467163",
              },
              {
                groupId: "67779677",
                addonId: "41467165",
              },
              {
                groupId: "67779677",
                addonId: "41467167",
              },
              {
                groupId: "67779677",
                addonId: "41467171",
              },
              {
                groupId: "67779675",
                addonId: "41467176",
              },
              {
                groupId: "67779675",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779674",
          groupName:
            "Choose From Ice Cream for Honey Butter Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779675",
          groupName:
            "Choose From Ice Cream for Honey Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779677",
          groupName:
            "Choose From Extra Fillings for Honey Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779676",
          groupName:
            "Choose From Extra Fillings for Honey Butter Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779679",
          groupName:
            "Choose From Add On for Honey Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779678",
          groupName:
            "Choose From Add On for Honey Butter Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 8857,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295478",
      name: "Blueberry Creamcheese Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Blueberry Compote Layered With Philadelphia Style Cream Cheese. Deliciously Tart!  Energy - 298 KCAL",
      imageId: "zskpofnejperevoee8vv",
      inStock: 1,
      isVeg: 1,
      price: 15571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424703",
            name: "Choose from Blueberry Creamcheese Mini Pancakes",
            variations: [
              {
                name: "Blueberry Creamcheese Mini Pancakes (Regular Batter)( 8 Pieces)",
                default: 1,
                id: "70437558",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Blueberry Cream Cheese Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437559",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424703",
                variationId: "70437558",
              },
            ],
            price: 15571,
            addonCombinations: [
              {
                groupId: "67779696",
                addonId: "41467134",
              },
              {
                groupId: "67779696",
                addonId: "41467136",
              },
              {
                groupId: "67779696",
                addonId: "41467138",
              },
              {
                groupId: "67779696",
                addonId: "41467140",
              },
              {
                groupId: "67779696",
                addonId: "41467142",
              },
              {
                groupId: "67779696",
                addonId: "55402204",
              },
              {
                groupId: "67779696",
                addonId: "54074008",
              },
              {
                groupId: "67779696",
                addonId: "41467143",
              },
              {
                groupId: "67779696",
                addonId: "54074009",
              },
              {
                groupId: "67779696",
                addonId: "41467132",
              },
              {
                groupId: "67779694",
                addonId: "41467145",
              },
              {
                groupId: "67779694",
                addonId: "41467147",
              },
              {
                groupId: "67779694",
                addonId: "41467149",
              },
              {
                groupId: "67779694",
                addonId: "41467151",
              },
              {
                groupId: "67779694",
                addonId: "41467152",
              },
              {
                groupId: "67779694",
                addonId: "41467154",
              },
              {
                groupId: "67779694",
                addonId: "41467156",
              },
              {
                groupId: "67779694",
                addonId: "41467158",
              },
              {
                groupId: "67779694",
                addonId: "41467160",
              },
              {
                groupId: "67779694",
                addonId: "41467162",
              },
              {
                groupId: "67779694",
                addonId: "41467171",
              },
              {
                groupId: "67779694",
                addonId: "41467163",
              },
              {
                groupId: "67779694",
                addonId: "41467165",
              },
              {
                groupId: "67779694",
                addonId: "41467167",
              },
              {
                groupId: "67779692",
                addonId: "41467176",
              },
              {
                groupId: "67779692",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424703",
                variationId: "70437559",
              },
            ],
            price: 19071,
            addonCombinations: [
              {
                groupId: "67779697",
                addonId: "41467134",
              },
              {
                groupId: "67779697",
                addonId: "41467136",
              },
              {
                groupId: "67779697",
                addonId: "41467138",
              },
              {
                groupId: "67779697",
                addonId: "41467140",
              },
              {
                groupId: "67779697",
                addonId: "41467142",
              },
              {
                groupId: "67779697",
                addonId: "41467143",
              },
              {
                groupId: "67779697",
                addonId: "55402204",
              },
              {
                groupId: "67779697",
                addonId: "54074008",
              },
              {
                groupId: "67779697",
                addonId: "54074009",
              },
              {
                groupId: "67779697",
                addonId: "41467132",
              },
              {
                groupId: "67779695",
                addonId: "41467145",
              },
              {
                groupId: "67779695",
                addonId: "41467147",
              },
              {
                groupId: "67779695",
                addonId: "41467149",
              },
              {
                groupId: "67779695",
                addonId: "41467151",
              },
              {
                groupId: "67779695",
                addonId: "41467152",
              },
              {
                groupId: "67779695",
                addonId: "41467154",
              },
              {
                groupId: "67779695",
                addonId: "41467156",
              },
              {
                groupId: "67779695",
                addonId: "41467158",
              },
              {
                groupId: "67779695",
                addonId: "41467160",
              },
              {
                groupId: "67779695",
                addonId: "41467162",
              },
              {
                groupId: "67779695",
                addonId: "41467163",
              },
              {
                groupId: "67779695",
                addonId: "41467165",
              },
              {
                groupId: "67779695",
                addonId: "41467167",
              },
              {
                groupId: "67779695",
                addonId: "41467171",
              },
              {
                groupId: "67779693",
                addonId: "41467176",
              },
              {
                groupId: "67779693",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779692",
          groupName:
            "Choose From Ice Cream for Blueberry Creamcheese Mini Pancakes (Regular Batter)( 8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779693",
          groupName:
            "Choose From Ice Cream for Blueberry Cream Cheese Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779695",
          groupName:
            "Choose From Extra Fillings for Blueberry Cream Cheese Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779694",
          groupName:
            "Choose From Extra Fillings for Blueberry Creamcheese Mini Pancakes (Regular Batter)( 8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779696",
          groupName:
            "Choose From Add On for Blueberry Creamcheese Mini Pancakes (Regular Batter)( 8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779697",
          groupName:
            "Choose From Add On for Blueberry Cream Cheese Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 15571,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295480",
      name: "Almond Cocoa Butter Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Mini Pancakes + Cocoa Butter Topped With Roasted Almonds. Nutty & Delicious!  Energy - 423 KCAL",
      imageId: "iroblkh0d1rdvth6rspz",
      inStock: 1,
      isVeg: 1,
      price: 14619,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424711",
            name: "Choose from Almond Cocoa Butter Mini Pancakes",
            variations: [
              {
                name: "Almond Cocoa Butter Mini Pancake (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437574",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Almond Cocoa Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437575",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424711",
                variationId: "70437574",
              },
            ],
            price: 14619,
            addonCombinations: [
              {
                groupId: "67779744",
                addonId: "41467134",
              },
              {
                groupId: "67779744",
                addonId: "41467136",
              },
              {
                groupId: "67779744",
                addonId: "41467138",
              },
              {
                groupId: "67779744",
                addonId: "41467140",
              },
              {
                groupId: "67779744",
                addonId: "41467142",
              },
              {
                groupId: "67779744",
                addonId: "55402204",
              },
              {
                groupId: "67779744",
                addonId: "54074008",
              },
              {
                groupId: "67779744",
                addonId: "41467143",
              },
              {
                groupId: "67779744",
                addonId: "54074009",
              },
              {
                groupId: "67779744",
                addonId: "41467132",
              },
              {
                groupId: "67779742",
                addonId: "41467145",
              },
              {
                groupId: "67779742",
                addonId: "41467147",
              },
              {
                groupId: "67779742",
                addonId: "41467149",
              },
              {
                groupId: "67779742",
                addonId: "41467151",
              },
              {
                groupId: "67779742",
                addonId: "41467152",
              },
              {
                groupId: "67779742",
                addonId: "41467154",
              },
              {
                groupId: "67779742",
                addonId: "41467156",
              },
              {
                groupId: "67779742",
                addonId: "41467158",
              },
              {
                groupId: "67779742",
                addonId: "41467160",
              },
              {
                groupId: "67779742",
                addonId: "41467162",
              },
              {
                groupId: "67779742",
                addonId: "41467163",
              },
              {
                groupId: "67779742",
                addonId: "41467165",
              },
              {
                groupId: "67779742",
                addonId: "41467167",
              },
              {
                groupId: "67779742",
                addonId: "41467171",
              },
              {
                groupId: "67779740",
                addonId: "41467176",
              },
              {
                groupId: "67779740",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424711",
                variationId: "70437575",
              },
            ],
            price: 18119,
            addonCombinations: [
              {
                groupId: "67779745",
                addonId: "41467134",
              },
              {
                groupId: "67779745",
                addonId: "41467136",
              },
              {
                groupId: "67779745",
                addonId: "41467138",
              },
              {
                groupId: "67779745",
                addonId: "41467140",
              },
              {
                groupId: "67779745",
                addonId: "41467142",
              },
              {
                groupId: "67779745",
                addonId: "41467143",
              },
              {
                groupId: "67779745",
                addonId: "55402204",
              },
              {
                groupId: "67779745",
                addonId: "54074008",
              },
              {
                groupId: "67779745",
                addonId: "54074009",
              },
              {
                groupId: "67779745",
                addonId: "41467132",
              },
              {
                groupId: "67779743",
                addonId: "41467145",
              },
              {
                groupId: "67779743",
                addonId: "41467147",
              },
              {
                groupId: "67779743",
                addonId: "41467149",
              },
              {
                groupId: "67779743",
                addonId: "41467151",
              },
              {
                groupId: "67779743",
                addonId: "41467152",
              },
              {
                groupId: "67779743",
                addonId: "41467154",
              },
              {
                groupId: "67779743",
                addonId: "41467156",
              },
              {
                groupId: "67779743",
                addonId: "41467158",
              },
              {
                groupId: "67779743",
                addonId: "41467160",
              },
              {
                groupId: "67779743",
                addonId: "41467162",
              },
              {
                groupId: "67779743",
                addonId: "41467163",
              },
              {
                groupId: "67779743",
                addonId: "41467165",
              },
              {
                groupId: "67779743",
                addonId: "41467167",
              },
              {
                groupId: "67779743",
                addonId: "41467171",
              },
              {
                groupId: "67779741",
                addonId: "41467176",
              },
              {
                groupId: "67779741",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779740",
          groupName:
            "Choose From Ice Cream for Almond Cocoa Butter Mini Pancake (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779741",
          groupName:
            "Choose From Ice Cream for Almond Cocoa Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779743",
          groupName:
            "Choose From Extra Fillings for Almond Cocoa Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779742",
          groupName:
            "Choose From Extra Fillings for Almond Cocoa Butter Mini Pancake (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779745",
          groupName:
            "Choose From Add On for Almond Cocoa Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779744",
          groupName:
            "Choose From Add On for Almond Cocoa Butter Mini Pancake (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 14619,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295514",
      name: "Peanut Butter Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Crunchy Roasted Peanut Butter With Melted Chocolate Swirl (add Banana if you like)  Energy - 463 KCAL",
      imageId: "ayifteyq6xwtb2he95lc",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424712",
            name: "Choose from Peanut Butter Mini Pancakes",
            variations: [
              {
                name: "Peanut Butter Mini Pancake (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437576",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Peanut Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437577",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424712",
                variationId: "70437576",
              },
            ],
            price: 13571,
            addonCombinations: [
              {
                groupId: "67779750",
                addonId: "41467132",
              },
              {
                groupId: "67779750",
                addonId: "41467136",
              },
              {
                groupId: "67779750",
                addonId: "41467138",
              },
              {
                groupId: "67779750",
                addonId: "41467140",
              },
              {
                groupId: "67779750",
                addonId: "41467142",
              },
              {
                groupId: "67779750",
                addonId: "41467143",
              },
              {
                groupId: "67779750",
                addonId: "54074008",
              },
              {
                groupId: "67779750",
                addonId: "55402204",
              },
              {
                groupId: "67779750",
                addonId: "54074009",
              },
              {
                groupId: "67779750",
                addonId: "41467134",
              },
              {
                groupId: "67779748",
                addonId: "41467145",
              },
              {
                groupId: "67779748",
                addonId: "41467147",
              },
              {
                groupId: "67779748",
                addonId: "41467149",
              },
              {
                groupId: "67779748",
                addonId: "41467151",
              },
              {
                groupId: "67779748",
                addonId: "41467152",
              },
              {
                groupId: "67779748",
                addonId: "41467154",
              },
              {
                groupId: "67779748",
                addonId: "41467156",
              },
              {
                groupId: "67779748",
                addonId: "41467158",
              },
              {
                groupId: "67779748",
                addonId: "41467160",
              },
              {
                groupId: "67779748",
                addonId: "41467162",
              },
              {
                groupId: "67779748",
                addonId: "41467163",
              },
              {
                groupId: "67779748",
                addonId: "41467165",
              },
              {
                groupId: "67779748",
                addonId: "41467167",
              },
              {
                groupId: "67779748",
                addonId: "41467171",
              },
              {
                groupId: "67779746",
                addonId: "41467176",
              },
              {
                groupId: "67779746",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424712",
                variationId: "70437577",
              },
            ],
            price: 17071,
            addonCombinations: [
              {
                groupId: "67779751",
                addonId: "41467132",
              },
              {
                groupId: "67779751",
                addonId: "41467134",
              },
              {
                groupId: "67779751",
                addonId: "41467136",
              },
              {
                groupId: "67779751",
                addonId: "41467138",
              },
              {
                groupId: "67779751",
                addonId: "41467140",
              },
              {
                groupId: "67779751",
                addonId: "41467142",
              },
              {
                groupId: "67779751",
                addonId: "41467143",
              },
              {
                groupId: "67779751",
                addonId: "55402204",
              },
              {
                groupId: "67779751",
                addonId: "54074008",
              },
              {
                groupId: "67779751",
                addonId: "54074009",
              },
              {
                groupId: "67779749",
                addonId: "41467145",
              },
              {
                groupId: "67779749",
                addonId: "41467147",
              },
              {
                groupId: "67779749",
                addonId: "41467149",
              },
              {
                groupId: "67779749",
                addonId: "41467151",
              },
              {
                groupId: "67779749",
                addonId: "41467152",
              },
              {
                groupId: "67779749",
                addonId: "41467154",
              },
              {
                groupId: "67779749",
                addonId: "41467156",
              },
              {
                groupId: "67779749",
                addonId: "41467158",
              },
              {
                groupId: "67779749",
                addonId: "41467160",
              },
              {
                groupId: "67779749",
                addonId: "41467162",
              },
              {
                groupId: "67779749",
                addonId: "41467163",
              },
              {
                groupId: "67779749",
                addonId: "41467165",
              },
              {
                groupId: "67779749",
                addonId: "41467167",
              },
              {
                groupId: "67779749",
                addonId: "41467171",
              },
              {
                groupId: "67779747",
                addonId: "41467176",
              },
              {
                groupId: "67779747",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779747",
          groupName:
            "Choose From Ice Cream for Peanut Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779746",
          groupName:
            "Choose From Ice Cream for Peanut Butter Mini Pancake (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779748",
          groupName:
            "Choose From Extra Fillings for Peanut Butter Mini Pancake (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779749",
          groupName:
            "Choose From Extra Fillings for Peanut Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779750",
          groupName:
            "Choose From Add On for Peanut Butter Mini Pancake (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 5,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779751",
          groupName:
            "Choose From Add On for Peanut Butter Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 13571,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295516",
      name: "Belgian Chocolate Milk Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Melted Belgian Milk Chocolate. Simplicity At Its Best!  Energy - 438 KCAL",
      imageId: "h6fkfhuvqiyvh0jw440t",
      inStock: 1,
      isVeg: 1,
      price: 12619,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424713",
            name: "Choose from Belgian Chocolate Milk Mini Pancakes",
            variations: [
              {
                name: "Belgian Chocolate - Milk Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437578",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Belgian Chocolate Milk Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437579",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424713",
                variationId: "70437578",
              },
            ],
            price: 12619,
            addonCombinations: [
              {
                groupId: "67779756",
                addonId: "41467134",
              },
              {
                groupId: "67779756",
                addonId: "41467136",
              },
              {
                groupId: "67779756",
                addonId: "41467138",
              },
              {
                groupId: "67779756",
                addonId: "41467140",
              },
              {
                groupId: "67779756",
                addonId: "41467142",
              },
              {
                groupId: "67779756",
                addonId: "55402204",
              },
              {
                groupId: "67779756",
                addonId: "54074008",
              },
              {
                groupId: "67779756",
                addonId: "41467143",
              },
              {
                groupId: "67779756",
                addonId: "54074009",
              },
              {
                groupId: "67779756",
                addonId: "41467132",
              },
              {
                groupId: "67779754",
                addonId: "41467145",
              },
              {
                groupId: "67779754",
                addonId: "41467147",
              },
              {
                groupId: "67779754",
                addonId: "41467149",
              },
              {
                groupId: "67779754",
                addonId: "41467151",
              },
              {
                groupId: "67779754",
                addonId: "41467152",
              },
              {
                groupId: "67779754",
                addonId: "41467154",
              },
              {
                groupId: "67779754",
                addonId: "41467156",
              },
              {
                groupId: "67779754",
                addonId: "41467158",
              },
              {
                groupId: "67779754",
                addonId: "41467160",
              },
              {
                groupId: "67779754",
                addonId: "41467162",
              },
              {
                groupId: "67779754",
                addonId: "41467163",
              },
              {
                groupId: "67779754",
                addonId: "41467165",
              },
              {
                groupId: "67779754",
                addonId: "41467167",
              },
              {
                groupId: "67779754",
                addonId: "41467171",
              },
              {
                groupId: "67779752",
                addonId: "41467176",
              },
              {
                groupId: "67779752",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424713",
                variationId: "70437579",
              },
            ],
            price: 16119,
            addonCombinations: [
              {
                groupId: "67779757",
                addonId: "41467132",
              },
              {
                groupId: "67779757",
                addonId: "41467134",
              },
              {
                groupId: "67779757",
                addonId: "41467136",
              },
              {
                groupId: "67779757",
                addonId: "41467138",
              },
              {
                groupId: "67779757",
                addonId: "41467142",
              },
              {
                groupId: "67779757",
                addonId: "41467140",
              },
              {
                groupId: "67779757",
                addonId: "41467143",
              },
              {
                groupId: "67779757",
                addonId: "55402204",
              },
              {
                groupId: "67779757",
                addonId: "54074008",
              },
              {
                groupId: "67779757",
                addonId: "54074009",
              },
              {
                groupId: "67779755",
                addonId: "41467145",
              },
              {
                groupId: "67779755",
                addonId: "41467147",
              },
              {
                groupId: "67779755",
                addonId: "41467149",
              },
              {
                groupId: "67779755",
                addonId: "41467151",
              },
              {
                groupId: "67779755",
                addonId: "41467152",
              },
              {
                groupId: "67779755",
                addonId: "41467154",
              },
              {
                groupId: "67779755",
                addonId: "41467156",
              },
              {
                groupId: "67779755",
                addonId: "41467158",
              },
              {
                groupId: "67779755",
                addonId: "41467160",
              },
              {
                groupId: "67779755",
                addonId: "41467162",
              },
              {
                groupId: "67779755",
                addonId: "41467163",
              },
              {
                groupId: "67779755",
                addonId: "41467165",
              },
              {
                groupId: "67779755",
                addonId: "41467167",
              },
              {
                groupId: "67779755",
                addonId: "41467171",
              },
              {
                groupId: "67779753",
                addonId: "41467176",
              },
              {
                groupId: "67779753",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779752",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate - Milk Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779753",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate Milk Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779754",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate - Milk Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779755",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate Milk Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779756",
          groupName:
            "Choose From Add On for Belgian Chocolate - Milk Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779757",
          groupName:
            "Choose From Add On for Belgian Chocolate Milk Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 12619,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "96295518",
      name: "Belgian Chocolate Dark Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Melted Belgian Dark Chocolate. Darker Simplicity! Energy - 429 KCAL",
      imageId: "h6fkfhuvqiyvh0jw440t",
      inStock: 1,
      isVeg: 1,
      price: 12619,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424714",
            name: "Choose from Belgian Chocolate Dark Mini Pancakes",
            variations: [
              {
                name: "Belgian Chocolate - Dark Mini Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437580",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Belgian Chocolate Dark Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437581",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424714",
                variationId: "70437580",
              },
            ],
            price: 12619,
            addonCombinations: [
              {
                groupId: "67779762",
                addonId: "41467134",
              },
              {
                groupId: "67779762",
                addonId: "41467136",
              },
              {
                groupId: "67779762",
                addonId: "41467138",
              },
              {
                groupId: "67779762",
                addonId: "41467140",
              },
              {
                groupId: "67779762",
                addonId: "41467142",
              },
              {
                groupId: "67779762",
                addonId: "55402204",
              },
              {
                groupId: "67779762",
                addonId: "54074008",
              },
              {
                groupId: "67779762",
                addonId: "41467143",
              },
              {
                groupId: "67779762",
                addonId: "54074009",
              },
              {
                groupId: "67779762",
                addonId: "41467132",
              },
              {
                groupId: "67779760",
                addonId: "41467145",
              },
              {
                groupId: "67779760",
                addonId: "41467147",
              },
              {
                groupId: "67779760",
                addonId: "41467149",
              },
              {
                groupId: "67779760",
                addonId: "41467151",
              },
              {
                groupId: "67779760",
                addonId: "41467152",
              },
              {
                groupId: "67779760",
                addonId: "41467154",
              },
              {
                groupId: "67779760",
                addonId: "41467156",
              },
              {
                groupId: "67779760",
                addonId: "41467158",
              },
              {
                groupId: "67779760",
                addonId: "41467160",
              },
              {
                groupId: "67779760",
                addonId: "41467162",
              },
              {
                groupId: "67779760",
                addonId: "41467163",
              },
              {
                groupId: "67779760",
                addonId: "41467165",
              },
              {
                groupId: "67779760",
                addonId: "41467167",
              },
              {
                groupId: "67779760",
                addonId: "41467171",
              },
              {
                groupId: "67779758",
                addonId: "41467176",
              },
              {
                groupId: "67779758",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424714",
                variationId: "70437581",
              },
            ],
            price: 16119,
            addonCombinations: [
              {
                groupId: "67779763",
                addonId: "41467134",
              },
              {
                groupId: "67779763",
                addonId: "41467136",
              },
              {
                groupId: "67779763",
                addonId: "41467138",
              },
              {
                groupId: "67779763",
                addonId: "41467140",
              },
              {
                groupId: "67779763",
                addonId: "41467142",
              },
              {
                groupId: "67779763",
                addonId: "41467143",
              },
              {
                groupId: "67779763",
                addonId: "55402204",
              },
              {
                groupId: "67779763",
                addonId: "54074009",
              },
              {
                groupId: "67779763",
                addonId: "54074008",
              },
              {
                groupId: "67779763",
                addonId: "41467132",
              },
              {
                groupId: "67779761",
                addonId: "41467145",
              },
              {
                groupId: "67779761",
                addonId: "41467147",
              },
              {
                groupId: "67779761",
                addonId: "41467149",
              },
              {
                groupId: "67779761",
                addonId: "41467151",
              },
              {
                groupId: "67779761",
                addonId: "41467152",
              },
              {
                groupId: "67779761",
                addonId: "41467154",
              },
              {
                groupId: "67779761",
                addonId: "41467156",
              },
              {
                groupId: "67779761",
                addonId: "41467158",
              },
              {
                groupId: "67779761",
                addonId: "41467160",
              },
              {
                groupId: "67779761",
                addonId: "41467162",
              },
              {
                groupId: "67779761",
                addonId: "41467163",
              },
              {
                groupId: "67779761",
                addonId: "41467165",
              },
              {
                groupId: "67779761",
                addonId: "41467167",
              },
              {
                groupId: "67779761",
                addonId: "41467171",
              },
              {
                groupId: "67779759",
                addonId: "41467176",
              },
              {
                groupId: "67779759",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779758",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate - Dark Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779759",
          groupName:
            "Choose From Ice Cream for Belgian Chocolate Dark Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779761",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate Dark Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779760",
          groupName:
            "Choose From Extra Fillings for Belgian Chocolate - Dark Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779762",
          groupName:
            "Choose From Add On for Belgian Chocolate - Dark Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779763",
          groupName:
            "Choose From Add On for Belgian Chocolate Dark Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 12619,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295520",
      name: "Butterscotch Crunch Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Crunchy Butterscotch Fudge. Go On Indulge!  Energy - 417 KCAL",
      imageId: "rw5mpmvuf9pm6cjz2jfg",
      inStock: 1,
      isVeg: 1,
      price: 10857,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424715",
            name: "Choose from Butterscotch Crunch Mini Pancakes",
            variations: [
              {
                name: "Butterscotch Crunch MIni Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437582",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Butterscotch Crunch Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437583",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424715",
                variationId: "70437582",
              },
            ],
            price: 10857,
            addonCombinations: [
              {
                groupId: "67779768",
                addonId: "41467134",
              },
              {
                groupId: "67779768",
                addonId: "41467136",
              },
              {
                groupId: "67779768",
                addonId: "41467138",
              },
              {
                groupId: "67779768",
                addonId: "41467140",
              },
              {
                groupId: "67779768",
                addonId: "41467142",
              },
              {
                groupId: "67779768",
                addonId: "54074008",
              },
              {
                groupId: "67779768",
                addonId: "55402204",
              },
              {
                groupId: "67779768",
                addonId: "54074009",
              },
              {
                groupId: "67779768",
                addonId: "41467143",
              },
              {
                groupId: "67779768",
                addonId: "41467132",
              },
              {
                groupId: "67779766",
                addonId: "41467145",
              },
              {
                groupId: "67779766",
                addonId: "41467147",
              },
              {
                groupId: "67779766",
                addonId: "41467149",
              },
              {
                groupId: "67779766",
                addonId: "41467151",
              },
              {
                groupId: "67779766",
                addonId: "41467152",
              },
              {
                groupId: "67779766",
                addonId: "41467154",
              },
              {
                groupId: "67779766",
                addonId: "41467156",
              },
              {
                groupId: "67779766",
                addonId: "41467158",
              },
              {
                groupId: "67779766",
                addonId: "41467160",
              },
              {
                groupId: "67779766",
                addonId: "41467162",
              },
              {
                groupId: "67779766",
                addonId: "41467163",
              },
              {
                groupId: "67779766",
                addonId: "41467165",
              },
              {
                groupId: "67779766",
                addonId: "41467167",
              },
              {
                groupId: "67779766",
                addonId: "41467171",
              },
              {
                groupId: "67779764",
                addonId: "41467176",
              },
              {
                groupId: "67779764",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424715",
                variationId: "70437583",
              },
            ],
            price: 14357,
            addonCombinations: [
              {
                groupId: "67779769",
                addonId: "41467132",
              },
              {
                groupId: "67779769",
                addonId: "41467134",
              },
              {
                groupId: "67779769",
                addonId: "41467136",
              },
              {
                groupId: "67779769",
                addonId: "41467138",
              },
              {
                groupId: "67779769",
                addonId: "41467140",
              },
              {
                groupId: "67779769",
                addonId: "41467142",
              },
              {
                groupId: "67779769",
                addonId: "41467143",
              },
              {
                groupId: "67779769",
                addonId: "55402204",
              },
              {
                groupId: "67779769",
                addonId: "54074008",
              },
              {
                groupId: "67779769",
                addonId: "54074009",
              },
              {
                groupId: "67779767",
                addonId: "41467145",
              },
              {
                groupId: "67779767",
                addonId: "41467147",
              },
              {
                groupId: "67779767",
                addonId: "41467149",
              },
              {
                groupId: "67779767",
                addonId: "41467151",
              },
              {
                groupId: "67779767",
                addonId: "41467152",
              },
              {
                groupId: "67779767",
                addonId: "41467154",
              },
              {
                groupId: "67779767",
                addonId: "41467156",
              },
              {
                groupId: "67779767",
                addonId: "41467158",
              },
              {
                groupId: "67779767",
                addonId: "41467160",
              },
              {
                groupId: "67779767",
                addonId: "41467162",
              },
              {
                groupId: "67779767",
                addonId: "41467163",
              },
              {
                groupId: "67779767",
                addonId: "41467165",
              },
              {
                groupId: "67779767",
                addonId: "41467167",
              },
              {
                groupId: "67779767",
                addonId: "41467171",
              },
              {
                groupId: "67779765",
                addonId: "41467176",
              },
              {
                groupId: "67779765",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779765",
          groupName:
            "Choose From Ice Cream for Butterscotch Crunch Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779764",
          groupName:
            "Choose From Ice Cream for Butterscotch Crunch MIni Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779767",
          groupName:
            "Choose From Extra Fillings for Butterscotch Crunch Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779766",
          groupName:
            "Choose From Extra Fillings for Butterscotch Crunch MIni Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779769",
          groupName:
            "Choose From Add On for Butterscotch Crunch Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779768",
          groupName:
            "Choose From Add On for Butterscotch Crunch MIni Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 10857,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295522",
      name: "Coffee Mocha Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Melted Chocolate Infused With Coffee Crumbs. For Coffee Lovers!  Energy - 427 KCAL",
      imageId: "damkqlpa8gpau4fhfase",
      inStock: 1,
      isVeg: 1,
      price: 11619,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424716",
            name: "Choose from Coffee Mocha Mini Pancakes",
            variations: [
              {
                name: "Coffee Mocha Mini Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437584",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Coffee Mocha Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437585",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424716",
                variationId: "70437584",
              },
            ],
            price: 11619,
            addonCombinations: [
              {
                groupId: "67779774",
                addonId: "41467134",
              },
              {
                groupId: "67779774",
                addonId: "41467136",
              },
              {
                groupId: "67779774",
                addonId: "41467138",
              },
              {
                groupId: "67779774",
                addonId: "41467140",
              },
              {
                groupId: "67779774",
                addonId: "41467142",
              },
              {
                groupId: "67779774",
                addonId: "54074008",
              },
              {
                groupId: "67779774",
                addonId: "55402204",
              },
              {
                groupId: "67779774",
                addonId: "54074009",
              },
              {
                groupId: "67779774",
                addonId: "41467143",
              },
              {
                groupId: "67779774",
                addonId: "41467132",
              },
              {
                groupId: "67779772",
                addonId: "41467145",
              },
              {
                groupId: "67779772",
                addonId: "41467147",
              },
              {
                groupId: "67779772",
                addonId: "41467149",
              },
              {
                groupId: "67779772",
                addonId: "41467151",
              },
              {
                groupId: "67779772",
                addonId: "41467152",
              },
              {
                groupId: "67779772",
                addonId: "41467154",
              },
              {
                groupId: "67779772",
                addonId: "41467156",
              },
              {
                groupId: "67779772",
                addonId: "41467158",
              },
              {
                groupId: "67779772",
                addonId: "41467160",
              },
              {
                groupId: "67779772",
                addonId: "41467162",
              },
              {
                groupId: "67779772",
                addonId: "41467163",
              },
              {
                groupId: "67779772",
                addonId: "41467165",
              },
              {
                groupId: "67779772",
                addonId: "41467167",
              },
              {
                groupId: "67779772",
                addonId: "41467171",
              },
              {
                groupId: "67779770",
                addonId: "41467176",
              },
              {
                groupId: "67779770",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424716",
                variationId: "70437585",
              },
            ],
            price: 15119,
            addonCombinations: [
              {
                groupId: "67779775",
                addonId: "41467134",
              },
              {
                groupId: "67779775",
                addonId: "41467136",
              },
              {
                groupId: "67779775",
                addonId: "41467138",
              },
              {
                groupId: "67779775",
                addonId: "41467140",
              },
              {
                groupId: "67779775",
                addonId: "41467142",
              },
              {
                groupId: "67779775",
                addonId: "41467143",
              },
              {
                groupId: "67779775",
                addonId: "55402204",
              },
              {
                groupId: "67779775",
                addonId: "54074008",
              },
              {
                groupId: "67779775",
                addonId: "54074009",
              },
              {
                groupId: "67779775",
                addonId: "41467132",
              },
              {
                groupId: "67779773",
                addonId: "41467145",
              },
              {
                groupId: "67779773",
                addonId: "41467147",
              },
              {
                groupId: "67779773",
                addonId: "41467149",
              },
              {
                groupId: "67779773",
                addonId: "41467151",
              },
              {
                groupId: "67779773",
                addonId: "41467152",
              },
              {
                groupId: "67779773",
                addonId: "41467154",
              },
              {
                groupId: "67779773",
                addonId: "41467156",
              },
              {
                groupId: "67779773",
                addonId: "41467158",
              },
              {
                groupId: "67779773",
                addonId: "41467160",
              },
              {
                groupId: "67779773",
                addonId: "41467162",
              },
              {
                groupId: "67779773",
                addonId: "41467163",
              },
              {
                groupId: "67779773",
                addonId: "41467165",
              },
              {
                groupId: "67779773",
                addonId: "41467167",
              },
              {
                groupId: "67779773",
                addonId: "41467171",
              },
              {
                groupId: "67779771",
                addonId: "41467176",
              },
              {
                groupId: "67779771",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779770",
          groupName:
            "Choose From Ice Cream for Coffee Mocha Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779771",
          groupName:
            "Choose From Ice Cream for Coffee Mocha Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779772",
          groupName:
            "Choose From Extra Fillings for Coffee Mocha Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779773",
          groupName:
            "Choose From Extra Fillings for Coffee Mocha Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779774",
          groupName:
            "Choose From Add On for Coffee Mocha Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779775",
          groupName:
            "Choose From Add On for Coffee Mocha Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 11619,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96295543",
      name: "Kitkat Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Melted Belgian White Chocolate And KitKat Bits. For KitKat Lovers!  Energy - 441 KCAL",
      imageId: "l7yi6boabhzow3f4nxcu",
      inStock: 1,
      isVeg: 1,
      price: 13571,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424726",
            name: "Choose from Kitkat Mini Pancakes",
            variations: [
              {
                name: "Kit Kat Mini Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437597",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "KitKat Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437598",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424726",
                variationId: "70437597",
              },
            ],
            price: 13571,
            addonCombinations: [
              {
                groupId: "67779813",
                addonId: "41467134",
              },
              {
                groupId: "67779813",
                addonId: "41467136",
              },
              {
                groupId: "67779813",
                addonId: "41467138",
              },
              {
                groupId: "67779813",
                addonId: "41467140",
              },
              {
                groupId: "67779813",
                addonId: "41467142",
              },
              {
                groupId: "67779813",
                addonId: "55402204",
              },
              {
                groupId: "67779813",
                addonId: "54074008",
              },
              {
                groupId: "67779813",
                addonId: "41467143",
              },
              {
                groupId: "67779813",
                addonId: "54074009",
              },
              {
                groupId: "67779813",
                addonId: "41467132",
              },
              {
                groupId: "67779811",
                addonId: "41467145",
              },
              {
                groupId: "67779811",
                addonId: "41467147",
              },
              {
                groupId: "67779811",
                addonId: "41467149",
              },
              {
                groupId: "67779811",
                addonId: "41467151",
              },
              {
                groupId: "67779811",
                addonId: "41467152",
              },
              {
                groupId: "67779811",
                addonId: "41467154",
              },
              {
                groupId: "67779811",
                addonId: "41467156",
              },
              {
                groupId: "67779811",
                addonId: "41467158",
              },
              {
                groupId: "67779811",
                addonId: "41467160",
              },
              {
                groupId: "67779811",
                addonId: "41467162",
              },
              {
                groupId: "67779811",
                addonId: "41467163",
              },
              {
                groupId: "67779811",
                addonId: "41467165",
              },
              {
                groupId: "67779811",
                addonId: "41467171",
              },
              {
                groupId: "67779811",
                addonId: "41467167",
              },
              {
                groupId: "67779809",
                addonId: "41467176",
              },
              {
                groupId: "67779809",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424726",
                variationId: "70437598",
              },
            ],
            price: 17071,
            addonCombinations: [
              {
                groupId: "67779814",
                addonId: "41467132",
              },
              {
                groupId: "67779814",
                addonId: "41467136",
              },
              {
                groupId: "67779814",
                addonId: "41467138",
              },
              {
                groupId: "67779814",
                addonId: "41467140",
              },
              {
                groupId: "67779814",
                addonId: "41467142",
              },
              {
                groupId: "67779814",
                addonId: "41467143",
              },
              {
                groupId: "67779814",
                addonId: "55402204",
              },
              {
                groupId: "67779814",
                addonId: "54074008",
              },
              {
                groupId: "67779814",
                addonId: "54074009",
              },
              {
                groupId: "67779814",
                addonId: "41467134",
              },
              {
                groupId: "67779812",
                addonId: "41467145",
              },
              {
                groupId: "67779812",
                addonId: "41467147",
              },
              {
                groupId: "67779812",
                addonId: "41467149",
              },
              {
                groupId: "67779812",
                addonId: "41467151",
              },
              {
                groupId: "67779812",
                addonId: "41467152",
              },
              {
                groupId: "67779812",
                addonId: "41467154",
              },
              {
                groupId: "67779812",
                addonId: "41467156",
              },
              {
                groupId: "67779812",
                addonId: "41467158",
              },
              {
                groupId: "67779812",
                addonId: "41467160",
              },
              {
                groupId: "67779812",
                addonId: "41467162",
              },
              {
                groupId: "67779812",
                addonId: "41467163",
              },
              {
                groupId: "67779812",
                addonId: "41467165",
              },
              {
                groupId: "67779812",
                addonId: "41467167",
              },
              {
                groupId: "67779812",
                addonId: "41467171",
              },
              {
                groupId: "67779810",
                addonId: "41467176",
              },
              {
                groupId: "67779810",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779809",
          groupName:
            "Choose From Ice Cream for Kit Kat Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779810",
          groupName:
            "Choose From Ice Cream for KitKat Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779811",
          groupName:
            "Choose From Extra Fillings for Kit Kat Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779812",
          groupName:
            "Choose From Extra Fillings for KitKat Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779813",
          groupName:
            "Choose From Add On for Kit Kat Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779814",
          groupName:
            "Choose From Add On for KitKat Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 13571,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "96295544",
      name: "Naked Nutella Mini Pancakes",
      category: "Mini Pancakes",
      description:
        "Serves 1 | Serves 1 | Classic Crispy Mini Pancakes + Premium European Chocolate Hazelnut Spread (Add Banana If You Like). A Universal Favourite!  Energy - 418 KCAL",
      imageId: "kpbsnny0wersugehn7qm",
      inStock: 1,
      isVeg: 1,
      price: 16619,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "21424717",
            name: "Choose from Naked Nutella Mini Pancakes",
            variations: [
              {
                name: "Naked Nutella Mini Pancakes (Regular Batter) (8 Pieces)",
                default: 1,
                id: "70437586",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Naked Nutella Mini Pancakes (Almond Flour Batter) (8 Pieces)",
                price: 35,
                id: "70437587",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "21424717",
                variationId: "70437586",
              },
            ],
            price: 16619,
            addonCombinations: [
              {
                groupId: "67779780",
                addonId: "41467134",
              },
              {
                groupId: "67779780",
                addonId: "41467136",
              },
              {
                groupId: "67779780",
                addonId: "41467138",
              },
              {
                groupId: "67779780",
                addonId: "41467140",
              },
              {
                groupId: "67779780",
                addonId: "41467142",
              },
              {
                groupId: "67779780",
                addonId: "55402204",
              },
              {
                groupId: "67779780",
                addonId: "54074008",
              },
              {
                groupId: "67779780",
                addonId: "41467143",
              },
              {
                groupId: "67779780",
                addonId: "54074009",
              },
              {
                groupId: "67779780",
                addonId: "41467132",
              },
              {
                groupId: "67779778",
                addonId: "41467145",
              },
              {
                groupId: "67779778",
                addonId: "41467147",
              },
              {
                groupId: "67779778",
                addonId: "41467149",
              },
              {
                groupId: "67779778",
                addonId: "41467151",
              },
              {
                groupId: "67779778",
                addonId: "41467152",
              },
              {
                groupId: "67779778",
                addonId: "41467154",
              },
              {
                groupId: "67779778",
                addonId: "41467156",
              },
              {
                groupId: "67779778",
                addonId: "41467158",
              },
              {
                groupId: "67779778",
                addonId: "41467160",
              },
              {
                groupId: "67779778",
                addonId: "41467162",
              },
              {
                groupId: "67779778",
                addonId: "41467163",
              },
              {
                groupId: "67779778",
                addonId: "41467165",
              },
              {
                groupId: "67779778",
                addonId: "41467167",
              },
              {
                groupId: "67779778",
                addonId: "41467171",
              },
              {
                groupId: "67779776",
                addonId: "41467176",
              },
              {
                groupId: "67779776",
                addonId: "41467178",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "21424717",
                variationId: "70437587",
              },
            ],
            price: 20119,
            addonCombinations: [
              {
                groupId: "67779781",
                addonId: "41467136",
              },
              {
                groupId: "67779781",
                addonId: "41467132",
              },
              {
                groupId: "67779781",
                addonId: "41467138",
              },
              {
                groupId: "67779781",
                addonId: "41467140",
              },
              {
                groupId: "67779781",
                addonId: "41467142",
              },
              {
                groupId: "67779781",
                addonId: "41467143",
              },
              {
                groupId: "67779781",
                addonId: "55402204",
              },
              {
                groupId: "67779781",
                addonId: "54074008",
              },
              {
                groupId: "67779781",
                addonId: "54074009",
              },
              {
                groupId: "67779781",
                addonId: "41467134",
              },
              {
                groupId: "67779779",
                addonId: "41467145",
              },
              {
                groupId: "67779779",
                addonId: "41467147",
              },
              {
                groupId: "67779779",
                addonId: "41467149",
              },
              {
                groupId: "67779779",
                addonId: "41467151",
              },
              {
                groupId: "67779779",
                addonId: "41467152",
              },
              {
                groupId: "67779779",
                addonId: "41467154",
              },
              {
                groupId: "67779779",
                addonId: "41467156",
              },
              {
                groupId: "67779779",
                addonId: "41467158",
              },
              {
                groupId: "67779779",
                addonId: "41467160",
              },
              {
                groupId: "67779779",
                addonId: "41467162",
              },
              {
                groupId: "67779779",
                addonId: "41467163",
              },
              {
                groupId: "67779779",
                addonId: "41467165",
              },
              {
                groupId: "67779779",
                addonId: "41467167",
              },
              {
                groupId: "67779779",
                addonId: "41467171",
              },
              {
                groupId: "67779777",
                addonId: "41467176",
              },
              {
                groupId: "67779777",
                addonId: "41467178",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "67779776",
          groupName:
            "Choose From Ice Cream for Naked Nutella Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779777",
          groupName:
            "Choose From Ice Cream for Naked Nutella Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779778",
          groupName:
            "Choose From Extra Fillings for Naked Nutella Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779779",
          groupName:
            "Choose From Extra Fillings for Naked Nutella Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467145",
              name: "Extra Milk Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467147",
              name: "Extra Dark Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467149",
              name: "Extra White Chocolate",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467151",
              name: "Extra Butterscotch Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467152",
              name: "Extra Coffee Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467154",
              name: "Extra Peanut Butter Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467156",
              name: "Extra Blueberry Filling",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467158",
              name: "Extra Strawberry Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467160",
              name: "Extra Honey",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467162",
              name: "Extra Maple Syrup",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467163",
              name: "Extra Cream Cheese",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467165",
              name: "Extra Nutella",
              price: 7071,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467167",
              name: "Extra Kiki Cream Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467171",
              name: "Extra Almond Cocoa Filling",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 14,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779780",
          groupName:
            "Choose From Add On for Naked Nutella Mini Pancakes (Regular Batter) (8 Pieces)",
          choices: [
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "67779781",
          groupName:
            "Choose From Add On for Naked Nutella Mini Pancakes (Almond Flour Batter) (8 Pieces)",
          choices: [
            {
              id: "41467136",
              name: "Extra Fudge Sauce",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467132",
              name: "Extra Roasted Almond",
              price: 4024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467138",
              name: "Extra KitKat Bits",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467140",
              name: "Extra Oreos",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467142",
              name: "Extra Chocolate Sprinkles",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467143",
              name: "Biscoff Biscuit",
              price: 3048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55402204",
              name: "Extra Seasalt",
              price: 952,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074008",
              name: "Extra Ice Cream & Fudge Vanilla",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "54074009",
              name: "Extra Ice Cream & Fudge Chocolate",
              price: 6024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467134",
              name: "Extra Bananas",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      defaultPrice: 16619,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
  ],
  Stroopwafels: [
    {
      id: "70435437",
      name: "Stroopwafel x 4",
      category: "Stroopwafels",
      description:
        "Serves 1 | Serves 2-3  | Introducing new thin and crispy waffle cookie sandwiched and drizzled with delicious chocolate! Pick any 4 of your choice. Energy - 525 Kcal per item",
      imageId: "ci4dy1cbkzfobsfdapem",
      inStock: 1,
      isVeg: 1,
      price: 35040,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75674337",
          groupName: "Stroopwafel 1",
          choices: [
            {
              id: "60670814",
              name: "The Red Dutchess Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670815",
              name: "Sir Chocolat Milk Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670810",
              name: "Sir Chocolat Dark Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670811",
              name: "Sir Chocolat White Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670812",
              name: "Kiki and Cream Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670813",
              name: "Voila Nutella with Sea Salt Stroopwafel",
              price: 2100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "75674338",
          groupName: "Stroopwafel 2",
          choices: [
            {
              id: "60670814",
              name: "The Red Dutchess Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670815",
              name: "Sir Chocolat Milk Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670810",
              name: "Sir Chocolat Dark Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670811",
              name: "Sir Chocolat White Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670812",
              name: "Kiki and Cream Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670813",
              name: "Voila Nutella with Sea Salt Stroopwafel",
              price: 2100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "75674339",
          groupName: "Stroopwafel 3",
          choices: [
            {
              id: "60670814",
              name: "The Red Dutchess Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670815",
              name: "Sir Chocolat Milk Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670810",
              name: "Sir Chocolat Dark Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670811",
              name: "Sir Chocolat White Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670812",
              name: "Kiki and Cream Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670813",
              name: "Voila Nutella with Sea Salt Stroopwafel",
              price: 2100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "75674340",
          groupName: "Stroopwafel 4",
          choices: [
            {
              id: "60670814",
              name: "The Red Dutchess Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670815",
              name: "Sir Chocolat Milk Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670810",
              name: "Sir Chocolat Dark Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670811",
              name: "Sir Chocolat White Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670812",
              name: "Kiki and Cream Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670813",
              name: "Voila Nutella with Sea Salt Stroopwafel",
              price: 2100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "75674341",
          groupName: "Choose From Ice Cream for Stroopwafel x 4",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75674342",
          groupName: "Choose From Add On for Stroopwafel x 4",
          choices: [
            {
              id: "60670793",
              name: "Extra Roasted Almond (SW)",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670794",
              name: "Biscoff Biscuit (Stroopwafel)",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670795",
              name: "Extra Oreos (SW)",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 3,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "70435513",
      name: "Stroopwafel x 2",
      category: "Stroopwafels",
      description:
        "Serves 1 | Serves 2 | Introducing new thin and crispy waffle cookie sandwiched and drizzled with delicious chocolate! Pick any 2 of your choice. Energy - 525 Kcal per item",
      imageId: "ci4dy1cbkzfobsfdapem",
      inStock: 1,
      isVeg: 1,
      price: 17520,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75674333",
          groupName: "Stroopwafel 1",
          choices: [
            {
              id: "60670814",
              name: "The Red Dutchess Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670815",
              name: "Sir Chocolat Milk Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670811",
              name: "Sir Chocolat White Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670812",
              name: "Kiki and Cream Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670810",
              name: "Sir Chocolat Dark Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670813",
              name: "Voila Nutella with Sea Salt Stroopwafel",
              price: 2100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "75674334",
          groupName: "Stroopwafel 2",
          choices: [
            {
              id: "60670814",
              name: "The Red Dutchess Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670815",
              name: "Sir Chocolat Milk Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670811",
              name: "Sir Chocolat White Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670812",
              name: "Kiki and Cream Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670810",
              name: "Sir Chocolat Dark Stroopwafel",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670813",
              name: "Voila Nutella with Sea Salt Stroopwafel",
              price: 2100,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "75674335",
          groupName: "Choose From Ice Cream for Stroopwafel x 2",
          choices: [
            {
              id: "41467176",
              name: "Extra Ice Cream Cup (Vanilla)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "41467178",
              name: "Extra Ice Cream Cup (Chocolate)",
              price: 5048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75674336",
          groupName: "Choose From Add On for Stroopwafel x 2",
          choices: [
            {
              id: "60670793",
              name: "Extra Roasted Almond (SW)",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670794",
              name: "Biscoff Biscuit (Stroopwafel)",
              price: 2024,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "60670795",
              name: "Extra Oreos (SW)",
              price: 1048,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 3,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662562",
      name: "Stroopwafel Box Of 6 - Chocolate",
      category: "Stroopwafels",
      description:
        "Serves 1 | Serves 4-5  | Indulge in our newly launched stroopwafels. The chocolate pack of 6 includes 2 pieces of Sir Chocolate Dark, Sir Chocolat Milk and Voila Nutella. Energy - 525 Kcal per item",
      imageId: "tvusx7fuwum5jlmb8qvn",
      inStock: 1,
      isVeg: 1,
      price: 53333,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92662564",
      name: "Stroopwafel Box Of 6 - Assorted",
      category: "Stroopwafels",
      description:
        "Serves 1 | Serves 4-5  | Indulge in our newly launched stroopwafels. The assorted pack of 6 includes Sir Chocolat Milk, Sir Chocolate Dark, Sir Chocolat White, The Red Dutchess, Voila Nutella and Kiki and Oreo Cream. Energy - 525 Kcal per item",
      imageId: "ltaqlgi5nva7busgj9mi",
      inStock: 1,
      isVeg: 1,
      price: 51429,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "0 gram",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[newModernCafe] = {
  "Our Special Dosa": [
    {
      id: "7555887",
      name: "Special Set Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7555889",
      name: "Schezwan Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7555890",
      name: "Spring Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "7555891",
      name: "Methi Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555892",
      name: "Neer Dosa",
      category: "Our Special Dosa",
      description:
        "Super-Thin And Soft 2 Neer Dosas With Coconut Chutney And Sambhar",
      imageId: "b2ed27b09e456c626c30d73ed323982e",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "38 ratings",
          ratingCountV2: "38",
        },
      },
    },
    {
      id: "7555894",
      name: "Palak Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "96974754",
      name: "Schezwan Masala Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96974761",
      name: "Nachni Masala Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "96974762",
      name: "Nachni Sada Dosa",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "112072039",
      name: "Cheese Garlic Uttappam",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072050",
      name: "Pizza Uttappam",
      category: "Our Special Dosa",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "South Indian Snacks": [
    {
      id: "7555841",
      name: "Medu Vada",
      category: "South Indian Snacks",
      description:
        "Serves 1, A Delectable Meal With Crunchy 2 Pieces Vada Served With Coconut Chutney And Sambhar",
      imageId: "91b139d26bb366d8fdaef8e1d7370c1e",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "333 ratings",
          ratingCountV2: "333",
        },
      },
    },
    {
      id: "7555842",
      name: "Steamed Idli",
      category: "South Indian Snacks",
      description:
        "Serves 1,Super-Soft, Melt-In-The-Mouth 2 Idlis Steamed To Perfection, Served With Coconut Chutney And Sambhar.",
      imageId: "9b5e14f0294a6a059a68f548bb16c88f",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "222 ratings",
          ratingCountV2: "222",
        },
      },
    },
    {
      id: "7555845",
      name: "Potato Vada",
      category: "South Indian Snacks",
      description:
        "Serves 1,A Delightful Breakfast Crispy Vada (2Pcs),Served Along With Sambhar And Coconut Chutney.",
      imageId: "09a2fd0a24b1e5f367fcd4bc5eae9a6b",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "43 ratings",
          ratingCountV2: "43",
        },
      },
    },
    {
      id: "7555846",
      name: "Rasam Vada",
      category: "South Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "7555847",
      name: "Veg Samosa",
      category: "South Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "7555848",
      name: "Punjabi Samosa",
      category: "South Indian Snacks",
      imageId: "4a6af56e5418aa13a4ea8807088f0a87",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "7555849",
      name: "Veg Cutlet",
      category: "South Indian Snacks",
      description:
        "Serves 1,A Delightful Dish With Assorted Veggies Packed In A Crispy Outer Coating And Served Along With Delectable Dips (2Pcs).",
      imageId: "462116d3833c42de43153006a2a38a55",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "74 ratings",
          ratingCountV2: "74",
        },
      },
    },
    {
      id: "7555862",
      name: "Misal Pav",
      category: "South Indian Snacks",
      description:
        "Maharashtrian Delicacy With Dry Subji Topped With Flavorsome Gravy Served With Soft 2 Pav",
      imageId: "e36ec7f905c4d85c3c8a2f5cfa58a946",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "73 ratings",
          ratingCountV2: "73",
        },
      },
    },
    {
      id: "112071793",
      name: "Dahi Idli",
      category: "South Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112071803",
      name: "Idli Wada",
      category: "South Indian Snacks",
      description:
        "The soft fluffy idlis along with the fresh crispy vada served with spicy hot sambar and chutney",
      imageId: "bbd75ede67a4b2e88fde659f31ad20ce",
      inStock: 1,
      isVeg: 1,
      price: 8700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "112071806",
      name: "Idli Fry",
      category: "South Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112071819",
      name: "Potato Chips [snacks]",
      category: "South Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112071869",
      name: "Sheera",
      category: "South Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "112071880",
      name: "Upma (morning)",
      category: "South Indian Snacks",
      imageId: "0f1fd4b2a908ef1cb59cd19bc844a001",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "55 ratings",
          ratingCountV2: "55",
        },
      },
    },
    {
      id: "112071881",
      name: "Usal Pav",
      category: "South Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Dosa Varieties": [
    {
      id: "7555863",
      name: "Sada Dosa",
      category: "Dosa Varieties",
      description:
        "Serves 1,Tawa- Toasted, Crispydosas, Made From Rice Batter And Served With Coconut Chutney And Sambhar.",
      imageId: "dda3b00c96c4a8aa80154609ff4573a9",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686672",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "86 ratings",
          ratingCountV2: "86",
        },
      },
    },
    {
      id: "7555864",
      name: "Masala Dosa",
      category: "Dosa Varieties",
      description:
        "Serves 1, Thin And Crispy Dosa Served With Coconut Chutney And Sambhar",
      imageId: "c5f10a877d333e59f57ae5cc916d17b5",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686493",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "203 ratings",
          ratingCountV2: "203",
        },
      },
    },
    {
      id: "7555865",
      name: "Rava Sada Dosa",
      category: "Dosa Varieties",
      imageId: "cf3790e17b81111fc10dbc45c7899a7b",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686643",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "35 ratings",
          ratingCountV2: "35",
        },
      },
    },
    {
      id: "7555866",
      name: "Rava Masala Dosa",
      category: "Dosa Varieties",
      imageId: "b34ea14e41fb80481e5b525fbe11267a",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686614",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "59 ratings",
          ratingCountV2: "59",
        },
      },
    },
    {
      id: "7555867",
      name: "Onion Rava Sada Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686502",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7555868",
      name: "Onion Rava Masala Dosa",
      category: "Dosa Varieties",
      description:
        "Crispy Rava Dosa With Crunchy Onion Folded Inside It,Served With Sambhar And Coconut Chutney",
      imageId: "08edcd2f32a6cfd60d46ef4f99ee9810",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686497",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "22 ratings",
          ratingCountV2: "22",
        },
      },
    },
    {
      id: "7555870",
      name: "Ghee Banana Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686490",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "7555871",
      name: "Uttapam",
      category: "Dosa Varieties",
      imageId: "e5bed0f42c61666b34e46e40cbcac5d3",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686712",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "7555872",
      name: "Masala Uttapam",
      category: "Dosa Varieties",
      imageId: "24bf0a6d691eb79bd6fe9df62214aa52",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686494",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "7555873",
      name: "Coconut Uttapam",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686489",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555878",
      name: "Mysore Sada Dosa",
      category: "Dosa Varieties",
      imageId: "292d9227f6aeb8260273d12bdff80755",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686496",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "7555879",
      name: "Mysore Masala Dosa",
      category: "Dosa Varieties",
      description:
        "Spicy Dosa In A Red Chutney Spread And Maasala Folded In And Served With Coconuts Chutney And Sambhar",
      imageId: "9dcb314ff8e35ea9626ff99a70e6abd2",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686495",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "90 ratings",
          ratingCountV2: "90",
        },
      },
    },
    {
      id: "7555882",
      name: "Paper Sada Dosa",
      category: "Dosa Varieties",
      imageId: "03c08ce8c54539493b5dda58318a85f2",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686612",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "7555883",
      name: "Paper Masala Dosa",
      category: "Dosa Varieties",
      description:
        "Serves 1,A Delightfully Flavorsome Combo With Mouthwatering Paper Masala Dosa Served Along With Chutney And Sambhar.",
      imageId: "14314d06e543d95a897c5070a552368b",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686560",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "7555884",
      name: "Ghee Paper Sada Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686492",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555885",
      name: "Ghee Paper Masala Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686491",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "93263504",
      name: "Tomato Onion Uttapam",
      category: "Dosa Varieties",
      imageId: "bc52c244473229a886a83cf58ca070ad",
      inStock: 1,
      isVeg: 1,
      price: 12200,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686702",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "28 ratings",
          ratingCountV2: "28",
        },
      },
    },
    {
      id: "93263505",
      name: "Onion Uttapam",
      category: "Dosa Varieties",
      description:
        "Nicely Chopped Onions And Tomatoes Spread Over Pancakes Made From Lentil And Rice Batter And Served With Cocount Chutney And Sambhar",
      imageId: "8d7dd2114925a79bf5ac3f800682ee92",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686555",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "112 ratings",
          ratingCountV2: "112",
        },
      },
    },
    {
      id: "112072027",
      name: "Tomato Omlat Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686677",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "112072038",
      name: "Tomato Uttappam",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81686703",
          groupName: "Dosa Variety Add On",
          choices: [
            {
              id: "66223692",
              name: "Extra Ghee",
              price: 3000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66223693",
              name: "Extra Cheese",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800646",
      name: "Ghee Masala Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800647",
      name: "Ghee Uttappam Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800648",
      name: "Ghee Sada Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800649",
      name: "Ghee Onion Rava",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800651",
      name: "Ghee Mysore Masala Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800652",
      name: "Ghee Rava Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800653",
      name: "Ghee Tomato Uttappam",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800654",
      name: "Ghee Tomato Onion Uttappm",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800656",
      name: "Ghee Onion Uttappam",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112800657",
      name: "Ghee Mysore Sada Dosa",
      category: "Dosa Varieties",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Pav Bhaji": [
    {
      id: "7555927",
      name: "Special Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555928",
      name: "Cheese Pav Bhaji",
      category: "Pav Bhaji",
      description:
        "Cheese Pav Bhaji Recipe is cooked with lots of Healthy Boiled Vegetables and flavored and topped with a good amount of grated cheese.",
      imageId: "257db8bcc081f55ec2a4f3a66e0c3eab",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "74 ratings",
          ratingCountV2: "74",
        },
      },
    },
    {
      id: "7555930",
      name: "Jain Pav Bhaji",
      category: "Pav Bhaji",
      imageId: "7c68efbb8df1424fabe3e933ed025088",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "37 ratings",
          ratingCountV2: "37",
        },
      },
    },
    {
      id: "7555931",
      name: "Jain Cheese Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7555932",
      name: "Khada Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7555933",
      name: "Khada Cheese Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7555934",
      name: "Masala Pav (2 Pcs)",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "7555935",
      name: "Cheese Masala Pav (2 Pcs)",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "68014533",
      name: "Extra Butter Pav",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 1200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "207 ratings",
          ratingCountV2: "207",
        },
      },
    },
    {
      id: "96766173",
      name: "Pav Bhaji",
      category: "Pav Bhaji",
      description:
        "Serves 1,An All-Time Favorite Dish Of Mumbaikar Made With Indian Spices And Assorted Vegetables, With A Dollop Of Butter And Served With Super Soft Pav (2Pcs).",
      imageId: "e7e41c84babc6e6820d01ca53dbd4fb6",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "278 ratings",
          ratingCountV2: "278",
        },
      },
    },
    {
      id: "112072073",
      name: "Jain Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072084",
      name: "Khada Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072096",
      name: "Only Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072113",
      name: "Tawa Paneer Pulav",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072114",
      name: "Tawa Pulav",
      category: "Pav Bhaji",
      imageId: "c663a8597dd1d7f4c0b9ab41b16f9a87",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112237679",
      name: "Sada Pav",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
  ],
  Pakoda: [
    {
      id: "67844833",
      name: "Cheese Pakoda",
      category: "Pakoda",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "67844837",
      name: "Onion Pakoda",
      category: "Pakoda",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "67844842",
      name: "Potato Pakoda",
      category: "Pakoda",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "67844845",
      name: "Paneer Pakoda",
      category: "Pakoda",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "112072115",
      name: "Onion Mix Pakoda",
      category: "Pakoda",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072126",
      name: "Potato Mix Pakoda",
      category: "Pakoda",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Upwas Ke Liye": [
    {
      id: "7555852",
      name: "Potato Chips",
      category: "Upwas Ke Liye",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "35 ratings",
          ratingCountV2: "35",
        },
      },
    },
    {
      id: "7555895",
      name: "Sabudana Dosa",
      category: "Upwas Ke Liye",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "7555898",
      name: "Sweet Kachori",
      category: "Upwas Ke Liye",
      description:
        "Sweet kachori is a deep fried snack with sweet lip smacking filling inside. And best as an evening snack or tea time snack.",
      imageId: "2fc6a20bf62d24fa140da14bd30fccd1",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "35 ratings",
          ratingCountV2: "35",
        },
      },
    },
    {
      id: "7555899",
      name: "Sabudana Vada",
      category: "Upwas Ke Liye",
      imageId: "7a84d539cf422f26bcbd85531e97af62",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "60 ratings",
          ratingCountV2: "60",
        },
      },
    },
  ],
  Sandwich: [
    {
      id: "7555902",
      name: "Veg Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688987",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "34 ratings",
          ratingCountV2: "34",
        },
      },
    },
    {
      id: "7555904",
      name: "Veg Toast Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 9200,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81689022",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "7555908",
      name: "Cheese Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 12300,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687927",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7555909",
      name: "Cheese Veg Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 12700,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687982",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7555910",
      name: "Cheese Toast Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687948",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555911",
      name: "Russian Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688652",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555912",
      name: "Italian Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688283",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410944",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410945",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7555913",
      name: "Club Sandwich",
      category: "Sandwich",
      description:
        "Serves 1, A Three Layered Sandwich With Loaded With Cheese And Veggies, Served With Chutneys",
      imageId: "76e2cda53fd5fc813c08ad7d989dd5d7",
      inStock: 1,
      isVeg: 1,
      price: 12700,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688063",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410944",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410945",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "70 ratings",
          ratingCountV2: "70",
        },
      },
    },
    {
      id: "7555914",
      name: "Bread Butter",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687601",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410944",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410945",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7555915",
      name: "Toast Butter",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688677",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410944",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410945",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555916",
      name: "Bread Butter With Jam",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687657",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410944",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410945",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7555917",
      name: "Jam Toast Butter",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688306",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555919",
      name: "Veg Grilled Sandwich",
      category: "Sandwich",
      description:
        "Serves 1, Freshly Baked Bread Stuffed With Select Vegetables, Layered With Green Chutney And Grilled To Perfection.",
      imageId: "a486dc7ac513cfdfa913b4557656335f",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688887",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "36 ratings",
          ratingCountV2: "36",
        },
      },
    },
    {
      id: "7555921",
      name: "Veg Cheese Grill Sandwich",
      category: "Sandwich",
      description:
        "Serves 1,Freshly Baked Bread Stuffed With Select Vegetables, Layered With Cheese And Green Chutney, And Grilled To Perfection.",
      imageId: "614e03b9eae4f4ecabb0bd35cdee74ca",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688773",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "101 ratings",
          ratingCountV2: "101",
        },
      },
    },
    {
      id: "7555922",
      name: "Veg Cheese Toast Sandwich",
      category: "Sandwich",
      imageId: "d2731938973cd187e29bda1eefe2b908",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688822",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "7555923",
      name: "Paneer Tikka Double Decker Sandwich",
      category: "Sandwich",
      imageId: "73eaad3a43e5956e8d17f2bd7c4015d0",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688508",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "7555924",
      name: "Corn Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688082",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7555926",
      name: "Corn Toast Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688106",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "93263500",
      name: "Garlic Bread",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688273",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "96974758",
      name: "Mayo Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688330",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072150",
      name: "Bread Slice (2 Pcs)",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687787",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072152",
      name: "Chatni Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 7200,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687821",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072153",
      name: "Cheese Chilly Toast",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81687888",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072186",
      name: "Omelette Cheese Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688335",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072195",
      name: "Only Cheese Grilled Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688412",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072218",
      name: "Toast Omelet Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688722",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072219",
      name: "Tomato Omelet Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688736",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072232",
      name: "Veg Omelet Sandwich",
      category: "Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81688941",
          groupName: "Sandwich Add On",
          choices: [
            {
              id: "67410936",
              name: "Brown Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "67410937",
              name: "White Bread",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Pizza: [
    {
      id: "7555942",
      name: '9" Onion Capsicum Cheese Pizza',
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25283027",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 208,
                default: 1,
                id: "80478234",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 227,
                id: "80478235",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25283027",
                variationId: "80478234",
              },
            ],
            price: 20800,
          },
          {
            variations: [
              {
                groupId: "25283027",
                variationId: "80478235",
              },
            ],
            price: 22700,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 20800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "7555946",
      name: '9" Modern Special Pizza',
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25283024",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 213,
                default: 1,
                id: "80478228",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 227,
                id: "80478229",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25283024",
                variationId: "80478228",
              },
            ],
            price: 21300,
          },
          {
            variations: [
              {
                groupId: "25283024",
                variationId: "80478229",
              },
            ],
            price: 22700,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21300,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "23 ratings",
          ratingCountV2: "23",
        },
      },
    },
    {
      id: "112072242",
      name: "Corn Tomato Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25283022",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 213,
                default: 1,
                id: "80478224",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 227,
                id: "80478225",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25283022",
                variationId: "80478224",
              },
            ],
            price: 21300,
          },
          {
            variations: [
              {
                groupId: "25283022",
                variationId: "80478225",
              },
            ],
            price: 22700,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21300,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072243",
      name: "Crazy Italian Pizza",
      category: "Pizza",
      imageId: "cb0df55f17c48ad175b9b67b7be05540",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25283023",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 217,
                default: 1,
                id: "80478226",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 232,
                id: "80478227",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25283023",
                variationId: "80478226",
              },
            ],
            price: 21700,
          },
          {
            variations: [
              {
                groupId: "25283023",
                variationId: "80478227",
              },
            ],
            price: 23200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21700,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072300",
      name: "Mushroom Corn Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25283025",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 213,
                default: 1,
                id: "80478230",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 227,
                id: "80478231",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25283025",
                variationId: "80478230",
              },
            ],
            price: 21300,
          },
          {
            variations: [
              {
                groupId: "25283025",
                variationId: "80478231",
              },
            ],
            price: 22700,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21300,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072301",
      name: "Ninno Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25283026",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 217,
                default: 1,
                id: "80478232",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 240,
                id: "80478233",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25283026",
                variationId: "80478232",
              },
            ],
            price: 21700,
          },
          {
            variations: [
              {
                groupId: "25283026",
                variationId: "80478233",
              },
            ],
            price: 24000,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21700,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112203271",
      name: "Sauteed Paneer Pizza",
      category: "Pizza",
      imageId: "5649e8704977ba423e71ca1fc5e6bcc3",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112203370",
      name: "Pineapple Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25343918",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 213,
                default: 1,
                id: "80630488",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 227,
                id: "80630489",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25343918",
                variationId: "80630488",
              },
            ],
            price: 21300,
          },
          {
            variations: [
              {
                groupId: "25343918",
                variationId: "80630489",
              },
            ],
            price: 22700,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21300,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112203374",
      name: "Only Cheese Pizza",
      category: "Pizza",
      imageId: "dea62dd5509fbb8ba86500d4be7c9739",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25343922",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 208,
                default: 1,
                id: "80630499",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 227,
                id: "80630500",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25343922",
                variationId: "80630499",
              },
            ],
            price: 20800,
          },
          {
            variations: [
              {
                groupId: "25343922",
                variationId: "80630500",
              },
            ],
            price: 22700,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 20800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112642827",
      name: "Margarita Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25533760",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 217,
                default: 1,
                id: "81086318",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 232,
                id: "81086319",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25533760",
                variationId: "81086318",
              },
            ],
            price: 21700,
          },
          {
            variations: [
              {
                groupId: "25533760",
                variationId: "81086319",
              },
            ],
            price: 23200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21700,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112642828",
      name: "Farm House Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25533761",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 245,
                default: 1,
                id: "81086320",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 260,
                id: "81086321",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25533761",
                variationId: "81086320",
              },
            ],
            price: 24500,
          },
          {
            variations: [
              {
                groupId: "25533761",
                variationId: "81086321",
              },
            ],
            price: 26000,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 24500,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112643011",
      name: "Jain Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25533839",
            name: "Size",
            variations: [
              {
                name: "8 Inch",
                price: 213,
                default: 1,
                id: "81086476",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "10 Inch",
                price: 232,
                id: "81086477",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25533839",
                variationId: "81086476",
              },
            ],
            price: 21300,
          },
          {
            variations: [
              {
                groupId: "25533839",
                variationId: "81086477",
              },
            ],
            price: 23200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 21300,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Veg Burger": [
    {
      id: "7555955",
      name: "Cheese Burger",
      category: "Veg Burger",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
  ],
  "Special Veg Khazana": [
    {
      id: "7556019",
      name: "Pancha Mela",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556020",
      name: "Veg Amritsari",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "7556021",
      name: "Veg Bhuna",
      category: "Special Veg Khazana",
      imageId: "d9e7f88f3e9f071c17f36ae42f8749af",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "7556022",
      name: "Veg Angoori",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556026",
      name: "Veg Handi",
      category: "Special Veg Khazana",
      imageId: "5a77183bc7f3ca515dd2fc9f1f87020b",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "35 ratings",
          ratingCountV2: "35",
        },
      },
    },
    {
      id: "7556027",
      name: "Veg Kadai",
      category: "Special Veg Khazana",
      imageId: "d77ba340b2285cbd876de6bbdf0df17a",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "37 ratings",
          ratingCountV2: "37",
        },
      },
    },
    {
      id: "7556031",
      name: "Corn Palak",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556032",
      name: "Pudina Chole",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556033",
      name: "Baingan Mirchi Ke Saag",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556034",
      name: "Ankruit Sabji",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556036",
      name: "Makai Mirch Masala",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556038",
      name: "Corn Capsicum Red Masala",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556039",
      name: "Sabji Pasanda",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556040",
      name: "Sabji Makhmali",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "90028525",
      name: "Veg Rajasthani",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072368",
      name: "Dewani Handi",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072369",
      name: "Green Kabab Masala",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072381",
      name: "Palak Lasooni",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072393",
      name: "Sabji Bahar (green Veg)",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072433",
      name: "Veg Butter Kheema",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072434",
      name: "Veg Chap Masala",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072449",
      name: "Veg Kabab Masala",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072478",
      name: "Veg Kolhapuri Tadka",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072486",
      name: "Veg Maratha",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "112072493",
      name: "Veg Noorani",
      category: "Special Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072494",
      name: "Veg Patiyala",
      category: "Special Veg Khazana",
      imageId: "f115661d1e452681b5c442e1e67c839d",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Babycorn Khazana": [
    {
      id: "7556077",
      name: "Baby Corn Masala",
      category: "Babycorn Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556078",
      name: "Baby Corn Tikka Masala",
      category: "Babycorn Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556079",
      name: "Baby Corn Palak",
      category: "Babycorn Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556080",
      name: "Baby Corn Mushroom Masala",
      category: "Babycorn Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "7556081",
      name: "Baby Corn Paneer Masala",
      category: "Babycorn Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556082",
      name: "Baby Corn Tawa",
      category: "Babycorn Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Green Field": [
    {
      id: "7556012",
      name: "Veg Hariyali",
      category: "Green Field",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556013",
      name: "Aloo Hariyali",
      category: "Green Field",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556014",
      name: "Mushroom Hariyali",
      category: "Green Field",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556015",
      name: "Baby Corn Hariyali",
      category: "Green Field",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556016",
      name: "Paneer Hariyali",
      category: "Green Field",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556017",
      name: "Baby Corn Mushroom Hariyali",
      category: "Green Field",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556018",
      name: "Modern Special Hariyali",
      category: "Green Field",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Dal Varieties": [
    {
      id: "7556093",
      name: "Dal Fry",
      category: "Dal Varieties",
      imageId: "49843d1b1e11940437bf5b46e525129a",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "101 ratings",
          ratingCountV2: "101",
        },
      },
    },
    {
      id: "7556094",
      name: "Dal Fry Butter",
      category: "Dal Varieties",
      imageId: "b0f81ed6e0e1ebdd5628678bf79b8ca5",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "35 ratings",
          ratingCountV2: "35",
        },
      },
    },
    {
      id: "7556096",
      name: "Dal Makhani",
      category: "Dal Varieties",
      imageId: "8cb7d518e442af7b12811b2b17500da5",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "23 ratings",
          ratingCountV2: "23",
        },
      },
    },
    {
      id: "7556097",
      name: "Dal Tadka",
      category: "Dal Varieties",
      imageId: "98ade7f1a155d6d24e58640864b99b48",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "86 ratings",
          ratingCountV2: "86",
        },
      },
    },
    {
      id: "7556098",
      name: "Dal Palak",
      category: "Dal Varieties",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7556099",
      name: "Dal Kolhapuri",
      category: "Dal Varieties",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "100413407",
      name: "Dal Moghlai (sweet)",
      category: "Dal Varieties",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Pulav / Biryani": [
    {
      id: "7556100",
      name: "Veg Biryani",
      category: "Pulav / Biryani",
      imageId: "83f2c5aedc46dac8408909c54c7fa36a",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692591",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "174 ratings",
          ratingCountV2: "174",
        },
      },
    },
    {
      id: "7556102",
      name: "Paneer Biryani",
      category: "Pulav / Biryani",
      imageId: "673118cf0733b8b2c357bff5420acf77",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692586",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "63 ratings",
          ratingCountV2: "63",
        },
      },
    },
    {
      id: "7556103",
      name: "Mushroom Biryani",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692582",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "7556104",
      name: "Veg Handi Biryani",
      category: "Pulav / Biryani",
      imageId: "8e1ce6e95447c6d835b4d5275e1ab846",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692595",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "7556105",
      name: "Veg Hyderabadi Biryani",
      category: "Pulav / Biryani",
      imageId: "b904beda0fc7200b90b4865d1c85d1ed",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692598",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "27 ratings",
          ratingCountV2: "27",
        },
      },
    },
    {
      id: "7556106",
      name: "Methi Pulao",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692581",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556107",
      name: "Veg Pulao",
      category: "Pulav / Biryani",
      imageId: "298e027123ade756ec65bb75c9a23ed0",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692599",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "142 ratings",
          ratingCountV2: "142",
        },
      },
    },
    {
      id: "7556108",
      name: "Green Peas Pulao",
      category: "Pulav / Biryani",
      imageId: "0389e900916605939668479e60d89003",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692572",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556110",
      name: "Paneer Pulao",
      category: "Pulav / Biryani",
      imageId: "7620a75f9c1116055221a5b728076b5d",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692587",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "7556114",
      name: "Palak Khichdi",
      category: "Pulav / Biryani",
      imageId: "cb918958e8b0d8388c4700a7b1e81c5d",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692583",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "7556116",
      name: "Curd Rice Tadka",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692561",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "16742335",
      name: "Dal Khichdi Tadka",
      category: "Pulav / Biryani",
      description:
        "It's a simple rice and moong dal khichdi with aromatic tadka (tempering) of garlic and few other spices.",
      imageId: "ae5ccb42a4c69ea0cfd4a744140a1204",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692567",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "278 ratings",
          ratingCountV2: "278",
        },
      },
    },
    {
      id: "100413402",
      name: "Paneer Tikka Biryani",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692588",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "100413403",
      name: "Palak Khichdi Tadka",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692584",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "100431016",
      name: "Dal Khichdi",
      category: "Pulav / Biryani",
      description:
        "Serves 1,A Plain Toor Dal Khichdi ,Seasoned With Subtle Spices And Served With Refreshing Raita And Papad",
      imageId: "483face346e3390e81b9cb917c41bbcc",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692563",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "73 ratings",
          ratingCountV2: "73",
        },
      },
    },
    {
      id: "112072602",
      name: "Amritsar Kichidi",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692559",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072603",
      name: "Corn Green Peas Pulav",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692560",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072648",
      name: "Kashmiri Biryani (sweet)",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692573",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072652",
      name: "Kashmiri Pulao (sweet)",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692576",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "112072664",
      name: "Lemon Rice",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 18500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692580",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072730",
      name: "Shajahan Pulav",
      category: "Pulav / Biryani",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692589",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072731",
      name: "Steam Rice",
      category: "Pulav / Biryani",
      imageId: "5cf7e123f67b7c0a2018a57c6af3dfad",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692590",
          groupName: "Pulav / Biryani Add On",
          choices: [
            {
              id: "66226404",
              name: "Extra Curry",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66226405",
              name: "Extra Raitha",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Tandoori Breads": [
    {
      id: "7556122",
      name: "Paratha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 4400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692789",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "7556123",
      name: "Kulcha",
      category: "Tandoori Breads",
      imageId: "6eff44600ef92ea036560ae253d6bdfd",
      inStock: 1,
      isVeg: 1,
      price: 3800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692619",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "58 ratings",
          ratingCountV2: "58",
        },
      },
    },
    {
      id: "7556124",
      name: "Naan",
      category: "Tandoori Breads",
      description:
        "Plain Indian bread made from refined white flour, baked in a traditional clay oven.",
      imageId: "8fd8a1f5e5c470225f28c70d14a35c7d",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692749",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "182 ratings",
          ratingCountV2: "182",
        },
      },
    },
    {
      id: "7556125",
      name: "Chapati",
      category: "Tandoori Breads",
      description:
        "Serves 1, Super -Soft Pure Wheat Chapati That Is Usually Paired With A Gravy-Based Dish",
      imageId: "28a9680fe83b4caa02ce460a95e8bd43",
      inStock: 1,
      isVeg: 1,
      price: 1200,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692605",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "234 ratings",
          ratingCountV2: "234",
        },
      },
    },
    {
      id: "7556127",
      name: "Aloo Paratha",
      category: "Tandoori Breads",
      description:
        "Serves 1, Homestyle Cooked Parathas With Generous Seasoned Potato Stuffing And Served With Green Chutney",
      imageId: "0e96a3e4f7ebae1b8c1056082c9568c8",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692601",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "162 ratings",
          ratingCountV2: "162",
        },
      },
    },
    {
      id: "7556128",
      name: "Methi Paratha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692633",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556129",
      name: "Onion Kulcha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 4800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692758",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556130",
      name: "Paneer Kulcha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692759",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "7556131",
      name: "Garlic Kulcha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 5500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692612",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7556132",
      name: "Garlic Naan",
      category: "Tandoori Breads",
      imageId: "86da938fb61f7e5105cb32ee93f17ff9",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692613",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "35 ratings",
          ratingCountV2: "35",
        },
      },
    },
    {
      id: "7556133",
      name: "Masala Kulcha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692632",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556134",
      name: "Mooli Paratha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692634",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "7556135",
      name: "Pudina Paratha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692790",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556136",
      name: "Cheese Kulcha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692610",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7556137",
      name: "Paneer Paratha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692773",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "16742336",
      name: "Cheese Naan",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692611",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072774",
      name: "Cheese Garlic Kulcha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692607",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072781",
      name: "Cheese Garlic Naan",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692608",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072911",
      name: "Roti (wheat)",
      category: "Tandoori Breads",
      description:
        "Round Indian bread made from wheat flour, baked in a clay oven.",
      imageId: "bc67fb23031e9f9811534e14301d32be",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692791",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "257 ratings",
          ratingCountV2: "257",
        },
      },
    },
    {
      id: "112072921",
      name: "Stuff Paratha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81692796",
          groupName: "Tandoori Bread Add On",
          choices: [
            {
              id: "66226406",
              name: "Extra Butter",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "112275323",
      name: "Butter Roti",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "112558263",
      name: "Butter Paratha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 5200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112558264",
      name: "Butter Kulcha",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112558265",
      name: "Butter Chapathi",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 2500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112558266",
      name: "Butter Naan",
      category: "Tandoori Breads",
      inStock: 1,
      isVeg: 1,
      price: 5500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  "Raita / Salad": [
    {
      id: "7556138",
      name: "Veg Raita",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556140",
      name: "Fruit Raita",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556142",
      name: "Boondi Raita",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "7556144",
      name: "Pineapple Raita",
      category: "Raita / Salad",
      imageId: "db5b54265b2b22faa3b818304d42302f",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "7556146",
      name: "Green Salad",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556148",
      name: "Tomato Salad",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556150",
      name: "Curd",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7556152",
      name: "Kakdi Raita",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556154",
      name: "Palak Raita",
      category: "Raita / Salad",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Starters: [
    {
      id: "7556158",
      name: "Veg Spring Roll",
      category: "Starters",
      description:
        "Mouthwatering Veg 6 Spring Roll Pieces And Served Along With Schezwan Sauce",
      imageId: "4a214b686f265dd3cafe7ac7503d959d",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "77 ratings",
          ratingCountV2: "77",
        },
      },
    },
    {
      id: "7556160",
      name: "Mushroom Spring Roll",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556162",
      name: "Schezwan Spring Roll",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7556166",
      name: "Veg Crispy",
      category: "Starters",
      description:
        "Serves 1,Crispy Potatoes And Vegetable Stir-Fried And Tossed In A Deliciously Spicy Chilli Sauce.",
      imageId: "c93435552ac3d077ca50cc0a8ff5eda3",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "94 ratings",
          ratingCountV2: "94",
        },
      },
    },
    {
      id: "7556171",
      name: "Paneer Satay",
      category: "Starters",
      imageId: "00bba37060a05552a9a4fdfa2feb3fdf",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "7556173",
      name: "Schezwan Idli",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556175",
      name: "Chinese Bhel",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7556179",
      name: "Hara Bhara Kebab",
      category: "Starters",
      description:
        "Serves 1, Flavorsome Preparation With Minced , Seasoned Vegetable Patty Cooked To Acrispl Golden Brown With Delectable Dips (8 Pcs)",
      imageId: "1728a57c55e0f9095ad2a35b24e48868",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "60 ratings",
          ratingCountV2: "60",
        },
      },
    },
    {
      id: "7556181",
      name: "Paneer Crispy",
      category: "Starters",
      description:
        "Paneer crispy is an Indo-Chinese starter of crispy fried paneer tossed in garlic-flavored little spicy, sweet, and sour sauce.",
      imageId: "6e68b6fcc4be296569bd287c7b5ca1d6",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "135 ratings",
          ratingCountV2: "135",
        },
      },
    },
    {
      id: "96974760",
      name: "Chilly Basil Paneer",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "112072940",
      name: "Cheese Balls",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072942",
      name: "Chinese Idli",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "112072959",
      name: "Veg Lolly Pop",
      category: "Starters",
      imageId: "6589f4d7e67946605990898b19fd39b1",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  "Chow Vegetables": [
    {
      id: "7556170",
      name: "Paneer Schezwan Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "7556189",
      name: "Veg 65 Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556196",
      name: "Paneer 65 Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556198",
      name: "Flower Manchurian Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556200",
      name: "Mushroom Manchurian Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556204",
      name: "Mushroom 65 Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556212",
      name: "Veg Manchurian Gravy",
      category: "Chow Vegetables",
      description:
        "Delightful 12 Manchurian Pieces Served With Freshly Made Juice Gravy .",
      imageId: "da2c879107285df48e3f4f35e61ccc5a",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "65 ratings",
          ratingCountV2: "65",
        },
      },
    },
    {
      id: "7556216",
      name: "Veg 65 Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556218",
      name: "Paneer Manchurian Gravy",
      category: "Chow Vegetables",
      imageId: "dba65ac5338387f998f5a22156a17a38",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556222",
      name: "Paneer Schezwan Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556224",
      name: "Paneer 65 Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556226",
      name: "Flower Manchurian Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556227",
      name: "Mushroom Manchurian Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556231",
      name: "Mushroom 65 Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556235",
      name: "Baby Corn Manchurian Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556237",
      name: "Baby Corn 65 Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556239",
      name: "Veg Schezwan Sauce",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556241",
      name: "Veg In Green Sauce",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556245",
      name: "Veg Ball In Green Sauce",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556247",
      name: "Mushroom In Green Sauce",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556249",
      name: "Baby Corn In Green Sauce",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556251",
      name: "Paneer In Green Sauce",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556253",
      name: "Veg Ginger",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556255",
      name: "Veg Garlic",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556257",
      name: "Veg In Hot Garlic",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556261",
      name: "Baby Corn In Hot Garlic",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556262",
      name: "Baby Corn Modern Special",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556306",
      name: "Veg Chow Chow",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "100431013",
      name: "Paneer Chilli Dry",
      category: "Chow Vegetables",
      description:
        "Serves 1,Delightfully Flavorful Dish Prepared With 12 Pieces Of Soft Paneer And Cooked Slowly With Flavorful Chili Sauce And Other Masalas.",
      imageId: "2dd2ed58d7941aad6b22c25466a602c4",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "81 ratings",
          ratingCountV2: "81",
        },
      },
    },
    {
      id: "112072980",
      name: "Baby Corn 65 Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072992",
      name: "Baby Corn Chilly Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072993",
      name: "Baby Corn Chilly Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072994",
      name: "Baby Corn Manchurian Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072995",
      name: "French Paneer Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 26500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072997",
      name: "French Paneer Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 26500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072998",
      name: "Mushroom Chilly Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112072999",
      name: "Mushroom Chilly Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073011",
      name: "Paneer Chilly Gravy",
      category: "Chow Vegetables",
      imageId: "f23c4e5d8b11d707950f00d3a90e139f",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073012",
      name: "Paneer Honkong",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073015",
      name: "Paneer Manchurian Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073036",
      name: "Soya Bean Chilly Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073047",
      name: "Soya Bean Chilly Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073058",
      name: "Veg Chilly Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073070",
      name: "Veg Chilly Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073082",
      name: "Veg Honkong",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073094",
      name: "Veg Manchurian Dry",
      category: "Chow Vegetables",
      imageId: "0352d01bf4081ac622abe24f7ae88615",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "112073113",
      name: "Veg Paneer Shanghai Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073117",
      name: "Veg Paneer Shanghai Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073120",
      name: "Veg Shanghai Dry",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073121",
      name: "Veg Shanghai Gravy",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073122",
      name: "Veg Sweet N Sour",
      category: "Chow Vegetables",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Rice: [
    {
      id: "7556271",
      name: "Veg Fried Rice",
      category: "Rice",
      description:
        "Serves 1,Fresh Veggies Tossed In A Pan With Steamed Rice And Flavorful Spices - Perfect To Satisfy Your Hunger Pangs Served With Chilly Sauce And Soya Sauce.",
      imageId: "446c63a480addfe27e29e85daff247e7",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "177 ratings",
          ratingCountV2: "177",
        },
      },
    },
    {
      id: "7556273",
      name: "Jeera Fried Rice",
      category: "Rice",
      description:
        "Serves 1, Aromatic Rice Cooked In A Tempering Of Cumin And Whole Spices",
      imageId: "68c9ab14a969430411c6508cdb18b714",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "84 ratings",
          ratingCountV2: "84",
        },
      },
    },
    {
      id: "7556275",
      name: "Onion Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556276",
      name: "Schezwan Fried Rice",
      category: "Rice",
      description:
        "Amp up your traditional fried rice with a generous topping of schezwan sauce",
      imageId: "631810825a29fa9904926cc16c4e4385",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "84 ratings",
          ratingCountV2: "84",
        },
      },
    },
    {
      id: "7556278",
      name: "Palak Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556279",
      name: "Singapore Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7556282",
      name: "Mushroom Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556284",
      name: "Green Peas Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556286",
      name: "Combination Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556287",
      name: "Paneer Fried Rice",
      category: "Rice",
      imageId: "f5328bb3e01cd7a4e51d554715c488bb",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "7556289",
      name: "Veg Triple Schezwan Rice",
      category: "Rice",
      description:
        "A Wholesome Dish With The Aromatic Triple Fried Rice Prepared With Assorted Fresh Veggies And Flavor-Packed Masaalas.",
      imageId: "d443f597f1bcfd44f84ad5877195f89c",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "75 ratings",
          ratingCountV2: "75",
        },
      },
    },
    {
      id: "7556291",
      name: "Veg Stewed Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556294",
      name: "Ginger Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556295",
      name: "Shanghai Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556297",
      name: "Cheese Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556299",
      name: "Golden Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "98670245",
      name: "Paneer Pepper Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 26500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073133",
      name: "Chilly Garlic Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073134",
      name: "Hong Kong Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073157",
      name: "Paneer Schezwan Fried Rice",
      category: "Rice",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Noodles: [
    {
      id: "67844923",
      name: "Veg Chowmein",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96974759",
      name: "Chilly Garlic Noodles",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "112073179",
      name: "Malaysian Noodles (flat Noodles)",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073187",
      name: "Schezwan Noodle",
      category: "Noodles",
      description: "Wok-tossed fried noodles tossed in spicy Schezwan sauce",
      imageId: "f46a379ba6449908f000e86c61a91700",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "112073192",
      name: "Singapore Noodle",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073193",
      name: "Veg American Chopsuey",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073194",
      name: "Veg Chinese Chopsuey",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073205",
      name: "Veg Hakka Noodle",
      category: "Noodles",
      description:
        "Serves 1,A Delectable Dish With Slippery Strands Of Noodles Dressed In A Flavorful Sauce And Tossed Along With Veggies And Spices.",
      imageId: "9d082ba72db59e1e9ece4d5d5d6b0ba9",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "112073207",
      name: "Veg Noodle",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Soup: [
    {
      id: "7555960",
      name: "Cream Of Tomato Soup",
      category: "Soup",
      description:
        "Serves 1, Soup That Is Packed With The Tanginess , Creaminess And Goodness Of Tomatoes",
      imageId: "29f8fb344e19279ddd9809f9377f17ae",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "65 ratings",
          ratingCountV2: "65",
        },
      },
    },
    {
      id: "7555961",
      name: "Cream Of Veg Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "7555962",
      name: "Sweet Corn Plain Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555963",
      name: "Sweet Corn Veg Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "7555965",
      name: "Veg Manchow Soup",
      category: "Soup",
      description:
        "Serves 1,Hot And Spicy, Thick Soup Made From Mixed Vegetables And Topped With Fried Noodles.",
      imageId: "0e7eca18fb81e0188ae80c081ef1e601",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "108 ratings",
          ratingCountV2: "108",
        },
      },
    },
    {
      id: "7555966",
      name: "Sweet Corn Noodle Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555967",
      name: "Palak Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7555968",
      name: "Veg Clear Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "7555969",
      name: "Cream Of Mushroom Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96974757",
      name: "Lemon Coriander Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "100431002",
      name: "French Onion Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073229",
      name: "Veg Hot N Sour Soup",
      category: "Soup",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Sweet Dishes": [
    {
      id: "7555851",
      name: "Dahi Vada",
      category: "Sweet Dishes",
      description:
        "Serves 1, Dish Prepared With A Delectable Vada Layered With Generous Ammount Of Curds , Garnished With Masalas And Chutneys (2Pc",
      imageId: "d5fa65dfc55ffe71033016fda0a789d9",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "173 ratings",
          ratingCountV2: "173",
        },
      },
    },
    {
      id: "7556337",
      name: "Gulab Jamun (2 Pcs)",
      category: "Sweet Dishes",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "7556339",
      name: "Shrikhand",
      category: "Sweet Dishes",
      imageId: "9d1edce226638b7fba75c2a251039ba9",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
  ],
  Desserts: [
    {
      id: "7556341",
      name: "Fruit Salad With Jelly",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7556342",
      name: "Fruit Salad",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "7556344",
      name: "Fruit Salad With Ice Cream",
      category: "Desserts",
      imageId: "78e98f3f50c43a682c7edf710c04a609",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "7556346",
      name: "Fruit Salad With Jelly And Ice Cream",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556347",
      name: "Plain Jelly",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073264",
      name: "Jelly With Lce-cream",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Lassi: [
    {
      id: "7556369",
      name: "Mango Lassi",
      category: "Lassi",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "7556370",
      name: "Kesar Lassi",
      category: "Lassi",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "93263413",
      name: "Sweet Lassi",
      category: "Lassi",
      description: "A Chilled Beverage Of Thick Sweetened Curd",
      imageId: "23ed5215ed4f107fde5fc82dc48e4c44",
      inStock: 1,
      isVeg: 1,
      price: 5500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "38 ratings",
          ratingCountV2: "38",
        },
      },
    },
    {
      id: "112073275",
      name: "Buttermilk (chaas)",
      category: "Lassi",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "112073276",
      name: "Chickoo Lassi",
      category: "Lassi",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073277",
      name: "Salted Lassi",
      category: "Lassi",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Fresh Fruit Juice": [
    {
      id: "7556372",
      name: "Mosambi Juice",
      category: "Fresh Fruit Juice",
      description:
        "Vitamin C Rich Juice Made With Fresh Mosambis And Served In A Bottle",
      imageId: "78958b236e22887950173599318e3dcb",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "36 ratings",
          ratingCountV2: "36",
        },
      },
    },
    {
      id: "7556375",
      name: "Apple Juice",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556376",
      name: "Pineapple Juice",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "7556377",
      name: "Grape Juice",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556381",
      name: "Lemon Juice",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "20 ratings",
          ratingCountV2: "20",
        },
      },
    },
    {
      id: "7556382",
      name: "Orange Blossom",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "68044323",
      name: "Aam Ras Puri",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "96765824",
      name: "Aamras",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "100413773",
      name: "Watermelon Juice",
      category: "Fresh Fruit Juice",
      imageId: "10929b175eacb60154ae0c5c5e346303",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isGuiltfree: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "112073289",
      name: "Ganga Jamuna Juice",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073300",
      name: "Mango Juice (seasonal)",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073311",
      name: "Pomegranate Juice (dalimb)",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "112073323",
      name: "Water Melon Blossom",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112953896",
      name: "Mango Juies",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "113052908",
      name: "Fresh Mango W Ice Cream",
      category: "Fresh Fruit Juice",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Falooda: [
    {
      id: "7556384",
      name: "Rose Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "7556385",
      name: "Kesar Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7556386",
      name: "Mango Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "7556387",
      name: "Kulfi Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "100413406",
      name: "Green Pista Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  Milkshakes: [
    {
      id: "93263407",
      name: "Cold Coffee",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694459",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "112073345",
      name: "Anjeer Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694453",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073346",
      name: "Apple Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694454",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073347",
      name: "Banana Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694455",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "112073348",
      name: "Butterscotch Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694456",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "112073349",
      name: "Chikoo Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694457",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073360",
      name: "Chocolate Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694458",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "112073361",
      name: "Dry Fruit Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694460",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073362",
      name: "Kitkat Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694461",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073364",
      name: "Pineapple Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694463",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073365",
      name: "Rose Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694464",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073366",
      name: "Vanilla Milk Shake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694465",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
  ],
  "Veg Khazana": [
    {
      id: "7555970",
      name: "Veg Makhanwala",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "20 ratings",
          ratingCountV2: "20",
        },
      },
    },
    {
      id: "7555971",
      name: "Veg Kolhapuri",
      category: "Veg Khazana",
      imageId: "9a748dd2cb17c6ea4f3ad5ca99e8e28b",
      inStock: 1,
      isVeg: 1,
      price: 20400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "197 ratings",
          ratingCountV2: "197",
        },
      },
    },
    {
      id: "7555973",
      name: "Veg Jaipuri",
      category: "Veg Khazana",
      imageId: "d711a9ba075dcb27ca6be79619f6f839",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "25 ratings",
          ratingCountV2: "25",
        },
      },
    },
    {
      id: "7555974",
      name: "Veg Jalfrezi",
      category: "Veg Khazana",
      imageId: "33cbd809a3c9e7ffeb1afb8851561760",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7555975",
      name: "Veg Do Pyaza",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7555976",
      name: "Veg Hyderabadi",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555978",
      name: "Veg Tawa",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7555981",
      name: "Simla Mirch Matki Masala",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555982",
      name: "Methi Masala",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7555984",
      name: "Green Peas Masala",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7555985",
      name: "Flower Masala",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "7555990",
      name: "Baingan Masala",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7555991",
      name: "Baingan Bharta",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.3",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "7556001",
      name: "Tomato Fry",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556004",
      name: "Green Peas Tomato",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556009",
      name: "Palak",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556010",
      name: "Green Peas Palak",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556011",
      name: "Tomato Seva",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "16742300",
      name: "Lasooni Methi",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073367",
      name: "Alu Baingan",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073368",
      name: "Alu Flower",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073369",
      name: "Alu Methi",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073380",
      name: "Alu Mutter",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073381",
      name: "Alu Palak",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073382",
      name: "Alu Pukare",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073383",
      name: "Alu Simla",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073384",
      name: "Alu Tomato Fry",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073395",
      name: "Bhendi Do Pyaza",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073396",
      name: "Bhendi Masala",
      category: "Veg Khazana",
      imageId: "4e291903d52f000924fe8b3f1d740aaf",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073397",
      name: "Bhendi Masala Fry",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073398",
      name: "Channa Masala",
      category: "Veg Khazana",
      imageId: "ff45eebeb7df6475294363b3f3f1457b",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073399",
      name: "Dum Alu",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073400",
      name: "Dum Alu Kashmiri",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073412",
      name: "Methi Malai Mutter",
      category: "Veg Khazana",
      imageId: "1ee07c546876023556747a5e57c16788",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073413",
      name: "Mix Vegetable",
      category: "Veg Khazana",
      imageId: "c030033b56012b512e6b99c843a76dd0",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "112073414",
      name: "Palak Channa",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073425",
      name: "Simla Masala",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 20500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073426",
      name: "Stuff Simla",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073427",
      name: "Stuff Tomato",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073428",
      name: "Tomato Bhartha",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 21500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073449",
      name: "Veg Moghlai (sweet)",
      category: "Veg Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Kaju Khazana": [
    {
      id: "63858831",
      name: "Kaju Masala",
      category: "Kaju Khazana",
      imageId: "6e92f28b4bfdca38fb81e0fcc8929906",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "68518252",
      name: "Kaju Mushroom Masala",
      category: "Kaju Khazana",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "68518253",
      name: "Kaju Paneer Masala",
      category: "Kaju Khazana",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "112073460",
      name: "Kaju Malai Mutter",
      category: "Kaju Khazana",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073461",
      name: "Kaju Mushroom Malai Mutter",
      category: "Kaju Khazana",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073472",
      name: "Kaju Paneer Malai Mutter",
      category: "Kaju Khazana",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Kurma Khazana": [
    {
      id: "7556044",
      name: "Veg Kurma",
      category: "Kurma Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7556045",
      name: "Paneer Kurma",
      category: "Kurma Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556046",
      name: "Navratan Kurma",
      category: "Kurma Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "7556047",
      name: "Veg Shahi Kurma",
      category: "Kurma Khazana",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073473",
      name: "Paneer Shahi Kurma",
      category: "Kurma Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Kofta Khazana": [
    {
      id: "7556050",
      name: "Veg Kofta",
      category: "Kofta Khazana",
      imageId: "e1f7dc8b36a84e74a8972a0778a881e5",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "7556051",
      name: "Paneer Kofta",
      category: "Kofta Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "7556052",
      name: "Kashmiri Kofta",
      category: "Kofta Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556053",
      name: "Palak Kofta",
      category: "Kofta Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556054",
      name: "Nargis Kofta",
      category: "Kofta Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "112073484",
      name: "Faldhari Kofta",
      category: "Kofta Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073485",
      name: "Lasooni Kofta",
      category: "Kofta Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073486",
      name: "Malai Kofta (sweet)",
      category: "Kofta Khazana",
      imageId: "8faa59bf1836211b51f1ff6be271a95a",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "33 ratings",
          ratingCountV2: "33",
        },
      },
    },
  ],
  "Paneer Khazana": [
    {
      id: "7556055",
      name: "Paneer Tikka Masala",
      category: "Paneer Khazana",
      imageId: "dc15120aa2ef0ac509b7e1ffc1ccd94b",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "314 ratings",
          ratingCountV2: "314",
        },
      },
    },
    {
      id: "7556057",
      name: "Paneer Pasanda",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7556058",
      name: "Paneer Bhurji",
      category: "Paneer Khazana",
      imageId: "f22e9bea3c2b8b236dd8709b644861f1",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "7556059",
      name: "Green Peas Paneer Bhurji",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "7556060",
      name: "Paneer Palak",
      category: "Paneer Khazana",
      imageId: "cecfab5e6c78ffe8fe211602725a0f54",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "43 ratings",
          ratingCountV2: "43",
        },
      },
    },
    {
      id: "7556061",
      name: "Paneer Makhanwala",
      category: "Paneer Khazana",
      imageId: "3fd8c689185f5fc8d89bf8137f9a83eb",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "78 ratings",
          ratingCountV2: "78",
        },
      },
    },
    {
      id: "7556062",
      name: "Paneer Butter Masala",
      category: "Paneer Khazana",
      imageId: "f18c2a691f7628b556ec9bb4aff6240b",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "107 ratings",
          ratingCountV2: "107",
        },
      },
    },
    {
      id: "7556063",
      name: "Paneer Chana",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556064",
      name: "Paneer Kadai",
      category: "Paneer Khazana",
      imageId: "c1bcdf0a93f28f5245dc404202c5f657",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "53 ratings",
          ratingCountV2: "53",
        },
      },
    },
    {
      id: "7556065",
      name: "Paneer Tawa",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556066",
      name: "Paneer Kabooli",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556067",
      name: "Paneer Kolhapuri",
      category: "Paneer Khazana",
      imageId: "b837c96fb0a150f56d40b7c79de233f9",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "51 ratings",
          ratingCountV2: "51",
        },
      },
    },
    {
      id: "7556068",
      name: "Paneer Do Pyaza",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556069",
      name: "Paneer Kashmiri Chaman",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556071",
      name: "Paneer Peshawari",
      category: "Paneer Khazana",
      imageId: "1bb5b8d82bc771ff6d18c11a77ce43dc",
      inStock: 1,
      isVeg: 1,
      price: 26500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "7556072",
      name: "Paneer Lahori",
      category: "Paneer Khazana",
      imageId: "fcace2695d406edc4ed13dda71ad9c99",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
    {
      id: "7556073",
      name: "Paneer Mirch",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "7556075",
      name: "Paneer Tiloni",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "16742334",
      name: "Paneer Masala",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "112073497",
      name: "Paneer Hyderabadi",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073508",
      name: "Paneer Kalimiri",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073519",
      name: "Paneer Kurchand",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073520",
      name: "Paneer Ludhiana",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 26500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073531",
      name: "Paneer Mutter",
      category: "Paneer Khazana",
      imageId: "597913470f9a3ab8a9438b2ebce9dc8f",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073532",
      name: "Paneer Nazkat",
      category: "Paneer Khazana",
      inStock: 1,
      isVeg: 1,
      price: 26500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073534",
      name: "Paneer Salamee",
      category: "Paneer Khazana",
      inStock: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Mushroom Khazana": [
    {
      id: "7556083",
      name: "Mushroom Paneer Delight",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 25500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "7556084",
      name: "Mushroom Paneer Masala",
      category: "Mushroom Khazana",
      imageId: "9ccc89c860dc59ae27e6acfb17b45db0",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
    {
      id: "7556085",
      name: "Mushroom Masala",
      category: "Mushroom Khazana",
      imageId: "ebe613c7f10446cb8ea75637263c28ad",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "7556086",
      name: "Mushroom Masala Fry",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556087",
      name: "Mushroom Palak",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556088",
      name: "Green Peas Mushroom Masala",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "7556089",
      name: "Mushroom Tikka Masala",
      category: "Mushroom Khazana",
      imageId: "b0a37261b91324df34ad8ab8cbf39d9f",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556090",
      name: "Green Peas Mushroom Fry",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "7556091",
      name: "Mushroom Tawa",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "7556092",
      name: "Mushroom Methi",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073545",
      name: "Mushroom Makai Masala",
      category: "Mushroom Khazana",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Dinner: [
    {
      id: "7555956",
      name: "Roasted Papad",
      category: "Dinner",
      inStock: 1,
      isVeg: 1,
      price: 2300,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "7555957",
      name: "Fried Papad",
      category: "Dinner",
      inStock: 1,
      isVeg: 1,
      price: 2800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "96766176",
      name: "Dal Rice",
      category: "Dinner",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "36 ratings",
          ratingCountV2: "36",
        },
      },
    },
    {
      id: "112073568",
      name: "Plain Dal",
      category: "Dinner",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073569",
      name: "Rasam",
      category: "Dinner",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073570",
      name: "Rice",
      category: "Dinner",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25283126",
            name: "Quantity",
            variations: [
              {
                name: "Half",
                price: 55,
                default: 1,
                id: "80478524",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 60,
                id: "80478525",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25283126",
                variationId: "80478524",
              },
            ],
            price: 5500,
          },
          {
            variations: [
              {
                groupId: "25283126",
                variationId: "80478525",
              },
            ],
            price: 6000,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 5500,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073571",
      name: "Sambhar",
      category: "Dinner",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  "Seasonal Milkshakes": [
    {
      id: "112073637",
      name: "Fresh Mango With Ice Cream",
      category: "Seasonal Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694643",
          groupName: "Milk Shake Add On",
          choices: [
            {
              id: "66227131",
              name: "Extra Ice Cream For Milk Shake",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Cold Drinks": [
    {
      id: "7556412",
      name: "Soda",
      category: "Cold Drinks",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "7556414",
      name: "Ginger Lemon",
      category: "Cold Drinks",
      inStock: 1,
      isVeg: 1,
      price: 3500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
  ],
  "Combos Paratha [raita / Dal Makhani]": [
    {
      id: "112073665",
      name: "Alu Paratha",
      category: "Combos Paratha [raita / Dal Makhani]",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694646",
          groupName: "Paratha Combo Choice",
          choices: [
            {
              id: "66227367",
              name: "Raitha",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66227368",
              name: "Dal Makhani",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073666",
      name: "Methi Paratha Combo",
      category: "Combos Paratha [raita / Dal Makhani]",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694647",
          groupName: "Paratha Combo Choice",
          choices: [
            {
              id: "66227367",
              name: "Raitha",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66227368",
              name: "Dal Makhani",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073685",
      name: "Mooli Paratha Combo",
      category: "Combos Paratha [raita / Dal Makhani]",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694648",
          groupName: "Paratha Combo Choice",
          choices: [
            {
              id: "66227367",
              name: "Raitha",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66227368",
              name: "Dal Makhani",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112073696",
      name: "Paneer Paratha Combo",
      category: "Combos Paratha [raita / Dal Makhani]",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81694649",
          groupName: "Paratha Combo Choice",
          choices: [
            {
              id: "66227367",
              name: "Raitha",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66227368",
              name: "Dal Makhani",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112203371",
      name: "Stuff Paratha Combo",
      category: "Combos Paratha [raita / Dal Makhani]",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81893684",
          groupName: "Paratha Combo Choice",
          choices: [
            {
              id: "66227367",
              name: "Raitha",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66227368",
              name: "Dal Makhani",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112203373",
      name: "Pudina Paratha Combo",
      category: "Combos Paratha [raita / Dal Makhani]",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "81893685",
          groupName: "Paratha Combo Choice",
          choices: [
            {
              id: "66227367",
              name: "Raitha",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66227368",
              name: "Dal Makhani",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
          minAddons: 1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Drink It Hot": [
    {
      id: "16742249",
      name: "Tea",
      category: "Drink It Hot",
      inStock: 1,
      isVeg: 1,
      price: 3200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "20 ratings",
          ratingCountV2: "20",
        },
      },
    },
    {
      id: "93263405",
      name: "Filter Coffee",
      category: "Drink It Hot",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "36 ratings",
          ratingCountV2: "36",
        },
      },
    },
    {
      id: "112073744",
      name: "Tea (no Sugar)",
      category: "Drink It Hot",
      inStock: 1,
      isVeg: 1,
      price: 3500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Puri: [
    {
      id: "7555858",
      name: "Poori Bhaji",
      category: "Puri",
      description:
        "Serves 1,Fluffy And Soft Five Pooris Served With Delicious Aalo Bhaaji Served With Onion Salad And Coconut Chutney.",
      imageId: "782528a60e50a89c554099f401b034ef",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "102 ratings",
          ratingCountV2: "102",
        },
      },
    },
    {
      id: "112071845",
      name: "Puri Chole Bhaji",
      category: "Puri",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112071847",
      name: "Puri Masala Bhaji",
      category: "Puri",
      description: "Serves 1",
      inStock: 1,
      isVeg: 1,
      price: 10700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112071848",
      name: "Puri Plate (5 Pc)",
      category: "Puri",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "112071850",
      name: "Puri Shrikaand",
      category: "Puri",
      imageId: "8073108fc4223f8d4f928760deb7d587",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Chole Bathura": [
    {
      id: "7555853",
      name: "Chole Bhatoore",
      category: "Chole Bathura",
      description:
        "Serves 1, A Classic Punjabi Dish Of Fluffy One Bathura And Delicious Chickpea Gravy, Serve With Onion Salad",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "90 ratings",
          ratingCountV2: "90",
        },
      },
    },
    {
      id: "112071782",
      name: "Bhatura (1 Pc)",
      category: "Chole Bathura",
      imageId: "c15943e70127c78bd46865bedd968dfb",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[gajananVp] = {
  Maharashtrian: [
    {
      id: "69701548",
      name: "Vada Pav (1 Pc)",
      category: "Maharashtrian",
      description:
        "Serves 1 | The classic  dish with deep batter fried aloo vada with green chutney in a Pav.",
      inStock: 1,
      isVeg: 1,
      price: 2700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "274 ratings",
          ratingCountV2: "274",
        },
      },
    },
    {
      id: "69701549",
      name: "Samosa Pav (1 Pc)",
      category: "Maharashtrian",
      inStock: 1,
      isVeg: 1,
      price: 3300,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "58 ratings",
          ratingCountV2: "58",
        },
      },
    },
    {
      id: "69701550",
      name: "Batata Bhaji Pav",
      category: "Maharashtrian",
      description: "Serves 1",
      inStock: 1,
      isVeg: 1,
      price: 2700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "116 ratings",
          ratingCountV2: "116",
        },
      },
    },
    {
      id: "69958716",
      name: "Single Vada (1 Pc)",
      category: "Maharashtrian",
      description: "(Serves 1)",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "71 ratings",
          ratingCountV2: "71",
        },
      },
    },
    {
      id: "69958717",
      name: "Single Samosa (1 Pc)",
      category: "Maharashtrian",
      description: "(Serves 1)",
      inStock: 1,
      isVeg: 1,
      price: 2500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "40129681",
          groupName: "Add-on",
          choices: [
            {
              id: "27521800",
              name: "Green Chutney",
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "117 ratings",
          ratingCountV2: "117",
        },
      },
    },
    {
      id: "69958718",
      name: "Extra Pav (1 Pc)",
      category: "Maharashtrian",
      inStock: 1,
      isVeg: 1,
      price: 800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "72 ratings",
          ratingCountV2: "72",
        },
      },
    },
    {
      id: "70874205",
      name: "Misal Pav",
      category: "Maharashtrian",
      description: "Serves 1",
      imageId: "0eff3e17d06900561bbb807e65a40fa2",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "83 ratings",
          ratingCountV2: "83",
        },
      },
    },
    {
      id: "70874206",
      name: "Misal",
      category: "Maharashtrian",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "71701543",
      name: "Bread Paties",
      category: "Maharashtrian",
      description: "Serves 1",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "96 ratings",
          ratingCountV2: "96",
        },
      },
    },
    {
      id: "73402309",
      name: "Extra Chutney",
      category: "Maharashtrian",
      description: "Serves 1",
      inStock: 1,
      isVeg: 1,
      price: 1500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "59 ratings",
          ratingCountV2: "59",
        },
      },
    },
    {
      id: "96877425",
      name: "Vada Pav (pack Of 5)",
      category: "Maharashtrian",
      description: "Pack of 5 vada pavs. Save ?15!",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "86 ratings",
          ratingCountV2: "86",
        },
      },
    },
    {
      id: "96877427",
      name: "Vada Pav (pack Of 10)",
      category: "Maharashtrian",
      description: "Pack of 10 vada pavs. Save ?35!",
      inStock: 1,
      isVeg: 1,
      price: 24500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "96877430",
      name: "Vada (pack Of 5)",
      category: "Maharashtrian",
      description: "Pack of 5 vadas. Save ?11!",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "96877432",
      name: "Vada (pack Of 10)",
      category: "Maharashtrian",
      description: "Pack of 10 vadas. Save ?25!",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[ssd] = {
  "French Fries": [
    {
      id: "104696803",
      name: "Plain French Fries",
      category: "French Fries",
      description: "The perfect crispy potato sticks with salt",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104697100",
      name: "Cheesy French Fries",
      category: "French Fries",
      description: "The perfect crispy potato sticks, lots of cheese, yum!",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104697108",
      name: "Schezwan French Fries",
      category: "French Fries",
      description:
        "The perfect crispy potato sticks in chef-made schezwan sauce.",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104697109",
      name: "Peri Peri Franch Fries",
      category: "French Fries",
      description:
        "The perfect crispy potato sticks with peri peri spice, hot indeed",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Dabeli: [
    {
      id: "79724880",
      name: "Amul Dabeli",
      category: "Dabeli",
      description:
        "A traditional kutchi flavour potato filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, special masala peanuts, fresh chopped onion, toasted with amul butter on pan, served with sev (gram flour noodles), special masala peanuts, pineapple & cherry.",
      imageId: "gzljxvyfkkrhpgdsopwn",
      inStock: 1,
      isVeg: 1,
      price: 2500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "39 ratings",
          ratingCountV2: "39",
        },
      },
    },
    {
      id: "79724881",
      name: "Amul Dabeli With Cheese     ",
      category: "Dabeli",
      description:
        "A traditional kutchi flavour potato filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, special masala peanuts, fresh chopped onion, toasted with amul butter on pan, served with grated cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry.",
      imageId: "q6egbbcz0e2nnemfajdd",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "79724882",
      name: "Amul Special Butter Dabeli",
      category: "Dabeli",
      description:
        "A traditional kutchi flavour potato filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, special masala peanuts, fresh chopped onion, toasted with extra amul butter on pan, served with more sev (gram flour noodles), more special masala peanuts, pineapple & cherry.",
      inStock: 1,
      isVeg: 1,
      price: 3500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "27 ratings",
          ratingCountV2: "27",
        },
      },
    },
    {
      id: "79724884",
      name: "Amul Dabeli With Cheese & Mayonnaise",
      category: "Dabeli",
      description:
        "Amul cheese mayonnaise dabeli is combination ofkutchi& italian flavours.a traditional kutchi flavour potato filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, mayonnaise,special masala peanuts, fresh chopped onion, toasted with amul butter on pan, served with grated cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry.",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724885",
      name: "Kadak Misal",
      category: "Dabeli",
      description:
        "Kutchi kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, special masala peanuts, fresh chopped onion,served with sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "79724886",
      name: "Kadak Misal With Cheese",
      category: "Dabeli",
      description:
        "Kutchi kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, special masala peanuts, fresh chopped onion,served with cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724887",
      name: "Kadak Misal With Mayonnaise",
      category: "Dabeli",
      description:
        "Mayonnaise kadak misal is combination ofkutchi& italian flavours. Mayonnaise kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, mayonnaise, special masala peanuts, fresh chopped onion,served with sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724888",
      name: "Kadak Misal With Cheese & Mayonnaise",
      category: "Dabeli",
      description:
        "Cheese mayonnaise kadak misal is combination ofkutchi& italian flavours. Mayonnaise kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, mayonnaise, special masala peanuts, fresh chopped onion,served with grated cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      imageId: "rcerbnpvylhpkaetcxod",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "114099452",
      name: "Masala Peanuts",
      category: "Dabeli",
      description: " peanuts tossed in spicy masalas.",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Jain Dabeli": [
    {
      id: "79724889",
      name: "Jain Amul Dabeli",
      category: "Jain Dabeli",
      description:
        "A traditional kutchi flavour banana filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, special masala peanuts,  toasted with amul butter on pan, served with sev (gram flour noodles), special masala peanuts, pineapple & cherry.",
      inStock: 1,
      isVeg: 1,
      price: 2500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "79724890",
      name: "Jain Special Butter Dabeli",
      category: "Jain Dabeli",
      description:
        "A traditional kutchi flavour banana filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, special masala peanuts,  toasted with extra amul butter on pan, served with more sev (gram flour noodles), more special masala peanuts, pineapple & cherry",
      inStock: 1,
      isVeg: 1,
      price: 3500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724891",
      name: "Jain Amul Dabeli With Cheese",
      category: "Jain Dabeli",
      description:
        "A traditional kutchi flavour banana filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, special masala peanuts,  toasted with amul butter on pan, served with grated cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry.",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724892",
      name: "Jain Amul Dabeli With Mayonnaise",
      category: "Jain Dabeli",
      description:
        "Amul mayonnaise dabeli is combination of kutchi& italian flavours. A traditional kutchi flavour banana filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, mayonnaise, special masala peanuts, toasted with amul butter on pan, served with sev (gram flour noodles), special masala peanuts, pineapple & cherry.",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724893",
      name: "Jain Amul Dabeli With Cheese & Mayonnaise",
      category: "Jain Dabeli",
      description:
        "Amul cheese mayonnaise dabeli is combination of kutchi& italian flavours.a traditional kutchi flavour banana filling stuffed in a soft pav (bread, bun), sweet & spicy chutney, mayonnaise ,special masala peanuts, toasted with amul butter on pan, served with grated cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry.",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724894",
      name: "Jain Kadak Misal",
      category: "Jain Dabeli",
      description:
        "Kutchi kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, special masala peanuts, served with sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724895",
      name: "Jain Kadak Misal With Cheese",
      category: "Jain Dabeli",
      description:
        "Kutchi kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, special masala peanuts, served with cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724896",
      name: "Jain Kadak Misal With Mayonnaise",
      category: "Jain Dabeli",
      description:
        "Mayonnaise kadak misal is combination of kutchi & italian flavours. Mayonnaise kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, mayonnaise, special masala peanuts, served with sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724897",
      name: "Jain Kadak Misal With Cheese & Mayonnaise",
      category: "Jain Dabeli",
      description:
        "Cheese mayonnaise kadak misal is combination ofkutchi& italian flavours. Mayonnaise kadak misal is made with crisp rusk (jeera butter) instead of the bun. Which adds the most required crunch to it. Sweet & spicy chutney, mayonnaise, special masala peanuts, served with grated cheese, sev (gram flour noodles), special masala peanuts, pineapple & cherry. Looks like a bhelpuri. Real tasty, crunchy, tangy and a wholesome flavourful meal in.",
      imageId: "rcerbnpvylhpkaetcxod",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724898",
      name: "Jain Burger",
      category: "Jain Dabeli",
      description:
        "Our best selling burger with special raw banana patty, special jain chutney, crispy lettuce, juicy tomato & signature sauce.",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724899",
      name: "Jain Burger With Cheese",
      category: "Jain Dabeli",
      description:
        "Our best selling burger with special raw banana patty, special jain chutney, crispy lettuce, juicy tomato, signature sauce & cheese slice.",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "114099613",
      name: "Jain Masala Peanuts",
      category: "Jain Dabeli",
      description: "Peanuts tossed in spicy jain masalas.",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Burgers: [
    {
      id: "79724900",
      name: "Aloo Tikki Burger",
      category: "Burgers",
      description:
        "Our best selling burger with crispy potato patty, crispy lettuce, fresh onion, juicy tomato, special chutney &signature sauce",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "79724901",
      name: "Aloo Tikki With Cheese",
      category: "Burgers",
      description:
        "Our best selling burger with crispy potato patty, crispy lettuce, fresh onion, juicy tomato, special chutney, signature sauce &cheese slice.",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724902",
      name: "Peri Peri Burger",
      category: "Burgers",
      description:
        "Our best selling burger with special peri peri sauce, crispy vegetable patty, crispy lettuce ,fresh onion, juicy tomato & signature sauce.",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724903",
      name: "Peri Peri With Cheese",
      category: "Burgers",
      description:
        "Our best selling burger with special peri peri sauce, crispy vegetable patty, crispy lettuce,fresh onion, juicytomato, signature sauce &cheese slice.",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724904",
      name: "Schezwan Burger",
      category: "Burgers",
      description:
        "Schezwan burger is combination of american style & chinese taste.our special schezwan sauce, crispy vegetable patty, crispylettuce, fresh onions, juicy tomato & signature sauce",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724905",
      name: "Schezwan With Cheese",
      category: "Burgers",
      description:
        "Schezwan burger is combination of american style & chinese taste. Our special schezwan sauce, crispy vegetable patty, crispylettuce, fresh onions, juicy tomato, signature sauce &cheese slice.",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724906",
      name: "Veggie Burger",
      category: "Burgers",
      description:
        "Our best selling burger with crispy vegetable patty, crispy lettuce, fresh onion, juicy tomato & signature sauce.",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724907",
      name: "Veggie With Cheese",
      category: "Burgers",
      description:
        "Our best selling burger with crispy vegetable patty, crispy lettuce, fresh onion, juicy tomato, special chutney, signature sauce &cheese slice.",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Sandwich: [
    {
      id: "102893085",
      name: "Bread Butter",
      category: "Sandwich",
      description: "Fresh bread served with amul butter & salt.",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893086",
      name: "Veg Sandwich",
      category: "Sandwich",
      description:
        "Bread, amul butter, veggies such as boiled potatoes, juicy tomatoes, cucumbers, beets & fresh onions.",
      inStock: 1,
      isVeg: 1,
      price: 4600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "102893087",
      name: "Cheese Sandwich",
      category: "Sandwich",
      description:
        "Bread, amul butter, special chutney, veggies such as boiled potatoes, juicy tomatoes, cucumber, beet & fresh onions, grated cheese.",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893088",
      name: "Veg Mayo Sandwich",
      category: "Sandwich",
      description:
        "Bread, amul butter, special chutney, veggies such as boiled potatoes, juicy tomatoes, cucumber, beet & fresh onions, mayonnaise",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893089",
      name: "Masala Toast Sandwich",
      category: "Sandwich",
      description:
        "This lip-smacking masala toast features an indian spiced potato filling layered with crunchy vegetables, then toasted until crisp.",
      inStock: 1,
      isVeg: 1,
      price: 7200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893090",
      name: "Cheese Masala Toast Sandwich",
      category: "Sandwich",
      description:
        "This lip-smacking masala toast features an indian spiced potato filling layered with crunchy vegetables and cheese, then toasted until crisp.",
      inStock: 1,
      isVeg: 1,
      price: 11700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893091",
      name: "Veg Toast Sandwich",
      category: "Sandwich",
      description:
        "Bread, amul butter, special chutney, veggies such as boiled potatoes, juicy tomatoes, cucumber, beet, fresh onions, bell peppers then toasted until crisp.",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "102893092",
      name: "Cheese Veg Toast Sandwich",
      category: "Sandwich",
      description:
        "Bread, amul butter, special chutney, veggies such as boiled potatoes, juicy tomatoes, cucumber, beet, fresh onions, bell peppers and cheese, then toasted until crisp.",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "102893093",
      name: "Dabeli Toast Sandwich",
      category: "Sandwich",
      description:
        "A traditional kutchi flavour potato filling stuffed in a bread, spicy chutney, special masala peanuts, fresh chopped onion, bell peppers, then toasted until crisp.",
      inStock: 1,
      isVeg: 1,
      price: 7200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893094",
      name: "Cheese Dabeli Toast Sandwich",
      category: "Sandwich",
      description:
        "A traditional kutchi flavour potato filling stuffed in a bread, spicy chutney, special masala peanuts, fresh chopped onion, bell peppers, grated cheese, then toasted until crisp.",
      inStock: 1,
      isVeg: 1,
      price: 11700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893095",
      name: "Paneer Toast Sandwich",
      category: "Sandwich",
      description:
        "Enjoy the classic paneer sandwich with veggies such as juicy tomatoes, fresh onions, bell peppers served with tomato sauce.",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893096",
      name: "Cheese Paneer Toast Sandwich",
      category: "Sandwich",
      description:
        "Enjoy the classic paneer sandwich with veggies such as juicy tomatoes, fresh onions, bell peppers, grated cheese served with tomato sauce.",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893097",
      name: "Chutney Cheese Toast Sandwich",
      category: "Sandwich",
      description:
        "Bread, green chutney, grated cheese, toasted until crisp, served with tomato sauce.",
      inStock: 1,
      isVeg: 1,
      price: 7200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893098",
      name: "Jumbo Grill Sandwich",
      category: "Sandwich",
      description:
        "Triangle bread, amul butter, green chutney, veggies such as boiled potatoes, juicy tomatoes, fresh onions & green bell pepper, served with potato chips and green & red chutney, tomato sauce. ",
      inStock: 1,
      isVeg: 1,
      price: 11700,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893099",
      name: "Jumbo Cheese Grill Sandwich",
      category: "Sandwich",
      description:
        "Triangle bread, amul butter, special chutney, veggies such as boiled potatoes, juicy tomatoes, fresh onions, bell peppers, grated cheese, served with crispy potato chips and green & red chutney, tomato sauce. ",
      inStock: 1,
      isVeg: 1,
      price: 15600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893100",
      name: "Jumbo Cheese Overloaded Grill Sandwich",
      category: "Sandwich",
      description:
        "Triangle bread, amul butter, special chutney, veggies such as boiled potatoes, juicy tomatoes, fresh onions, bell peppers, double grated cheese, served with crispy potato chips and green & red chutney, tomato sauce.",
      inStock: 1,
      isVeg: 1,
      price: 19500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Pizza: [
    {
      id: "102893078",
      name: "Margherita Pizza",
      category: "Pizza",
      description:
        "Red tomato sauce, white mozzarella cheese and fresh green basils. With all of these delicious flavors a universally-adored pizza is prepared.",
      inStock: 1,
      isVeg: 1,
      price: 11700,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67463955",
          groupName: "Add  Ons",
          choices: [
            {
              id: "53820538",
              name: "Mayonnaise",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53820537",
              name: "Cheese",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893079",
      name: "Kurkure Pizza",
      category: "Pizza",
      description:
        "Kurkure pizza which is topped with red tomato sauce, white mozzarella cheese and guess what – kurkure sticks! ",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67463956",
          groupName: "Addons",
          choices: [
            {
              id: "53820538",
              name: "Mayonnaise",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53820537",
              name: "Cheese",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893080",
      name: "Masala Pizza",
      category: "Pizza",
      description:
        "Mozzarella cheese, tomatoes & our 4 types of special masalas is a spice mixture that has been ground into a powder which is used for cooking indian food.",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67463957",
          groupName: "Addons",
          choices: [
            {
              id: "53820538",
              name: "Mayonnaise",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53820537",
              name: "Cheese",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893081",
      name: "Corn Pizza",
      category: "Pizza",
      description:
        "Corn pizza is topped with sweet & juicy golden corns, onions, mozzarella cheese for that lipsmacking taste.",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67463958",
          groupName: "Addons",
          choices: [
            {
              id: "53820538",
              name: "Mayonnaise",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53820537",
              name: "Cheese",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893082",
      name: "Fresh Veggie Pizza",
      category: "Pizza",
      description:
        "Delightful combination of onion, capsicum, tomato, jalapeno pepper & mozzarella cheese.",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67463959",
          groupName: "Addons",
          choices: [
            {
              id: "53820538",
              name: "Mayonnaise",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53820537",
              name: "Cheese",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893083",
      name: "Tandoori Paneer Pizza",
      category: "Pizza",
      description:
        "Pizza topped with our signature tandoori sauce, crunchy onion, tomato, mozzarella cheese",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67463960",
          groupName: "Addons",
          choices: [
            {
              id: "53820538",
              name: "Mayonnaise",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53820537",
              name: "Cheese",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "102893084",
      name: "Peri Peri Paneer Pizza",
      category: "Pizza",
      description:
        "The awesome foursome! spiced red paprika paneer, onion, green capsicum & mozzarella cheese. ",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67463961",
          groupName: "Addons",
          choices: [
            {
              id: "53820538",
              name: "Mayonnaise",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53820537",
              name: "Cheese",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: -1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Beverages: [
    {
      id: "79724908",
      name: "Thums Up [200ml]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724909",
      name: "Sprite [200ml]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724910",
      name: "Jeera Masala [200ml]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724911",
      name: "Maaza [200ml]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724912",
      name: "Limca [200ml]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724914",
      name: "Kokam Sarbhat [200ml]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724917",
      name: "Mineral Water [500ml]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 1500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "79724918",
      name: "Mineral Water [1 L]",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[chineseWok] = {
  "Combos powered by RAW": [
    {
      id: "104900362",
      name: "Veg Manchurian with choice of Noodles + Juice",
      category: "Combos powered by RAW",
      description: "Serves 1",
      imageId: "5ecbd4ee563bd9cd36acd90c1717a0bb",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "22144478",
            name: "Noodle Bowl",
            variations: [
              {
                name: "Hakka Noodles",
                price: 324,
                default: 1,
                id: "72485243",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144479",
                  variationId: "72485247",
                },
              },
              {
                name: "Burnt Garlic Noodles",
                price: 324,
                id: "72485244",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144479",
                  variationId: "72485247",
                },
              },
              {
                name: "Chilli Garlic Noodles",
                price: 344,
                id: "72485245",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144479",
                  variationId: "72485247",
                },
              },
              {
                name: "Schezwan Noodles",
                price: 344,
                id: "72485246",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144479",
                  variationId: "72485247",
                },
              },
            ],
          },
          {
            groupId: "22144479",
            name: "Juice",
            variations: [
              {
                name: "Aloe Vera Lemonade",
                price: 1,
                default: 1,
                id: "72485247",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tender Coconut",
                price: 1,
                id: "72485248",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Alphonso Mango",
                price: 1,
                id: "72485249",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Mixed Fruit",
                price: 1,
                id: "72485250",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485243",
              },
              {
                groupId: "22144479",
                variationId: "72485247",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485243",
              },
              {
                groupId: "22144479",
                variationId: "72485248",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485243",
              },
              {
                groupId: "22144479",
                variationId: "72485249",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485243",
              },
              {
                groupId: "22144479",
                variationId: "72485250",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485244",
              },
              {
                groupId: "22144479",
                variationId: "72485247",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485244",
              },
              {
                groupId: "22144479",
                variationId: "72485248",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485244",
              },
              {
                groupId: "22144479",
                variationId: "72485249",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485244",
              },
              {
                groupId: "22144479",
                variationId: "72485250",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485245",
              },
              {
                groupId: "22144479",
                variationId: "72485247",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485245",
              },
              {
                groupId: "22144479",
                variationId: "72485248",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485245",
              },
              {
                groupId: "22144479",
                variationId: "72485249",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485245",
              },
              {
                groupId: "22144479",
                variationId: "72485250",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485246",
              },
              {
                groupId: "22144479",
                variationId: "72485247",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485246",
              },
              {
                groupId: "22144479",
                variationId: "72485248",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485246",
              },
              {
                groupId: "22144479",
                variationId: "72485249",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144478",
                variationId: "72485246",
              },
              {
                groupId: "22144479",
                variationId: "72485250",
              },
            ],
            price: 34500,
          },
        ],
      },
      itemAttribute: {
        portionSize: "Serves 1",
      },
      defaultPrice: 32500,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "104900364",
      name: "Veg Manchurian with choice of Rice + Juice",
      category: "Combos powered by RAW",
      description: "Serves 1",
      imageId: "93704affc446971b16703ae69a64315e",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "22144480",
            name: "Rice Bowl",
            variations: [
              {
                name: "Fried Rice",
                price: 324,
                default: 1,
                id: "72485251",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144481",
                  variationId: "72485255",
                },
              },
              {
                name: "Burnt Garlic Fried Rice",
                price: 324,
                id: "72485252",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144481",
                  variationId: "72485255",
                },
              },
              {
                name: "Chilli Garlic Fried Rice",
                price: 344,
                id: "72485253",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144481",
                  variationId: "72485255",
                },
              },
              {
                name: "Schezwan Fried Rice",
                price: 344,
                id: "72485254",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144481",
                  variationId: "72485255",
                },
              },
            ],
          },
          {
            groupId: "22144481",
            name: "Juice",
            variations: [
              {
                name: "Aloe Vera Lemonade",
                price: 1,
                default: 1,
                id: "72485255",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tender Coconut",
                price: 1,
                id: "72485256",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Alphonso Mango",
                price: 1,
                id: "72485257",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Mixed Fruit",
                price: 1,
                id: "72485258",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485251",
              },
              {
                groupId: "22144481",
                variationId: "72485255",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485251",
              },
              {
                groupId: "22144481",
                variationId: "72485256",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485251",
              },
              {
                groupId: "22144481",
                variationId: "72485257",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485251",
              },
              {
                groupId: "22144481",
                variationId: "72485258",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485252",
              },
              {
                groupId: "22144481",
                variationId: "72485255",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485252",
              },
              {
                groupId: "22144481",
                variationId: "72485256",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485252",
              },
              {
                groupId: "22144481",
                variationId: "72485257",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485252",
              },
              {
                groupId: "22144481",
                variationId: "72485258",
              },
            ],
            price: 32500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485253",
              },
              {
                groupId: "22144481",
                variationId: "72485255",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485253",
              },
              {
                groupId: "22144481",
                variationId: "72485256",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485253",
              },
              {
                groupId: "22144481",
                variationId: "72485257",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485253",
              },
              {
                groupId: "22144481",
                variationId: "72485258",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485254",
              },
              {
                groupId: "22144481",
                variationId: "72485255",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485254",
              },
              {
                groupId: "22144481",
                variationId: "72485256",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485254",
              },
              {
                groupId: "22144481",
                variationId: "72485257",
              },
            ],
            price: 34500,
          },
          {
            variations: [
              {
                groupId: "22144480",
                variationId: "72485254",
              },
              {
                groupId: "22144481",
                variationId: "72485258",
              },
            ],
            price: 34500,
          },
        ],
      },
      itemAttribute: {
        portionSize: "Serves 1",
      },
      defaultPrice: 32500,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104900365",
      name: "Kung Pao Chicken with choice of Noodles + Juice",
      category: "Combos powered by RAW",
      description: "Serves 1",
      imageId: "83612512ddf97a0048efd333ee886e6b",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "22144482",
            name: "Noodle Bowl",
            variations: [
              {
                name: "Hakka Noodles",
                price: 369,
                default: 1,
                id: "72485259",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144483",
                  variationId: "72485263",
                },
              },
              {
                name: "Burnt Garlic Noodles",
                price: 369,
                id: "72485260",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144483",
                  variationId: "72485263",
                },
              },
              {
                name: "Chilli Garlic Noodles",
                price: 389,
                id: "72485261",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144483",
                  variationId: "72485263",
                },
              },
              {
                name: "Schezwan Noodles",
                price: 389,
                id: "72485262",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144483",
                  variationId: "72485263",
                },
              },
            ],
          },
          {
            groupId: "22144483",
            name: "Juice",
            variations: [
              {
                name: "Aloe Vera Lemonade",
                price: 1,
                default: 1,
                id: "72485263",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tender Coconut",
                price: 1,
                id: "72485264",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Alphonso Mango",
                price: 1,
                id: "72485265",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Mixed Fruit",
                price: 1,
                id: "72485266",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485259",
              },
              {
                groupId: "22144483",
                variationId: "72485263",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485259",
              },
              {
                groupId: "22144483",
                variationId: "72485264",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485259",
              },
              {
                groupId: "22144483",
                variationId: "72485265",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485259",
              },
              {
                groupId: "22144483",
                variationId: "72485266",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485260",
              },
              {
                groupId: "22144483",
                variationId: "72485263",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485260",
              },
              {
                groupId: "22144483",
                variationId: "72485264",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485260",
              },
              {
                groupId: "22144483",
                variationId: "72485265",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485260",
              },
              {
                groupId: "22144483",
                variationId: "72485266",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485261",
              },
              {
                groupId: "22144483",
                variationId: "72485263",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485261",
              },
              {
                groupId: "22144483",
                variationId: "72485264",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485261",
              },
              {
                groupId: "22144483",
                variationId: "72485265",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485261",
              },
              {
                groupId: "22144483",
                variationId: "72485266",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485262",
              },
              {
                groupId: "22144483",
                variationId: "72485263",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485262",
              },
              {
                groupId: "22144483",
                variationId: "72485264",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485262",
              },
              {
                groupId: "22144483",
                variationId: "72485265",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144482",
                variationId: "72485262",
              },
              {
                groupId: "22144483",
                variationId: "72485266",
              },
            ],
            price: 39000,
          },
        ],
      },
      itemAttribute: {
        portionSize: "Serves 1",
      },
      defaultPrice: 37000,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104900366",
      name: "Chilli Chicken with Choice of Rice + Juice",
      category: "Combos powered by RAW",
      description: "Serves 1",
      imageId: "323ed4db81f86c0073ea81c61f70a041",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "22144484",
            name: "Rice Bowl",
            variations: [
              {
                name: "Fried Rice",
                price: 369,
                default: 1,
                id: "72485267",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144485",
                  variationId: "72485271",
                },
              },
              {
                name: "Burnt Garlic Fried Rice",
                price: 369,
                id: "72485268",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144485",
                  variationId: "72485271",
                },
              },
              {
                name: "Chilli Garlic Fried Rice",
                price: 389,
                id: "72485269",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144485",
                  variationId: "72485271",
                },
              },
              {
                name: "Schezwan Fried Rice",
                price: 389,
                id: "72485270",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "22144485",
                  variationId: "72485271",
                },
              },
            ],
          },
          {
            groupId: "22144485",
            name: "Juice",
            variations: [
              {
                name: "Aloe Vera Lemonade",
                price: 1,
                default: 1,
                id: "72485271",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Tender Coconut",
                price: 1,
                id: "72485272",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Alphonso Mango",
                price: 1,
                id: "72485273",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Mixed Fruit",
                price: 1,
                id: "72485274",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485267",
              },
              {
                groupId: "22144485",
                variationId: "72485271",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485267",
              },
              {
                groupId: "22144485",
                variationId: "72485272",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485267",
              },
              {
                groupId: "22144485",
                variationId: "72485273",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485267",
              },
              {
                groupId: "22144485",
                variationId: "72485274",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485268",
              },
              {
                groupId: "22144485",
                variationId: "72485271",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485268",
              },
              {
                groupId: "22144485",
                variationId: "72485272",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485268",
              },
              {
                groupId: "22144485",
                variationId: "72485273",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485268",
              },
              {
                groupId: "22144485",
                variationId: "72485274",
              },
            ],
            price: 37000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485269",
              },
              {
                groupId: "22144485",
                variationId: "72485271",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485269",
              },
              {
                groupId: "22144485",
                variationId: "72485272",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485269",
              },
              {
                groupId: "22144485",
                variationId: "72485273",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485269",
              },
              {
                groupId: "22144485",
                variationId: "72485274",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485270",
              },
              {
                groupId: "22144485",
                variationId: "72485271",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485270",
              },
              {
                groupId: "22144485",
                variationId: "72485272",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485270",
              },
              {
                groupId: "22144485",
                variationId: "72485273",
              },
            ],
            price: 39000,
          },
          {
            variations: [
              {
                groupId: "22144484",
                variationId: "72485270",
              },
              {
                groupId: "22144485",
                variationId: "72485274",
              },
            ],
            price: 39000,
          },
        ],
      },
      itemAttribute: {
        portionSize: "Serves 1",
      },
      defaultPrice: 37000,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Starters & Soup": [
    {
      id: "80599934",
      name: "Chicken Manchow Soup with Crispy Noodles",
      category: "Starters & Soup",
      description:
        "Serves 1 | A local favourite with chicken and egg topped with crunchy fried noodles.",
      imageId: "cyvqdhmgeuapscloyuxd",
      inStock: 1,
      price: 17900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69993284",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993330",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993352",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993264",
          groupName: "Add Non Veg Starters & Momos",
          choices: [
            {
              id: "53484559",
              name: "Chicken Spring Roll - 4 Pcs (Mini)",
              price: 20900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785204",
              name: "Steamed Chicken Classic Momos with Momo Chutney",
              price: 17400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785206",
              name: "Fried Chicken Classic Momos with Momo Chutney",
              price: 21400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785207",
              name: "Fried Chicken Corn n' Cheese Momos with Momo Chutney",
              price: 25400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993257",
          groupName: "Add Chicken Triple Schezwan Rice",
          choices: [
            {
              id: "58687251",
              name: "Chicken Triple Schezwan Rice",
              price: 35900,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "55 ratings",
          ratingCountV2: "55",
        },
      },
    },
    {
      id: "80600099",
      name: "Veg Manchow Soup with Crispy Noodles",
      category: "Starters & Soup",
      description:
        "Serves 1 | A local favourite with veggies topped with crunchy fried noodles.",
      imageId: "kwi6nvngkj1smlxupub2",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69995099",
          groupName: "Add Veg Triple Schezwan Rice",
          choices: [
            {
              id: "58687423",
              name: "Veg Triple Schezwan Rice",
              price: 31900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995111",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995136",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995155",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995102",
          groupName: "Add Veg Starters & Momos",
          choices: [
            {
              id: "55785458",
              name: "Veg Spring Roll - 4 Pcs (Mini)",
              price: 16900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785459",
              name: "Steamed Classic Veg Momos with Momo Chutney",
              price: 16400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785460",
              name: "Fried Classic Veg Momos with Momo Chutney",
              price: 20400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785461",
              name: "Fried Veg Corn n' Cheese Momos with Momo Chutney",
              price: 24400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "46 ratings",
          ratingCountV2: "46",
        },
      },
    },
    {
      id: "80600152",
      name: "Veg Schezwan Noodle Soup",
      category: "Starters & Soup",
      description:
        "Serves 1 | Mixed vegetables and boiled hakka noodles flavored with crowd favourite schezwan sauce.",
      imageId: "hcse6pbihlenzxsos2cr",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69997594",
          groupName: "Add Veg Triple Schezwan Rice",
          choices: [
            {
              id: "58687423",
              name: "Veg Triple Schezwan Rice",
              price: 31900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997613",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997676",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997701",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997600",
          groupName: "Add Veg Starters & Momos",
          choices: [
            {
              id: "55785458",
              name: "Veg Spring Roll - 4 Pcs (Mini)",
              price: 16900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785459",
              name: "Steamed Classic Veg Momos with Momo Chutney",
              price: 16400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785460",
              name: "Fried Classic Veg Momos with Momo Chutney",
              price: 20400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785461",
              name: "Fried Veg Corn n' Cheese Momos with Momo Chutney",
              price: 24400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "80600156",
      name: "Veg Spring Roll - 6 Pieces (Mini)",
      category: "Starters & Soup",
      description:
        "Serves 1 | Mixed vegetables & noodles encased in crispy spring roll sheet served with sweet chilli sauce.",
      imageId: "sshcj3uj4d4zm0g07thb",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69998401",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998385",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998458",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998492",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998370",
          groupName: "Add Veg Rice/Noodle",
          choices: [
            {
              id: "58687617",
              name: "Veg Fried Rice - Half",
              price: 17400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687613",
              name: "Veg Hakka Noodles - Half",
              price: 17900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "80600158",
      name: "Veg Manchurian Dry",
      category: "Starters & Soup",
      description:
        "Serves 1 | Mix veg fried balls, onion and capsicum tossed in classic manchurian sauce.",
      imageId: "kijeahmhwcth1bqxa5kw",
      inStock: 1,
      isVeg: 1,
      price: 26400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69998595",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998581",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998676",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998716",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998565",
          groupName: "Add Veg Rice/Noodle",
          choices: [
            {
              id: "58687617",
              name: "Veg Fried Rice - Half",
              price: 17400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687613",
              name: "Veg Hakka Noodles - Half",
              price: 17900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "33 ratings",
          ratingCountV2: "33",
        },
      },
    },
    {
      id: "80600159",
      name: "Kung Pao Paneer Dry",
      category: "Starters & Soup",
      description:
        "Serves 1 | Cubes Of Paneer, Onion, Capsicum Tossed With Kung Pao Sauce.",
      imageId: "yptzz3gakfzgs2uwhoyh",
      inStock: 1,
      isVeg: 1,
      price: 29900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69998831",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998814",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998899",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998937",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69998795",
          groupName: "Add Veg Rice/Noodle",
          choices: [
            {
              id: "58687617",
              name: "Veg Fried Rice - Half",
              price: 17400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687613",
              name: "Veg Hakka Noodles - Half",
              price: 17900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "80600161",
      name: "Chilli Paneer Dry",
      category: "Starters & Soup",
      description:
        "Serves 1 | Paneer cubes, green chillies, onion, capsicum tossed in desi chilli sauce finished with a punch of soya.",
      imageId: "ctpjdap1d284crbnunun",
      inStock: 1,
      isVeg: 1,
      price: 30900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69999036",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69999022",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69999116",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69999155",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69999006",
          groupName: "Add Veg Rice/Noodle",
          choices: [
            {
              id: "58687617",
              name: "Veg Fried Rice - Half",
              price: 17400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687613",
              name: "Veg Hakka Noodles - Half",
              price: 17900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "80600166",
      name: "Kung Pao Chicken Dry",
      category: "Starters & Soup",
      description: "Serves 1 | Chicken cubes tossed with kung pao sauce.",
      imageId: "t59z6dttoeahjprlu3zt",
      inStock: 1,
      price: 30900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69999739",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340819",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69999818",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69999861",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "81854978",
          groupName: "Add Non Veg Rice/Noodle",
          choices: [
            {
              id: "58687308",
              name: "Chicken Chinese Hakka Noodles - Half",
              price: 21900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687304",
              name: "Chicken Fried Rice - Half",
              price: 20400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "80600168",
      name: "Chilli Chicken Dry",
      category: "Starters & Soup",
      description:
        "Serves 1 | Diced chicken, green chillies, onion, capsicum tossed in desi chilli sauce finished with a punch of soya.",
      imageId: "kmhbqavvnlzebrocci0d",
      inStock: 1,
      price: 31900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69999966",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340821",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "70000023",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "70000072",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "81854979",
          groupName: "Add Non Veg Rice/Noodle",
          choices: [
            {
              id: "58687308",
              name: "Chicken Chinese Hakka Noodles - Half",
              price: 21900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687304",
              name: "Chicken Fried Rice - Half",
              price: 20400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "80600259",
      name: "Chicken Spring Roll - 6 Pieces (Mini)",
      category: "Starters & Soup",
      description:
        "Serves 1 | Minced chicken encased in crispy spring roll sheet served with sweet chilli sauce.",
      imageId: "sp8of7wja7aujseilcz3",
      inStock: 1,
      price: 27400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70002055",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340849",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "70002129",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "70002167",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "81854990",
          groupName: "Add Non Veg Rice/Noodle",
          choices: [
            {
              id: "58687308",
              name: "Chicken Chinese Hakka Noodles - Half",
              price: 21900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687304",
              name: "Chicken Fried Rice - Half",
              price: 20400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
  ],
  "Momos (Dumplings)": [
    {
      id: "104265155",
      name: "Veg Momos Tossed in Desi Chilli Sauce",
      category: "Momos (Dumplings)",
      description:
        "Serves 1 | (5 pcs) delicious mixture of chopped vegetables enveloped in a thin wrapper, pan fried till crispy and tossed in desi chilli sauce",
      imageId: "f3unpvamljnf8xgyukcs",
      inStock: 1,
      isVeg: 1,
      price: 23400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70017534",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "70017522",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "70017610",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "70017639",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "70017513",
          groupName: "Add Veg Spring Rolls",
          choices: [
            {
              id: "55785458",
              name: "Veg Spring Roll - 4 Pcs (Mini)",
              price: 16900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55789001",
              name: "Veg Spring Roll - 6 Pieces (Mini)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104265156",
      name: "Chicken Momos Tossed in Desi Chilli Sauce",
      category: "Momos (Dumplings)",
      description:
        "Serves 1 | (5 pcs) delicious mix of juicy minced chicken filling enveloped in a thin wrapper, pan fried till crispy tossed in Desi Chilli sauce.",
      imageId: "vir9g9h9ucrhn9e6mttj",
      inStock: 1,
      price: 27400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70017753",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "70017818",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "70017844",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "70017728",
          groupName: "Add Non Veg Spring Rolls",
          choices: [
            {
              id: "53484559",
              name: "Chicken Spring Roll - 4 Pcs (Mini)",
              price: 20900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785412",
              name: "Chicken Spring Roll - 6 Pieces (Mini)",
              price: 27400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Chinese Gravy": [
    {
      id: "80600129",
      name: "Veg Manchurian Gravy",
      category: "Chinese Gravy",
      description:
        "Serves 1 | Mix veg fried fritters, onion and capsicum tossed in classic manchurian sauce.",
      imageId: "jxlfpc8pbrlacbx4zhld",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15962853",
            name: "Manchurian Veg Gravy Half / Full",
            variations: [
              {
                name: "Manchurian Veg - Half",
                price: 209,
                default: 1,
                id: "53114692",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Manchurian Veg - Full",
                price: 279,
                id: "53114693",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15962853",
                variationId: "53114692",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "69996307",
                addonId: "53484560",
              },
              {
                groupId: "69996307",
                addonId: "53484629",
              },
              {
                groupId: "69996307",
                addonId: "53484630",
              },
              {
                groupId: "69996307",
                addonId: "53484631",
              },
              {
                groupId: "69996307",
                addonId: "53484632",
              },
              {
                groupId: "69996307",
                addonId: "53484633",
              },
              {
                groupId: "69996348",
                addonId: "53484561",
              },
              {
                groupId: "69996348",
                addonId: "53484562",
              },
              {
                groupId: "69996380",
                addonId: "48878889",
              },
              {
                groupId: "69996380",
                addonId: "55785146",
              },
              {
                groupId: "69996380",
                addonId: "55785148",
              },
              {
                groupId: "69996380",
                addonId: "55785150",
              },
              {
                groupId: "69996380",
                addonId: "55785152",
              },
              {
                groupId: "69996380",
                addonId: "55785153",
              },
              {
                groupId: "69996380",
                addonId: "58687222",
              },
              {
                groupId: "69996299",
                addonId: "58687617",
              },
              {
                groupId: "69996299",
                addonId: "58687618",
              },
              {
                groupId: "69996299",
                addonId: "58687619",
              },
              {
                groupId: "69996299",
                addonId: "58687620",
              },
              {
                groupId: "69996287",
                addonId: "58687613",
              },
              {
                groupId: "69996287",
                addonId: "58687614",
              },
              {
                groupId: "69996287",
                addonId: "58687615",
              },
              {
                groupId: "69996287",
                addonId: "58687616",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962853",
                variationId: "53114693",
              },
            ],
            price: 27900,
            addonCombinations: [
              {
                groupId: "69996307",
                addonId: "53484560",
              },
              {
                groupId: "69996307",
                addonId: "53484629",
              },
              {
                groupId: "69996307",
                addonId: "53484630",
              },
              {
                groupId: "69996307",
                addonId: "53484631",
              },
              {
                groupId: "69996307",
                addonId: "53484632",
              },
              {
                groupId: "69996307",
                addonId: "53484633",
              },
              {
                groupId: "69996348",
                addonId: "53484561",
              },
              {
                groupId: "69996348",
                addonId: "53484562",
              },
              {
                groupId: "69996380",
                addonId: "48878889",
              },
              {
                groupId: "69996380",
                addonId: "55785146",
              },
              {
                groupId: "69996380",
                addonId: "55785148",
              },
              {
                groupId: "69996380",
                addonId: "55785150",
              },
              {
                groupId: "69996380",
                addonId: "55785152",
              },
              {
                groupId: "69996380",
                addonId: "55785153",
              },
              {
                groupId: "69996380",
                addonId: "58687222",
              },
              {
                groupId: "69996299",
                addonId: "58687617",
              },
              {
                groupId: "69996299",
                addonId: "58687618",
              },
              {
                groupId: "69996299",
                addonId: "58687619",
              },
              {
                groupId: "69996299",
                addonId: "58687620",
              },
              {
                groupId: "69996287",
                addonId: "58687613",
              },
              {
                groupId: "69996287",
                addonId: "58687614",
              },
              {
                groupId: "69996287",
                addonId: "58687615",
              },
              {
                groupId: "69996287",
                addonId: "58687616",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "69996307",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69996348",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69996380",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69996299",
          groupName: "Add Veg Fried Rice",
          choices: [
            {
              id: "58687617",
              name: "Veg Fried Rice - Half",
              price: 17400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687618",
              name: "Veg Burnt Garlic Fried Rice - Half",
              price: 18400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687619",
              name: "Veg Chilli Garlic Fried Rice - Half",
              price: 19400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687620",
              name: "Veg Schezwan Fried Rice - Half",
              price: 21400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
        {
          groupId: "69996287",
          groupName: "Add Veg Noodles",
          choices: [
            {
              id: "58687613",
              name: "Veg Hakka Noodles - Half",
              price: 17900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687614",
              name: "Veg Burnt Garlic Fried Noodles - Half",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687615",
              name: "Veg Chilli Garlic Noodles - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687616",
              name: "Veg Schezwan Noodles - Half",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 20900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
  ],
  "Rice & Noodles": [
    {
      id: "80599922",
      name: "Chicken Burnt Garlic Fried Rice",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Rice egg, shredded chicken carrot, french beans & baby corn tossed with burnt garlic & coriander.",
      imageId: "ghluacc0jg3gvnpx3lyz",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15961955",
            name: "Chicken Burnt Garlic Fried Rice - Half/ Full",
            variations: [
              {
                name: "Chicken Burnt Garlic Fried Rice - Half",
                price: 224,
                default: 1,
                id: "53111534",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Burnt Garlic Fried Rice - Full",
                price: 269,
                id: "53111536",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15961955",
                variationId: "53111534",
              },
            ],
            price: 22400,
            addonCombinations: [
              {
                groupId: "69992540",
                addonId: "58687216",
              },
              {
                groupId: "69992540",
                addonId: "58687217",
              },
              {
                groupId: "69992540",
                addonId: "58687218",
              },
              {
                groupId: "69992540",
                addonId: "58687219",
              },
              {
                groupId: "69992540",
                addonId: "58687220",
              },
              {
                groupId: "69992540",
                addonId: "58687221",
              },
              {
                groupId: "69992551",
                addonId: "53484560",
              },
              {
                groupId: "69992551",
                addonId: "53484629",
              },
              {
                groupId: "69992551",
                addonId: "53484630",
              },
              {
                groupId: "69992551",
                addonId: "53484631",
              },
              {
                groupId: "69992551",
                addonId: "53484632",
              },
              {
                groupId: "69992551",
                addonId: "53484633",
              },
              {
                groupId: "82340668",
                addonId: "55785141",
              },
              {
                groupId: "82340668",
                addonId: "55785176",
              },
              {
                groupId: "82340668",
                addonId: "55785142",
              },
              {
                groupId: "82340668",
                addonId: "55785177",
              },
              {
                groupId: "69992580",
                addonId: "53484561",
              },
              {
                groupId: "69992580",
                addonId: "53484562",
              },
              {
                groupId: "69992603",
                addonId: "48878889",
              },
              {
                groupId: "69992603",
                addonId: "55785146",
              },
              {
                groupId: "69992603",
                addonId: "55785148",
              },
              {
                groupId: "69992603",
                addonId: "55785150",
              },
              {
                groupId: "69992603",
                addonId: "55785152",
              },
              {
                groupId: "69992603",
                addonId: "55785153",
              },
              {
                groupId: "69992603",
                addonId: "58687222",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15961955",
                variationId: "53111536",
              },
            ],
            price: 26900,
            addonCombinations: [
              {
                groupId: "69992540",
                addonId: "58687216",
              },
              {
                groupId: "69992540",
                addonId: "58687217",
              },
              {
                groupId: "69992540",
                addonId: "58687218",
              },
              {
                groupId: "69992540",
                addonId: "58687219",
              },
              {
                groupId: "69992540",
                addonId: "58687220",
              },
              {
                groupId: "69992540",
                addonId: "58687221",
              },
              {
                groupId: "69992551",
                addonId: "53484560",
              },
              {
                groupId: "69992551",
                addonId: "53484629",
              },
              {
                groupId: "69992551",
                addonId: "53484630",
              },
              {
                groupId: "69992551",
                addonId: "53484631",
              },
              {
                groupId: "69992551",
                addonId: "53484632",
              },
              {
                groupId: "69992551",
                addonId: "53484633",
              },
              {
                groupId: "82340668",
                addonId: "55785141",
              },
              {
                groupId: "82340668",
                addonId: "55785176",
              },
              {
                groupId: "82340668",
                addonId: "55785142",
              },
              {
                groupId: "82340668",
                addonId: "55785177",
              },
              {
                groupId: "69992580",
                addonId: "53484561",
              },
              {
                groupId: "69992580",
                addonId: "53484562",
              },
              {
                groupId: "69992603",
                addonId: "48878889",
              },
              {
                groupId: "69992603",
                addonId: "55785146",
              },
              {
                groupId: "69992603",
                addonId: "55785148",
              },
              {
                groupId: "69992603",
                addonId: "55785150",
              },
              {
                groupId: "69992603",
                addonId: "55785152",
              },
              {
                groupId: "69992603",
                addonId: "55785153",
              },
              {
                groupId: "69992603",
                addonId: "58687222",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "69992540",
          groupName: "Add Non Veg Gravy",
          choices: [
            {
              id: "58687216",
              name: "Chilli Oyster Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687217",
              name: "Black Pepper Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687218",
              name: "Chicken Schezwan Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687219",
              name: "Chilli Chicken Gravy- Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687220",
              name: "Chicken Manchurian Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687221",
              name: "Kung Pao Chicken - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69992551",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340668",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69992580",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69992603",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 22400,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "80599927",
      name: "Burnt Garlic Fried Rice",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Rice, carrot, french beans & baby corn tossed with burnt garlic & coriander.",
      imageId: "zljmjg7nuioadtbsscav",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15961979",
            name: "Veg Burnt Garlic Fried Rice - Half/ Full",
            variations: [
              {
                name: "Veg Burnt Garlic Fried Rice - Half",
                price: 184,
                default: 1,
                id: "53111615",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veg Burnt Garlic Fried Rice - Full",
                price: 229,
                id: "53111618",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15961979",
                variationId: "53111615",
              },
            ],
            price: 18400,
            addonCombinations: [
              {
                groupId: "69992729",
                addonId: "58687230",
              },
              {
                groupId: "69992729",
                addonId: "58687231",
              },
              {
                groupId: "69992729",
                addonId: "58687232",
              },
              {
                groupId: "69992729",
                addonId: "58687233",
              },
              {
                groupId: "69992729",
                addonId: "58687234",
              },
              {
                groupId: "69992729",
                addonId: "58687235",
              },
              {
                groupId: "69992729",
                addonId: "58687236",
              },
              {
                groupId: "69992729",
                addonId: "58687237",
              },
              {
                groupId: "69992729",
                addonId: "58687238",
              },
              {
                groupId: "69992729",
                addonId: "58687239",
              },
              {
                groupId: "69992729",
                addonId: "58687240",
              },
              {
                groupId: "69992729",
                addonId: "58687241",
              },
              {
                groupId: "69992742",
                addonId: "53484560",
              },
              {
                groupId: "69992742",
                addonId: "53484629",
              },
              {
                groupId: "69992742",
                addonId: "53484630",
              },
              {
                groupId: "69992742",
                addonId: "53484631",
              },
              {
                groupId: "69992742",
                addonId: "53484632",
              },
              {
                groupId: "69992742",
                addonId: "53484633",
              },
              {
                groupId: "69992739",
                addonId: "55785141",
              },
              {
                groupId: "69992739",
                addonId: "55785176",
              },
              {
                groupId: "69992739",
                addonId: "55785142",
              },
              {
                groupId: "69992739",
                addonId: "55785177",
              },
              {
                groupId: "69992774",
                addonId: "53484561",
              },
              {
                groupId: "69992774",
                addonId: "53484562",
              },
              {
                groupId: "69992799",
                addonId: "48878889",
              },
              {
                groupId: "69992799",
                addonId: "55785146",
              },
              {
                groupId: "69992799",
                addonId: "55785148",
              },
              {
                groupId: "69992799",
                addonId: "55785150",
              },
              {
                groupId: "69992799",
                addonId: "55785152",
              },
              {
                groupId: "69992799",
                addonId: "55785153",
              },
              {
                groupId: "69992799",
                addonId: "58687222",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15961979",
                variationId: "53111618",
              },
            ],
            price: 22900,
            addonCombinations: [
              {
                groupId: "69992729",
                addonId: "58687230",
              },
              {
                groupId: "69992729",
                addonId: "58687231",
              },
              {
                groupId: "69992729",
                addonId: "58687232",
              },
              {
                groupId: "69992729",
                addonId: "58687233",
              },
              {
                groupId: "69992729",
                addonId: "58687234",
              },
              {
                groupId: "69992729",
                addonId: "58687235",
              },
              {
                groupId: "69992729",
                addonId: "58687236",
              },
              {
                groupId: "69992729",
                addonId: "58687237",
              },
              {
                groupId: "69992729",
                addonId: "58687238",
              },
              {
                groupId: "69992729",
                addonId: "58687239",
              },
              {
                groupId: "69992729",
                addonId: "58687240",
              },
              {
                groupId: "69992729",
                addonId: "58687241",
              },
              {
                groupId: "69992742",
                addonId: "53484560",
              },
              {
                groupId: "69992742",
                addonId: "53484629",
              },
              {
                groupId: "69992742",
                addonId: "53484630",
              },
              {
                groupId: "69992742",
                addonId: "53484631",
              },
              {
                groupId: "69992742",
                addonId: "53484632",
              },
              {
                groupId: "69992742",
                addonId: "53484633",
              },
              {
                groupId: "69992739",
                addonId: "55785141",
              },
              {
                groupId: "69992739",
                addonId: "55785176",
              },
              {
                groupId: "69992739",
                addonId: "55785142",
              },
              {
                groupId: "69992739",
                addonId: "55785177",
              },
              {
                groupId: "69992774",
                addonId: "53484561",
              },
              {
                groupId: "69992774",
                addonId: "53484562",
              },
              {
                groupId: "69992799",
                addonId: "48878889",
              },
              {
                groupId: "69992799",
                addonId: "55785146",
              },
              {
                groupId: "69992799",
                addonId: "55785148",
              },
              {
                groupId: "69992799",
                addonId: "55785150",
              },
              {
                groupId: "69992799",
                addonId: "55785152",
              },
              {
                groupId: "69992799",
                addonId: "55785153",
              },
              {
                groupId: "69992799",
                addonId: "58687222",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "69992729",
          groupName: "Add Veg Gravy",
          choices: [
            {
              id: "58687230",
              name: "Chilli Oyster Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687231",
              name: "Chilli Oyster Paneer Gravy - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687232",
              name: "Black Pepper Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687233",
              name: "Black Pepper Paneer Gravy - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687234",
              name: "Chilli Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687235",
              name: "Chilli Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687236",
              name: "Schezwan Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687237",
              name: "Schezwan Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687238",
              name: "Kung Pao Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687239",
              name: "Kung Pao Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687240",
              name: "Manchurian Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687241",
              name: "Manchurian Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 12,
          maxFreeAddons: -1,
        },
        {
          groupId: "69992742",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69992739",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69992774",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69992799",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 18400,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "80599929",
      name: "Chicken Chinese Schezwan Fried Rice",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Rice tossed with shredded chicken, egg, carrot, french beans & baby corn in schezwan sauce. Garnished with spring onion.",
      imageId: "yfs1fikxllbj0pyjk6ke",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15961997",
            name: "Chicken Schezwan Fried Rice - Half/ Full",
            variations: [
              {
                name: "Chicken Schezwan Fried Rice - Half",
                price: 254,
                default: 1,
                id: "53111685",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Schezwan Fried Rice - Full",
                price: 299,
                id: "53111687",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15961997",
                variationId: "53111685",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "69993119",
                addonId: "58687216",
              },
              {
                groupId: "69993119",
                addonId: "58687217",
              },
              {
                groupId: "69993119",
                addonId: "58687218",
              },
              {
                groupId: "69993119",
                addonId: "58687219",
              },
              {
                groupId: "69993119",
                addonId: "58687220",
              },
              {
                groupId: "69993119",
                addonId: "58687221",
              },
              {
                groupId: "69993145",
                addonId: "53484560",
              },
              {
                groupId: "69993145",
                addonId: "53484629",
              },
              {
                groupId: "69993145",
                addonId: "53484630",
              },
              {
                groupId: "69993145",
                addonId: "53484631",
              },
              {
                groupId: "69993145",
                addonId: "53484632",
              },
              {
                groupId: "69993145",
                addonId: "53484633",
              },
              {
                groupId: "82340671",
                addonId: "55785141",
              },
              {
                groupId: "82340671",
                addonId: "55785176",
              },
              {
                groupId: "82340671",
                addonId: "55785142",
              },
              {
                groupId: "82340671",
                addonId: "55785177",
              },
              {
                groupId: "69993198",
                addonId: "53484561",
              },
              {
                groupId: "69993198",
                addonId: "53484562",
              },
              {
                groupId: "69993230",
                addonId: "48878889",
              },
              {
                groupId: "69993230",
                addonId: "55785146",
              },
              {
                groupId: "69993230",
                addonId: "55785148",
              },
              {
                groupId: "69993230",
                addonId: "55785150",
              },
              {
                groupId: "69993230",
                addonId: "55785152",
              },
              {
                groupId: "69993230",
                addonId: "55785153",
              },
              {
                groupId: "69993230",
                addonId: "58687222",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15961997",
                variationId: "53111687",
              },
            ],
            price: 29900,
            addonCombinations: [
              {
                groupId: "69993119",
                addonId: "58687216",
              },
              {
                groupId: "69993119",
                addonId: "58687217",
              },
              {
                groupId: "69993119",
                addonId: "58687218",
              },
              {
                groupId: "69993119",
                addonId: "58687219",
              },
              {
                groupId: "69993119",
                addonId: "58687220",
              },
              {
                groupId: "69993119",
                addonId: "58687221",
              },
              {
                groupId: "69993145",
                addonId: "53484560",
              },
              {
                groupId: "69993145",
                addonId: "53484629",
              },
              {
                groupId: "69993145",
                addonId: "53484630",
              },
              {
                groupId: "69993145",
                addonId: "53484631",
              },
              {
                groupId: "69993145",
                addonId: "53484632",
              },
              {
                groupId: "69993145",
                addonId: "53484633",
              },
              {
                groupId: "82340671",
                addonId: "55785141",
              },
              {
                groupId: "82340671",
                addonId: "55785176",
              },
              {
                groupId: "82340671",
                addonId: "55785142",
              },
              {
                groupId: "82340671",
                addonId: "55785177",
              },
              {
                groupId: "69993198",
                addonId: "53484561",
              },
              {
                groupId: "69993198",
                addonId: "53484562",
              },
              {
                groupId: "69993230",
                addonId: "48878889",
              },
              {
                groupId: "69993230",
                addonId: "55785146",
              },
              {
                groupId: "69993230",
                addonId: "55785148",
              },
              {
                groupId: "69993230",
                addonId: "55785150",
              },
              {
                groupId: "69993230",
                addonId: "55785152",
              },
              {
                groupId: "69993230",
                addonId: "55785153",
              },
              {
                groupId: "69993230",
                addonId: "58687222",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "69993145",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993119",
          groupName: "Add Non Veg Gravy",
          choices: [
            {
              id: "58687216",
              name: "Chilli Oyster Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687217",
              name: "Black Pepper Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687218",
              name: "Chicken Schezwan Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687219",
              name: "Chilli Chicken Gravy- Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687220",
              name: "Chicken Manchurian Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687221",
              name: "Kung Pao Chicken - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340671",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993198",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993230",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 25400,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "20 ratings",
          ratingCountV2: "20",
        },
      },
    },
    {
      id: "80599942",
      name: "Chicken Chinese Fried Rice",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Rice tossed with shredded chicken, egg & mixed veggies (carrot, french beans & baby corn) with a touch of seasoning sauce,  garnished with spring onion.",
      imageId: "ty7i6mufsllmhyr5ydop",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15962027",
            name: "Chicken Fried Rice - Half/ Full",
            variations: [
              {
                name: "Chicken Fried Rice - Half",
                price: 204,
                default: 1,
                id: "53111807",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Fried Rice - Full",
                price: 249,
                id: "53111810",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15962027",
                variationId: "53111807",
              },
            ],
            price: 20400,
            addonCombinations: [
              {
                groupId: "69993533",
                addonId: "58687216",
              },
              {
                groupId: "69993533",
                addonId: "58687217",
              },
              {
                groupId: "69993533",
                addonId: "58687218",
              },
              {
                groupId: "69993533",
                addonId: "58687219",
              },
              {
                groupId: "69993533",
                addonId: "58687220",
              },
              {
                groupId: "69993533",
                addonId: "58687221",
              },
              {
                groupId: "69993568",
                addonId: "53484560",
              },
              {
                groupId: "69993568",
                addonId: "53484629",
              },
              {
                groupId: "69993568",
                addonId: "53484630",
              },
              {
                groupId: "69993568",
                addonId: "53484631",
              },
              {
                groupId: "69993568",
                addonId: "53484632",
              },
              {
                groupId: "69993568",
                addonId: "53484633",
              },
              {
                groupId: "82340681",
                addonId: "55785141",
              },
              {
                groupId: "82340681",
                addonId: "55785176",
              },
              {
                groupId: "82340681",
                addonId: "55785142",
              },
              {
                groupId: "82340681",
                addonId: "55785177",
              },
              {
                groupId: "69993601",
                addonId: "53484561",
              },
              {
                groupId: "69993601",
                addonId: "53484562",
              },
              {
                groupId: "69993623",
                addonId: "48878889",
              },
              {
                groupId: "69993623",
                addonId: "55785146",
              },
              {
                groupId: "69993623",
                addonId: "55785148",
              },
              {
                groupId: "69993623",
                addonId: "55785150",
              },
              {
                groupId: "69993623",
                addonId: "55785152",
              },
              {
                groupId: "69993623",
                addonId: "55785153",
              },
              {
                groupId: "69993623",
                addonId: "58687222",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962027",
                variationId: "53111810",
              },
            ],
            price: 24900,
            addonCombinations: [
              {
                groupId: "69993533",
                addonId: "58687216",
              },
              {
                groupId: "69993533",
                addonId: "58687217",
              },
              {
                groupId: "69993533",
                addonId: "58687218",
              },
              {
                groupId: "69993533",
                addonId: "58687219",
              },
              {
                groupId: "69993533",
                addonId: "58687220",
              },
              {
                groupId: "69993533",
                addonId: "58687221",
              },
              {
                groupId: "69993568",
                addonId: "53484560",
              },
              {
                groupId: "69993568",
                addonId: "53484629",
              },
              {
                groupId: "69993568",
                addonId: "53484630",
              },
              {
                groupId: "69993568",
                addonId: "53484631",
              },
              {
                groupId: "69993568",
                addonId: "53484632",
              },
              {
                groupId: "69993568",
                addonId: "53484633",
              },
              {
                groupId: "82340681",
                addonId: "55785141",
              },
              {
                groupId: "82340681",
                addonId: "55785176",
              },
              {
                groupId: "82340681",
                addonId: "55785142",
              },
              {
                groupId: "82340681",
                addonId: "55785177",
              },
              {
                groupId: "69993601",
                addonId: "53484561",
              },
              {
                groupId: "69993601",
                addonId: "53484562",
              },
              {
                groupId: "69993623",
                addonId: "48878889",
              },
              {
                groupId: "69993623",
                addonId: "55785146",
              },
              {
                groupId: "69993623",
                addonId: "55785148",
              },
              {
                groupId: "69993623",
                addonId: "55785150",
              },
              {
                groupId: "69993623",
                addonId: "55785152",
              },
              {
                groupId: "69993623",
                addonId: "55785153",
              },
              {
                groupId: "69993623",
                addonId: "58687222",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "69993568",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993533",
          groupName: "Add Non Veg Gravy",
          choices: [
            {
              id: "58687216",
              name: "Chilli Oyster Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687217",
              name: "Black Pepper Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687218",
              name: "Chicken Schezwan Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687219",
              name: "Chilli Chicken Gravy- Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687220",
              name: "Chicken Manchurian Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687221",
              name: "Kung Pao Chicken - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340681",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993601",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993623",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 20400,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "55 ratings",
          ratingCountV2: "55",
        },
      },
    },
    {
      id: "80599959",
      name: "Chicken Chilli Garlic Noodles",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Noodles Tossed With Carrot, Cabbage & Onion Egg, Chicken Flavoured With Chilli Flakes, Garlic & Soy. Garnished With Spring Onion",
      imageId: "d4wmwa0in7rvrgp70vpu",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15962049",
            name: "Chicken Chilli Garlic Noodles - Half/ Full",
            variations: [
              {
                name: "Chicken Chilli Garlic Noodles - Half",
                price: 249,
                default: 1,
                id: "53111892",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Chicken Chilli Garlic Noodles - Full",
                price: 294,
                id: "53111893",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15962049",
                variationId: "53111892",
              },
            ],
            price: 24900,
            addonCombinations: [
              {
                groupId: "69993797",
                addonId: "58687216",
              },
              {
                groupId: "69993797",
                addonId: "58687217",
              },
              {
                groupId: "69993797",
                addonId: "58687218",
              },
              {
                groupId: "69993797",
                addonId: "58687219",
              },
              {
                groupId: "69993797",
                addonId: "58687220",
              },
              {
                groupId: "69993797",
                addonId: "58687221",
              },
              {
                groupId: "69993818",
                addonId: "53484560",
              },
              {
                groupId: "69993818",
                addonId: "53484629",
              },
              {
                groupId: "69993818",
                addonId: "53484630",
              },
              {
                groupId: "69993818",
                addonId: "53484631",
              },
              {
                groupId: "69993818",
                addonId: "53484632",
              },
              {
                groupId: "69993818",
                addonId: "53484633",
              },
              {
                groupId: "82340683",
                addonId: "55785141",
              },
              {
                groupId: "82340683",
                addonId: "55785176",
              },
              {
                groupId: "82340683",
                addonId: "55785142",
              },
              {
                groupId: "82340683",
                addonId: "55785177",
              },
              {
                groupId: "69993855",
                addonId: "53484561",
              },
              {
                groupId: "69993855",
                addonId: "53484562",
              },
              {
                groupId: "69993874",
                addonId: "48878889",
              },
              {
                groupId: "69993874",
                addonId: "55785146",
              },
              {
                groupId: "69993874",
                addonId: "55785148",
              },
              {
                groupId: "69993874",
                addonId: "55785150",
              },
              {
                groupId: "69993874",
                addonId: "55785152",
              },
              {
                groupId: "69993874",
                addonId: "55785153",
              },
              {
                groupId: "69993874",
                addonId: "58687222",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962049",
                variationId: "53111893",
              },
            ],
            price: 29400,
            addonCombinations: [
              {
                groupId: "69993797",
                addonId: "58687216",
              },
              {
                groupId: "69993797",
                addonId: "58687217",
              },
              {
                groupId: "69993797",
                addonId: "58687218",
              },
              {
                groupId: "69993797",
                addonId: "58687219",
              },
              {
                groupId: "69993797",
                addonId: "58687220",
              },
              {
                groupId: "69993797",
                addonId: "58687221",
              },
              {
                groupId: "69993818",
                addonId: "53484560",
              },
              {
                groupId: "69993818",
                addonId: "53484629",
              },
              {
                groupId: "69993818",
                addonId: "53484630",
              },
              {
                groupId: "69993818",
                addonId: "53484631",
              },
              {
                groupId: "69993818",
                addonId: "53484632",
              },
              {
                groupId: "69993818",
                addonId: "53484633",
              },
              {
                groupId: "82340683",
                addonId: "55785141",
              },
              {
                groupId: "82340683",
                addonId: "55785176",
              },
              {
                groupId: "82340683",
                addonId: "55785142",
              },
              {
                groupId: "82340683",
                addonId: "55785177",
              },
              {
                groupId: "69993855",
                addonId: "53484561",
              },
              {
                groupId: "69993855",
                addonId: "53484562",
              },
              {
                groupId: "69993874",
                addonId: "48878889",
              },
              {
                groupId: "69993874",
                addonId: "55785146",
              },
              {
                groupId: "69993874",
                addonId: "55785148",
              },
              {
                groupId: "69993874",
                addonId: "55785150",
              },
              {
                groupId: "69993874",
                addonId: "55785152",
              },
              {
                groupId: "69993874",
                addonId: "55785153",
              },
              {
                groupId: "69993874",
                addonId: "58687222",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "69993797",
          groupName: "Add Non Veg Gravy",
          choices: [
            {
              id: "58687216",
              name: "Chilli Oyster Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687217",
              name: "Black Pepper Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687218",
              name: "Chicken Schezwan Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687219",
              name: "Chilli Chicken Gravy- Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687220",
              name: "Chicken Manchurian Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687221",
              name: "Kung Pao Chicken - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993818",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340683",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993855",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69993874",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 24900,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "80600102",
      name: "Veg Chilli Garlic Noodles",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Noodles Tossed With Carrot, Cabbage & Onion Flavoured With Chilli Flakes, Garlic & Soy. Garnished With Spring Onion.",
      imageId: "ugfawjqo5v17itjkmor0",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15962573",
            name: "Veg Chilli Garlic Noodles - Half/ Full",
            variations: [
              {
                name: "Veg Chilli Garlic Noodles - Half",
                price: 209,
                default: 1,
                id: "53113669",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Veg Chilli Garlic Noodles - Full",
                price: 254,
                id: "53113670",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15962573",
                variationId: "53113669",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "69995186",
                addonId: "58687230",
              },
              {
                groupId: "69995186",
                addonId: "58687231",
              },
              {
                groupId: "69995186",
                addonId: "58687232",
              },
              {
                groupId: "69995186",
                addonId: "58687233",
              },
              {
                groupId: "69995186",
                addonId: "58687234",
              },
              {
                groupId: "69995186",
                addonId: "58687235",
              },
              {
                groupId: "69995186",
                addonId: "58687236",
              },
              {
                groupId: "69995186",
                addonId: "58687237",
              },
              {
                groupId: "69995186",
                addonId: "58687238",
              },
              {
                groupId: "69995186",
                addonId: "58687239",
              },
              {
                groupId: "69995186",
                addonId: "58687240",
              },
              {
                groupId: "69995186",
                addonId: "58687241",
              },
              {
                groupId: "69995213",
                addonId: "53484560",
              },
              {
                groupId: "69995213",
                addonId: "53484629",
              },
              {
                groupId: "69995213",
                addonId: "53484630",
              },
              {
                groupId: "69995213",
                addonId: "53484631",
              },
              {
                groupId: "69995213",
                addonId: "53484632",
              },
              {
                groupId: "69995213",
                addonId: "53484633",
              },
              {
                groupId: "69995204",
                addonId: "55785141",
              },
              {
                groupId: "69995204",
                addonId: "55785176",
              },
              {
                groupId: "69995204",
                addonId: "55785142",
              },
              {
                groupId: "69995204",
                addonId: "55785177",
              },
              {
                groupId: "69995235",
                addonId: "53484561",
              },
              {
                groupId: "69995235",
                addonId: "53484562",
              },
              {
                groupId: "69995260",
                addonId: "48878889",
              },
              {
                groupId: "69995260",
                addonId: "55785146",
              },
              {
                groupId: "69995260",
                addonId: "55785148",
              },
              {
                groupId: "69995260",
                addonId: "55785150",
              },
              {
                groupId: "69995260",
                addonId: "55785152",
              },
              {
                groupId: "69995260",
                addonId: "55785153",
              },
              {
                groupId: "69995260",
                addonId: "58687222",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962573",
                variationId: "53113670",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "69995186",
                addonId: "58687230",
              },
              {
                groupId: "69995186",
                addonId: "58687231",
              },
              {
                groupId: "69995186",
                addonId: "58687232",
              },
              {
                groupId: "69995186",
                addonId: "58687233",
              },
              {
                groupId: "69995186",
                addonId: "58687234",
              },
              {
                groupId: "69995186",
                addonId: "58687235",
              },
              {
                groupId: "69995186",
                addonId: "58687236",
              },
              {
                groupId: "69995186",
                addonId: "58687237",
              },
              {
                groupId: "69995186",
                addonId: "58687238",
              },
              {
                groupId: "69995186",
                addonId: "58687239",
              },
              {
                groupId: "69995186",
                addonId: "58687240",
              },
              {
                groupId: "69995186",
                addonId: "58687241",
              },
              {
                groupId: "69995213",
                addonId: "53484560",
              },
              {
                groupId: "69995213",
                addonId: "53484629",
              },
              {
                groupId: "69995213",
                addonId: "53484630",
              },
              {
                groupId: "69995213",
                addonId: "53484631",
              },
              {
                groupId: "69995213",
                addonId: "53484632",
              },
              {
                groupId: "69995213",
                addonId: "53484633",
              },
              {
                groupId: "69995204",
                addonId: "55785141",
              },
              {
                groupId: "69995204",
                addonId: "55785176",
              },
              {
                groupId: "69995204",
                addonId: "55785142",
              },
              {
                groupId: "69995204",
                addonId: "55785177",
              },
              {
                groupId: "69995235",
                addonId: "53484561",
              },
              {
                groupId: "69995235",
                addonId: "53484562",
              },
              {
                groupId: "69995260",
                addonId: "48878889",
              },
              {
                groupId: "69995260",
                addonId: "55785146",
              },
              {
                groupId: "69995260",
                addonId: "55785148",
              },
              {
                groupId: "69995260",
                addonId: "55785150",
              },
              {
                groupId: "69995260",
                addonId: "55785152",
              },
              {
                groupId: "69995260",
                addonId: "55785153",
              },
              {
                groupId: "69995260",
                addonId: "58687222",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "69995186",
          groupName: "Add Veg Gravy",
          choices: [
            {
              id: "58687230",
              name: "Chilli Oyster Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687231",
              name: "Chilli Oyster Paneer Gravy - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687232",
              name: "Black Pepper Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687233",
              name: "Black Pepper Paneer Gravy - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687234",
              name: "Chilli Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687235",
              name: "Chilli Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687236",
              name: "Schezwan Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687237",
              name: "Schezwan Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687238",
              name: "Kung Pao Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687239",
              name: "Kung Pao Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687240",
              name: "Manchurian Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687241",
              name: "Manchurian Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 12,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995213",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995204",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995235",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69995260",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      defaultPrice: 20900,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "62 ratings",
          ratingCountV2: "62",
        },
      },
    },
    {
      id: "80600147",
      name: "Veg Triple Schezwan Rice",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Rice & noodle with mixed vegetable tossed in schezwan sauce. Served with vegetable schezwan gravy.",
      imageId: "xkdbli6tfegpyb1xdlk6",
      inStock: 1,
      isVeg: 1,
      price: 31900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69996898",
          groupName: "Add Veg Gravy",
          choices: [
            {
              id: "58687230",
              name: "Chilli Oyster Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687231",
              name: "Chilli Oyster Paneer Gravy - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687232",
              name: "Black Pepper Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687233",
              name: "Black Pepper Paneer Gravy - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687234",
              name: "Chilli Veg Gravy - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687235",
              name: "Chilli Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687236",
              name: "Schezwan Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687237",
              name: "Schezwan Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687238",
              name: "Kung Pao Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687239",
              name: "Kung Pao Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687240",
              name: "Manchurian Veg - Half",
              price: 20900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687241",
              name: "Manchurian Paneer - Half",
              price: 23900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 12,
          maxFreeAddons: -1,
        },
        {
          groupId: "69996933",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69996924",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69996998",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997030",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "55 ratings",
          ratingCountV2: "55",
        },
      },
    },
    {
      id: "80600148",
      name: "Chicken Triple Schezwan Rice",
      category: "Rice & Noodles",
      description:
        "Serves 1 | Rice & noodle with diced chicken tossed in schezwan sauce. Garnished with a egg omlette. Served with chicken schezwan gravy.",
      imageId: "fu4xdkvzlbop9b49aaus",
      inStock: 1,
      price: 35900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69997127",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997091",
          groupName: "Add Non Veg Gravy",
          choices: [
            {
              id: "58687216",
              name: "Chilli Oyster Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687217",
              name: "Black Pepper Chicken Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687218",
              name: "Chicken Schezwan Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687219",
              name: "Chilli Chicken Gravy- Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687220",
              name: "Chicken Manchurian Gravy - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "58687221",
              name: "Kung Pao Chicken - Half",
              price: 24400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340779",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997179",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997221",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "41 ratings",
          ratingCountV2: "41",
        },
      },
    },
  ],
  "Make Your Own Wok": [
    {
      id: "80600069",
      name: "Veg Personal Wok Bowl",
      category: "Make Your Own Wok",
      description:
        "Serves 1 | Light eater - choice of any 1 rice/noodles, 1 sauce, 4 vegetables and 2 seasoning.",
      imageId: "srsld2kau1fuy3be7kiy",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15962289",
            name: "Rice/Noodles",
            variations: [
              {
                name: "Rice",
                price: 209,
                default: 1,
                id: "53112669",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "15962291",
                  variationId: "57523323",
                },
              },
              {
                name: "Noodles",
                price: 209,
                id: "53112671",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "15962291",
                  variationId: "57523323",
                },
              },
              {
                name: "Half Rice & Half Noodles",
                price: 209,
                id: "53112673",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "15962291",
                  variationId: "57523323",
                },
              },
            ],
          },
          {
            groupId: "15962291",
            name: "Sauces",
            variations: [
              {
                name: "Chilli Oyster  - (Less Spicy)",
                default: 1,
                id: "57523323",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Black Pepper",
                id: "57523324",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Desi Chilli - (Spicy)",
                id: "53112685",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Teriyaki - (Non Spicy)",
                id: "53112676",
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Manchurian - (Less Spicy)",
                id: "53112677",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Kung Pao - (Less Spicy)",
                id: "53112678",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan - (Spicy)",
                id: "53112679",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112669",
              },
              {
                groupId: "15962291",
                variationId: "57523323",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112669",
              },
              {
                groupId: "15962291",
                variationId: "57523324",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112669",
              },
              {
                groupId: "15962291",
                variationId: "53112685",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112669",
              },
              {
                groupId: "15962291",
                variationId: "53112676",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112669",
              },
              {
                groupId: "15962291",
                variationId: "53112677",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112669",
              },
              {
                groupId: "15962291",
                variationId: "53112678",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112669",
              },
              {
                groupId: "15962291",
                variationId: "53112679",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112671",
              },
              {
                groupId: "15962291",
                variationId: "57523323",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112671",
              },
              {
                groupId: "15962291",
                variationId: "57523324",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112671",
              },
              {
                groupId: "15962291",
                variationId: "53112685",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112671",
              },
              {
                groupId: "15962291",
                variationId: "53112676",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112671",
              },
              {
                groupId: "15962291",
                variationId: "53112677",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112671",
              },
              {
                groupId: "15962291",
                variationId: "53112678",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112671",
              },
              {
                groupId: "15962291",
                variationId: "53112679",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112673",
              },
              {
                groupId: "15962291",
                variationId: "57523323",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112673",
              },
              {
                groupId: "15962291",
                variationId: "57523324",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112673",
              },
              {
                groupId: "15962291",
                variationId: "53112685",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112673",
              },
              {
                groupId: "15962291",
                variationId: "53112676",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112673",
              },
              {
                groupId: "15962291",
                variationId: "53112677",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112673",
              },
              {
                groupId: "15962291",
                variationId: "53112678",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962289",
                variationId: "53112673",
              },
              {
                groupId: "15962291",
                variationId: "53112679",
              },
            ],
            price: 20900,
            addonCombinations: [
              {
                groupId: "52465041",
                addonId: "42992060",
              },
              {
                groupId: "52465041",
                addonId: "42992062",
              },
              {
                groupId: "52465041",
                addonId: "42992064",
              },
              {
                groupId: "52465041",
                addonId: "42992066",
              },
              {
                groupId: "52465041",
                addonId: "42992069",
              },
              {
                groupId: "52465041",
                addonId: "42992070",
              },
              {
                groupId: "52465041",
                addonId: "42992071",
              },
              {
                groupId: "52465041",
                addonId: "42992072",
              },
              {
                groupId: "52465047",
                addonId: "42991917",
              },
              {
                groupId: "52465047",
                addonId: "42991918",
              },
              {
                groupId: "52465047",
                addonId: "42991920",
              },
              {
                groupId: "52465047",
                addonId: "42991924",
              },
              {
                groupId: "52465047",
                addonId: "42991926",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "52465041",
          groupName: "Choose Vegetables",
          choices: [
            {
              id: "42992060",
              name: "Onion",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992062",
              name: "French Beans",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992064",
              name: "Capsicum",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992066",
              name: "Carrot",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992069",
              name: "Mushroom",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992070",
              name: "Cabbage",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992071",
              name: "Spring Onion",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992072",
              name: "Baby Corn",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "52465047",
          groupName: "Choose Seasoning",
          choices: [
            {
              id: "42991917",
              name: "Fried Onion",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991918",
              name: "Burnt Garlic",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991920",
              name: "Fresh Coriander",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991924",
              name: "Chilli Flakes",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991926",
              name: "Crispy Noodles",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
          minAddons: 2,
        },
      ],
      itemAttribute: {
        portionSize: "Serves 1",
      },
      defaultPrice: 20900,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "33 ratings",
          ratingCountV2: "33",
        },
      },
    },
    {
      id: "80600138",
      name: "Chicken Personal Wok Bowl",
      category: "Make Your Own Wok",
      description:
        "Serves 1 | Light eater - choice of any 1 rice/noodles, 1 sauce, 4 vegetables and 2 seasoning.",
      imageId: "ehqmv3lq2bcu1xctaxsi",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "15962933",
            name: "Rice/Noodles",
            variations: [
              {
                name: "Rice",
                price: 254,
                default: 1,
                id: "53114979",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "15962936",
                  variationId: "57525007",
                },
              },
              {
                name: "Noodles",
                price: 254,
                id: "53114981",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "15962936",
                  variationId: "57525007",
                },
              },
              {
                name: "Half Rice & Half Noodles",
                price: 254,
                id: "53114984",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
                dependantVariation: {
                  groupId: "15962936",
                  variationId: "57525007",
                },
              },
            ],
          },
          {
            groupId: "15962936",
            name: "Sauces",
            variations: [
              {
                name: "Chilli Oyster  - (Less Spicy)",
                default: 1,
                id: "57525007",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Black Pepper",
                id: "57525008",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Desi Chilli - (Spicy)",
                id: "53115001",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Teriyaki - (Non Spicy)",
                id: "53114986",
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Manchurian - (Less Spicy)",
                id: "53114989",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Kung Pao - (Less Spicy)",
                id: "53114990",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Schezwan - (Spicy)",
                id: "53114994",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114979",
              },
              {
                groupId: "15962936",
                variationId: "57525007",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114979",
              },
              {
                groupId: "15962936",
                variationId: "57525008",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114979",
              },
              {
                groupId: "15962936",
                variationId: "53115001",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114979",
              },
              {
                groupId: "15962936",
                variationId: "53114986",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114979",
              },
              {
                groupId: "15962936",
                variationId: "53114989",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114979",
              },
              {
                groupId: "15962936",
                variationId: "53114990",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114979",
              },
              {
                groupId: "15962936",
                variationId: "53114994",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114981",
              },
              {
                groupId: "15962936",
                variationId: "57525007",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114981",
              },
              {
                groupId: "15962936",
                variationId: "57525008",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114981",
              },
              {
                groupId: "15962936",
                variationId: "53115001",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114981",
              },
              {
                groupId: "15962936",
                variationId: "53114986",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114981",
              },
              {
                groupId: "15962936",
                variationId: "53114989",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114981",
              },
              {
                groupId: "15962936",
                variationId: "53114990",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114981",
              },
              {
                groupId: "15962936",
                variationId: "53114994",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114984",
              },
              {
                groupId: "15962936",
                variationId: "57525007",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114984",
              },
              {
                groupId: "15962936",
                variationId: "57525008",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114984",
              },
              {
                groupId: "15962936",
                variationId: "53115001",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114984",
              },
              {
                groupId: "15962936",
                variationId: "53114986",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114984",
              },
              {
                groupId: "15962936",
                variationId: "53114989",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114984",
              },
              {
                groupId: "15962936",
                variationId: "53114990",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
          {
            variations: [
              {
                groupId: "15962933",
                variationId: "53114984",
              },
              {
                groupId: "15962936",
                variationId: "53114994",
              },
            ],
            price: 25400,
            addonCombinations: [
              {
                groupId: "52465928",
                addonId: "42992060",
              },
              {
                groupId: "52465928",
                addonId: "42992062",
              },
              {
                groupId: "52465928",
                addonId: "42992064",
              },
              {
                groupId: "52465928",
                addonId: "42992066",
              },
              {
                groupId: "52465928",
                addonId: "42992069",
              },
              {
                groupId: "52465928",
                addonId: "42992070",
              },
              {
                groupId: "52465928",
                addonId: "42992071",
              },
              {
                groupId: "52465928",
                addonId: "42992072",
              },
              {
                groupId: "52465939",
                addonId: "42991917",
              },
              {
                groupId: "52465939",
                addonId: "42991918",
              },
              {
                groupId: "52465939",
                addonId: "42991920",
              },
              {
                groupId: "52465939",
                addonId: "42991924",
              },
              {
                groupId: "52465939",
                addonId: "42991926",
              },
            ],
          },
        ],
      },
      addons: [
        {
          groupId: "52465928",
          groupName: "Choose Vegetables",
          choices: [
            {
              id: "42992060",
              name: "Onion",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992062",
              name: "French Beans",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992064",
              name: "Capsicum",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992066",
              name: "Carrot",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992069",
              name: "Mushroom",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992070",
              name: "Cabbage",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992071",
              name: "Spring Onion",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42992072",
              name: "Baby Corn",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
          minAddons: 1,
        },
        {
          groupId: "52465939",
          groupName: "Choose Seasoning",
          choices: [
            {
              id: "42991917",
              name: "Fried Onion",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991918",
              name: "Burnt Garlic",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991920",
              name: "Fresh Coriander",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991924",
              name: "Chilli Flakes",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "42991926",
              name: "Crispy Noodles",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
          minAddons: 2,
        },
      ],
      itemAttribute: {
        portionSize: "Serves 1",
      },
      defaultPrice: 25400,
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "31 ratings",
          ratingCountV2: "31",
        },
      },
    },
  ],
  "Value Wok (For Light Eaters)": [
    {
      id: "80599987",
      name: "Chicken Hakka Noodles",
      category: "Value Wok (For Light Eaters)",
      description:
        "Serves 1 | Noodles tossed with egg, chicken, onion, cabbage, carrot with a touch of dark soya. Garnished with spring onion.",
      imageId: "ywrmwgb4fapmsih6xbk2",
      inStock: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69994248",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "82340701",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69994273",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69994288",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69994233",
          groupName: "Add Non Veg Starters & Momos",
          choices: [
            {
              id: "53484559",
              name: "Chicken Spring Roll - 4 Pcs (Mini)",
              price: 20900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785204",
              name: "Steamed Chicken Classic Momos with Momo Chutney",
              price: 17400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785206",
              name: "Fried Chicken Classic Momos with Momo Chutney",
              price: 21400,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785207",
              name: "Fried Chicken Corn n' Cheese Momos with Momo Chutney",
              price: 25400,
              inStock: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "40 ratings",
          ratingCountV2: "40",
        },
      },
    },
    {
      id: "80600150",
      name: "Veg Hakka Noodles",
      category: "Value Wok (For Light Eaters)",
      description:
        "Serves 1 | Noodles tossed with onion, cabbage & carrot with a touch of dark soya. Garnished with spring onion.",
      imageId: "ywrmwgb4fapmsih6xbk2",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69997292",
          groupName: "Add Extra Dips",
          choices: [
            {
              id: "53484560",
              name: "Extra Schezwan Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484629",
              name: "Extra Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484630",
              name: "Extra Sweet Chilli Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484631",
              name: "Extra Tandoori Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484632",
              name: "Extra Mint Mayo Dip",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484633",
              name: "Extra Momo Chutney",
              price: 2000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 6,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997283",
          groupName: "Add  Soup",
          choices: [
            {
              id: "55785141",
              name: "Chicken Manchow Soup with Crispy Noodles",
              price: 17900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785176",
              name: "Veg Manchow Soup with Crispy Noodles",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785142",
              name: "Chicken Schezwan Noodle Soup",
              price: 19900,
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "55785177",
              name: "Veg Schezwan Noodle Soup",
              price: 15400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997345",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997383",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
        {
          groupId: "69997271",
          groupName: "Add Veg Starters & Momos",
          choices: [
            {
              id: "55785458",
              name: "Veg Spring Roll - 4 Pcs (Mini)",
              price: 16900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785459",
              name: "Steamed Classic Veg Momos with Momo Chutney",
              price: 16400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785460",
              name: "Fried Classic Veg Momos with Momo Chutney",
              price: 20400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785461",
              name: "Fried Veg Corn n' Cheese Momos with Momo Chutney",
              price: 24400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "101 ratings",
          ratingCountV2: "101",
        },
      },
    },
  ],
  Desserts: [
    {
      id: "80600146",
      name: "Choco Lava",
      category: "Desserts",
      description:
        "Serves 1 | Rich chocolate cake with molten chocolate center, served warm.",
      imageId: "ledjxwcs2vbfd8rnmsgb",
      inStock: 1,
      isVeg: 1,
      price: 9900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "80600190",
      name: "Chocolate Mousse",
      category: "Desserts",
      description:
        "Serves 1 | Creamy chocolate mousse layered with moist chocolate cake.",
      imageId: "x23wx7p7hlequ4stovdc",
      inStock: 1,
      isVeg: 1,
      price: 9900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70000364",
          groupName: "Add Drinks",
          choices: [
            {
              id: "48878889",
              name: "Pepsi Pet Bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785146",
              name: "7 Up pet bottle",
              price: 6000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785148",
              name: "Aloe Vera Lemonade (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785150",
              name: "Tender Coconut",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785152",
              name: "Alphonso Mango  (Save Rs. 60) 180 ml",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "55785153",
              name: "Mixed Fruit",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "58687222",
              name: "Aquafina",
              price: 1000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 7,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
  ],
  Drinks: [
    {
      id: "80599984",
      name: "7 Up pet bottle",
      category: "Drinks",
      description: "Serves 1",
      imageId: "lpdhsbtoluz7uvflydbr",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69994159",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "80600144",
      name: "Pepsi pet bottle",
      category: "Drinks",
      description: "Serves 1",
      imageId: "v73dbzh71l7haeywdrxl",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "69996772",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "99586398",
      name: "Aquafina",
      category: "Drinks",
      description: "Serves 1 | Drinks",
      imageId: "13d447605819f7ce3e2c48c38f752292",
      inStock: 1,
      isVeg: 1,
      price: 1000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70014904",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "104979254",
      name: "Aloe vera Lemonade",
      category: "Drinks",
      description: "Serves 1",
      imageId: "4dfb298fb533d4bcebe87ea2d2cdef63",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70158825",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104979255",
      name: "Tender Coconut",
      category: "Drinks",
      description: "Serves 1",
      imageId: "bd1bbe41f00ad365f0b6a092a193c7f9",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70158826",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "104979256",
      name: "Alphonso Mango",
      category: "Drinks",
      description: "Serves 1",
      imageId: "ddba490d85eb69f607595daccf43d920",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70158827",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104979257",
      name: "Mixed Fruit",
      category: "Drinks",
      description: "Serves 1",
      imageId: "23dbf9a94e2e6e816e6b65afee87aab0",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "70158828",
          groupName: "Add Dessert",
          choices: [
            {
              id: "53484561",
              name: "Chocolate Mousse (Save Rs. 20)",
              price: 8000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "53484562",
              name: "Choco Lava",
              price: 9900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Extras: [
    {
      id: "104900356",
      name: "Extra Schezwan Dip",
      category: "Extras",
      description: "Serves 1",
      imageId: "212ae51f7aea4f7d25f6602e2ee9f346",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "104900357",
      name: "Extra Mayo Dip",
      category: "Extras",
      description: "Serves 1",
      imageId: "9b578193f0ea8b29b0256e8dbae32909",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104900358",
      name: "Extra Sweet Chilli Dip",
      category: "Extras",
      description: "Serves 1",
      imageId: "36f8f93fbd9b582f4f5b7387bf1cdd54",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104900359",
      name: "Extra Tandoori Mayo Dip",
      category: "Extras",
      description: "Serves 1",
      imageId: "21a0e5d7e6631e9df52f557b38afa7c8",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "104900360",
      name: "Extra Mint Mayo Dip",
      category: "Extras",
      description: "Serves 1",
      imageId: "06dc8fbb87f6a6dfd2fc742b912504f5",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104900361",
      name: "Extra Momo Chutney",
      category: "Extras",
      description: "Serves 1",
      imageId: "c6f0184c974776535686bc4b44e5713a",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
        portionSize: "Serves 1",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE TRYNEW",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[rajusPizzaCorner] = {
  Pizza: [
    {
      id: "108218998",
      name: "Cheese Schezwan Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615560",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658742",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658743",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658744",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615560",
                variationId: "76658742",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615560",
                variationId: "76658743",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615560",
                variationId: "76658744",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219000",
      name: "Dryfruit Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615562",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 140,
                default: 1,
                id: "76658747",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 266,
                id: "76658748",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 499,
                id: "76658749",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615562",
                variationId: "76658747",
              },
            ],
            price: 14000,
          },
          {
            variations: [
              {
                groupId: "23615562",
                variationId: "76658748",
              },
            ],
            price: 26600,
          },
          {
            variations: [
              {
                groupId: "23615562",
                variationId: "76658749",
              },
            ],
            price: 49900,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219002",
      name: "Golden Crown Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615564",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658752",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658753",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658754",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615564",
                variationId: "76658752",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615564",
                variationId: "76658753",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615564",
                variationId: "76658754",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219004",
      name: "Mayonnaise Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615566",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658757",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658758",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658759",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615566",
                variationId: "76658757",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615566",
                variationId: "76658758",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615566",
                variationId: "76658759",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219006",
      name: "Mozzarella Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615568",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658762",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658763",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658764",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615568",
                variationId: "76658762",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615568",
                variationId: "76658763",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615568",
                variationId: "76658764",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219008",
      name: "Mushroom Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615570",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658767",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658768",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658769",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615570",
                variationId: "76658767",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615570",
                variationId: "76658768",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615570",
                variationId: "76658769",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219010",
      name: "Olive Onion Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615572",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658772",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658773",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658774",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615572",
                variationId: "76658772",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615572",
                variationId: "76658773",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615572",
                variationId: "76658774",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219012",
      name: "Only Cheese Mozzarella Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615573",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658775",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658776",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658777",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615573",
                variationId: "76658775",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615573",
                variationId: "76658776",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615573",
                variationId: "76658777",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "108219013",
      name: "Only Cheese Pizza",
      category: "Pizza",
      imageId: "ac1ca757d2f347695f9a808f3ae78006",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615575",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658780",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658781",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658782",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615575",
                variationId: "76658780",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615575",
                variationId: "76658781",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615575",
                variationId: "76658782",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219014",
      name: "Paneer Cheese Pizza",
      category: "Pizza",
      imageId: "fb35c6804eb429045a31ba350c485ea1",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615576",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658783",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658784",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658785",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615576",
                variationId: "76658783",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615576",
                variationId: "76658784",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615576",
                variationId: "76658785",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "108219015",
      name: "Paneer Mozarella Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615577",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 126,
                default: 1,
                id: "76658786",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 238,
                id: "76658787",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 448,
                id: "76658788",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615577",
                variationId: "76658786",
              },
            ],
            price: 12600,
          },
          {
            variations: [
              {
                groupId: "23615577",
                variationId: "76658787",
              },
            ],
            price: 23800,
          },
          {
            variations: [
              {
                groupId: "23615577",
                variationId: "76658788",
              },
            ],
            price: 44800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219017",
      name: "Peri Peri Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615579",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 140,
                default: 1,
                id: "76658791",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 266,
                id: "76658792",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 499,
                id: "76658793",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615579",
                variationId: "76658791",
              },
            ],
            price: 14000,
          },
          {
            variations: [
              {
                groupId: "23615579",
                variationId: "76658792",
              },
            ],
            price: 26600,
          },
          {
            variations: [
              {
                groupId: "23615579",
                variationId: "76658793",
              },
            ],
            price: 49900,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219018",
      name: "Pineapple Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615580",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658794",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658795",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658796",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615580",
                variationId: "76658794",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615580",
                variationId: "76658795",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615580",
                variationId: "76658796",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219019",
      name: "Raju's Special Pizza",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615581",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 168,
                default: 1,
                id: "76658797",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 306,
                id: "76658798",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 600,
                id: "76658799",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615581",
                variationId: "76658797",
              },
            ],
            price: 16800,
          },
          {
            variations: [
              {
                groupId: "23615581",
                variationId: "76658798",
              },
            ],
            price: 30600,
          },
          {
            variations: [
              {
                groupId: "23615581",
                variationId: "76658799",
              },
            ],
            price: 60000,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 16800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "108219022",
      name: "Schezwan Paneer Pizza",
      category: "Pizza",
      imageId: "80881a748eda71a22b13c314aad78892",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615584",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 126,
                default: 1,
                id: "76658804",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 234,
                id: "76658805",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 414,
                id: "76658806",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615584",
                variationId: "76658804",
              },
            ],
            price: 12600,
          },
          {
            variations: [
              {
                groupId: "23615584",
                variationId: "76658805",
              },
            ],
            price: 23400,
          },
          {
            variations: [
              {
                groupId: "23615584",
                variationId: "76658806",
              },
            ],
            price: 41400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12600,
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219023",
      name: "Sweet Corn Pizza",
      category: "Pizza",
      imageId: "63d8ceba3208a37e85ef9063b0764d63",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615585",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 112,
                default: 1,
                id: "76658807",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658809",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 392,
                id: "76658810",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615585",
                variationId: "76658807",
              },
            ],
            price: 11200,
          },
          {
            variations: [
              {
                groupId: "23615585",
                variationId: "76658809",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615585",
                variationId: "76658810",
              },
            ],
            price: 39200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11200,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "2.4",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "108219025",
      name: "Veg Cheese Pizza",
      category: "Pizza",
      imageId: "98ecacfec57c61f1037dff86e4432c19",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615587",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 98,
                default: 1,
                id: "76658812",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 182,
                id: "76658813",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 336,
                id: "76658814",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615587",
                variationId: "76658812",
              },
            ],
            price: 9800,
          },
          {
            variations: [
              {
                groupId: "23615587",
                variationId: "76658813",
              },
            ],
            price: 18200,
          },
          {
            variations: [
              {
                groupId: "23615587",
                variationId: "76658814",
              },
            ],
            price: 33600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9800,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
  ],
  "Garlic Bread": [
    {
      id: "62298738",
      name: "Capsicum Cheese Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298739",
      name: "Mushroom Cheese Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298741",
      name: "Golden Crown Cheese Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298743",
      name: "Sweet Corn Cheese Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "62298744",
      name: "Paneer Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298883",
      name: "Cheese Garlic Bread",
      category: "Garlic Bread",
      imageId: "145cb6fd12336064f09ec28cf5f097d9",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "62298884",
      name: "Chilly Cheese Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "62298886",
      name: "Schezwan Garlic Cheese Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298888",
      name: "Onion Cheese Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219031",
      name: "Mayonnaise Mozarella Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219033",
      name: "Mozarella Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219035",
      name: "Mozarella Paneer Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219037",
      name: "Mushroom Schezwan Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219041",
      name: "Peri Peri Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219042",
      name: "Raju's S Special Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219045",
      name: "Sweet Schezwan Garlic Bread",
      category: "Garlic Bread",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "French Fries": [
    {
      id: "62298750",
      name: "Salted Fries",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "62298753",
      name: "Butter Fries",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "62298754",
      name: "Cheese Fries",
      category: "French Fries",
      imageId: "a2f4ac1848e7204d9be904a2cc66582f",
      inStock: 1,
      isVeg: 1,
      price: 12600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "62298755",
      name: "Peri Peri Fries",
      category: "French Fries",
      imageId: "e8e4a116598c86f6bd31b9accc31ea77",
      inStock: 1,
      isVeg: 1,
      price: 12600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298758",
      name: "Garlic Fries",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 12600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "93093746",
      name: "Cheese Shots",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219049",
      name: "Cheese Mayo Garlic Schezwan Fries",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 18600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219051",
      name: "Chilly Cheese Balls",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219056",
      name: "Mayo Chilly Fries",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219057",
      name: "Potato Drop",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 12600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219058",
      name: "Schezwan Cheese Fries",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219059",
      name: "Smiles",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219060",
      name: "Veggie Stick",
      category: "French Fries",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Grill Sandwiches": [
    {
      id: "62298783",
      name: "Cheese Grill Sandwich",
      category: "Grill Sandwiches",
      imageId: "c8751d7b960277b7b8c0234419c6eeae",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "47 ratings",
          ratingCountV2: "47",
        },
      },
    },
    {
      id: "62298785",
      name: "Jain Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298794",
      name: "Paneer Grill Sandwich",
      category: "Grill Sandwiches",
      imageId: "63701426e311e48dfb9f59ad5fea68f1",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "62298797",
      name: "Mushroom Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "62298798",
      name: "Sweet Corn Cheese Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298803",
      name: "Club Grill Sandwich",
      category: "Grill Sandwiches",
      imageId: "5658fa86652c5fa56f76879ae7a6ee79",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "62298808",
      name: "Chilly Cheese Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 19600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298809",
      name: "Paneer Chilly Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298811",
      name: "Schezwan Sweet Corn Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219066",
      name: "Jain Mozarella Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219067",
      name: "Mozarella Cheese Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219068",
      name: "Mozarella Chilly Cheese Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219069",
      name: "Mozarella Club Grill Sandwich",
      category: "Grill Sandwiches",
      imageId: "d316989f9a1c97e5a742e8f4ed323d3b",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219070",
      name: "Schezwan Mozarella Grill Sandwich",
      category: "Grill Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Frankie: [
    {
      id: "63007789",
      name: "Sada Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "63007791",
      name: "Cheese Schezwan Frankie",
      category: "Frankie",
      imageId: "0ccc5488f193d5e34add69aa78d1ce07",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "63007792",
      name: "Mushroom Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "63007796",
      name: "Cheese Mayonnaise Frankie",
      category: "Frankie",
      imageId: "5f2db94f51d989b255383fe2496c90c7",
      inStock: 1,
      isVeg: 1,
      price: 10800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "63007801",
      name: "Noodles Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "63007802",
      name: "Noodles Cheese Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "63007803",
      name: "Noodles Paneer Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "63007805",
      name: "Noodles Schezwan Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "63007810",
      name: "Noodles Mushroom Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "63007812",
      name: "Noodles Mushroom Paneer Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219129",
      name: "Cheese Frankie",
      category: "Frankie",
      imageId: "020563929a6c84c0414b015fc30ccf22",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "108219130",
      name: "Cheese Sweet Corn Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219131",
      name: "Mayonnaise Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219132",
      name: "Mushroom Cheese Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219133",
      name: "Mushroom Paneer Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 10800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219134",
      name: "Mushroom Sweet Corn Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 10800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219135",
      name: "Noodles Cheese Paneer Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 10800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219136",
      name: "Noodles Mushroom Cheese Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 10800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219137",
      name: "Noodles Schezwan Cheese Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 10800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219138",
      name: "Noodles Sweet Corn Cheese Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219139",
      name: "Noodles Sweet Corn Paneer Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219140",
      name: "Paneer Cheese Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "108219141",
      name: "Paneer Rankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219142",
      name: "Schezwan Frankie",
      category: "Frankie",
      imageId: "4237c326576b65943533135e8436f55c",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219143",
      name: "Sweet Corn Cheese Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219144",
      name: "Sweet Corn Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219145",
      name: "Sweet Corn Paneer Frankie",
      category: "Frankie",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Juices: [
    {
      id: "62298890",
      name: "Mosambi Juice",
      category: "Juices",
      imageId: "74d66ee87b2521ee4b7512184478b599",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "62298891",
      name: "Orange Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "62298892",
      name: "Pineapple Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "62298893",
      name: "Apple Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "1.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "62298894",
      name: "Grapes Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298895",
      name: "Cocktail Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298896",
      name: "Anar Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298900",
      name: "Carrot Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298901",
      name: "Beetroot Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "108219156",
      name: "Carrot Beet Mix",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219157",
      name: "Fresh Lemon",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 4200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219158",
      name: "Ganga Jamuna",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219159",
      name: "Ganga Jamuna Saraswati",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219160",
      name: "Water Melon",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Burgers: [
    {
      id: "62298764",
      name: "Veg Cheese Burger",
      category: "Burgers",
      imageId: "74b730bf06526096485eabe8fe82c984",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "62298766",
      name: "Dryfruit Burger",
      category: "Burgers",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298768",
      name: "Schezwan Burger",
      category: "Burgers",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298769",
      name: "Mushroom Burger",
      category: "Burgers",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219061",
      name: "Mozarella Burger",
      category: "Burgers",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219062",
      name: "Peri Peri Burger",
      category: "Burgers",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219063",
      name: "Sweetcorn Burger",
      category: "Burgers",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Hot Dog": [
    {
      id: "62298774",
      name: "Veg Hot Dog",
      category: "Hot Dog",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298777",
      name: "Mushroom Hot Dog",
      category: "Hot Dog",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298782",
      name: "Schezwan Hot Dog",
      category: "Hot Dog",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219064",
      name: "Dryfruit Hot Dog",
      category: "Hot Dog",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219065",
      name: "Mozarella Hot Dog",
      category: "Hot Dog",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Lays Grill Sandwich": [
    {
      id: "62298775",
      name: "Lays Chilly Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298780",
      name: "Paneer Lays Chilly Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298879",
      name: "Lays Cheese Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 19600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298881",
      name: "Paneer Lays Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298882",
      name: "Mushroom Lays Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219071",
      name: "Club Lays Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219072",
      name: "Mozarella Cheese Lays Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219073",
      name: "Mozarella Club Lays Chilly Cheese Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219074",
      name: "Mozarella Club Lays Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219076",
      name: "Schezwan Lays Chilly Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219077",
      name: "Schezwan Mozarella Lays Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219078",
      name: "Sweet Corn Lays Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 22200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219079",
      name: "Sweet Corn Mozarella Lays Grill Sandwich",
      category: "Lays Grill Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Dholaki Grill": [
    {
      id: "80163577",
      name: "Jain Mozzarella Dholaki",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80163578",
      name: "Jain Sweet Corn Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80163579",
      name: "Jain Golden Crown Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80163588",
      name: "Paneer Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80163589",
      name: "Mushroom Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80163591",
      name: "Sweet Corn Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "80163593",
      name: "Schezwan Sweet Corn Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219080",
      name: "Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219081",
      name: "Jain Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219082",
      name: "Mozzarella Dholaki",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219083",
      name: "Sweet Corn Mozarella Dholaki Grill",
      category: "Dholaki Grill",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Dholaki Lays Grill": [
    {
      id: "108219084",
      name: "Dholaki Lays Grill",
      category: "Dholaki Lays Grill",
      inStock: 1,
      isVeg: 1,
      price: 19800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219085",
      name: "Mushroom Dholaki Lays Grill",
      category: "Dholaki Lays Grill",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219086",
      name: "Paneer Dholaki Lays Grill",
      category: "Dholaki Lays Grill",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219087",
      name: "Schezwan Sweetcorn Dholaki Lays Grill",
      category: "Dholaki Lays Grill",
      inStock: 1,
      isVeg: 1,
      price: 25200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219088",
      name: "Sweetcorn Dholaki Lays Grill",
      category: "Dholaki Lays Grill",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219089",
      name: "Sweetcorn Mozarella Dholaki Lays Grill",
      category: "Dholaki Lays Grill",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Chocolate Sandwiches": [
    {
      id: "62298791",
      name: "Chocolate Sandwich",
      category: "Chocolate Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298796",
      name: "Cheese Chocolate Sandwich",
      category: "Chocolate Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298801",
      name: "Brown Bread Chocolate Sandwich",
      category: "Chocolate Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298806",
      name: "Cheese Brown Bread Chocolate Sandwich",
      category: "Chocolate Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Toast Sandwiches": [
    {
      id: "62298816",
      name: "Masala Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "108219090",
      name: "Aloo Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "108219091",
      name: "Bread Butter Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 5600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219092",
      name: "Brown Bread Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219093",
      name: "Brown Bread Only Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219094",
      name: "Brown Bread Toast Butter Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219095",
      name: "Brown Bread Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 9600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "108219096",
      name: "Chilly Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 12600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219097",
      name: "Jam Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219098",
      name: "Jam Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219099",
      name: "Masala Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "108219100",
      name: "Mozarella Chilly Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219101",
      name: "Mushroom Chilly Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219102",
      name: "Only Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219103",
      name: "Paneer Chilly Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "108219104",
      name: "Paneer Mozarella Chilly Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219105",
      name: "Salad Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219106",
      name: "Salad Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219107",
      name: "Schezwan Chilly Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219108",
      name: "Sweet Corn Chilly Cheese Toast Sandwich",
      category: "Toast Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Toast Lays Sandwich": [
    {
      id: "108219109",
      name: "Chilly Cheese Lays Toast Sandwich",
      category: "Toast Lays Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219110",
      name: "Mozarella Chilly Cheese Lays Toast Sandwich",
      category: "Toast Lays Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219111",
      name: "Paneer Chilly Cheese Lays Toast Sandwich",
      category: "Toast Lays Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219112",
      name: "Schezwan Lays Chilly Cheese Lays Toast Sandwich",
      category: "Toast Lays Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219113",
      name: "Sweet Corn Chilly Cheese Lays Toast Sandwich",
      category: "Toast Lays Sandwich",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Sandwiches: [
    {
      id: "62298870",
      name: "Sada Sandwich",
      category: "Sandwiches",
      imageId: "c3629c61bfe8c5177cc2d0df19078517",
      inStock: 1,
      isVeg: 1,
      price: 5600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "31 ratings",
          ratingCountV2: "31",
        },
      },
    },
    {
      id: "62298871",
      name: "Sada Cheese Sandwich",
      category: "Sandwiches",
      imageId: "be584e8e69dc64969e416e53cc48e15c",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "62298875",
      name: "Brown Bread Sada Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298877",
      name: "Brown Bread Sada Cheese Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 9100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298878",
      name: "Only Cheese Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219114",
      name: "Aloo Bread Butter Cheese Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 5600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219115",
      name: "Bread Butter Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 4200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219116",
      name: "Jam Bread Butter Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 5600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219117",
      name: "Jam Cheese Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Pav Bhaji": [
    {
      id: "63007785",
      name: "Masala Papad Churni",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104251343",
      name: "Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104251509",
      name: "Mushroom Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 19800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104251512",
      name: "Mushroom Cheese Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104251539",
      name: "Khada Paneer Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219119",
      name: "Butter Pav",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 1500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219120",
      name: "Cheese Masala Pav",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219121",
      name: "Cheese Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 19800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219122",
      name: "Jain Cheese Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219123",
      name: "Jain Pav Bhai",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219124",
      name: "Khada Cheese Pav Bhai",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219125",
      name: "Khada Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219126",
      name: "Masala Pav",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 12600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219127",
      name: "Paneer Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 19800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Tawa Pulav": [
    {
      id: "62997106",
      name: "Tawa Pulav",
      category: "Tawa Pulav",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "63007786",
      name: "Paneer Tawa Pulav",
      category: "Tawa Pulav",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "104252092",
      name: "Cheese Paneer Tawa Pulav",
      category: "Tawa Pulav",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219128",
      name: "Cheese Tawa Pulav",
      category: "Tawa Pulav",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Sandwiches [jain]": [
    {
      id: "62298789",
      name: "Jain Paneer Grill Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298820",
      name: "Jain Toast Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298873",
      name: "Jain Sada Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 5200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298874",
      name: "Jain Sada Cheese Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219146",
      name: "Jain Cheese Toast Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219147",
      name: "Jain Golden Crown Grill Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219148",
      name: "Jain Grll Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219149",
      name: "Jain Sweet Corn Grill Sandwich",
      category: "Sandwiches [jain]",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Pizza[jain]": [
    {
      id: "108219150",
      name: "Jain Golden Crown Plzza",
      category: "Pizza[jain]",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615609",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 120,
                default: 1,
                id: "76658857",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658858",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 366,
                id: "76658859",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615609",
                variationId: "76658857",
              },
            ],
            price: 12000,
          },
          {
            variations: [
              {
                groupId: "23615609",
                variationId: "76658858",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615609",
                variationId: "76658859",
              },
            ],
            price: 36600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219151",
      name: "Jain Mozzarella Pizza",
      category: "Pizza[jain]",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615610",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 120,
                default: 1,
                id: "76658860",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658861",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 366,
                id: "76658862",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615610",
                variationId: "76658860",
              },
            ],
            price: 12000,
          },
          {
            variations: [
              {
                groupId: "23615610",
                variationId: "76658861",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615610",
                variationId: "76658862",
              },
            ],
            price: 36600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219152",
      name: "Jain Only Cheese Mozzarella Pizza",
      category: "Pizza[jain]",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615611",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 120,
                default: 1,
                id: "76658863",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658864",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 366,
                id: "76658865",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615611",
                variationId: "76658863",
              },
            ],
            price: 12000,
          },
          {
            variations: [
              {
                groupId: "23615611",
                variationId: "76658864",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615611",
                variationId: "76658865",
              },
            ],
            price: 36600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219153",
      name: "Jain Paneer Pizza",
      category: "Pizza[jain]",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615612",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 120,
                default: 1,
                id: "76658866",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658867",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 366,
                id: "76658868",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615612",
                variationId: "76658866",
              },
            ],
            price: 12000,
          },
          {
            variations: [
              {
                groupId: "23615612",
                variationId: "76658867",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615612",
                variationId: "76658868",
              },
            ],
            price: 36600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219154",
      name: "Jain Pizza",
      category: "Pizza[jain]",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615613",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 108,
                default: 1,
                id: "76658869",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 186,
                id: "76658870",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 318,
                id: "76658871",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615613",
                variationId: "76658869",
              },
            ],
            price: 10800,
          },
          {
            variations: [
              {
                groupId: "23615613",
                variationId: "76658870",
              },
            ],
            price: 18600,
          },
          {
            variations: [
              {
                groupId: "23615613",
                variationId: "76658871",
              },
            ],
            price: 31800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 10800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219155",
      name: "Jain Sweet Corn Pizza",
      category: "Pizza[jain]",
      imageId: "4f000e45f2a4380209574715f6745477",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615614",
            name: "Size",
            variations: [
              {
                name: "Small",
                price: 120,
                default: 1,
                id: "76658872",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Medium",
                price: 210,
                id: "76658873",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Large",
                price: 366,
                id: "76658874",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615614",
                variationId: "76658872",
              },
            ],
            price: 12000,
          },
          {
            variations: [
              {
                groupId: "23615614",
                variationId: "76658873",
              },
            ],
            price: 21000,
          },
          {
            variations: [
              {
                groupId: "23615614",
                variationId: "76658874",
              },
            ],
            price: 36600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Milkshake: [
    {
      id: "62298904",
      name: "Strawberry Milkshake",
      category: "Milkshake",
      imageId: "b501ea61dd9aabfb592a04c2152a535b",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298905",
      name: "Mango Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298906",
      name: "Rose Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 10800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298907",
      name: "Chocolate Milkshake",
      category: "Milkshake",
      imageId: "fb7993a38cf06725b8d76d22d12e72a1",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298908",
      name: "Chickoo Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298909",
      name: "Kesar Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298910",
      name: "Kiwi Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298911",
      name: "Sitafal Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "62298912",
      name: "Butterscotch Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298913",
      name: "Banana Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "1 rating",
          ratingCountV2: "1",
        },
      },
    },
    {
      id: "62298914",
      name: "Pineapple Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298915",
      name: "Apple Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298916",
      name: "Anjeer Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "62298919",
      name: "Oreo Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "63080951",
      name: "Chickoo Chocolate Milkshake",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219161",
      name: "Chocolate Banana Milkshake -",
      category: "Milkshake",
      inStock: 1,
      isVeg: 1,
      price: 13200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Rice Preparation": [
    {
      id: "108219162",
      name: "Cheese Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615615",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658875",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658876",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615615",
                variationId: "76658875",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615615",
                variationId: "76658876",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219163",
      name: "Chilly Garlic Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615616",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658877",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658878",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615616",
                variationId: "76658877",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615616",
                variationId: "76658878",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219164",
      name: "Combination Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615617",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658879",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658880",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615617",
                variationId: "76658879",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615617",
                variationId: "76658880",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219165",
      name: "Ginger Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615618",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658881",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658882",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615618",
                variationId: "76658881",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615618",
                variationId: "76658882",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219166",
      name: "Golden Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615619",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658883",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658884",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615619",
                variationId: "76658883",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615619",
                variationId: "76658884",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219167",
      name: "Golden Nylon Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615620",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658885",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658886",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615620",
                variationId: "76658885",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615620",
                variationId: "76658886",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219169",
      name: "Green Peas Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615622",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658889",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658891",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615622",
                variationId: "76658889",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615622",
                variationId: "76658891",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219171",
      name: "Hong Kong Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615624",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658894",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658895",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615624",
                variationId: "76658894",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615624",
                variationId: "76658895",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219173",
      name: "Jeera Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615626",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 108,
                default: 1,
                id: "76658898",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 156,
                id: "76658899",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615626",
                variationId: "76658898",
              },
            ],
            price: 10800,
          },
          {
            variations: [
              {
                groupId: "23615626",
                variationId: "76658899",
              },
            ],
            price: 15600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 10800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219176",
      name: "Manchurian Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615629",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658905",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658907",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615629",
                variationId: "76658905",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615629",
                variationId: "76658907",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219179",
      name: "Mushroom Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615632",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658911",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658912",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615632",
                variationId: "76658911",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615632",
                variationId: "76658912",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "108219180",
      name: "Onion Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615633",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658913",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658914",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615633",
                variationId: "76658913",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615633",
                variationId: "76658914",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219182",
      name: "Palak Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615635",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658917",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658918",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615635",
                variationId: "76658917",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615635",
                variationId: "76658918",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219185",
      name: "Paneer Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615638",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658924",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658925",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615638",
                variationId: "76658924",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615638",
                variationId: "76658925",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219188",
      name: "Shangai Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615642",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658933",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658934",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615642",
                variationId: "76658933",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615642",
                variationId: "76658934",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219190",
      name: "Singapore Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615645",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658939",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 228,
                id: "76658940",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615645",
                variationId: "76658939",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615645",
                variationId: "76658940",
              },
            ],
            price: 22800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219192",
      name: "Tripple Schezwan Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615647",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 168,
                default: 1,
                id: "76658943",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 252,
                id: "76658944",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615647",
                variationId: "76658943",
              },
            ],
            price: 16800,
          },
          {
            variations: [
              {
                groupId: "23615647",
                variationId: "76658944",
              },
            ],
            price: 25200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 16800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219194",
      name: "Veg Fried Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615649",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658948",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 192,
                id: "76658949",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615649",
                variationId: "76658948",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615649",
                variationId: "76658949",
              },
            ],
            price: 19200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219196",
      name: "Veg Stewed Rice",
      category: "Rice Preparation",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615651",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658952",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658953",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615651",
                variationId: "76658952",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615651",
                variationId: "76658953",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Noodles: [
    {
      id: "108219198",
      name: "Veg Chinese Bhel",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615653",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 120,
                default: 1,
                id: "76658956",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658957",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615653",
                variationId: "76658956",
              },
            ],
            price: 12000,
          },
          {
            variations: [
              {
                groupId: "23615653",
                variationId: "76658957",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219200",
      name: "Veg Fried Noodles",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615655",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658960",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658961",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615655",
                variationId: "76658960",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615655",
                variationId: "76658961",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219203",
      name: "Veg Hakka Noodles",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615658",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658966",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658967",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615658",
                variationId: "76658966",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615658",
                variationId: "76658967",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219207",
      name: "Veg Hong Kong Noodles",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615662",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658974",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658975",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615662",
                variationId: "76658974",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615662",
                variationId: "76658975",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219209",
      name: "Veg Noodle Rice",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615664",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658978",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658979",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615664",
                variationId: "76658978",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615664",
                variationId: "76658979",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219212",
      name: "Veg Schezwan Noodles",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615667",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658984",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658985",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615667",
                variationId: "76658984",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615667",
                variationId: "76658985",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219214",
      name: "Veg Singapore Noodles",
      category: "Noodles",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615669",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658988",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658989",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615669",
                variationId: "76658988",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615669",
                variationId: "76658989",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Potato Twister ": [
    {
      id: "110276399",
      name: "Schezwan Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276400",
      name: "Mayonise Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 9800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276402",
      name: "Salted Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 8400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276403",
      name: "Cheese Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276404",
      name: "Peri Peri Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276406",
      name: "Tandoori Potato",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 11200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276407",
      name: "Mayonise Chilly Cheese Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276408",
      name: "Mayonise Cg",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 15400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276409",
      name: "Garlic Cheese Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276410",
      name: "Tandoori Cheese Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276411",
      name: "Mayonise Cheese Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276412",
      name: "Schezwan Cheese Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276413",
      name: "Peri Peri Cheese Potato Twister",
      category: "Potato Twister ",
      inStock: 1,
      isVeg: 1,
      price: 12600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Starters: [
    {
      id: "111957810",
      name: "Veg Spring Roll",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 21600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Choice Vegetables": [
    {
      id: "108219215",
      name: "Babycorn Chilly",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615670",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658990",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658991",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615670",
                variationId: "76658990",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615670",
                variationId: "76658991",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219216",
      name: "Gobi Chilli",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615671",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76658992",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76658993",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615671",
                variationId: "76658992",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615671",
                variationId: "76658993",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219218",
      name: "Gobi Manchurian",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615673",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 132,
                default: 1,
                id: "76658996",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76658997",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615673",
                variationId: "76658996",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "23615673",
                variationId: "76658997",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219221",
      name: "Manchurian Roll",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615676",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659002",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 240,
                id: "76659003",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615676",
                variationId: "76659002",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615676",
                variationId: "76659003",
              },
            ],
            price: 24000,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219223",
      name: "Mushroom Chilli",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615678",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659006",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659007",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615678",
                variationId: "76659006",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615678",
                variationId: "76659007",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219225",
      name: "Mushroom Manchurian",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615680",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659010",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659011",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615680",
                variationId: "76659010",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615680",
                variationId: "76659011",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219227",
      name: "Mushroom Schezwan",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615682",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659014",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 228,
                id: "76659015",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615682",
                variationId: "76659014",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615682",
                variationId: "76659015",
              },
            ],
            price: 22800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219228",
      name: "Paneer Chilli Dry",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615684",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659018",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659019",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615684",
                variationId: "76659018",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615684",
                variationId: "76659019",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219229",
      name: "Paneer Chilli",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615686",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659022",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 252,
                id: "76659023",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615686",
                variationId: "76659022",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615686",
                variationId: "76659023",
              },
            ],
            price: 25200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219230",
      name: "Paneer Manchurian",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615688",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659026",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659027",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615688",
                variationId: "76659026",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615688",
                variationId: "76659027",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219233",
      name: "Paneer Satte",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615690",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659030",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 252,
                id: "76659031",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615690",
                variationId: "76659030",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615690",
                variationId: "76659031",
              },
            ],
            price: 25200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219236",
      name: "Paneer Schezwan",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615691",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659032",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659033",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615691",
                variationId: "76659032",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615691",
                variationId: "76659033",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219238",
      name: "Soyabean Chilli",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615692",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659034",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 234,
                id: "76659035",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615692",
                variationId: "76659034",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615692",
                variationId: "76659035",
              },
            ],
            price: 23400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219239",
      name: "Veg 65",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615693",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659036",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659037",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615693",
                variationId: "76659036",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615693",
                variationId: "76659037",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219241",
      name: "Veg Crispy",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615694",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659038",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 252,
                id: "76659039",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615694",
                variationId: "76659038",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615694",
                variationId: "76659039",
              },
            ],
            price: 25200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219243",
      name: "Veg Dry Chilly",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615695",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659040",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659041",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615695",
                variationId: "76659040",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615695",
                variationId: "76659041",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219245",
      name: "Veg Finger Schezwan",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615696",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659042",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 204,
                id: "76659043",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615696",
                variationId: "76659042",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615696",
                variationId: "76659043",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219247",
      name: "Veg Garlic Sour",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615697",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659044",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 216,
                id: "76659045",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615697",
                variationId: "76659044",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615697",
                variationId: "76659045",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219248",
      name: "Veg Gold Coin",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615698",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659046",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 228,
                id: "76659047",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615698",
                variationId: "76659046",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615698",
                variationId: "76659047",
              },
            ],
            price: 22800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219253",
      name: "Veg Schezwan",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615700",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659050",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 228,
                id: "76659051",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615700",
                variationId: "76659050",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615700",
                variationId: "76659051",
              },
            ],
            price: 22800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219255",
      name: "Veg Spring Roll",
      category: "Choice Vegetables",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615701",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 144,
                default: 1,
                id: "76659052",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 240,
                id: "76659053",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615701",
                variationId: "76659052",
              },
            ],
            price: 14400,
          },
          {
            variations: [
              {
                groupId: "23615701",
                variationId: "76659053",
              },
            ],
            price: 24000,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 14400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Soups: [
    {
      id: "104251269",
      name: "Veg Noodles Soup",
      category: "Soups",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615708",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 84,
                default: 1,
                id: "76659066",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 132,
                id: "76659067",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615708",
                variationId: "76659066",
              },
            ],
            price: 8400,
          },
          {
            variations: [
              {
                groupId: "23615708",
                variationId: "76659067",
              },
            ],
            price: 13200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 8400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219257",
      name: "Mushroom Soup",
      category: "Soups",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615702",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 96,
                default: 1,
                id: "76659054",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 144,
                id: "76659055",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615702",
                variationId: "76659054",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "23615702",
                variationId: "76659055",
              },
            ],
            price: 14400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219258",
      name: "Sweet Corn Soup",
      category: "Soups",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615703",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 96,
                default: 1,
                id: "76659056",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 144,
                id: "76659057",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615703",
                variationId: "76659056",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "23615703",
                variationId: "76659057",
              },
            ],
            price: 14400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219259",
      name: "Tomato Soup",
      category: "Soups",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615704",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 96,
                default: 1,
                id: "76659058",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 144,
                id: "76659059",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615704",
                variationId: "76659058",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "23615704",
                variationId: "76659059",
              },
            ],
            price: 14400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219260",
      name: "Veg Clear Soup",
      category: "Soups",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615705",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 84,
                default: 1,
                id: "76659060",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 132,
                id: "76659061",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615705",
                variationId: "76659060",
              },
            ],
            price: 8400,
          },
          {
            variations: [
              {
                groupId: "23615705",
                variationId: "76659061",
              },
            ],
            price: 13200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 8400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219261",
      name: "Veg Hot & Sour Soup",
      category: "Soups",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615706",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 84,
                default: 1,
                id: "76659062",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 132,
                id: "76659063",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615706",
                variationId: "76659062",
              },
            ],
            price: 8400,
          },
          {
            variations: [
              {
                groupId: "23615706",
                variationId: "76659063",
              },
            ],
            price: 13200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 8400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "108219262",
      name: "Veg Manchow Soup",
      category: "Soups",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "23615707",
            name: "Quantity",
            variations: [
              {
                name: "half",
                price: 96,
                default: 1,
                id: "76659064",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full",
                price: 144,
                id: "76659065",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "23615707",
                variationId: "76659064",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "23615707",
                variationId: "76659065",
              },
            ],
            price: 14400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Momos: [
    {
      id: "110267619",
      name: "Paneer",
      category: "Momos",
      inStock: 1,
      isVeg: 1,
      price: 16800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110267620",
      name: "Paneer Cheese Momos",
      category: "Momos",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110267743",
      name: "Sweet Corn Chilly Momos",
      category: "Momos",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276414",
      name: "Cheese Momos",
      category: "Momos",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276415",
      name: "Schezwan Chilly Momos",
      category: "Momos",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110276416",
      name: "Jain Paneer Momos",
      category: "Momos",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111957811",
      name: "Chilly Cheese Momos",
      category: "Momos",
      inStock: 1,
      isVeg: 1,
      price: 18200,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[ramdevPureVeg] = {
  Dosa: [
    {
      id: "20807746",
      name: "Sada Dosa",
      category: "Dosa",
      imageId: "e317b7fa226520667faa6bd07487872b",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "26 ratings",
          ratingCountV2: "26",
        },
      },
    },
    {
      id: "20807754",
      name: "Mysore Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "20807759",
      name: "Mysore Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036844",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "22 ratings",
          ratingCountV2: "22",
        },
      },
    },
    {
      id: "20807770",
      name: "Paper Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036788",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036789",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036790",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807775",
      name: "Rava Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "20807780",
      name: "Rava Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036775",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "20807785",
      name: "Palak Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807790",
      name: "Palak Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036779",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807795",
      name: "Cheese Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036845",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807799",
      name: "Cheese Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036830",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036831",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807804",
      name: "Cheese Mysore Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036825",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036826",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807809",
      name: "Cheese Mysore Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036835",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036837",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036839",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807815",
      name: "Onion Rava Ghee Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036822",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807820",
      name: "Onion Rava Ghee Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036818",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036819",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "20807825",
      name: "Paneer Mysore Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807828",
      name: "Paneer Mysore Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036847",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036848",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036849",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807832",
      name: "Schezwan Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036812",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807842",
      name: "Spring Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036749",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036750",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036751",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807847",
      name: "Pav Bhaji Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036755",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036756",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036757",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910083",
      name: "Ghee Rava Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036814",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036816",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92910087",
      name: "Jini Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036752",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036753",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036754",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355908",
      name: "Cheese Onion Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355909",
      name: "Cheese Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355910",
      name: "Coconut Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355911",
      name: "Ghree Rava Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036832",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355912",
      name: "Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "64 ratings",
          ratingCountV2: "64",
        },
      },
    },
    {
      id: "95355913",
      name: "Masala Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "95355914",
      name: "Onion Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
    {
      id: "95355915",
      name: "Paper Sada Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036796",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036797",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036798",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355916",
      name: "Podi Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355917",
      name: "Schewan Masala Dosa",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036807",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355918",
      name: "Tomato Omelette",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "95355919",
      name: "Tomato Onion Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "95355920",
      name: "Tomato Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355921",
      name: "Uttappam",
      category: "Dosa",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  "Indian Snacks": [
    {
      id: "20808042",
      name: "Sweet Kachori",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "95355748",
      name: "Aamras Puri",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "95355749",
      name: "Chhole Batura",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036761",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036762",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036763",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "95355750",
      name: "Chhole Puri",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036758",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036759",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036760",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355751",
      name: "Paneer Pakoda",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036764",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036765",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036766",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355752",
      name: "Potato Wada",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "95355753",
      name: "Puri",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355754",
      name: "Puri Bhaji",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "30 ratings",
          ratingCountV2: "30",
        },
      },
    },
    {
      id: "95355755",
      name: "Sabudana Wada",
      category: "Indian Snacks",
      imageId: "4297904730103d99721c102c6901b419",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "95355756",
      name: "Shrikhand Puri",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355757",
      name: "Veg Pakoda",
      category: "Indian Snacks",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036768",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036769",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Pav Bhaji": [
    {
      id: "20807761",
      name: "Pav Bhaji Fondue",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036646",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036647",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036648",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807766",
      name: "Hariyali Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807771",
      name: "Paneer Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88839890",
      name: "Pav Bhaji",
      category: "Pav Bhaji",
      imageId: "10e6141a9281843a2e00e526fb1e7bd6",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465209",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "79465210",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79465211",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "74 ratings",
          ratingCountV2: "74",
        },
      },
    },
    {
      id: "92910037",
      name: "Jain Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036664",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036666",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036667",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355759",
      name: "Butter Pav",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 3500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "36 ratings",
          ratingCountV2: "36",
        },
      },
    },
    {
      id: "95355760",
      name: "Cheese Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036654",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036655",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036656",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "95355761",
      name: "Khada Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036659",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036660",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036661",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355762",
      name: "Masala  Pav (2 Pcs)",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036644",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036645",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355763",
      name: "Pav Bhaji Extra Chutney",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355764",
      name: "Special Pav Bhaji",
      category: "Pav Bhaji",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465212",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "79465213",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79465214",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
  ],
  "Sabzi Mandi": [
    {
      id: "20807782",
      name: "Veg Bhuna Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994544",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994545",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994546",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "20807787",
      name: "Veg Maratha Darbar",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994574",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994575",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994576",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "20807806",
      name: "Veg Kadai",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994553",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994554",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994555",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "20807810",
      name: "Veg Handi",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994547",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994548",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994549",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
    {
      id: "20807814",
      name: "Veg Kolhapuri",
      category: "Sabzi Mandi",
      imageId: "b69467e7dac7e693a43aff58ffea5875",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994562",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994563",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994564",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "52 ratings",
          ratingCountV2: "52",
        },
      },
    },
    {
      id: "20807822",
      name: "Veg Tawa Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 29000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994583",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994584",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994585",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807831",
      name: "Veg Hyderabadi",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994550",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994551",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994552",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807848",
      name: "Aloo Gobi",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994490",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994491",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994492",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625394",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625395",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807851",
      name: "Green Peas Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994517",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994518",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994519",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807863",
      name: "Veg Kofta",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994559",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994560",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994561",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "20807868",
      name: "Malai Kofta",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994523",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994524",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994525",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "20807873",
      name: "Cheese Kofta",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994514",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994515",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994516",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807883",
      name: "Kaju Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036739",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036740",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036741",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994520",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994521",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994522",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "20807887",
      name: "Mushroom Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994538",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994539",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994540",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "92910113",
      name: "Aloo Palak",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994496",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994497",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994498",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625394",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625395",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92910115",
      name: "Baighan Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994505",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994506",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994507",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625394",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625395",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910116",
      name: "Bhindi Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994508",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994509",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994510",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625394",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625395",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910118",
      name: "Methi Lasooni",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994526",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994527",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994528",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92910119",
      name: "Methi Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994529",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994530",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994531",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910121",
      name: "Mix Veg",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994532",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994533",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994534",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.1",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "92910127",
      name: "Palak Lasooni",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994541",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994542",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994543",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910128",
      name: "Veg Lajawab",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994568",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994569",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994570",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355828",
      name: "Aloo Mutter",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994493",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994494",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994495",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625394",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625395",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355830",
      name: "Babycorn Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 27500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994499",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994500",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994501",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625394",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625395",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355831",
      name: "Babycorn Mushroom Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 28500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994502",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994503",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994504",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625394",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625395",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355841",
      name: "Veg Kheema Masala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994556",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994557",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994558",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355844",
      name: "Veg Kurma",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036620",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036621",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036623",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994565",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994566",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994567",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355850",
      name: "Veg Maharaja",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994571",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994572",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994573",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "95355853",
      name: "Veg Navratan Kurma",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994577",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994578",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994579",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355854",
      name: "Veg Patiyala",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994580",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994581",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994582",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "111390141",
      name: "Bhindi Tawa Fry",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994511",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994512",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994513",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390142",
      name: "Mushroom Ghee Roast",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994535",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994536",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994537",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390143",
      name: "Veg. Nawabdar",
      category: "Sabzi Mandi",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994586",
          groupName: "Breads in Curry",
          choices: [
            {
              id: "64625360",
              name: "Butter Naan",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625361",
              name: "Naan",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625364",
              name: "Missi Roti",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625365",
              name: "Butter Roti",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625362",
              name: "Butter Paratha",
              price: 8500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625363",
              name: "Paratha",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625366",
              name: "Roti",
              price: 3500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994587",
          groupName: "Accompaniments in Curry",
          choices: [
            {
              id: "64625371",
              name: "Boondi Raitha",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625372",
              name: "Aloo Pudina Raita",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625370",
              name: "Mix Fruit Raita",
              price: 15500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625368",
              name: "Fried Papad",
              price: 4500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625369",
              name: "Pineapple Raita",
              price: 14500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625367",
              name: "Green Salad",
              price: 11000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79994588",
          groupName: "Sweets in Curry",
          choices: [
            {
              id: "64625375",
              name: "Kulfi",
              price: 9000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625376",
              name: "Gulab Jamun",
              price: 9500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625373",
              name: "Rabdi with Gulab Jamun",
              price: 20000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625374",
              name: "Rabdi",
              price: 16000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625377",
              name: "Masala Papad",
              price: 7000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Paneer Ki Sabzi": [
    {
      id: "20807893",
      name: "Paneer Lahori",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036674",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807895",
      name: "Paneer Butter Masala",
      category: "Paneer Ki Sabzi",
      imageId: "858a2b34c8ca06d9265f97cef1ca6a2a",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036715",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "48 ratings",
          ratingCountV2: "48",
        },
      },
    },
    {
      id: "20807898",
      name: "Paneer Tikka Masala",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036709",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "95 ratings",
          ratingCountV2: "95",
        },
      },
    },
    {
      id: "20807901",
      name: "Paneer Kadai",
      category: "Paneer Ki Sabzi",
      imageId: "d4252ddcf788225b20af703d24067650",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036720",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807904",
      name: "Paneer Handi",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036716",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "20807907",
      name: "Paneer Tawa Masala",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036699",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807910",
      name: "Paneer Kolhapuri",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036698",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "20807984",
      name: "Paneer Reshmi Masala",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036693",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807987",
      name: "Paneer Bhurji",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036696",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807988",
      name: "Paneer Lajawab",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036694",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807991",
      name: "Cheese Amritsari",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036810",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807992",
      name: "Paneer Banjara Masala",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 29000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036806",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807993",
      name: "Paneer Angoori",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036784",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807995",
      name: "Paneer Kaju Masala",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036795",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "95355864",
      name: "Paneer Do Pyaaza",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036704",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355877",
      name: "Paneer Lasooni",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036803",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355881",
      name: "Paneer Mutter",
      category: "Paneer Ki Sabzi",
      imageId: "ceca5149b6ba8fa9a68d64a12a643d76",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036706",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "95355882",
      name: "Paneer Palak",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036783",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "111390144",
      name: "Gomanchal Malai",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390145",
      name: "Paneer Ghee Roast",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390148",
      name: "Paneer Nawabdar",
      category: "Paneer Ki Sabzi",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Dal Ki Khushboo": [
    {
      id: "20807996",
      name: "Dal Fry",
      category: "Dal Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "20807997",
      name: "Dal Tadka",
      category: "Dal Ki Khushboo",
      imageId: "bb96185f1fef54929abaeb3077cec344",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "37 ratings",
          ratingCountV2: "37",
        },
      },
    },
    {
      id: "20807998",
      name: "Dal Kolhapuri",
      category: "Dal Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807999",
      name: "Dal Makhani Black",
      category: "Dal Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "95355883",
      name: "Dal Bukhara",
      category: "Dal Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Basmati Ki Khushboo": [
    {
      id: "20808001",
      name: "Veg Biryani",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465222",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "62 ratings",
          ratingCountV2: "62",
        },
      },
    },
    {
      id: "20808002",
      name: "Veg Dum Biryani",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994354",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "20808006",
      name: "Jeera Rice",
      category: "Basmati Ki Khushboo",
      imageId: "522272909ccfb82ddbc8de4548c48b72",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "20808012",
      name: "Dal Khichdi",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465215",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "79465216",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "79465217",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "56 ratings",
          ratingCountV2: "56",
        },
      },
    },
    {
      id: "20808013",
      name: "Dal Khichdi Tadka",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036557",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036558",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036559",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "56 ratings",
          ratingCountV2: "56",
        },
      },
    },
    {
      id: "20808014",
      name: "Dal Khichdi Ghee Tadka",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036550",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036551",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036552",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "20808015",
      name: "Lemon Rice",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808016",
      name: "Ghee Rice",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808017",
      name: "Curd Rice",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808019",
      name: "Palak Khichdi",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036566",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036567",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036568",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "92910107",
      name: "Paneer Biryani",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465221",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "92910108",
      name: "Mushroom Biryani",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465220",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910111",
      name: "Tomato Rice",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355891",
      name: "Cheese Pulav",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355892",
      name: "Curd Rice With Tadka",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355893",
      name: "Green Peas Pulav",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355894",
      name: "Hyderabadi Biryani",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 28500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465218",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355895",
      name: "Hyderabadi Dum Biryani",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 32000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79465219",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355896",
      name: "Paneer Pulav",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "95355897",
      name: "Soya Chaap Dum Biryani",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036642",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355898",
      name: "Steam Rice",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "95355899",
      name: "Tawa Pulav",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "95355900",
      name: "Veg Kashmiri Pulav",
      category: "Basmati Ki Khushboo",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036632",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355901",
      name: "Veg Pulav",
      category: "Basmati Ki Khushboo",
      imageId: "289b2c913143f4f2992a7efc6879fd4a",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036625",
          groupName: "Extras",
          choices: [
            {
              id: "59907955",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907956",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907957",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907958",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.9",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
  ],
  "Soups Chinese & Thai": [
    {
      id: "20807845",
      name: "Veg Manchow Soup",
      category: "Soups Chinese & Thai",
      imageId: "70aa7777384e6bfda86a13bf27d435e5",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "20807850",
      name: "Veg Hot & Sour Soup",
      category: "Soups Chinese & Thai",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807859",
      name: "Veg Clear Soup",
      category: "Soups Chinese & Thai",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807864",
      name: "Veg Mushroom Soup",
      category: "Soups Chinese & Thai",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910112",
      name: "Lemon Coriander Soup",
      category: "Soups Chinese & Thai",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355783",
      name: "Minestrone Soup",
      category: "Soups Chinese & Thai",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355784",
      name: "Paneer Lemon Grass",
      category: "Soups Chinese & Thai",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355785",
      name: "Veg Sweet Corn Soup",
      category: "Soups Chinese & Thai",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Fried Rice & Noodles": [
    {
      id: "20807753",
      name: "Veg Fried Rice",
      category: "Fried Rice & Noodles",
      imageId: "c8545d37b8c396028b3b7f98ad47a8a9",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036634",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036635",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036636",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "20807762",
      name: "Veg Triple Schezwan Fried Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 34000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036554",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036555",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036556",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "20807774",
      name: "Veg Singapore Fried Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036563",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036564",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036565",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807778",
      name: "Veg Combination Fried Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807781",
      name: "Veg Ramdev Special Fried Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036583",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036584",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036585",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "20807796",
      name: "Veg Hakka Noodles",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "20807800",
      name: "Veg Schezwan Noodles",
      category: "Fried Rice & Noodles",
      imageId: "298ee4a14707396b5199824e916f3217",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "20807811",
      name: "Veg Singapore Noodles",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807816",
      name: "Veg Mushroom Noodles",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807821",
      name: "Veg Ramdev Special Noodles",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910130",
      name: "Mushroom Fried Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036560",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036561",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036562",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910131",
      name: "Herb Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910132",
      name: "Corn Chilli Garlic Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355902",
      name: "Paneer Fied Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355903",
      name: "Veg Hong Kong Nooldes",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355904",
      name: "Veg Hongkong Fried Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355905",
      name: "Veg Manchurian Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036596",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036597",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036598",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355906",
      name: "Veg Pot Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 32000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355907",
      name: "Veg Schezwan Rice",
      category: "Fried Rice & Noodles",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
  ],
  "Oriental Starters (chinese)": [
    {
      id: "20807949",
      name: "Veg Manchurian",
      category: "Oriental Starters (chinese)",
      imageId: "58bd993b2eaa121e7ae31b4f5d84f01e",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036733",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036734",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036735",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "28 ratings",
          ratingCountV2: "28",
        },
      },
    },
    {
      id: "20807951",
      name: "Veg Crispy",
      category: "Oriental Starters (chinese)",
      imageId: "a0a271b63372c6743a2bd31eb6f54c41",
      inStock: 1,
      isVeg: 1,
      price: 32000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "20807952",
      name: "Veg 65",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807953",
      name: "Veg Crunchy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807954",
      name: "Veg Finger Schezwan",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036727",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036728",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036729",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807955",
      name: "Veg Spring Roll",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807957",
      name: "Paneer Manchurian",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036730",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036731",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036732",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807964",
      name: "Paneer 65",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807967",
      name: "Paneer Crispy",
      category: "Oriental Starters (chinese)",
      imageId: "5f9548f1ef194bda566507ba28924ab0",
      inStock: 1,
      isVeg: 1,
      price: 33000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "20807968",
      name: "Paneer Chatpata",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 32000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910123",
      name: "Mushroom Manchurian",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036687",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036688",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036689",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910124",
      name: "Mushroom Crispy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910125",
      name: "Veg Surprise",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 48000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355801",
      name: "Idli Chilly",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "95355802",
      name: "Malaysian Corn Crispy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355803",
      name: "Mushroom Chilly",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355804",
      name: "Paneer Chilly",
      category: "Oriental Starters (chinese)",
      imageId: "0644551b367076b4de7b7bc9ee8a79f3",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "30 ratings",
          ratingCountV2: "30",
        },
      },
    },
    {
      id: "95355806",
      name: "Paneer Sathe",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355807",
      name: "Soya Chap Chilly",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036681",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036683",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036684",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355808",
      name: "Veg Chilly",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390153",
      name: "Mushroom Chilly Gravy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390155",
      name: "Paneer 65 Gravy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390157",
      name: "Paneer Chilly Gravy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390159",
      name: "Veg. 65 Gravy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390160",
      name: "Veg. Chilly Gravy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390161",
      name: "Veg. Manchurian Gravy",
      category: "Oriental Starters (chinese)",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Idli & Wada": [
    {
      id: "20807719",
      name: "Fried Idli",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807723",
      name: "Butter Idli",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807731",
      name: "Dahi Idli",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036724",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "59028269",
      name: "Podi Idli",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "95355922",
      name: "Dahi Wada",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "15 ratings",
          ratingCountV2: "15",
        },
      },
    },
    {
      id: "95355923",
      name: "Idli Chutney Sambhar",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "93 ratings",
          ratingCountV2: "93",
        },
      },
    },
    {
      id: "95355924",
      name: "Idli Wada",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "58 ratings",
          ratingCountV2: "58",
        },
      },
    },
    {
      id: "95355925",
      name: "Medu Wada",
      category: "Idli & Wada",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "103 ratings",
          ratingCountV2: "103",
        },
      },
    },
  ],
  Sandwiches: [
    {
      id: "20807716",
      name: "Jam Butter Bread",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807788",
      name: "Veg Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807803",
      name: "Cheese Toast Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036586",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "1.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "20807807",
      name: "Veg Grilled Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036589",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "20808044",
      name: "Toast Butter",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808045",
      name: "Bread Butter",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910040",
      name: "Veg Toast Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "92910041",
      name: "Tandoori Paneer Grilled Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036587",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910043",
      name: "Cheese Chilly Grilled Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036601",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355927",
      name: "Club Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036578",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355929",
      name: "Veg Cheese Grilled Sandwich",
      category: "Sandwiches",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036576",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
  ],
  Pizza: [
    {
      id: "95355819",
      name: "Gourmet Pizza [10 Inches]",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      price: 32000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036697",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355820",
      name: "Margherita Pizza [10 Inches]",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036695",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355821",
      name: "Mexican Pizza [10 Inches]",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036802",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355822",
      name: "Paneer Tikka Pizza [10 Inches]",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036725",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355824",
      name: "Peppy Paneer Pizza [10 Inches]",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036703",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355826",
      name: "Ramdev Special Pizza [10 Inches]",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036804",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "95355827",
      name: "Tangy Chipotle Pizza [10 Inches]",
      category: "Pizza",
      inStock: 1,
      isVeg: 1,
      price: 31000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036705",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Shorba: [
    {
      id: "20807897",
      name: "Dal Shorba",
      category: "Shorba",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807902",
      name: "Veg Shorba",
      category: "Shorba",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Chef's Special": [
    {
      id: "20807985",
      name: "Paneer Mirchidar Kadai",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036774",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92910058",
      name: "Veg Khazana",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 44000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036773",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910060",
      name: "Paneer Koliwada Masala",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036841",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910063",
      name: "Veg Kebab Masala",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036840",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92910068",
      name: "Kothambari Wadi Masala",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036829",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355809",
      name: "Birbal E Chaman",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036772",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355810",
      name: "Sham Savera",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036771",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355811",
      name: "Spicy Soya Chaap Masala",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 29000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036850",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036851",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036852",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036853",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355812",
      name: "Veg Tiranga",
      category: "Chef's Special",
      inStock: 1,
      isVeg: 1,
      price: 46000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036846",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Tandoor Ki Aag Se": [
    {
      id: "20807916",
      name: "Garlic Naan",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "20807919",
      name: "Cheese Garlic Naan",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807921",
      name: "Kulcha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808022",
      name: "Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808023",
      name: "Butter Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808024",
      name: "Naan",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "20808026",
      name: "Missi Roti",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "20808027",
      name: "Aloo Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "20808029",
      name: "Pudina Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20808030",
      name: "Methi Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "92910078",
      name: "Lachha Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "92910080",
      name: "Paneer Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "92910085",
      name: "Butter Kulcha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910086",
      name: "Stuff Kulcha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355884",
      name: "Butter Chapati",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 2500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "95355885",
      name: "Butter Naan",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 8500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "95355886",
      name: "Butter Roti",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "41 ratings",
          ratingCountV2: "41",
        },
      },
    },
    {
      id: "95355887",
      name: "Chapati",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 2000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "63 ratings",
          ratingCountV2: "63",
        },
      },
    },
    {
      id: "95355888",
      name: "Roti",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 3500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "38 ratings",
          ratingCountV2: "38",
        },
      },
    },
    {
      id: "95355889",
      name: "Roti Ki Tokri",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 47500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355890",
      name: "Stuff Paratha",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 13000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390149",
      name: "Zaatar Naan",
      category: "Tandoor Ki Aag Se",
      inStock: 1,
      isVeg: 1,
      price: 8000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Accompaniments: [
    {
      id: "20807926",
      name: "Green Salad",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807927",
      name: "Tossed Salad",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807929",
      name: "Russian Salad",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807931",
      name: "Curd",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807932",
      name: "Veg Raita",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807934",
      name: "Boondi Raita",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807936",
      name: "Pineapple Raita",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "20807939",
      name: "Aloo Pudina Raita",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807943",
      name: "Fried Papad",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 4500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807945",
      name: "Roasted Papad",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 3000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807946",
      name: "Masala Papad",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910117",
      name: "Papad Churi",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355930",
      name: "Mix Fruit Raita",
      category: "Accompaniments",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Oriental Starters": [
    {
      id: "95355794",
      name: "Assorted Vegetables",
      category: "Oriental Starters",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "54238357",
          groupName: "Preparation for starters",
          choices: [
            {
              id: "44550394",
              name: "Black Brean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550395",
              name: "Oyster",
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "44550396",
              name: "Sweet Chilli",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550397",
              name: "Barbeque",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550398",
              name: "Hot Garlic Yellow Bean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550399",
              name: "Teriyaki",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550400",
              name: "Coriander Chilly",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550401",
              name: "Black Pepper",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036607",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355795",
      name: "Mushroom Oriental",
      category: "Oriental Starters",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "54238358",
          groupName: "Preparation for starters",
          choices: [
            {
              id: "44550394",
              name: "Black Brean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550395",
              name: "Oyster",
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "44550396",
              name: "Sweet Chilli",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550397",
              name: "Barbeque",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550398",
              name: "Hot Garlic Yellow Bean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550399",
              name: "Teriyaki",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550400",
              name: "Coriander Chilly",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550401",
              name: "Black Pepper",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036770",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355796",
      name: "Paneer Oriental",
      category: "Oriental Starters",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "54238359",
          groupName: "Preparation for starters",
          choices: [
            {
              id: "44550394",
              name: "Black Brean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550395",
              name: "Oyster",
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "44550396",
              name: "Sweet Chilli",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550397",
              name: "Barbeque",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550398",
              name: "Hot Garlic Yellow Bean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550399",
              name: "Teriyaki",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550400",
              name: "Coriander Chilly",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550401",
              name: "Black Pepper",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036767",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355797",
      name: "Potato Sticks",
      category: "Oriental Starters",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "54238360",
          groupName: "Preparation for starters",
          choices: [
            {
              id: "44550394",
              name: "Black Brean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550395",
              name: "Oyster",
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "44550396",
              name: "Sweet Chilli",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550397",
              name: "Barbeque",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550398",
              name: "Hot Garlic Yellow Bean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550399",
              name: "Teriyaki",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550400",
              name: "Coriander Chilly",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550401",
              name: "Black Pepper",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036726",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355799",
      name: "Veg Balls",
      category: "Oriental Starters",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "54238364",
          groupName: "Preparation for starters",
          choices: [
            {
              id: "44550394",
              name: "Black Brean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550395",
              name: "Oyster",
              inStock: 1,
              isEnabled: 1,
            },
            {
              id: "44550396",
              name: "Sweet Chilli",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550397",
              name: "Barbeque",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550398",
              name: "Hot Garlic Yellow Bean",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550399",
              name: "Teriyaki",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550400",
              name: "Coriander Chilly",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "44550401",
              name: "Black Pepper",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036617",
          groupName: "Extra Add-ons",
          choices: [
            {
              id: "59907959",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907960",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907961",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907962",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 4,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Thai: [
    {
      id: "20807976",
      name: "Veg Red Thai Curry With Rice",
      category: "Thai",
      inStock: 1,
      isVeg: 1,
      price: 38000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807977",
      name: "Veg Green Thai Curry With Rice",
      category: "Thai",
      inStock: 1,
      isVeg: 1,
      price: 38000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Continental Soups": [
    {
      id: "95355777",
      name: "Cream Of Mushroom Soup",
      category: "Continental Soups",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355779",
      name: "Cream Of Tomato Soup",
      category: "Continental Soups",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "95355780",
      name: "Cream Of Veg Soup",
      category: "Continental Soups",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "95355781",
      name: "French Onion Soup",
      category: "Continental Soups",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390165",
      name: "Cream Of Spinach Soup",
      category: "Continental Soups",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Starters: [
    {
      id: "20807718",
      name: "Kaju Methi Roll",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807722",
      name: "Masala Papad Roll",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807760",
      name: "Veg Seekh Kebab",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807764",
      name: "Paneer Seekh Kebab",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807972",
      name: "French Fries",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "92910042",
      name: "Garlic Bread With Cheese",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910045",
      name: "Cheese Chilly Open Toast",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910089",
      name: "Cheese Makai Tikki",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036799",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036800",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036801",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355786",
      name: "Aloo Methi Tikki",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036785",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036786",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036787",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355787",
      name: "Bhindi Kurkure",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036780",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036781",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036782",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355789",
      name: "Corn Cheese Balls",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036675",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036676",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036677",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355791",
      name: "Hara Bhara Kabab",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "95355792",
      name: "Kabuli Tikki",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036776",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036777",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036778",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390168",
      name: "Arancini",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390170",
      name: "Butter Garlic Paneer Tarts",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390173",
      name: "God Father Nachos",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390174",
      name: "Hummus With Pita Bread",
      category: "Starters",
      inStock: 1,
      isVeg: 1,
      price: 26000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Pasta: [
    {
      id: "95355814",
      name: "Creamy Spinach Penne Pasta",
      category: "Pasta",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036700",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036701",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036702",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355815",
      name: "Red Penne Pasta",
      category: "Pasta",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036721",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036722",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036723",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355817",
      name: "Spicy Chipotle Penne Pasta",
      category: "Pasta",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036712",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036713",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036714",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95355818",
      name: "White Penne Pasta",
      category: "Pasta",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75036717",
          groupName: "Beverages",
          choices: [
            {
              id: "59907951",
              name: "Mosambi Juice",
              price: 12150,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "59907952",
              name: "Apple Juice",
              price: 13500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036718",
          groupName: "Desserts",
          choices: [
            {
              id: "59907953",
              name: "Kulfi Falooda",
              price: 16200,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75036719",
          groupName: "Side",
          choices: [
            {
              id: "59907954",
              name: "Veg Manchow Soup",
              price: 14400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390177",
      name: "Risotto",
      category: "Pasta",
      inStock: 1,
      isVeg: 1,
      price: 30000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Hot Cold Beverages": [
    {
      id: "20807844",
      name: "Jaljeera",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807909",
      name: "Tea",
      category: "Hot Cold Beverages",
      description: "150 ml.",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "20807912",
      name: "Masala Tea",
      category: "Hot Cold Beverages",
      description: "150 ml.",
      inStock: 1,
      isVeg: 1,
      price: 6000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807914",
      name: "Coffee",
      category: "Hot Cold Beverages",
      description: "150 ml.",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "20807923",
      name: "Cold Coffee",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 16500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807928",
      name: "Sweet Lassi",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807930",
      name: "Salted Lassi",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807933",
      name: "Mango Lassi",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807935",
      name: "Rose Lassi",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807937",
      name: "Kesar Lassi",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910044",
      name: "Green Tea",
      category: "Hot Cold Beverages",
      description: "150 ml.",
      inStock: 1,
      isVeg: 1,
      price: 5000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910055",
      name: "Salted Lime Juice",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910056",
      name: "Sweet Lime Juice",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "92910067",
      name: "Ice Tea",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355765",
      name: "Cold Coffee With Ice Cream",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 18500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355766",
      name: "Hot Chocolate",
      category: "Hot Cold Beverages",
      description: "150 ml.",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355768",
      name: "Jaljeera With Soda",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355769",
      name: "Masala Chhaas",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 6500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "95355770",
      name: "Salted Fresh Lime Soda",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355771",
      name: "Sweet Fresh Lime Soda",
      category: "Hot Cold Beverages",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 10000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "111390180",
      name: "Filter Kappi",
      category: "Hot Cold Beverages",
      inStock: 1,
      isVeg: 1,
      price: 7500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Mocktails: [
    {
      id: "92910038",
      name: "Sunrise",
      category: "Mocktails",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910104",
      name: "Blue Hawaii",
      category: "Mocktails",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355773",
      name: "Cindrella",
      category: "Mocktails",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355775",
      name: "Ramdev Fruit Punch",
      category: "Mocktails",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355776",
      name: "Spicy Guava Punch",
      category: "Mocktails",
      description: "300 ml.",
      inStock: 1,
      isVeg: 1,
      price: 21000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390183",
      name: "Pina Colada",
      category: "Mocktails",
      description: "(Pineapple, Tender Coconut, Vanilla, Sparkling Water)",
      inStock: 1,
      isVeg: 1,
      price: 23000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111390185",
      name: "Virgin Mojito",
      category: "Mocktails",
      description: "(Pineapple, Tender Coconut, Vanilla, Sparkling Water)",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Juices: [
    {
      id: "20807721",
      name: "Mango Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807729",
      name: "Ganga Jamuna Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807738",
      name: "Pomegranate Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807940",
      name: "Orange Juice",
      category: "Juices",
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 8:30 am, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807942",
      name: "Mosambi Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807944",
      name: "Pineapple Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807947",
      name: "Apple Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807948",
      name: "Grapes Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355738",
      name: "Cocktail Juice",
      category: "Juices",
      description: "[Non Alcoholic]",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355740",
      name: "Water Melon Juice",
      category: "Juices",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  Milkshakes: [
    {
      id: "20807748",
      name: "Oreo Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807752",
      name: "Nutella Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807757",
      name: "Apple Milkshake",
      category: "Milkshakes",
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      nextAvailableAtMessage: "Next available at 2:56 pm, tomorrow",
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807763",
      name: "Mango Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807772",
      name: "Strawberry Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807777",
      name: "Vanilla Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807783",
      name: "Chocolate Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355741",
      name: "Biscoff Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 24000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355743",
      name: "Chickoo Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355744",
      name: "Coconut Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355745",
      name: "Dryfruit Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355746",
      name: "Peanut Caramel Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 18000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355747",
      name: "Sitafal Milkshake",
      category: "Milkshakes",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Falooda: [
    {
      id: "20807826",
      name: "Rose Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807833",
      name: "Kesar Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807841",
      name: "Kulfi Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "20807853",
      name: "Royal Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910050",
      name: "Delhi Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355730",
      name: "Ramdev Special Falooda",
      category: "Falooda",
      inStock: 1,
      isVeg: 1,
      price: 22000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.4",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
  ],
  "Fruit & Jelly": [
    {
      id: "20807867",
      name: "Jelly",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910059",
      name: "Fruit Salad",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "92910062",
      name: "Fruit Salad With Ice Cream",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "92910064",
      name: "Assorted Fruits",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355732",
      name: "Fruit Salad Jelly With Ice Cream",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 17500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355733",
      name: "Fruit With Jelly",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 14500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355734",
      name: "Jelly With Ice Cream",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 15500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355735",
      name: "Special Gadbad Ice Cream",
      category: "Fruit & Jelly",
      inStock: 1,
      isVeg: 1,
      price: 22500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Desserts: [
    {
      id: "20807892",
      name: "Gulab Jamun",
      category: "Desserts",
      imageId: "17f628ab71115e27d95c193287401747",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "20807905",
      name: "Aamras",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 15000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "92910072",
      name: "Rabdi",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 16000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "92910073",
      name: "Rabdi With Gulab Jamun",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 20000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "92910077",
      name: "Kulfi",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95355737",
      name: "Hoey Fried Noodles With Vanilla Ice Cream",
      category: "Desserts",
      inStock: 1,
      isVeg: 1,
      price: 17000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Choose Any": [
    {
      id: "92910101",
      name: "Soya",
      category: "Choose Any",
      inStock: 1,
      isVeg: 1,
      price: 28000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994381",
          groupName: "Choose Any Preparation",
          choices: [
            {
              id: "64625247",
              name: "Achari",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625248",
              name: "Kalimiri",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625249",
              name: "Malai",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625250",
              name: "Reshmi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625251",
              name: "Pahadi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625252",
              name: "Tikka",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "93574783",
      name: "Mushroom",
      category: "Choose Any",
      inStock: 1,
      isVeg: 1,
      price: 29000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994380",
          groupName: "Choose Any Preparation",
          choices: [
            {
              id: "64625247",
              name: "Achari",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625248",
              name: "Kalimiri",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625249",
              name: "Malai",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625250",
              name: "Reshmi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625251",
              name: "Pahadi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625252",
              name: "Tikka",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "93574784",
      name: "Broccoli",
      category: "Choose Any",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994379",
          groupName: "Choose Any Preparation",
          choices: [
            {
              id: "64625247",
              name: "Achari",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625260",
              name: "Kalimiri",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625261",
              name: "Malai",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625256",
              name: "Reshmi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625257",
              name: "Pahadi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625264",
              name: "Tikka",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "93574786",
      name: "Baby Corn",
      category: "Choose Any",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994378",
          groupName: "Choose Any Preparation",
          choices: [
            {
              id: "64625247",
              name: "Achari",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625260",
              name: "Kalimiri",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625261",
              name: "Malai",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625256",
              name: "Reshmi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625257",
              name: "Pahadi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625264",
              name: "Tikka",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "93574787",
      name: "Aloo",
      category: "Choose Any",
      inStock: 1,
      isVeg: 1,
      price: 25000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79994377",
          groupName: "Choose Any Preparation",
          choices: [
            {
              id: "64625247",
              name: "Achari",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625260",
              name: "Kalimiri",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625261",
              name: "Malai",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625256",
              name: "Reshmi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625257",
              name: "Pahadi",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "64625264",
              name: "Tikka",
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[burgerKing] = {
  Whopper: [
    {
      id: "88676617",
      name: "Veg Whopper",
      category: "Whopper",
      description:
        "Our Signature Whopper With 7 Layers Between The Buns. Extra Crunchy Veg Patty, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces With Xxl Buns. It’S Not A Burger, It’S A Whopper",
      imageId: "sgnlylsa7gqijo2qydq3",
      inStock: 1,
      isVeg: 1,
      price: 17900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65532519",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532521",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532520",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532524",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532522",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "186 ratings",
          ratingCountV2: "186",
        },
      },
    },
    {
      id: "88676618",
      name: "Veg Whopper with Cheese",
      category: "Whopper",
      description:
        "Our Signature Whopper With 7 Layers Between The Buns. Extra Crunchy Veg Patty With Cheese Slice, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces With Xxl Buns. It’S Not A Burger, It’S A Whopper",
      imageId: "vriqohxtrafiqxmx6k2p",
      inStock: 1,
      isVeg: 1,
      price: 19400,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79623006",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532537",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532535",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532539",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532538",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
    {
      id: "88676620",
      name: "Veg Whopper Double Patty",
      category: "Whopper",
      description:
        "Our Signature Whopper With 7 Layers Between The Buns. Extra Crunchy Veg Double Patty, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces With Xxl Buns. It’S Not A Burger, It’S A Whopper",
      imageId: "xrcphbn2qqfzz7uus38l",
      inStock: 1,
      isVeg: 1,
      price: 22900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65532945",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532954",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532947",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532961",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532958",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "88676622",
      name: "Indie Tikka Whopper Veg",
      category: "Whopper",
      description:
        "Extra crunchy veg patty, loads of veggies, Minty, Makhani and Creamy Sauce in XXL buns, the Indie Tikka Whopper is a fusion of funky flavours.",
      imageId: "dratvwvse8acuj0tsrtu",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533014",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65533028",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65533022",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65533041",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65533034",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "30 ratings",
          ratingCountV2: "30",
        },
      },
    },
  ],
  "Kings Premium Burgers": [
    {
      id: "88676552",
      name: "Hot 'N' Cheezy Burger",
      category: "Kings Premium Burgers",
      description:
        "Chilli Cheese patty, spicy sauce, soft square masala buns. It's cheezy & spicy.",
      imageId: "zv7fx1ed433greh6tpvn",
      inStock: 1,
      isVeg: 1,
      price: 19900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65742371",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742373",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742372",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742375",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742374",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "78 ratings",
          ratingCountV2: "78",
        },
      },
    },
    {
      id: "88676553",
      name: "Paneer Royale Burger",
      category: "Kings Premium Burgers",
      description:
        "Thick Paneer Patty, loads of sauces in soft square masala buns. It's Royally Paneer.",
      imageId: "gq6qbyomdgkuql8aevd1",
      inStock: 1,
      isVeg: 1,
      price: 19900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65742376",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742378",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742377",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742380",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742379",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "53 ratings",
          ratingCountV2: "53",
        },
      },
    },
    {
      id: "88676554",
      name: "Fiery Chicken Burger",
      category: "Kings Premium Burgers",
      description:
        "Spicy Fried Chicken, loads of sauces in soft square masala buns. It's hot and happening.",
      imageId: "ppxmlepv15e3qexhhq9v",
      inStock: 1,
      price: 19900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65742381",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742383",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742382",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742385",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65742384",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "139 ratings",
          ratingCountV2: "139",
        },
      },
    },
  ],
  "Burger Doubles.": [
    {
      id: "88676579",
      name: "Crispy Veg Double Patty + Crispy Veg Double Patty",
      category: "Burger Doubles.",
      description: "Crispy Veg Double Patty + Crispy Veg Double Patty",
      imageId: "n3xekdsgny6jdboxy4xw",
      inStock: 1,
      isVeg: 1,
      price: 19000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65531692",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531688",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531698",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531693",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "97 ratings",
          ratingCountV2: "97",
        },
      },
    },
    {
      id: "88676580",
      name: "BK Veggie Burger + BK Veggie Burger",
      category: "Burger Doubles.",
      description: "BK Veggie Burger + BK Veggie Burger",
      imageId: "bxzazdbhgsttmnoqdhdu",
      inStock: 1,
      isVeg: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65531746",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531743",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531750",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531748",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "22 ratings",
          ratingCountV2: "22",
        },
      },
    },
    {
      id: "88676582",
      name: "Veg Makhani Burst +  Whopper Jr Veg",
      category: "Burger Doubles.",
      description: "Veg Makhani Burst + Lite Whopper Jr Veg",
      imageId: "vrs4vlu7go8nr7q4mcwb",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65531795",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531792",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531798",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531797",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "43 ratings",
          ratingCountV2: "43",
        },
      },
    },
    {
      id: "88676583",
      name: "BK Chicken Burger + BK Chicken Burger",
      category: "Burger Doubles.",
      description: "BK Chicken Burger + BK Chicken Burger",
      imageId: "qfrcbn4v04lkctjsyeoa",
      inStock: 1,
      price: 27800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65531735",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531733",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531737",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531736",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "88676586",
      name: "Crispy Chicken Double Patty + Crispy Chicken Double Patty",
      category: "Burger Doubles.",
      description: "Crispy Chicken Double Patty + Crispy Chicken Double Patty",
      imageId: "rbsdsxa1esuwgdh3bsh0",
      inStock: 1,
      price: 23800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65532061",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532058",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532068",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65532063",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "106 ratings",
          ratingCountV2: "106",
        },
      },
    },
    {
      id: "88676587",
      name: "Veg Whopper + Veg Whopper",
      category: "Burger Doubles.",
      description: "Veg Whopper + Veg Whopper",
      imageId: "kjeubraveyclzcylvfnj",
      inStock: 1,
      isVeg: 1,
      price: 35800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65531966",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531962",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531976",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65531972",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "111433234",
      name: "2 Crispy Veg",
      category: "Burger Doubles.",
      imageId: "5cab04c856cc023e482522be309fc5b1",
      inStock: 1,
      isVeg: 1,
      price: 14000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Friends & Family Combo (Save upto 20%)": [
    {
      id: "88676605",
      name: "2 Crispy Veg Double Patty + 1King Fries + 1Veggie strips",
      category: "Friends & Family Combo (Save upto 20%)",
      description: "2 Crispy Veg Double Patty + 1King Fries + 1Veggie strips",
      imageId: "nijanydurnusuwckrzim",
      inStock: 1,
      isVeg: 1,
      price: 35800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "100380917",
      name: "1 Jr Veg Whopper +1 Chocolate Thick Shake",
      category: "Friends & Family Combo (Save upto 20%)",
      description: "Save Rs. 49 | 1 Jr. Veg Whopper +1 Chocolate Thick Shake",
      imageId: "guewpefkkopaurmjxwlf",
      inStock: 1,
      isVeg: 1,
      price: 26900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "105243917",
      name: "Cheezy Bite",
      category: "Friends & Family Combo (Save upto 20%)",
      description: "MRP: 318 |  Save 15%, Hot 'N' Cheezy Burger+1King Fries",
      imageId: "m5wgy2mjxgzla05jqdsi",
      inStock: 1,
      isVeg: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "105243918",
      name: "Fire Me Up",
      category: "Friends & Family Combo (Save upto 20%)",
      description: "MRP: 318 |  Save 15%, Fiery Chicken Burger + 1 King Fries",
      imageId: "h3abpmfvnui7auc6lcdt",
      inStock: 1,
      price: 27000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Meal Combos(Save Rs. 45)": [
    {
      id: "88676656",
      name: "Crispy Veg Combo",
      category: "Meal Combos(Save Rs. 45)",
      description:
        "Save Rs 45 | Our best-selling burger with crispy veg patty, fresh onion and our signature sauce. Comes with Fries (M) + Pepsi (M)",
      imageId: "deyyaxafzufypp1xtpij",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75013335",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013338",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013339",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "51 ratings",
          ratingCountV2: "51",
        },
      },
    },
    {
      id: "88676658",
      name: "BK Veggie Burger Combo",
      category: "Meal Combos(Save Rs. 45)",
      description:
        "Save Rs 45 | Our tribute to classic American taste. BK veg patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce. Comes with Fries (M) + Pepsi (M)",
      imageId: "zmn1fymdtkprk5vlkud1",
      inStock: 1,
      isVeg: 1,
      price: 24800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75013363",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013364",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013365",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "88676661",
      name: "BK Chicken Burger Combo",
      category: "Meal Combos(Save Rs. 45)",
      description:
        "Save Rs 45 |Our tribute to classic American taste. BK chicken patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce. Comes with Fries (M) + Pepsi (M)",
      imageId: "ketwbup2ikpyy7cn37x5",
      inStock: 1,
      price: 26800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75013373",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013374",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013375",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676662",
      name: "Whopper Jr Veg Combo",
      category: "Meal Combos(Save Rs. 45)",
      description:
        "Save Rs 45 |Our signature Whopper with 7 layers between the buns in a convenient size. Extra crunchy veg Patty, fresh onion, crispy lettuce, juicy tomatoes(seasonal), tangy gherkins, creamy and smoky sauces. Comes with Fries (M) + Pepsi (M)",
      imageId: "ctrtjnt4kbua0aptyelj",
      inStock: 1,
      isVeg: 1,
      price: 26800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75013381",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013384",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013387",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "88676675",
      name: "Hot 'N' Cheezy Burger Combo",
      category: "Meal Combos(Save Rs. 45)",
      description:
        "Save Rs 45 |Chilli Cheese patty, spicy sauce, soft square masala buns. It's cheezy & spicy. Comes with Fries (M) + Pepsi (M)",
      imageId: "rviwuzgjzwfnncsah6ht",
      inStock: 1,
      isVeg: 1,
      price: 34800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75013513",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013514",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013515",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676676",
      name: "Paneer Royale Burger Combo",
      category: "Meal Combos(Save Rs. 45)",
      description:
        "Save Rs 45 |Thick Paneer Patty, loads of sauces in soft square masala buns. It's Royally Paneer. Comes with Fries (M) + Pepsi (M)",
      imageId: "jrvhuujbgioijvapv5sv",
      inStock: 1,
      isVeg: 1,
      price: 34800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75013548",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013549",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013550",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "108367464",
      name: "Veg Whopper Combo",
      category: "Meal Combos(Save Rs. 45)",
      description:
        "Save Rs 45 |Our signature Whopper with 7 layers between the buns. Extra crunchy veg Patty, fresh onion, crispy lettuce, juicy tomatoes(seasonal), tangy gherkins, creamy and smoky sauces with xxl buns. It’s Not A Burger, it’s a Whopper. Comes with Fries (M) + Pepsi (M)",
      imageId: "msp9yzcm0mo0hgc7nltp",
      inStock: 1,
      isVeg: 1,
      price: 31800,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "75013483",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013484",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "75013485",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  Sides: [
    {
      id: "88676725",
      name: "Chicken Fries - 5 Pcs",
      category: "Sides",
      description: "Chicken In A Spicy New Avatar",
      imageId: "tqhq4zd5sxa6qdc8yhwj",
      inStock: 1,
      price: 7900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "83691902",
          groupName: "Add Peri Peri Spice Mix",
          choices: [
            {
              id: "68726883",
              name: "Peri Peri Spice Mix",
              price: 2857,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "137 ratings",
          ratingCountV2: "137",
        },
      },
    },
    {
      id: "88676729",
      name: "Cheesy Fries",
      category: "Sides",
      description: "Crispy French Fries, Loads Of Cheese, Yum!",
      imageId: "bs5oedbj1ihduwvbuj8z",
      inStock: 1,
      isVeg: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "83691817",
          groupName: "Add Peri Peri Spice Mix",
          choices: [
            {
              id: "68726883",
              name: "Peri Peri Spice Mix",
              price: 2857,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "46 ratings",
          ratingCountV2: "46",
        },
      },
    },
    {
      id: "88676730",
      name: "Creamy Italian  Fries",
      category: "Sides",
      description:
        "The Lip-Smacking Duo Of Creamy Classic Mayo And Tangy Tomato Herb Mayo Make These Fries Very Hard To Resist!",
      imageId: "b3hgwlbtnnuovkb4rvcv",
      inStock: 1,
      isVeg: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "83691809",
          groupName: "Add Peri Peri Spice Mix",
          choices: [
            {
              id: "68726883",
              name: "Peri Peri Spice Mix",
              price: 2857,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "88676731",
      name: "King Peri Peri Fries",
      category: "Sides",
      description: "Crispy Fries With Peri Peri Spice. Hot Indeed",
      imageId: "mgipyyoulmma7rjwofoj",
      inStock: 1,
      isVeg: 1,
      price: 14800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "46 ratings",
          ratingCountV2: "46",
        },
      },
    },
    {
      id: "100562945",
      name: "Hashbrown",
      category: "Sides",
      description: "What Every Potato Wants To Be",
      imageId: "hslhhbg0ix0ptxl1egez",
      inStock: 1,
      isVeg: 1,
      price: 3900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "67 ratings",
          ratingCountV2: "67",
        },
      },
    },
    {
      id: "101191352",
      name: "Veggie Strips(5 Pcs)",
      category: "Sides",
      description: "Vegetarian's Favourite Finger Food",
      imageId: "jez2tqz2d0euumrrpvbn",
      inStock: 1,
      isVeg: 1,
      price: 4900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "83691781",
          groupName: "Add Peri Peri Spice Mix",
          choices: [
            {
              id: "68726883",
              name: "Peri Peri Spice Mix",
              price: 2857,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "94 ratings",
          ratingCountV2: "94",
        },
      },
    },
    {
      id: "101191354",
      name: "Medium Fries",
      category: "Sides",
      description: "The Perfect Crispy Partner",
      imageId: "uttwq3j7gos3thsaposd",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "66 ratings",
          ratingCountV2: "66",
        },
      },
    },
    {
      id: "101191358",
      name: "King Fries",
      category: "Sides",
      description: "The Perfect Crispy Partner",
      imageId: "uttwq3j7gos3thsaposd",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "83692011",
          groupName: "Add Peri Peri Spice Mix",
          choices: [
            {
              id: "68726883",
              name: "Peri Peri Spice Mix",
              price: 2857,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "147 ratings",
          ratingCountV2: "147",
        },
      },
    },
    {
      id: "101191359",
      name: "Medium Peri Peri Fries",
      category: "Sides",
      description: "Crispy Fries With Peri Peri Spice. Hot Indeed",
      imageId: "mgipyyoulmma7rjwofoj",
      inStock: 1,
      isVeg: 1,
      price: 13400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "60 ratings",
          ratingCountV2: "60",
        },
      },
    },
    {
      id: "111845928",
      name: "Peri Peri Spice Mix",
      category: "Sides",
      imageId: "1200974eb60f9c4489cad469e5485498",
      inStock: 1,
      isVeg: 1,
      price: 2857,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
  ],
  Beverages: [
    {
      id: "88676732",
      name: "Pepsi",
      category: "Beverages",
      imageId: "jjsk5itomwsjmfz3sd3b",
      inStock: 1,
      isVeg: 1,
      price: 8900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "22 ratings",
          ratingCountV2: "22",
        },
      },
    },
    {
      id: "88676735",
      name: "Chocolate Thick Shake",
      category: "Beverages",
      description: "Our Signature Chocolate Thick Shake",
      imageId: "iixakii4wvkq3dgmpsvc",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "34 ratings",
          ratingCountV2: "34",
        },
      },
    },
    {
      id: "88676736",
      name: "Mango Thick Shake",
      category: "Beverages",
      description: "Our Signature Mango Thick Shake",
      imageId: "e5fk28ospzzsy5a7m7hc",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "88676739",
      name: "Berry Blast Thick Shake",
      category: "Beverages",
      description: "Rich Creamy Black Currant Thick shake",
      imageId: "yzkpob5ifvenc79yqjvs",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "109811390",
      name: "Pepsi Black Medium",
      category: "Beverages",
      description: "Pepsi Black",
      imageId: "f8320b1b518af3ccb404687e2e185e58",
      inStock: 1,
      isVeg: 1,
      price: 8900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.2",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "111132078",
      name: "Mirinda Medium",
      category: "Beverages",
      imageId: "39e3ce914464c6eac8e601ec3f4dded4",
      inStock: 1,
      isVeg: 1,
      price: 8900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "111132079",
      name: "Mountain Dew Medium",
      category: "Beverages",
      imageId: "8766c3abdc752653526a3663bd86c550",
      inStock: 1,
      isVeg: 1,
      price: 8900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111132080",
      name: "Lipton Ice Tea (Medium)",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 8900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111132081",
      name: "7 Up Medium",
      category: "Beverages",
      imageId: "09b99545c6879dfb5cbae7525544026e",
      inStock: 1,
      isVeg: 1,
      price: 8900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Desserts: [
    {
      id: "88676740",
      name: "Choco Lava Cup",
      category: "Desserts",
      description: "Melty Chocolate filled in cupcake",
      imageId: "nsm44tzuxpceproaymyr",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "88676741",
      name: "Chocolate Mousse Cup",
      category: "Desserts",
      description:
        "Airy and creamy chocolate mousse topped with chocolate ganache and choco chips",
      imageId: "hxpyxm2e2dasvebpzkoz",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "101437678",
      name: "Chocochip Muffin",
      category: "Desserts",
      description: "Soft & Fluffy chocolate cake topped with chocolate chips",
      imageId: "lhkmuwim5nfedoaye6lc",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "101437679",
      name: "Vanilla Blueberry Muffin",
      category: "Desserts",
      description: "Soft & Fluffy vanilla cake with blueberry flavour.",
      imageId: "ydcvw9nkp3o2exsjk4cz",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
  ],
  "Chicken Wings": [
    {
      id: "88676748",
      name: "Boneless Wings Large",
      category: "Chicken Wings",
      description: "7pcs Boneless Chicken Bites",
      imageId: "qefyb4gxjhh0i9iz6ozu",
      inStock: 1,
      price: 24900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "23 ratings",
          ratingCountV2: "23",
        },
      },
    },
  ],
  "Super Saver Combos (Save Rs 85)": [
    {
      id: "88676511",
      name: "Paneer Royale Burger + Hot 'N' Cheezy Burger + 1 Med Fries",
      category: "Super Saver Combos (Save Rs 85)",
      description: "MRP 533. Save Rs 95! With this Limited Time Offer",
      imageId: "onssgrtxft7udr5ds7qy",
      inStock: 1,
      isVeg: 1,
      price: 41800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "88676512",
      name: "2 Hot 'N' Cheezy Burger + 1 Med Fries",
      category: "Super Saver Combos (Save Rs 85)",
      description: "MRP 533. Save Rs 95! With this Limited Time Offer",
      imageId: "pqm4ofmptidnqw9e6pmy",
      inStock: 1,
      isVeg: 1,
      price: 41800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "88676513",
      name: "2 Fiery Chicken Burger + 1 Med Fries",
      category: "Super Saver Combos (Save Rs 85)",
      description: "MRP 533. Save Rs 95! With this Limited Time Offer",
      imageId: "hyvhcr4g1efoo71itzk5",
      inStock: 1,
      price: 41800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "88676514",
      name: "2 Paneer Royale Burger + 1 Med Fries",
      category: "Super Saver Combos (Save Rs 85)",
      description: "MRP 533. Save Rs 95! With this Limited Time Offer",
      imageId: "zftsnjnvvbmbshojb5zk",
      inStock: 1,
      isVeg: 1,
      price: 41800,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Burgers & Wraps": [
    {
      id: "88676702",
      name: "BK-Chicken Double Patty Burger",
      category: "Burgers & Wraps",
      description:
        "Our tribute to classic American taste. BK chicken double patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce",
      imageId: "mvuj0ttjafdeebulhop4",
      inStock: 1,
      price: 17900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79623135",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65535482",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65535480",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65535483",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "9 ratings",
          ratingCountV2: "9",
        },
      },
    },
    {
      id: "101191216",
      name: "Crispy Veg Burger",
      category: "Burgers & Wraps",
      description:
        "Our Best-Selling Burger With Crispy Veg Patty, Fresh Onion And Our Signature Sauce",
      imageId: "eqaon8guufklmil7ayhr",
      inStock: 1,
      isVeg: 1,
      price: 7000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65534475",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534481",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534477",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534485",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534483",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "287 ratings",
          ratingCountV2: "287",
        },
      },
    },
    {
      id: "101191220",
      name: "Crispy Veg Double Patty Burger",
      category: "Burgers & Wraps",
      description:
        "Our Best-Selling Burger With Crispy Veg Double Patty, Fresh Onion And Our Signature Sauce",
      imageId: "phm3t2g7v0lpczvtu6g7",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65534495",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534500",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534497",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534503",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534502",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "77 ratings",
          ratingCountV2: "77",
        },
      },
    },
    {
      id: "101191231",
      name: "BK-Veggie Double Patty Burger",
      category: "Burgers & Wraps",
      description:
        "Our tribute to classic American taste. BK veg double patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce",
      imageId: "iajmq3xmw6cg13easydh",
      inStock: 1,
      isVeg: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79623105",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534764",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534763",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534768",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "101191235",
      name: "BK Veggie Burger",
      category: "Burgers & Wraps",
      description:
        "Our tribute to classic American taste. Bk veg patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce",
      imageId: "ylt69e6eeeltgwnf8jla",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65534784",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534797",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534791",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534806",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534801",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "101191284",
      name: "Crispy Veg Double Patty with Cheese",
      category: "Burgers & Wraps",
      description:
        "Our Best-Selling Burger With Crispy Veg Double Patty, Cheese Slice, Fresh Onion And Our Signature Sauce",
      imageId: "ndp3akjkdainthdpugjp",
      inStock: 1,
      isVeg: 1,
      price: 12000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79623106",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534834",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534827",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534845",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534840",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "101191286",
      name: "BK Chicken Burger_",
      category: "Burgers & Wraps",
      description:
        "Our tribute to classic American taste. BK chicken patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce.",
      imageId: "zo2ukigdl7xu15zkf4ml",
      inStock: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65534906",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534908",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534907",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534910",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65534909",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
    {
      id: "101191288",
      name: "Whopper Jr Veg",
      category: "Burgers & Wraps",
      description:
        "Our Signature Whopper With 7 Layers Between The Buns In A Convenient Size. Extra Crunchy Veg Patty, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces",
      imageId: "y9paueit9iwqcdwv62kf",
      inStock: 1,
      isVeg: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65535090",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65535093",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65535091",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "65535101",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "65535097",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "101191297",
      name: "Crispy Chicken Burger",
      category: "Burgers & Wraps",
      description:
        "Our Best-Selling Burger With Crispy Chicken Patty, Onion And Classic Mayo Sauce",
      imageId: "mqr237klqgnu0w2pzd94",
      inStock: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67054145",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054149",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054147",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054152",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054150",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "177 ratings",
          ratingCountV2: "177",
        },
      },
    },
    {
      id: "101191299",
      name: "Crispy Chicken Double Patty Burger",
      category: "Burgers & Wraps",
      description:
        "Our Best-Selling Burger With Crispy Chicken Double Patty, Onion And Classic Mayo Sauce",
      imageId: "vfagr7gcirgouhiewq66",
      inStock: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "67054164",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054167",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054166",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054169",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054168",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "110 ratings",
          ratingCountV2: "110",
        },
      },
    },
    {
      id: "102671326",
      name: "Crispy Chicken with Cheese Burger",
      category: "Burgers & Wraps",
      description:
        "Our Best-Selling Burger With Crispy Chicken Patty, Cheese Slice, Onion And Classic Mayo Sauce",
      imageId: "ieec9d9wdbunnpe98vun",
      inStock: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "79623110",
          groupName: "SAY CHEESE!",
          choices: [
            {
              id: "52217002",
              name: "Double Cheese Slice",
              price: 5000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217003",
              name: "Single Cheese Slice",
              price: 2500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054155",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054154",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054158",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "67054157",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "21 ratings",
          ratingCountV2: "21",
        },
      },
    },
    {
      id: "106695981",
      name: "Crunchy Chicken Taco",
      category: "Burgers & Wraps",
      description:
        "Crunchy Shell with chicken patty, crunchy veggies and spicy sauce",
      imageId: "kzekifdu0vakjkebcxml",
      inStock: 1,
      price: 11000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "83387802",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "83387803",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "83387804",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "83387805",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.1",
          ratingCount: "45 ratings",
          ratingCountV2: "45",
        },
      },
    },
    {
      id: "106695982",
      name: "Veg Crunchy Taco",
      category: "Burgers & Wraps",
      description:
        "Crunchy Shell with mix veg filling, crunchy veggies and spicy sauce",
      imageId: "ljhtdtkkjocyjmczu994",
      inStock: 1,
      isVeg: 1,
      price: 9000,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "83387806",
          groupName: "Make it a combo!!",
          choices: [
            {
              id: "64705355",
              name: "King Fries + Medium Pepsi (23% off)",
              price: 15900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115883",
              name: "Medium Fries + Medium Pepsi Black (23% OFF)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217015",
              name: "Medium Fries + Medium Fountain Pepsi(23% Off)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217013",
              name: "Medium Fries + Chocolate Thick Shake (34% off)",
              price: 19500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217012",
              name: "Medium Fries + Classic Cold coffee (22% off)",
              price: 22900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217011",
              name: "Med Fries + Med Pepsi + Choco Lava (25% Off)",
              price: 21900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "83387807",
          groupName: "Choose your Sides",
          choices: [
            {
              id: "52217005",
              name: "King Fries",
              price: 11900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217006",
              name: "King Peri Peri Fries",
              price: 14800,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217008",
              name: "Medium Fries",
              price: 10500,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217009",
              name: "Medium Peri Peri Fries",
              price: 13400,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217007",
              name: "Cheesy Fries",
              price: 13900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "66921432",
              name: "Boneless Wings (4 Pcs)",
              price: 14900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 2,
          maxFreeAddons: -1,
        },
        {
          groupId: "83387808",
          groupName: "Choose Your Beverages!!",
          choices: [
            {
              id: "52217025",
              name: "Chocolate Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217023",
              name: "Classic Cold Coffee",
              price: 19900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217027",
              name: "Berry Blast Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217024",
              name: "Mocha Frappe",
              price: 25900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217029",
              name: "Medium Pepsi",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "62115884",
              name: "Medium Pepsi Black",
              price: 8900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217026",
              name: "Mango Thick Shake",
              price: 18900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
        {
          groupId: "83387809",
          groupName: "Add Dessert",
          choices: [
            {
              id: "52217018",
              name: "Choco Lava Cake",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217017",
              name: "Chocolate Mousse Cup",
              price: 10900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217019",
              name: "Chocochip Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
            {
              id: "52217020",
              name: "Vanilla Blueberry Muffin",
              price: 12900,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "29 ratings",
          ratingCountV2: "29",
        },
      },
    },
  ],
  "Cricket Mania Combos": [
    {
      id: "110154105",
      name: "Kungfu Brothers Combo- Veg",
      category: "Cricket Mania Combos",
      description:
        "2 BK Crispy Veg Burgers + Med Pepsi + Classic Cold Coffee + Med Fries",
      imageId: "2b92859bd189acbd8920d0416b66eff6",
      inStock: 1,
      isVeg: 1,
      price: 53300,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110154108",
      name: "Whopper Partnership Combo- Veg",
      category: "Cricket Mania Combos",
      description: "2Veg Whopper + 2Med Pepsi + 1King Fries",
      imageId: "31cdff103fdf86f07e0dd63786a83f0a",
      inStock: 1,
      isVeg: 1,
      price: 65500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "110154110",
      name: "Toss Ka Boss Combo- Veg",
      category: "Cricket Mania Combos",
      description:
        "Paneer Royale Burger + BK Classic Veg Burger + Med Fries +2Pepsi",
      imageId: "ab72007cae26333b3de9d08d69ca72d1",
      inStock: 1,
      isVeg: 1,
      price: 60100,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "BK Cafe": [
    {
      id: "88676522",
      name: "Americano (Small)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with Hot Water.",
      imageId: "xarekgjg37pajk0gksq4",
      inStock: 1,
      isVeg: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533111",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676523",
      name: "Americano (Regular)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with Hot Water.",
      imageId: "xarekgjg37pajk0gksq4",
      inStock: 1,
      isVeg: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533138",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676524",
      name: "Cappuccino (Small)",
      category: "BK Cafe",
      description: "Espresso with steamed milk & milk froth",
      imageId: "mkm2kxtsjaaej5adzosw",
      inStock: 1,
      isVeg: 1,
      price: 15900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533145",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676525",
      name: "Cappuccino (Regular)",
      category: "BK Cafe",
      description: "Espresso with steamed milk & milk froth",
      imageId: "mkm2kxtsjaaej5adzosw",
      inStock: 1,
      isVeg: 1,
      price: 17900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533153",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "88676526",
      name: "Café Latte (Small)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with steamed milk.",
      imageId: "rxo7t0cvvcz4yqcjnqxt",
      inStock: 1,
      isVeg: 1,
      price: 15900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533161",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676527",
      name: "Café Latte (Regular)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with steamed milk.",
      imageId: "rxo7t0cvvcz4yqcjnqxt",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533170",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676528",
      name: "Mocha Cappuccino (Small)",
      category: "BK Cafe",
      description: "Rich Chocolate Flavoured Coffee",
      imageId: "pwcengrvuiwin79ftiim",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533185",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676529",
      name: "Mocha Cappuccino (Regular)",
      category: "BK Cafe",
      description: "Rich Chocolate Flavoured Coffee",
      imageId: "pwcengrvuiwin79ftiim",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533197",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676530",
      name: "Café Caramello (Small)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with Sweet Caramel Flavour",
      imageId: "cyftwiykxzkx1kerkkaf",
      inStock: 1,
      isVeg: 1,
      price: 17900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533237",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676531",
      name: "Café Caramello (Regular)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with Sweet Caramel Flavour",
      imageId: "cyftwiykxzkx1kerkkaf",
      inStock: 1,
      isVeg: 1,
      price: 20900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533256",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676534",
      name: "Hazelnut Cappuccino (Small)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with Nutty Hazelnut Flavour",
      imageId: "ia1aenystt2p7qtewi37",
      inStock: 1,
      isVeg: 1,
      price: 17900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533273",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676535",
      name: "Hazelnut Cappuccino (Regular)",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee with Nutty Hazelnut Flavour",
      imageId: "ia1aenystt2p7qtewi37",
      inStock: 1,
      isVeg: 1,
      price: 20900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533293",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676536",
      name: "Hot Chocolate",
      category: "BK Cafe",
      description:
        "The chocolate which you can drink. Rich Creamy Chocolate with steamed milk.",
      imageId: "bbcnyic4eczdu81trzaf",
      inStock: 1,
      isVeg: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "88676538",
      name: "Berry Blast Thickshake",
      category: "BK Cafe",
      description: "Rich Creamy Black Currant Thick shake",
      imageId: "vrtwfmv5culjrethblhy",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "17 ratings",
          ratingCountV2: "17",
        },
      },
    },
    {
      id: "88676645",
      name: "Chocolate Thickshake",
      category: "BK Cafe",
      description: "Rich Creamy Chocolate Thick shake",
      imageId: "iixakii4wvkq3dgmpsvc",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "34 ratings",
          ratingCountV2: "34",
        },
      },
    },
    {
      id: "88676646",
      name: "Mango Thickshake",
      category: "BK Cafe",
      description: "Rich Creamy Mango Thick shake",
      imageId: "e5fk28ospzzsy5a7m7hc",
      inStock: 1,
      isVeg: 1,
      price: 18900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "10 ratings",
          ratingCountV2: "10",
        },
      },
    },
    {
      id: "95388216",
      name: "Classic Cold Coffee",
      category: "BK Cafe",
      description: "Our signature BK Café Coffee ice blended with milk & cream",
      imageId: "spupzyvwrsv4yjegs4gf",
      inStock: 1,
      isVeg: 1,
      price: 19900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "95388217",
      name: "Mocha Frappe",
      category: "BK Cafe",
      description: "Chocolate Flavoured Cold Coffee topped with Cream",
      imageId: "oakfdc83as9rhjwwij8y",
      inStock: 1,
      isVeg: 1,
      price: 25900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533335",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95388218",
      name: "Caramel Frappe",
      category: "BK Cafe",
      description: "Sweet Caramel Flavoured Cold Coffee topped with Cream",
      imageId: "szhxtvl5xkwjiv5vnkrq",
      inStock: 1,
      isVeg: 1,
      price: 25900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533351",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95388219",
      name: "Hazelnut Frappe",
      category: "BK Cafe",
      description:
        "Creamy Vanilla Irish Flavoured Cold Coffee topped with Cream",
      imageId: "vgej9fb9zv8gyls7vzuz",
      inStock: 1,
      isVeg: 1,
      price: 25900,
      variants: {},
      variantsV2: {},
      addons: [
        {
          groupId: "65533354",
          groupName: "Add Extra Shot",
          choices: [
            {
              id: "52217230",
              name: "Extra Shot",
              price: 4000,
              inStock: 1,
              isVeg: 1,
              isEnabled: 1,
            },
          ],
          maxAddons: 1,
          maxFreeAddons: -1,
        },
      ],
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95388222",
      name: "Caramel Crunch Shake",
      category: "BK Cafe",
      description:
        "Thick Shake with Butterscotch Crunch & Caramel Sauce topped with Cream. A BK Café Special.",
      imageId: "piu5wxvfyakmtgol7eid",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "95388223",
      name: "Choco Berry Shake",
      category: "BK Cafe",
      description:
        "Thick Shake with Rich Chocolate & Blackcurrant topped with Cream. A BK Café Special.",
      imageId: "tetj5z7fy1r0rbdkj3ub",
      inStock: 1,
      isVeg: 1,
      price: 21900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "18 ratings",
          ratingCountV2: "18",
        },
      },
    },
    {
      id: "95388226",
      name: "Chocochip Muffin",
      category: "BK Cafe",
      description: "Soft & Fluffy chocolate cake topped with chocolate chips.",
      imageId: "lhkmuwim5nfedoaye6lc",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "95388227",
      name: "Vanilla Blueberry Muffin",
      category: "BK Cafe",
      description: "Soft & Fluffy vanilla cake with blueberry flavour.",
      imageId: "ydcvw9nkp3o2exsjk4cz",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "107186821",
      name: "Masala Chai",
      category: "BK Cafe",
      description: "Masala Chai",
      imageId: "9784c1fba62f646f985518145ec2c5c7",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      offerTags: [
        {
          title: "60% OFF",
          subTitle: "USE STEALDEAL",
          textColor: "#DB6742",
          backgroundColor: "#FAE8E3",
        },
      ],
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[momoNation] = {
  "Veg Momos": [
    {
      id: "105475606",
      name: "Simple Veg Steam (6 Pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with freshly chopped veggies (carrot, cabbage, beans & coriander) tinch of spices and mixed with indian masala. Served with spicy red sauce\n",
      imageId: "79e6b4d864b53652a2cb111a5edfb61d",
      inStock: 1,
      isVeg: 1,
      price: 8900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.4",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "105475607",
      name: "Simple Veg Fried (6 Pcs)  ",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with freshly chopped veggies (carrot, cabbage, beans & coriander) tinch of spices and mixed with indian masala. Served with spicy red sauce\n",
      imageId: "b3b4999e740e7cc4f8289b80409e2b99",
      inStock: 1,
      isVeg: 1,
      price: 9900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475608",
      name: "Schezwan Veg Steam(6 Pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with schezwan and freshly chopped veggies (carrot, cabbage, beans & coriander), paneer, tinch of spices and mixed with indian masala. Served with spicy red sauce\n",
      imageId: "4018820572399410fef476fbc1e57c5a",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475609",
      name: "Schezwan Veg Fried (6 Pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with schezwan and freshly chopped veggies (carrot, cabbage, beans & coriander), paneer, tinch of spices and mixed with indian masala. Served with spicy red sauce\n",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475610",
      name: "Simply Paneer Steam (6 Pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with freshly chopped veggies and paneer, tinch of spices and mixed with indian masala. Served with spicy red sauce \n",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475611",
      name: "Simply Paneer Fried (6 Pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with freshly chopped veggies and paneer, tinch of spices and mixed with indian masala. Served with spicy red sauce \n",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475613",
      name: "Maggie Momos Steam (6 Pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with tasty maggie tinch of spices and mixed with maggi masala. Served with spicy red sauce \n",
      inStock: 1,
      isVeg: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475614",
      name: "Maggie Momos Fried (6pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with tasty maggie tinch of spices and mixed with maggi masala. Served with spicy red sauce \n",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475615",
      name: "Veg Cheese Steam (6pcs)",
      category: "Veg Momos",
      description:
        "Momos filled with shredded cheese veggies and sweet corn and mixed with the flavours of indian spices. Served with home-made spicy red sauce\n",
      imageId: "e8387f4465ad94cbdd35c5ccbabd7ce3",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475616",
      name: "Veg Cheese Fried (6 Pcs)",
      category: "Veg Momos",
      description:
        "Momos filled with shredded cheese veggies and sweet corn and mixed with the flavours of indian spices. Served with home-made spicy red sauce\n",
      imageId: "a18e65c2f4df50f6aec40e5546b08721",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "6 ratings",
          ratingCountV2: "6",
        },
      },
    },
    {
      id: "105475617",
      name: "Paneer Chilly Steam (6 Pcs)",
      category: "Veg Momos",
      description:
        " momos filled with panner chilly capsicum  and mixed with the flavours herbs. Served with home-made spicy red sauce\n",
      imageId: "56cd6721941a06cca2e755219cf4647c",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475618",
      name: "Paneer Chilly Fried (6 Pcs)",
      category: "Veg Momos",
      description:
        " momos filled with panner chilly capsicum  and mixed with the flavours herbs. Served with home-made spicy red sauce\n",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475619",
      name: "Achari Paneer Steam (6 Pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with freshly chopped veggies tangy paneer, tinch of spices and mixed with indian achari masala. Served with spicy red sauce\n",
      inStock: 1,
      isVeg: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475620",
      name: "Achari Paneer Fried (6pcs)",
      category: "Veg Momos",
      description:
        "Delicious momos stuffed with freshly chopped veggies tangy paneer, tinch of spices and mixed with indian achari masala. Served with spicy red sauce\n",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475621",
      name: "C3 Steam Corn Cheese And Capsicum Momos (6 Pcs) ",
      category: "Veg Momos",
      description:
        "Momos filled with shredded cheese  sweet corn and capsicum  and mixed with the flavours herbs. Served with home-made spicy red sauce\n",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475622",
      name: "C3 Veg Fried Corn Cheese And Capsicum Momos (6 Pcs) ",
      category: "Veg Momos",
      description:
        "Momos filled with shredded cheese  sweet corn and capsicum  and mixed with the flavours herbs. Served with home-made spicy red sauce\n",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475623",
      name: "Steam Veg Platter Momos (6 Pcs) ",
      category: "Veg Momos",
      description:
        "All type of favourite, mouth-watering momos stuffed with fresh veggies and indian spices. Served with spicy red sauce \n",
      imageId: "38eb76f005a8e3cee692ea41cd1de58a",
      inStock: 1,
      isVeg: 1,
      price: 11500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475624",
      name: "Fried Veg Platter Momos (6 Pcs)",
      category: "Veg Momos",
      description:
        "All type of favourite, mouth-watering momos stuffed with fresh veggies and indian spices. Served with spicy red sauce \n",
      inStock: 1,
      isVeg: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475625",
      name: "Pizza Momos (6 Pcs) ",
      category: "Veg Momos",
      description:
        "An all-time favourite, mouth-watering momos stuffed with mix of cheese, onion,veggies, herbs and indian spices. Served with spicy red sauce\n",
      imageId: "eec68a5bb98a7489611a4ea3fadefdd4",
      inStock: 1,
      isVeg: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "105475626",
      name: "Veg Kurkure Momos (6 Pcs)",
      category: "Veg Momos",
      description:
        "Crispy fired delicious momos stuffed with freshly chopped veggies tangy paneer, tinch of spices served with spicy red sauce\n",
      imageId: "6d0f9e0ff3f52d1bc2bc0c0e64a399d1",
      inStock: 1,
      isVeg: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "14 ratings",
          ratingCountV2: "14",
        },
      },
    },
  ],
  "Chicken Momos": [
    {
      id: "105475627",
      name: "Simply Chicken Steam (6pcs)",
      category: "Chicken Momos",
      description:
        "Filled with soft juicy bonless chicken, onion, coriander and mixed with the flavour of indian spices. Served with home-made spicy red sauce\n",
      imageId: "19ab31f78902cc522f375ffe8d04e07f",
      inStock: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "22 ratings",
          ratingCountV2: "22",
        },
      },
    },
    {
      id: "105475628",
      name: "Simply Chicken Fried (6 Pcs)",
      category: "Chicken Momos",
      description:
        "Filled with soft juicy bonless chicken, onion, coriander and mixed with the flavour of indian spices. Served with home-made spicy red sauce\n",
      inStock: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "105475629",
      name: "Schezwan Chicken Steam (6pcs)",
      category: "Chicken Momos",
      description:
        "Filled with soft juicy bonless chicken, onion, coriander and mixed with the flavour of schezwan served with home-made spicy red sauce\n",
      imageId: "2cd562ba1d5517707243a0d5649597cb",
      inStock: 1,
      price: 10900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.2",
          ratingCount: "12 ratings",
          ratingCountV2: "12",
        },
      },
    },
    {
      id: "105475630",
      name: "Schezwan Chicken Fried (6 Pcs)",
      category: "Chicken Momos",
      description:
        "Filled with soft juicy bonless chicken, onion, coriander and mixed with the flavour of schezwan served with home-made spicy red sauce\n",
      imageId: "258ec637a1982725487f99fff079bca9",
      inStock: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "105475631",
      name: "Achari Chicken Steam (6pcs)",
      category: "Chicken Momos",
      description:
        "Delicious momos stuffed with fresh chicken , tinch of spices and mixed with indian achari masala. Served with spicy red sauce\n",
      imageId: "574dfd052220d61127d92e809ad334c2",
      inStock: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475632",
      name: "Achari Chicken Fried (6 Pcs)",
      category: "Chicken Momos",
      description:
        "Delicious momos stuffed with fresh chicken , tinch of spices and mixed with indian achari masala. Served with spicy red sauce\n",
      imageId: "c924a6fe7a49a8db43574baa8d4996cf",
      inStock: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475633",
      name: "Chillie Chicken Steam (6 Pcs)",
      category: "Chicken Momos",
      description:
        "Soft juicy boneless chicken, with the flavour of in house spices. Served with schezwan spicy red sauce\n",
      imageId: "2d9a390f06471d24b244ee97d25c5a0c",
      inStock: 1,
      price: 11900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475634",
      name: "Chillie Chicken Fried (6pcs)",
      category: "Chicken Momos",
      description:
        "Soft juicy boneless chicken, with the flavour of in house spices. Served with schezwan spicy red sauce\n",
      inStock: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475635",
      name: "Spicy Tandoori Chicken Momos (6 Pcs)",
      category: "Chicken Momos",
      description:
        "An all-time favourite, mouth-watering momos stuffed with mix of smoky boneless chicken and indian spices. Served with spicy red sauce \n",
      imageId: "4f6ac9cecd004319a6003114f58b7f16",
      inStock: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.6",
          ratingCount: "13 ratings",
          ratingCountV2: "13",
        },
      },
    },
    {
      id: "105475637",
      name: "Steam Chilli cheese Chicken Momos (6 Pcs) ",
      category: "Chicken Momos",
      description:
        "Mouth-watering momos stuffed with mix of juicy boneless chicken, cheese, coriander,  and indian spices. Served with spicy red sauce ",
      inStock: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475638",
      name: "Freied Chilli cheese Chicken Momos (6 Pcs)",
      category: "Chicken Momos",
      description:
        "Mouth-watering momos stuffed with mix of juicy boneless chicken, chilly ,cheese along with indian spices. Served with spicy red sauce",
      inStock: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475639",
      name: "Steam Chicken Platter Momos (6 Pcs)",
      category: "Chicken Momos",
      description:
        "All type of favourite, mouth-watering momos stuffed with mix of  boneless chicken and indian spices. Served with spicy red sauce \n",
      inStock: 1,
      price: 12500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475640",
      name: "Fried Chicken Platter Momos (6 Pcs)",
      category: "Chicken Momos",
      description:
        "All type of favourite, mouth-watering momos stuffed with mix of  boneless chicken and indian spices. Served with spicy red sauce \n",
      inStock: 1,
      price: 13500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475641",
      name: "Steam Momos (6 Pcs) with Stuff Chilli chicken with momo chutney",
      category: "Chicken Momos",
      inStock: 1,
      price: 13900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "105475643",
      name: "Fried Momos (6 Pcs) with Stuff Chilli chicken with momo chutney",
      category: "Chicken Momos",
      inStock: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "5.0",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475644",
      name: "Chicken Kurkure Momos (6 Pcs)",
      category: "Chicken Momos",
      description:
        "Crispy fried momos stuff with juicy bonless chicken, onion, coriander and mixed with the flavour of indian spices. Served with home-made spicy red sauce\n",
      imageId: "790752094f7d7afc004bd7d9f17b2138",
      inStock: 1,
      price: 14900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "37 ratings",
          ratingCountV2: "37",
        },
      },
    },
  ],
  Fries: [
    {
      id: "105475645",
      name: "Regular French Fries",
      category: "Fries",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.8",
          ratingCount: "4 ratings",
          ratingCountV2: "4",
        },
      },
    },
    {
      id: "105475646",
      name: "Peri Peri Fries",
      category: "Fries",
      imageId: "1b3fd19617d503f2acb19d1783daa902",
      inStock: 1,
      isVeg: 1,
      price: 10500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      showImage: true,
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "3 ratings",
          ratingCountV2: "3",
        },
      },
    },
    {
      id: "105475648",
      name: "Maxican Fries",
      category: "Fries",
      inStock: 1,
      isVeg: 1,
      price: 12900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "111061273",
      name: "Chicken Fries",
      category: "Fries",
      inStock: 1,
      price: 16900,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[thakurVp] = {
  Pav: [
    {
      id: "57124826",
      name: "Vada Pav",
      category: "Pav",
      inStock: 1,
      isVeg: 1,
      price: 2600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "494 ratings",
          ratingCountV2: "494",
        },
      },
    },
    {
      id: "57124827",
      name: "Samosa Pav",
      category: "Pav",
      inStock: 1,
      isVeg: 1,
      price: 2600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "153 ratings",
          ratingCountV2: "153",
        },
      },
    },
    {
      id: "57124828",
      name: "Bhajiya Pav",
      category: "Pav",
      inStock: 1,
      isVeg: 1,
      price: 2600,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.0",
          ratingCount: "53 ratings",
          ratingCountV2: "53",
        },
      },
    },
  ],
  Snacks: [
    {
      id: "57124829",
      name: "Bhajiya Plate",
      category: "Snacks",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.3",
          ratingCount: "99 ratings",
          ratingCountV2: "99",
        },
      },
    },
    {
      id: "57124830",
      name: "Samosa Plate",
      category: "Snacks",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.4",
          ratingCount: "145 ratings",
          ratingCountV2: "145",
        },
      },
    },
    {
      id: "57124831",
      name: "Vada Plate",
      category: "Snacks",
      inStock: 1,
      isVeg: 1,
      price: 4000,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "4.5",
          ratingCount: "74 ratings",
          ratingCountV2: "74",
        },
      },
    },
  ],
};
allMenu[appetiteMomo] = {
  "Veg Steamed Momos": [
    {
      id: "70613938",
      name: "Steamed Paneer Achari",
      category: "Veg Steamed Momos",
      description:
        "PANEER STUFFING MARINATED IN  SLIGHTLY TANGY & SPICY INDIAN STYLE",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170544",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 96,
                default: 1,
                id: "67107673",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 180,
                id: "67107675",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170544",
                variationId: "67107673",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "20170544",
                variationId: "67107675",
              },
            ],
            price: 18000,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.7",
          ratingCount: "11 ratings",
          ratingCountV2: "11",
        },
      },
    },
    {
      id: "70613940",
      name: "Steamed Simply Paneer",
      category: "Veg Steamed Momos",
      description: "MOMOS STUFFED WITH COTTAGE CHEESE AND STEAMED",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170547",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 84,
                default: 1,
                id: "67107679",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 144,
                id: "67107682",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170547",
                variationId: "67107679",
              },
            ],
            price: 8400,
          },
          {
            variations: [
              {
                groupId: "20170547",
                variationId: "67107682",
              },
            ],
            price: 14400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 8400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "32 ratings",
          ratingCountV2: "32",
        },
      },
    },
    {
      id: "70613941",
      name: "Steamed Simply Veg",
      category: "Veg Steamed Momos",
      description: "MOMOS DELIGHTFULLY STEAMED WITH MIX VEGGIES",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170549",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 78,
                default: 1,
                id: "67107683",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 126,
                id: "67107684",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170549",
                variationId: "67107683",
              },
            ],
            price: 7800,
          },
          {
            variations: [
              {
                groupId: "20170549",
                variationId: "67107684",
              },
            ],
            price: 12600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 7800,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "42 ratings",
          ratingCountV2: "42",
        },
      },
    },
  ],
  "Non-veg Steamed Momos": [
    {
      id: "70613947",
      name: "Steamed Chilly Cheese Chicken",
      category: "Non-veg Steamed Momos",
      description:
        "AS THE NAME DESCRIBE CHICKEN MARINATED IN FULLY LOADED CHEESE",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170551",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 108,
                default: 1,
                id: "67107687",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 186,
                id: "67107688",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170551",
                variationId: "67107687",
              },
            ],
            price: 10800,
          },
          {
            variations: [
              {
                groupId: "20170551",
                variationId: "67107688",
              },
            ],
            price: 18600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 10800,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.1",
          ratingCount: "22 ratings",
          ratingCountV2: "22",
        },
      },
    },
    {
      id: "70613950",
      name: "Steamed Simply Chicken",
      category: "Non-veg Steamed Momos",
      description: "Chicken stuffed in simply marination and steamed",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170552",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 96,
                default: 1,
                id: "67107689",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 162,
                id: "67107690",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170552",
                variationId: "67107689",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "20170552",
                variationId: "67107690",
              },
            ],
            price: 16200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 9600,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "34 ratings",
          ratingCountV2: "34",
        },
      },
    },
    {
      id: "100799058",
      name: "Chicken Achari Steamed Momos",
      category: "Non-veg Steamed Momos",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170550",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 108,
                default: 1,
                id: "67107685",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 186,
                id: "67107686",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170550",
                variationId: "67107685",
              },
            ],
            price: 10800,
          },
          {
            variations: [
              {
                groupId: "20170550",
                variationId: "67107686",
              },
            ],
            price: 18600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 10800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.3",
          ratingCount: "8 ratings",
          ratingCountV2: "8",
        },
      },
    },
  ],
  "Veg Fried Momos": [
    {
      id: "70613951",
      name: "Crispy Fried Peri Peri Veg Cheese",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170557",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 126,
                default: 1,
                id: "67107699",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 204,
                id: "67107700",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170557",
                variationId: "67107699",
              },
            ],
            price: 12600,
          },
          {
            variations: [
              {
                groupId: "20170557",
                variationId: "67107700",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 12600,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "49 ratings",
          ratingCountV2: "49",
        },
      },
    },
    {
      id: "70613953",
      name: "Crispy Fried Paneer Achari",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170556",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 108,
                default: 1,
                id: "67107697",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 192,
                id: "67107698",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170556",
                variationId: "67107697",
              },
            ],
            price: 10800,
          },
          {
            variations: [
              {
                groupId: "20170556",
                variationId: "67107698",
              },
            ],
            price: 19200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 10800,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "24 ratings",
          ratingCountV2: "24",
        },
      },
    },
    {
      id: "70613955",
      name: "Crispy Fried Tandoori Paneer",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170560",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 114,
                default: 1,
                id: "67107705",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 192,
                id: "67107706",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170560",
                variationId: "67107705",
              },
            ],
            price: 11400,
          },
          {
            variations: [
              {
                groupId: "20170560",
                variationId: "67107706",
              },
            ],
            price: 19200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11400,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "34 ratings",
          ratingCountV2: "34",
        },
      },
    },
    {
      id: "70613957",
      name: "Crispy Fried Simply Veg",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170559",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 90,
                default: 1,
                id: "67107703",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 138,
                id: "67107704",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170559",
                variationId: "67107703",
              },
            ],
            price: 9000,
          },
          {
            variations: [
              {
                groupId: "20170559",
                variationId: "67107704",
              },
            ],
            price: 13800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9000,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "16 ratings",
          ratingCountV2: "16",
        },
      },
    },
    {
      id: "70613958",
      name: "Crispy Fried Chilly Cheese Veg",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170554",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 108,
                default: 1,
                id: "67107693",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 192,
                id: "67107694",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170554",
                variationId: "67107693",
              },
            ],
            price: 10800,
          },
          {
            variations: [
              {
                groupId: "20170554",
                variationId: "67107694",
              },
            ],
            price: 19200,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 10800,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "105 ratings",
          ratingCountV2: "105",
        },
      },
    },
    {
      id: "75980651",
      name: "Cripsy Fried Simply Paneer",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170558",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 96,
                default: 1,
                id: "67107701",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 156,
                id: "67107702",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170558",
                variationId: "67107701",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "20170558",
                variationId: "67107702",
              },
            ],
            price: 15600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 9600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "2.6",
          ratingCount: "5 ratings",
          ratingCountV2: "5",
        },
      },
    },
    {
      id: "100799063",
      name: "Chocolate Momos (6 Pcs)",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      price: 11400,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
    {
      id: "100799064",
      name: "Corn Cheese Fried Momos",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170555",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 114,
                default: 1,
                id: "67107695",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 198,
                id: "67107696",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170555",
                variationId: "67107695",
              },
            ],
            price: 11400,
          },
          {
            variations: [
              {
                groupId: "20170555",
                variationId: "67107696",
              },
            ],
            price: 19800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.1",
          ratingCount: "7 ratings",
          ratingCountV2: "7",
        },
      },
    },
    {
      id: "112135479",
      name: "Crispy Fried Schezwan Veg Momos",
      category: "Veg Fried Momos",
      inStock: 1,
      isVeg: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "25303516",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 114,
                default: 1,
                id: "80554775",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 198,
                id: "80554776",
                inStock: 1,
                isVeg: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "25303516",
                variationId: "80554775",
              },
            ],
            price: 11400,
          },
          {
            variations: [
              {
                groupId: "25303516",
                variationId: "80554776",
              },
            ],
            price: 19800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "VEG",
      },
      defaultPrice: 11400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Non-veg Fried Momos": [
    {
      id: "70613960",
      name: "Crispy Fried Chicken Achari",
      category: "Non-veg Fried Momos",
      description:
        "CHICKEN MARINATE IN TANGY & SPICY INDIAN FLAVORS AND DEEP FRIED",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170561",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 114,
                default: 1,
                id: "67107707",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 198,
                id: "67107708",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170561",
                variationId: "67107707",
              },
            ],
            price: 11400,
          },
          {
            variations: [
              {
                groupId: "20170561",
                variationId: "67107708",
              },
            ],
            price: 19800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 11400,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.9",
          ratingCount: "34 ratings",
          ratingCountV2: "34",
        },
      },
    },
    {
      id: "70613961",
      name: "Crispy Fried Tandoori Chicken",
      category: "Non-veg Fried Momos",
      description:
        "FLAVORS OF INDIAN TANDOORI SPICES MARINATED CHICKEN DEEP FRIED",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170566",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 114,
                default: 1,
                id: "67107717",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 198,
                id: "67107718",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170566",
                variationId: "67107717",
              },
            ],
            price: 11400,
          },
          {
            variations: [
              {
                groupId: "20170566",
                variationId: "67107718",
              },
            ],
            price: 19800,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 11400,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.5",
          ratingCount: "25 ratings",
          ratingCountV2: "25",
        },
      },
    },
    {
      id: "70613962",
      name: "Crispy Fried Chilly Cheese Chicken",
      category: "Non-veg Fried Momos",
      description:
        "MARINATED CHICKEN WITH FULLY LOADED CHEESE AND CHILLY FLAKES TO ADD SOME SPICY FLAVORS & DEEP FRIED",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170562",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 120,
                default: 1,
                id: "67107709",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 204,
                id: "67107710",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170562",
                variationId: "67107709",
              },
            ],
            price: 12000,
          },
          {
            variations: [
              {
                groupId: "20170562",
                variationId: "67107710",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 12000,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "64 ratings",
          ratingCountV2: "64",
        },
      },
    },
    {
      id: "70613965",
      name: "Crispy Fried Simply Chicken",
      category: "Non-veg Fried Momos",
      description: "CHICKEN MARINATE IN SIMPLY WAY & DEEP FRIED.",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170565",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 96,
                default: 1,
                id: "67107715",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 174,
                id: "67107716",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170565",
                variationId: "67107715",
              },
            ],
            price: 9600,
          },
          {
            variations: [
              {
                groupId: "20170565",
                variationId: "67107716",
              },
            ],
            price: 17400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 9600,
      ribbon: {
        text: "Bestseller",
        textColor: "#ffffff",
        topBackgroundColor: "#d53d4c",
        bottomBackgroundColor: "#b02331",
      },
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      isBestseller: true,
      ratings: {
        aggregatedRating: {
          rating: "3.6",
          ratingCount: "19 ratings",
          ratingCountV2: "19",
        },
      },
    },
    {
      id: "75980661",
      name: "Crispy Fried Peri Peri Chicken",
      category: "Non-veg Fried Momos",
      description: "CHICKEN MARINATED WITH PERI PERI SPICE AND DEEP FRIED",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "20170564",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 126,
                default: 1,
                id: "67107713",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 216,
                id: "67107714",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "20170564",
                variationId: "67107713",
              },
            ],
            price: 12600,
          },
          {
            variations: [
              {
                groupId: "20170564",
                variationId: "67107714",
              },
            ],
            price: 21600,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 12600,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {
          rating: "3.7",
          ratingCount: "28 ratings",
          ratingCountV2: "28",
        },
      },
    },
    {
      id: "109976557",
      name: "Crispy Fried Schezwan Chicken Momos",
      category: "Non-veg Fried Momos",
      inStock: 1,
      variants: {},
      variantsV2: {
        variantGroups: [
          {
            groupId: "24340056",
            name: "Quantity",
            variations: [
              {
                name: "Half (4 Pcs)",
                price: 132,
                default: 1,
                id: "78369273",
                inStock: 1,
                isEnabled: 1,
              },
              {
                name: "Full (8 Pcs)",
                price: 204,
                id: "78369274",
                inStock: 1,
                isEnabled: 1,
              },
            ],
          },
        ],
        pricingModels: [
          {
            variations: [
              {
                groupId: "24340056",
                variationId: "78369273",
              },
            ],
            price: 13200,
          },
          {
            variations: [
              {
                groupId: "24340056",
                variationId: "78369274",
              },
            ],
            price: 20400,
          },
        ],
      },
      itemAttribute: {
        vegClassifier: "NONVEG",
      },
      defaultPrice: 13200,
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  "Dessert & Shake": [
    {
      id: "100799077",
      name: "Choclolate Momos (6 Pcs)",
      category: "Dessert & Shake",
      inStock: 1,
      isVeg: 1,
      price: 9500,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
  Beverages: [
    {
      id: "109976553",
      name: "Coolberg",
      category: "Beverages",
      inStock: 1,
      isVeg: 1,
      price: 10680,
      variants: {},
      variantsV2: {},
      itemAttribute: {
        vegClassifier: "VEG",
      },
      ribbon: {},
      type: "ITEM",
      itemBadge: {},
      badgesV2: {},
      ratings: {
        aggregatedRating: {},
      },
    },
  ],
};
allMenu[behrouzBiryani] = {
  
    "Ramadan Iftar Special": [
        {
            "id": "113013154",
            "name": "Gosht-e-Haleem (Mutton Haleem- Serves 2)",
            "category": "Ramadan Iftar Special",
            "description": "A thick, creamy, porridge textured dish of slow-cooked tender mutton, prepared with a blend of lentils, barley and aromatic masalas. Relish this Ramzan classic as a main course or an accompaniment with your favourite biryani.",
            "imageId": "433f058364653f9323670ae157547031",
            "inStock": 1,
            "price": 54900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84962917",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84962919",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113013162",
            "name": "Gosht-e-Haleem with Ayran",
            "category": "Ramadan Iftar Special",
            "description": "(Mutton Haleem-Serves 1 with Buttermilk-1) Savour the goodness of slow-cooked tender mutton and lentils with the authentic Gosht-e-Haleem along with a refreshing glass of buttermilk during Ramzan.",
            "imageId": "9d9d9882b32bed1e9c035cf674c80c51",
            "inStock": 1,
            "price": 37900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84963150",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84963153",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113013163",
            "name": "Gosht-e-Haleem (Mutton Haleem- Serves 1)",
            "category": "Ramadan Iftar Special",
            "description": "A thick, creamy, porridge textured dish of slow-cooked tender mutton, prepared with a blend of lentils, barley and aromatic masalas. Relish this Ramzan classic as a main course or an accompaniment with your favourite biryani.",
            "imageId": "d905f4cd2ce038344509f604a06d1474",
            "inStock": 1,
            "price": 32900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84963127",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84963130",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.3",
                    "ratingCount": "6 ratings",
                    "ratingCountV2": "6"
                }
            }
        },
        {
            "id": "113013164",
            "name": "Shahi Mutton Biryani with Gosht e Haleem Feast",
            "category": "Ramadan Iftar Special",
            "description": "(Dum Gosht Biryani -Serves 1 with Gulab Jamun & Raita + Mutton Haleem-Serves 1) Begin your festive jashn with a generous daawat of creamy, porridge-textured flavours of Gosht-e-Haleem along with one of our shaandaar classics and most loved, Dum Gosht Biryani.",
            "imageId": "b279a8fa217cb71e9649f5f9734bf3fe",
            "inStock": 1,
            "price": 84900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84963135",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84963137",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113013165",
            "name": "Shahi Chicken Biryani with Gosht e Haleem Feast",
            "category": "Ramadan Iftar Special",
            "description": "(Lazeez Bhuna Biryani -Serves 1 with Gulab Jamun & Raita + Mutton Haleem-Serves 1) Relish the rich, authentic flavours of tender mutton and lentils with Gosht-e-Haleem and the goodness of tender chicken marinated in exhuberant bhuna spices with our Lazeez Bhuna Murgh Biryani. Make Ramzan khaas with two of our most magnificent dishes.",
            "imageId": "5d2f8de10eefce78dd3a53d8e7ed9d68",
            "inStock": 1,
            "price": 69900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84962909",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84962911",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113206170",
            "name": "Gosht e Haleem with Kulcha",
            "category": "Ramadan Iftar Special",
            "description": "(Mutton Haleem-Serves 1 with 1 Kulcha) Pair our classic Ramzan special Gosht-e-Haleem, along with soft bread Kulcha! Our gosht haleem is a thick, creamy, porridge textured dish of slow-cooked tender mutton, prepared with a blend of lentils, barley and aromatic masalas.",
            "imageId": "c1f9b03a06f6bb76d700375a520bf8db",
            "inStock": 1,
            "price": 37900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84963030",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84963033",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113206171",
            "name": "Gosht-e-Haleem with Kulcha & Falafel",
            "category": "Ramadan Iftar Special",
            "description": "(Mutton Haleem-Serves 1 with 1 Kulcha & Falafel-12Pcs) Enjoy creamy Gosht-e-Haleem, made of tender mutton and a lajawab blend of lentils, barley, aromatic masalas along with soft-leavened Kulcha and a plateful of nugget-sized Falafel-e-Khaas. A Ramzan special daawat you simply cannot miss.",
            "imageId": "7bc061776d7eb41ada748871d2b99c8f",
            "inStock": 1,
            "price": 44900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84963013",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84963016",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113514475",
            "name": "Shahi Raan-e-Murgh Biryani with Gosht-e-Haleem & Royal Dates",
            "category": "Ramadan Iftar Special",
            "description": "(Chicken Whole Leg Biryani -Serves 1 with Gulab Jamun & Raita, Mutton Haleem-Serves 1, Royal Dates 3pcs) Set up your Iftar feast with the unique Raan-e-Murgh Biryani, made with premium chicken whole leg, marinated with royal spices, along with the Ramzan special porridge-textured Gosht-e-Haleem, and 100% natural, high quality Royal Dates.",
            "imageId": "1b7514f5bcf845e7833a00aa035d1021",
            "inStock": 1,
            "price": 72900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84962903",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84962906",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113514486",
            "name": "Gosht-e-Haleem Feast with Kulcha, Royal Dates & Ayran",
            "category": "Ramadan Iftar Special",
            "description": "(Mutton Haleem-Serves 1, Kulcha-1, Royal Dates-3pcs, Buttermilk-1) Pair our classic Ramzan porridge-textured Gosht-e-Haleem, along with soft bread Kulcha, 100% natural, high quality Royal Dates and refreshing buttermilk.",
            "imageId": "aecbd58e63e3f0c5635ee8008c2ced4b",
            "inStock": 1,
            "price": 45900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84962921",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84962923",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113514487",
            "name": "Shahi Chicken Biryani with Gosht-e-Haleem & Royal Dates",
            "category": "Ramadan Iftar Special",
            "description": "(Lazeez Bhuna Murgh Biryani -Serves 1 with Gulab Jamun & Raita, Mutton Haleem-Serves 1, Royal Dates-3pcs)  Set up your Iftar feast with an all-time favourite biryani made with tender chicken pieces, marinated with exuberant bhuna spices and dum pukht with aromatic rice, along with Gosht-e-Haleem, and 100% natural, high quality Royal Dates.",
            "imageId": "d494d2397dae8bd81209df6ae9865ddd",
            "inStock": 1,
            "price": 74900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84962984",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84962986",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113514488",
            "name": "Shahi Mutton Biryani with Gosht-e-Haleem & Royal Dates",
            "category": "Ramadan Iftar Special",
            "description": "(Dum Gosht Biryani -Serves 1 with Gulab Jamun & Raita, Mutton Haleem-Serves 1, Royal Dates-3pcs) Set up your Iftar feast with an immaculately spiced biryani of succulent mutton pieces layered on long-grain basmati and dumpukht to perfection, along with the Ramzan special porridge-textured Gosht-e-Haleem, and 100% natural, high quality Royal Dates.",
            "imageId": "9428bd55d603c0554970311d918e96dd",
            "inStock": 1,
            "price": 89900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84962899",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84962900",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113514489",
            "name": "Gosht-e-Haleem with Royal Dates",
            "category": "Ramadan Iftar Special",
            "description": "(Mutton Haleem-Serves 1 & Royal Dates-3pcs) Relish our Gosht-e-Haleem, a special porridge-textured dish of slow-cooked tender mutton, prepared with a blend of lentils, barley and aromatic masalas along with 100% natural, high quality Royal Dates.",
            "imageId": "606cec636871b77b7c718ac2b53d8907",
            "inStock": 1,
            "price": 35900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84962995",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84962998",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113514499",
            "name": "Gosht-e-Haleem Feast with Kebabs, Royal Dates & Ayran",
            "category": "Ramadan Iftar Special",
            "description": "(Mutton Haleem-Serves 1, Murgh Kefta-9pcs, Royal Dates-3pcs, Buttermilk-1) Relish our Gosht-e-Haleem, a special porridge-textured dish of slow-cooked tender mutton with the lajawab combination of 100% natural, high quality Royal Dates, delectable Murgh Kefta and refreshing buttermilk.",
            "imageId": "4535bf3c02b7985055d0e39f1ccf8921",
            "inStock": 1,
            "price": 49900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84963143",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84963145",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Shahi Biryani (serves 1)": [
        {
            "id": "98639730",
            "name": "Lajawab Kathal Biryani (Serves-1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Served with 1 Gulab Jamun & Mint Raita) A flavoursome biryani crafted with juicy, raw jackfruit, married with a range of exotic spices and aromatic basmati rice thats sure to sweep you off your feet.",
            "imageId": "upt41llny6ejst0mvmuc",
            "isVeg": 1,
            "price": 36500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882237",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882832",
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 15,
                                "id": "81882833",
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882237",
                                "variationId": "81882832"
                            }
                        ],
                        "price": 36500,
                        "addonCombinations": [
                            {
                                "groupId": "84288945",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288945",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288945",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882237",
                                "variationId": "81882833"
                            }
                        ],
                        "price": 38000,
                        "addonCombinations": [
                            {
                                "groupId": "84288945",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288945",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288945",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288948",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288945",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288948",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 36500,
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110854999",
            "name": "Lazeez Bhuna Murgh (Chicken Dum Biryani Boneless - Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Boneless, Served with 1 Gulab Jamun & Mint Raita) In this culinary jewel from Behrouz, Tender chicken pieces are marinated with exuberant bhuna spices that are freshly ground and dum pukht with aromatic rice.",
            "imageId": "htra1ceo32gospqkqalp",
            "inStock": 1,
            "price": 38500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882332",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883074",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81883075",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882332",
                                "variationId": "81883074"
                            }
                        ],
                        "price": 38500,
                        "addonCombinations": [
                            {
                                "groupId": "84289455",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882332",
                                "variationId": "81883075"
                            }
                        ],
                        "price": 39900,
                        "addonCombinations": [
                            {
                                "groupId": "84289455",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289455",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289460",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289455",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289460",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 38500,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.4",
                    "ratingCount": "31 ratings",
                    "ratingCountV2": "31"
                }
            }
        },
        {
            "id": "110855000",
            "name": "Dum Gosht (Mutton Dum Biryani - Boneless - Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Boneless, Served with 1 Gulab Jamun & Mint Raita) In this most enigmatic & treasured recipe of Behrouz, immaculately spiced fresh, succulent mutton pieces are layered with basmati & then slow-cooked on a charcoal fire.",
            "imageId": "s3cootrdhb93xht1oadq",
            "inStock": 1,
            "price": 53500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882456",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883418",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81883419",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882456",
                                "variationId": "81883418"
                            }
                        ],
                        "price": 53500,
                        "addonCombinations": [
                            {
                                "groupId": "84290032",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882456",
                                "variationId": "81883419"
                            }
                        ],
                        "price": 54900,
                        "addonCombinations": [
                            {
                                "groupId": "84290032",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84290032",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290036",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84290032",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84290036",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 53500,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "68 ratings",
                    "ratingCountV2": "68"
                }
            }
        },
        {
            "id": "110855002",
            "name": "Raan-E-Murgh Biryani (Chicken Whole Leg Biryani) (Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(With Bone, Served with 1 Gulab Jamun & Raita) A classic redefined with a touch of royalty! Entice your taste buds with the indulgent chicken whole leg, marinated in exquisite royal spices, laid atop a bed of fragrant, long-grain basmati rice.",
            "imageId": "caeef7009cc017a14a4ab2f6083af7d8",
            "inStock": 1,
            "price": 45900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882339",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883092",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 16,
                                "id": "81883093",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882339",
                                "variationId": "81883092"
                            }
                        ],
                        "price": 45900,
                        "addonCombinations": [
                            {
                                "groupId": "84289480",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882339",
                                "variationId": "81883093"
                            }
                        ],
                        "price": 47500,
                        "addonCombinations": [
                            {
                                "groupId": "84289480",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289480",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289483",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289480",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289483",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 45900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.3",
                    "ratingCount": "10 ratings",
                    "ratingCountV2": "10"
                }
            }
        },
        {
            "id": "110855004",
            "name": "Subz-E-Biryani (Veg Dum Biryani - Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Served with 1 Gulab Jamun & Mint Raita) Adorned with fresh vegetables, golden-hued long-grain basmati, & the coveted Behrouz spice mix, this dish will lend you an experience unlike any other.",
            "imageId": "tej2ho3s9mbti5akvkcd",
            "inStock": 1,
            "isVeg": 1,
            "price": 31500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882116",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882518",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81882519",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882116",
                                "variationId": "81882518"
                            }
                        ],
                        "price": 31500,
                        "addonCombinations": [
                            {
                                "groupId": "84288312",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288312",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288312",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882116",
                                "variationId": "81882519"
                            }
                        ],
                        "price": 32900,
                        "addonCombinations": [
                            {
                                "groupId": "84288312",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288312",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288312",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288315",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288312",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288315",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 31500,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.6",
                    "ratingCount": "14 ratings",
                    "ratingCountV2": "14"
                }
            }
        },
        {
            "id": "110855007",
            "name": "Murgh Makhani (Butter Chicken Biryani, Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Boneless, Served with 1 Gulab Jamun & Mint Raita) Tender chicken pieces cooked in creamy butter chicken gravy, layered with aromatic basmati rice and dum pukht in its full glory. A royal fusion between two of Indias most beloved dishes.",
            "imageId": "bdblbav2iadstbti1ku6",
            "inStock": 1,
            "price": 43900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882351",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883127",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 16,
                                "id": "81883128",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882351",
                                "variationId": "81883127"
                            }
                        ],
                        "price": 43900,
                        "addonCombinations": [
                            {
                                "groupId": "84289513",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882351",
                                "variationId": "81883128"
                            }
                        ],
                        "price": 45500,
                        "addonCombinations": [
                            {
                                "groupId": "84289513",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289513",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289515",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289513",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289515",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 43900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110855009",
            "name": "Murgh Afghani Tikka (Creamy Chicken Tikka Dum Biryani - Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Boneless, Served with 1 Gulab Jamun & Mint Raita) Legendary for its rich taste & creamy texture, tender chicken marinated in fresh creamy yoghurt & spices is layered with aromatic basmati. Let your tastebuds feel enchanted!",
            "imageId": "n7khabrtrcenjnkbhmfe",
            "inStock": 1,
            "price": 43500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882204",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882748",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81882749",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882204",
                                "variationId": "81882748"
                            }
                        ],
                        "price": 43500,
                        "addonCombinations": [
                            {
                                "groupId": "84288806",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882204",
                                "variationId": "81882749"
                            }
                        ],
                        "price": 44900,
                        "addonCombinations": [
                            {
                                "groupId": "84288806",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288806",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288808",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288806",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288808",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 43500,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.3",
                    "ratingCount": "56 ratings",
                    "ratingCountV2": "56"
                }
            }
        },
        {
            "id": "110855010",
            "name": "Murgh Tikka (Chicken Tikka Dum Biryani - Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Boneless, Served with 1 Gulab Jamun & Mint Raita) A potpourri of extravagant flavours, tender chicken spiced with freshly ground Behrouz masala is charcoal-grilled then layered with fragrant basmati & dum-pukht in its full glory.",
            "imageId": "xpqih4lpjnrdae8fu7lg",
            "inStock": 1,
            "price": 43500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882267",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882909",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81882910",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882267",
                                "variationId": "81882909"
                            }
                        ],
                        "price": 43500,
                        "addonCombinations": [
                            {
                                "groupId": "84289103",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882267",
                                "variationId": "81882910"
                            }
                        ],
                        "price": 44900,
                        "addonCombinations": [
                            {
                                "groupId": "84289103",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289103",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289104",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289103",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289104",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 43500,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.4",
                    "ratingCount": "101 ratings",
                    "ratingCountV2": "101"
                }
            }
        },
        {
            "id": "110855011",
            "name": "Do Gosht ki Dum Biryani (Mutton & Chicken Dum Biryani, Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Boneless, Served with 1 Gulab Jamun & Mint Raita) Tantalise your tastebuds with this epicurean delight of succulent chicken & mutton pieces marinated in aromatic spices and dum-pukht with long-grain basmati.",
            "imageId": "k1h5fhoymftcs6zdm2kz",
            "inStock": 1,
            "price": 47900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882231",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882815",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 16,
                                "id": "81882817",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882231",
                                "variationId": "81882815"
                            }
                        ],
                        "price": 47900,
                        "addonCombinations": [
                            {
                                "groupId": "84288925",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882231",
                                "variationId": "81882817"
                            }
                        ],
                        "price": 49500,
                        "addonCombinations": [
                            {
                                "groupId": "84288925",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288925",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288930",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288925",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288930",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 47900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.4",
                    "ratingCount": "8 ratings",
                    "ratingCountV2": "8"
                }
            }
        },
        {
            "id": "110855013",
            "name": "Paneer Subz (Classic Paneer and Veg Dum Biryani - Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Served with 1 Gulab Jamun & Mint Raita) In this immaculately balanced culinary masterpiece, diced fresh vegetables infused with succulent pieces of spiced paneer are layered on a bed of aromatic rice.",
            "imageId": "xxwcydkccq651lzvrtkd",
            "inStock": 1,
            "isVeg": 1,
            "price": 34500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882131",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882558",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81882559",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882131",
                                "variationId": "81882558"
                            }
                        ],
                        "price": 34500,
                        "addonCombinations": [
                            {
                                "groupId": "84288405",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288405",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288405",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882131",
                                "variationId": "81882559"
                            }
                        ],
                        "price": 35900,
                        "addonCombinations": [
                            {
                                "groupId": "84288405",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288405",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288405",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288408",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288405",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288408",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 34500,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.8",
                    "ratingCount": "12 ratings",
                    "ratingCountV2": "12"
                }
            }
        },
        {
            "id": "110855014",
            "name": "Murgh Kefta (Minced Chicken Meatball Biryani, Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Served with 1 Gulab Jamun & Mint Raita) Spicy, succulent minced chicken meatballs combined with an array of spices and long grain, golden-hued basmati makes this concoction a culinary meal you cannot miss",
            "imageId": "yxipqpvdchxw6nqgsmam",
            "inStock": 1,
            "price": 37500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882227",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882807",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81882808",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882227",
                                "variationId": "81882807"
                            }
                        ],
                        "price": 37500,
                        "addonCombinations": [
                            {
                                "groupId": "84288909",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882227",
                                "variationId": "81882808"
                            }
                        ],
                        "price": 38900,
                        "addonCombinations": [
                            {
                                "groupId": "84288909",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288909",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288911",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288909",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288911",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 37500,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113408078",
            "name": "Zaikedaar Paneer (Paneer Dum Biryani - Serves 1)",
            "category": "Shahi Biryani (serves 1)",
            "description": "(Served with 1 Gulab Jamun & Mint Raita) In this extravagant dish, soft & crumbly, fresh paneer is marinated with exquisite royal spices & layered with basmati to create a dish that is as delectable as it is extravagant.",
            "imageId": "8141298d6e2fc40e01002cfda26b4d57",
            "inStock": 1,
            "isVeg": 1,
            "price": 34500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882327",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883060",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 14,
                                "id": "81883061",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882327",
                                "variationId": "81883060"
                            }
                        ],
                        "price": 34500,
                        "addonCombinations": [
                            {
                                "groupId": "84289434",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289434",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289434",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882327",
                                "variationId": "81883061"
                            }
                        ],
                        "price": 35900,
                        "addonCombinations": [
                            {
                                "groupId": "84289434",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289434",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289434",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289437",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289434",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289437",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 34500,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.7",
                    "ratingCount": "91 ratings",
                    "ratingCountV2": "91"
                }
            }
        }
    ],
    "Shaan Biryani (serves 2)": [
        {
            "id": "104669750",
            "name": "Nayaabi Plant Protein Biryani - Serves 2",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Served with 2 Gulab Jamun & Mint Raita) Presenting the unique Naayabi Plant-based Meat Biryani, with delectable vegetable protein, derived from soyabean and layered with long grain basmati. Fall in love with this unique plant-based peshkash.",
            "imageId": "148be3f2835f8a593d110483b3ce838c",
            "isVeg": 1,
            "price": 49900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882453",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883410",
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 25,
                                "id": "81883411",
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882453",
                                "variationId": "81883410"
                            }
                        ],
                        "price": 49900,
                        "addonCombinations": [
                            {
                                "groupId": "84290015",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84290015",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84290015",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882453",
                                "variationId": "81883411"
                            }
                        ],
                        "price": 52400,
                        "addonCombinations": [
                            {
                                "groupId": "84290015",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84290015",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84290015",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290018",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84290015",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84290018",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 49900,
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110855017",
            "name": "Lazeez Bhuna Murgh (Chicken Dum Biryani Boneless - Serves - 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Boneless, Served with 2 Gulab Jamuns & Mint Raita) In this culinary jewel from Behrouz, Tender chicken pieces are marinated with exuberant bhuna spices that are freshly ground and dum pukht with aromatic rice.",
            "imageId": "hb4izlpgssdpielcpxgs",
            "inStock": 1,
            "price": 72500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882247",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882859",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 24,
                                "id": "81882862",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882247",
                                "variationId": "81882859"
                            }
                        ],
                        "price": 72500,
                        "addonCombinations": [
                            {
                                "groupId": "84288993",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882247",
                                "variationId": "81882862"
                            }
                        ],
                        "price": 74900,
                        "addonCombinations": [
                            {
                                "groupId": "84288993",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288993",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288997",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288993",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288997",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 72500,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.7",
                    "ratingCount": "61 ratings",
                    "ratingCountV2": "61"
                }
            }
        },
        {
            "id": "110855018",
            "name": "Dum Gosht (Mutton Dum Biryani- Boneless - Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Boneless, Served with 2 Gulab Jamuns & Mint Raita) In this most enigmatic & treasured recipe of Behrouz, immaculately spiced fresh, succulent mutton pieces are layered with basmati & then slow-cooked on a charcoal fire.",
            "imageId": "ocaq0qjsau8no0pnn4dl",
            "inStock": 1,
            "price": 91900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882470",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883455",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 26,
                                "id": "81883456",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882470",
                                "variationId": "81883455"
                            }
                        ],
                        "price": 91900,
                        "addonCombinations": [
                            {
                                "groupId": "84290099",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882470",
                                "variationId": "81883456"
                            }
                        ],
                        "price": 94500,
                        "addonCombinations": [
                            {
                                "groupId": "84290099",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84290099",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290103",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84290099",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84290103",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 91900,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.8",
                    "ratingCount": "10 ratings",
                    "ratingCountV2": "10"
                }
            }
        },
        {
            "id": "110855019",
            "name": "Raan-E-Murgh Biryani (Chicken Whole Leg Biryani) (Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(With Bone, Served with 2 Gulab Jamun & Raita) A classic redefined with a touch of royalty! Entice your taste buds with the indulgent chicken whole leg, marinated in exquisite royal spices, laid atop a bed of fragrant, long-grain basmati rice.",
            "imageId": "f0b6581bcb557796cb31f94fd0f26b26",
            "inStock": 1,
            "price": 86900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882162",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882637",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 26,
                                "id": "81882638",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882162",
                                "variationId": "81882637"
                            }
                        ],
                        "price": 86900,
                        "addonCombinations": [
                            {
                                "groupId": "84288551",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882162",
                                "variationId": "81882638"
                            }
                        ],
                        "price": 89500,
                        "addonCombinations": [
                            {
                                "groupId": "84288551",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288551",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288553",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288551",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288553",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 86900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.3",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "110855020",
            "name": "Zaikedaar Paneer (Paneer Dum Biryani - Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Served with 2 Gulab Jamuns & Mint Raita) In this extravagant dish, soft & crumbly, fresh paneer is marinated with exquisite royal spices & layered with basmati to create a dish that is as delectable as it is extravagant.",
            "imageId": "gtetaljp9gkdys1a4i23",
            "inStock": 1,
            "isVeg": 1,
            "price": 65500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882081",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882429",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 24,
                                "id": "81882430",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882081",
                                "variationId": "81882429"
                            }
                        ],
                        "price": 65500,
                        "addonCombinations": [
                            {
                                "groupId": "84288157",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288157",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288157",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882081",
                                "variationId": "81882430"
                            }
                        ],
                        "price": 67900,
                        "addonCombinations": [
                            {
                                "groupId": "84288157",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288157",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288157",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288159",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288157",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288159",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 65500,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "22 ratings",
                    "ratingCountV2": "22"
                }
            }
        },
        {
            "id": "110855021",
            "name": "Subz-E-Biryani (Veg Dum Biryani - Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Served with 2 Gulab Jamuns & Mint Raita) Adorned with fresh vegetables, golden-hued long-grain basmati, & the coveted Behrouz spice mix, this dish will lend you an experience unlike any other.",
            "imageId": "ov39z8btk6qbdyuskw5j",
            "inStock": 1,
            "isVeg": 1,
            "price": 58900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882433",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883353",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 26,
                                "id": "81883354",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882433",
                                "variationId": "81883353"
                            }
                        ],
                        "price": 58900,
                        "addonCombinations": [
                            {
                                "groupId": "84289928",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289928",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289928",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882433",
                                "variationId": "81883354"
                            }
                        ],
                        "price": 61500,
                        "addonCombinations": [
                            {
                                "groupId": "84289928",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289928",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289928",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289931",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289928",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289931",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 58900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.3",
                    "ratingCount": "26 ratings",
                    "ratingCountV2": "26"
                }
            }
        },
        {
            "id": "110855025",
            "name": "Murgh Makhani (Butter Chicken Biryani, Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Boneless, Served with 2 Gulab Jamuns & Mint Raita) Tender chicken pieces cooked in creamy butter chicken gravy, layered with aromatic basmati rice and dum pukht in its full glory. A royal fusion between two of Indias most beloved dishes.",
            "imageId": "khl90o2e5ffyqupsoelr",
            "inStock": 1,
            "price": 78900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882272",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882921",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "id": "81882922",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882272",
                                "variationId": "81882921"
                            }
                        ],
                        "price": 78900,
                        "addonCombinations": [
                            {
                                "groupId": "84289142",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882272",
                                "variationId": "81882922"
                            }
                        ],
                        "price": 78900,
                        "addonCombinations": [
                            {
                                "groupId": "84289142",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289142",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289149",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289142",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289149",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 78900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.3",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "110855026",
            "name": "Murgh Afghani Tikka (Creamy Chicken Tikka Dum Biryani - Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Boneless, Served with 2 Gulab Jamuns & Mint Raita) Legendary for its rich taste & creamy texture, tender chicken marinated in fresh creamy yoghurt & spices is layered with aromatic basmati. Let your tastebuds feel enchanted!",
            "imageId": "eayqc49lmnbhyrvukxnf",
            "inStock": 1,
            "price": 78900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882346",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883115",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 26,
                                "id": "81883116",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882346",
                                "variationId": "81883115"
                            }
                        ],
                        "price": 78900,
                        "addonCombinations": [
                            {
                                "groupId": "84289500",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882346",
                                "variationId": "81883116"
                            }
                        ],
                        "price": 81500,
                        "addonCombinations": [
                            {
                                "groupId": "84289500",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289500",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289506",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289500",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289506",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 78900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.5",
                    "ratingCount": "8 ratings",
                    "ratingCountV2": "8"
                }
            }
        },
        {
            "id": "110855027",
            "name": "Murgh Tikka (Chicken Tikka Dum Biryani - Serves-2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Boneless, Served with 2 Gulab Jamuns & Mint Raita) A potpourri of extravagant flavours, tender chicken spiced with freshly ground Behrouz masala is charcoal-grilled then layered with fragrant basmati & dum-pukht in its full glory.",
            "imageId": "ylc4rma8jaofxut7ifpf",
            "inStock": 1,
            "price": 78900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882430",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883345",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 26,
                                "id": "81883347",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882430",
                                "variationId": "81883345"
                            }
                        ],
                        "price": 78900,
                        "addonCombinations": [
                            {
                                "groupId": "84289911",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882430",
                                "variationId": "81883347"
                            }
                        ],
                        "price": 81500,
                        "addonCombinations": [
                            {
                                "groupId": "84289911",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289911",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289915",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289911",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289915",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 78900,
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "19 ratings",
                    "ratingCountV2": "19"
                }
            }
        },
        {
            "id": "110855028",
            "name": "Do Gosht ki Dum Biryani (Mutton & Chicken Dum Biryani Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Boneless, Served with 2 Gulab Jamuns & Mint Raita) Tantalise your tastebuds with this epicurean delight of succulent chicken & mutton pieces marinated in aromatic spices and dum-pukht with long-grain basmati.",
            "imageId": "c078ba89963d2ead6ac956bd93b1013c",
            "inStock": 1,
            "price": 88900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882424",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883329",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 26,
                                "id": "81883330",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882424",
                                "variationId": "81883329"
                            }
                        ],
                        "price": 88900,
                        "addonCombinations": [
                            {
                                "groupId": "84289896",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882424",
                                "variationId": "81883330"
                            }
                        ],
                        "price": 91500,
                        "addonCombinations": [
                            {
                                "groupId": "84289896",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289896",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289899",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289896",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289899",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 88900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110855030",
            "name": "Paneer Subz (Classic Paneer and Veg Dum Biryani - Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Served with 2 Gulab Jamuns & Mint Raita) In this immaculately balanced culinary masterpiece, diced fresh vegetables infused with succulent pieces of spiced paneer are layered on a bed of aromatic rice.",
            "imageId": "ytmyobwx2ilwjrdu5xrx",
            "inStock": 1,
            "isVeg": 1,
            "price": 65500,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882381",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883208",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 24,
                                "id": "81883209",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882381",
                                "variationId": "81883208"
                            }
                        ],
                        "price": 65500,
                        "addonCombinations": [
                            {
                                "groupId": "84289650",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289650",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289650",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882381",
                                "variationId": "81883209"
                            }
                        ],
                        "price": 67900,
                        "addonCombinations": [
                            {
                                "groupId": "84289650",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289650",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289650",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289652",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289650",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289652",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 65500,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110855034",
            "name": "Murgh Kefta (Minced Chicken Meatball Biryani, Serves 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Served with 2 Gulab Jamuns & Mint Raita) Spicy, succulent minced chicken meatballs combined with an array of spices and long grain, golden-hued basmati makes this concoction a culinary meal you cannot miss",
            "imageId": "uzp7gbcqlbyqtzd9quvm",
            "inStock": 1,
            "price": 69900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882119",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882525",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 26,
                                "id": "81882526",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882119",
                                "variationId": "81882525"
                            }
                        ],
                        "price": 69900,
                        "addonCombinations": [
                            {
                                "groupId": "84288328",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288328",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288328",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288328",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288328",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288328",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288328",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288332",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882119",
                                "variationId": "81882526"
                            }
                        ],
                        "price": 72500
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288328",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288332",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 69900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110855035",
            "name": "Lajawab Kathal Biryani (Serves - 2)",
            "category": "Shaan Biryani (serves 2)",
            "description": "(Served with 2 Gulab Jamuns & Mint Raita) A flavoursome biryani crafted with juicy, raw jackfruit, married with a range of exotic spices and aromatic basmati rice thats sure to sweep you off your feet.",
            "imageId": "efigstywbpofzizmvfsy",
            "isVeg": 1,
            "price": 69900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882243",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882849",
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 20,
                                "id": "81882850",
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882243",
                                "variationId": "81882849"
                            }
                        ],
                        "price": 69900,
                        "addonCombinations": [
                            {
                                "groupId": "84288964",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288964",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288964",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882243",
                                "variationId": "81882850"
                            }
                        ],
                        "price": 71900,
                        "addonCombinations": [
                            {
                                "groupId": "84288964",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288964",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288964",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288967",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288964",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288967",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 69900,
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Alishaan Biryani (serves 4)": [
        {
            "id": "104669751",
            "name": "Nayaabi Plant Protein Biryani - Serves 4",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Served with 4 Gulab Jamun & Mint Raita) Presenting the unique Naayabi Plant-based Meat Biryani, with delectable vegetable protein, derived from soyabean and layered with long grain basmati. Fall in love with this unique plant-based peshkash.",
            "imageId": "47af4a5a5755bf831e3a18283c98f085",
            "isVeg": 1,
            "price": 113900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882307",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883010",
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81883011",
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882307",
                                "variationId": "81883010"
                            }
                        ],
                        "price": 113900,
                        "addonCombinations": [
                            {
                                "groupId": "84289322",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289322",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289322",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882307",
                                "variationId": "81883011"
                            }
                        ],
                        "price": 117900,
                        "addonCombinations": [
                            {
                                "groupId": "84289322",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84289322",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84289322",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289325",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289322",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289325",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 113900,
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869390",
            "name": "Lazeez Bhuna Murgh (Chicken Dum Biryani Boneless - Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Boneless, Served with 4 Gulab Jamuns & Mint Raita) In this culinary jewel from Behrouz, Tender chicken pieces are marinated with exuberant bhuna spices that are freshly ground and dum pukht with aromatic rice.",
            "imageId": "gsp9uaof3r8nt1qgxvz9",
            "inStock": 1,
            "price": 138900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882078",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882423",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81882424",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882078",
                                "variationId": "81882423"
                            }
                        ],
                        "price": 138900,
                        "addonCombinations": [
                            {
                                "groupId": "84288149",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882078",
                                "variationId": "81882424"
                            }
                        ],
                        "price": 142900,
                        "addonCombinations": [
                            {
                                "groupId": "84288149",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288149",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288151",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288149",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288151",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 138900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.1",
                    "ratingCount": "16 ratings",
                    "ratingCountV2": "16"
                }
            }
        },
        {
            "id": "110869395",
            "name": "Dum Gosht (Mutton Dum Biryani - Boneless - Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Boneless, Served with 4 Gulab Jamuns & Mint Raita) In this most enigmatic & treasured recipe of Behrouz, immaculately spiced fresh, succulent mutton pieces are layered with basmati & then slow-cooked on a charcoal fire.",
            "imageId": "a9q6xthkxygbphke32la",
            "inStock": 1,
            "price": 178900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882140",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882581",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81882582",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882140",
                                "variationId": "81882581"
                            }
                        ],
                        "price": 178900,
                        "addonCombinations": [
                            {
                                "groupId": "84288438",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882140",
                                "variationId": "81882582"
                            }
                        ],
                        "price": 182900,
                        "addonCombinations": [
                            {
                                "groupId": "84288438",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288438",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288443",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288438",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288443",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 178900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "5.0",
                    "ratingCount": "4 ratings",
                    "ratingCountV2": "4"
                }
            }
        },
        {
            "id": "110869399",
            "name": "Raan-E-Murgh Biryani (Chicken Whole Leg Biryani) (Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(With Bone, Served with 4 Gulab Jamun & Raita) A classic redefined with a touch of royalty! Entice your taste buds with the indulgent chicken whole leg, marinated in exquisite royal spices, laid atop a bed of fragrant, long-grain basmati rice.",
            "imageId": "3e93013829ff5bf04a7995f066df6b36",
            "inStock": 1,
            "price": 161900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882304",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883002",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81883003",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882304",
                                "variationId": "81883002"
                            }
                        ],
                        "price": 161900,
                        "addonCombinations": [
                            {
                                "groupId": "84289302",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882304",
                                "variationId": "81883003"
                            }
                        ],
                        "price": 165900,
                        "addonCombinations": [
                            {
                                "groupId": "84289302",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289302",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289305",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289302",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289305",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 161900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.7",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "110869402",
            "name": "Zaikedaar Paneer (Paneer Dum Biryani - Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Served with 4 Gulab Jamuns & Mint Raita) In this extravagant dish, soft & crumbly, fresh paneer is marinated with exquisite royal spices & layered with basmati to create a dish that is as delectable as it is extravagant.",
            "imageId": "c9peytnshi9uqajxw0oh",
            "inStock": 1,
            "isVeg": 1,
            "price": 123900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882185",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882696",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81882697",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882185",
                                "variationId": "81882696"
                            }
                        ],
                        "price": 123900,
                        "addonCombinations": [
                            {
                                "groupId": "84288714",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288714",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288714",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882185",
                                "variationId": "81882697"
                            }
                        ],
                        "price": 127900,
                        "addonCombinations": [
                            {
                                "groupId": "84288714",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288714",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288714",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288716",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288714",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288716",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 123900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "4 ratings",
                    "ratingCountV2": "4"
                }
            }
        },
        {
            "id": "110869415",
            "name": "Subz-E-Biryani (Veg Dum Biryani - Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Served with 4 Gulab Jamuns & Mint Raita) Adorned with fresh vegetables, golden-hued long-grain basmati, & the coveted Behrouz spice mix, this dish will lend you an experience unlike any other.",
            "imageId": "h8lo0zpbj6skv4ptcchk",
            "inStock": 1,
            "isVeg": 1,
            "price": 113900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882205",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882751",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81882752",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882205",
                                "variationId": "81882751"
                            }
                        ],
                        "price": 113900,
                        "addonCombinations": [
                            {
                                "groupId": "84288813",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288813",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288813",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882205",
                                "variationId": "81882752"
                            }
                        ],
                        "price": 117900,
                        "addonCombinations": [
                            {
                                "groupId": "84288813",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288813",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288813",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288815",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288813",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288815",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 113900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869419",
            "name": "Malai Kofta Biryani (Creamy Kebab Biryani, Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Served with 4 Gulab Jamuns & Mint Raita) Enriched with gentle flavours of curd and subtly spiced with cumin and ginger, these tender Malai Koftas are layered with basmati rice and slow-cooked to perfection making this a must-try extravagant meal",
            "imageId": "to5e8xgc0wdldwfktf6i",
            "isVeg": 1,
            "price": 150900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882459",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883423",
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81883425",
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882459",
                                "variationId": "81883423"
                            }
                        ],
                        "price": 150900,
                        "addonCombinations": [
                            {
                                "groupId": "84290043",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84290043",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84290043",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882459",
                                "variationId": "81883425"
                            }
                        ],
                        "price": 154900,
                        "addonCombinations": [
                            {
                                "groupId": "84290043",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84290043",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84290043",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84290046",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84290043",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84290046",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 150900,
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869427",
            "name": "Murgh Makhani (Butter Chicken Biryani, Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Boneless, Served with 4 Gulab Jamuns & Mint Raita) Tender chicken pieces cooked in creamy butter chicken gravy, layered with aromatic basmati rice and dum pukht in its full glory. A royal fusion between two of Indias most beloved dishes.",
            "imageId": "zgobhpfmltm6kerw7azw",
            "inStock": 1,
            "price": 150900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882290",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882969",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani ",
                                "price": 40,
                                "id": "81882970",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882290",
                                "variationId": "81882969"
                            }
                        ],
                        "price": 150900,
                        "addonCombinations": [
                            {
                                "groupId": "84289220",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882290",
                                "variationId": "81882970"
                            }
                        ],
                        "price": 154900,
                        "addonCombinations": [
                            {
                                "groupId": "84289220",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289220",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289222",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289220",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289222",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 150900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869430",
            "name": "Murgh Afghani Tikka (Creamy Chicken Tikka Dum Biryani - Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Boneless, Served with 4 Gulab Jamuns & Mint Raita) Legendary for its rich taste & creamy texture, tender chicken marinated in fresh creamy yoghurt & spices is layered with aromatic basmati. Let your tastebuds feel enchanted!",
            "imageId": "ybxivhdlbsopvguo0dnm",
            "inStock": 1,
            "price": 150900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882174",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882668",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81882669",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882174",
                                "variationId": "81882668"
                            }
                        ],
                        "price": 150900,
                        "addonCombinations": [
                            {
                                "groupId": "84288657",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882174",
                                "variationId": "81882669"
                            }
                        ],
                        "price": 154900,
                        "addonCombinations": [
                            {
                                "groupId": "84288657",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288657",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288664",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288657",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288664",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 150900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869437",
            "name": "Murgh Tikka (Chicken Tikka Dum Biryani - Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Boneless, Served with 4 Gulab Jamuns & Mint Raita) Legendary for its rich taste & creamy texture, tender chicken marinated in fresh creamy yoghurt & spices is layered with aromatic basmati. Let your tastebuds feel enchanted.",
            "imageId": "hl7ncvbafkoclogfz7cj",
            "inStock": 1,
            "price": 150900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882208",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882758",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81882759",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882208",
                                "variationId": "81882758"
                            }
                        ],
                        "price": 150900,
                        "addonCombinations": [
                            {
                                "groupId": "84288820",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882208",
                                "variationId": "81882759"
                            }
                        ],
                        "price": 154900,
                        "addonCombinations": [
                            {
                                "groupId": "84288820",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288820",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288821",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288820",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288821",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 150900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "110869441",
            "name": "Do Gosht ki Dum Biryani (Mutton & Chicken Dum Biryani Serves 4).",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Boneless, Served with 4 Gulab Jamuns & Mint Raita) Tantalise your tastebuds with this epicurean delight of succulent chicken & mutton pieces marinated in aromatic spices and dum-pukht with long-grain basmati.",
            "imageId": "zq5qnfrmpxfu9hen7yoj",
            "inStock": 1,
            "price": 168900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882325",
                        "name": "Type of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81883056",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81883057",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882325",
                                "variationId": "81883056"
                            }
                        ],
                        "price": 168900,
                        "addonCombinations": [
                            {
                                "groupId": "84289426",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882325",
                                "variationId": "81883057"
                            }
                        ],
                        "price": 172900,
                        "addonCombinations": [
                            {
                                "groupId": "84289426",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84289426",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84289429",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84289426",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289429",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 168900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869448",
            "name": "Paneer Subz (Classic Paneer and Veg Dum Biryani - Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Served with 4 Gulab Jamuns & Mint Raita) In this immaculately balanced culinary masterpiece, diced fresh vegetables infused with succulent pieces of spiced paneer are layered on a bed of aromatic rice.",
            "imageId": "lrqhac9tvu2qp5uydsct",
            "inStock": 1,
            "isVeg": 1,
            "price": 123900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882212",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882766",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 130,
                                "id": "81882767",
                                "inStock": 1,
                                "isVeg": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882212",
                                "variationId": "81882766"
                            }
                        ],
                        "price": 123900,
                        "addonCombinations": [
                            {
                                "groupId": "84288830",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288830",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288830",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882212",
                                "variationId": "81882767"
                            }
                        ],
                        "price": 136900,
                        "addonCombinations": [
                            {
                                "groupId": "84288830",
                                "addonId": "68389152"
                            },
                            {
                                "groupId": "84288830",
                                "addonId": "69901419"
                            },
                            {
                                "groupId": "84288830",
                                "addonId": "68389153"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288832",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288830",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288832",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "defaultPrice": 123900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869449",
            "name": "Murgh Kefta (Minced Chicken Meatball Biryani, Serves 4)",
            "category": "Alishaan Biryani (serves 4)",
            "description": "(Served with 4 Gulab Jamuns & Mint Raita) Spicy, succulent minced chicken meatballs combined with an array of spices and long grain, golden-hued basmati makes this concoction a culinary meal you cannot miss",
            "imageId": "nknzantyf8eihissu2wb",
            "inStock": 1,
            "price": 133900,
            "variants": {},
            "variantsV2": {
                "variantGroups": [
                    {
                        "groupId": "25882086",
                        "name": "Type Of Biryani",
                        "variations": [
                            {
                                "name": "Classic Biryani",
                                "default": 1,
                                "id": "81882442",
                                "inStock": 1,
                                "isEnabled": 1
                            },
                            {
                                "name": "Hyderabadi Inspired Biryani",
                                "price": 40,
                                "id": "81882443",
                                "inStock": 1,
                                "isEnabled": 1
                            }
                        ]
                    }
                ],
                "pricingModels": [
                    {
                        "variations": [
                            {
                                "groupId": "25882086",
                                "variationId": "81882442"
                            }
                        ],
                        "price": 133900,
                        "addonCombinations": [
                            {
                                "groupId": "84288167",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "73118755"
                            }
                        ]
                    },
                    {
                        "variations": [
                            {
                                "groupId": "25882086",
                                "variationId": "81882443"
                            }
                        ],
                        "price": 137900,
                        "addonCombinations": [
                            {
                                "groupId": "84288167",
                                "addonId": "68389143"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "69901421"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389144"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "69901422"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389145"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389146"
                            },
                            {
                                "groupId": "84288167",
                                "addonId": "68389147"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "68389148"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "69901418"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "63659630"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "63659631"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "63659632"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "68389149"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "68389150"
                            },
                            {
                                "groupId": "84288172",
                                "addonId": "73118755"
                            }
                        ]
                    }
                ]
            },
            "addons": [
                {
                    "groupId": "84288167",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288172",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "defaultPrice": 133900,
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Hyderabad-e-Khaas (Spicy) Biryani": [
        {
            "id": "110855036",
            "name": "Spicy Subz-E-Biryani (Hyderabadi Veg Biryani - Serves 1)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy, Served with 1 Gulab Jamun & Mint Raita) Inspired by the Hyderabadi Style, fresh, crisp vegetables marinated in a spicier blend are layered & dum pukht with golden-hued basmati.",
            "imageId": "zajzlb10h1bnvrcz7wg0",
            "inStock": 1,
            "isVeg": 1,
            "price": 32900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289131",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289132",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "4 ratings",
                    "ratingCountV2": "4"
                }
            }
        },
        {
            "id": "110855037",
            "name": "Spicy Subz-E-Biryani (Hyderabadi Veg Dum Biryani Serves 2)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy, Served with 2 Gulab Jamuns & Mint Raita) Inspired by the Hyderabadi Style, fresh, crisp vegetables marinated in a spicier blend are layered & dum pukht with golden-hued basmati.",
            "imageId": "b1c6w841qdk18gehg6sr",
            "inStock": 1,
            "isVeg": 1,
            "price": 61500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288685",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288693",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "4 ratings",
                    "ratingCountV2": "4"
                }
            }
        },
        {
            "id": "110855038",
            "name": "Spicy Zaikedaar Paneer (Hyderabadi Paneer Dum Biryani - Serves 1)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy, Served with 1 Gulab Jamun & Mint Raita) Crafted in Hyderabadi style, this recipe cherishes the love for all things royal. Fresh paneer marinated with exquisite spices is layered with basmati & slow-cooked to perfection.",
            "imageId": "bjycbjklewqhh6oqv47u",
            "inStock": 1,
            "isVeg": 1,
            "price": 35900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288067",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288071",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.4",
                    "ratingCount": "16 ratings",
                    "ratingCountV2": "16"
                }
            }
        },
        {
            "id": "110855039",
            "name": "Spicy Zaikedaar Paneer (Hyderabadi Paneer Dum Biryani Serves 2)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy, Served with 2 Gulab Jamuns & Mint Raita) Crafted in Hyderabadi style, this recipe cherishes the love for all things royal. Fresh paneer marinated with exquisite spices is layered with basmati & slow-cooked to perfection.",
            "imageId": "zkdcyso8wpksfbfmwdvw",
            "inStock": 1,
            "isVeg": 1,
            "price": 67900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289799",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289800",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110855046",
            "name": "Spicy Lazeez Bhuna Murgh (Hyderabadi Chicken Dum Biryani, Boneless Serves 1)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy & Boneless, Served with 1 Gulab Jamun & Mint Raita) Crafted in Hyderabadi style, tender chicken pieces are dum-pukht with aromatic rice & exuberant bhuna spices in full glory. It is an experience unlike any other.",
            "imageId": "uezdgzcsp6p6ysay4ren",
            "inStock": 1,
            "price": 39900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289353",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289356",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {
                "text": "Bestseller",
                "textColor": "#ffffff",
                "topBackgroundColor": "#d53d4c",
                "bottomBackgroundColor": "#b02331"
            },
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "isBestseller": true,
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.1",
                    "ratingCount": "52 ratings",
                    "ratingCountV2": "52"
                }
            }
        },
        {
            "id": "110855049",
            "name": "Spicy Lazeez Bhuna Murgh (Hyderabadi Chicken Dum Biryani, Boneless - Serves 2)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy & Boneless, Served with 2 Gulab Jamuns & Mint Raita) Crafted in Hyderabadi style, tender chicken pieces are dum-pukht with aromatic rice & exuberant bhuna spices in full glory. It is an experience unlike any other.",
            "imageId": "oog9zzz6yfgxkff8rhoo",
            "inStock": 1,
            "price": 74900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288297",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288299",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110855050",
            "name": "Spicy Dum Gosht (Hyderabadi Mutton Dum Biryani, Boneless - Serves 1)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy & Boneless, Served with 1 Gulab Jamun & Mint Raita) Inspired by the Hyderabadi Style, freshly marinated tender mutton pieces are laid on long-grain rice are slow cooked to create a special delicacy",
            "imageId": "df9ea2568329e594983ca7957f04bb07",
            "inStock": 1,
            "price": 54900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288743",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288746",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.5",
                    "ratingCount": "4 ratings",
                    "ratingCountV2": "4"
                }
            }
        },
        {
            "id": "110855052",
            "name": "Spicy Dum Gosht (Hyderabadi Mutton Dum Biryani, Boneless Serves 2)",
            "category": "Hyderabad-e-Khaas (Spicy) Biryani",
            "description": "(Spicy & Boneless, Served with 2 Gulab Jamuns & Mint Raita) Inspired by the Hyderabadi Style, freshly marinated tender mutton pieces are laid on long-grain rice are slow cooked to create a special delicacy",
            "imageId": "6d0d8a6d28dbf2e47b7406f43175eb16",
            "inStock": 1,
            "price": 94500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289767",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289770",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Solo Celebration Combos (save upto Rs 50)": [
        {
            "id": "107552596",
            "name": "Solo Celebration Combo with Murgh Afgani Biryani + Murgh Kefta Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Murgh Afghani Tikka (Serves 1) & Delectable Murgh Kefta Kebab (4 pcs) making it perfect for your special occasions",
            "imageId": "56570e8af5b471734eb3d68ce12a3e5e",
            "inStock": 1,
            "price": 54900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397928",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397929",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552597",
            "name": "Solo Celebration Combo with Dum Gosht Biryani + Murgh Kefta Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Dum Gosht (Mutton Biryani) (Serves 1) & Delectable Murgh Kefta Kebab (4 pcs)making it perfect for your special occasions",
            "imageId": "83c4f331458b09e2910280e8840c04d5",
            "inStock": 1,
            "price": 64900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397911",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397913",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552599",
            "name": "Solo Celebration Combo with Lazeez Bhuna Murgh Biryani + Murgh Kefta Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Lazeez Bhuna Murgh (Chicken Biryani) (Serves 1) & Delectable Murgh Kefta Kebab (4 pcs) making it perfect for your special occasions",
            "imageId": "98c72b5789d4cfbd707a6744f44b1504",
            "inStock": 1,
            "price": 49500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397917",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397920",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "107552601",
            "name": "Solo Celebration Combo with Lazeez Bhuna Murgh Biryani + Haleem Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Lazeez Bhuna Murgh (Chicken Biryani) (Serves 1) & Delectable Murgh Haleem Kebab (6 pcs) making it perfect for your special occasions",
            "imageId": "e0435c2d08ff8a5a793a236fb2a0ad40",
            "inStock": 1,
            "price": 69500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397977",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397979",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552605",
            "name": "Solo Celebration Combo with Murgh Makhani Biryani + Murgh Koobideh Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Murgh Makhani (Butter Chicken Biryani, Serves 1) & Delectable Murgh Koobideh Kebab (5 Pcs) making it perfect for your special occasions",
            "imageId": "c4702725a70c9d8dd797714c5704c467",
            "inStock": 1,
            "price": 56900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397899",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397902",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552606",
            "name": "Solo Celebration Combo with Raan-E-Murgh Biryani + Haleem Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Raan-E-Murgh Biryani-(Chicken Whole Leg Biryani) (Serves 1) & Delectable Murgh Haleem Kebab (6 Pcs) making it perfect for your special occasions",
            "imageId": "b91e6840694f8e0b60af85a9377758c2",
            "inStock": 1,
            "price": 75900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397922",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397925",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552626",
            "name": "Solo Celebration Combo with Kathal Biryani + Beetroot Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Kathal Biryani (Serves 1) & Delectable Beetroot and Peanut Kebab (6 Pcs) making it perfect for your special occasions",
            "imageId": "0af5a4614f76b55cd011d0ac19b6f183",
            "isVeg": 1,
            "price": 52900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397907",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397908",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552629",
            "name": "Solo Celebration Combo with Nayaabi Plant Protein Biryani + Beetroot Kebab",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Nayaabi Plant Protein Biryani - Serves 1) & Delectable Beetroot and Peanut Kebab (6 Pcs) making it perfect for your special occasions",
            "imageId": "0eb3297120d4f76ce3d5c6d7d8989f56",
            "isVeg": 1,
            "price": 54900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397972",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397974",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113067449",
            "name": "Solo Celebration Combo with Paneer Subz Biryani + Beetroot Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Paneer Subz Biryani (Serves 1) & Delectable Beetroot and Peanut Kebab (6 Pcs) making it perfect for your special occasions",
            "imageId": "723d24bd187d593afec66a9da4165e72",
            "isVeg": 1,
            "price": 54900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397904",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397905",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113067452",
            "name": "Solo Celebration Combo with Zaikedaar Paneer Biryani + Beetroot Kebabs",
            "category": "Solo Celebration Combos (save upto Rs 50)",
            "description": "(Serves 1) This Solo Celebration Combo includes Zaikedaar Paneer Biryani (Serves 1) & Delectable Beetroot and Peanut Kebab (6 Pcs) making it perfect for your special occasions",
            "imageId": "1c7fc03b53fa3d5ada0bd4ee265f34c4",
            "isVeg": 1,
            "price": 54900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86397985",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86397987",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Group Celebration Combos (save upto Rs 100)": [
        {
            "id": "107552607",
            "name": "Group Celebration Combo with Dum Gosht Biryani + Mutton Galouti Kebab",
            "category": "Group Celebration Combos (save upto Rs 100)",
            "description": "(Serves 2) This Group Celebration Combo Dum Gosht Biryani (Serves 2) & delectable Mutton Galouti Kebab (6 pcs) making it perfect for your special occasions",
            "imageId": "db64794e8cc7a94e6d53019de2d90cbb",
            "inStock": 1,
            "price": 125900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288556",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288557",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552609",
            "name": "Group Celebration Combo with Raan-E-Murgh Biryani + Kefta Kebabs",
            "category": "Group Celebration Combos (save upto Rs 100)",
            "description": "(Serves 2) This Group Celebration Combo includes Raan-E-Murgh Biryani (Chicken Whole Leg Biryani - Serves 2) & delectable Murgh Kefta Kebab (9 pcs)making it perfect for your special occasions",
            "imageId": "b42abd89a433873dd95b76d10ad55e4a",
            "inStock": 1,
            "price": 99900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288193",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288196",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552611",
            "name": "Group Celebration Combo with Lazeez Bhuna Murgh Biryani + Kefta Kebabs",
            "category": "Group Celebration Combos (save upto Rs 100)",
            "description": "(Serves 2) This Group Celebration Combo includes Lazeez Bhuna Murgh (Serves 2) & delectable Murgh Kefta Kebab (9pcs) making it perfect for your special occasions",
            "imageId": "98c72b5789d4cfbd707a6744f44b1504",
            "inStock": 1,
            "price": 89900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288536",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288538",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.7",
                    "ratingCount": "7 ratings",
                    "ratingCountV2": "7"
                }
            }
        },
        {
            "id": "107552613",
            "name": "Group Celebration Combo with Lazeez Bhuna Murgh Biryani + Seekh Kebabs",
            "category": "Group Celebration Combos (save upto Rs 100)",
            "description": "(Serves 2) This Group Celebration Combo Lazeez Bhuna Murgh (Serves 2) & delectable Murgh Seekh Kebabs (6 pcs) making it perfect for your special occasions",
            "imageId": "fdfa46a3d2ebe5298b10b2861714d15e",
            "inStock": 1,
            "price": 104900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289364",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289367",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552614",
            "name": "Group Celebration Combo with Lazeez Bhuna Murgh Biryani + Murgh Koobideh Kebabs",
            "category": "Group Celebration Combos (save upto Rs 100)",
            "description": "(Serves 2) This Group Celebration Combo includes Lazeez Bhuna Murgh (Serves 2) & delectable Murgh Koobideh Kebabs (8 pcs) making it perfect for your special occasions",
            "imageId": "2fca1d7b0a22d133b8b8eb76f9593d10",
            "inStock": 1,
            "price": 89900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289631",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289634",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552631",
            "name": "Group Celebration Combo with Zaikedaar Paneer Biryani + Beetroot Kebab",
            "category": "Group Celebration Combos (save upto Rs 100)",
            "description": "(Serves 2) This Group Celebration Combo includes Zaikedaar Paneer (Serves 2) & delectable Beetroot and Peanut Kebab (6 Pcs)making it perfect for your special occasions",
            "imageId": "602380cb1de2b4a59a7a06052bffa276",
            "isVeg": 1,
            "price": 85900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289115",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289119",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "113408156",
            "name": "Group Celebration Combo with 2 Paneer Biryanis + 1 portion of Kebabs",
            "category": "Group Celebration Combos (save upto Rs 100)",
            "description": "(Serves 2) This Group Celebration Combo includes 2 Biryanis: Zaikedaar Paneer (Serves 1) + Paneer Subz Biryani (Serves 1) & delectable Beetroot and peanut Kebab (6 Pcs)making it perfect for your special occasions",
            "imageId": "f3fcedd9cef3c628a42e65ba6a74b6f2",
            "isVeg": 1,
            "price": 84900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84290109",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84290113",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Grand Celebration Combos (save upto Rs 200)": [
        {
            "id": "107552620",
            "name": "Grand Celebration Combo with Lazeez Bhuna Murgh Biryani + 2 portions of Kebabs",
            "category": "Grand Celebration Combos (save upto Rs 200)",
            "description": "(Serves 4) This Grand Celebration Combo includes Lazeez Bhuna Murgh Biryani (Serves 4) & delectable Murgh Seekh Kebab (6 Pcs) + Murgh Kefta Kebab (9pcs) making it perfect for your special occasions",
            "imageId": "ea332af53f4ced43acaf3ea7c78e6e4c",
            "inStock": 1,
            "price": 184900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288206",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84288212",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "107552623",
            "name": "Grand Celebration Combo with Dum Gosht Biryani + 2 portions of Kebabs",
            "category": "Grand Celebration Combos (save upto Rs 200)",
            "description": "(Serves 4) This Grand Celebration Combo includes Dum Gosht Biryani (Serves 4) & delectable Murgh Haleem Kebab (6 pcs) + Murgh Koobideh Kebabs (8 Pcs) making it perfect for your special occasions",
            "imageId": "175b03d178b31bff3605f0abbd6cf1d8",
            "inStock": 1,
            "price": 229900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289755",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84289760",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Royal Curries & Breads": [
        {
            "id": "109614143",
            "name": "Murgh Tikka Masala",
            "category": "Royal Curries & Breads",
            "description": "(Served with Green Chutney & Onions) Make a royal pick with juicy, succulent chicken tikka marinated immaculately in authentic spicy masala. Topped with generous amount of cream, this timeless chicken curry is worth every morsel.",
            "imageId": "a89c2ec7089280de1e7efbfaf2538eee",
            "inStock": 1,
            "price": 44900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454381",
                    "groupName": "Choose breads & rice",
                    "choices": [
                        {
                            "id": "69603227",
                            "name": "Khamiri Naan (Pack of 2)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603230",
                            "name": "Khamiri Naan (Pack of 4)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603228",
                            "name": "Khasta Tawa Paratha (Pack of 3)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603231",
                            "name": "Khasta Tawa Paratha (Pack of 6)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603229",
                            "name": "Aromatic Basmati Rice",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 5,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454383",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454384",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "109614144",
            "name": "Old Delhis Murgh Makhni (Butter Chicken)",
            "category": "Royal Curries & Breads",
            "description": "(Served with Green Chutney & Onions) Relish juicy grilled chicken pieces prepared in a rich gravy of blended cashews, fresh tomatoes, masalas and a generous dollop of smooth butter. An unbeatable Mughlai wonder, our all-time favourite.",
            "imageId": "a7d2c53ebeae89a21a8aee93e83c9640",
            "inStock": 1,
            "price": 45900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454387",
                    "groupName": "Choose breads & rice",
                    "choices": [
                        {
                            "id": "69603227",
                            "name": "Khamiri Naan (Pack of 2)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603230",
                            "name": "Khamiri Naan (Pack of 4)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603228",
                            "name": "Khasta Tawa Paratha (Pack of 3)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603231",
                            "name": "Khasta Tawa Paratha (Pack of 6)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603229",
                            "name": "Aromatic Basmati Rice",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 5,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454388",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454389",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "2.8",
                    "ratingCount": "5 ratings",
                    "ratingCountV2": "5"
                }
            }
        },
        {
            "id": "109614146",
            "name": "Kashmiri Mutton Rogan Josh",
            "category": "Royal Curries & Breads",
            "description": "(Served with Green Chutney & Onions) Indulge in the epic flavours of this shandaar dum-pukht gosht curry, with tender mutton pieces braised in traditional spices and creamy fresh yoghurt. Make your daawat special with this majestic dish from the valleys of Kashmir.",
            "imageId": "26989325381524dffda3a018b182df72",
            "price": 79900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454409",
                    "groupName": "Choose breads & rice",
                    "choices": [
                        {
                            "id": "69603227",
                            "name": "Khamiri Naan (Pack of 2)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603230",
                            "name": "Khamiri Naan (Pack of 4)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603228",
                            "name": "Khasta Tawa Paratha (Pack of 3)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603231",
                            "name": "Khasta Tawa Paratha (Pack of 6)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603229",
                            "name": "Aromatic Basmati Rice",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 5,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454410",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901421",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389144",
                            "name": "Murgh Kefta (Chicken Meatball Kebab - 9 pcs)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69901422",
                            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
                            "price": 19900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389145",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389143",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389146",
                            "name": "Murgh Haleem Kebab(6 pcs)",
                            "price": 29500,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389147",
                            "name": "Murgh Malai Kebab (Chicken Malai Tikka Kebab 6 Pcs)",
                            "price": 38500,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454411",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "109614148",
            "name": "Paneer Makhani (Paneer Butter Masala)",
            "category": "Royal Curries & Breads",
            "description": "(Served with Green Chutney & Onions) Relish fresh, tender paneer prepared in a rich gravy of blended cashews, fresh tomatoes, masalas and a generous dollop of smooth butter. An unbeatable Mughlai wonder, our all-time favourite.",
            "imageId": "75f331b8f14e9cfc0acaf09f0d1b64a3",
            "inStock": 1,
            "isVeg": 1,
            "price": 34900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454402",
                    "groupName": "Choose breads & rice",
                    "choices": [
                        {
                            "id": "69603227",
                            "name": "Khamiri Naan (Pack of 2)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603230",
                            "name": "Khamiri Naan (Pack of 4)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603228",
                            "name": "Khasta Tawa Paratha (Pack of 3)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603231",
                            "name": "Khasta Tawa Paratha (Pack of 6)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603229",
                            "name": "Aromatic Basmati Rice",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 5,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454403",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454404",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "109614149",
            "name": "Paneer Tikka Masala",
            "category": "Royal Curries & Breads",
            "description": "(Served with Green Chutney & Onions) Make a royal pick with spicy, tender paneer chunks marinated immaculately in authentic tikka masala. Topped with generous amount of cream, this timeless paneer curry is worth every morsel.",
            "imageId": "7380d68c5b0d68098279d874e6df59e4",
            "inStock": 1,
            "isVeg": 1,
            "price": 32900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454395",
                    "groupName": "Choose breads & rice",
                    "choices": [
                        {
                            "id": "69603227",
                            "name": "Khamiri Naan (Pack of 2)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603230",
                            "name": "Khamiri Naan (Pack of 4)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603228",
                            "name": "Khasta Tawa Paratha (Pack of 3)",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603231",
                            "name": "Khasta Tawa Paratha (Pack of 6)",
                            "price": 19900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603229",
                            "name": "Aromatic Basmati Rice",
                            "price": 9900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 5,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454396",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454397",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "109614152",
            "name": "Khamiri Naan (Pack of 2)",
            "category": "Royal Curries & Breads",
            "description": "Made with refined flour, yeast and milk, this traditional flatbread from the Mughal era is the perfect jodidaar for your choice of rich curry.",
            "imageId": "9792a17013509f91f46984b91279aac2",
            "inStock": 1,
            "isVeg": 1,
            "price": 9900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454421",
                    "groupName": "Add your favourite Royal Curry",
                    "choices": [
                        {
                            "id": "69603238",
                            "name": "Paneer Makhani",
                            "price": 34900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603237",
                            "name": "Paneer Tikka Masala",
                            "price": 32900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603239",
                            "name": "Kadhai Paneer",
                            "price": 39900,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603240",
                            "name": "Murgh Tikka Masala",
                            "price": 44900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603241",
                            "name": "Old Delhi's Murgh Makhni (Butter Chicken)",
                            "price": 45900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603242",
                            "name": "Kadhai Murgh",
                            "price": 45900,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603243",
                            "name": "Kashmiri Mutton Rogan Josh",
                            "price": 79900,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454422",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454423",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "109614153",
            "name": "Khamiri Naan (Pack of 4)",
            "category": "Royal Curries & Breads",
            "description": "Made with refined flour, yeast and milk, this traditional flatbread from the Mughal era is the perfect jodidaar for your choice of rich curry.",
            "imageId": "d4ded64bd7d6c2d86028c904d0dfd043",
            "inStock": 1,
            "isVeg": 1,
            "price": 19900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454415",
                    "groupName": "Add your favourite Royal Curry",
                    "choices": [
                        {
                            "id": "69603238",
                            "name": "Paneer Makhani",
                            "price": 34900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603237",
                            "name": "Paneer Tikka Masala",
                            "price": 32900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603239",
                            "name": "Kadhai Paneer",
                            "price": 39900,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603240",
                            "name": "Murgh Tikka Masala",
                            "price": 44900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603241",
                            "name": "Old Delhi's Murgh Makhni (Butter Chicken)",
                            "price": 45900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603242",
                            "name": "Kadhai Murgh",
                            "price": 45900,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603243",
                            "name": "Kashmiri Mutton Rogan Josh",
                            "price": 79900,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454416",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454417",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "109614154",
            "name": "Khasta Tawa Paratha (Pack of 3)",
            "category": "Royal Curries & Breads",
            "description": "Have an indulgent and satisfying feast with these large, triangular shaped parathas seared on tawa until crispy. Nothing beats these crispy parathas for a wholesome meal.",
            "imageId": "10e43a515407bd7fb7fffa60437f3767",
            "inStock": 1,
            "isVeg": 1,
            "price": 9900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "86441823",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "86441825",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "5.0",
                    "ratingCount": "4 ratings",
                    "ratingCountV2": "4"
                }
            }
        },
        {
            "id": "109614155",
            "name": "Khasta Tawa Paratha (Pack of 6)",
            "category": "Royal Curries & Breads",
            "description": "Have an indulgent and satisfying feast with these large, triangular shaped parathas seared on tawa until crispy. Nothing beats these crispy parathas for a wholesome meal.",
            "imageId": "0976f4682076ac0ce5eafe01432c206c",
            "inStock": 1,
            "isVeg": 1,
            "price": 19900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84454405",
                    "groupName": "Add your favourite Royal Curry",
                    "choices": [
                        {
                            "id": "69603238",
                            "name": "Paneer Makhani",
                            "price": 34900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603237",
                            "name": "Paneer Tikka Masala",
                            "price": 32900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603239",
                            "name": "Kadhai Paneer",
                            "price": 39900,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603240",
                            "name": "Murgh Tikka Masala",
                            "price": 44900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603241",
                            "name": "Old Delhi's Murgh Makhni (Butter Chicken)",
                            "price": 45900,
                            "inStock": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603242",
                            "name": "Kadhai Murgh",
                            "price": 45900,
                            "isEnabled": 1
                        },
                        {
                            "id": "69603243",
                            "name": "Kashmiri Mutton Rogan Josh",
                            "price": 79900,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 7,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454406",
                    "groupName": "Add a kebab",
                    "choices": [
                        {
                            "id": "69901419",
                            "name": "Beetroot Kebab (6 pcs)",
                            "price": 19500,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389152",
                            "name": "Falafel-E-Khaas (12pcs)",
                            "price": 10500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389153",
                            "name": "Dahi Labneh Kebab(6 pcs)",
                            "price": 23500,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 3,
                    "maxFreeAddons": -1
                },
                {
                    "groupId": "84454407",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Dastaan-E-Kebab": [
        {
            "id": "85935079",
            "name": "Murgh Haleem Kebab (6 pcs) & Murgh Kefta (6pcs) Combo",
            "category": "Dastaan-E-Kebab",
            "description": "The coveted chicken haleem kebabs made with a melange of Hyderabadi spices is served alongside Murgh Kefta that is a fine amalgamation of finely minced fresh chicken and the choicest of spices.",
            "imageId": "ajgaaaxugwrr4krmztcx",
            "inStock": 1,
            "price": 54900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288528",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869513",
            "name": "Falafel-E-Khaas (Half)",
            "category": "Dastaan-E-Kebab",
            "description": "12 Pcs, Savour the great taste with shallow fried chickpea nuggets with a blend of aromatic spices.",
            "imageId": "723b1edded2b1899f93ad5cd949419b7",
            "inStock": 1,
            "isVeg": 1,
            "price": 12900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288110",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869522",
            "name": "Murgh Koobideh (Half, Chicken Tikki Kebab)",
            "category": "Dastaan-E-Kebab",
            "description": "5 Pcs, Ground chicken flavored with cardamom & green chilli and grilled to perfection",
            "imageId": "smpsgtnq2olinlweop3j",
            "inStock": 1,
            "price": 16500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288047",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.8",
                    "ratingCount": "4 ratings",
                    "ratingCountV2": "4"
                }
            }
        },
        {
            "id": "110869523",
            "name": "Murgh Kefta (Half, Chicken Meatball Kebab)",
            "category": "Dastaan-E-Kebab",
            "description": "4 Pcs, Minced chicken kebabs cooked into soft delicious meatballs served with Minty dip.",
            "imageId": "lzqojiyqfuwiwfxxdvtr",
            "inStock": 1,
            "price": 14500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288750",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "110869533",
            "name": "Murgh Kefta (Chicken Meatball Kebab)",
            "category": "Dastaan-E-Kebab",
            "description": "Minced chicken kebabs cooked into soft delicious meatballs served with Minty dip.",
            "imageId": "876ff76bdd44e0364a9d6e7383924394",
            "inStock": 1,
            "price": 23500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289663",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "5.0",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "110869534",
            "name": "Murgh Koobideh (Chicken Tikki Kebab)",
            "category": "Dastaan-E-Kebab",
            "description": "Ground chicken flavored with cardamom & green chilli and grilled to perfection.",
            "imageId": "1dbe98f56f5f7aeace08d9f20f49e09b",
            "inStock": 1,
            "price": 25500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289644",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.3",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "110869535",
            "name": "Murgh Haleem Kebab (6 Pcs)",
            "category": "Dastaan-E-Kebab",
            "description": "Crafted by Celebrity Chef Kunal Kapur slow-cooked haleem, a speciality of Mehfil-e-Ramadan is fused with Hyderabadi spices, rolled into elegant kebabs & char-grilled to perfection in ghee.",
            "imageId": "c432e7ee4f9272ee476abeae670853ae",
            "inStock": 1,
            "price": 34900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288838",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.3",
                    "ratingCount": "6 ratings",
                    "ratingCountV2": "6"
                }
            }
        },
        {
            "id": "110869538",
            "name": "Gosht-E-Galouti Kebab (Mutton Galauti Kebab,6 Pcs)",
            "category": "Dastaan-E-Kebab",
            "description": "A melt-in-mouth culinary delicacy it can take the most enigmatic feasts a notch above. Tenderest mutton is minced to perfection & cooked with delicate spices to offer you a truly exquisite culinary experience.",
            "imageId": "824ccc9ad8ce792be1926ac0534577b8",
            "inStock": 1,
            "price": 43500,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84288471",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.0",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "110869540",
            "name": "Murgh Seekh Kebab (6 Pcs)",
            "category": "Dastaan-E-Kebab",
            "description": "One of the most revered kebab delicacies, this culinary marvel is crafted with minced chicken that is elegantly spiced with royal spices and is served with a refreshing mint dip.",
            "imageId": "ae7d84a9c2fa1aacbb6d09fcf236e275",
            "inStock": 1,
            "price": 39900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84289886",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "itemAttribute": {
                "vegClassifier": "NONVEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.7",
                    "ratingCount": "3 ratings",
                    "ratingCountV2": "3"
                }
            }
        },
        {
            "id": "113408146",
            "name": "Beetroot Kebab (6 pcs)",
            "category": "Dastaan-E-Kebab",
            "description": "(6 Pcs) Savour the flavours of handpicked fresh beetroots and roasted peanuts with a subtle hint of spices. These royal beetroot kebabs are crisp on the outside and soft on the inside.",
            "imageId": "lghpnxrl0sgduwqua1np",
            "isVeg": 1,
            "price": 23900,
            "variants": {},
            "variantsV2": {},
            "addons": [
                {
                    "groupId": "84290024",
                    "groupName": "Choose Your Extras",
                    "choices": [
                        {
                            "id": "69901418",
                            "name": "Royal Dates",
                            "price": 2500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659631",
                            "name": "Extra Mint Raita (100 Gms)",
                            "price": 3500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389150",
                            "name": "Ayran (Buttermilk)",
                            "price": 5900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659630",
                            "name": "Gulab Jamun - Pack of 1",
                            "price": 2900,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "63659632",
                            "name": "Mughlai Gravy (100 Gms)",
                            "price": 4500,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389149",
                            "name": "Coca-Cola Bottle (475 ML)",
                            "price": 5700,
                            "inStock": 1,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "68389148",
                            "name": "Thums Up 250 Ml",
                            "price": 2000,
                            "isVeg": 1,
                            "isEnabled": 1
                        },
                        {
                            "id": "73118755",
                            "name": "Mixed Fruit Halwa (100 gm)",
                            "price": 7900,
                            "isVeg": 1,
                            "isEnabled": 1
                        }
                    ],
                    "maxAddons": 8,
                    "maxFreeAddons": -1
                }
            ],
            "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "type": "ITEM",
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ],
    "Royal Desserts and Beverages": [
        {
            "id": "20148683",
            "name": "SWIG Jeera Masala",
            "category": "Royal Desserts and Beverages",
            "description": "Aerated drink with the added zing of jeera and masala. A perfect accompaniment to your meal.",
            "imageId": "nwtrkehj63w4k2jit5dn",
            "inStock": 1,
            "isVeg": 1,
            "price": 5900,
            "variants": {},
            "variantsV2": {},
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        },
        {
            "id": "20148686",
            "name": "Ayran (Buttermilk)",
            "category": "Royal Desserts and Beverages",
            "description": "Ayran (Buttermilk)",
            "imageId": "wttvnnzenyee9fsgvxda",
            "inStock": 1,
            "isVeg": 1,
            "price": 6500,
            "variants": {},
            "variantsV2": {},
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.2",
                    "ratingCount": "5 ratings",
                    "ratingCountV2": "5"
                }
            }
        },
        {
            "id": "20148688",
            "name": "Mint Raita",
            "category": "Royal Desserts and Beverages",
            "description": "Mint raita is a refreshing and cooling raita made with mint, whisk yogurt and cumin.",
            "imageId": "9417c3bf51cd6575a63524853b8f2f1c",
            "inStock": 1,
            "isVeg": 1,
            "price": 3900,
            "variants": {},
            "variantsV2": {},
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.8",
                    "ratingCount": "5 ratings",
                    "ratingCountV2": "5"
                }
            }
        },
        {
            "id": "20148690",
            "name": "Mughlai Gravy",
            "category": "Royal Desserts and Beverages",
            "description": "Mughlai Gravy, a classic popular North India dish has a thick & creamy gravy with a flavor of yogurt and the taste of ground and whole spices.",
            "imageId": "s2u4dd6mlgpo7v1d11ob",
            "inStock": 1,
            "isVeg": 1,
            "price": 4900,
            "variants": {},
            "variantsV2": {},
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "3.7",
                    "ratingCount": "7 ratings",
                    "ratingCountV2": "7"
                }
            }
        },
        {
            "id": "84341857",
            "name": "Coca-Cola Bottle (475 ML)",
            "category": "Royal Desserts and Beverages",
            "description": "Coca-Cola Bottle (475 ML)",
            "imageId": "ydqqpussdhedmr5edm2b",
            "inStock": 1,
            "isVeg": 1,
            "price": 5700,
            "variants": {},
            "variantsV2": {},
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.4",
                    "ratingCount": "7 ratings",
                    "ratingCountV2": "7"
                }
            }
        },
        {
            "id": "110869547",
            "name": "Gulab Jamun (Pack Of 2)",
            "category": "Royal Desserts and Beverages",
            "description": "Gulab Jamun. Soft. Plump and the way we are used to. There is nothing else in our gulab jamuns than authenticity and love.",
            "imageId": "2c2c0e4d03dde1b74c926d3b0ca9e2bf",
            "inStock": 1,
            "isVeg": 1,
            "price": 5900,
            "variants": {},
            "variantsV2": {},
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {
                    "rating": "4.4",
                    "ratingCount": "23 ratings",
                    "ratingCountV2": "23"
                }
            }
        },
        {
            "id": "110869550",
            "name": "Gulab Jamuns (Pack Of 10)",
            "category": "Royal Desserts and Beverages",
            "description": "Gulab Jamun. Soft. Plump and the way we are used to. There is nothing else in our gulab jamuns than authenticity and love.",
            "imageId": "cc6e9348bb748e745a3d28396ada6e79",
            "inStock": 1,
            "isVeg": 1,
            "price": 27500,
            "variants": {},
            "variantsV2": {},
            "itemAttribute": {
                "vegClassifier": "VEG"
            },
            "ribbon": {},
            "showImage": true,
            "itemBadge": {},
            "badgesV2": {},
            "ratings": {
                "aggregatedRating": {}
            }
        }
    ]
}

export default allMenu
